export default { "vendorsList": [
   {
      "Vendor": "ARCATA COOP",
      "Address": " 811 I ST",
      "City": "ARCATA",
      "Zip Code": " 95521",
      "County": " HUMBOLDT",
      "Latitude": "40.8689460  ",
      "Longitude": " -124.08850 "
   },
   {
      "Vendor": "SHOP SMART #32",
      "Address": " 3430 REDWOOD AVE",
      "City": "REDWAY",
      "Zip Code": " 95560",
      "County": " HUMBOLDT",
      "Latitude": "40.1202890  ",
      "Longitude": " -123.82349 "
   },
   {
      "Vendor": "RAY'S FOOD PLACE #07",
      "Address": " 5000 VALLEY WEST BLVD",
      "City": "ARCATA",
      "Zip Code": " 95521",
      "County": " HUMBOLDT",
      "Latitude": "40.9039660  ",
      "Longitude": " -124.08280 "
   },
   {
      "Vendor": "SAFEWAY #0793",
      "Address": " 600 F ST",
      "City": "ARCATA",
      "Zip Code": " 95521",
      "County": " HUMBOLDT",
      "Latitude": "40.8661640  ",
      "Longitude": " -124.08427 "
   },
   {
      "Vendor": "MURPHY'S SUNNYBRAE MARKET",
      "Address": " 785 BAYSIDE RD",
      "City": "ARCATA",
      "Zip Code": " 95521",
      "County": " HUMBOLDT",
      "Latitude": "40.8583760  ",
      "Longitude": " -124.07277 "
   },
   {
      "Vendor": "SAFEWAY #0975",
      "Address": "S 701 FORTUNA BLVD",
      "City": "FORTUNA",
      "Zip Code": " 95540",
      "County": " HUMBOLDT",
      "Latitude": "40.5842900  ",
      "Longitude": " -124.14492 "
   },
   {
      "Vendor": "MURPHY'S CUTTEN MARKET",
      "Address": " 4020 WALNUT DR",
      "City": "EUREKA",
      "Zip Code": " 95501",
      "County": " HUMBOLDT",
      "Latitude": "40.7694520  ",
      "Longitude": " -124.14342 "
   },
   {
      "Vendor": "WINCO FOODS #07",
      "Address": "W 636 HARRIS ST",
      "City": "EUREKA",
      "Zip Code": " 95501",
      "County": " HUMBOLDT",
      "Latitude": "40.7817680  ",
      "Longitude": " -124.17798 "
   },
   {
      "Vendor": "MURPHY'S MARKET #4",
      "Address": " 1451 GLENDALE DR",
      "City": "ARCATA",
      "Zip Code": " 95521",
      "County": " HUMBOLDT",
      "Latitude": "40.9002580  ",
      "Longitude": " -124.02078 "
   },
   {
      "Vendor": "RAY'S FOOD PLACE #47",
      "Address": " 2009 MAIN ST",
      "City": "FORTUNA",
      "Zip Code": " 95540",
      "County": " HUMBOLDT",
      "Latitude": "40.5956850  ",
      "Longitude": " -124.14605 "
   },
   {
      "Vendor": "MURPHY'S MARKET #5",
      "Address": " 1ST MAIN ST",
      "City": "TRINIDAD",
      "Zip Code": " 95570",
      "County": " HUMBOLDT",
      "Latitude": "41.0612900  ",
      "Longitude": " -124.14123 "
   },
   {
      "Vendor": "SAFEWAY #1640",
      "Address": " 1503 CITY CENTER RD",
      "City": "MCKINLEYVILLE",
      "Zip Code": " 95519",
      "County": " HUMBOLDT",
      "Latitude": "40.9438620  ",
      "Longitude": " -124.10260 "
   },
   {
      "Vendor": "RAY'S FOOD PLACE #64",
      "Address": " 875 REDWOOD DR",
      "City": "GARBERVILLE",
      "Zip Code": " 95542",
      "County": " HUMBOLDT",
      "Latitude": "40.0987700  ",
      "Longitude": " -123.79432 "
   },
   {
      "Vendor": "EUREKA COOP.",
      "Address": " 25 4TH ST",
      "City": "EUREKA",
      "Zip Code": " 95501",
      "County": " HUMBOLDT",
      "Latitude": "40.8025120  ",
      "Longitude": " -124.17122 "
   },
   {
      "Vendor": "RAY'S FOOD PLACE #75",
      "Address": " 38195 CALIFORNIA 299",
      "City": "WILLOW CREEK",
      "Zip Code": " 95573",
      "County": " HUMBOLDT",
      "Latitude": "40.9425080  ",
      "Longitude": " -123.64088 "
   },
   {
      "Vendor": "MURPHY'S MARKET",
      "Address": " 100 WESTWOOD CTR",
      "City": "ARCATA",
      "Zip Code": " 95521",
      "County": " HUMBOLDT",
      "Latitude": "40.8824450  ",
      "Longitude": " -124.09145 "
   },
   {
      "Vendor": "SAFEWAY #2908",
      "Address": " 2555 HARRIS ST",
      "City": "EUREKA",
      "Zip Code": " 95503",
      "County": " HUMBOLDT",
      "Latitude": "40.7808010  ",
      "Longitude": " -124.13852 "
   },
   {
      "Vendor": "HOBY'S MARKET",
      "Address": " 111 MAIN ST",
      "City": "SCOTIA",
      "Zip Code": " 95565",
      "County": " HUMBOLDT",
      "Latitude": "40.4840330  ",
      "Longitude": " -124.10225 "
   },
   {
      "Vendor": "TARGET STORE T-1421",
      "Address": " 2525 4TH ST",
      "City": "EUREKA",
      "Zip Code": " 95501",
      "County": " HUMBOLDT",
      "Latitude": "40.8048820  ",
      "Longitude": " -124.14462 "
   },
   {
      "Vendor": "CC MARKET AND DELI",
      "Address": " 1328 EELOA AVE",
      "City": "RIO DELL",
      "Zip Code": " 95562",
      "County": " HUMBOLDT",
      "Latitude": "40.5069150  ",
      "Longitude": " -124.11274 "
   },
   {
      "Vendor": "HOOPA SHOPPING CENTER",
      "Address": " 12500 STATE HWY",
      "Second Address": "  96",
      "City": "HOOPA",
      "Zip Code": " 95546",
      "County": " HUMBOLDT",
      "Latitude": "41.0629190  ",
      "Longitude": " -123.68572 "
   },
   {
      "Vendor": "SAFEWAY #0788",
      "Address": " 1 CAMINO ALTO",
      "City": "MILL VALLEY",
      "Zip Code": " 94941",
      "County": " MARIN",
      "Latitude": "37.8939810  ",
      "Longitude": " -122.53074 "
   },
   {
      "Vendor": "SAFEWAY #1723",
      "Address": " 838 SIR FRANCIS DRAKE BLVD",
      "City": "SAN ANSELMO",
      "Zip Code": " 94960",
      "County": " MARIN",
      "Latitude": "37.9806690  ",
      "Longitude": " -122.56436 "
   },
   {
      "Vendor": "SAFEWAY #0653",
      "Address": " 700 B ST",
      "City": "SAN RAFAEL",
      "Zip Code": " 94901",
      "County": " MARIN",
      "Latitude": "37.9702750  ",
      "Longitude": " -122.52919 "
   },
   {
      "Vendor": "SAFEWAY #0932",
      "Address": " 950 LAS GALLINAS AVE",
      "City": "SAN RAFAEL",
      "Zip Code": " 94903",
      "County": " MARIN",
      "Latitude": "38.0087510  ",
      "Longitude": " -122.54883 "
   },
   {
      "Vendor": "SAFEWAY #0979",
      "Address": " 900 DIABLO AVE",
      "City": "NOVATO",
      "Zip Code": " 94947",
      "County": " MARIN",
      "Latitude": "38.1037690  ",
      "Longitude": " -122.57201 "
   },
   {
      "Vendor": "SAFEWAY #2318",
      "Address": " 137 CORTE MADERA AVE",
      "City": "CORTE MADERA",
      "Zip Code": " 94925",
      "County": " MARIN",
      "Latitude": "37.9264490  ",
      "Longitude": " -122.53082 "
   },
   {
      "Vendor": "SAFEWAY #2718",
      "Address": " 110 STRAWBERRY VILLAGE",
      "Second Address": "  B100",
      "City": "MILL VALLEY",
      "Zip Code": " 94941",
      "County": " MARIN",
      "Latitude": "37.8982570  ",
      "Longitude": " -122.51347 "
   },
   {
      "Vendor": "LUCKY #720",
      "Address": " 570 MAGNOLIA AVE",
      "City": "LARKSPUR",
      "Zip Code": " 94939",
      "County": " MARIN",
      "Latitude": "37.9371930  ",
      "Longitude": " -122.53347 "
   },
   {
      "Vendor": "LUCKY #732",
      "Address": " 1761 GRANT AVE",
      "City": "NOVATO",
      "Zip Code": " 94947",
      "County": " MARIN",
      "Latitude": "38.1086710  ",
      "Longitude": " -122.58032 "
   },
   {
      "Vendor": "SUPERMERCADO MI TIERRA #6",
      "Address": " 175 BELVEDERE ST",
      "City": "SAN RAFAEL",
      "Zip Code": " 94901",
      "County": " MARIN",
      "Latitude": "37.9640320  ",
      "Longitude": " -122.50825 "
   },
   {
      "Vendor": "SAFEWAY #2828",
      "Address": " 5720 NAVE DR",
      "City": "NOVATO",
      "Zip Code": " 94949",
      "County": " MARIN",
      "Latitude": "38.0625020  ",
      "Longitude": " -122.53221 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #527",
      "Address": " 3255 KERNER BLVD",
      "Second Address": " STE A",
      "City": "SAN RAFAEL",
      "Zip Code": " 94901",
      "County": " MARIN",
      "Latitude": "37.9609100  ",
      "Longitude": " -122.50216 "
   },
   {
      "Vendor": "SMART & FINAL #526",
      "Address": " 935 ANDERSEN DR",
      "City": "SAN RAFAEL",
      "Zip Code": " 94901",
      "County": " MARIN",
      "Latitude": "37.9573850  ",
      "Longitude": " -122.50693 "
   },
   {
      "Vendor": "TARGET STORE T-0692",
      "Address": " 200 VINTAGE WAY",
      "City": "NOVATO",
      "Zip Code": " 94945",
      "County": " MARIN",
      "Latitude": "38.0911570  ",
      "Longitude": " -122.55618 "
   },
   {
      "Vendor": "TARGET STORE T-2772",
      "Address": " 125 SHORELINE PKWY",
      "City": "SAN RAFAEL",
      "Zip Code": " 94901",
      "County": " MARIN",
      "Latitude": "37.9521900  ",
      "Longitude": " -122.49229 "
   },
   {
      "Vendor": "CARDENAS #216",
      "Address": " 330 BELLAM BLVD",
      "City": "SAN RAFAEL",
      "Zip Code": " 94901",
      "County": " MARIN",
      "Latitude": "37.9613580  ",
      "Longitude": " -122.50041 "
   },
   {
      "Vendor": "SAFEWAY COMMUNITY MARKET #2",
      "Address": " 100 CENTER BLVD",
      "City": "SAN ANSELMO",
      "Zip Code": " 94960",
      "County": " MARIN",
      "Latitude": "37.9767550  ",
      "Longitude": " -122.56275 "
   },
   {
      "Vendor": "KEITH'S FAMILY FOOD CENTER",
      "Address": " 76201 COVELO RD",
      "City": "COVELO",
      "Zip Code": " 95428",
      "County": " MENDOCINO",
      "Latitude": "39.7909950  ",
      "Longitude": " -123.24779 "
   },
   {
      "Vendor": "S & B MARKET",
      "Address": "S 19400 HIGHWAY 1",
      "City": "MANCHESTER",
      "Zip Code": " 95459",
      "County": " MENDOCINO",
      "Latitude": "38.9697570  ",
      "Longitude": " -123.68763 "
   },
   {
      "Vendor": "SAFEWAY #0965",
      "Address": "S 845 MAIN ST",
      "City": "WILLITS",
      "Zip Code": " 95490",
      "County": " MENDOCINO",
      "Latitude": "39.4027670  ",
      "Longitude": " -123.35031 "
   },
   {
      "Vendor": "SAFEWAY #1583",
      "Address": "S 653 STATE ST",
      "City": "UKIAH",
      "Zip Code": " 95482",
      "County": " MENDOCINO",
      "Latitude": "39.1443430  ",
      "Longitude": " -123.20626 "
   },
   {
      "Vendor": "SAFEWAY #0978",
      "Address": "S 660 MAIN ST",
      "City": "FORT BRAGG",
      "Zip Code": " 95437",
      "County": " MENDOCINO",
      "Latitude": "39.4337410  ",
      "Longitude": " -123.80534 "
   },
   {
      "Vendor": "RALEY'S #328",
      "Address": "N 1315 STATE ST",
      "City": "UKIAH",
      "Zip Code": " 95482",
      "County": " MENDOCINO",
      "Latitude": "39.1684890  ",
      "Longitude": " -123.20928 "
   },
   {
      "Vendor": "FOOD MAXX #473",
      "Address": " 1235 AIRPORT PARK BLVD",
      "City": "UKIAH",
      "Zip Code": " 95482",
      "County": " MENDOCINO",
      "Latitude": "39.1311780  ",
      "Longitude": " -123.19700 "
   },
   {
      "Vendor": "LUCKY #628",
      "Address": "E 504 PERKINS ST",
      "City": "UKIAH",
      "Zip Code": " 95482",
      "County": " MENDOCINO",
      "Latitude": "39.1510600  ",
      "Longitude": " -123.20114 "
   },
   {
      "Vendor": "SUPER CHAVEZ MARKET",
      "Address": "S 1420 STATE ST",
      "City": "UKIAH",
      "Zip Code": " 95482",
      "County": " MENDOCINO",
      "Latitude": "39.1276430  ",
      "Longitude": " -123.20491 "
   },
   {
      "Vendor": "WAL-MART STORE #2052",
      "Address": " 1155 AIRPORT PARK BLVD",
      "City": "UKIAH",
      "Zip Code": " 95482",
      "County": " MENDOCINO",
      "Latitude": "39.1337920  ",
      "Longitude": " -123.19724 "
   },
   {
      "Vendor": "GEIGER'S LONG VALLEY MARKET",
      "Address": " 44951 HWY 101",
      "City": "LAYTONVILLE",
      "Zip Code": " 95454",
      "County": " MENDOCINO",
      "Latitude": "39.6873880  ",
      "Longitude": " -123.48203 "
   },
   {
      "Vendor": "NOB HILL FOODS #607",
      "Address": "S 1320 MAIN ST",
      "City": "SALINAS",
      "Zip Code": " 93901",
      "County": " MONTEREY",
      "Latitude": "36.6554180  ",
      "Longitude": " -121.66168 "
   },
   {
      "Vendor": "SAFEWAY #0706",
      "Address": " 104 MID VALLEY CENTER",
      "City": "CARMEL",
      "Zip Code": " 93923",
      "County": " MONTEREY",
      "Latitude": "36.5225940  ",
      "Longitude": " -121.81007 "
   },
   {
      "Vendor": "FARMER'S MARKET",
      "Address": "S 246 ALTA ST",
      "City": "GONZALES",
      "Zip Code": " 93926",
      "County": " MONTEREY",
      "Latitude": "36.5031240  ",
      "Longitude": " -121.44110 "
   },
   {
      "Vendor": "ORD COMMUNITY COMMISSARY",
      "Address": " 4240 GIGLING RD",
      "City": "SEASIDE",
      "Zip Code": " 93955",
      "County": " MONTEREY",
      "Latitude": "36.6455950  ",
      "Longitude": " -121.76950 "
   },
   {
      "Vendor": "SAFEWAY #0761",
      "Address": " 1212 FOREST AVE",
      "City": "PACIFIC GROVE",
      "Zip Code": " 93955",
      "County": " MONTEREY",
      "Latitude": "36.6048240  ",
      "Longitude": " -121.92111 "
   },
   {
      "Vendor": "SAFEWAY #1204",
      "Address": " 17539 VIERRA CANYON RD",
      "City": "PRUNEDALE",
      "Zip Code": " 93907",
      "County": " MONTEREY",
      "Latitude": "36.7919570  ",
      "Longitude": " -121.66537 "
   },
   {
      "Vendor": "FOOD MAXX #405",
      "Address": "N 1962 MAIN ST",
      "City": "SALINAS",
      "Zip Code": " 93906",
      "County": " MONTEREY",
      "Latitude": "36.7202920  ",
      "Longitude": " -121.65591 "
   },
   {
      "Vendor": "EL RANCHO MARKET",
      "Address": " 346 RESERVATION RD",
      "City": "MARINA",
      "Zip Code": " 93933",
      "County": " MONTEREY",
      "Latitude": "36.6826640  ",
      "Longitude": " -121.78935 "
   },
   {
      "Vendor": "SAFEWAY #1232",
      "Address": " 530 CANAL ST",
      "City": "KING CITY",
      "Zip Code": " 93930",
      "County": " MONTEREY",
      "Latitude": "36.2043760  ",
      "Longitude": " -121.13303 "
   },
   {
      "Vendor": "HUNTER-LIGGETT COMMISSARY",
      "Address": " BLGD S-182 FRIENDSHIP LN",
      "City": "JOLON",
      "Zip Code": " 93928",
      "County": " MONTEREY",
      "Latitude": "36.0100950  ",
      "Longitude": " -121.23820 "
   },
   {
      "Vendor": "SAFEWAY #1110",
      "Address": "N 1546 MAIN ST",
      "City": "SALINAS",
      "Zip Code": " 93906",
      "County": " MONTEREY",
      "Latitude": "36.7120360  ",
      "Longitude": " -121.65409 "
   },
   {
      "Vendor": "FOODS CO #769",
      "Address": "E 1030 ALISAL ST",
      "City": "SALINAS",
      "Zip Code": " 93905",
      "County": " MONTEREY",
      "Latitude": "36.6717020  ",
      "Longitude": " -121.62585 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #504",
      "Address": "S 17 PEARL ST",
      "City": "SALINAS",
      "Zip Code": " 93905",
      "County": " MONTEREY",
      "Latitude": "36.6728420  ",
      "Longitude": " -121.63346 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #511",
      "Address": "N 611 SANBORN RD",
      "City": "SALINAS",
      "Zip Code": " 93905",
      "County": " MONTEREY",
      "Latitude": "36.6827300  ",
      "Longitude": " -121.62186 "
   },
   {
      "Vendor": "FOOD 4 LESS #08",
      "Address": "N 1576 SANBORN RD",
      "City": "SALINAS",
      "Zip Code": " 93905",
      "County": " MONTEREY",
      "Latitude": "36.6931030  ",
      "Longitude": " -121.59575 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #514",
      "Address": " 620 BROADWAY AVE",
      "Second Address": " UNIT F",
      "City": "KING CITY",
      "Zip Code": " 93930",
      "County": " MONTEREY",
      "Latitude": "36.2107180  ",
      "Longitude": " -121.13148 "
   },
   {
      "Vendor": "LA PRINCESA MARKET #9",
      "Address": " 620 BROADWAY ST",
      "Second Address": " STE A",
      "City": "KING CITY",
      "Zip Code": " 93930",
      "County": " MONTEREY",
      "Latitude": "36.2107180  ",
      "Longitude": " -121.13148 "
   },
   {
      "Vendor": "SAFEWAY #2654",
      "Address": " 1516 CONSTITUTION BLVD",
      "City": "SALINAS",
      "Zip Code": " 93905",
      "County": " MONTEREY",
      "Latitude": "36.6990250  ",
      "Longitude": " -121.62072 "
   },
   {
      "Vendor": "FOODS CO #387",
      "Address": " 2443 H. DE LA ROSA SR. ST",
      "City": "SOLEDAD",
      "Zip Code": " 93960",
      "County": " MONTEREY",
      "Latitude": "36.4145860  ",
      "Longitude": " -121.31992 "
   },
   {
      "Vendor": "LUCKY CALIFORNIA #703",
      "Address": " 555 CARMEL RANCHO BLVD",
      "City": "CARMEL",
      "Zip Code": " 93923",
      "County": " MONTEREY",
      "Latitude": "36.5433570  ",
      "Longitude": " -121.90480 "
   },
   {
      "Vendor": "LUCKY #724",
      "Address": " 270 RESERVATION RD",
      "City": "MARINA",
      "Zip Code": " 93933",
      "County": " MONTEREY",
      "Latitude": "36.6840950  ",
      "Longitude": " -121.79648 "
   },
   {
      "Vendor": "LUCKY CALIFORNIA #738",
      "Address": " 200 COUNTRY CLUB GATE CTR",
      "City": "PACIFIC GROVE",
      "Zip Code": " 93950",
      "County": " MONTEREY",
      "Latitude": "36.6082710  ",
      "Longitude": " -121.92543 "
   },
   {
      "Vendor": "LUCKY #747",
      "Address": "S 1150 MAIN ST",
      "City": "SALINAS",
      "Zip Code": " 93901",
      "County": " MONTEREY",
      "Latitude": "36.6589710  ",
      "Longitude": " -121.66030 "
   },
   {
      "Vendor": "LUCKY #772",
      "Address": " 2000 CALIFORNIA AVE",
      "City": "SAND CITY",
      "Zip Code": " 93955",
      "County": " MONTEREY",
      "Latitude": "36.6198520  ",
      "Longitude": " -121.84380 "
   },
   {
      "Vendor": "SAFEWAY #2669",
      "Address": " 5 CROSSROADS BLVD",
      "City": "CARMEL",
      "Zip Code": " 93923",
      "County": " MONTEREY",
      "Latitude": "36.5388650  ",
      "Longitude": " -121.90944 "
   },
   {
      "Vendor": "EL PUEBLO FOOD",
      "Address": " 315 BROADWAY ST",
      "City": "KING CITY",
      "Zip Code": " 93930",
      "County": " MONTEREY",
      "Latitude": "36.2122250  ",
      "Longitude": " -121.12647 "
   },
   {
      "Vendor": "SAFEWAY #2841",
      "Address": " 815 CANYON DEL REY",
      "City": "DEL REY OAKS",
      "Zip Code": " 93940",
      "County": " MONTEREY",
      "Latitude": "36.5976840  ",
      "Longitude": " -121.85020 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #524",
      "Address": " 343 GABILAN DR",
      "City": "SOLEDAD",
      "Zip Code": " 93960",
      "County": " MONTEREY",
      "Latitude": "36.4365330  ",
      "Longitude": " -121.32838 "
   },
   {
      "Vendor": "SMART & FINAL #431",
      "Address": "E 319 MARKET ST",
      "City": "SALINAS",
      "Zip Code": " 93901",
      "County": " MONTEREY",
      "Latitude": "36.6793190  ",
      "Longitude": " -121.64546 "
   },
   {
      "Vendor": "SMART & FINAL #455",
      "Address": " 1560 CANYON DEL REY BLVD",
      "City": "SEASIDE",
      "Zip Code": " 93955",
      "County": " MONTEREY",
      "Latitude": "36.6086260  ",
      "Longitude": " -121.85671 "
   },
   {
      "Vendor": "LA PRECIOSA FAMILY SUPERMAR",
      "Address": " 1220 BROADWAY AVE",
      "City": "SEASIDE",
      "Zip Code": " 93955",
      "County": " MONTEREY",
      "Latitude": "36.6088530  ",
      "Longitude": " -121.83968 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #539",
      "Address": "N 1575 SANBORN RD",
      "Second Address": " STE 1575",
      "City": "SALINAS",
      "Zip Code": " 93905",
      "County": " MONTEREY",
      "Latitude": "36.6947660  ",
      "Longitude": " -121.59673 "
   },
   {
      "Vendor": "LAS LOMAS MARKET",
      "Address": " 182 HALL RD",
      "City": "ROYAL OAKS",
      "Zip Code": " 95076",
      "County": " MONTEREY",
      "Latitude": "36.8651810  ",
      "Longitude": " -121.73452 "
   },
   {
      "Vendor": "MARITZA MARKET",
      "Address": "E 549 MARKET ST",
      "City": "SALINAS",
      "Zip Code": " 93905",
      "County": " MONTEREY",
      "Latitude": "36.6772020  ",
      "Longitude": " -121.63585 "
   },
   {
      "Vendor": "EL SUPER #36",
      "Address": "E 640 BORONDA RD",
      "City": "SALINAS",
      "Zip Code": " 93906",
      "County": " MONTEREY",
      "Latitude": "36.7148110  ",
      "Longitude": " -121.62560 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #542",
      "Address": " 345 EL CAMINO REAL",
      "City": "GREENFIELD",
      "Zip Code": " 93927",
      "County": " MONTEREY",
      "Latitude": "36.3235460  ",
      "Longitude": " -121.24610 "
   },
   {
      "Vendor": "EL PUEBLO FOODS #2",
      "Address": " 128 KIDDER ST",
      "City": "SOLEDAD",
      "Zip Code": " 93960",
      "County": " MONTEREY",
      "Latitude": "36.4259300  ",
      "Longitude": " -121.32689 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #4488",
      "Address": " 150 BEACH RD",
      "City": "MARINA",
      "Zip Code": " 93933",
      "County": " MONTEREY",
      "Latitude": "36.6931650  ",
      "Longitude": " -121.80122 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2458",
      "Address": "N 1800 MAIN ST",
      "City": "SALINAS",
      "Zip Code": " 93906",
      "County": " MONTEREY",
      "Latitude": "36.7177520  ",
      "Longitude": " -121.65522 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5751",
      "Address": "N 1375 DAVIS RD",
      "City": "SALINAS",
      "Zip Code": " 93907",
      "County": " MONTEREY",
      "Latitude": "36.7058310  ",
      "Longitude": " -121.66888 "
   },
   {
      "Vendor": "TARGET STORE T-0676",
      "Address": "N 1640 MAIN ST",
      "City": "SALINAS",
      "Zip Code": " 93906",
      "County": " MONTEREY",
      "Latitude": "36.7146870  ",
      "Longitude": " -121.65458 "
   },
   {
      "Vendor": "TARGET STORE T-2306",
      "Address": " 133 GENERAL STILWELL DR",
      "City": "MARINA",
      "Zip Code": " 93933",
      "County": " MONTEREY",
      "Latitude": "36.6663340  ",
      "Longitude": " -121.81070 "
   },
   {
      "Vendor": "TARGET STORE T-1062",
      "Address": " 2040 CALIFORNIA AVE",
      "City": "SAND CITY",
      "Zip Code": " 93955",
      "County": " MONTEREY",
      "Latitude": "36.6202780  ",
      "Longitude": " -121.84293 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #564",
      "Address": " 1926 FREMONT BLVD",
      "City": "SEASIDE",
      "Zip Code": " 93955",
      "County": " MONTEREY",
      "Latitude": "36.6173100  ",
      "Longitude": " -121.84093 "
   },
   {
      "Vendor": "RANCHO SAN MIGUEL #025",
      "Address": " 500 WALNUT AVE",
      "City": "GREENFIELD",
      "Zip Code": " 93927",
      "County": " MONTEREY",
      "Latitude": "36.3280570  ",
      "Longitude": " -121.24659 "
   },
   {
      "Vendor": "EL REY MARKET",
      "Address": " 851 OAK AVE",
      "City": "GREENFIELD",
      "Zip Code": " 93927",
      "County": " MONTEREY",
      "Latitude": "36.3201260  ",
      "Longitude": " -121.24400 "
   },
   {
      "Vendor": "FILETE DE ORO",
      "Address": " 420 BROADWAY ST",
      "City": "KING CITY",
      "Zip Code": " 93930",
      "County": " MONTEREY",
      "Latitude": "36.2120900  ",
      "Longitude": " -121.12859 "
   },
   {
      "Vendor": "EL REY MEAT MARKET",
      "Address": "N 1159 SANBORN RD",
      "City": "SALINAS",
      "Zip Code": " 93905",
      "County": " MONTEREY",
      "Latitude": "36.6886510  ",
      "Longitude": " -121.61124 "
   },
   {
      "Vendor": "JUQUILITA MARKET",
      "Address": "E 170 LAUREL DR",
      "City": "SALINAS",
      "Zip Code": " 93906",
      "County": " MONTEREY",
      "Latitude": "36.6987720  ",
      "Longitude": " -121.65019 "
   },
   {
      "Vendor": "CARDENAS #205",
      "Address": "E 950 ALISAL ST",
      "City": "SALINAS",
      "Zip Code": " 93905",
      "County": " MONTEREY",
      "Latitude": "36.6723480  ",
      "Longitude": " -121.62815 "
   },
   {
      "Vendor": "CORONA MARKET",
      "Address": "E 695 ALISAL ST",
      "City": "SALINAS",
      "Zip Code": " 93905",
      "County": " MONTEREY",
      "Latitude": "36.6736920  ",
      "Longitude": " -121.63251 "
   },
   {
      "Vendor": "LAS PALMAS MARKET",
      "Address": " 200 4TH ST",
      "City": "SOLEDAD",
      "Zip Code": " 93960",
      "County": " MONTEREY",
      "Latitude": "36.4208690  ",
      "Longitude": " -121.31691 "
   },
   {
      "Vendor": "CALIDAD MARKET Y CARNICERIA",
      "Address": "N 949 SANBORN RD",
      "City": "SALINAS",
      "Zip Code": " 93905",
      "County": " MONTEREY",
      "Latitude": "36.6861100  ",
      "Longitude": " -121.61594 "
   },
   {
      "Vendor": "CAL-MART",
      "Address": " 1491 LINCOLN AVE",
      "City": "CALISTOGA",
      "Zip Code": " 94515",
      "County": " NAPA",
      "Latitude": "38.5802960  ",
      "Longitude": " -122.57882 "
   },
   {
      "Vendor": "MI FAMILIA MARKET",
      "Address": " 2565 KILBURN AVE",
      "City": "NAPA",
      "Zip Code": " 94558",
      "County": " NAPA",
      "Latitude": "38.2945400  ",
      "Longitude": " -122.30361 "
   },
   {
      "Vendor": "SAFEWAY #2449",
      "Address": " 3375 JEFFERSON ST",
      "City": "NAPA",
      "Zip Code": " 94558",
      "County": " NAPA",
      "Latitude": "38.3220590  ",
      "Longitude": " -122.30003 "
   },
   {
      "Vendor": "SAFEWAY #2605",
      "Address": " 1026 HUNT AVE",
      "City": "ST. HELENA",
      "Zip Code": " 94574",
      "County": " NAPA",
      "Latitude": "38.5056600  ",
      "Longitude": " -122.46812 "
   },
   {
      "Vendor": "NOB HILL FOODS #623",
      "Address": " 611 TRANCAS ST",
      "City": "NAPA",
      "Zip Code": " 94558",
      "County": " NAPA",
      "Latitude": "38.3240840  ",
      "Longitude": " -122.28681 "
   },
   {
      "Vendor": "RALEY'S #319",
      "Address": " 217 SOSCOL AVE",
      "City": "NAPA",
      "Zip Code": " 94559",
      "County": " NAPA",
      "Latitude": "38.2835660  ",
      "Longitude": " -122.27658 "
   },
   {
      "Vendor": "SAFEWAY #1883",
      "Address": " 103 AMERICAN CANYON RD",
      "City": "AMERICAN CANYON",
      "Zip Code": " 94503",
      "County": " NAPA",
      "Latitude": "38.1644790  ",
      "Longitude": " -122.25450 "
   },
   {
      "Vendor": "LUCKY #730",
      "Address": " 2355 CALIFORNIA BLVD",
      "City": "NAPA",
      "Zip Code": " 94558",
      "County": " NAPA",
      "Latitude": "38.3059720  ",
      "Longitude": " -122.30295 "
   },
   {
      "Vendor": "LUCKY #731",
      "Address": " 1312 TRANCAS ST",
      "City": "NAPA",
      "Zip Code": " 94558",
      "County": " NAPA",
      "Latitude": "38.3232980  ",
      "Longitude": " -122.30307 "
   },
   {
      "Vendor": "ECONOMY FOOD MARKET",
      "Address": "E 1100 IMOLA AVE",
      "City": "NAPA",
      "Zip Code": " 94559",
      "County": " NAPA",
      "Latitude": "38.2817250  ",
      "Longitude": " -122.28724 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1651",
      "Address": "N 7011 MAIN ST",
      "City": "AMERICAN CANYON",
      "Zip Code": " 94503",
      "County": " NAPA",
      "Latitude": "38.1830250  ",
      "Longitude": " -122.25248 "
   },
   {
      "Vendor": "TARGET STORE T-1026",
      "Address": " 205 SOSCOL AVE",
      "City": "NAPA",
      "Zip Code": " 94559",
      "County": " NAPA",
      "Latitude": "38.2821350  ",
      "Longitude": " -122.27725 "
   },
   {
      "Vendor": "LA TAPITIA MARKET NAPA",
      "Address": " 504 BROWN ST",
      "City": "NAPA",
      "Zip Code": " 94559",
      "County": " NAPA",
      "Latitude": "38.2934150  ",
      "Longitude": " -122.28327 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2925",
      "Address": " 681 LINCOLN AVE",
      "City": "NAPA",
      "Zip Code": " 94558",
      "County": " NAPA",
      "Latitude": "38.3089350  ",
      "Longitude": " -122.28340 "
   },
   {
      "Vendor": "TARGET STORE T-1438",
      "Address": " 4000 BEL AIRE PLAZA",
      "City": "NAPA",
      "Zip Code": " 94558",
      "County": " NAPA",
      "Latitude": "38.3224740  ",
      "Longitude": " -122.30650 "
   },
   {
      "Vendor": "RADIO SHARK",
      "Address": " 3016 JEFFERSON ST",
      "City": "NAPA",
      "Zip Code": " 94558",
      "County": " NAPA",
      "Latitude": "38.3162960  ",
      "Longitude": " -122.29751 "
   },
   {
      "Vendor": "NOB HILL FOODS #605",
      "Address": " 1700 AIRLINE HWY",
      "City": "HOLLISTER",
      "Zip Code": " 95023",
      "County": " SAN BENITO",
      "Latitude": "36.8372560  ",
      "Longitude": " -121.39086 "
   },
   {
      "Vendor": "HOLLISTER SUPER",
      "Address": " 1280 SAN JUAN RD",
      "City": "HOLLISTER",
      "Zip Code": " 95023",
      "County": " SAN BENITO",
      "Latitude": "36.8535310  ",
      "Longitude": " -121.42067 "
   },
   {
      "Vendor": "HOLLISTER SUPER #2",
      "Address": " 211 THIRD ST",
      "City": "HOLLISTER",
      "Zip Code": " 95023",
      "County": " SAN BENITO",
      "Latitude": "36.8533450  ",
      "Longitude": " -121.40108 "
   },
   {
      "Vendor": "SAFEWAY #1757",
      "Address": " 591 TRES PINOS RD",
      "City": "HOLLISTER",
      "Zip Code": " 95023",
      "County": " SAN BENITO",
      "Latitude": "36.8384990  ",
      "Longitude": " -121.39166 "
   },
   {
      "Vendor": "LUCKY #719",
      "Address": " 291 MCCRAY ST",
      "City": "HOLLISTER",
      "Zip Code": " 95023",
      "County": " SAN BENITO",
      "Latitude": "36.8532300  ",
      "Longitude": " -121.39749 "
   },
   {
      "Vendor": "TARGET STORE T-0941",
      "Address": " 1790 AIRLINE HWY",
      "City": "HOLLISTER",
      "Zip Code": " 95023",
      "County": " SAN BENITO",
      "Latitude": "36.8353450  ",
      "Longitude": " -121.38940 "
   },
   {
      "Vendor": "LUPITA'S SUPERMERCADO",
      "Address": " 889 4TH ST",
      "City": "HOLLISTER",
      "Zip Code": " 95023",
      "County": " SAN BENITO",
      "Latitude": "36.8524710  ",
      "Longitude": " -121.41260 "
   },
   {
      "Vendor": "SAFEWAY #0759",
      "Address": " 625 MONTEREY BLVD",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94127",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7312320  ",
      "Longitude": " -122.44955 "
   },
   {
      "Vendor": "SAFEWAY #0739",
      "Address": " 3350 MISSION ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94110",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7433900  ",
      "Longitude": " -122.42154 "
   },
   {
      "Vendor": "SAFEWAY #1711",
      "Address": " 15 MARINA BLVD",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94123",
      "County": " SAN FRANCISCO",
      "Latitude": "37.8045780  ",
      "Longitude": " -122.43301 "
   },
   {
      "Vendor": "SAFEWAY #2646",
      "Address": " 735 7TH AVE",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94118",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7747410  ",
      "Longitude": " -122.46542 "
   },
   {
      "Vendor": "SAFEWAY #1507",
      "Address": " 2020 MARKET ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94114",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7691320  ",
      "Longitude": " -122.42803 "
   },
   {
      "Vendor": "SAFEWAY #0667",
      "Address": " 5290 DIAMOND HEIGHTS BLVD",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94131",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7437180  ",
      "Longitude": " -122.43904 "
   },
   {
      "Vendor": "SAFEWAY #1490",
      "Address": " 2300 16TH ST",
      "Second Address": " STE 203",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94103",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7658320  ",
      "Longitude": " -122.41012 "
   },
   {
      "Vendor": "SAFEWAY #0785",
      "Address": " 850 LA PLAYA ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94121",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7723550  ",
      "Longitude": " -122.50942 "
   },
   {
      "Vendor": "SAFEWAY #0909",
      "Address": " 730 TARAVAL ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94116",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7433380  ",
      "Longitude": " -122.47389 "
   },
   {
      "Vendor": "SAFEWAY #0964",
      "Address": " 4950 MISSION ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94112",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7196010  ",
      "Longitude": " -122.43915 "
   },
   {
      "Vendor": "SAFEWAY #4601",
      "Address": " 145 JACKSON ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94111",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7969460  ",
      "Longitude": " -122.39859 "
   },
   {
      "Vendor": "SAFEWAY #0995",
      "Address": " 1335 WEBSTER ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94115",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7825180  ",
      "Longitude": " -122.43108 "
   },
   {
      "Vendor": "SAFEWAY #0985",
      "Address": " 2350 NORIEGA ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94122",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7541280  ",
      "Longitude": " -122.48882 "
   },
   {
      "Vendor": "SAFEWAY #1206",
      "Address": " 350 BAY ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94133",
      "County": " SAN FRANCISCO",
      "Latitude": "37.8062250  ",
      "Longitude": " -122.41270 "
   },
   {
      "Vendor": "FOODS CO #351",
      "Address": " 345 WILLIAMS AVE",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94124",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7297840  ",
      "Longitude": " -122.39931 "
   },
   {
      "Vendor": "FOODS CO #357",
      "Address": " 1800 FOLSOM ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94103",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7678320  ",
      "Longitude": " -122.41611 "
   },
   {
      "Vendor": "M & M SHORT STOP",
      "Address": " 2145A GENEVA AVE",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94134",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7086810  ",
      "Longitude": " -122.42026 "
   },
   {
      "Vendor": "WALGREENS #893",
      "Address": " 1344 STOCKTON ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94133",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7982410  ",
      "Longitude": " -122.40859 "
   },
   {
      "Vendor": "SAFEWAY #2606",
      "Address": " 298 KING ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94107",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7763970  ",
      "Longitude": " -122.39343 "
   },
   {
      "Vendor": "LUCKY #755",
      "Address": " 1515 SLOAT BLVD",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94132",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7331910  ",
      "Longitude": " -122.48976 "
   },
   {
      "Vendor": "LUCKY #756",
      "Address": " 1750 FULTON ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94117",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7759020  ",
      "Longitude": " -122.44578 "
   },
   {
      "Vendor": "SMART & FINAL #351",
      "Address": " 350 SEVENTH AVE",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94118",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7818440  ",
      "Longitude": " -122.46508 "
   },
   {
      "Vendor": "WALGREENS #5487",
      "Address": " 5300 3RD ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94124",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7289810  ",
      "Longitude": " -122.39306 "
   },
   {
      "Vendor": "SUPER SAVE SUPERMARKET",
      "Address": " 4517 3RD ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94124",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7365530  ",
      "Longitude": " -122.38969 "
   },
   {
      "Vendor": "EL CHICO PRODUCE MARKET #4",
      "Address": " 2965 24TH ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94110",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7524300  ",
      "Longitude": " -122.41120 "
   },
   {
      "Vendor": "WALGREENS #4231",
      "Address": " 2690 MISSION ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94110",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7540290  ",
      "Longitude": " -122.41897 "
   },
   {
      "Vendor": "OASIS FOOD MARKET",
      "Address": " 444 GRAND AVE",
      "City": "SOUTH SAN FRANCISCO",
      "Zip Code": " 94080",
      "County": " SAN MATEO",
      "Latitude": "37.6564210  ",
      "Longitude": " -122.41443 "
   },
   {
      "Vendor": "GUZMAN'S PRODUCE MARKET",
      "Address": " 5229 MISSION ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94112",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7151400  ",
      "Longitude": " -122.44206 "
   },
   {
      "Vendor": "TARGET STORE T-2766",
      "Address": " 789 MISSION ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94103",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7845030  ",
      "Longitude": " -122.40397 "
   },
   {
      "Vendor": "TARGET STORE T-2768",
      "Address": " 2675 GEARY BLVD",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94118",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7820590  ",
      "Longitude": " -122.44692 "
   },
   {
      "Vendor": "BNC #49",
      "Address": " 2424 SAN BRUNO AVE",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94134",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7318650  ",
      "Longitude": " -122.40557 "
   },
   {
      "Vendor": "FRESH START #1",
      "Address": " 2631 23RD ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94110",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7541730  ",
      "Longitude": " -122.40609 "
   },
   {
      "Vendor": "FRESH START #2",
      "Address": " 2400 SAN BRUNO AVE",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94134",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7321400  ",
      "Longitude": " -122.40590 "
   },
   {
      "Vendor": "ANDRONICO'S COMMUNITY MKT 2",
      "Address": " 1200 IRVING ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94122",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7643490  ",
      "Longitude": " -122.47116 "
   },
   {
      "Vendor": "LUNA'S COFFEE HOUSE",
      "Address": " 1101 POTRERO AVE",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94110",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7545780  ",
      "Longitude": " -122.40624 "
   },
   {
      "Vendor": "BABY & MOM NUTRITION",
      "Address": " 4992 MISSION ST",
      "City": "SAN FRANCISCO",
      "Zip Code": " 94112",
      "County": " SAN FRANCISCO",
      "Latitude": "37.7186930  ",
      "Longitude": " -122.43959 "
   },
   {
      "Vendor": "COOKIE CROCK MARKET",
      "Address": " 1240 KNOLLWOOD DR",
      "City": "CAMBRIA",
      "Zip Code": " 93428",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.5634450  ",
      "Longitude": " -121.09199 "
   },
   {
      "Vendor": "VONS #2314",
      "Address": " 7135 EL CAMINO REAL",
      "City": "ATASCADERO",
      "Zip Code": " 93422",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.4858570  ",
      "Longitude": " -120.66234 "
   },
   {
      "Vendor": "VONS #2306",
      "Address": "S 3900 BROAD ST",
      "City": "SAN LUIS OBISPO",
      "Zip Code": " 93401",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.2503650  ",
      "Longitude": " -120.64206 "
   },
   {
      "Vendor": "VONS #2560",
      "Address": " 1758 GRAND AVE",
      "City": "GROVER BEACH",
      "Zip Code": " 93433",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.1221490  ",
      "Longitude": " -120.63283 "
   },
   {
      "Vendor": "SPENCER'S FRESH MARKET",
      "Address": " 2650 MAIN ST",
      "City": "MORRO BAY",
      "Zip Code": " 93442",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.3893380  ",
      "Longitude": " -120.85843 "
   },
   {
      "Vendor": "VONS #1621",
      "Address": "W 525 TEFFT ST",
      "City": "NIPOMO",
      "Zip Code": " 93444",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.0362880  ",
      "Longitude": " -120.48561 "
   },
   {
      "Vendor": "CENTRAL MARKET",
      "Address": " 2061 CIENAGA ST",
      "City": "OCEANO",
      "Zip Code": " 93445",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.0984190  ",
      "Longitude": " -120.60945 "
   },
   {
      "Vendor": "RALPHS #656",
      "Address": " 201 MADONNA RD",
      "City": "SAN LUIS OBISPO",
      "Zip Code": " 93405",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.2634740  ",
      "Longitude": " -120.67604 "
   },
   {
      "Vendor": "FOOD 4 LESS #12",
      "Address": " 1465 CRESTON RD",
      "City": "PASO ROBLES",
      "Zip Code": " 93446",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.6169150  ",
      "Longitude": " -120.65770 "
   },
   {
      "Vendor": "FOOD 4 LESS #10",
      "Address": " 8360 EL CAMINO REAL",
      "City": "ATASCADERO",
      "Zip Code": " 93422",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.4737480  ",
      "Longitude": " -120.65583 "
   },
   {
      "Vendor": "FOOD 4 LESS #11",
      "Address": "S 3985 HIGUERA ST",
      "City": "SAN LUIS OBISPO",
      "Zip Code": " 93401",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.2445180  ",
      "Longitude": " -120.67365 "
   },
   {
      "Vendor": "RALPHS #271",
      "Address": " 1240 LOS OSOS VALLEY RD",
      "City": "LOS OSOS",
      "Zip Code": " 93402",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.3112260  ",
      "Longitude": " -120.82586 "
   },
   {
      "Vendor": "OAK HILL MARKET",
      "Address": " 2150 HERITAGE LOOP RD",
      "City": "PASO ROBLES",
      "Zip Code": " 93446",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.7424684  ",
      "Longitude": " -120.87741 "
   },
   {
      "Vendor": "HEALTHY BABIES",
      "Address": " 1912 CRESTON RD",
      "Second Address": " STE B",
      "City": "PASO ROBLES",
      "Zip Code": " 93446",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.6068500  ",
      "Longitude": " -120.65821 "
   },
   {
      "Vendor": "TARGET STORE T-2759",
      "Address": " 11990 LOS OSOS VALLEY RD",
      "City": "SAN LUIS OBISPO",
      "Zip Code": " 93405",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.2513120  ",
      "Longitude": " -120.68612 "
   },
   {
      "Vendor": "TARGET STORE T-1120",
      "Address": " 2305 THEATRE DR",
      "City": "PASO ROBLES",
      "Zip Code": " 93446",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.5836750  ",
      "Longitude": " -120.69695 "
   },
   {
      "Vendor": "ALBERTSONS #314",
      "Address": " 189 NIBLICK RD",
      "City": "PASO ROBLES",
      "Zip Code": " 93447",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.6151030  ",
      "Longitude": " -120.68203 "
   },
   {
      "Vendor": "ALBERTSONS #1345",
      "Address": " 730 QUINTANA RD",
      "City": "MORRO BAY",
      "Zip Code": " 93442",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.3677360  ",
      "Longitude": " -120.84442 "
   },
   {
      "Vendor": "SMART & FINAL #392",
      "Address": " 2121 SPRING ST",
      "City": "PASO ROBLES",
      "Zip Code": " 93446",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.6365660  ",
      "Longitude": " -120.69281 "
   },
   {
      "Vendor": "SMART & FINAL #358",
      "Address": " 1464 GRAND AVE",
      "City": "ARROYO GRANDE",
      "Zip Code": " 93420",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.1208780  ",
      "Longitude": " -120.60619 "
   },
   {
      "Vendor": "WAL-MART STORE #2556",
      "Address": "W 1168 BRANCH ST",
      "City": "ARROYO GRANDE",
      "Zip Code": " 93420",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.1270580  ",
      "Longitude": " -120.59752 "
   },
   {
      "Vendor": "WAL-MART STORE #2099",
      "Address": " 180 NIBLICK RD",
      "City": "PASO ROBLES",
      "Zip Code": " 93446",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.6147680  ",
      "Longitude": " -120.68206 "
   },
   {
      "Vendor": "MI GUADALAJARA MEAT MARKET",
      "Address": "W 1400 GRAND AVE",
      "Second Address": " STE D",
      "City": "GROVER BEACH",
      "Zip Code": " 93433",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.1205260  ",
      "Longitude": " -120.61357 "
   },
   {
      "Vendor": "SMART & FINAL #912",
      "Address": " 8200 EL CAMINO REAL",
      "City": "ATASCADERO",
      "Zip Code": " 93422",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.4753850  ",
      "Longitude": " -120.65679 "
   },
   {
      "Vendor": "SMART & FINAL #913",
      "Address": " 1321 JOHNSON AVE",
      "City": "SAN LUIS OBISPO",
      "Zip Code": " 93401",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.2816310  ",
      "Longitude": " -120.65552 "
   },
   {
      "Vendor": "SMART & FINAL #939",
      "Address": "E 1191 CRESTON RD",
      "City": "PASO ROBLES",
      "Zip Code": " 93446",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.6222520  ",
      "Longitude": " -120.65971 "
   },
   {
      "Vendor": "FOOD 4 LESS #13",
      "Address": "W 1132 BRANCH ST",
      "City": "ARROYO GRANDE",
      "Zip Code": " 93420",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.1288890  ",
      "Longitude": " -120.59564 "
   },
   {
      "Vendor": "NURTURED FAMILIES",
      "Address": "W 1508 GRAND AVE",
      "City": "GROVER BEACH",
      "Zip Code": " 93433",
      "County": " SAN LUIS OBISPO",
      "Latitude": "35.1209380  ",
      "Longitude": " -120.61290 "
   },
   {
      "Vendor": "SAFEWAY #3008",
      "Address": " 12 MANOR PLAZA",
      "City": "PACIFICA",
      "Zip Code": " 94044",
      "County": " SAN MATEO",
      "Latitude": "37.6501320  ",
      "Longitude": " -122.49188 "
   },
   {
      "Vendor": "SAFEWAY #2719",
      "Address": " 525 EL CAMINO REAL",
      "City": "MENLO PARK",
      "Zip Code": " 94025",
      "County": " SAN MATEO",
      "Latitude": "37.4506140  ",
      "Longitude": " -122.17883 "
   },
   {
      "Vendor": "SAFEWAY #0639",
      "Address": " 100 DE ANZA BLVD",
      "City": "SAN MATEO",
      "Zip Code": " 94402",
      "County": " SAN MATEO",
      "Latitude": "37.5209810  ",
      "Longitude": " -122.33767 "
   },
   {
      "Vendor": "SAFEWAY #0668",
      "Address": " 2100 RALSTON AVE",
      "City": "BELMONT",
      "Zip Code": " 94002",
      "County": " SAN MATEO",
      "Latitude": "37.5122050  ",
      "Longitude": " -122.29552 "
   },
   {
      "Vendor": "SAFEWAY #0694",
      "Address": "N 860 DELAWARE ST",
      "City": "SAN MATEO",
      "Zip Code": " 94401",
      "County": " SAN MATEO",
      "Latitude": "37.5805290  ",
      "Longitude": " -122.33303 "
   },
   {
      "Vendor": "SAFEWAY #1709",
      "Address": "S 325 SHARON PARK DR",
      "City": "MENLO PARK",
      "Zip Code": " 94025",
      "County": " SAN MATEO",
      "Latitude": "37.4234670  ",
      "Longitude": " -122.19774 "
   },
   {
      "Vendor": "SAFEWAY #1547",
      "Address": " 1450 HOWARD AVE",
      "City": "BURLINGAME",
      "Zip Code": " 94010",
      "County": " SAN MATEO",
      "Latitude": "37.5764230  ",
      "Longitude": " -122.34800 "
   },
   {
      "Vendor": "SAFEWAY #0747",
      "Address": " 850 WOODSIDE RD",
      "City": "REDWOOD CITY",
      "Zip Code": " 94061",
      "County": " SAN MATEO",
      "Latitude": "37.4655810  ",
      "Longitude": " -122.22513 "
   },
   {
      "Vendor": "SAFEWAY #0777",
      "Address": " 30 CHESTNUT AVE",
      "City": "SOUTH SAN FRANCISCO",
      "Zip Code": " 94080",
      "County": " SAN MATEO",
      "Latitude": "37.6553880  ",
      "Longitude": " -122.43177 "
   },
   {
      "Vendor": "SAFEWAY #0970",
      "Address": " 1655 EL CAMINO REAL",
      "City": "SAN MATEO",
      "Zip Code": " 94402",
      "County": " SAN MATEO",
      "Latitude": "37.5531430  ",
      "Longitude": " -122.31384 "
   },
   {
      "Vendor": "SAFEWAY #0304",
      "Address": " 1380 LINDA MAR SHOPPING C",
      "City": "PACIFICA",
      "Zip Code": " 94044",
      "County": " SAN MATEO",
      "Latitude": "37.5950040  ",
      "Longitude": " -122.50279 "
   },
   {
      "Vendor": "SAFEWAY #0308",
      "Address": "N 70 CABRILLO HWY",
      "City": "HALF MOON BAY",
      "Zip Code": " 94019",
      "County": " SAN MATEO",
      "Latitude": "37.4691440  ",
      "Longitude": " -122.43620 "
   },
   {
      "Vendor": "SAFEWAY #3031",
      "Address": " 85 WESTLAKE MALL",
      "City": "DALY CITY",
      "Zip Code": " 94015",
      "County": " SAN MATEO",
      "Latitude": "37.6997190  ",
      "Longitude": " -122.48146 "
   },
   {
      "Vendor": "SAFEWAY #0999",
      "Address": "E 921 HILLSDALE BLVD",
      "City": "FOSTER CITY",
      "Zip Code": " 94404",
      "County": " SAN MATEO",
      "Latitude": "37.5558310  ",
      "Longitude": " -122.27566 "
   },
   {
      "Vendor": "SAFEWAY #3116",
      "Address": " 2255 GELLERT BLVD",
      "City": "SOUTH SAN FRANCISCO",
      "Zip Code": " 94080",
      "County": " SAN MATEO",
      "Latitude": "37.6464090  ",
      "Longitude": " -122.45208 "
   },
   {
      "Vendor": "SAFEWAY #0305",
      "Address": " 1071 EL CAMINO REAL",
      "City": "REDWOOD CITY",
      "Zip Code": " 94063",
      "County": " SAN MATEO",
      "Latitude": "37.4837120  ",
      "Longitude": " -122.23143 "
   },
   {
      "Vendor": "SAFEWAY #1138",
      "Address": " 1100 EL CAMINO REAL",
      "City": "BELMONT",
      "Zip Code": " 94002",
      "County": " SAN MATEO",
      "Latitude": "37.5188860  ",
      "Longitude": " -122.27555 "
   },
   {
      "Vendor": "LA HACIENDA MARKET #2",
      "Address": "N 201 AMPHLETT BLVD",
      "City": "SAN MATEO",
      "Zip Code": " 94401",
      "County": " SAN MATEO",
      "Latitude": "37.5761550  ",
      "Longitude": " -122.32077 "
   },
   {
      "Vendor": "MI RANCHO SUPERMARKET #2",
      "Address": " 137 ROOSEVELT AVE",
      "City": "REDWOOD CITY",
      "Zip Code": " 94061",
      "County": " SAN MATEO",
      "Latitude": "37.4783080  ",
      "Longitude": " -122.22561 "
   },
   {
      "Vendor": "LUCKY CALIFORNIA #707",
      "Address": " 6843 MISSION BLVD",
      "City": "DALY CITY",
      "Zip Code": " 94015",
      "County": " SAN MATEO",
      "Latitude": "37.6978960  ",
      "Longitude": " -122.46305 "
   },
   {
      "Vendor": "LUCKY #710",
      "Address": " 919 EDGEWATER BLVD",
      "City": "FOSTER CITY",
      "Zip Code": " 94404",
      "County": " SAN MATEO",
      "Latitude": "37.5450300  ",
      "Longitude": " -122.27181 "
   },
   {
      "Vendor": "LUCKY #726",
      "Address": " 45 MURCHISON DR",
      "City": "MILLBRAE",
      "Zip Code": " 94030",
      "County": " SAN MATEO",
      "Latitude": "37.5962490  ",
      "Longitude": " -122.38632 "
   },
   {
      "Vendor": "LUCKY #745",
      "Address": " 200 WOODSIDE PLAZA",
      "City": "REDWOOD CITY",
      "Zip Code": " 94061",
      "County": " SAN MATEO",
      "Latitude": "37.4565590  ",
      "Longitude": " -122.22994 "
   },
   {
      "Vendor": "LUCKY #748",
      "Address": " 1322 EL CAMINO REAL",
      "City": "SAN BRUNO",
      "Zip Code": " 94066",
      "County": " SAN MATEO",
      "Latitude": "37.6399150  ",
      "Longitude": " -122.42222 "
   },
   {
      "Vendor": "UNITED FOOD CENTER",
      "Address": " 8100 HIGHWAY 111",
      "City": "NILAND",
      "Zip Code": " 92257",
      "County": " IMPERIAL",
      "Latitude": "33.2402240  ",
      "Longitude": " -115.51904 "
   },
   {
      "Vendor": "VONS #2406",
      "Address": "N 750 IMPERIAL AVE",
      "City": "EL CENTRO",
      "Zip Code": " 92243",
      "County": " IMPERIAL",
      "Latitude": "32.7989520  ",
      "Longitude": " -115.57159 "
   },
   {
      "Vendor": "EL CENTRO COMMISSARY",
      "Address": " 2024 BENNETT RD",
      "City": "NAF EL CENTRO",
      "Zip Code": " 92243",
      "County": " IMPERIAL",
      "Latitude": "32.7982740  ",
      "Longitude": " -115.67205 "
   },
   {
      "Vendor": "CALIFORNIA SUPER MARKET",
      "Address": "S 601 IMPERIAL AVE",
      "City": "CALEXICO",
      "Zip Code": " 92231",
      "County": " IMPERIAL",
      "Latitude": "32.6714130  ",
      "Longitude": " -115.49903 "
   },
   {
      "Vendor": "EL SOL MEAT MARKET #2",
      "Address": "W 100 BIRCH ST",
      "City": "CALEXICO",
      "Zip Code": " 92231",
      "County": " IMPERIAL",
      "Latitude": "32.6788480  ",
      "Longitude": " -115.50026 "
   },
   {
      "Vendor": "KENNEDY'S MARKET",
      "Address": "E 70 MAIN ST",
      "City": "HEBER",
      "Zip Code": " 92249",
      "County": " IMPERIAL",
      "Latitude": "32.7310100  ",
      "Longitude": " -115.52860 "
   },
   {
      "Vendor": "DEL SOL MARKET",
      "Address": "E 402 5TH ST",
      "City": "HOLTVILLE",
      "Zip Code": " 92250",
      "County": " IMPERIAL",
      "Latitude": "32.8104590  ",
      "Longitude": " -115.37607 "
   },
   {
      "Vendor": "EL SOL MEAT MARKET",
      "Address": " 1100 MEADOWS ROAD",
      "City": "CALEXICO",
      "Zip Code": " 92231",
      "County": " IMPERIAL",
      "Latitude": "32.6799000  ",
      "Longitude": " -115.48217 "
   },
   {
      "Vendor": "EL SOL MARKET #7",
      "Address": "S 1586 4TH ST",
      "City": "EL CENTRO",
      "Zip Code": " 92243",
      "County": " IMPERIAL",
      "Latitude": "32.7791450  ",
      "Longitude": " -115.55306 "
   },
   {
      "Vendor": "VONS #1767",
      "Address": "W 475 MAIN ST",
      "City": "BRAWLEY",
      "Zip Code": " 92227",
      "County": " IMPERIAL",
      "Latitude": "32.9791650  ",
      "Longitude": " -115.55016 "
   },
   {
      "Vendor": "FOOD 4 LESS #774",
      "Address": "N 2420 COTTONWOOD DR",
      "City": "EL CENTRO",
      "Zip Code": " 92243",
      "County": " IMPERIAL",
      "Latitude": "32.8157160  ",
      "Longitude": " -115.57216 "
   },
   {
      "Vendor": "FOOD 4 LESS #781",
      "Address": "W 109 BIRCH ST",
      "City": "CALEXICO",
      "Zip Code": " 92231",
      "County": " IMPERIAL",
      "Latitude": "32.6773240  ",
      "Longitude": " -115.52235 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1859",
      "Address": " 2540 ROCKWOOD AVE",
      "City": "CALEXICO",
      "Zip Code": " 92231",
      "County": " IMPERIAL",
      "Latitude": "32.6976410  ",
      "Longitude": " -115.49869 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1555",
      "Address": "N 2150 WATERMAN AVE",
      "City": "EL CENTRO",
      "Zip Code": " 92243",
      "County": " IMPERIAL",
      "Latitude": "32.8117420  ",
      "Longitude": " -115.57446 "
   },
   {
      "Vendor": "EUCLID MARKET",
      "Address": "W 603 EUCLID AVE",
      "City": "EL CENTRO",
      "Zip Code": " 92243",
      "County": " IMPERIAL",
      "Latitude": "32.7981300  ",
      "Longitude": " -115.55727 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5335",
      "Address": " 250 WILDCAT DR",
      "City": "BRAWLEY",
      "Zip Code": " 92227",
      "County": " IMPERIAL",
      "Latitude": "32.9634560  ",
      "Longitude": " -115.54664 "
   },
   {
      "Vendor": "LUCKY #749",
      "Address": " 1133 OLD COUNTY RD",
      "City": "SAN CARLOS",
      "Zip Code": " 94070",
      "County": " SAN MATEO",
      "Latitude": "37.5000350  ",
      "Longitude": " -122.24922 "
   },
   {
      "Vendor": "CHAVEZ MEAT MARKET",
      "Address": " 775 ARGUELLO ST",
      "City": "REDWOOD CITY",
      "Zip Code": " 94063",
      "County": " SAN MATEO",
      "Latitude": "37.4885120  ",
      "Longitude": " -122.23540 "
   },
   {
      "Vendor": "CHAVEZ SUPERMARKET",
      "Address": " 3282 MIDDLEFIELD RD",
      "City": "MENLO PARK",
      "Zip Code": " 94025",
      "County": " SAN MATEO",
      "Latitude": "37.4708140  ",
      "Longitude": " -122.20333 "
   },
   {
      "Vendor": "CHAVEZ SUPERMARKET",
      "Address": " 46 5TH ST",
      "City": "REDWOOD CITY",
      "Zip Code": " 94063",
      "County": " SAN MATEO",
      "Latitude": "37.4674280  ",
      "Longitude": " -122.20797 "
   },
   {
      "Vendor": "SOLESKA MARKET",
      "Address": " 1305 WILLOW RD",
      "City": "MENLO PARK",
      "Zip Code": " 94025",
      "County": " SAN MATEO",
      "Latitude": "37.4763890  ",
      "Longitude": " -122.15326 "
   },
   {
      "Vendor": "LA MORENITA MARKET",
      "Address": " 2434 JEFFERSON ST",
      "City": "NAPA",
      "Zip Code": " 94558",
      "County": " NAPA",
      "Latitude": "38.3095410  ",
      "Longitude": " -122.29566 "
   },
   {
      "Vendor": "MI TIERRA LINDA SUPERMERCADO",
      "Address": " 1209 WILLOW RD",
      "City": "MENLO PARK",
      "Zip Code": " 94025",
      "County": " SAN MATEO",
      "Latitude": "37.4733160  ",
      "Longitude": " -122.15477 "
   },
   {
      "Vendor": "NOB HILL FOODS #628",
      "Address": " 270 REDWOOD SHORES PKWY",
      "City": "REDWOOD CITY",
      "Zip Code": " 94065",
      "County": " SAN MATEO",
      "Latitude": "37.5232220  ",
      "Longitude": " -122.25201 "
   },
   {
      "Vendor": "SMART & FINAL #441",
      "Address": " 249 KENWOOD WAY",
      "City": "SO SAN FRANCISCO",
      "Zip Code": " 94080",
      "County": " SAN MATEO",
      "Latitude": "37.6420100  ",
      "Longitude": " -122.42607 "
   },
   {
      "Vendor": "SMART & FINAL #530",
      "Address": " 1783 HILLSDALE AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95124",
      "County": " SANTA CLARA",
      "Latitude": "37.2644110  ",
      "Longitude": " -121.91562 "
   },
   {
      "Vendor": "SMART & FINAL #320",
      "Address": " 6967 MISSION BLVD",
      "City": "DALY CITY",
      "Zip Code": " 94014",
      "County": " SAN MATEO",
      "Latitude": "37.6963360  ",
      "Longitude": " -122.46412 "
   },
   {
      "Vendor": "SMART & FINAL #410",
      "Address": " 1185 BROADWAY ST",
      "City": "REDWOOD CITY",
      "Zip Code": " 94063",
      "County": " SAN MATEO",
      "Latitude": "37.4864620  ",
      "Longitude": " -122.21389 "
   },
   {
      "Vendor": "SMART & FINAL #453",
      "Address": "S 1840 NORFOLK ST",
      "City": "SAN MATEO",
      "Zip Code": " 94403",
      "County": " SAN MATEO",
      "Latitude": "37.5556340  ",
      "Longitude": " -122.29331 "
   },
   {
      "Vendor": "LA ESTRELLITA MARKET",
      "Address": " 2387 UNIVERSITY AVE",
      "City": "EAST PALO ALTO",
      "Zip Code": " 94303",
      "County": " SAN MATEO",
      "Latitude": "37.4713370  ",
      "Longitude": " -122.14022 "
   },
   {
      "Vendor": "LA TIENDITA MARKET",
      "Address": " 510 O'CONNOR ST",
      "City": "EAST PALO ALTO",
      "Zip Code": " 94303",
      "County": " SAN MATEO",
      "Latitude": "37.4602310  ",
      "Longitude": " -122.14421 "
   },
   {
      "Vendor": "TARGET STORE T-1407",
      "Address": " 133 SERRAMONTE CTR",
      "City": "DALY CITY",
      "Zip Code": " 94015",
      "County": " SAN MATEO",
      "Latitude": "37.6712900  ",
      "Longitude": " -122.46852 "
   },
   {
      "Vendor": "TARGET STORE T-0321",
      "Address": " 2485 EL CAMINO REAL",
      "City": "REDWOOD CITY",
      "Zip Code": " 94061",
      "County": " SAN MATEO",
      "Latitude": "37.4741710  ",
      "Longitude": " -122.21816 "
   },
   {
      "Vendor": "TARGET STORE T-1122",
      "Address": " 2220 BRIDGEPOINTE PKWY",
      "City": "FOSTER CITY",
      "Zip Code": " 94404",
      "County": " SAN MATEO",
      "Latitude": "37.5618880  ",
      "Longitude": " -122.28200 "
   },
   {
      "Vendor": "MI RANCHO SUPERMARKET",
      "Address": " 150 CHARTER ST",
      "City": "REDWOOD CITY",
      "Zip Code": " 94063",
      "County": " SAN MATEO",
      "Latitude": "37.4766140  ",
      "Longitude": " -122.21777 "
   },
   {
      "Vendor": "TARGET STORE T-1054",
      "Address": " 1150 EL CAMINO REAL",
      "City": "SAN BRUNO",
      "Zip Code": " 94066",
      "County": " SAN MATEO",
      "Latitude": "37.6357330  ",
      "Longitude": " -122.42032 "
   },
   {
      "Vendor": "TARGET STORE T-0320",
      "Address": " 5001 JUNIPERO SERRA BLVD",
      "City": "SAN MATEO",
      "Zip Code": " 94014",
      "County": " SAN MATEO",
      "Latitude": "37.6740880  ",
      "Longitude": " -122.46423 "
   },
   {
      "Vendor": "LA HACIENDA FOOD CENTER",
      "Address": " 1933 MENALTO AVE",
      "City": "MENLO PARK",
      "Zip Code": " 94025",
      "County": " SAN MATEO",
      "Latitude": "37.4594830  ",
      "Longitude": " -122.15287 "
   },
   {
      "Vendor": "SAFEWAY #2878",
      "Address": " 525 EL CAMINO REAL",
      "City": "MILLBRAE",
      "Zip Code": " 94030",
      "County": " SAN MATEO",
      "Latitude": "37.6034670  ",
      "Longitude": " -122.39446 "
   },
   {
      "Vendor": "LA HACIENDA MARKET",
      "Address": " 249 HILLSIDE BLVD",
      "City": "SOUTH SAN FRANCISCO",
      "Zip Code": " 94080",
      "County": " SAN MATEO",
      "Latitude": "37.6628760  ",
      "Longitude": " -122.40853 "
   },
   {
      "Vendor": "LOS PRIMOS PRODUCE & GROCER",
      "Address": " 599 SAN MATEO AVE",
      "City": "SAN BRUNO",
      "Zip Code": " 94066",
      "County": " SAN MATEO",
      "Latitude": "37.6264440  ",
      "Longitude": " -122.41126 "
   },
   {
      "Vendor": "FAST AND EASY",
      "Address": " 2512 EL CAMINO REAL",
      "City": "REDWOOD CITY",
      "Zip Code": " 94061",
      "County": " SAN MATEO",
      "Latitude": "37.4734760  ",
      "Longitude": " -122.21812 "
   },
   {
      "Vendor": "FAST & EASY 123",
      "Address": " 2388 JUNIPERO SERRA BLVD",
      "Second Address": " STE B",
      "City": "DALY CITY",
      "Zip Code": " 94015",
      "County": " SAN MATEO",
      "Latitude": "37.6935260  ",
      "Longitude": " -122.47124 "
   },
   {
      "Vendor": "CHAVEZ SUPERMARKET",
      "Address": "S 500 NORFOLK ST",
      "City": "SAN MATEO",
      "Zip Code": " 94401",
      "County": " SAN MATEO",
      "Latitude": "37.5715680  ",
      "Longitude": " -122.31000 "
   },
   {
      "Vendor": "SAFEWAY #2843",
      "Address": " 709 HICKEY BLVD",
      "City": "PACIFICA",
      "Zip Code": " 94044",
      "County": " SAN MATEO",
      "Latitude": "37.6609830  ",
      "Longitude": " -122.47880 "
   },
   {
      "Vendor": "CARDENAS #215",
      "Address": "E 1731 BAYSHORE RD",
      "City": "EAST PALO ALTO",
      "Zip Code": " 94303",
      "County": " SAN MATEO",
      "Latitude": "37.4589550  ",
      "Longitude": " -122.13701 "
   },
   {
      "Vendor": "EL CHICO PRODUCE MARKET #3",
      "Address": " 390 GRAND AVE",
      "City": "SOUTH SAN FRANCISCO",
      "Zip Code": " 94080",
      "County": " SAN MATEO",
      "Latitude": "37.6558340  ",
      "Longitude": " -122.41224 "
   },
   {
      "Vendor": "NOB HILL FOODS #606",
      "Address": "W 1602 CAMPBELL AVE",
      "City": "CAMPBELL",
      "Zip Code": " 95008",
      "County": " SANTA CLARA",
      "Latitude": "37.2853480  ",
      "Longitude": " -121.97866 "
   },
   {
      "Vendor": "NOB HILL FOODS #602",
      "Address": " 777 FIRST ST",
      "City": "GILROY",
      "Zip Code": " 95020",
      "County": " SANTA CLARA",
      "Latitude": "37.0143810  ",
      "Longitude": " -121.58522 "
   },
   {
      "Vendor": "SAFEWAY #0695",
      "Address": " 6477 ALMADEN RD",
      "City": "SAN JOSE",
      "Zip Code": " 95120",
      "County": " SANTA CLARA",
      "Latitude": "37.2225280  ",
      "Longitude": " -121.86423 "
   },
   {
      "Vendor": "SAFEWAY #0763",
      "Address": " 2605 THE ALAMEDA",
      "City": "SANTA CLARA",
      "Zip Code": " 95050",
      "County": " SANTA CLARA",
      "Latitude": "37.3454250  ",
      "Longitude": " -121.93653 "
   },
   {
      "Vendor": "SAFEWAY #1526",
      "Address": " 3071 STEVENS CREEK BLVD",
      "City": "SANTA CLARA",
      "Zip Code": " 95050",
      "County": " SANTA CLARA",
      "Latitude": "37.3236520  ",
      "Longitude": " -121.94875 "
   },
   {
      "Vendor": "SAFEWAY #0929",
      "Address": " 2558 BERRYESSA RD",
      "City": "SAN JOSE",
      "Zip Code": " 95132",
      "County": " SANTA CLARA",
      "Latitude": "37.3880620  ",
      "Longitude": " -121.85804 "
   },
   {
      "Vendor": "SAFEWAY #1682",
      "Address": " 2811 MIDDLEFIELD RD",
      "City": "PALO ALTO",
      "Zip Code": " 94306",
      "County": " SANTA CLARA",
      "Latitude": "37.4329140  ",
      "Longitude": " -122.12742 "
   },
   {
      "Vendor": "SAFEWAY #0700",
      "Address": " 2760 HOMESTEAD RD",
      "City": "SANTA CLARA",
      "Zip Code": " 95051",
      "County": " SANTA CLARA",
      "Latitude": "37.3379220  ",
      "Longitude": " -121.97520 "
   },
   {
      "Vendor": "SAFEWAY #0767",
      "Address": " 6150 BOLLINGER RD",
      "City": "SAN JOSE",
      "Zip Code": " 95129",
      "County": " SANTA CLARA",
      "Latitude": "37.3103070  ",
      "Longitude": " -122.01144 "
   },
   {
      "Vendor": "SAFEWAY #0742",
      "Address": " 1500 POLLARD RD",
      "City": "LOS GATOS",
      "Zip Code": " 95030",
      "County": " SANTA CLARA",
      "Latitude": "37.2638650  ",
      "Longitude": " -121.98459 "
   },
   {
      "Vendor": "SAFEWAY #2815",
      "Address": "N 470 SANTA CRUZ AVE",
      "City": "LOS GATOS",
      "Zip Code": " 95030",
      "County": " SANTA CLARA",
      "Latitude": "37.2313390  ",
      "Longitude": " -121.97912 "
   },
   {
      "Vendor": "SAFEWAY #0919",
      "Address": " 12876 SARATOGA SUNNYVALE RD",
      "City": "SARATOGA",
      "Zip Code": " 95070",
      "County": " SANTA CLARA",
      "Latitude": "37.2810610  ",
      "Longitude": " -122.03108 "
   },
   {
      "Vendor": "SAFEWAY #0705",
      "Address": "N 570 SHORELINE BLVD",
      "City": "MOUNTAIN VIEW",
      "Zip Code": " 94041",
      "County": " SANTA CLARA",
      "Latitude": "37.4030360  ",
      "Longitude": " -122.07907 "
   },
   {
      "Vendor": "MERCADO CALIFORNIA",
      "Address": " 5302 MONTEREY RD",
      "City": "SAN JOSE",
      "Zip Code": " 95111",
      "County": " SANTA CLARA",
      "Latitude": "37.2597300  ",
      "Longitude": " -121.80788 "
   },
   {
      "Vendor": "ARTEAGAS FOOD CENTER",
      "Address": " 6906 AUTOMALL PKWY",
      "City": "GILROY",
      "Zip Code": " 95020",
      "County": " SANTA CLARA",
      "Latitude": "37.0005970  ",
      "Longitude": " -121.56008 "
   },
   {
      "Vendor": "SAFEWAY #1990",
      "Address": " 3970 RIVERMARK PLAZA",
      "City": "SANTA CLARA",
      "Zip Code": " 95054",
      "County": " SANTA CLARA",
      "Latitude": "37.3948050  ",
      "Longitude": " -121.94728 "
   },
   {
      "Vendor": "FOOD MAXX #460",
      "Address": " 1539 PARKMOOR AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95128",
      "County": " SANTA CLARA",
      "Latitude": "37.3175420  ",
      "Longitude": " -121.91556 "
   },
   {
      "Vendor": "FOOD MAXX #461",
      "Address": " 1972 TULLY RD",
      "City": "SAN JOSE",
      "Zip Code": " 95122",
      "County": " SANTA CLARA",
      "Latitude": "37.3255290  ",
      "Longitude": " -121.82110 "
   },
   {
      "Vendor": "LUCKY 7 SUPERMARKET",
      "Address": " 1625 MCKEE RD",
      "City": "SAN JOSE",
      "Zip Code": " 95116",
      "County": " SANTA CLARA",
      "Latitude": "37.3563820  ",
      "Longitude": " -121.86356 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #517",
      "Address": " 2001 STORY RD",
      "Second Address": " STE 400",
      "City": "SAN JOSE",
      "Zip Code": " 95122",
      "County": " SANTA CLARA",
      "Latitude": "37.3441570  ",
      "Longitude": " -121.83802 "
   },
   {
      "Vendor": "SAFEWAY #1891",
      "Address": " 235 TENNANT STATION",
      "City": "MORGAN HILL",
      "Zip Code": " 95037",
      "County": " SANTA CLARA",
      "Latitude": "37.1151190  ",
      "Longitude": " -121.63910 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2002",
      "Address": " 7150 CAMINO ARROYO",
      "City": "GILROY",
      "Zip Code": " 95020",
      "County": " SANTA CLARA",
      "Latitude": "37.0072220  ",
      "Longitude": " -121.55274 "
   },
   {
      "Vendor": "NOB HILL FOODS #604",
      "Address": " 15710 LOS GATOS BLVD",
      "City": "LOS GATOS",
      "Zip Code": " 95030",
      "County": " SANTA CLARA",
      "Latitude": "37.2401940  ",
      "Longitude": " -121.95991 "
   },
   {
      "Vendor": "SAFEWAY #1483",
      "Address": " 1530 HAMILTON AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95125",
      "County": " SANTA CLARA",
      "Latitude": "37.2933920  ",
      "Longitude": " -121.91088 "
   },
   {
      "Vendor": "SAFEWAY #2948",
      "Address": " 645 SAN ANTONIO RD",
      "City": "MOUNTAIN VIEW",
      "Zip Code": " 94040",
      "County": " SANTA CLARA",
      "Latitude": "37.4018190  ",
      "Longitude": " -122.11178 "
   },
   {
      "Vendor": "SAFEWAY #1574",
      "Address": " 4950 ALMADEN EXPRESSWAY",
      "City": "SAN JOSE",
      "Zip Code": " 95118",
      "County": " SANTA CLARA",
      "Latitude": "37.2602810  ",
      "Longitude": " -121.87469 "
   },
   {
      "Vendor": "SAFEWAY #0997",
      "Address": " 1663 BRANHAM LN",
      "City": "SAN JOSE",
      "Zip Code": " 95118",
      "County": " SANTA CLARA",
      "Latitude": "37.2522830  ",
      "Longitude": " -121.90692 "
   },
   {
      "Vendor": "NOB HILL FOODS #603",
      "Address": " 451 VINEYARD TOWN CENTER",
      "City": "MORGAN HILL",
      "Zip Code": " 95037",
      "County": " SANTA CLARA",
      "Latitude": "37.1103930  ",
      "Longitude": " -121.64156 "
   },
   {
      "Vendor": "MOFFETT FIELD COMMISSARY",
      "Address": "N BLDG 12 AKRON RD",
      "City": "MOFFET FIELD",
      "Zip Code": " 94035",
      "County": " SANTA CLARA",
      "Latitude": "37.4113420  ",
      "Longitude": " -122.05784 "
   },
   {
      "Vendor": "SAFEWAY #0316",
      "Address": " 179 BRANHAM LN",
      "City": "SAN JOSE",
      "Zip Code": " 95136",
      "County": " SANTA CLARA",
      "Latitude": "37.2669760  ",
      "Longitude": " -121.83305 "
   },
   {
      "Vendor": "LUCKY #222",
      "Address": "N 1641 CAPITOL AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95132",
      "County": " SANTA CLARA",
      "Latitude": "37.3967680  ",
      "Longitude": " -121.87349 "
   },
   {
      "Vendor": "NOB HILL FOODS #635",
      "Address": " 6061 SNELL AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95123",
      "County": " SANTA CLARA",
      "Latitude": "37.2378060  ",
      "Longitude": " -121.83236 "
   },
   {
      "Vendor": "SAFEWAY #1196",
      "Address": "S 639 BERNARDO AVE",
      "City": "SUNNYVALE",
      "Zip Code": " 94087",
      "County": " SANTA CLARA",
      "Latitude": "37.3725260  ",
      "Longitude": " -122.05803 "
   },
   {
      "Vendor": "SAFEWAY #1245",
      "Address": " 15549 UNION AVE",
      "City": "LOS GATOS",
      "Zip Code": " 95032",
      "County": " SANTA CLARA",
      "Latitude": "37.2423740  ",
      "Longitude": " -121.93233 "
   },
   {
      "Vendor": "SAFEWAY #1108",
      "Address": " 1750 MIRAMONTE AVE",
      "City": "MOUNTAIN VIEW",
      "Zip Code": " 94040",
      "County": " SANTA CLARA",
      "Latitude": "37.3722900  ",
      "Longitude": " -122.08821 "
   },
   {
      "Vendor": "SAFEWAY #1293",
      "Address": "S 2341 WINCHESTER BLVD",
      "City": "CAMPBELL",
      "Zip Code": " 95008",
      "County": " SANTA CLARA",
      "Latitude": "37.2800320  ",
      "Longitude": " -121.95082 "
   },
   {
      "Vendor": "SAFEWAY #1455",
      "Address": "E 840 DUNNE AVE",
      "City": "MORGAN HILL",
      "Zip Code": " 95037",
      "County": " SANTA CLARA",
      "Latitude": "37.1289520  ",
      "Longitude": " -121.63653 "
   },
   {
      "Vendor": "SAFEWAY #1439",
      "Address": "E 785 EL CAMINO REAL",
      "City": "SUNNYVALE",
      "Zip Code": " 94087",
      "County": " SANTA CLARA",
      "Latitude": "37.3567310  ",
      "Longitude": " -122.01846 "
   },
   {
      "Vendor": "SAFEWAY #1465",
      "Address": " 5146 STEVENS CREEK RD",
      "City": "SAN JOSE",
      "Zip Code": " 95129",
      "County": " SANTA CLARA",
      "Latitude": "37.3227800  ",
      "Longitude": " -121.99289 "
   },
   {
      "Vendor": "SAFEWAY #1476",
      "Address": "W 1300 SAN CARLOS ST",
      "City": "SAN JOSE",
      "Zip Code": " 95126",
      "County": " SANTA CLARA",
      "Latitude": "37.3229630  ",
      "Longitude": " -121.91190 "
   },
   {
      "Vendor": "SAFEWAY #1505",
      "Address": " 905 FIRST ST",
      "City": "GILROY",
      "Zip Code": " 95020",
      "County": " SANTA CLARA",
      "Latitude": "37.0146630  ",
      "Longitude": " -121.58901 "
   },
   {
      "Vendor": "MARINA GROCERY",
      "Address": " 4148 MONTEREY RD",
      "City": "SAN JOSE",
      "Zip Code": " 95111",
      "County": " SANTA CLARA",
      "Latitude": "37.2783250  ",
      "Longitude": " -121.83541 "
   },
   {
      "Vendor": "LUCKY #233",
      "Address": " 3457 MCKEE RD",
      "City": "SAN JOSE",
      "Zip Code": " 95127",
      "County": " SANTA CLARA",
      "Latitude": "37.3811100  ",
      "Longitude": " -121.82949 "
   },
   {
      "Vendor": "LUCKY #766",
      "Address": "S 3270 WHITE RD",
      "City": "SAN JOSE",
      "Zip Code": " 95148",
      "County": " SANTA CLARA",
      "Latitude": "37.3150360  ",
      "Longitude": " -121.79039 "
   },
   {
      "Vendor": "LUCKY #723",
      "Address": " 2175 GRANT AVE",
      "City": "LOS ALTOS",
      "Zip Code": " 94024",
      "County": " SANTA CLARA",
      "Latitude": "37.3416420  ",
      "Longitude": " -122.07211 "
   },
   {
      "Vendor": "LUCKY #727",
      "Address": "S 1350 PARK VICTORIA DR",
      "City": "MILPITAS",
      "Zip Code": " 95035",
      "County": " SANTA CLARA",
      "Latitude": "37.4185340  ",
      "Longitude": " -121.87575 "
   },
   {
      "Vendor": "LUCKY #757",
      "Address": " 2027 CAMDEN AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95124",
      "County": " SANTA CLARA",
      "Latitude": "37.2618210  ",
      "Longitude": " -121.93281 "
   },
   {
      "Vendor": "LUCKY #758",
      "Address": "W 565 CAPITOL EXPRESSWAY",
      "City": "SAN JOSE",
      "Zip Code": " 95136",
      "County": " SANTA CLARA",
      "Latitude": "37.2757340  ",
      "Longitude": " -121.85394 "
   },
   {
      "Vendor": "LUCKY #759",
      "Address": " 129 BERNAL RD",
      "City": "SAN JOSE",
      "Zip Code": " 95119",
      "County": " SANTA CLARA",
      "Latitude": "37.2327870  ",
      "Longitude": " -121.77443 "
   },
   {
      "Vendor": "FOOD MAXX #483",
      "Address": " 5510 MONTEREY HWY",
      "City": "SAN JOSE",
      "Zip Code": " 95138",
      "County": " SANTA CLARA",
      "Latitude": "37.2543060  ",
      "Longitude": " -121.79997 "
   },
   {
      "Vendor": "LUCKY #762",
      "Address": " 6109 MERIDIAN AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95120",
      "County": " SANTA CLARA",
      "Latitude": "37.2275100  ",
      "Longitude": " -121.88454 "
   },
   {
      "Vendor": "LUCKY #763",
      "Address": " 844 BLOSSOM HILL RD",
      "City": "SAN JOSE",
      "Zip Code": " 95123",
      "County": " SANTA CLARA",
      "Latitude": "37.2502460  ",
      "Longitude": " -121.85595 "
   },
   {
      "Vendor": "LUCKY #765",
      "Address": " 430 BLOSSOM HILL RD",
      "City": "SAN JOSE",
      "Zip Code": " 95123",
      "County": " SANTA CLARA",
      "Latitude": "37.2505000  ",
      "Longitude": " -121.82940 "
   },
   {
      "Vendor": "LUCKY #773",
      "Address": " 3705 EL CAMINO REAL",
      "City": "SANTA CLARA",
      "Zip Code": " 95051",
      "County": " SANTA CLARA",
      "Latitude": "37.3534420  ",
      "Longitude": " -121.99789 "
   },
   {
      "Vendor": "LUCKY #774",
      "Address": " 234 SARATOGA AVE",
      "City": "SANTA CLARA",
      "Zip Code": " 95050",
      "County": " SANTA CLARA",
      "Latitude": "37.3293120  ",
      "Longitude": " -121.96650 "
   },
   {
      "Vendor": "LUCKY #780",
      "Address": "N 484 MATHILDA AVE",
      "City": "SUNNYVALE",
      "Zip Code": " 94085",
      "County": " SANTA CLARA",
      "Latitude": "37.3885580  ",
      "Longitude": " -122.02918 "
   },
   {
      "Vendor": "NOB HILL FOODS #634",
      "Address": " 1250 GRANT RD",
      "City": "MOUNTAIN VIEW",
      "Zip Code": " 94040",
      "County": " SANTA CLARA",
      "Latitude": "37.3782710  ",
      "Longitude": " -122.07621 "
   },
   {
      "Vendor": "TROPICANA FOODS",
      "Address": " 1630 STORY RD",
      "City": "SAN JOSE",
      "Zip Code": " 95122",
      "County": " SANTA CLARA",
      "Latitude": "37.3380460  ",
      "Longitude": " -121.84422 "
   },
   {
      "Vendor": "SAFEWAY #1879",
      "Address": "E 551 CALAVERAS BLVD",
      "City": "MILPITAS",
      "Zip Code": " 95035",
      "County": " SANTA CLARA",
      "Latitude": "37.4333220  ",
      "Longitude": " -121.89582 "
   },
   {
      "Vendor": "CHAVEZ SUPERMARKET",
      "Address": "N 666 FAIR OAKS AVE",
      "City": "SUNNYVALE",
      "Zip Code": " 94085",
      "County": " SANTA CLARA",
      "Latitude": "37.3901340  ",
      "Longitude": " -122.01405 "
   },
   {
      "Vendor": "CHAVEZ SUPERMARKET",
      "Address": " 2327 MCKEE RD",
      "City": "SAN JOSE",
      "Zip Code": " 95116",
      "County": " SANTA CLARA",
      "Latitude": "37.3659750  ",
      "Longitude": " -121.84956 "
   },
   {
      "Vendor": "GUADALAJARA MARKET",
      "Address": " 829 BORREGAS AVE",
      "City": "SUNNYVALE",
      "Zip Code": " 94086",
      "County": " SANTA CLARA",
      "Latitude": "37.3970010  ",
      "Longitude": " -122.02286 "
   },
   {
      "Vendor": "SMART & FINAL #327",
      "Address": "S 1265 MARY AVE",
      "City": "SUNNYVALE",
      "Zip Code": " 94087",
      "County": " SANTA CLARA",
      "Latitude": "37.3539190  ",
      "Longitude": " -122.05050 "
   },
   {
      "Vendor": "SMART & FINAL #432",
      "Address": "E 141 EL CAMINO REAL",
      "City": "MOUNTAIN VIEW",
      "Zip Code": " 94040",
      "County": " SANTA CLARA",
      "Latitude": "37.3795780  ",
      "Longitude": " -122.07133 "
   },
   {
      "Vendor": "SMART & FINAL #433",
      "Address": " 5281 PROSPECT RD",
      "City": "SAN JOSE",
      "Zip Code": " 95129",
      "County": " SANTA CLARA",
      "Latitude": "37.2921960  ",
      "Longitude": " -121.99515 "
   },
   {
      "Vendor": "SMART & FINAL #589",
      "Address": "E 250 10TH ST",
      "City": "GILROY",
      "Zip Code": " 95020",
      "County": " SANTA CLARA",
      "Latitude": "37.0011170  ",
      "Longitude": " -121.56272 "
   },
   {
      "Vendor": "SMART & FINAL #448",
      "Address": " 2065 EL CAMINO REAL",
      "City": "SANTA CLARA",
      "Zip Code": " 95050",
      "County": " SANTA CLARA",
      "Latitude": "37.3524240  ",
      "Longitude": " -121.96137 "
   },
   {
      "Vendor": "APATZINGAN MEAT MARKET",
      "Address": " 7237 MONTEREY ST",
      "City": "GILROY",
      "Zip Code": " 95020",
      "County": " SANTA CLARA",
      "Latitude": "37.0037160  ",
      "Longitude": " -121.56766 "
   },
   {
      "Vendor": "SAFEWAY #2934",
      "Address": "S 100 2ND ST",
      "City": "SAN JOSE",
      "Zip Code": " 95113",
      "County": " SANTA CLARA",
      "Latitude": "37.3345250  ",
      "Longitude": " -121.88746 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #533",
      "Address": "N 301 JACKSON AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95133",
      "County": " SANTA CLARA",
      "Latitude": "37.3655760  ",
      "Longitude": " -121.85152 "
   },
   {
      "Vendor": "CHAVEZ SUPERMARKET",
      "Address": " 2670 MONTEREY RD",
      "City": "SAN JOSE",
      "Zip Code": " 95111",
      "County": " SANTA CLARA",
      "Latitude": "37.2957440  ",
      "Longitude": " -121.85194 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5766",
      "Address": " 170 COCHRANE RD",
      "City": "MORGAN HILL",
      "Zip Code": " 95037",
      "County": " SANTA CLARA",
      "Latitude": "37.1459740  ",
      "Longitude": " -121.66297 "
   },
   {
      "Vendor": "TARGET STORE T-2584",
      "Address": "W 298 MCKINLEY AVE",
      "City": "SUNNYVALE",
      "Zip Code": " 94086",
      "County": " SANTA CLARA",
      "Latitude": "37.3744620  ",
      "Longitude": " -122.03286 "
   },
   {
      "Vendor": "TARGET STORE T-0324",
      "Address": " 1811 HILLSDALE AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95124",
      "County": " SANTA CLARA",
      "Latitude": "37.2651270  ",
      "Longitude": " -121.91878 "
   },
   {
      "Vendor": "MI RANCHO SUPERMARKET",
      "Address": " 2806 STORY RD",
      "City": "SAN JOSE",
      "Zip Code": " 95127",
      "County": " SANTA CLARA",
      "Latitude": "37.3524750  ",
      "Longitude": " -121.82378 "
   },
   {
      "Vendor": "SAFEWAY #2887",
      "Address": "E 150 EL CAMINO REAL",
      "City": "SUNNYVALE",
      "Zip Code": " 94087",
      "County": " SANTA CLARA",
      "Latitude": "37.3642890  ",
      "Longitude": " -122.02952 "
   },
   {
      "Vendor": "EL SOL MARKET",
      "Address": "W 2299 ADAMS AVE",
      "Second Address": " STE 114",
      "City": "EL CENTRO",
      "Zip Code": " 92243",
      "County": " IMPERIAL",
      "Latitude": "32.7965490  ",
      "Longitude": " -115.58250 "
   },
   {
      "Vendor": "MOTHER EARTH NUTRITION",
      "Address": " 648 E ST",
      "City": "BRAWLEY",
      "Zip Code": " 92227",
      "County": " IMPERIAL",
      "Latitude": "32.9797780  ",
      "Longitude": " -115.53101 "
   },
   {
      "Vendor": "MOTHER EARTH NUTRITION",
      "Address": " 605 WAKE AVE",
      "Second Address": " STE 5",
      "City": "EL CENTRO",
      "Zip Code": " 92243",
      "County": " IMPERIAL",
      "Latitude": "32.7707370  ",
      "Longitude": " -115.55696 "
   },
   {
      "Vendor": "MOTHER EARTH NUTRITION",
      "Address": " 2451 ROCKWOOD AVE",
      "City": "CALEXICO",
      "Zip Code": " 92231",
      "County": " IMPERIAL",
      "Latitude": "32.6948310  ",
      "Longitude": " -115.49762 "
   },
   {
      "Vendor": "TARGET STORE T-1816",
      "Address": "N 2295 IMPERIAL AVE",
      "City": "EL CENTRO",
      "Zip Code": " 92243",
      "County": " IMPERIAL",
      "Latitude": "32.8137200  ",
      "Longitude": " -115.56703 "
   },
   {
      "Vendor": "WEST SHORES MARKET",
      "Address": "S 2113 MARINA DR",
      "City": "SALTON CITY",
      "Zip Code": " 92275",
      "County": " IMPERIAL",
      "Latitude": "33.2812300  ",
      "Longitude": " -115.96229 "
   },
   {
      "Vendor": "CARDENAS MARKET #23",
      "Address": "N 1620 IMPERIAL AVE",
      "City": "EL CENTRO",
      "Zip Code": " 92243",
      "County": " IMPERIAL",
      "Latitude": "32.8081100  ",
      "Longitude": " -115.57135 "
   },
   {
      "Vendor": "MARKET SQUARE",
      "Address": "W 110 MAIN ST",
      "City": "CALIPATRIA",
      "Zip Code": " 92233",
      "County": " IMPERIAL",
      "Latitude": "33.1261250  ",
      "Longitude": " -115.51482 "
   },
   {
      "Vendor": "GARCIA MARKET",
      "Address": " 1198 MAIN ST",
      "City": "BRAWLEY",
      "Zip Code": " 92227",
      "County": " IMPERIAL",
      "Latitude": "32.9783400  ",
      "Longitude": " -115.52243 "
   },
   {
      "Vendor": "CARDENAS MARKET #34",
      "Address": "N 2300 IMPERIAL AVE",
      "City": "CALEXICO",
      "Zip Code": " 92231",
      "County": " IMPERIAL",
      "Latitude": "32.7005740  ",
      "Longitude": " -115.49923 "
   },
   {
      "Vendor": "SMART & FINAL #798",
      "Address": "N 650 IMPERIAL AVE",
      "City": "EL CENTRO",
      "Zip Code": " 92243",
      "County": " IMPERIAL",
      "Latitude": "32.7978860  ",
      "Longitude": " -115.57113 "
   },
   {
      "Vendor": "VONS #1753",
      "Address": "N 1190 MAIN ST",
      "City": "BISHOP",
      "Zip Code": " 93514",
      "County": " INYO",
      "Latitude": "37.3739150  ",
      "Longitude": " -118.39552 "
   },
   {
      "Vendor": "SMART & FINAL #380",
      "Address": "N 1180 MAIN ST",
      "City": "BISHOP",
      "Zip Code": " 93514",
      "County": " INYO",
      "Latitude": "37.3734100  ",
      "Longitude": " -118.39453 "
   },
   {
      "Vendor": "LONE PINE MARKET",
      "Address": "S 119 MAIN ST",
      "City": "LONE PINE",
      "Zip Code": " 93545",
      "County": " INYO",
      "Latitude": "36.6052350  ",
      "Longitude": " -118.06351 "
   },
   {
      "Vendor": "VONS #2262",
      "Address": " 710 BROADWAY",
      "City": "SANTA MONICA",
      "Zip Code": " 90401",
      "County": " LOS ANGELES",
      "Latitude": "34.0171750  ",
      "Longitude": " -118.48998 "
   },
   {
      "Vendor": "VONS #2283",
      "Address": " 1221 GAFFEY ST",
      "City": "SAN PEDRO",
      "Zip Code": " 90731",
      "County": " LOS ANGELES",
      "Latitude": "33.7329240  ",
      "Longitude": " -118.29348 "
   },
   {
      "Vendor": "VONS #2268",
      "Address": "S 1430 FAIRFAX AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90019",
      "County": " LOS ANGELES",
      "Latitude": "34.0504630  ",
      "Longitude": " -118.36621 "
   },
   {
      "Vendor": "VONS #2273",
      "Address": " 245 PALOS VERDES BLVD",
      "City": "REDONDO BEACH",
      "Zip Code": " 90277",
      "County": " LOS ANGELES",
      "Latitude": "33.8162120  ",
      "Longitude": " -118.38615 "
   },
   {
      "Vendor": "VONS #2861",
      "Address": "E 600 BROADWAY",
      "City": "LONG BEACH",
      "Zip Code": " 90802",
      "County": " LOS ANGELES",
      "Latitude": "33.7691160  ",
      "Longitude": " -118.18454 "
   },
   {
      "Vendor": "VONS #3263",
      "Address": "N 1342 ALVARADO ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90027",
      "County": " LOS ANGELES",
      "Latitude": "34.0794950  ",
      "Longitude": " -118.26128 "
   },
   {
      "Vendor": "VONS #2254",
      "Address": "W 311 LOS FELIZ BLVD",
      "City": "GLENDALE",
      "Zip Code": " 91204",
      "County": " LOS ANGELES",
      "Latitude": "34.1286370  ",
      "Longitude": " -118.25850 "
   },
   {
      "Vendor": "VONS #2665",
      "Address": "W 4520 SUNSET BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90027",
      "County": " LOS ANGELES",
      "Latitude": "34.0981570  ",
      "Longitude": " -118.28826 "
   },
   {
      "Vendor": "VONS #2261",
      "Address": "W 3461 THIRD ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90020",
      "County": " LOS ANGELES",
      "Latitude": "34.0696910  ",
      "Longitude": " -118.29080 "
   },
   {
      "Vendor": "PAVILIONS #3237",
      "Address": "W 9467 OLYMPIC BLVD",
      "City": "BEVERLY HILLS",
      "Zip Code": " 90212",
      "County": " LOS ANGELES",
      "Latitude": "34.0599970  ",
      "Longitude": " -118.39979 "
   },
   {
      "Vendor": "SUPER A FOODS #07",
      "Address": " 2925 DIVISION ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90065",
      "County": " LOS ANGELES",
      "Latitude": "34.1035050  ",
      "Longitude": " -118.23577 "
   },
   {
      "Vendor": "SUPER A FOODS #04",
      "Address": " 13120 DOWNEY AVE",
      "City": "PARAMOUNT",
      "Zip Code": " 90723",
      "County": " LOS ANGELES",
      "Latitude": "33.9140990  ",
      "Longitude": " -118.15132 "
   },
   {
      "Vendor": "SUPER A FOODS #05",
      "Address": "E 6380 FLORENCE AVE",
      "City": "BELL GARDENS",
      "Zip Code": " 90201",
      "County": " LOS ANGELES",
      "Latitude": "33.9642840  ",
      "Longitude": " -118.15080 "
   },
   {
      "Vendor": "VONS #2078",
      "Address": " 9119 RESEDA BLVD",
      "City": "NORTHRIDGE",
      "Zip Code": " 91324",
      "County": " LOS ANGELES",
      "Latitude": "34.2359810  ",
      "Longitude": " -118.53726 "
   },
   {
      "Vendor": "VONS #2056",
      "Address": "E 932 BADILLO ST",
      "City": "COVINA",
      "Zip Code": " 91724",
      "County": " LOS ANGELES",
      "Latitude": "34.0853630  ",
      "Longitude": " -117.87132 "
   },
   {
      "Vendor": "VONS #2034",
      "Address": " 13730 FOOTHILL BLVD",
      "City": "SYLMAR",
      "Zip Code": " 91342",
      "County": " LOS ANGELES",
      "Latitude": "34.3090640  ",
      "Longitude": " -118.43238 "
   },
   {
      "Vendor": "VONS #2077",
      "Address": "S 3118 SEPULVEDA BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90034",
      "County": " LOS ANGELES",
      "Latitude": "34.0266400  ",
      "Longitude": " -118.42726 "
   },
   {
      "Vendor": "VONS #3083",
      "Address": "N 301 PASS AVE",
      "City": "BURBANK",
      "Zip Code": " 91505",
      "County": " LOS ANGELES",
      "Latitude": "34.1548080  ",
      "Longitude": " -118.34639 "
   },
   {
      "Vendor": "VONS #2123",
      "Address": " 777 GLENDORA AVE",
      "City": "WEST COVINA",
      "Zip Code": " 91790",
      "County": " LOS ANGELES",
      "Latitude": "34.0623990  ",
      "Longitude": " -117.93209 "
   },
   {
      "Vendor": "VONS #2108",
      "Address": " 1212 BERYL ST",
      "City": "REDONDO BEACH",
      "Zip Code": " 90277",
      "County": " LOS ANGELES",
      "Latitude": "33.8545250  ",
      "Longitude": " -118.38106 "
   },
   {
      "Vendor": "VONS #2124",
      "Address": " 7789 FOOTHILL BLVD",
      "City": "TUJUNGA",
      "Zip Code": " 91042",
      "County": " LOS ANGELES",
      "Latitude": "34.2587810  ",
      "Longitude": " -118.30235 "
   },
   {
      "Vendor": "ADLONG MARKET",
      "Address": "W 1550 ADAMS BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90007",
      "County": " LOS ANGELES",
      "Latitude": "34.0322100  ",
      "Longitude": " -118.29627 "
   },
   {
      "Vendor": "RALPHS #710",
      "Address": " 21431 DEVONSHIRE ST",
      "City": "CHATSWORTH",
      "Zip Code": " 91311",
      "County": " LOS ANGELES",
      "Latitude": "34.2574310  ",
      "Longitude": " -118.59806 "
   },
   {
      "Vendor": "RALPHS #721",
      "Address": " 22333 SHERMAN WAY",
      "City": "CANOGA PARK",
      "Zip Code": " 91303",
      "County": " LOS ANGELES",
      "Latitude": "34.2018030  ",
      "Longitude": " -118.61353 "
   },
   {
      "Vendor": "JON'S MARKETPLACE #01",
      "Address": "W 3667 THIRD ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90020",
      "County": " LOS ANGELES",
      "Latitude": "34.0692680  ",
      "Longitude": " -118.29624 "
   },
   {
      "Vendor": "RALPHS #712",
      "Address": "N 1100 SAN FERNANDO BLVD",
      "City": "BURBANK",
      "Zip Code": " 91504",
      "County": " LOS ANGELES",
      "Latitude": "34.1889140  ",
      "Longitude": " -118.31826 "
   },
   {
      "Vendor": "RALPHS #278",
      "Address": " 8701 LINCOLN BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90045",
      "County": " LOS ANGELES",
      "Latitude": "33.9580460  ",
      "Longitude": " -118.41838 "
   },
   {
      "Vendor": "VONS #2655",
      "Address": "N 7311 FIGUEROA ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90041",
      "County": " LOS ANGELES",
      "Latitude": "34.1361530  ",
      "Longitude": " -118.18948 "
   },
   {
      "Vendor": "BIG SAVER FOODS #01",
      "Address": "N 3000 BROADWAY",
      "City": "LOS ANGELES",
      "Zip Code": " 90031",
      "County": " LOS ANGELES",
      "Latitude": "34.0733770  ",
      "Longitude": " -118.21014 "
   },
   {
      "Vendor": "TOP VALU #03",
      "Address": " 10819 HAWTHORNE BLVD",
      "City": "LENNOX",
      "Zip Code": " 90304",
      "County": " LOS ANGELES",
      "Latitude": "33.9377260  ",
      "Longitude": " -118.35326 "
   },
   {
      "Vendor": "RALPHS #251",
      "Address": "E 2930 FOURTH ST",
      "City": "LONG BEACH",
      "Zip Code": " 90814",
      "County": " LOS ANGELES",
      "Latitude": "33.7714370  ",
      "Longitude": " -118.15729 "
   },
   {
      "Vendor": "RALPHS #284",
      "Address": " 10772 JEFFERSON BLVD",
      "City": "CULVER CITY",
      "Zip Code": " 90230",
      "County": " LOS ANGELES",
      "Latitude": "34.0023480  ",
      "Longitude": " -118.39359 "
   },
   {
      "Vendor": "FOOD 4 LESS #326",
      "Address": " 20155 SATICOY ST",
      "City": "CANOGA PARK",
      "Zip Code": " 91306",
      "County": " LOS ANGELES",
      "Latitude": "34.2085380  ",
      "Longitude": " -118.57276 "
   },
   {
      "Vendor": "GELSON'S MARKET #022",
      "Address": " 2725 HYPERION AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90027",
      "County": " LOS ANGELES",
      "Latitude": "34.1079430  ",
      "Longitude": " -118.27289 "
   },
   {
      "Vendor": "GELSON'S MARKET #108",
      "Address": "W 8330 SANTA MONICA BLVD",
      "City": "WEST HOLLYWOOD",
      "Zip Code": " 90069",
      "County": " LOS ANGELES",
      "Latitude": "34.0903780  ",
      "Longitude": " -118.37102 "
   },
   {
      "Vendor": "GELSON'S MARKET #114",
      "Address": " 5877 FRANKLIN AVE",
      "City": "HOLLYWOOD",
      "Zip Code": " 90028",
      "County": " LOS ANGELES",
      "Latitude": "34.1059120  ",
      "Longitude": " -118.31752 "
   },
   {
      "Vendor": "VONS #2275",
      "Address": " 410 MANHATTAN BEACH BLVD",
      "City": "MANHATTAN BEACH",
      "Zip Code": " 90266",
      "County": " LOS ANGELES",
      "Latitude": "33.8850600  ",
      "Longitude": " -118.40785 "
   },
   {
      "Vendor": "VONS #2266",
      "Address": " 17380 SUNSET BLVD",
      "City": "PACIFIC PALISADES",
      "Zip Code": " 90272",
      "County": " LOS ANGELES",
      "Latitude": "34.0393320  ",
      "Longitude": " -118.55409 "
   },
   {
      "Vendor": "VONS #2858",
      "Address": "E 2355 COLORADO BLVD",
      "City": "PASADENA",
      "Zip Code": " 91107",
      "County": " LOS ANGELES",
      "Latitude": "34.1460940  ",
      "Longitude": " -118.10188 "
   },
   {
      "Vendor": "RALPHS #277",
      "Address": "N 950 LA BREA AVE",
      "City": "INGLEWOOD",
      "Zip Code": " 90302",
      "County": " LOS ANGELES",
      "Latitude": "33.9754150  ",
      "Longitude": " -118.35698 "
   },
   {
      "Vendor": "RALPHS #279",
      "Address": " 4700 ADMIRALTY WAY",
      "City": "MARINA DEL REY",
      "Zip Code": " 90292",
      "County": " LOS ANGELES",
      "Latitude": "33.9799320  ",
      "Longitude": " -118.43983 "
   },
   {
      "Vendor": "FOOD 4 LESS #375",
      "Address": "S 1091 HOOVER ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90006",
      "County": " LOS ANGELES",
      "Latitude": "34.0510640  ",
      "Longitude": " -118.28438 "
   },
   {
      "Vendor": "RALPHS #274",
      "Address": "W 1730 MANCHESTER AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90047",
      "County": " LOS ANGELES",
      "Latitude": "33.9593070  ",
      "Longitude": " -118.30790 "
   },
   {
      "Vendor": "FOOD 4 LESS #767",
      "Address": " 12689 GLENOAKS BLVD",
      "City": "SYLMAR",
      "Zip Code": " 91342",
      "County": " LOS ANGELES",
      "Latitude": "34.3005990  ",
      "Longitude": " -118.44096 "
   },
   {
      "Vendor": "VONS #2162",
      "Address": "W 1440 25TH ST",
      "City": "SAN PEDRO",
      "Zip Code": " 90732",
      "County": " LOS ANGELES",
      "Latitude": "33.7229680  ",
      "Longitude": " -118.31088 "
   },
   {
      "Vendor": "VONS #2152",
      "Address": "W 155 CALIFORNIA BLVD",
      "City": "PASADENA",
      "Zip Code": " 91105",
      "County": " LOS ANGELES",
      "Latitude": "34.1358170  ",
      "Longitude": " -118.15301 "
   },
   {
      "Vendor": "VONS #3138",
      "Address": "W 16550 SOLEDAD CANYON RD",
      "City": "SANTA CLARITA",
      "Zip Code": " 91351",
      "County": " LOS ANGELES",
      "Latitude": "34.4163960  ",
      "Longitude": " -118.45413 "
   },
   {
      "Vendor": "PAVILIONS #2105",
      "Address": " 4365 GLENCOE AVE",
      "City": "MARINA DEL REY",
      "Zip Code": " 90292",
      "County": " LOS ANGELES",
      "Latitude": "33.9851010  ",
      "Longitude": " -118.43957 "
   },
   {
      "Vendor": "VONS #3086",
      "Address": "S 2122 HACIENDA BLVD",
      "City": "HACIENDA HEIGHTS",
      "Zip Code": " 91745",
      "County": " LOS ANGELES",
      "Latitude": "33.9950170  ",
      "Longitude": " -117.96655 "
   },
   {
      "Vendor": "VONS #3076",
      "Address": " 1820 XIMENO AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90815",
      "County": " LOS ANGELES",
      "Latitude": "33.7906720  ",
      "Longitude": " -118.13742 "
   },
   {
      "Vendor": "VONS #3075",
      "Address": " 1129 FAIR OAKS AVE",
      "City": "SOUTH PASADENA",
      "Zip Code": " 91030",
      "County": " LOS ANGELES",
      "Latitude": "34.1128690  ",
      "Longitude": " -118.15109 "
   },
   {
      "Vendor": "VONS #2066",
      "Address": " 18439 VENTURA BLVD",
      "City": "TARZANA",
      "Zip Code": " 91356",
      "County": " LOS ANGELES",
      "Latitude": "34.1688050  ",
      "Longitude": " -118.53441 "
   },
   {
      "Vendor": "VONS #2001",
      "Address": " 5671 KANAN ROAD",
      "City": "AGOURA HILLS",
      "Zip Code": " 91301",
      "County": " LOS ANGELES",
      "Latitude": "34.1533970  ",
      "Longitude": " -118.75742 "
   },
   {
      "Vendor": "VONS #2039",
      "Address": " 19333 VICTORY BLVD",
      "City": "RESEDA",
      "Zip Code": " 91335",
      "County": " LOS ANGELES",
      "Latitude": "34.1877690  ",
      "Longitude": " -118.55445 "
   },
   {
      "Vendor": "VONS #2027",
      "Address": " 15740 LA FORGE ST",
      "City": "WHITTIER",
      "Zip Code": " 90603",
      "County": " LOS ANGELES",
      "Latitude": "33.9411290  ",
      "Longitude": " -117.99422 "
   },
   {
      "Vendor": "VONS #4021",
      "Address": "W 6571 80TH ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90045",
      "County": " LOS ANGELES",
      "Latitude": "33.9693190  ",
      "Longitude": " -118.40547 "
   },
   {
      "Vendor": "VONS #1625",
      "Address": "W 1260 REDONDO BEACH BLVD",
      "City": "GARDENA",
      "Zip Code": " 90247",
      "County": " LOS ANGELES",
      "Latitude": "33.8916170  ",
      "Longitude": " -118.29809 "
   },
   {
      "Vendor": "RALPHS #100",
      "Address": " 7257 SUNSET BLVD",
      "City": "HOLLYWOOD",
      "Zip Code": " 90046",
      "County": " LOS ANGELES",
      "Latitude": "34.0987140  ",
      "Longitude": " -118.34839 "
   },
   {
      "Vendor": "RALPHS #189",
      "Address": " 17250 SATICOY ST",
      "City": "VAN NUYS",
      "Zip Code": " 91406",
      "County": " LOS ANGELES",
      "Latitude": "34.2082310  ",
      "Longitude": " -118.50907 "
   },
   {
      "Vendor": "RALPHS #006",
      "Address": " 17840 VENTURA BLVD",
      "City": "ENCINO",
      "Zip Code": " 91316",
      "County": " LOS ANGELES",
      "Latitude": "34.1625970  ",
      "Longitude": " -118.52106 "
   },
   {
      "Vendor": "RALPHS #021",
      "Address": " 1745 GARFIELD AVE",
      "City": "SOUTH PASADENA",
      "Zip Code": " 91030",
      "County": " LOS ANGELES",
      "Latitude": "34.1051240  ",
      "Longitude": " -118.13550 "
   },
   {
      "Vendor": "RALPHS #032",
      "Address": "W 3410 THIRD ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90020",
      "County": " LOS ANGELES",
      "Latitude": "34.0688490  ",
      "Longitude": " -118.28938 "
   },
   {
      "Vendor": "RALPHS #041",
      "Address": "E 211 FOOTHILL BLVD",
      "City": "ARCADIA",
      "Zip Code": " 91006",
      "County": " LOS ANGELES",
      "Latitude": "34.1516410  ",
      "Longitude": " -118.02509 "
   },
   {
      "Vendor": "RALPHS #044",
      "Address": " 12057 WILSHIRE BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90025",
      "County": " LOS ANGELES",
      "Latitude": "34.0449310  ",
      "Longitude": " -118.46703 "
   },
   {
      "Vendor": "RALPHS #047",
      "Address": " 7221 WOODMAN AVE",
      "City": "VAN NUYS",
      "Zip Code": " 91405",
      "County": " LOS ANGELES",
      "Latitude": "34.2017770  ",
      "Longitude": " -118.43146 "
   },
   {
      "Vendor": "RALPHS #049",
      "Address": " 10455 SUNLAND BLVD",
      "City": "SUNLAND",
      "Zip Code": " 91040",
      "County": " LOS ANGELES",
      "Latitude": "34.2605260  ",
      "Longitude": " -118.32580 "
   },
   {
      "Vendor": "RALPHS #053",
      "Address": " 9470 LAS TUNAS DR",
      "City": "TEMPLE CITY",
      "Zip Code": " 91780",
      "County": " LOS ANGELES",
      "Latitude": "34.1055090  ",
      "Longitude": " -118.06407 "
   },
   {
      "Vendor": "RALPHS #055",
      "Address": " 521 FOOTHILL BLVD",
      "City": "LA CANADA",
      "Zip Code": " 91011",
      "County": " LOS ANGELES",
      "Latitude": "34.2005060  ",
      "Longitude": " -118.18998 "
   },
   {
      "Vendor": "RALPHS #058",
      "Address": " 3380 LOS COYOTES DIAGONAL",
      "City": "LONG BEACH",
      "Zip Code": " 90808",
      "County": " LOS ANGELES",
      "Latitude": "33.8181230  ",
      "Longitude": " -118.10881 "
   },
   {
      "Vendor": "RALPHS #063",
      "Address": " 12921 MAGNOLIA BLVD",
      "City": "VAN NUYS",
      "Zip Code": " 91423",
      "County": " LOS ANGELES",
      "Latitude": "34.1655220  ",
      "Longitude": " -118.41449 "
   },
   {
      "Vendor": "RALPHS #064",
      "Address": " 14919 WHITTIER BLVD",
      "City": "WHITTIER",
      "Zip Code": " 90605",
      "County": " LOS ANGELES",
      "Latitude": "33.9497210  ",
      "Longitude": " -118.00741 "
   },
   {
      "Vendor": "RALPHS #070",
      "Address": " 20060 VENTURA BLVD",
      "City": "WOODLAND HILLS",
      "Zip Code": " 91364",
      "County": " LOS ANGELES",
      "Latitude": "34.1700480  ",
      "Longitude": " -118.57030 "
   },
   {
      "Vendor": "RALPHS #156",
      "Address": "W 10309 OLYMPIC BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90064",
      "County": " LOS ANGELES",
      "Latitude": "34.0524360  ",
      "Longitude": " -118.41788 "
   },
   {
      "Vendor": "STATER BROS. #057",
      "Address": "E 1145 ALOSTA AVE",
      "City": "AZUSA",
      "Zip Code": " 91702",
      "County": " LOS ANGELES",
      "Latitude": "34.1294080  ",
      "Longitude": " -117.88288 "
   },
   {
      "Vendor": "STATER BROS. #049",
      "Address": "W 1055 FOOTHILL BLVD",
      "City": "CLAREMONT",
      "Zip Code": " 91711",
      "County": " LOS ANGELES",
      "Latitude": "34.1079340  ",
      "Longitude": " -117.73551 "
   },
   {
      "Vendor": "STATER BROS. #006",
      "Address": "E 1830 ROUTE 66",
      "City": "GLENDORA",
      "Zip Code": " 91740",
      "County": " LOS ANGELES",
      "Latitude": "34.1273180  ",
      "Longitude": " -117.83006 "
   },
   {
      "Vendor": "STATER BROS. #048",
      "Address": " 2090 FOOTHILL BLVD",
      "City": "LA VERNE",
      "Zip Code": " 91750",
      "County": " LOS ANGELES",
      "Latitude": "34.1127070  ",
      "Longitude": " -117.76616 "
   },
   {
      "Vendor": "STATER BROS. #070",
      "Address": " 12523 ALONDRA BLVD",
      "City": "NORWALK",
      "Zip Code": " 90650",
      "County": " LOS ANGELES",
      "Latitude": "33.8884430  ",
      "Longitude": " -118.06554 "
   },
   {
      "Vendor": "STATER BROS. #019",
      "Address": "N 1045 GAREY AVE",
      "City": "POMONA",
      "Zip Code": " 91767",
      "County": " LOS ANGELES",
      "Latitude": "34.0683110  ",
      "Longitude": " -117.75288 "
   },
   {
      "Vendor": "STATER BROS. #067",
      "Address": "E 19756 COLIMA RD",
      "City": "ROWLAND HEIGHTS",
      "Zip Code": " 91748",
      "County": " LOS ANGELES",
      "Latitude": "33.9862360  ",
      "Longitude": " -117.87014 "
   },
   {
      "Vendor": "STATER BROS. #056",
      "Address": "W 1425 ARROW HWY",
      "City": "SAN DIMAS",
      "Zip Code": " 91773",
      "County": " LOS ANGELES",
      "Latitude": "34.1073530  ",
      "Longitude": " -117.83663 "
   },
   {
      "Vendor": "STATER BROS. #054",
      "Address": " 1025 AMAR ST",
      "City": "WEST COVINA",
      "Zip Code": " 91790",
      "County": " LOS ANGELES",
      "Latitude": "34.0298270  ",
      "Longitude": " -117.88975 "
   },
   {
      "Vendor": "STATER BROS. #015",
      "Address": " 14212 MULBERRY ST",
      "City": "WHITTIER",
      "Zip Code": " 90604",
      "County": " LOS ANGELES",
      "Latitude": "33.9416010  ",
      "Longitude": " -118.02759 "
   },
   {
      "Vendor": "VONS #2100",
      "Address": " 9860 NATIONAL BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90034",
      "County": " LOS ANGELES",
      "Latitude": "34.0303160  ",
      "Longitude": " -118.40140 "
   },
   {
      "Vendor": "SUPER A FOODS #08",
      "Address": "W 2924 BEVERLY BLVD",
      "City": "MONTEBELLO",
      "Zip Code": " 90640",
      "County": " LOS ANGELES",
      "Latitude": "34.0228960  ",
      "Longitude": " -118.13416 "
   },
   {
      "Vendor": "RALPHS #743",
      "Address": "W 320 COLORADO BLVD",
      "City": "PASADENA",
      "Zip Code": " 91105",
      "County": " LOS ANGELES",
      "Latitude": "34.1452050  ",
      "Longitude": " -118.15712 "
   },
   {
      "Vendor": "RALPHS #728",
      "Address": " 2909 ROLLING HILLS RD",
      "City": "TORRANCE",
      "Zip Code": " 90505",
      "County": " LOS ANGELES",
      "Latitude": "33.7887710  ",
      "Longitude": " -118.34079 "
   },
   {
      "Vendor": "RALPHS #724",
      "Address": "W 9040 BEVERLY BLVD",
      "City": "WEST HOLLYWOOD",
      "Zip Code": " 90048",
      "County": " LOS ANGELES",
      "Latitude": "34.0767560  ",
      "Longitude": " -118.38921 "
   },
   {
      "Vendor": "RALPHS #715",
      "Address": "N 330 ATLANTIC BLVD",
      "City": "MONTEREY PARK",
      "Zip Code": " 91754",
      "County": " LOS ANGELES",
      "Latitude": "34.0655120  ",
      "Longitude": " -118.13366 "
   },
   {
      "Vendor": "RALPHS #711",
      "Address": " 6657 LAUREL CANYON BLVD",
      "City": "NORTH HOLLYWOOD",
      "Zip Code": " 91606",
      "County": " LOS ANGELES",
      "Latitude": "34.1917730  ",
      "Longitude": " -118.39670 "
   },
   {
      "Vendor": "VONS #2002",
      "Address": " 1311 WILSHIRE BLVD",
      "City": "SANTA MONICA",
      "Zip Code": " 90403",
      "County": " LOS ANGELES",
      "Latitude": "34.0263010  ",
      "Longitude": " -118.48945 "
   },
   {
      "Vendor": "RALPHS #269",
      "Address": "S 11873 HAWTHORNE BLVD",
      "City": "HAWTHORNE",
      "Zip Code": " 90250",
      "County": " LOS ANGELES",
      "Latitude": "33.9259710  ",
      "Longitude": " -118.35404 "
   },
   {
      "Vendor": "RALPHS #266",
      "Address": "S 11922 VERMONT AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90044",
      "County": " LOS ANGELES",
      "Latitude": "33.9250230  ",
      "Longitude": " -118.29099 "
   },
   {
      "Vendor": "RALPHS #701",
      "Address": " 12842 VENTURA BLVD",
      "City": "STUDIO CITY",
      "Zip Code": " 91604",
      "County": " LOS ANGELES",
      "Latitude": "34.1443720  ",
      "Longitude": " -118.41307 "
   },
   {
      "Vendor": "RALPHS #702",
      "Address": " 14440 BURBANK BLVD",
      "City": "SHERMAN OAKS",
      "Zip Code": " 91401",
      "County": " LOS ANGELES",
      "Latitude": "34.1719160  ",
      "Longitude": " -118.44787 "
   },
   {
      "Vendor": "RALPHS #704",
      "Address": " 16940 DEVONSHIRE ST",
      "City": "GRANADA HILLS",
      "Zip Code": " 91344",
      "County": " LOS ANGELES",
      "Latitude": "34.2567270  ",
      "Longitude": " -118.50153 "
   },
   {
      "Vendor": "RALPHS #709",
      "Address": " 11361 NATIONAL BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90064",
      "County": " LOS ANGELES",
      "Latitude": "34.0259870  ",
      "Longitude": " -118.43342 "
   },
   {
      "Vendor": "JON'S MARKETPLACE #02",
      "Address": " 6655 VAN NUYS BLVD",
      "City": "VAN NUYS",
      "Zip Code": " 91405",
      "County": " LOS ANGELES",
      "Latitude": "34.1922320  ",
      "Longitude": " -118.44965 "
   },
   {
      "Vendor": "FOOD 4 LESS #336",
      "Address": " 8620 WHITTIER BLVD",
      "City": "PICO RIVERA",
      "Zip Code": " 90660",
      "County": " LOS ANGELES",
      "Latitude": "34.0028830  ",
      "Longitude": " -118.08812 "
   },
   {
      "Vendor": "VONS #2169",
      "Address": "W 435 FOOTHILL BLVD",
      "City": "GLENDORA",
      "Zip Code": " 91741",
      "County": " LOS ANGELES",
      "Latitude": "34.1370910  ",
      "Longitude": " -117.87167 "
   },
   {
      "Vendor": "RALPHS #017",
      "Address": " 8325 LAUREL CANYON BLVD",
      "City": "SUN VALLEY",
      "Zip Code": " 91352",
      "County": " LOS ANGELES",
      "Latitude": "34.2233240  ",
      "Longitude": " -118.39804 "
   },
   {
      "Vendor": "VONS #2125",
      "Address": " 1160 VIA VERDE AVE",
      "City": "SAN DIMAS",
      "Zip Code": " 91773",
      "County": " LOS ANGELES",
      "Latitude": "34.0727820  ",
      "Longitude": " -117.82916 "
   },
   {
      "Vendor": "RALPHS #283",
      "Address": " 5080 RODEO RD",
      "City": "LOS ANGELES",
      "Zip Code": " 90016",
      "County": " LOS ANGELES",
      "Latitude": "34.0213250  ",
      "Longitude": " -118.35518 "
   },
   {
      "Vendor": "RALPHS #173",
      "Address": " 9200 LAKEWOOD BLVD",
      "City": "DOWNEY",
      "Zip Code": " 90240",
      "County": " LOS ANGELES",
      "Latitude": "33.9555060  ",
      "Longitude": " -118.11226 "
   },
   {
      "Vendor": "JON'S MARKET #03",
      "Address": "W 3334 8TH ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90005",
      "County": " LOS ANGELES",
      "Latitude": "34.0574670  ",
      "Longitude": " -118.30127 "
   },
   {
      "Vendor": "FOOD 4 LESS #370",
      "Address": " 4910 HUNTINGTON DR",
      "City": "LOS ANGELES",
      "Zip Code": " 90032",
      "County": " LOS ANGELES",
      "Latitude": "34.0866750  ",
      "Longitude": " -118.17588 "
   },
   {
      "Vendor": "RALPHS #256",
      "Address": "E 650 CARSON ST",
      "City": "CARSON",
      "Zip Code": " 90745",
      "County": " LOS ANGELES",
      "Latitude": "33.8313900  ",
      "Longitude": " -118.26444 "
   },
   {
      "Vendor": "RALPHS #281",
      "Address": " 910 LINCOLN BLVD",
      "City": "VENICE",
      "Zip Code": " 90291",
      "County": " LOS ANGELES",
      "Latitude": "33.9986930  ",
      "Longitude": " -118.46193 "
   },
   {
      "Vendor": "FOOD 4 LESS #338",
      "Address": " 11950 GARVEY AVE",
      "City": "EL MONTE",
      "Zip Code": " 91732",
      "County": " LOS ANGELES",
      "Latitude": "34.0620710  ",
      "Longitude": " -118.01983 "
   },
   {
      "Vendor": "RALPHS #730",
      "Address": "E 3601 FOOTHILL BLVD",
      "City": "PASADENA",
      "Zip Code": " 91107",
      "County": " LOS ANGELES",
      "Latitude": "34.1512470  ",
      "Longitude": " -118.07581 "
   },
   {
      "Vendor": "RALPHS #731",
      "Address": "W 23841 MALIBU RD",
      "City": "MALIBU",
      "Zip Code": " 90265",
      "County": " LOS ANGELES",
      "Latitude": "34.0342170  ",
      "Longitude": " -118.69361 "
   },
   {
      "Vendor": "RALPHS #096",
      "Address": "N 160 LAKE AVE",
      "City": "PASADENA",
      "Zip Code": " 91101",
      "County": " LOS ANGELES",
      "Latitude": "34.1489670  ",
      "Longitude": " -118.13129 "
   },
   {
      "Vendor": "FOOD 4 LESS #381",
      "Address": "S 1717 WESTERN AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90006",
      "County": " LOS ANGELES",
      "Latitude": "34.0420390  ",
      "Longitude": " -118.31010 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #102",
      "Address": "S 7316 COMPTON AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90001",
      "County": " LOS ANGELES",
      "Latitude": "33.9733940  ",
      "Longitude": " -118.24695 "
   },
   {
      "Vendor": "LONDON MARKET",
      "Address": " 1814 ATLANTIC AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90806",
      "County": " LOS ANGELES",
      "Latitude": "33.7903750  ",
      "Longitude": " -118.18468 "
   },
   {
      "Vendor": "VONS #3258",
      "Address": " 804 BEVERLY BLVD",
      "City": "MONTEBELLO",
      "Zip Code": " 90640",
      "County": " LOS ANGELES",
      "Latitude": "34.0172650  ",
      "Longitude": " -118.10609 "
   },
   {
      "Vendor": "VONS #2270",
      "Address": " 4030 CENTINELA AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90066",
      "County": " LOS ANGELES",
      "Latitude": "33.9989090  ",
      "Longitude": " -118.42874 "
   },
   {
      "Vendor": "FOOD 4 LESS #322",
      "Address": "E 1651 103RD ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90002",
      "County": " LOS ANGELES",
      "Latitude": "33.9434000  ",
      "Longitude": " -118.24455 "
   },
   {
      "Vendor": "FOOD 4 LESS #377",
      "Address": " 12765 VAN NUYS BLVD",
      "City": "PACOIMA",
      "Zip Code": " 91331",
      "County": " LOS ANGELES",
      "Latitude": "34.2746340  ",
      "Longitude": " -118.41072 "
   },
   {
      "Vendor": "SUPER A FOODS #10",
      "Address": " 8116 CALIFORNIA AVE",
      "City": "SOUTH GATE",
      "Zip Code": " 90280",
      "County": " LOS ANGELES",
      "Latitude": "33.9618390  ",
      "Longitude": " -118.20429 "
   },
   {
      "Vendor": "RALPHS #083",
      "Address": "E 13321 SOUTH ST",
      "City": "CERRITOS",
      "Zip Code": " 90703",
      "County": " LOS ANGELES",
      "Latitude": "33.8589290  ",
      "Longitude": " -118.04738 "
   },
   {
      "Vendor": "RALPHS #086",
      "Address": " 3827 CULVER CENTER ST",
      "City": "CULVER CITY",
      "Zip Code": " 90232",
      "County": " LOS ANGELES",
      "Latitude": "34.0174950  ",
      "Longitude": " -118.40769 "
   },
   {
      "Vendor": "RALPHS #087",
      "Address": "N 1050 WESTERN AVE",
      "City": "SAN PEDRO",
      "Zip Code": " 90732",
      "County": " LOS ANGELES",
      "Latitude": "33.7530800  ",
      "Longitude": " -118.30864 "
   },
   {
      "Vendor": "RALPHS #097",
      "Address": "N 1200 CENTRAL AVE",
      "City": "GLENDALE",
      "Zip Code": " 91202",
      "County": " LOS ANGELES",
      "Latitude": "34.1644080  ",
      "Longitude": " -118.25633 "
   },
   {
      "Vendor": "RALPHS #165",
      "Address": " 5951 DEL AMO BLVD",
      "City": "LAKEWOOD",
      "Zip Code": " 90713",
      "County": " LOS ANGELES",
      "Latitude": "33.8476660  ",
      "Longitude": " -118.11571 "
   },
   {
      "Vendor": "RALPHS #166",
      "Address": " 2700 SEPULVEDA BLVD",
      "City": "MANHATTAN BEACH",
      "Zip Code": " 90266",
      "County": " LOS ANGELES",
      "Latitude": "33.8958420  ",
      "Longitude": " -118.39573 "
   },
   {
      "Vendor": "LOS ANGELES COMMISSARY",
      "Address": "N 483 AVIATION BLVD",
      "Second Address": " BLDG 251",
      "City": "EL SEGUNDO",
      "Zip Code": " 90245",
      "County": " LOS ANGELES",
      "Latitude": "33.9192040  ",
      "Longitude": " -118.37862 "
   },
   {
      "Vendor": "TARGET STORE T-1426",
      "Address": "N 450 CAPITAL AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95133",
      "County": " SANTA CLARA",
      "Latitude": "37.3735900  ",
      "Longitude": " -121.84601 "
   },
   {
      "Vendor": "TARGET STORE T-1984",
      "Address": " 1750 STORY RD",
      "City": "SAN JOSE",
      "Zip Code": " 95122",
      "County": " SANTA CLARA",
      "Latitude": "37.3400950  ",
      "Longitude": " -121.84231 "
   },
   {
      "Vendor": "TARGET STORE T-2281",
      "Address": " 2161 MONTEREY HWY",
      "City": "SAN JOSE",
      "Zip Code": " 95112",
      "County": " SANTA CLARA",
      "Latitude": "37.3041660  ",
      "Longitude": " -121.86572 "
   },
   {
      "Vendor": "TARGET STORE T-2088",
      "Address": " 533 COLEMAN AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95110",
      "County": " SANTA CLARA",
      "Latitude": "37.3404760  ",
      "Longitude": " -121.90630 "
   },
   {
      "Vendor": "BABY NUTRITIONAL CARE #106",
      "Address": " 7500 ARROYO CIR",
      "Second Address": " STE 130",
      "City": "GILROY",
      "Zip Code": " 95020",
      "County": " SANTA CLARA",
      "Latitude": "37.0124000  ",
      "Longitude": " -121.55774 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #540",
      "Address": " 4100 MONTEREY HWY",
      "Second Address": " STE 120",
      "City": "SAN JOSE",
      "Zip Code": " 95111",
      "County": " SANTA CLARA",
      "Latitude": "37.2794700  ",
      "Longitude": " -121.83465 "
   },
   {
      "Vendor": "TARGET STORE T-2238",
      "Address": " 3155 SILVER CREEK RD",
      "City": "SAN JOSE",
      "Zip Code": " 95121",
      "County": " SANTA CLARA",
      "Latitude": "37.3078510  ",
      "Longitude": " -121.81181 "
   },
   {
      "Vendor": "TARGET STORE T-2581",
      "Address": " 95 HOLGER WAY",
      "City": "SAN JOSE",
      "Zip Code": " 95134",
      "County": " SANTA CLARA",
      "Latitude": "37.4175060  ",
      "Longitude": " -121.95508 "
   },
   {
      "Vendor": "TARGET STORE T-0626",
      "Address": " 2155 MORRILL AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95132",
      "County": " SANTA CLARA",
      "Latitude": "37.4137320  ",
      "Longitude": " -121.87671 "
   },
   {
      "Vendor": "TARGET STORE T-2252",
      "Address": " 1061 COCHRANE RD",
      "City": "MORGAN HILL",
      "Zip Code": " 95037",
      "County": " SANTA CLARA",
      "Latitude": "37.1550970  ",
      "Longitude": " -121.64982 "
   },
   {
      "Vendor": "TARGET STORE T-1927",
      "Address": " 879 BLOSSOM HILL RD",
      "City": "SAN JOSE",
      "Zip Code": " 95123",
      "County": " SANTA CLARA",
      "Latitude": "37.2517400  ",
      "Longitude": " -121.86010 "
   },
   {
      "Vendor": "TARGET STORE T-1427",
      "Address": " 1600 SARATOGA AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95129",
      "County": " SANTA CLARA",
      "Latitude": "37.2918420  ",
      "Longitude": " -121.98800 "
   },
   {
      "Vendor": "CHAVEZ SUPERMARKET",
      "Address": " 646 BLOSSOM HILL RD",
      "City": "SAN JOSE",
      "Zip Code": " 95123",
      "County": " SANTA CLARA",
      "Latitude": "37.2503090  ",
      "Longitude": " -121.84522 "
   },
   {
      "Vendor": "APATZINGAN MARKET",
      "Address": " 901 OAKLAND RD",
      "City": "SAN JOSE",
      "Zip Code": " 95112",
      "County": " SANTA CLARA",
      "Latitude": "37.3593520  ",
      "Longitude": " -121.89138 "
   },
   {
      "Vendor": "SAFEWAY #3241",
      "Address": "W 950 HAMILTON AVE",
      "City": "CAMPBELL",
      "Zip Code": " 95008",
      "County": " SANTA CLARA",
      "Latitude": "37.2938910  ",
      "Longitude": " -121.96637 "
   },
   {
      "Vendor": "LOS PRIMOS MEAT MARKET #2",
      "Address": "S 1539 WINCHESTER BLVD",
      "City": "SAN JOSE",
      "Zip Code": " 95128",
      "County": " SANTA CLARA",
      "Latitude": "37.2958340  ",
      "Longitude": " -121.95043 "
   },
   {
      "Vendor": "MI RANCHO CARNICERIA",
      "Address": " 1383 KOOSER RD",
      "City": "SAN JOSE",
      "Zip Code": " 95118",
      "County": " SANTA CLARA",
      "Latitude": "37.2465150  ",
      "Longitude": " -121.88914 "
   },
   {
      "Vendor": "WAL-MART STORE #2280",
      "Address": " 600 SHOWERS DR",
      "City": "MOUNTAIN VIEW",
      "Zip Code": " 94040",
      "County": " SANTA CLARA",
      "Latitude": "37.4008910  ",
      "Longitude": " -122.10944 "
   },
   {
      "Vendor": "WAL-MART STORE #5435",
      "Address": " 777 STORY RD",
      "City": "SAN JOSE",
      "Zip Code": " 95122",
      "County": " SANTA CLARA",
      "Latitude": "37.3310020  ",
      "Longitude": " -121.86044 "
   },
   {
      "Vendor": "LOS CUATES MEAT MARKET",
      "Address": "S 1507 WINCHESTER BLVD",
      "City": "SAN JOSE",
      "Zip Code": " 95128",
      "County": " SANTA CLARA",
      "Latitude": "37.2969410  ",
      "Longitude": " -121.95000 "
   },
   {
      "Vendor": "FAMILIA FOODS",
      "Address": " 3851 SEVEN TREES BLVD",
      "City": "SAN JOSE",
      "Zip Code": " 95111",
      "County": " SANTA CLARA",
      "Latitude": "37.2835570  ",
      "Longitude": " -121.83350 "
   },
   {
      "Vendor": "WAL-MART #5884",
      "Address": " 5095 ALMADEN EXPRESSWAY",
      "City": "SAN JOSE",
      "Zip Code": " 95118",
      "County": " SANTA CLARA",
      "Latitude": "37.2563870  ",
      "Longitude": " -121.87696 "
   },
   {
      "Vendor": "WAL-MART #3123",
      "Address": " 3255 MISSION COLLEGE BLVD",
      "City": "SANTA CLARA",
      "Zip Code": " 95054",
      "County": " SANTA CLARA",
      "Latitude": "37.3898920  ",
      "Longitude": " -121.98557 "
   },
   {
      "Vendor": "WAL-MART #3023",
      "Address": " 4055 EVERGREEN VILLAGE SQ",
      "Second Address": " STE 140",
      "City": "SAN JOSE",
      "Zip Code": " 95135",
      "County": " SANTA CLARA",
      "Latitude": "37.3138200  ",
      "Longitude": " -121.77329 "
   },
   {
      "Vendor": "SMART & FINAL #451",
      "Address": "S 1180 KING RD",
      "City": "SAN JOSE",
      "Zip Code": " 95122",
      "County": " SANTA CLARA",
      "Latitude": "37.3387180  ",
      "Longitude": " -121.84140 "
   },
   {
      "Vendor": "WAL-MART STORE #2486",
      "Address": " 4080 STEVENS CREEK BLVD",
      "City": "SAN JOSE",
      "Zip Code": " 95129",
      "County": " SANTA CLARA",
      "Latitude": "37.3220600  ",
      "Longitude": " -121.97342 "
   },
   {
      "Vendor": "SAFEWAY #3251",
      "Address": " 20620 HOMESTEAD RD",
      "City": "CUPERTINO",
      "Zip Code": " 95014",
      "County": " SANTA CLARA",
      "Latitude": "37.3363970  ",
      "Longitude": " -122.03429 "
   },
   {
      "Vendor": "SAFEWAY #2814",
      "Address": " 160 1ST ST",
      "City": "LOS ALTOS",
      "Zip Code": " 94022",
      "County": " SANTA CLARA",
      "Latitude": "37.3790640  ",
      "Longitude": " -122.11905 "
   },
   {
      "Vendor": "SAFEWAY #2900",
      "Address": " 5760 COTTLE RD",
      "City": "SAN JOSE",
      "Zip Code": " 95123",
      "County": " SANTA CLARA",
      "Latitude": "37.2463040  ",
      "Longitude": " -121.80274 "
   },
   {
      "Vendor": "WAL-MART NBRHD MARKET #4174",
      "Address": " 1450 MONTEREY RD",
      "City": "SAN JOSE",
      "Zip Code": " 95112",
      "County": " SANTA CLARA",
      "Latitude": "37.3162210  ",
      "Longitude": " -121.87145 "
   },
   {
      "Vendor": "LION MARKET",
      "Address": " 1070 STORY RD",
      "City": "SAN JOSE",
      "Zip Code": " 95122",
      "County": " SANTA CLARA",
      "Latitude": "37.3317010  ",
      "Longitude": " -121.85412 "
   },
   {
      "Vendor": "FRESCO SUPERMARKET",
      "Address": " 2217 QUIMBY RD",
      "City": "SAN JOSE",
      "Zip Code": " 95122",
      "County": " SANTA CLARA",
      "Latitude": "37.3239330  ",
      "Longitude": " -121.81041 "
   },
   {
      "Vendor": "SAFEWAY #3095",
      "Address": "E 2980 CAPITOL EXPY",
      "City": "SAN JOSE",
      "Zip Code": " 95148",
      "County": " SANTA CLARA",
      "Latitude": "37.3307070  ",
      "Longitude": " -121.81073 "
   },
   {
      "Vendor": "TARGET STORE T-2830",
      "Address": " 2004 EL CAMINO REAL",
      "City": "SANTA CLARA",
      "Zip Code": " 95050",
      "County": " SANTA CLARA",
      "Latitude": "37.3520840  ",
      "Longitude": " -121.96079 "
   },
   {
      "Vendor": "TARGET STORE T-2605",
      "Address": " 5630 COTTLE RD",
      "City": "SAN JOSE",
      "Zip Code": " 95123",
      "County": " SANTA CLARA",
      "Latitude": "37.2504300  ",
      "Longitude": " -121.80244 "
   },
   {
      "Vendor": "FOOD MAXX #491",
      "Address": " 3002 STORY RD",
      "City": "SAN JOSE",
      "Zip Code": " 95127",
      "County": " SANTA CLARA",
      "Latitude": "37.3542700  ",
      "Longitude": " -121.82024 "
   },
   {
      "Vendor": "LAS PALMAS MERCADO Y CARNIC",
      "Address": " 1080 SARATOGA AVE",
      "Second Address": " STE 15",
      "City": "SAN JOSE",
      "Zip Code": " 95129",
      "County": " SANTA CLARA",
      "Latitude": "37.3056730  ",
      "Longitude": " -121.97804 "
   },
   {
      "Vendor": "BABY NUTRITION",
      "Address": " 3117 ALUM ROCK AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95127",
      "County": " SANTA CLARA",
      "Latitude": "37.3663380  ",
      "Longitude": " -121.82771 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2119",
      "Address": " 301 RANCH DR",
      "City": "MILPITAS",
      "Zip Code": " 95035",
      "County": " SANTA CLARA",
      "Latitude": "37.4314090  ",
      "Longitude": " -121.92117 "
   },
   {
      "Vendor": "LA PLAZA MARKET #2",
      "Address": "S 40 RENGSTORFF AVE",
      "City": "MOUNTAIN VIEW",
      "Zip Code": " 94040",
      "County": " SANTA CLARA",
      "Latitude": "37.4028800  ",
      "Longitude": " -122.09788 "
   },
   {
      "Vendor": "LA PLAZA MARKET #3",
      "Address": " 515 MCLAUGHLIN AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95116",
      "County": " SANTA CLARA",
      "Latitude": "37.3405580  ",
      "Longitude": " -121.86202 "
   },
   {
      "Vendor": "CARDENAS #222",
      "Address": "S 1070 WHITE RD",
      "City": "SAN JOSE",
      "Zip Code": " 95127",
      "County": " SANTA CLARA",
      "Latitude": "37.3579690  ",
      "Longitude": " -121.81903 "
   },
   {
      "Vendor": "CARDENAS #204",
      "Address": " 1745 STORY RD",
      "City": "SAN JOSE",
      "Zip Code": " 95122",
      "County": " SANTA CLARA",
      "Latitude": "37.3413440  ",
      "Longitude": " -121.84309 "
   },
   {
      "Vendor": "CARDENAS #203",
      "Address": "E 235 JULIAN ST",
      "City": "SAN JOSE",
      "Zip Code": " 95112",
      "County": " SANTA CLARA",
      "Latitude": "37.3432490  ",
      "Longitude": " -121.88936 "
   },
   {
      "Vendor": "CARDENAS #212",
      "Address": "N 320 CAPITOL AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95133",
      "County": " SANTA CLARA",
      "Latitude": "37.3711160  ",
      "Longitude": " -121.84358 "
   },
   {
      "Vendor": "CARDENAS #220",
      "Address": " 727 1ST ST",
      "City": "GILROY",
      "Zip Code": " 95020",
      "County": " SANTA CLARA",
      "Latitude": "37.0143050  ",
      "Longitude": " -121.58289 "
   },
   {
      "Vendor": "SAFEWAY #2150",
      "Address": " 1489 BIRD AVE",
      "City": "SAN JOSE",
      "Zip Code": " 95125",
      "County": " SANTA CLARA",
      "Latitude": "37.3061280  ",
      "Longitude": " -121.89124 "
   },
   {
      "Vendor": "SAFEWAY COMMUNITY MKT #2454",
      "Address": " 690 FREMONT AVE",
      "City": "LOS ALTOS",
      "Zip Code": " 94024",
      "County": " SANTA CLARA",
      "Latitude": "37.3607000  ",
      "Longitude": " -122.09696 "
   },
   {
      "Vendor": "SMART & FINAL #779",
      "Address": " 401 JACKLIN RD",
      "City": "MILPITAS",
      "Zip Code": " 95035",
      "County": " SANTA CLARA",
      "Latitude": "37.4474740  ",
      "Longitude": " -121.90281 "
   },
   {
      "Vendor": "SAFEWAY #3403",
      "Address": "N 580 RENGSTORFF AVE",
      "City": "MOUNTAIN VIEW",
      "Zip Code": " 94043",
      "County": " SANTA CLARA",
      "Latitude": "37.4110070  ",
      "Longitude": " -122.09304 "
   },
   {
      "Vendor": "LA RAZA SUPERMARKET",
      "Address": "E 960 SANTA CLARA ST",
      "City": "SAN JOSE",
      "Zip Code": " 95116",
      "County": " SANTA CLARA",
      "Latitude": "37.3450510  ",
      "Longitude": " -121.87112 "
   },
   {
      "Vendor": "A1 GROCERIES",
      "Address": "E 143 VIRGINIA ST",
      "Second Address": " STE A",
      "City": "SAN JOSE",
      "Zip Code": " 95112",
      "County": " SANTA CLARA",
      "Latitude": "37.3257920  ",
      "Longitude": " -121.87897 "
   },
   {
      "Vendor": "MI RANCHO SUPERMARKET",
      "Address": " 3840 MONTEREY RD",
      "City": "SAN JOSE",
      "Zip Code": " 95111",
      "County": " SANTA CLARA",
      "Latitude": "37.2825010  ",
      "Longitude": " -121.83968 "
   },
   {
      "Vendor": "NOB HILL FOODS #636",
      "Address": " 3555 MONROE ST",
      "City": "SANTA CLARA",
      "Zip Code": " 95051",
      "County": " SANTA CLARA",
      "Latitude": "37.3671610  ",
      "Longitude": " -121.99477 "
   },
   {
      "Vendor": "AC GROCERY",
      "Address": "E 702 SANTA CLARA ST",
      "City": "SAN JOSE",
      "Zip Code": " 95112",
      "County": " SANTA CLARA",
      "Latitude": "37.3427870  ",
      "Longitude": " -121.87582 "
   },
   {
      "Vendor": "SMART & FINAL #810",
      "Address": "W 1290 SAN CARLOS ST",
      "City": "SAN JOSE",
      "Zip Code": " 95138",
      "County": " SANTA CLARA",
      "Latitude": "37.3232530  ",
      "Longitude": " -121.91126 "
   },
   {
      "Vendor": "LUCKY 7 SUPERMARKET",
      "Address": " 1675 TULLY RD",
      "City": "SAN JOSE",
      "Zip Code": " 95122",
      "County": " SANTA CLARA",
      "Latitude": "37.3230210  ",
      "Longitude": " -121.82810 "
   },
   {
      "Vendor": "JOYA SUPERMARKET",
      "Address": " 2512 CALIFORNIA ST",
      "Second Address": "  STE 2530",
      "City": "MOUNTAIN VIEW",
      "Zip Code": " 94040",
      "County": " SANTA CLARA",
      "Latitude": "37.4039740  ",
      "Longitude": " -122.10638 "
   },
   {
      "Vendor": "SAFEWAY #0786",
      "Address": " 6255 GRAHAM HILL RD",
      "City": "FELTON",
      "Zip Code": " 95018",
      "County": " SANTA CRUZ",
      "Latitude": "37.0515080  ",
      "Longitude": " -122.06948 "
   },
   {
      "Vendor": "SAFEWAY #0640",
      "Address": " 16 RANCHO DELMAR SHPG C",
      "City": "APTOS",
      "Zip Code": " 95003",
      "County": " SANTA CRUZ",
      "Latitude": "36.9785370  ",
      "Longitude": " -121.90839 "
   },
   {
      "Vendor": "SAFEWAY #0799",
      "Address": " 117 MORRISSEY BLVD",
      "City": "SANTA CRUZ",
      "Zip Code": " 95062",
      "County": " SANTA CRUZ",
      "Latitude": "36.9820480  ",
      "Longitude": " -122.00741 "
   },
   {
      "Vendor": "NOB HILL FOODS #615",
      "Address": " 809 BAY AVE",
      "City": "CAPITOLA",
      "Zip Code": " 95010",
      "County": " SANTA CRUZ",
      "Latitude": "36.9806620  ",
      "Longitude": " -121.95641 "
   },
   {
      "Vendor": "NOB HILL FOODS #617",
      "Address": " 1912 MAIN ST",
      "City": "WATSONVILLE",
      "Zip Code": " 95076",
      "County": " SANTA CRUZ",
      "Latitude": "36.9183430  ",
      "Longitude": " -121.78062 "
   },
   {
      "Vendor": "SAFEWAY #0300",
      "Address": " 253 MOUNT HERMON RD",
      "City": "SCOTTS VALLEY",
      "Zip Code": " 95060",
      "County": " SANTA CRUZ",
      "Latitude": "37.0464150  ",
      "Longitude": " -122.03092 "
   },
   {
      "Vendor": "NOB HILL FOODS #620",
      "Address": " 222 MOUNT HERMON RD",
      "City": "SCOTTS VALLEY",
      "Zip Code": " 95066",
      "County": " SANTA CRUZ",
      "Latitude": "37.0470670  ",
      "Longitude": " -122.02709 "
   },
   {
      "Vendor": "LUCKY #702",
      "Address": " 1475 41ST AVE",
      "City": "CAPITOLA",
      "Zip Code": " 95010",
      "County": " SANTA CRUZ",
      "Latitude": "36.9718620  ",
      "Longitude": " -121.96641 "
   },
   {
      "Vendor": "FOOD MAXX #486",
      "Address": " 1465 MAIN ST",
      "City": "WATSONVILLE",
      "Zip Code": " 95076",
      "County": " SANTA CRUZ",
      "Latitude": "36.9157000  ",
      "Longitude": " -121.77658 "
   },
   {
      "Vendor": "SAFEWAY #1929",
      "Address": " 2720 41ST AVE",
      "City": "SOQUEL",
      "Zip Code": " 95073",
      "County": " SANTA CRUZ",
      "Latitude": "36.9863710  ",
      "Longitude": " -121.96356 "
   },
   {
      "Vendor": "SAFEWAY #2840",
      "Address": " 2010 FREEDOM BLVD",
      "City": "FREEDOM",
      "Zip Code": " 95019",
      "County": " SANTA CRUZ",
      "Latitude": "36.9398510  ",
      "Longitude": " -121.77565 "
   },
   {
      "Vendor": "LA PRINCESA MARKET #14",
      "Address": " 1424 FREEDOM BLVD",
      "City": "WATSONVILLE",
      "Zip Code": " 95076",
      "County": " SANTA CRUZ",
      "Latitude": "36.9261180  ",
      "Longitude": " -121.76310 "
   },
   {
      "Vendor": "SAFEWAY #2607",
      "Address": " 2203 MISSION ST",
      "City": "SANTA CRUZ",
      "Zip Code": " 95060",
      "County": " SANTA CRUZ",
      "Latitude": "36.9609750  ",
      "Longitude": " -122.04516 "
   },
   {
      "Vendor": "LA PRINCESA MARKET #5",
      "Address": " 1260 MAIN ST",
      "City": "WATSONVILLE",
      "Zip Code": " 95076",
      "County": " SANTA CRUZ",
      "Latitude": "36.9170760  ",
      "Longitude": " -121.77075 "
   },
   {
      "Vendor": "TARGET STORE T-1143",
      "Address": " 1415 MAIN ST",
      "City": "WATSONVILLE",
      "Zip Code": " 95076",
      "County": " SANTA CRUZ",
      "Latitude": "36.9165550  ",
      "Longitude": " -121.77331 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #563",
      "Address": "W 27 LAKE AVE",
      "City": "WATSONVILLE",
      "Zip Code": " 95076",
      "County": " SANTA CRUZ",
      "Latitude": "36.9109920  ",
      "Longitude": " -121.75891 "
   },
   {
      "Vendor": "TARGET STORE T-2795",
      "Address": " 1825 41ST AVE",
      "City": "CAPITOLA",
      "Zip Code": " 95010",
      "County": " SANTA CRUZ",
      "Latitude": "36.9752330  ",
      "Longitude": " -121.96911 "
   },
   {
      "Vendor": "FARM FRESH NUTRITION",
      "Address": " 510 MAIN ST",
      "City": "WATSONVILLE",
      "Zip Code": " 95076",
      "County": " SANTA CRUZ",
      "Latitude": "36.9120660  ",
      "Longitude": " -121.75837 "
   },
   {
      "Vendor": "CARDENAS",
      "Address": " 1437 FREEDOM BLVD",
      "City": "WATSONVILLE",
      "Zip Code": " 95076",
      "County": " SANTA CRUZ",
      "Latitude": "36.9272810  ",
      "Longitude": " -121.76649 "
   },
   {
      "Vendor": "SAFEWAY #0774",
      "Address": " 50 SOLANO SQUARE",
      "City": "BENICIA",
      "Zip Code": " 94510",
      "County": " SOLANO",
      "Latitude": "38.0541980  ",
      "Longitude": " -122.15522 "
   },
   {
      "Vendor": "RALEY'S #332",
      "Address": " 3001 TRAVIS BLVD",
      "City": "FAIRFIELD",
      "Zip Code": " 94533",
      "County": " SOLANO",
      "Latitude": "38.2576690  ",
      "Longitude": " -122.06639 "
   },
   {
      "Vendor": "SAFEWAY #0968",
      "Address": " 702 LINCOLN RD W",
      "City": "VALLEJO",
      "Zip Code": " 94590",
      "County": " SOLANO",
      "Latitude": "38.0992230  ",
      "Longitude": " -122.23037 "
   },
   {
      "Vendor": "TRAVIS COMMISSARY",
      "Address": " 460 SKYMASTER DR",
      "Second Address": " BLDG 680",
      "City": "TRAVIS AFB",
      "Zip Code": " 94535",
      "County": " SOLANO",
      "Latitude": "38.2699100  ",
      "Longitude": " -121.94769 "
   },
   {
      "Vendor": "SAFEWAY #0989",
      "Address": " 774 ADMIRAL CALLAGHAN LN",
      "City": "VALLEJO",
      "Zip Code": " 94590",
      "County": " SOLANO",
      "Latitude": "38.1253340  ",
      "Longitude": " -122.22654 "
   },
   {
      "Vendor": "RALEY'S #344",
      "Address": " 3061 ALAMO DR",
      "City": "VACAVILLE",
      "Zip Code": " 95687",
      "County": " SOLANO",
      "Latitude": "38.3355780  ",
      "Longitude": " -121.95484 "
   },
   {
      "Vendor": "RALEY'S #343",
      "Address": "S 890 HAMPTON RD",
      "City": "BENICIA",
      "Zip Code": " 94510",
      "County": " SOLANO",
      "Latitude": "38.0668750  ",
      "Longitude": " -122.16805 "
   },
   {
      "Vendor": "RALEY'S #330",
      "Address": " 270 SUNSET AVE",
      "City": "SUISUN CITY",
      "Zip Code": " 94585",
      "County": " SOLANO",
      "Latitude": "38.2458410  ",
      "Longitude": " -122.02182 "
   },
   {
      "Vendor": "LIRA'S SUPERMARKET",
      "Address": " 609 HIGHWAY 12",
      "City": "RIO VISTA",
      "Zip Code": " 94571",
      "County": " SOLANO",
      "Latitude": "38.1600740  ",
      "Longitude": " -121.69467 "
   },
   {
      "Vendor": "SAFEWAY #1258",
      "Address": " 1235 STRATFORD AVE",
      "City": "DIXON",
      "Zip Code": " 95620",
      "County": " SOLANO",
      "Latitude": "38.4577940  ",
      "Longitude": " -121.83893 "
   },
   {
      "Vendor": "SAFEWAY #1109",
      "Address": " 2090 HARBISON DR",
      "City": "VACAVILLE",
      "Zip Code": " 95688",
      "County": " SOLANO",
      "Latitude": "38.3621370  ",
      "Longitude": " -121.96204 "
   },
   {
      "Vendor": "SAFEWAY #1127",
      "Address": " 2401 WATERMAN BLVD",
      "City": "FAIRFIELD",
      "Zip Code": " 94533",
      "County": " SOLANO",
      "Latitude": "38.2726390  ",
      "Longitude": " -122.05349 "
   },
   {
      "Vendor": "FOOD MAXX #415",
      "Address": "N 1833 TEXAS ST",
      "City": "FAIRFIELD",
      "Zip Code": " 94533",
      "County": " SOLANO",
      "Latitude": "38.2638250  ",
      "Longitude": " -122.03559 "
   },
   {
      "Vendor": "RALEY'S #331",
      "Address": "N 3330 TEXAS ST",
      "City": "FAIRFIELD",
      "Zip Code": " 94533",
      "County": " SOLANO",
      "Latitude": "38.2890460  ",
      "Longitude": " -122.03301 "
   },
   {
      "Vendor": "SAFEWAY #1631",
      "Address": " 122 ROBLES DR",
      "City": "VALLEJO",
      "Zip Code": " 94591",
      "County": " SOLANO",
      "Latitude": "38.0845780  ",
      "Longitude": " -122.21020 "
   },
   {
      "Vendor": "SAFEWAY #1722",
      "Address": " 5051 BUSINESS CENTER DR",
      "City": "FAIRFIELD",
      "Zip Code": " 94533",
      "County": " SOLANO",
      "Latitude": "38.2167290  ",
      "Longitude": " -122.14133 "
   },
   {
      "Vendor": "NUGGET MARKET #11",
      "Address": " 130 BROWNS VALLEY PKWY",
      "City": "VACAVILLE",
      "Zip Code": " 95688",
      "County": " SOLANO",
      "Latitude": "38.3647940  ",
      "Longitude": " -121.96945 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #508",
      "Address": " 1530 SOLANO AVE",
      "Second Address": " UNIT C",
      "City": "VALLEJO",
      "Zip Code": " 94590",
      "County": " SOLANO",
      "Latitude": "38.1017540  ",
      "Longitude": " -122.23901 "
   },
   {
      "Vendor": "FOOD MAXX #467",
      "Address": "W 1955 TEXAS ST",
      "City": "FAIRFIELD",
      "Zip Code": " 94533",
      "County": " SOLANO",
      "Latitude": "38.2483950  ",
      "Longitude": " -122.06453 "
   },
   {
      "Vendor": "WINCO FOODS #60",
      "Address": " 855 DAVIS ST",
      "City": "VACAVILLE",
      "Zip Code": " 95688",
      "County": " SOLANO",
      "Latitude": "38.3465960  ",
      "Longitude": " -121.98477 "
   },
   {
      "Vendor": "LUCKY #783",
      "Address": "E 777 MONTE VISTA AVE",
      "City": "VACAVILLE",
      "Zip Code": " 95688",
      "County": " SOLANO",
      "Latitude": "38.3598160  ",
      "Longitude": " -121.98277 "
   },
   {
      "Vendor": "LUCKY #784",
      "Address": " 1979 PEABODY RD",
      "City": "VACAVILLE",
      "Zip Code": " 95687",
      "County": " SOLANO",
      "Latitude": "38.3362150  ",
      "Longitude": " -121.96926 "
   },
   {
      "Vendor": "FOOD MAXX #489",
      "Address": " 1740 TUOLUMNE ST",
      "City": "VALLEJO",
      "Zip Code": " 94589",
      "County": " SOLANO",
      "Latitude": "38.1242750  ",
      "Longitude": " -122.23737 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #528",
      "Address": "N 1726 TEXAS ST",
      "City": "FAIRFIELD",
      "Zip Code": " 94533",
      "County": " SOLANO",
      "Latitude": "38.2512860  ",
      "Longitude": " -122.05976 "
   },
   {
      "Vendor": "SMART & FINAL #338",
      "Address": " 3901 SONOMA BLVD",
      "City": "VALLEJO",
      "Zip Code": " 94589",
      "County": " SOLANO",
      "Latitude": "38.1280880  ",
      "Longitude": " -122.25636 "
   },
   {
      "Vendor": "TARGET STORE T-0331",
      "Address": " 904 ADMIRAL CALLAGHAN LN",
      "City": "VALLEJO",
      "Zip Code": " 94591",
      "County": " SOLANO",
      "Latitude": "38.1318760  ",
      "Longitude": " -122.22319 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #541",
      "Address": "E 1020 MONTE VISTA AVE",
      "Second Address": " STE B",
      "City": "VACAVILLE",
      "Zip Code": " 95688",
      "County": " SOLANO",
      "Latitude": "38.3590020  ",
      "Longitude": " -121.97907 "
   },
   {
      "Vendor": "TARGET STORE T-0675",
      "Address": " 2059 CADENASSO DR",
      "City": "FAIRFIELD",
      "Zip Code": " 94533",
      "County": " SOLANO",
      "Latitude": "38.2464820  ",
      "Longitude": " -122.06891 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5139",
      "Address": "E 235 DORSET DR",
      "City": "DIXON",
      "Zip Code": " 95620",
      "County": " SOLANO",
      "Latitude": "38.4713060  ",
      "Longitude": " -121.81895 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1704",
      "Address": " 1501 HELEN POWER DR",
      "City": "VACAVILLE",
      "Zip Code": " 95687",
      "County": " SOLANO",
      "Latitude": "38.3621300  ",
      "Longitude": " -121.95924 "
   },
   {
      "Vendor": "TARGET STORE T-0827",
      "Address": " 3000 HARBISON DR",
      "City": "VACAVILLE",
      "Zip Code": " 95687",
      "County": " SOLANO",
      "Latitude": "38.3614350  ",
      "Longitude": " -121.96237 "
   },
   {
      "Vendor": "WAL-MART STORE #2048",
      "Address": "N 2701 TEXAS ST",
      "City": "FAIRFIELD",
      "Zip Code": " 94534",
      "County": " SOLANO",
      "Latitude": "38.2785570  ",
      "Longitude": " -122.03523 "
   },
   {
      "Vendor": "VIVA SUPERMARKET",
      "Address": "N 925 ADAMS ST",
      "City": "DIXON",
      "Zip Code": " 95620",
      "County": " SOLANO",
      "Latitude": "38.4543740  ",
      "Longitude": " -121.82382 "
   },
   {
      "Vendor": "WAL-MART #5609",
      "Address": " 501 SERENO DR",
      "City": "VALLEJO",
      "Zip Code": " 94589",
      "County": " SOLANO",
      "Latitude": "38.1264790  ",
      "Longitude": " -122.25436 "
   },
   {
      "Vendor": "WAL-MART #5007",
      "Address": " 2050 NUT TREE RD",
      "City": "VACAVILLE",
      "Zip Code": " 95687",
      "County": " SOLANO",
      "Latitude": "38.3505540  ",
      "Longitude": " -121.95117 "
   },
   {
      "Vendor": "WAL-MART #5608",
      "Address": " 941 ALAMO DR",
      "City": "VACAVILLE",
      "Zip Code": " 95687",
      "County": " SOLANO",
      "Latitude": "38.3446640  ",
      "Longitude": " -121.99589 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #3708",
      "Address": " 350 WALTERS RD",
      "City": "SUISUN CITY",
      "Zip Code": " 94585",
      "County": " SOLANO",
      "Latitude": "38.2423750  ",
      "Longitude": " -121.99020 "
   },
   {
      "Vendor": "FAIRFIELD MARKET & LIQUOR",
      "Address": "W 1303 TEXAS ST",
      "City": "FAIRFIELD",
      "Zip Code": " 94533",
      "County": " SOLANO",
      "Latitude": "38.2489400  ",
      "Longitude": " -122.05025 "
   },
   {
      "Vendor": "SMART & FINAL #723",
      "Address": "N 2525 TEXAS ST",
      "Second Address": " STE C",
      "City": "FAIRFIELD",
      "Zip Code": " 94533",
      "County": " SOLANO",
      "Latitude": "38.2752600  ",
      "Longitude": " -122.03546 "
   },
   {
      "Vendor": "CARDENAS #213",
      "Address": " 2107 SOLANO AVE",
      "City": "VALLEJO",
      "Zip Code": " 94590",
      "County": " SOLANO",
      "Latitude": "38.1054490  ",
      "Longitude": " -122.23065 "
   },
   {
      "Vendor": "LA TAPATIA MARKET",
      "Address": " 601 BROADWAY ST",
      "City": "VALLEJO",
      "Zip Code": " 94590",
      "County": " SOLANO",
      "Latitude": "38.1122560  ",
      "Longitude": " -122.24901 "
   },
   {
      "Vendor": "SAFEWAY #0911",
      "Address": "W 477 NAPA ST",
      "City": "SONOMA",
      "Zip Code": " 95476",
      "County": " SONOMA",
      "Latitude": "38.2915870  ",
      "Longitude": " -122.46676 "
   },
   {
      "Vendor": "SAFEWAY #3011",
      "Address": "S 389 MCDOWELL BLVD",
      "City": "PETALUMA",
      "Zip Code": " 94954",
      "County": " SONOMA",
      "Latitude": "38.2489000  ",
      "Longitude": " -122.62200 "
   },
   {
      "Vendor": "SAFEWAY #0950",
      "Address": " 16405 HWY 116",
      "City": "GUERNEVILLE",
      "Zip Code": " 95446",
      "County": " KERN",
      "Latitude": "38.5008000  ",
      "Longitude": " -123.00088 "
   },
   {
      "Vendor": "SAFEWAY #0713",
      "Address": " 100 CALISTOGA RD",
      "City": "SANTA ROSA",
      "Zip Code": " 95409",
      "County": " SONOMA",
      "Latitude": "38.4650060  ",
      "Longitude": " -122.65318 "
   },
   {
      "Vendor": "SAFEWAY #0918",
      "Address": " 6340 COMMERCE BLVD",
      "City": "ROHNERT PARK",
      "Zip Code": " 94928",
      "County": " SONOMA",
      "Latitude": "38.3474870  ",
      "Longitude": " -122.70837 "
   },
   {
      "Vendor": "SAFEWAY #0933",
      "Address": "N 406 MAIN ST",
      "City": "SEBASTOPOL",
      "Zip Code": " 95472",
      "County": " SONOMA",
      "Latitude": "38.4045690  ",
      "Longitude": " -122.82693 "
   },
   {
      "Vendor": "RALEY'S #337",
      "Address": " 100 RALEY'S TOWN CENTER",
      "City": "ROHNERT PARK",
      "Zip Code": " 94928",
      "County": " SONOMA",
      "Latitude": "38.3466630  ",
      "Longitude": " -122.70708 "
   },
   {
      "Vendor": "RALEY'S #341",
      "Address": " 8852 LAKEWOOD DR",
      "City": "WINDSOR",
      "Zip Code": " 95492",
      "County": " SONOMA",
      "Latitude": "38.5489430  ",
      "Longitude": " -122.80513 "
   },
   {
      "Vendor": "SAFEWAY #0956",
      "Address": " 1799 MARLOW RD",
      "City": "SANTA ROSA",
      "Zip Code": " 95401",
      "County": " SONOMA",
      "Latitude": "38.4511230  ",
      "Longitude": " -122.75147 "
   },
   {
      "Vendor": "SAFEWAY #0998",
      "Address": " 1115 VINE ST",
      "City": "HEALDSBURG",
      "Zip Code": " 95448",
      "County": " SONOMA",
      "Latitude": "38.6091800  ",
      "Longitude": " -122.87337 "
   },
   {
      "Vendor": "OLIVER'S MARKET #1",
      "Address": "E 546 COTATI AVE",
      "City": "COTATI",
      "Zip Code": " 94931",
      "County": " SONOMA",
      "Latitude": "38.3285240  ",
      "Longitude": " -122.69899 "
   },
   {
      "Vendor": "RALEY'S #313",
      "Address": " 1407A FULTON RD",
      "City": "SANTA ROSA",
      "Zip Code": " 95403",
      "County": " SONOMA",
      "Latitude": "38.4540350  ",
      "Longitude": " -122.77102 "
   },
   {
      "Vendor": "SAFEWAY #1265",
      "Address": " 2785 YULUPA AVE",
      "City": "SANTA ROSA",
      "Zip Code": " 95405",
      "County": " SONOMA",
      "Latitude": "38.4258230  ",
      "Longitude": " -122.66825 "
   },
   {
      "Vendor": "SAFEWAY #1434",
      "Address": " 9080 BROOKS RD",
      "City": "WINDSOR",
      "Zip Code": " 95492",
      "County": " SONOMA",
      "Latitude": "38.5524130  ",
      "Longitude": " -122.80717 "
   },
   {
      "Vendor": "RAY'S FOOD PLACE #42",
      "Address": "S 1139 CLOVERDALE BLVD",
      "City": "CLOVERDALE",
      "Zip Code": " 95425",
      "County": " SONOMA",
      "Latitude": "38.7840280  ",
      "Longitude": " -123.01481 "
   },
   {
      "Vendor": "SAFEWAY #1562",
      "Address": " 2751 4TH ST",
      "City": "SANTA ROSA",
      "Zip Code": " 95404",
      "County": " SONOMA",
      "Latitude": "38.4506910  ",
      "Longitude": " -122.69104 "
   },
   {
      "Vendor": "FOOD MAXX #468",
      "Address": " 605 ROHNERT PARK EXPY  W",
      "City": "ROHNERT PARK",
      "Zip Code": " 94928",
      "County": " SONOMA",
      "Latitude": "38.3483720  ",
      "Longitude": " -122.72443 "
   },
   {
      "Vendor": "FOOD MAXX #469",
      "Address": " 2055 SEBASTOPOL RD",
      "City": "SANTA ROSA",
      "Zip Code": " 95407",
      "County": " SONOMA",
      "Latitude": "38.4266720  ",
      "Longitude": " -122.74388 "
   },
   {
      "Vendor": "SAFEWAY #1576",
      "Address": " 2300 MENDOCINO AVE",
      "City": "SANTA ROSA",
      "Zip Code": " 95403",
      "County": " SONOMA",
      "Latitude": "38.4628680  ",
      "Longitude": " -122.71737 "
   },
   {
      "Vendor": "LOLA'S MARKET",
      "Address": " 440 DUTTON AVE",
      "Second Address": " STE 17",
      "City": "SANTA ROSA",
      "Zip Code": " 95407",
      "County": " SONOMA",
      "Latitude": "38.4313870  ",
      "Longitude": " -122.72495 "
   },
   {
      "Vendor": "LOLA'S MARKET",
      "Address": " 1680 PETALUMA HILL RD",
      "City": "SANTA ROSA",
      "Zip Code": " 95404",
      "County": " SONOMA",
      "Latitude": "38.4228100  ",
      "Longitude": " -122.70693 "
   },
   {
      "Vendor": "LUCKY #740",
      "Address": " 939 LAKEVILLE HWY",
      "City": "PETALUMA",
      "Zip Code": " 94952",
      "County": " SONOMA",
      "Latitude": "38.2364390  ",
      "Longitude": " -122.62378 "
   },
   {
      "Vendor": "LUCKY #741",
      "Address": "N 1000 PETALUMA BLVD",
      "City": "PETALUMA",
      "Zip Code": " 94952",
      "County": " SONOMA",
      "Latitude": "38.2454070  ",
      "Longitude": " -122.64351 "
   },
   {
      "Vendor": "LUCKY #775",
      "Address": " 150 BICENTENNIAL WAY",
      "City": "SANTA ROSA",
      "Zip Code": " 95403",
      "County": " SONOMA",
      "Latitude": "38.4704590  ",
      "Longitude": " -122.71989 "
   },
   {
      "Vendor": "LUCKY #776",
      "Address": " 915 VILLAGE CT",
      "City": "SANTA ROSA",
      "Zip Code": " 95405",
      "County": " SONOMA",
      "Latitude": "38.4429650  ",
      "Longitude": " -122.68592 "
   },
   {
      "Vendor": "LUCKY #777",
      "Address": "N 776 GRAVENSTEIN HWY",
      "City": "SEBASTOPOL",
      "Zip Code": " 95472",
      "County": " SONOMA",
      "Latitude": "38.4072300  ",
      "Longitude": " -122.84012 "
   },
   {
      "Vendor": "LUCKY #778",
      "Address": " 19181 SONOMA HWY",
      "City": "SONOMA",
      "Zip Code": " 95476",
      "County": " SONOMA",
      "Latitude": "38.3002890  ",
      "Longitude": " -122.47697 "
   },
   {
      "Vendor": "OLIVER'S MARKET #3",
      "Address": " 461 STONY POINT RD",
      "City": "SANTA ROSA",
      "Zip Code": " 95401",
      "County": " SONOMA",
      "Latitude": "38.4324900  ",
      "Longitude": " -122.74350 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #523",
      "Address": " 443 DUTTON AVE",
      "Second Address": " STE 14",
      "City": "SANTA ROSA",
      "Zip Code": " 95407",
      "County": " SONOMA",
      "Latitude": "38.4311790  ",
      "Longitude": " -122.72629 "
   },
   {
      "Vendor": "JUANITA MARKET",
      "Address": " 93 SOUTHWEST BLVD",
      "City": "ROHNERT PARK",
      "Zip Code": " 94928",
      "County": " SONOMA",
      "Latitude": "38.3359710  ",
      "Longitude": " -122.70982 "
   },
   {
      "Vendor": "VONS #2110",
      "Address": " 715 PIER AVE",
      "City": "HERMOSA BEACH",
      "Zip Code": " 90254",
      "County": " LOS ANGELES",
      "Latitude": "33.8648640  ",
      "Longitude": " -118.39412 "
   },
   {
      "Vendor": "FOOD 4 LESS #341",
      "Address": "E 4400 SLAUSON AVE",
      "City": "MAYWOOD",
      "Zip Code": " 90270",
      "County": " LOS ANGELES",
      "Latitude": "33.9867180  ",
      "Longitude": " -118.18701 "
   },
   {
      "Vendor": "VONS #2111",
      "Address": " 24160 LYONS AVE",
      "City": "SANTA CLARITA",
      "Zip Code": " 91321",
      "County": " LOS ANGELES",
      "Latitude": "34.3774320  ",
      "Longitude": " -118.55741 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #103",
      "Address": "E 3831 MARTIN L. KING JR. BLVD",
      "City": "LYNWOOD",
      "Zip Code": " 90262",
      "County": " LOS ANGELES",
      "Latitude": "33.9280250  ",
      "Longitude": " -118.19758 "
   },
   {
      "Vendor": "FOOD 4 LESS #327",
      "Address": "N 1329 LAKE AVE",
      "City": "PASADENA",
      "Zip Code": " 91104",
      "County": " LOS ANGELES",
      "Latitude": "34.1687470  ",
      "Longitude": " -118.13244 "
   },
   {
      "Vendor": "FOOD 4 LESS #378",
      "Address": " 11840 WILMINGTON AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90059",
      "County": " LOS ANGELES",
      "Latitude": "33.9256700  ",
      "Longitude": " -118.23766 "
   },
   {
      "Vendor": "GARDENA SUPERMARKET",
      "Address": "W 1012 GARDENA BLVD",
      "City": "GARDENA",
      "Zip Code": " 90247",
      "County": " LOS ANGELES",
      "Latitude": "33.8812990  ",
      "Longitude": " -118.29199 "
   },
   {
      "Vendor": "BIG SAVER FOODS #02",
      "Address": "S 5168 HUNTINGTON DR",
      "City": "LOS ANGELES",
      "Zip Code": " 90032",
      "County": " LOS ANGELES",
      "Latitude": "34.0889860  ",
      "Longitude": " -118.16987 "
   },
   {
      "Vendor": "RALPHS #120",
      "Address": " 1413 HAWTHORNE BLVD",
      "City": "REDONDO BEACH",
      "Zip Code": " 90278",
      "County": " LOS ANGELES",
      "Latitude": "33.8667590  ",
      "Longitude": " -118.35354 "
   },
   {
      "Vendor": "VONS #3161",
      "Address": " 10321 SEPULVEDA BLVD",
      "City": "MISSION HILLS",
      "Zip Code": " 91345",
      "County": " LOS ANGELES",
      "Latitude": "34.2582430  ",
      "Longitude": " -118.46752 "
   },
   {
      "Vendor": "RALPHS #026",
      "Address": " 5727 KANAN RD",
      "City": "AGOURA HILLS",
      "Zip Code": " 91301",
      "County": " LOS ANGELES",
      "Latitude": "34.1548450  ",
      "Longitude": " -118.75699 "
   },
   {
      "Vendor": "RALPHS #088",
      "Address": " 5035 PACIFIC COAST HWY",
      "City": "TORRANCE",
      "Zip Code": " 90505",
      "County": " LOS ANGELES",
      "Latitude": "33.8131160  ",
      "Longitude": " -118.36771 "
   },
   {
      "Vendor": "RALPHS #110",
      "Address": " 3455 SEPULVEDA BLVD",
      "City": "TORRANCE",
      "Zip Code": " 90505",
      "County": " LOS ANGELES",
      "Latitude": "33.8267930  ",
      "Longitude": " -118.34761 "
   },
   {
      "Vendor": "RALPHS #185",
      "Address": "W 5245 CENTINELA AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90045",
      "County": " LOS ANGELES",
      "Latitude": "33.9775440  ",
      "Longitude": " -118.37093 "
   },
   {
      "Vendor": "RALPHS #186",
      "Address": "N 1930 LAKEWOOD BLVD",
      "City": "LONG BEACH",
      "Zip Code": " 90815",
      "County": " LOS ANGELES",
      "Latitude": "33.7918500  ",
      "Longitude": " -118.14138 "
   },
   {
      "Vendor": "VONS #2155",
      "Address": "E 550 BASELINE RD",
      "City": "CLAREMONT",
      "Zip Code": " 91711",
      "County": " LOS ANGELES",
      "Latitude": "34.1207170  ",
      "Longitude": " -117.70611 "
   },
   {
      "Vendor": "FOOD 4 LESS #324",
      "Address": " 11245 LONG BEACH BLVD",
      "City": "LYNWOOD",
      "Zip Code": " 90262",
      "County": " LOS ANGELES",
      "Latitude": "33.9286740  ",
      "Longitude": " -118.21130 "
   },
   {
      "Vendor": "JON'S MARKETPLACE #07",
      "Address": " 5311 SANTA MONICA BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90029",
      "County": " LOS ANGELES",
      "Latitude": "34.0911730  ",
      "Longitude": " -118.30516 "
   },
   {
      "Vendor": "BAJA RANCH MARKET #1",
      "Address": "W 328 HUNTINGTON DR",
      "City": "MONROVIA",
      "Zip Code": " 91016",
      "County": " LOS ANGELES",
      "Latitude": "34.1401100  ",
      "Longitude": " -118.00658 "
   },
   {
      "Vendor": "RALPHS #726",
      "Address": " 19340 SOLEDAD CANYON RD",
      "City": "CANYON COUNTRY",
      "Zip Code": " 91351",
      "County": " LOS ANGELES",
      "Latitude": "34.4147640  ",
      "Longitude": " -118.47320 "
   },
   {
      "Vendor": "RALPHS #705",
      "Address": " 15120 SUNSET BLVD",
      "City": "PACIFIC PALISADES",
      "Zip Code": " 90272",
      "County": " LOS ANGELES",
      "Latitude": "34.0449860  ",
      "Longitude": " -118.52414 "
   },
   {
      "Vendor": "RALPHS #720",
      "Address": " 30019 HAWTHORNE BLVD",
      "City": "PALOS VERDES PENINSU",
      "Zip Code": " 90274",
      "County": " LOS ANGELES",
      "Latitude": "33.7774680  ",
      "Longitude": " -118.37876 "
   },
   {
      "Vendor": "PAVILIONS #2233",
      "Address": " 7 PENINSULA CENTER",
      "City": "ROLLING HILLS ESTATE",
      "Zip Code": " 90274",
      "County": " LOS ANGELES",
      "Latitude": "33.7756560  ",
      "Longitude": " -118.37788 "
   },
   {
      "Vendor": "VONS #2288",
      "Address": " 2039 VERDUGO BLVD",
      "City": "MONTROSE",
      "Zip Code": " 91020",
      "County": " LOS ANGELES",
      "Latitude": "34.2047930  ",
      "Longitude": " -118.22086 "
   },
   {
      "Vendor": "FOOD 4 LESS #321",
      "Address": " 6920 SANTA FE AVE",
      "City": "HUNTINGTON PARK",
      "Zip Code": " 90255",
      "County": " LOS ANGELES",
      "Latitude": "33.9761540  ",
      "Longitude": " -118.22960 "
   },
   {
      "Vendor": "TOP VALU #09",
      "Address": " 421 PACIFIC AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90802",
      "County": " LOS ANGELES",
      "Latitude": "33.7720030  ",
      "Longitude": " -118.19412 "
   },
   {
      "Vendor": "STATER BROS. #106",
      "Address": "N 375 AZUSA AVE",
      "City": "WEST COVINA",
      "Zip Code": " 91791",
      "County": " LOS ANGELES",
      "Latitude": "34.0771430  ",
      "Longitude": " -117.90943 "
   },
   {
      "Vendor": "FOOD 4 LESS #306",
      "Address": " 44455 VALLEY CENTRAL WAY",
      "City": "LANCASTER",
      "Zip Code": " 93536",
      "County": " LOS ANGELES",
      "Latitude": "34.6905780  ",
      "Longitude": " -118.17346 "
   },
   {
      "Vendor": "VONS #2029",
      "Address": " 4033 WEST AVE",
      "Second Address": " STE L",
      "City": "LANCASTER",
      "Zip Code": " 93536",
      "County": " LOS ANGELES",
      "Latitude": "34.6615210  ",
      "Longitude": " -118.20226 "
   },
   {
      "Vendor": "FOOD 4 LESS #307",
      "Address": " 6901 EASTERN AVE",
      "City": "BELL GARDENS",
      "Zip Code": " 90201",
      "County": " LOS ANGELES",
      "Latitude": "33.9705140  ",
      "Longitude": " -118.16548 "
   },
   {
      "Vendor": "FOOD 4 LESS #309",
      "Address": " 9635 LAUREL CANYON BLVD",
      "City": "PACOIMA",
      "Zip Code": " 91331",
      "County": " LOS ANGELES",
      "Latitude": "34.2444790  ",
      "Longitude": " -118.41728 "
   },
   {
      "Vendor": "RALPHS #001",
      "Address": " 2675 FOOTHILL BLVD",
      "City": "LA CRESCENTA",
      "Zip Code": " 91214",
      "County": " LOS ANGELES",
      "Latitude": "34.2225580  ",
      "Longitude": " -118.23701 "
   },
   {
      "Vendor": "FOOD 4 LESS #379",
      "Address": "W 1900 ROSECRANS AVE",
      "City": "COMPTON",
      "Zip Code": " 90220",
      "County": " LOS ANGELES",
      "Latitude": "33.9015550  ",
      "Longitude": " -118.25227 "
   },
   {
      "Vendor": "RALPHS #039",
      "Address": "S 260 LA BREA AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90036",
      "County": " LOS ANGELES",
      "Latitude": "34.0700180  ",
      "Longitude": " -118.34350 "
   },
   {
      "Vendor": "VONS #3017",
      "Address": " 3027 RANCHO VISTA BLVD",
      "City": "PALMDALE",
      "Zip Code": " 93551",
      "County": " LOS ANGELES",
      "Latitude": "34.6019490  ",
      "Longitude": " -118.18467 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #101",
      "Address": "S 10211 AVALON BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90003",
      "County": " LOS ANGELES",
      "Latitude": "33.9434730  ",
      "Longitude": " -118.26681 "
   },
   {
      "Vendor": "HAWAII SUPERMARKET",
      "Address": "E 120 VALLEY BLVD",
      "City": "SAN GABRIEL",
      "Zip Code": " 91776",
      "County": " LOS ANGELES",
      "Latitude": "34.0791560  ",
      "Longitude": " -118.09888 "
   },
   {
      "Vendor": "VONS #2167",
      "Address": "N 350 LEMON AVE",
      "City": "WALNUT",
      "Zip Code": " 91789",
      "County": " LOS ANGELES",
      "Latitude": "34.0194690  ",
      "Longitude": " -117.86437 "
   },
   {
      "Vendor": "VONS #2200",
      "Address": "W 130 FOOTHILL BLVD",
      "City": "MONROVIA",
      "Zip Code": " 91016",
      "County": " LOS ANGELES",
      "Latitude": "34.1513420  ",
      "Longitude": " -118.00239 "
   },
   {
      "Vendor": "PAVILIONS #2203",
      "Address": "E 5949 SPRING ST",
      "City": "LONG BEACH",
      "Zip Code": " 90808",
      "County": " LOS ANGELES",
      "Latitude": "33.8116090  ",
      "Longitude": " -118.11580 "
   },
   {
      "Vendor": "VONS #3208",
      "Address": "E 745 NAOMI AVE",
      "City": "ARCADIA",
      "Zip Code": " 91007",
      "County": " LOS ANGELES",
      "Latitude": "34.1223480  ",
      "Longitude": " -118.06756 "
   },
   {
      "Vendor": "PAVILIONS #2212",
      "Address": " 11030 JEFFERSON BLVD",
      "City": "CULVER CITY",
      "Zip Code": " 90230",
      "County": " LOS ANGELES",
      "Latitude": "33.9969420  ",
      "Longitude": " -118.39398 "
   },
   {
      "Vendor": "PAVILIONS #2224",
      "Address": "E 845 CALIFORNIA BLVD",
      "City": "PASADENA",
      "Zip Code": " 91106",
      "County": " LOS ANGELES",
      "Latitude": "34.1378480  ",
      "Longitude": " -118.13307 "
   },
   {
      "Vendor": "PAVILIONS #2228",
      "Address": " 1213 FAIR OAKS AVE",
      "City": "SOUTH PASADENA",
      "Zip Code": " 91030",
      "County": " LOS ANGELES",
      "Latitude": "34.1116320  ",
      "Longitude": " -118.15147 "
   },
   {
      "Vendor": "PAVILIONS #2229",
      "Address": "N 727 VINE ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90038",
      "County": " LOS ANGELES",
      "Latitude": "34.0845280  ",
      "Longitude": " -118.32720 "
   },
   {
      "Vendor": "RALEY'S #329",
      "Address": "N 157 MCDOWELL BLVD",
      "City": "PETALUMA",
      "Zip Code": " 94954",
      "County": " SONOMA",
      "Latitude": "38.2501160  ",
      "Longitude": " -122.62798 "
   },
   {
      "Vendor": "MARTIN'S MARKET",
      "Address": " 10333 OLD REDWOOD HWY",
      "Second Address": " STE 101",
      "City": "WINDSOR",
      "Zip Code": " 95492",
      "County": " SONOMA",
      "Latitude": "38.5621600  ",
      "Longitude": " -122.82539 "
   },
   {
      "Vendor": "ORTEGA'S MARKET",
      "Address": " 1331 GUERNEVILLE RD",
      "Second Address": " STE J",
      "City": "SANTA ROSA",
      "Zip Code": " 95403",
      "County": " SONOMA",
      "Latitude": "38.4574630  ",
      "Longitude": " -122.73481 "
   },
   {
      "Vendor": "TARGET STORE T-0852",
      "Address": " 475 ROHNERT PARK EXPY",
      "City": "ROHNERT PARK",
      "Zip Code": " 94928",
      "County": " SONOMA",
      "Latitude": "38.3481760  ",
      "Longitude": " -122.70619 "
   },
   {
      "Vendor": "LOLA'S MARKET",
      "Address": " 102 HEALDSBURG AVE",
      "City": "HEALDSBURG",
      "Zip Code": " 95448",
      "County": " SONOMA",
      "Latitude": "38.6046910  ",
      "Longitude": " -122.86786 "
   },
   {
      "Vendor": "FOOD CONNECTIONS MARKET",
      "Address": " 3990 BRICKWAY BLVD",
      "City": "SANTA ROSA",
      "Zip Code": " 95403",
      "County": " SONOMA",
      "Latitude": "38.5139260  ",
      "Longitude": " -122.79257 "
   },
   {
      "Vendor": "PAVILIONS #2231",
      "Address": " 820 MONTANA AVE",
      "City": "SANTA MONICA",
      "Zip Code": " 90403",
      "County": " LOS ANGELES",
      "Latitude": "34.0279730  ",
      "Longitude": " -118.50038 "
   },
   {
      "Vendor": "VONS #2232",
      "Address": " 4705 TORRANCE BLVD",
      "City": "TORRANCE",
      "Zip Code": " 90503",
      "County": " LOS ANGELES",
      "Latitude": "33.8383550  ",
      "Longitude": " -118.36331 "
   },
   {
      "Vendor": "VONS #2209",
      "Address": " 5500 WOODRUFF AVE",
      "City": "LAKEWOOD",
      "Zip Code": " 90713",
      "County": " LOS ANGELES",
      "Latitude": "33.8580680  ",
      "Longitude": " -118.11577 "
   },
   {
      "Vendor": "JON'S FRESH MARKETPLACE #09",
      "Address": " 1717 GLENOAKS BLVD",
      "City": "GLENDALE",
      "Zip Code": " 91201",
      "County": " LOS ANGELES",
      "Latitude": "34.1716890  ",
      "Longitude": " -118.28997 "
   },
   {
      "Vendor": "PAVILIONS #2214",
      "Address": "W 1110 ALAMEDA AVE",
      "City": "BURBANK",
      "Zip Code": " 91506",
      "County": " LOS ANGELES",
      "Latitude": "34.1613940  ",
      "Longitude": " -118.31360 "
   },
   {
      "Vendor": "RALPHS #245",
      "Address": " 11825 WHITTIER BLVD",
      "City": "WHITTIER",
      "Zip Code": " 90601",
      "County": " LOS ANGELES",
      "Latitude": "33.9809450  ",
      "Longitude": " -118.04973 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #549",
      "Address": " 1450 GUERNEVILLE RD",
      "City": "SANTA ROSA",
      "Zip Code": " 95407",
      "County": " SONOMA",
      "Latitude": "38.4565900  ",
      "Longitude": " -122.73559 "
   },
   {
      "Vendor": "WAL-MART STORE #1755",
      "Address": " 4625 REDWOOD DR",
      "City": "ROHNERT PARK",
      "Zip Code": " 94928",
      "County": " SONOMA",
      "Latitude": "38.3675060  ",
      "Longitude": " -122.71650 "
   },
   {
      "Vendor": "LOLA'S MARKET",
      "Address": " 2750 OLD SONOMA RD",
      "City": "NAPA",
      "Zip Code": " 94558",
      "County": " NAPA",
      "Latitude": "38.2886090  ",
      "Longitude": " -122.30924 "
   },
   {
      "Vendor": "LOLA'S MARKET",
      "Address": "N 241 MCDOWELL BLVD",
      "City": "PETALUMA",
      "Zip Code": " 94954",
      "County": " SONOMA",
      "Latitude": "38.2512160  ",
      "Longitude": " -122.62989 "
   },
   {
      "Vendor": "SMART & FINAL #409",
      "Address": " 2805 SANTA ROSA AVE",
      "City": "SANTA ROSA",
      "Zip Code": " 95407",
      "County": " SONOMA",
      "Latitude": "38.4097200  ",
      "Longitude": " -122.71404 "
   },
   {
      "Vendor": "ORTEGA'S MARKET #2",
      "Address": " 946 CAULFIELD LN",
      "City": "PETALUMA",
      "Zip Code": " 94952",
      "County": " SONOMA",
      "Latitude": "38.2362040  ",
      "Longitude": " -122.62156 "
   },
   {
      "Vendor": "WAL-MART NBRHD MARKET #2468",
      "Address": " 901 GOLF COURSE DR",
      "City": "ROHNERT PARK",
      "Zip Code": " 94928",
      "County": " SONOMA",
      "Latitude": "38.3616860  ",
      "Longitude": " -122.69315 "
   },
   {
      "Vendor": "CASTANEDA'S MARKETPLACE",
      "Address": " 8465 OLD REDWOOD HWY",
      "Second Address": " STE 601",
      "City": "WINDSOR",
      "Zip Code": " 95492",
      "County": " SONOMA",
      "Latitude": "38.5425520  ",
      "Longitude": " -122.80071 "
   },
   {
      "Vendor": "CAMACHO MARKET",
      "Address": " 645 SEBASTOPOL RD",
      "City": "SANTA ROSA",
      "Zip Code": " 95407",
      "County": " SONOMA",
      "Latitude": "38.4301210  ",
      "Longitude": " -122.72735 "
   },
   {
      "Vendor": "MI CHATITA MKT & TAQUERIA",
      "Address": " 1471 SOUTHWEST BLVD",
      "City": "ROHNERT PARK",
      "Zip Code": " 94928",
      "County": " SONOMA",
      "Latitude": "38.3393060  ",
      "Longitude": " -122.68653 "
   },
   {
      "Vendor": "TARGET STORE T-2601",
      "Address": " 401 KENILWORTH DR",
      "City": "PETALUMA",
      "Zip Code": " 94952",
      "County": " SONOMA",
      "Latitude": "38.2436540  ",
      "Longitude": " -122.62495 "
   },
   {
      "Vendor": "TARGET STORE T-2804",
      "Address": " 900 CODDINGTOWN CTR",
      "City": "SANTA ROSA",
      "Zip Code": " 95401",
      "County": " SONOMA",
      "Latitude": "38.4561290  ",
      "Longitude": " -122.72828 "
   },
   {
      "Vendor": "SAFEWAY #2456",
      "Address": " 701 SONOMA MOUNTAIN PKWY",
      "City": "PETALUMA",
      "Zip Code": " 94954",
      "County": " SONOMA",
      "Latitude": "38.2685610  ",
      "Longitude": " -122.63936 "
   },
   {
      "Vendor": "SAFEWAY #2457",
      "Address": "W 1211 COLLEGE AVE",
      "City": "SANTA ROSA",
      "Zip Code": " 95401",
      "County": " SONOMA",
      "Latitude": "38.4463970  ",
      "Longitude": " -122.74164 "
   },
   {
      "Vendor": "SMART & FINAL #782",
      "Address": " 465 MCDOWELL BLVD",
      "City": "PETALUMA",
      "Zip Code": " 94954",
      "County": " SONOMA",
      "Latitude": "38.2552840  ",
      "Longitude": " -122.63713 "
   },
   {
      "Vendor": "SUPER CHAVEZ MARKET",
      "Address": " 1480 GUERNEVILLE RD",
      "City": "SANTA ROSA",
      "Zip Code": " 95403",
      "County": " SONOMA",
      "Latitude": "38.4559550  ",
      "Longitude": " -122.73624 "
   },
   {
      "Vendor": "SONOMA MARKET #17",
      "Address": "W 500 NAPA ST",
      "City": "SONOMA",
      "Zip Code": " 95476",
      "County": " SONOMA",
      "Latitude": "38.2939910  ",
      "Longitude": " -122.46860 "
   },
   {
      "Vendor": "LOS REYES MARKET",
      "Address": " 177 SOUTHWEST BLVD",
      "City": "ROHNERT PARK",
      "Zip Code": " 94928",
      "County": " SONOMA",
      "Latitude": "38.3357920  ",
      "Longitude": " -122.70779 "
   },
   {
      "Vendor": "RALEY'S #426",
      "Address": "S 781 HIGHWAY 49",
      "City": "JACKSON",
      "Zip Code": " 95642",
      "County": " AMADOR",
      "Latitude": "38.3410920  ",
      "Longitude": " -120.76519 "
   },
   {
      "Vendor": "PAYLESS MARKET #2",
      "Address": " 26560 STATE HIGHWAY 88",
      "City": "PIONEER",
      "Zip Code": " 95666",
      "County": " AMADOR",
      "Latitude": "38.4430090  ",
      "Longitude": " -120.53520 "
   },
   {
      "Vendor": "COST LESS FOOD COMPANY",
      "Address": "S 555 STATE HIGHWAY 49",
      "City": "JACKSON",
      "Zip Code": " 95642",
      "County": " AMADOR",
      "Latitude": "38.3426280  ",
      "Longitude": " -120.76905 "
   },
   {
      "Vendor": "SAVE MART #609",
      "Address": " 11980 HIGHWAY 88",
      "City": "JACKSON",
      "Zip Code": " 95642",
      "County": " AMADOR",
      "Latitude": "38.3625740  ",
      "Longitude": " -120.80165 "
   },
   {
      "Vendor": "SAFEWAY #2778",
      "Address": " 12110 INDUSTRY BLVD",
      "City": "JACKSON",
      "Zip Code": " 95654",
      "County": " AMADOR",
      "Latitude": "38.3696260  ",
      "Longitude": " -120.80040 "
   },
   {
      "Vendor": "IONE PLAZA MARKET",
      "Address": " 313 PRESTON AVE",
      "City": "IONE",
      "Zip Code": " 95640",
      "County": " AMADOR",
      "Latitude": "38.3530690  ",
      "Longitude": " -120.93513 "
   },
   {
      "Vendor": "WAL-MART STORE #2054",
      "Address": " 10355 WICKLOW WAY",
      "City": "JACKSON",
      "Zip Code": " 95642",
      "County": " AMADOR",
      "Latitude": "38.3583630  ",
      "Longitude": " -120.80552 "
   },
   {
      "Vendor": "POKERVILLE MARKET",
      "Address": " 18170 CA-49",
      "City": "PLYMOUTH",
      "Zip Code": " 95669",
      "County": " AMADOR",
      "Latitude": "38.4721190  ",
      "Longitude": " -120.85101 "
   },
   {
      "Vendor": "ORLANDO'S PINE GROVE",
      "Address": " 19394 CA-88",
      "City": "PINE GROVE",
      "Zip Code": " 95665",
      "County": " AMADOR",
      "Latitude": "38.4122800  ",
      "Longitude": " -120.66699 "
   },
   {
      "Vendor": "RALEY'S #236",
      "Address": " 2325 MYERS ST",
      "Second Address": " STE A",
      "City": "OROVILLE",
      "Zip Code": " 95965",
      "County": " BUTTE",
      "Latitude": "39.5072260  ",
      "Longitude": " -121.54939 "
   },
   {
      "Vendor": "SAFEWAY #2287",
      "Address": " 1596 STATE HIGHWAY 99",
      "City": "GRIDLEY",
      "Zip Code": " 95948",
      "County": " BUTTE",
      "Latitude": "39.3625450  ",
      "Longitude": " -121.68654 "
   },
   {
      "Vendor": "SAFEWAY #0256",
      "Address": "W 1016 SACRAMENTO AVE",
      "City": "CHICO",
      "Zip Code": " 95926",
      "County": " BUTTE",
      "Latitude": "39.7320320  ",
      "Longitude": " -121.85948 "
   },
   {
      "Vendor": "HOLIDAY QUALITY FOODS #15",
      "Address": " 6848 L SKYWAY RD",
      "City": "PARADISE",
      "Zip Code": " 95969",
      "County": " BUTTE",
      "Latitude": "39.7296590  ",
      "Longitude": " -121.68498 "
   },
   {
      "Vendor": "RALEY'S #249",
      "Address": " 2485 NOTRE DAME BLVD",
      "Second Address": " UNIT 330",
      "City": "CHICO",
      "Zip Code": " 95928",
      "County": " BUTTE",
      "Latitude": "39.7152800  ",
      "Longitude": " -121.79494 "
   },
   {
      "Vendor": "SAV MOR FOODS #33",
      "Address": " 540 WASHINGTON ST",
      "City": "GRIDLEY",
      "Zip Code": " 95948",
      "County": " BUTTE",
      "Latitude": "39.3645590  ",
      "Longitude": " -121.69343 "
   },
   {
      "Vendor": "SAFEWAY #1125",
      "Address": " 1366 EAST AVE",
      "City": "CHICO",
      "Zip Code": " 95973",
      "County": " BUTTE",
      "Latitude": "39.7623660  ",
      "Longitude": " -121.82276 "
   },
   {
      "Vendor": "WINCO FOODS #25",
      "Address": "E 2060 20TH ST",
      "City": "CHICO",
      "Zip Code": " 95928",
      "County": " BUTTE",
      "Latitude": "39.7291660  ",
      "Longitude": " -121.80035 "
   },
   {
      "Vendor": "RALEY'S #245",
      "Address": "W 211 EAST AVE",
      "City": "CHICO",
      "Zip Code": " 95926",
      "County": " BUTTE",
      "Latitude": "39.7554300  ",
      "Longitude": " -121.86308 "
   },
   {
      "Vendor": "SAV MOR FOODS #60",
      "Address": " 14001 LAKERIDGE CIR",
      "City": "MAGALIA",
      "Zip Code": " 95954",
      "County": " BUTTE",
      "Latitude": "39.8150580  ",
      "Longitude": " -121.59064 "
   },
   {
      "Vendor": "SAFEWAY #1651",
      "Address": " 720 MANGROVE WAY",
      "City": "CHICO",
      "Zip Code": " 95926",
      "County": " BUTTE",
      "Latitude": "39.7367040  ",
      "Longitude": " -121.83364 "
   },
   {
      "Vendor": "FOOD MAXX #475",
      "Address": " 2051 DR. MARTIN L KING JR PKWY",
      "City": "CHICO",
      "Zip Code": " 95928",
      "County": " BUTTE",
      "Latitude": "39.7239070  ",
      "Longitude": " -121.80937 "
   },
   {
      "Vendor": "FOOD MAXX #474",
      "Address": " 1160 OROVILLE DAM BLVD",
      "City": "OROVILLE",
      "Zip Code": " 95965",
      "County": " BUTTE",
      "Latitude": "39.5026380  ",
      "Longitude": " -121.56121 "
   },
   {
      "Vendor": "SAVE MART #602",
      "Address": "W 146 EAST AVE",
      "City": "CHICO",
      "Zip Code": " 95926",
      "County": " BUTTE",
      "Latitude": "39.7561750  ",
      "Longitude": " -121.86242 "
   },
   {
      "Vendor": "SAVE MART #613",
      "Address": " 6636 CLARK RD",
      "City": "PARADISE",
      "Zip Code": " 95969",
      "County": " BUTTE",
      "Latitude": "39.7765750  ",
      "Longitude": " -121.58962 "
   },
   {
      "Vendor": "RALPHS #095",
      "Address": " 2230 ATLANTIC BLVD",
      "City": "MONTEREY PARK",
      "Zip Code": " 91754",
      "County": " LOS ANGELES",
      "Latitude": "34.0371090  ",
      "Longitude": " -118.14479 "
   },
   {
      "Vendor": "FOOD 4 LESS #313",
      "Address": " 14500 OCEAN GATE AVE",
      "City": "HAWTHORNE",
      "Zip Code": " 90250",
      "County": " LOS ANGELES",
      "Latitude": "33.8998500  ",
      "Longitude": " -118.36683 "
   },
   {
      "Vendor": "FOOD 4 LESS #317",
      "Address": " 6700 CHERRY AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90805",
      "County": " LOS ANGELES",
      "Latitude": "33.8773990  ",
      "Longitude": " -118.16772 "
   },
   {
      "Vendor": "GELSON'S MARKET #002",
      "Address": " 16450 VENTURA BLVD",
      "City": "ENCINO",
      "Zip Code": " 91436",
      "County": " LOS ANGELES",
      "Latitude": "34.1568810  ",
      "Longitude": " -118.49173 "
   },
   {
      "Vendor": "GELSON'S MARKET #003",
      "Address": " 4738 LAUREL CANYON BLVD",
      "City": "NORTH HOLLYWOOD",
      "Zip Code": " 91607",
      "County": " LOS ANGELES",
      "Latitude": "34.1568200  ",
      "Longitude": " -118.39629 "
   },
   {
      "Vendor": "GELSON'S MARKET #005",
      "Address": " 5500 RESEDA BLVD",
      "City": "TARZANA",
      "Zip Code": " 91356",
      "County": " LOS ANGELES",
      "Latitude": "34.1701190  ",
      "Longitude": " -118.53551 "
   },
   {
      "Vendor": "GELSON'S MARKET #004",
      "Address": " 10250 SANTA MONICA BLVD",
      "City": "CENTURY CITY",
      "Zip Code": " 90067",
      "County": " LOS ANGELES",
      "Latitude": "34.0586000  ",
      "Longitude": " -118.41900 "
   },
   {
      "Vendor": "GELSON'S MARKET #007",
      "Address": " 15424 SUNSET BLVD",
      "City": "PACIFIC PALISADES",
      "Zip Code": " 90272",
      "County": " LOS ANGELES",
      "Latitude": "34.0476880  ",
      "Longitude": " -118.52786 "
   },
   {
      "Vendor": "GELSON'S MARKET #010",
      "Address": " 13455 MAXELLA AVE",
      "City": "MARINA DEL REY",
      "Zip Code": " 90292",
      "County": " LOS ANGELES",
      "Latitude": "33.9864710  ",
      "Longitude": " -118.44281 "
   },
   {
      "Vendor": "RALPHS #056",
      "Address": " 10900 MAGNOLIA BLVD",
      "City": "NORTH HOLLYWOOD",
      "Zip Code": " 91601",
      "County": " LOS ANGELES",
      "Latitude": "34.1643920  ",
      "Longitude": " -118.36819 "
   },
   {
      "Vendor": "TOP VALU #14",
      "Address": " 4831 WHITTIER BLVD",
      "City": "EAST LOS ANGELES",
      "Zip Code": " 90022",
      "County": " LOS ANGELES",
      "Latitude": "34.0220700  ",
      "Longitude": " -118.16363 "
   },
   {
      "Vendor": "RALPHS #081",
      "Address": " 21909 VENTURA BLVD",
      "City": "WOODLAND HILLS",
      "Zip Code": " 91364",
      "County": " LOS ANGELES",
      "Latitude": "34.1691190  ",
      "Longitude": " -118.60406 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #7",
      "Address": " 13820 FOOTHILL BLVD",
      "City": "SYLMAR",
      "Zip Code": " 91342",
      "County": " LOS ANGELES",
      "Latitude": "34.3101900  ",
      "Longitude": " -118.43489 "
   },
   {
      "Vendor": "FOOD 4 LESS #323",
      "Address": " 16530 SHERMAN WAY",
      "City": "VAN NUYS",
      "Zip Code": " 91406",
      "County": " LOS ANGELES",
      "Latitude": "34.2006450  ",
      "Longitude": " -118.49354 "
   },
   {
      "Vendor": "FOOD 4 LESS #399",
      "Address": "S 11507 WESTERN AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90047",
      "County": " LOS ANGELES",
      "Latitude": "33.9294450  ",
      "Longitude": " -118.31022 "
   },
   {
      "Vendor": "VONS #2502",
      "Address": "E 500 MANCHESTER BLVD",
      "City": "INGLEWOOD",
      "Zip Code": " 90301",
      "County": " LOS ANGELES",
      "Latitude": "33.9614580  ",
      "Longitude": " -118.34834 "
   },
   {
      "Vendor": "RALPHS #280",
      "Address": " 4311 LINCOLN BLVD",
      "City": "MARINA DEL REY",
      "Zip Code": " 90292",
      "County": " LOS ANGELES",
      "Latitude": "33.9845410  ",
      "Longitude": " -118.44335 "
   },
   {
      "Vendor": "FOOD 4 LESS #344",
      "Address": "S 5318 MAIN ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90037",
      "County": " LOS ANGELES",
      "Latitude": "33.9939450  ",
      "Longitude": " -118.27338 "
   },
   {
      "Vendor": "JON'S MARKETPLACE #11",
      "Address": "N 1601 VERMONT AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90027",
      "County": " LOS ANGELES",
      "Latitude": "34.1002200  ",
      "Longitude": " -118.29246 "
   },
   {
      "Vendor": "RALPHS #060",
      "Address": "E 1416 COLORADO ST",
      "City": "GLENDALE",
      "Zip Code": " 91205",
      "County": " LOS ANGELES",
      "Latitude": "34.1418430  ",
      "Longitude": " -118.23329 "
   },
   {
      "Vendor": "FOOD 4 LESS #337",
      "Address": "N 615 AZUSA AVE",
      "City": "WEST COVINA",
      "Zip Code": " 91791",
      "County": " LOS ANGELES",
      "Latitude": "34.0814940  ",
      "Longitude": " -117.90894 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #1",
      "Address": " 3560 SANTA ANITA AVE",
      "Second Address": " UNIT J",
      "City": "EL MONTE",
      "Zip Code": " 91731",
      "County": " LOS ANGELES",
      "Latitude": "34.0747680  ",
      "Longitude": " -118.04080 "
   },
   {
      "Vendor": "RALPHS #289",
      "Address": " 5601 WILSHIRE BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90036",
      "County": " LOS ANGELES",
      "Latitude": "34.0629210  ",
      "Longitude": " -118.35096 "
   },
   {
      "Vendor": "RALPHS #219",
      "Address": " 16325 VENTURA BLVD",
      "City": "ENCINO",
      "Zip Code": " 91436",
      "County": " LOS ANGELES",
      "Latitude": "34.1576430  ",
      "Longitude": " -118.48938 "
   },
   {
      "Vendor": "RALPHS #209",
      "Address": " 8824 SEPULVEDA BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90045",
      "County": " LOS ANGELES",
      "Latitude": "33.9619260  ",
      "Longitude": " -118.39592 "
   },
   {
      "Vendor": "RALPHS #291",
      "Address": "W 4760 PICO BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90019",
      "County": " LOS ANGELES",
      "Latitude": "34.0482210  ",
      "Longitude": " -118.33978 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #2",
      "Address": "S 413 AZUSA AVE",
      "City": "LA PUENTE",
      "Zip Code": " 91744",
      "County": " LOS ANGELES",
      "Latitude": "34.0139760  ",
      "Longitude": " -117.92283 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #3",
      "Address": " 13720 AMAR RD",
      "City": "LA PUENTE",
      "Zip Code": " 91746",
      "County": " LOS ANGELES",
      "Latitude": "34.0539850  ",
      "Longitude": " -117.97774 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#401",
      "Address": " 3361 TWEEDY BLVD",
      "City": "SOUTH GATE",
      "Zip Code": " 90280",
      "County": " LOS ANGELES",
      "Latitude": "33.9449530  ",
      "Longitude": " -118.20990 "
   },
   {
      "Vendor": "VONS #3519",
      "Address": " 4550 ATLANTIC AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90807",
      "County": " LOS ANGELES",
      "Latitude": "33.8414720  ",
      "Longitude": " -118.18470 "
   },
   {
      "Vendor": "TOP VALU #18",
      "Address": "W 970 FIRST ST",
      "City": "SAN PEDRO",
      "Zip Code": " 90731",
      "County": " LOS ANGELES",
      "Latitude": "33.7437740  ",
      "Longitude": " -118.29840 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKETS #4",
      "Address": "E 440 PALMDALE BLVD",
      "City": "PALMDALE",
      "Zip Code": " 93550",
      "County": " LOS ANGELES",
      "Latitude": "34.5792760  ",
      "Longitude": " -118.12228 "
   },
   {
      "Vendor": "FOOD 4 LESS #376",
      "Address": " 19200 SOLEDAD CANYON RD",
      "City": "SANTA CLARITA",
      "Zip Code": " 91351",
      "County": " LOS ANGELES",
      "Latitude": "34.4147540  ",
      "Longitude": " -118.47079 "
   },
   {
      "Vendor": "FOOD 4 LESS #366",
      "Address": " 10901 IMPERIAL HWY",
      "City": "NORWALK",
      "Zip Code": " 90650",
      "County": " LOS ANGELES",
      "Latitude": "33.9180810  ",
      "Longitude": " -118.10145 "
   },
   {
      "Vendor": "FOOD 4 LESS #363",
      "Address": "E 2750 FIRST ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90033",
      "County": " LOS ANGELES",
      "Latitude": "34.0411940  ",
      "Longitude": " -118.20458 "
   },
   {
      "Vendor": "FOOD 4 LESS #362",
      "Address": " 5420 SUNSET BLVD",
      "City": "HOLLYWOOD",
      "Zip Code": " 90027",
      "County": " LOS ANGELES",
      "Latitude": "34.0970480  ",
      "Longitude": " -118.30789 "
   },
   {
      "Vendor": "FOOD 4 LESS #360",
      "Address": "E 2341 AVENUE S",
      "City": "PALMDALE",
      "Zip Code": " 93550",
      "County": " LOS ANGELES",
      "Latitude": "34.5591140  ",
      "Longitude": " -118.08611 "
   },
   {
      "Vendor": "RALPHS #210",
      "Address": " 11727 OLYMPIC BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90064",
      "County": " LOS ANGELES",
      "Latitude": "34.0341510  ",
      "Longitude": " -118.44844 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #5",
      "Address": "S 2226 GAREY AVE",
      "City": "POMONA",
      "Zip Code": " 91766",
      "County": " LOS ANGELES",
      "Latitude": "34.0310340  ",
      "Longitude": " -117.74890 "
   },
   {
      "Vendor": "RALPHS #293",
      "Address": " 1233 NORTH LA BREA AVE",
      "City": "WEST HOLLYWOOD",
      "Zip Code": " 90038",
      "County": " LOS ANGELES",
      "Latitude": "34.0938780  ",
      "Longitude": " -118.34482 "
   },
   {
      "Vendor": "NORTHGATE MARKET #3",
      "Address": " 21423 NORWALK BLVD",
      "City": "HAWAIIAN GARDENS",
      "Zip Code": " 90716",
      "County": " LOS ANGELES",
      "Latitude": "33.8347760  ",
      "Longitude": " -118.07204 "
   },
   {
      "Vendor": "FOOD 4 LESS #368",
      "Address": "W 851 SEPULVEDA BLVD",
      "City": "TORRANCE",
      "Zip Code": " 90502",
      "County": " LOS ANGELES",
      "Latitude": "33.8111960  ",
      "Longitude": " -118.28894 "
   },
   {
      "Vendor": "FOOD 4 LESS #383",
      "Address": " 7810 NORWALK BLVD",
      "City": "SANTA FE SPRINGS",
      "Zip Code": " 90606",
      "County": " LOS ANGELES",
      "Latitude": "33.9595720  ",
      "Longitude": " -118.07081 "
   },
   {
      "Vendor": "FOOD 4 LESS #364",
      "Address": "W 3200 CENTURY BLVD",
      "City": "INGLEWOOD",
      "Zip Code": " 90303",
      "County": " LOS ANGELES",
      "Latitude": "33.9451910  ",
      "Longitude": " -118.32836 "
   },
   {
      "Vendor": "FOOD 4 LESS #367",
      "Address": "E 2185 SOUTH ST",
      "City": "LONG BEACH",
      "Zip Code": " 90805",
      "County": " LOS ANGELES",
      "Latitude": "33.8614000  ",
      "Longitude": " -118.16661 "
   },
   {
      "Vendor": "FOOD 4 LESS #314",
      "Address": " 8530 TOBIAS AVE",
      "City": "PANORAMA CITY",
      "Zip Code": " 91402",
      "County": " LOS ANGELES",
      "Latitude": "34.2256260  ",
      "Longitude": " -118.45146 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #107",
      "Address": "S 6010 PACIFIC BLVD",
      "City": "HUNTINGTON PARK",
      "Zip Code": " 90255",
      "County": " LOS ANGELES",
      "Latitude": "33.9867290  ",
      "Longitude": " -118.22365 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #105",
      "Address": " 7300 ATLANTIC AVE",
      "City": "CUDAHY",
      "Zip Code": " 90201",
      "County": " LOS ANGELES",
      "Latitude": "33.9687000  ",
      "Longitude": " -118.18713 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #106",
      "Address": "W 1201 WHITTIER BLVD",
      "City": "MONTEBELLO",
      "Zip Code": " 90640",
      "County": " LOS ANGELES",
      "Latitude": "34.0110440  ",
      "Longitude": " -118.11318 "
   },
   {
      "Vendor": "GELSON'S MARKET #011",
      "Address": " 22277 MULHOLLAND HWY",
      "City": "CALABASAS",
      "Zip Code": " 91302",
      "County": " LOS ANGELES",
      "Latitude": "34.1471990  ",
      "Longitude": " -118.61327 "
   },
   {
      "Vendor": "FOOD 4 LESS #369",
      "Address": "N 1821 HACIENDA BLVD",
      "City": "LA PUENTE",
      "Zip Code": " 91744",
      "County": " LOS ANGELES",
      "Latitude": "34.0521140  ",
      "Longitude": " -117.94407 "
   },
   {
      "Vendor": "VONS #3517",
      "Address": " 24325 CRENSHAW BLVD",
      "City": "TORRANCE",
      "Zip Code": " 90503",
      "County": " LOS ANGELES",
      "Latitude": "33.8040930  ",
      "Longitude": " -118.32797 "
   },
   {
      "Vendor": "BIG SAVER FOODS #08",
      "Address": "E 7619 GARVEY AVE",
      "City": "ROSEMEAD",
      "Zip Code": " 91770",
      "County": " LOS ANGELES",
      "Latitude": "34.0628810  ",
      "Longitude": " -118.10290 "
   },
   {
      "Vendor": "RALPHS #198",
      "Address": "W 9616 PICO BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90035",
      "County": " LOS ANGELES",
      "Latitude": "34.0549220  ",
      "Longitude": " -118.39814 "
   },
   {
      "Vendor": "RALPHS #295",
      "Address": " 8626 FIRESTONE BLVD",
      "City": "DOWNEY",
      "Zip Code": " 90241",
      "County": " LOS ANGELES",
      "Latitude": "33.9362080  ",
      "Longitude": " -118.12701 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#402",
      "Address": " 7503 ATLANTIC BLVD",
      "Second Address": " UNIT B",
      "City": "CUDAHY",
      "Zip Code": " 90201",
      "County": " LOS ANGELES",
      "Latitude": "33.9675600  ",
      "Longitude": " -118.18753 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#405",
      "Address": "S 6501 GARFIELD AVE",
      "Second Address": " UNIT C",
      "City": "BELL GARDENS",
      "Zip Code": " 90201",
      "County": " LOS ANGELES",
      "Latitude": "33.9730090  ",
      "Longitude": " -118.14775 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #7",
      "Address": " 1311 GLENDALE BLVD",
      "Second Address": " UNIT F",
      "City": "LOS ANGELES",
      "Zip Code": " 90026",
      "County": " LOS ANGELES",
      "Latitude": "34.0789390  ",
      "Longitude": " -118.26064 "
   },
   {
      "Vendor": "SUPERMERCADO VALLARTA #8",
      "Address": " 9136 SEPULVEDA BLVD",
      "City": "NORTH HILLS",
      "Zip Code": " 91343",
      "County": " LOS ANGELES",
      "Latitude": "34.2365110  ",
      "Longitude": " -118.46668 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#408",
      "Address": " 17610 BELLFLOWER BLVD",
      "Second Address": " STE 101",
      "City": "BELLFLOWER",
      "Zip Code": " 90706",
      "County": " LOS ANGELES",
      "Latitude": "33.8726440  ",
      "Longitude": " -118.12519 "
   },
   {
      "Vendor": "RALPHS #292",
      "Address": " 1644 CLOVERFIELD BLVD",
      "City": "SANTA MONICA",
      "Zip Code": " 90404",
      "County": " LOS ANGELES",
      "Latitude": "34.0270460  ",
      "Longitude": " -118.47382 "
   },
   {
      "Vendor": "FOOD 4 LESS #332",
      "Address": " 8035 WEBB AVE",
      "City": "NORTH HOLLYWOOD",
      "Zip Code": " 91605",
      "County": " LOS ANGELES",
      "Latitude": "34.2162780  ",
      "Longitude": " -118.38940 "
   },
   {
      "Vendor": "RALPHS #016",
      "Address": "S 670 WESTERN AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90005",
      "County": " LOS ANGELES",
      "Latitude": "34.0600300  ",
      "Longitude": " -118.30851 "
   },
   {
      "Vendor": "RALPHS #147",
      "Address": " 27760 MCBEAN PKWY",
      "City": "VALENCIA",
      "Zip Code": " 91354",
      "County": " LOS ANGELES",
      "Latitude": "34.4458780  ",
      "Longitude": " -118.55216 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#407",
      "Address": "E 423 FLORENCE AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90003",
      "County": " LOS ANGELES",
      "Latitude": "33.9749910  ",
      "Longitude": " -118.26666 "
   },
   {
      "Vendor": "VALU MART FOOD WAREHOUSE",
      "Address": "N 6340 ROSEMEAD BLVD",
      "City": "TEMPLE CITY",
      "Zip Code": " 91780",
      "County": " LOS ANGELES",
      "Latitude": "34.1136440  ",
      "Longitude": " -118.07337 "
   },
   {
      "Vendor": "RALPHS #757",
      "Address": " 24975 PICO CANYON RD",
      "City": "STEVENSON RANCH",
      "Zip Code": " 91381",
      "County": " LOS ANGELES",
      "Latitude": "34.3824390  ",
      "Longitude": " -118.57425 "
   },
   {
      "Vendor": "PLAZA MARKET",
      "Address": " 4121 CITY TERRACE DR",
      "City": "LOS ANGELES",
      "Zip Code": " 90063",
      "County": " LOS ANGELES",
      "Latitude": "34.0559830  ",
      "Longitude": " -118.17687 "
   },
   {
      "Vendor": "RALPHS #178",
      "Address": "E 6290 PACIFIC COAST HWY",
      "City": "LONG BEACH",
      "Zip Code": " 90803",
      "County": " LOS ANGELES",
      "Latitude": "33.7609060  ",
      "Longitude": " -118.11597 "
   },
   {
      "Vendor": "RALPHS #294",
      "Address": "S 2600 VERMONT AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90007",
      "County": " LOS ANGELES",
      "Latitude": "34.0320140  ",
      "Longitude": " -118.29066 "
   },
   {
      "Vendor": "FOOD 4 LESS #330",
      "Address": "E 3654 OLYMPIC BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90023",
      "County": " LOS ANGELES",
      "Latitude": "34.0186310  ",
      "Longitude": " -118.19827 "
   },
   {
      "Vendor": "RALPHS #213",
      "Address": " 22915 VICTORY BLVD",
      "City": "CANOGA PARK",
      "Zip Code": " 91307",
      "County": " LOS ANGELES",
      "Latitude": "34.1868400  ",
      "Longitude": " -118.62640 "
   },
   {
      "Vendor": "UNION PLAZA MARKET",
      "Address": "W 1629 6TH ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90017",
      "County": " LOS ANGELES",
      "Latitude": "34.0570410  ",
      "Longitude": " -118.26927 "
   },
   {
      "Vendor": "VONS #2250",
      "Address": " 16830 SAN FERNANDO MISSION BLVD",
      "City": "GRANADA HILLS",
      "Zip Code": " 91344",
      "County": " LOS ANGELES",
      "Latitude": "34.2719950  ",
      "Longitude": " -118.49898 "
   },
   {
      "Vendor": "FOOD 4 LESS #348",
      "Address": " 18318 VANOWEN ST",
      "City": "RESEDA",
      "Zip Code": " 91335",
      "County": " LOS ANGELES",
      "Latitude": "34.1936690  ",
      "Longitude": " -118.53208 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#412",
      "Address": " 7026 RUGBY AVE",
      "City": "HUNTINGTON PARK",
      "Zip Code": " 90255",
      "County": " LOS ANGELES",
      "Latitude": "33.9758340  ",
      "Longitude": " -118.22650 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#414",
      "Address": "E 10016 GARVEY AVE",
      "Second Address": " UNIT 4",
      "City": "EL MONTE",
      "Zip Code": " 91733",
      "County": " LOS ANGELES",
      "Latitude": "34.0627220  ",
      "Longitude": " -118.05037 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKETS #9",
      "Address": " 10859 OXNARD ST",
      "City": "NORTH HOLLYWOOD",
      "Zip Code": " 91606",
      "County": " LOS ANGELES",
      "Latitude": "34.1802890  ",
      "Longitude": " -118.36762 "
   },
   {
      "Vendor": "LA MEXICANA MARKET",
      "Address": "S 4800 COMPTON AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90011",
      "County": " LOS ANGELES",
      "Latitude": "33.9999430  ",
      "Longitude": " -118.24739 "
   },
   {
      "Vendor": "R-RANCH MARKET #6",
      "Address": "N 1800 LONG BEACH BLVD",
      "City": "COMPTON",
      "Zip Code": " 90221",
      "County": " LOS ANGELES",
      "Latitude": "33.9079080  ",
      "Longitude": " -118.20791 "
   },
   {
      "Vendor": "EL SUPER #01",
      "Address": " 5702 FIRESTONE BLVD",
      "City": "SOUTH GATE",
      "Zip Code": " 90280",
      "County": " LOS ANGELES",
      "Latitude": "33.9490830  ",
      "Longitude": " -118.16696 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #5",
      "Address": " 8453 RESEDA BLVD",
      "City": "NORTHRIDGE",
      "Zip Code": " 91324",
      "County": " LOS ANGELES",
      "Latitude": "34.2243190  ",
      "Longitude": " -118.53660 "
   },
   {
      "Vendor": "FOOD 4 LESS #396",
      "Address": " 3000 BALDWIN PARK BLVD",
      "City": "BALDWIN PARK",
      "Zip Code": " 91706",
      "County": " LOS ANGELES",
      "Latitude": "34.0690820  ",
      "Longitude": " -117.97855 "
   },
   {
      "Vendor": "RALPHS #646",
      "Address": " 18010 CHATSWORTH ST",
      "City": "GRANADA HILLS",
      "Zip Code": " 91344",
      "County": " LOS ANGELES",
      "Latitude": "34.2647060  ",
      "Longitude": " -118.52418 "
   },
   {
      "Vendor": "RALPHS #645",
      "Address": "N 500 SEPULVEDA BLVD",
      "City": "EL SEGUNDO",
      "Zip Code": " 90245",
      "County": " LOS ANGELES",
      "Latitude": "33.9225870  ",
      "Longitude": " -118.39557 "
   },
   {
      "Vendor": "VONS #2030",
      "Address": "N 25850 THE OLD RD",
      "City": "VALENCIA",
      "Zip Code": " 91381",
      "County": " LOS ANGELES",
      "Latitude": "34.3907920  ",
      "Longitude": " -118.57349 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#415",
      "Address": " 15625 HAWTHORNE BLVD",
      "Second Address": " UNIT F",
      "City": "LAWNDALE",
      "Zip Code": " 90260",
      "County": " LOS ANGELES",
      "Latitude": "33.8890640  ",
      "Longitude": " -118.35272 "
   },
   {
      "Vendor": "LUIS MEAT MARKET",
      "Address": "S 4253 VERMONT AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90037",
      "County": " LOS ANGELES",
      "Latitude": "34.0061970  ",
      "Longitude": " -118.29154 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #108",
      "Address": "S 8811 WESTERN AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90047",
      "County": " LOS ANGELES",
      "Latitude": "33.9576440  ",
      "Longitude": " -118.30971 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#417",
      "Address": " 1319 LONG BEACH BLVD",
      "City": "LONG BEACH",
      "Zip Code": " 90813",
      "County": " LOS ANGELES",
      "Latitude": "33.7828370  ",
      "Longitude": " -118.18950 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#418",
      "Address": " 3665 CRENSHAW BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90016",
      "County": " LOS ANGELES",
      "Latitude": "34.0209790  ",
      "Longitude": " -118.33517 "
   },
   {
      "Vendor": "JON'S MARKETPLACE #14",
      "Address": "E 600 COLORADO ST",
      "City": "GLENDALE",
      "Zip Code": " 91205",
      "County": " LOS ANGELES",
      "Latitude": "34.1423910  ",
      "Longitude": " -118.24817 "
   },
   {
      "Vendor": "FOOD 4 LESS #358",
      "Address": "S 2090 GAREY AVE",
      "City": "POMONA",
      "Zip Code": " 91766",
      "County": " LOS ANGELES",
      "Latitude": "34.0343350  ",
      "Longitude": " -117.74810 "
   },
   {
      "Vendor": "FOOD 4 LESS #350",
      "Address": "W 1299 ARTESIA BLVD",
      "City": "GARDENA",
      "Zip Code": " 90248",
      "County": " LOS ANGELES",
      "Latitude": "33.8730370  ",
      "Longitude": " -118.29369 "
   },
   {
      "Vendor": "GUADALAJARA MEAT MARKET",
      "Address": "S 14114 VERMONT AVE",
      "City": "GARDENA",
      "Zip Code": " 90247",
      "County": " LOS ANGELES",
      "Latitude": "33.9034550  ",
      "Longitude": " -118.29118 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #11",
      "Address": " 5930 SANTA MONICA BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90038",
      "County": " LOS ANGELES",
      "Latitude": "34.0905480  ",
      "Longitude": " -118.31827 "
   },
   {
      "Vendor": "RALPHS #205",
      "Address": " 4754 COMMONS WAY",
      "City": "CALABASAS",
      "Zip Code": " 91302",
      "County": " LOS ANGELES",
      "Latitude": "34.1542630  ",
      "Longitude": " -118.64461 "
   },
   {
      "Vendor": "RALPHS #648",
      "Address": "W 2600 VICTORY BLVD",
      "City": "BURBANK",
      "Zip Code": " 91505",
      "County": " LOS ANGELES",
      "Latitude": "34.1836630  ",
      "Longitude": " -118.33954 "
   },
   {
      "Vendor": "VONS #1671",
      "Address": " 20440 DEVONSHIRE ST",
      "City": "CHATSWORTH",
      "Zip Code": " 91311",
      "County": " LOS ANGELES",
      "Latitude": "34.2572570  ",
      "Longitude": " -118.57838 "
   },
   {
      "Vendor": "VONS #1674",
      "Address": " 4033 LAUREL CANYON BLVD",
      "City": "STUDIO CITY",
      "Zip Code": " 91604",
      "County": " LOS ANGELES",
      "Latitude": "34.1446130  ",
      "Longitude": " -118.39617 "
   },
   {
      "Vendor": "VILLA MARKET",
      "Address": " 2990 SANTA FE AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90810",
      "County": " LOS ANGELES",
      "Latitude": "33.8111960  ",
      "Longitude": " -118.21487 "
   },
   {
      "Vendor": "RALPHS #196",
      "Address": "E 2250 CARSON ST",
      "City": "LONG BEACH",
      "Zip Code": " 90807",
      "County": " LOS ANGELES",
      "Latitude": "33.8312200  ",
      "Longitude": " -118.16519 "
   },
   {
      "Vendor": "JON'S MARKETPLACE #15",
      "Address": " 20151 ROSCOE BLVD",
      "City": "WINNETKA",
      "Zip Code": " 91306",
      "County": " LOS ANGELES",
      "Latitude": "34.2210020  ",
      "Longitude": " -118.57260 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#423",
      "Address": " 4243 MAINE AVE",
      "City": "BALDWIN PARK",
      "Zip Code": " 91706",
      "County": " LOS ANGELES",
      "Latitude": "34.0899820  ",
      "Longitude": " -117.96044 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#421",
      "Address": " 16000 PARAMOUNT BLVD",
      "Second Address": " UNIT C",
      "City": "PARAMOUNT",
      "Zip Code": " 90723",
      "County": " LOS ANGELES",
      "Latitude": "33.8877280  ",
      "Longitude": " -118.15997 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#424",
      "Address": " 3820 SLAUSON AVE",
      "Second Address": " UNIT A & B",
      "City": "MAYWOOD",
      "Zip Code": " 90270",
      "County": " LOS ANGELES",
      "Latitude": "33.9879230  ",
      "Longitude": " -118.19585 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#430",
      "Address": "S 4353 CENTRAL AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90011",
      "County": " LOS ANGELES",
      "Latitude": "34.0047940  ",
      "Longitude": " -118.25648 "
   },
   {
      "Vendor": "RALPHS #193",
      "Address": "E 25 ALAMEDA AVE",
      "City": "BURBANK",
      "Zip Code": " 91502",
      "County": " LOS ANGELES",
      "Latitude": "34.1736610  ",
      "Longitude": " -118.30149 "
   },
   {
      "Vendor": "RALPHS #111",
      "Address": " 2201 REDONDO BEACH BLVD",
      "City": "GARDENA",
      "Zip Code": " 90247",
      "County": " LOS ANGELES",
      "Latitude": "33.8858940  ",
      "Longitude": " -118.31789 "
   },
   {
      "Vendor": "FOOD 4 LESS #359",
      "Address": "W 1748 JEFFERSON BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90018",
      "County": " LOS ANGELES",
      "Latitude": "34.0252290  ",
      "Longitude": " -118.30744 "
   },
   {
      "Vendor": "LEE'S MARKET",
      "Address": "S 4801 AVALON BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90011",
      "County": " LOS ANGELES",
      "Latitude": "34.0059180  ",
      "Longitude": " -118.26525 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#429",
      "Address": " 3797 MARTIN L. KING JR. BLVD",
      "City": "LYNWOOD",
      "Zip Code": " 90262",
      "County": " LOS ANGELES",
      "Latitude": "33.9286920  ",
      "Longitude": " -118.19940 "
   },
   {
      "Vendor": "SUPER A FOODS #11",
      "Address": " 5250 YORK BLVD",
      "City": "HIGHLAND PARK",
      "Zip Code": " 90042",
      "County": " LOS ANGELES",
      "Latitude": "34.1200220  ",
      "Longitude": " -118.20088 "
   },
   {
      "Vendor": "STATER BROS. #130",
      "Address": "E 2535 AVENUE S",
      "City": "PALMDALE",
      "Zip Code": " 93550",
      "County": " LOS ANGELES",
      "Latitude": "34.5590790  ",
      "Longitude": " -118.08364 "
   },
   {
      "Vendor": "STATER BROS. #134",
      "Address": " 12800 LA MIRADA BLVD",
      "City": "LA MIRADA",
      "Zip Code": " 90638",
      "County": " LOS ANGELES",
      "Latitude": "33.9159620  ",
      "Longitude": " -118.01135 "
   },
   {
      "Vendor": "STATER BROS. #137",
      "Address": "E 11750 WHITTIER BLVD",
      "City": "WHITTIER",
      "Zip Code": " 90601",
      "County": " LOS ANGELES",
      "Latitude": "33.9800320  ",
      "Longitude": " -118.05179 "
   },
   {
      "Vendor": "STATER BROS. #141",
      "Address": " 26900 SIERRA HWY",
      "City": "SANTA CLARITA",
      "Zip Code": " 91321",
      "County": " LOS ANGELES",
      "Latitude": "34.4041410  ",
      "Longitude": " -118.46515 "
   },
   {
      "Vendor": "STATER BROS. #144",
      "Address": "E 1850 AVENUE J",
      "City": "LANCASTER",
      "Zip Code": " 93535",
      "County": " LOS ANGELES",
      "Latitude": "34.6882140  ",
      "Longitude": " -118.09582 "
   },
   {
      "Vendor": "STATER BROS. #145",
      "Address": " 37218 47TH ST E",
      "City": "PALMDALE",
      "Zip Code": " 93552",
      "County": " LOS ANGELES",
      "Latitude": "34.5594040  ",
      "Longitude": " -118.04398 "
   },
   {
      "Vendor": "STATER BROS. #146",
      "Address": "W 2845 AVENUE L",
      "City": "LANCASTER",
      "Zip Code": " 93536",
      "County": " LOS ANGELES",
      "Latitude": "34.6611960  ",
      "Longitude": " -118.18248 "
   },
   {
      "Vendor": "STATER BROS. #153",
      "Address": "E 8640 ALONDRA BLVD",
      "City": "PARAMOUNT",
      "Zip Code": " 90723",
      "County": " LOS ANGELES",
      "Latitude": "33.8886760  ",
      "Longitude": " -118.15088 "
   },
   {
      "Vendor": "STATER BROS. #154",
      "Address": " 11300 FIRESTONE BLVD",
      "City": "NORWALK",
      "Zip Code": " 90650",
      "County": " LOS ANGELES",
      "Latitude": "33.9177960  ",
      "Longitude": " -118.09254 "
   },
   {
      "Vendor": "STATER BROS. #155",
      "Address": "E 7814 FIRESTONE BLVD",
      "City": "DOWNEY",
      "Zip Code": " 90241",
      "County": " LOS ANGELES",
      "Latitude": "33.9440540  ",
      "Longitude": " -118.14172 "
   },
   {
      "Vendor": "STATER BROS. #160",
      "Address": "E 6501 SPRING ST",
      "City": "LONG BEACH",
      "Zip Code": " 90808",
      "County": " LOS ANGELES",
      "Latitude": "33.8113460  ",
      "Longitude": " -118.10554 "
   },
   {
      "Vendor": "STATER BROS. #161",
      "Address": " 11815 ARTESIA BLVD",
      "City": "ARTESIA",
      "Zip Code": " 90701",
      "County": " LOS ANGELES",
      "Latitude": "33.8742210  ",
      "Longitude": " -118.08090 "
   },
   {
      "Vendor": "STATER BROS. #168",
      "Address": " 20677 AMAR RD",
      "City": "WALNUT",
      "Zip Code": " 91789",
      "County": " LOS ANGELES",
      "Latitude": "34.0426550  ",
      "Longitude": " -117.85162 "
   },
   {
      "Vendor": "AMAPOLA MEXICAN DELI",
      "Address": "E 7420 FLORENCE AVE",
      "City": "DOWNEY",
      "Zip Code": " 90240",
      "County": " LOS ANGELES",
      "Latitude": "33.9577750  ",
      "Longitude": " -118.13991 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKETS #11",
      "Address": " 21208 SHERMAN WAY",
      "City": "CANOGA PARK",
      "Zip Code": " 91303",
      "County": " LOS ANGELES",
      "Latitude": "34.2005990  ",
      "Longitude": " -118.59486 "
   },
   {
      "Vendor": "FOOD 4 LESS #760",
      "Address": "W 336 ANAHEIM ST",
      "City": "WILMINGTON",
      "Zip Code": " 90744",
      "County": " LOS ANGELES",
      "Latitude": "33.7790720  ",
      "Longitude": " -118.26562 "
   },
   {
      "Vendor": "BIG SAVER FOODS #12",
      "Address": "E 13925 AMAR RD",
      "City": "LA PUENTE",
      "Zip Code": " 91746",
      "County": " LOS ANGELES",
      "Latitude": "34.0539740  ",
      "Longitude": " -117.97268 "
   },
   {
      "Vendor": "SAN DIEGO MARKET",
      "Address": "S 1131 UNION AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90015",
      "County": " LOS ANGELES",
      "Latitude": "34.0469070  ",
      "Longitude": " -118.27577 "
   },
   {
      "Vendor": "VONS #1623",
      "Address": " 4001 INGLEWOOD AVE",
      "City": "REDONDO BEACH",
      "Zip Code": " 90278",
      "County": " LOS ANGELES",
      "Latitude": "33.8928340  ",
      "Longitude": " -118.36224 "
   },
   {
      "Vendor": "GELSON'S MARKET #016",
      "Address": " 4520 VAN NUYS BLVD",
      "City": "SHERMAN OAKS",
      "Zip Code": " 91403",
      "County": " LOS ANGELES",
      "Latitude": "34.1539340  ",
      "Longitude": " -118.44756 "
   },
   {
      "Vendor": "RALPHS #127",
      "Address": " 19781 RINALDI ST",
      "City": "PORTER RANCH",
      "Zip Code": " 91326",
      "County": " LOS ANGELES",
      "Latitude": "34.2760150  ",
      "Longitude": " -118.56398 "
   },
   {
      "Vendor": "RALPHS #133",
      "Address": " 10901 VENTURA BLVD",
      "City": "STUDIO CITY",
      "Zip Code": " 91604",
      "County": " LOS ANGELES",
      "Latitude": "34.1404900  ",
      "Longitude": " -118.36848 "
   },
   {
      "Vendor": "MOMMY'S NUTRITIONAL CENTER",
      "Address": "N 312 GAFFEY ST",
      "Second Address": " UNIT 100",
      "City": "SAN PEDRO",
      "Zip Code": " 90731",
      "County": " LOS ANGELES",
      "Latitude": "33.7453650  ",
      "Longitude": " -118.29198 "
   },
   {
      "Vendor": "EL SUPER #02",
      "Address": " 14620 PARTHENIA ST",
      "City": "PANORAMA CITY",
      "Zip Code": " 91402",
      "County": " LOS ANGELES",
      "Latitude": "34.2274030  ",
      "Longitude": " -118.45122 "
   },
   {
      "Vendor": "RALPHS #134",
      "Address": "N 211 GLENDALE AVE",
      "City": "GLENDALE",
      "Zip Code": " 91206",
      "County": " LOS ANGELES",
      "Latitude": "34.1487240  ",
      "Longitude": " -118.24837 "
   },
   {
      "Vendor": "JON'S MARKETPLACE #16",
      "Address": " 12122 MAGNOLIA BLVD",
      "City": "NORTH HOLLYWOOD",
      "Zip Code": " 91607",
      "County": " LOS ANGELES",
      "Latitude": "34.1642950  ",
      "Longitude": " -118.39739 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #13",
      "Address": " 8868 MISSION DR",
      "Second Address": " UNIT A",
      "City": "ROSEMEAD",
      "Zip Code": " 91770",
      "County": " LOS ANGELES",
      "Latitude": "34.0848790  ",
      "Longitude": " -118.07581 "
   },
   {
      "Vendor": "AJ FOOD MARKET",
      "Address": " 3157 LINCOLN BLVD",
      "City": "OROVILLE",
      "Zip Code": " 95966",
      "County": " BUTTE",
      "Latitude": "39.4997720  ",
      "Longitude": " -121.55057 "
   },
   {
      "Vendor": "WAL-MART STORE #1630",
      "Address": " 1906 FORT JONES RD",
      "City": "YREKA",
      "Zip Code": " 96097",
      "County": " SISKIYOU",
      "Latitude": "41.6994450  ",
      "Longitude": " -122.64709 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #570",
      "Address": " 2491 CARMICHAEL DR",
      "Second Address": " STE 300",
      "City": "CHICO",
      "Zip Code": " 95928",
      "County": " BUTTE",
      "Latitude": "39.7158040  ",
      "Longitude": " -121.80471 "
   },
   {
      "Vendor": "TARGET STORE T-0317",
      "Address": "E 1951 20TH ST",
      "City": "CHICO",
      "Zip Code": " 95928",
      "County": " BUTTE",
      "Latitude": "39.7270240  ",
      "Longitude": " -121.80306 "
   },
   {
      "Vendor": "COLLINS AND DENNY MARKET",
      "Address": " 434 PLUMAS AVE",
      "City": "OROVILLE",
      "Zip Code": " 95965",
      "County": " BUTTE",
      "Latitude": "39.5207540  ",
      "Longitude": " -121.57441 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1575",
      "Address": " 465 CAL OAK RD",
      "City": "OROVILLE",
      "Zip Code": " 95965",
      "County": " BUTTE",
      "Latitude": "39.4924610  ",
      "Longitude": " -121.56684 "
   },
   {
      "Vendor": "SMART & FINAL #808",
      "Address": "E 355 ORO DAM BLVD",
      "Second Address": " STE A",
      "City": "OROVILLE",
      "Zip Code": " 95966",
      "County": " BUTTE",
      "Latitude": "39.4977180  ",
      "Longitude": " -121.57384 "
   },
   {
      "Vendor": "BIG TREES MARKET",
      "Address": " 2182 HIGHWAY 4",
      "City": "ARNOLD",
      "Zip Code": " 95223",
      "County": " CALAVERAS",
      "Latitude": "38.2388880  ",
      "Longitude": " -120.36451 "
   },
   {
      "Vendor": "SENDER'S MARKET",
      "Address": " 8111 GARABALDI ST",
      "City": "MOUNTAIN RANCH",
      "Zip Code": " 95246",
      "County": " CALAVERAS",
      "Latitude": "38.2287650  ",
      "Longitude": " -120.54141 "
   },
   {
      "Vendor": "TREAT'S GENERAL STORE",
      "Address": "E 197 ST. CHARLES ST",
      "City": "SAN ANDREAS",
      "Zip Code": " 95249",
      "County": " CALAVERAS",
      "Latitude": "38.1943980  ",
      "Longitude": " -120.67724 "
   },
   {
      "Vendor": "SAVE MART #046",
      "Address": "S 260 MAIN ST",
      "City": "ANGELS CAMP",
      "Zip Code": " 95222",
      "County": " CALAVERAS",
      "Latitude": "38.0799620  ",
      "Longitude": " -120.55528 "
   },
   {
      "Vendor": "MAR-VAL FOOD STORE #4",
      "Address": " 55 HIGHWAY 26",
      "City": "VALLEY SPRINGS",
      "Zip Code": " 95252",
      "County": " CALAVERAS",
      "Latitude": "38.2604780  ",
      "Longitude": " -120.74269 "
   },
   {
      "Vendor": "PAYLESS IGA MARKET #3",
      "Address": " 3505 SPANGLER LN",
      "City": "COPPEROPOLIS",
      "Zip Code": " 95228",
      "County": " CALAVERAS",
      "Latitude": "37.9380690  ",
      "Longitude": " -120.60415 "
   },
   {
      "Vendor": "SAV MOR FOODS #31",
      "Address": " 1017 BRIDGE ST",
      "City": "COLUSA",
      "Zip Code": " 95932",
      "County": " COLUSA",
      "Latitude": "39.2043870  ",
      "Longitude": " -122.00274 "
   },
   {
      "Vendor": "SHOP & SAVE MARKET",
      "Address": " 421 7TH ST",
      "City": "WILLIAMS",
      "Zip Code": " 95987",
      "County": " COLUSA",
      "Latitude": "39.1556960  ",
      "Longitude": " -122.14995 "
   },
   {
      "Vendor": "EL TORO LOCO #2",
      "Address": " 757 E ST",
      "City": "WILLIAMS",
      "Zip Code": " 95987",
      "County": " COLUSA",
      "Latitude": "39.1540500  ",
      "Longitude": " -122.15045 "
   },
   {
      "Vendor": "ARBUCKLE FOOD CENTER",
      "Address": " 575 AMANDA ST",
      "City": "ARBUCKLE",
      "Zip Code": " 95912",
      "County": " COLUSA",
      "Latitude": "39.0163440  ",
      "Longitude": " -122.05765 "
   },
   {
      "Vendor": "ROY'S SUPERMARKET",
      "Address": " 933 E ST",
      "City": "WILLIAMS",
      "Zip Code": " 95987",
      "County": " COLUSA",
      "Latitude": "39.1532510  ",
      "Longitude": " -122.15227 "
   },
   {
      "Vendor": "RALEY'S #422",
      "Address": " 166 PLACERVILLE DR",
      "City": "PLACERVILLE",
      "Zip Code": " 95667",
      "County": " EL DORADO",
      "Latitude": "38.7269490  ",
      "Longitude": " -120.83552 "
   },
   {
      "Vendor": "SAFEWAY #1825",
      "Address": " 6498 PONY EXPRESS TRAIL",
      "City": "POLLOCK PINES",
      "Zip Code": " 95726",
      "County": " EL DORADO",
      "Latitude": "38.7623470  ",
      "Longitude": " -120.57692 "
   },
   {
      "Vendor": "SAFEWAY #1824",
      "Address": " 1020 JOHNSON LN",
      "City": "SOUTH LAKE TAHOE",
      "Zip Code": " 96150",
      "County": " EL DORADO",
      "Latitude": "38.9441840  ",
      "Longitude": " -119.96741 "
   },
   {
      "Vendor": "RALEY'S #119",
      "Address": " 4000 LAKE TAHOE BLVD",
      "Second Address": " STE 6",
      "City": "SOUTH LAKE TAHOE",
      "Zip Code": " 96150",
      "County": " EL DORADO",
      "Latitude": "38.9550310  ",
      "Longitude": " -119.94458 "
   },
   {
      "Vendor": "RALEY'S #127",
      "Address": " 1040 EMERALD BAY RD",
      "City": "SOUTH LAKE TAHOE",
      "Zip Code": " 96150",
      "County": " EL DORADO",
      "Latitude": "38.9124820  ",
      "Longitude": " -120.00438 "
   },
   {
      "Vendor": "SAFEWAY #1618",
      "Address": " 3380 COACH LN",
      "City": "CAMERON PARK",
      "Zip Code": " 95682",
      "County": " EL DORADO",
      "Latitude": "38.6565740  ",
      "Longitude": " -120.97101 "
   },
   {
      "Vendor": "MAR-VAL FOOD STORE #6",
      "Address": " 6049 FRONT ST",
      "City": "GEORGETOWN",
      "Zip Code": " 95634",
      "County": " EL DORADO",
      "Latitude": "38.9091620  ",
      "Longitude": " -120.85161 "
   },
   {
      "Vendor": "BEL AIR MARKET #515",
      "Address": " 3510 PALMER DR",
      "City": "CAMERON PARK",
      "Zip Code": " 95682",
      "County": " EL DORADO",
      "Latitude": "38.6611640  ",
      "Longitude": " -120.96694 "
   },
   {
      "Vendor": "RALEY'S #424",
      "Address": " 3935A PARK RD",
      "City": "EL DORADO HILLS",
      "Zip Code": " 95762",
      "County": " EL DORADO",
      "Latitude": "38.6556880  ",
      "Longitude": " -121.06981 "
   },
   {
      "Vendor": "HOLIDAY QUALITY FOODS #57",
      "Address": " 4653 MT AUKUM ROAD",
      "City": "PLACERVILLE",
      "Zip Code": " 95667",
      "County": " EL DORADO",
      "Latitude": "38.6821660  ",
      "Longitude": " -120.66139 "
   },
   {
      "Vendor": "FOOD 4 LESS CAMERON PARK #21",
      "Address": " 3333 COACH LANE",
      "City": "CAMERON PARK",
      "Zip Code": " 95682",
      "County": " EL DORADO",
      "Latitude": "38.6586680  ",
      "Longitude": " -120.97174 "
   },
   {
      "Vendor": "SAFEWAY #1724",
      "Address": " 3955 MISSOURI FLAT RD",
      "City": "PLACERVILLE",
      "Zip Code": " 95667",
      "County": " EL DORADO",
      "Latitude": "38.7137920  ",
      "Longitude": " -120.84020 "
   },
   {
      "Vendor": "SAVE MART #614",
      "Address": " 1270 BROADWAY",
      "City": "PLACERVILLE",
      "Zip Code": " 95667",
      "County": " EL DORADO",
      "Latitude": "38.7309330  ",
      "Longitude": " -120.78461 "
   },
   {
      "Vendor": "SAVE MART #615",
      "Address": " 3966 MISSOURI FLAT RD",
      "Second Address": " STE A",
      "City": "PLACERVILLE",
      "Zip Code": " 95667",
      "County": " EL DORADO",
      "Latitude": "38.7122580  ",
      "Longitude": " -120.84109 "
   },
   {
      "Vendor": "SAFEWAY #2683",
      "Address": " 2207 FRANCISCO DR",
      "City": "EL DORADO HILLS",
      "Zip Code": " 95762",
      "County": " EL DORADO",
      "Latitude": "38.7104250  ",
      "Longitude": " -121.08273 "
   },
   {
      "Vendor": "NUGGET MARKET #09",
      "Address": " 4500 POST ST",
      "City": "EL DORADO HILLS",
      "Zip Code": " 95762",
      "County": " EL DORADO",
      "Latitude": "38.6525740  ",
      "Longitude": " -121.06717 "
   },
   {
      "Vendor": "TARGET STORE T-2270",
      "Address": " 4400 TOWN CENTER BLVD",
      "City": "EL DORADO HILLS",
      "Zip Code": " 95762",
      "County": " EL DORADO",
      "Latitude": "38.6513710  ",
      "Longitude": " -121.06375 "
   },
   {
      "Vendor": "WAL-MART STORE #2418",
      "Address": " 4300 MISSOURI FLAT RD",
      "City": "PLACERVILLE",
      "Zip Code": " 95667",
      "County": " EL DORADO",
      "Latitude": "38.7057090  ",
      "Longitude": " -120.83006 "
   },
   {
      "Vendor": "PLAZA TAPATIA",
      "Address": " 3564 LAKE TAHOE BLVD",
      "Second Address": " UNIT C",
      "City": "SOUTH LAKE TAHOE",
      "Zip Code": " 96150",
      "County": " EL DORADO",
      "Latitude": "38.9468020  ",
      "Longitude": " -119.96087 "
   },
   {
      "Vendor": "SMART & FINAL #787",
      "Address": " 2061 LAKE TAHOE BLVD",
      "City": "SOUTH LAKE TAHOE",
      "Zip Code": " 96150",
      "County": " EL DORADO",
      "Latitude": "38.9149220  ",
      "Longitude": " -120.00285 "
   },
   {
      "Vendor": "A MART",
      "Address": "N 115 SEVENTH ST",
      "City": "FOWLER",
      "Zip Code": " 93625",
      "County": " FRESNO",
      "Latitude": "36.6303980  ",
      "Longitude": " -119.68021 "
   },
   {
      "Vendor": "GONG'S MARKET - SOUTHGATE",
      "Address": " 1825 ACADEMY AVE",
      "City": "SANGER",
      "Zip Code": " 93657",
      "County": " FRESNO",
      "Latitude": "36.6913980  ",
      "Longitude": " -119.55431 "
   },
   {
      "Vendor": "SAVE MART #027",
      "Address": "E 1580 MANNING AVE",
      "City": "REEDLEY",
      "Zip Code": " 93654",
      "County": " FRESNO",
      "Latitude": "36.6058120  ",
      "Longitude": " -119.43208 "
   },
   {
      "Vendor": "KINGSBURG SUPER MARKET",
      "Address": " 1367 MARION ST",
      "City": "KINGSBURG",
      "Zip Code": " 93631",
      "County": " FRESNO",
      "Latitude": "36.5133640  ",
      "Longitude": " -119.55133 "
   },
   {
      "Vendor": "VALLEY FOOD SUPER CENTER",
      "Address": "W 15057 WHITESBRIDGE AVE",
      "City": "KERMAN",
      "Zip Code": " 93630",
      "County": " FRESNO",
      "Latitude": "36.7347440  ",
      "Longitude": " -120.06100 "
   },
   {
      "Vendor": "SAVE MART #019",
      "Address": "E 4041 ASHLAN AVE",
      "City": "FRESNO",
      "Zip Code": " 93726",
      "County": " FRESNO",
      "Latitude": "36.7950790  ",
      "Longitude": " -119.75653 "
   },
   {
      "Vendor": "VONS #1754",
      "Address": "E 5638 KINGS CANYON RD",
      "City": "FRESNO",
      "Zip Code": " 93727",
      "County": " FRESNO",
      "Latitude": "36.7345330  ",
      "Longitude": " -119.69842 "
   },
   {
      "Vendor": "SAVE MART #054",
      "Address": "W 2066 BULLARD AVE",
      "City": "FRESNO",
      "Zip Code": " 93711",
      "County": " FRESNO",
      "Latitude": "36.8229570  ",
      "Longitude": " -119.82849 "
   },
   {
      "Vendor": "SAVE MART #052",
      "Address": " 2179 SHAW AVE",
      "City": "CLOVIS",
      "Zip Code": " 93611",
      "County": " FRESNO",
      "Latitude": "36.8099280  ",
      "Longitude": " -119.67372 "
   },
   {
      "Vendor": "SAVE MART #058",
      "Address": " 2859 WHITSON ST",
      "City": "SELMA",
      "Zip Code": " 93662",
      "County": " FRESNO",
      "Latitude": "36.5743870  ",
      "Longitude": " -119.62543 "
   },
   {
      "Vendor": "R-N MARKET",
      "Address": "N 6670 CEDAR AVE",
      "City": "FRESNO",
      "Zip Code": " 93710",
      "County": " FRESNO",
      "Latitude": "36.8352390  ",
      "Longitude": " -119.75339 "
   },
   {
      "Vendor": "SAVE MART #065",
      "Address": "N 7075 MARKS AVE",
      "City": "FRESNO",
      "Zip Code": " 93711",
      "County": " FRESNO",
      "Latitude": "36.8384020  ",
      "Longitude": " -119.84897 "
   },
   {
      "Vendor": "FOOD MAXX #403",
      "Address": "W 3241 SHAW AVE",
      "City": "FRESNO",
      "Zip Code": " 93711",
      "County": " FRESNO",
      "Latitude": "36.8068480  ",
      "Longitude": " -119.84996 "
   },
   {
      "Vendor": "CHOICE FOOD MARKET",
      "Address": "W 2106 OLIVE ST",
      "City": "FRESNO",
      "Zip Code": " 93728",
      "County": " FRESNO",
      "Latitude": "36.7577640  ",
      "Longitude": " -119.83601 "
   },
   {
      "Vendor": "SAVE MART #071",
      "Address": "E 659 NEES AVE",
      "City": "FRESNO",
      "Zip Code": " 93720",
      "County": " FRESNO",
      "Latitude": "36.8509450  ",
      "Longitude": " -119.77357 "
   },
   {
      "Vendor": "VONS #2188",
      "Address": "N 8949 CEDAR AVE",
      "City": "FRESNO",
      "Zip Code": " 93720",
      "County": " FRESNO",
      "Latitude": "36.8656640  ",
      "Longitude": " -119.75707 "
   },
   {
      "Vendor": "SAVE MART #078",
      "Address": "E 1107 CHAMPLAIN DR",
      "City": "FRESNO",
      "Zip Code": " 93720",
      "County": " FRESNO",
      "Latitude": "36.8707910  ",
      "Longitude": " -119.76493 "
   },
   {
      "Vendor": "FOOD MAXX #414",
      "Address": "N 5422 BLACKSTONE AVE",
      "City": "FRESNO",
      "Zip Code": " 93710",
      "County": " FRESNO",
      "Latitude": "36.8167500  ",
      "Longitude": " -119.79008 "
   },
   {
      "Vendor": "R-N MARKET",
      "Address": "E 13639 MANNING AVE",
      "City": "PARLIER",
      "Zip Code": " 93648",
      "County": " FRESNO",
      "Latitude": "36.6038930  ",
      "Longitude": " -119.54652 "
   },
   {
      "Vendor": "FOOD 4 LESS",
      "Address": " 2819 HIGHLAND AVE",
      "City": "SELMA",
      "Zip Code": " 93662",
      "County": " FRESNO",
      "Latitude": "36.5753700  ",
      "Longitude": " -119.62959 "
   },
   {
      "Vendor": "BIG POTATO MARKET",
      "Address": "S 6947 ELM AVE",
      "City": "FRESNO",
      "Zip Code": " 93706",
      "County": " FRESNO",
      "Latitude": "36.6350020  ",
      "Longitude": " -119.79084 "
   },
   {
      "Vendor": "VONS #1756",
      "Address": " 1650 HERNDON AVE",
      "City": "CLOVIS",
      "Zip Code": " 93611",
      "County": " FRESNO",
      "Latitude": "36.8357950  ",
      "Longitude": " -119.68504 "
   },
   {
      "Vendor": "FOODS CO #316",
      "Address": "E 4838 KINGS CANYON RD",
      "City": "FRESNO",
      "Zip Code": " 93727",
      "County": " FRESNO",
      "Latitude": "36.7346170  ",
      "Longitude": " -119.73494 "
   },
   {
      "Vendor": "ALFA & OMEGA NUTRITIONAL PR",
      "Address": "N 546 FRESNO ST",
      "City": "PARLIER",
      "Zip Code": " 93648",
      "County": " FRESNO",
      "Latitude": "36.6110570  ",
      "Longitude": " -119.52513 "
   },
   {
      "Vendor": "FRESNO COMMUNITY MARKET #2",
      "Address": "N 178 BLACKSTONE AVE",
      "City": "FRESNO",
      "Zip Code": " 93701",
      "County": " FRESNO",
      "Latitude": "36.7448690  ",
      "Longitude": " -119.79029 "
   },
   {
      "Vendor": "SAVE MART #087",
      "Address": "N 1157 WILLOW AVE",
      "City": "CLOVIS",
      "Zip Code": " 93611",
      "County": " FRESNO",
      "Latitude": "36.8509800  ",
      "Longitude": " -119.72847 "
   },
   {
      "Vendor": "VONS #2701",
      "Address": " 3100 FOWLER AVE",
      "City": "CLOVIS",
      "Zip Code": " 93611",
      "County": " FRESNO",
      "Latitude": "36.7954600  ",
      "Longitude": " -119.68375 "
   },
   {
      "Vendor": "LA ESTRELLA MARKET #3",
      "Address": " 2345 WHITSON ST",
      "City": "SELMA",
      "Zip Code": " 93662",
      "County": " FRESNO",
      "Latitude": "36.5709400  ",
      "Longitude": " -119.61920 "
   },
   {
      "Vendor": "FOODS CO #784",
      "Address": "W 3657 SHAW AVE",
      "City": "FRESNO",
      "Zip Code": " 93711",
      "County": " FRESNO",
      "Latitude": "36.8079410  ",
      "Longitude": " -119.85903 "
   },
   {
      "Vendor": "LOS AMIGOS FAMILY FOOD CENT",
      "Address": " 8676 8TH ST",
      "City": "SAN JOAQUIN",
      "Zip Code": " 93660",
      "County": " FRESNO",
      "Latitude": "36.6084460  ",
      "Longitude": " -120.18864 "
   },
   {
      "Vendor": "FOOD MAXX #459",
      "Address": " 1355 SHAW AVE",
      "City": "CLOVIS",
      "Zip Code": " 93612",
      "County": " FRESNO",
      "Latitude": "36.8086710  ",
      "Longitude": " -119.69148 "
   },
   {
      "Vendor": "FOOD MAXX #456",
      "Address": " 1177 FRESNO ST",
      "City": "FRESNO",
      "Zip Code": " 93706",
      "County": " FRESNO",
      "Latitude": "36.7318460  ",
      "Longitude": " -119.80191 "
   },
   {
      "Vendor": "MAR-VAL FOOD STORE #7",
      "Address": " 29424 AUBERRY RD",
      "Second Address": " UNIT 125",
      "City": "PRATHER",
      "Zip Code": " 93651",
      "County": " FRESNO",
      "Latitude": "37.0379310  ",
      "Longitude": " -119.51666 "
   },
   {
      "Vendor": "FOODS CO #339",
      "Address": "E 3053 SHIELDS AVE",
      "City": "FRESNO",
      "Zip Code": " 93726",
      "County": " FRESNO",
      "Latitude": "36.7797550  ",
      "Longitude": " -119.77378 "
   },
   {
      "Vendor": "SAVE MART #092",
      "Address": "N 4120 WEST AVE",
      "City": "FRESNO",
      "Zip Code": " 93705",
      "County": " FRESNO",
      "Latitude": "36.7914500  ",
      "Longitude": " -119.82620 "
   },
   {
      "Vendor": "WINCO FOODS #59",
      "Address": "W 4488 SHAW AVE",
      "City": "FRESNO",
      "Zip Code": " 93722",
      "County": " FRESNO",
      "Latitude": "36.8112940  ",
      "Longitude": " -119.87276 "
   },
   {
      "Vendor": "SAVE MART #098",
      "Address": " 1835 HERNDON AVE",
      "City": "CLOVIS",
      "Zip Code": " 93611",
      "County": " FRESNO",
      "Latitude": "36.8386410  ",
      "Longitude": " -119.68241 "
   },
   {
      "Vendor": "SAVE MART #093",
      "Address": "N 6797 MILBURN AVE",
      "City": "FRESNO",
      "Zip Code": " 93722",
      "County": " FRESNO",
      "Latitude": "36.8362520  ",
      "Longitude": " -119.88113 "
   },
   {
      "Vendor": "SAVE MART #088",
      "Address": "W 275 FOREST AVE",
      "City": "COALINGA",
      "Zip Code": " 93210",
      "County": " FRESNO",
      "Latitude": "36.1351970  ",
      "Longitude": " -120.36065 "
   },
   {
      "Vendor": "SAVE MART #650",
      "Address": "W 4043 CLINTON AVE",
      "City": "FRESNO",
      "Zip Code": " 93722",
      "County": " FRESNO",
      "Latitude": "36.7716870  ",
      "Longitude": " -119.86338 "
   },
   {
      "Vendor": "SAVE MART #651",
      "Address": "N 5750 FIRST ST",
      "City": "FRESNO",
      "Zip Code": " 93710",
      "County": " FRESNO",
      "Latitude": "36.8222090  ",
      "Longitude": " -119.77148 "
   },
   {
      "Vendor": "SAVE MART #654",
      "Address": " 909 SIERRA ST",
      "City": "KINGSBURG",
      "Zip Code": " 93631",
      "County": " FRESNO",
      "Latitude": "36.5181900  ",
      "Longitude": " -119.55779 "
   },
   {
      "Vendor": "FIESTA LATINO MARKET",
      "Address": " 1611 N ST",
      "City": "FIREBAUGH",
      "Zip Code": " 93622",
      "County": " FRESNO",
      "Latitude": "36.8526750  ",
      "Longitude": " -120.45155 "
   },
   {
      "Vendor": "VENTURA SUPER MARKET",
      "Address": "E 3232 VENTURA AVE",
      "City": "FRESNO",
      "Zip Code": " 93702",
      "County": " FRESNO",
      "Latitude": "36.7349900  ",
      "Longitude": " -119.77009 "
   },
   {
      "Vendor": "FOOD 4 LESS",
      "Address": "N 8921 CHESTNUT AVE",
      "City": "FRESNO",
      "Zip Code": " 93720",
      "County": " FRESNO",
      "Latitude": "36.8651020  ",
      "Longitude": " -119.73986 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #10",
      "Address": "E 4831 BUTLER AVE",
      "City": "FRESNO",
      "Zip Code": " 93727",
      "County": " FRESNO",
      "Latitude": "36.7288740  ",
      "Longitude": " -119.73505 "
   },
   {
      "Vendor": "LUCKY MARKET",
      "Address": "S 2419 ELM AVE",
      "City": "FRESNO",
      "Zip Code": " 93706",
      "County": " FRESNO",
      "Latitude": "36.7134960  ",
      "Longitude": " -119.79048 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #4238",
      "Address": " 2761 JENSEN AVE",
      "City": "SANGER",
      "Zip Code": " 93657",
      "County": " FRESNO",
      "Latitude": "36.7064880  ",
      "Longitude": " -119.57707 "
   },
   {
      "Vendor": "TRANQUILLITY MARKET",
      "Address": " 5789 ANTHONY AVE",
      "City": "TRANQUILLITY",
      "Zip Code": " 93668",
      "County": " FRESNO",
      "Latitude": "36.6496790  ",
      "Longitude": " -120.25244 "
   },
   {
      "Vendor": "EL PROVINCIANO",
      "Address": "W 1808 CLINTON AVE",
      "City": "FRESNO",
      "Zip Code": " 93705",
      "County": " FRESNO",
      "Latitude": "36.7722090  ",
      "Longitude": " -119.83254 "
   },
   {
      "Vendor": "ASIA SUPERMARKET",
      "Address": "E 4818 TULARE AVE",
      "City": "FRESNO",
      "Zip Code": " 93727",
      "County": " FRESNO",
      "Latitude": "36.7426560  ",
      "Longitude": " -119.73565 "
   },
   {
      "Vendor": "CITY WIDE MARKET",
      "Address": "W 505 DAKOTA AVE",
      "City": "FRESNO",
      "Zip Code": " 93705",
      "County": " FRESNO",
      "Latitude": "36.7864190  ",
      "Longitude": " -119.81775 "
   },
   {
      "Vendor": "BELMONT MARKET",
      "Address": "E 4492 BELMONT AVE",
      "City": "FRESNO",
      "Zip Code": " 93702",
      "County": " FRESNO",
      "Latitude": "36.7501290  ",
      "Longitude": " -119.75010 "
   },
   {
      "Vendor": "FOOD MAXX #499",
      "Address": "E 5671 KINGS CANYON RD",
      "City": "FRESNO",
      "Zip Code": " 93727",
      "County": " FRESNO",
      "Latitude": "36.7369100  ",
      "Longitude": " -119.69622 "
   },
   {
      "Vendor": "EL CAMPESINO MEAT MARKET",
      "Address": "E 245 WHITESBRIDGE AVE",
      "City": "FRESNO",
      "Zip Code": " 93706",
      "County": " FRESNO",
      "Latitude": "36.7361990  ",
      "Longitude": " -119.80910 "
   },
   {
      "Vendor": "QUICK SHOP",
      "Address": " 825 ANNADALE AVE",
      "City": "SANGER",
      "Zip Code": " 93657",
      "County": " FRESNO",
      "Latitude": "36.6992190  ",
      "Longitude": " -119.54840 "
   },
   {
      "Vendor": "HAPPY MARKET",
      "Address": "E 4605 SHIELDS AVE",
      "City": "FRESNO",
      "Zip Code": " 93726",
      "County": " FRESNO",
      "Latitude": "36.7798030  ",
      "Longitude": " -119.74499 "
   },
   {
      "Vendor": "R & S MINI MART",
      "Address": "N 1334 FIRST ST",
      "City": "FRESNO",
      "Zip Code": " 93703",
      "County": " FRESNO",
      "Latitude": "36.7602170  ",
      "Longitude": " -119.77215 "
   },
   {
      "Vendor": "TOWER MARKET AND DELI",
      "Address": "N 1233 VAN NESS AVE",
      "City": "FRESNO",
      "Zip Code": " 93728",
      "County": " FRESNO",
      "Latitude": "36.7584840  ",
      "Longitude": " -119.79929 "
   },
   {
      "Vendor": "PRIMO MARKET",
      "Address": " 409 PARK BLVD",
      "City": "ORANGE COVE",
      "Zip Code": " 93646",
      "County": " FRESNO",
      "Latitude": "36.6244380  ",
      "Longitude": " -119.31011 "
   },
   {
      "Vendor": "SMART & FINAL #328",
      "Address": " 631 H ST",
      "City": "FRESNO",
      "Zip Code": " 93721",
      "County": " FRESNO",
      "Latitude": "36.7288030  ",
      "Longitude": " -119.78838 "
   },
   {
      "Vendor": "SMART & FINAL #449",
      "Address": "W 3330 SHAW AVE",
      "City": "FRESNO",
      "Zip Code": " 93711",
      "County": " FRESNO",
      "Latitude": "36.8096730  ",
      "Longitude": " -119.85173 "
   },
   {
      "Vendor": "SMART & FINAL #329",
      "Address": "N 5700 BLACKSTONE AVE",
      "City": "FRESNO",
      "Zip Code": " 93710",
      "County": " FRESNO",
      "Latitude": "36.8218930  ",
      "Longitude": " -119.79003 "
   },
   {
      "Vendor": "FIESTA LATINO",
      "Address": "S 36869 LASSEN AVE",
      "City": "HURON",
      "Zip Code": " 93234",
      "County": " FRESNO",
      "Latitude": "36.1978590  ",
      "Longitude": " -120.10378 "
   },
   {
      "Vendor": "A & M WESTSIDE MARKET",
      "Address": "E 10 WHITESBRIDGE AVE",
      "City": "FRESNO",
      "Zip Code": " 93706",
      "County": " FRESNO",
      "Latitude": "36.7356430  ",
      "Longitude": " -119.81259 "
   },
   {
      "Vendor": "FAIR PRICE FOOD STORE",
      "Address": "N 3805 HUGHES AVE",
      "City": "FRESNO",
      "Zip Code": " 93705",
      "County": " FRESNO",
      "Latitude": "36.7868670  ",
      "Longitude": " -119.83574 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #29",
      "Address": "N 3850 CEDAR AVE",
      "City": "FRESNO",
      "Zip Code": " 93726",
      "County": " FRESNO",
      "Latitude": "36.7873850  ",
      "Longitude": " -119.75288 "
   },
   {
      "Vendor": "WINCO FOODS #69",
      "Address": "S 1004 PEACH AVE",
      "City": "FRESNO",
      "Zip Code": " 93727",
      "County": " FRESNO",
      "Latitude": "36.7341010  ",
      "Longitude": " -119.71886 "
   },
   {
      "Vendor": "MENDOTA VALLEY FOOD",
      "Address": " 1840 7TH ST",
      "City": "MENDOTA",
      "Zip Code": " 93640",
      "County": " FRESNO",
      "Latitude": "36.7527300  ",
      "Longitude": " -120.38348 "
   },
   {
      "Vendor": "DISCOUNT MARKET",
      "Address": "E 3985 JENSEN AVE",
      "City": "FRESNO",
      "Zip Code": " 93725",
      "County": " FRESNO",
      "Latitude": "36.7070990  ",
      "Longitude": " -119.75745 "
   },
   {
      "Vendor": "ANGELITOS NUTRITION",
      "Address": "E 4787 KINGS CANYON RD",
      "Second Address": " STE 102",
      "City": "FRESNO",
      "Zip Code": " 93702",
      "County": " FRESNO",
      "Latitude": "36.7361940  ",
      "Longitude": " -119.73709 "
   },
   {
      "Vendor": "EL SUPER #33",
      "Address": "E 3190 TULARE ST",
      "City": "FRESNO",
      "Zip Code": " 93702",
      "County": " FRESNO",
      "Latitude": "36.7426100  ",
      "Longitude": " -119.77077 "
   },
   {
      "Vendor": "LOS AMIGOS FOOD CENTER #9",
      "Address": "S 36210 LASSEN AVE",
      "City": "HURON",
      "Zip Code": " 93234",
      "County": " FRESNO",
      "Latitude": "36.2094350  ",
      "Longitude": " -120.10359 "
   },
   {
      "Vendor": "ZACK'S MARKET",
      "Address": "E 854 CALIFORNIA AVE",
      "City": "FRESNO",
      "Zip Code": " 93706",
      "County": " FRESNO",
      "Latitude": "36.7209650  ",
      "Longitude": " -119.80025 "
   },
   {
      "Vendor": "BABY SHOP #1",
      "Address": "E 4995 KINGS CANYON RD",
      "City": "FRESNO",
      "Zip Code": " 93727",
      "County": " FRESNO",
      "Latitude": "36.7360900  ",
      "Longitude": " -119.72773 "
   },
   {
      "Vendor": "QUICKEROO #550",
      "Address": " 567 OLLER ST",
      "City": "MENDOTA",
      "Zip Code": " 93640",
      "County": " FRESNO",
      "Latitude": "36.7564030  ",
      "Longitude": " -120.38123 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2277",
      "Address": "W 323 SHAW AVE",
      "City": "CLOVIS",
      "Zip Code": " 93612",
      "County": " FRESNO",
      "Latitude": "36.8087480  ",
      "Longitude": " -119.71663 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1882",
      "Address": " 3400 FLORA AVE",
      "City": "SELMA",
      "Zip Code": " 93662",
      "County": " FRESNO",
      "Latitude": "36.5765570  ",
      "Longitude": " -119.63403 "
   },
   {
      "Vendor": "PRIMO MINI MART",
      "Address": "E 4692 SHIELDS AVE",
      "City": "FRESNO",
      "Zip Code": " 93726",
      "County": " FRESNO",
      "Latitude": "36.7792310  ",
      "Longitude": " -119.74114 "
   },
   {
      "Vendor": "FIRST STEP NUTRITION #4",
      "Address": "N 1529 DINUBA BLVD",
      "City": "VISALIA",
      "Zip Code": " 93291",
      "County": " TULARE",
      "Latitude": "36.3432570  ",
      "Longitude": " -119.29710 "
   },
   {
      "Vendor": "QUICKEROO #544",
      "Address": "S 5751 ELM AVE",
      "Second Address": " UNIT C",
      "City": "FRESNO",
      "Zip Code": " 93706",
      "County": " FRESNO",
      "Latitude": "36.6520130  ",
      "Longitude": " -119.79137 "
   },
   {
      "Vendor": "QUICKEROO #548",
      "Address": "W 1444 ASHLAN AVE",
      "City": "FRESNO",
      "Zip Code": " 93705",
      "County": " FRESNO",
      "Latitude": "36.7940750  ",
      "Longitude": " -119.82770 "
   },
   {
      "Vendor": "QUICKEROO #551",
      "Address": " 1014 FRESNO ST",
      "Second Address": " STE 106",
      "City": "FRESNO",
      "Zip Code": " 93706",
      "County": " FRESNO",
      "Latitude": "36.7286880  ",
      "Longitude": " -119.80178 "
   },
   {
      "Vendor": "QUICKEROO #545",
      "Address": "E 4809 KINGS CANYON RD",
      "City": "FRESNO",
      "Zip Code": " 93727",
      "County": " FRESNO",
      "Latitude": "36.7362500  ",
      "Longitude": " -119.73602 "
   },
   {
      "Vendor": "LOS AMIGOS MARKET",
      "Address": " 600 PARK BLVD",
      "City": "ORANGE COVE",
      "Zip Code": " 93646",
      "County": " FRESNO",
      "Latitude": "36.6248970  ",
      "Longitude": " -119.31264 "
   },
   {
      "Vendor": "QUIK FOODS & U-BAKE PIZZA",
      "Address": "E 4204 OLIVE AVE",
      "City": "FRESNO",
      "Zip Code": " 93702",
      "County": " FRESNO",
      "Latitude": "36.7574960  ",
      "Longitude": " -119.75412 "
   },
   {
      "Vendor": "TARGET STORE T-0911",
      "Address": "N 7600 BLACKSTONE AVE",
      "City": "FRESNO",
      "Zip Code": " 93720",
      "County": " FRESNO",
      "Latitude": "36.8457610  ",
      "Longitude": " -119.79030 "
   },
   {
      "Vendor": "TARGET STORE T-2018",
      "Address": "W 695 HERNDON AVE",
      "City": "CLOVIS",
      "Zip Code": " 93612",
      "County": " FRESNO",
      "Latitude": "36.8378450  ",
      "Longitude": " -119.72595 "
   },
   {
      "Vendor": "UNITED MARKET",
      "Address": " 3736 MCCALL AVE",
      "City": "SELMA",
      "Zip Code": " 93662",
      "County": " FRESNO",
      "Latitude": "36.5889100  ",
      "Longitude": " -119.60957 "
   },
   {
      "Vendor": "QUICKEROO #559",
      "Address": "N 2478 MARKS AVE",
      "Second Address": " STE A",
      "City": "FRESNO",
      "Zip Code": " 93722",
      "County": " FRESNO",
      "Latitude": "36.7733650  ",
      "Longitude": " -119.84405 "
   },
   {
      "Vendor": "QUICKEROO #557",
      "Address": "E 3604 BUTLER AVE",
      "Second Address": " STE 102",
      "City": "FRESNO",
      "Zip Code": " 93702",
      "County": " FRESNO",
      "Latitude": "36.7282430  ",
      "Longitude": " -119.76333 "
   },
   {
      "Vendor": "QUICKEROO #558",
      "Address": "E 64 HERNDON AVE",
      "City": "FRESNO",
      "Zip Code": " 93720",
      "County": " FRESNO",
      "Latitude": "36.8386740  ",
      "Longitude": " -119.78875 "
   },
   {
      "Vendor": "QUICKEROO #546",
      "Address": "E 3122 VENTURA AVE",
      "City": "FRESNO",
      "Zip Code": " 93702",
      "County": " FRESNO",
      "Latitude": "36.7354180  ",
      "Longitude": " -119.77207 "
   },
   {
      "Vendor": "QUICKEROO #554",
      "Address": "S 692 MADERA AVE",
      "City": "KERMAN",
      "Zip Code": " 93630",
      "County": " FRESNO",
      "Latitude": "36.7246720  ",
      "Longitude": " -120.05999 "
   },
   {
      "Vendor": "WAL-MART STORE #2985",
      "Address": "N 7065 INGRAM AVE",
      "City": "FRESNO",
      "Zip Code": " 93650",
      "County": " FRESNO",
      "Latitude": "36.8376090  ",
      "Longitude": " -119.80236 "
   },
   {
      "Vendor": "T & V FOOD MARKET",
      "Address": "N 2306 FRESNO ST",
      "City": "FRESNO",
      "Zip Code": " 93703",
      "County": " FRESNO",
      "Latitude": "36.7714770  ",
      "Longitude": " -119.78130 "
   },
   {
      "Vendor": "FIREBAUGH SUPERMARKET",
      "Address": " 1125 N ST",
      "City": "FIREBAUGH",
      "Zip Code": " 93622",
      "County": " FRESNO",
      "Latitude": "36.8580400  ",
      "Longitude": " -120.45674 "
   },
   {
      "Vendor": "TARGET STORE T-0314",
      "Address": "E 3173 SHIELDS AVE",
      "City": "FRESNO",
      "Zip Code": " 93726",
      "County": " FRESNO",
      "Latitude": "36.7805750  ",
      "Longitude": " -119.77102 "
   },
   {
      "Vendor": "TARGET STORE T-1417",
      "Address": "N 5740 BLACKSTONE AVE",
      "City": "FRESNO",
      "Zip Code": " 93710",
      "County": " FRESNO",
      "Latitude": "36.8218260  ",
      "Longitude": " -119.79008 "
   },
   {
      "Vendor": "TARGET STORE T-0358",
      "Address": " 900 SHAW AVE",
      "City": "CLOVIS",
      "Zip Code": " 93612",
      "County": " FRESNO",
      "Latitude": "36.8071240  ",
      "Longitude": " -119.69881 "
   },
   {
      "Vendor": "WAL-MART STORE #2001",
      "Address": "E 5125 KINGS CANYON RD",
      "City": "FRESNO",
      "Zip Code": " 93727",
      "County": " FRESNO",
      "Latitude": "36.7380940  ",
      "Longitude": " -119.72153 "
   },
   {
      "Vendor": "QUICKEROO #566",
      "Address": " 3706 MCCALL AVE",
      "Second Address": " STE 110",
      "City": "SELMA",
      "Zip Code": " 93662",
      "County": " FRESNO",
      "Latitude": "36.5879640  ",
      "Longitude": " -119.60968 "
   },
   {
      "Vendor": "A.C. MARKET",
      "Address": " 1145 PARK BLVD",
      "City": "ORANGE COVE",
      "Zip Code": " 93646",
      "County": " FRESNO",
      "Latitude": "36.6242990  ",
      "Longitude": " -119.31974 "
   },
   {
      "Vendor": "WAL-MART #5633",
      "Address": " 1830 SHAW AVE",
      "City": "CLOVIS",
      "Zip Code": " 93611",
      "County": " FRESNO",
      "Latitude": "36.8083170  ",
      "Longitude": " -119.68058 "
   },
   {
      "Vendor": "WAL-MART #5337",
      "Address": " 1185 HERNDON AVE",
      "City": "CLOVIS",
      "Zip Code": " 93611",
      "County": " FRESNO",
      "Latitude": "36.8377400  ",
      "Longitude": " -119.69622 "
   },
   {
      "Vendor": "WAL-MART #5701",
      "Address": "W 14061 WHITESBRIDGE AVE",
      "City": "KERMAN",
      "Zip Code": " 93630",
      "County": " FRESNO",
      "Latitude": "36.7351640  ",
      "Longitude": " -120.06121 "
   },
   {
      "Vendor": "WAL-MART #5634",
      "Address": "N 6855 WILLOW AVE",
      "City": "FRESNO",
      "Zip Code": " 93710",
      "County": " FRESNO",
      "Latitude": "36.8359700  ",
      "Longitude": " -119.72985 "
   },
   {
      "Vendor": "MENDOTA FOOD CENTER",
      "Address": " 697 DERRICK AVE",
      "City": "MENDOTA",
      "Zip Code": " 93640",
      "County": " FRESNO",
      "Latitude": "36.7508950  ",
      "Longitude": " -120.38604 "
   },
   {
      "Vendor": "SAN JOAQUIN FOODLAND",
      "Address": "S 8712 MAIN ST",
      "City": "SAN JOAQUIN",
      "Zip Code": " 93660",
      "County": " FRESNO",
      "Latitude": "36.6076770  ",
      "Longitude": " -120.18576 "
   },
   {
      "Vendor": "FIRST STEP NUTRITION #9",
      "Address": " 2570 JENSEN AVE",
      "Second Address": " STE 116",
      "City": "SANGER",
      "Zip Code": " 93657",
      "County": " FRESNO",
      "Latitude": "36.7073080  ",
      "Longitude": " -119.57355 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5632",
      "Address": "E 1804 ASHLAN AVE",
      "City": "FRESNO",
      "Zip Code": " 93726",
      "County": " FRESNO",
      "Latitude": "36.7938430  ",
      "Longitude": " -119.78928 "
   },
   {
      "Vendor": "EL PUEBLO FOOD MARKET",
      "Address": "E 640 DINUBA AVE",
      "City": "REEDLEY",
      "Zip Code": " 93654",
      "County": " FRESNO",
      "Latitude": "36.5899350  ",
      "Longitude": " -119.44253 "
   },
   {
      "Vendor": "STATE FOODS SUPERMARKET",
      "Address": "S 21282 MARKS AVE",
      "City": "RIVERDALE",
      "Zip Code": " 93656",
      "County": " FRESNO",
      "Latitude": "36.4266590  ",
      "Longitude": " -119.85064 "
   },
   {
      "Vendor": "CARNICERIA COLIMA",
      "Address": "N 2303 CHESTNUT AVE",
      "City": "FRESNO",
      "Zip Code": " 93703",
      "County": " FRESNO",
      "Latitude": "36.7714960  ",
      "Longitude": " -119.73682 "
   },
   {
      "Vendor": "STATE FOODS SUPERMARKET",
      "Address": "S 553 NEWMARK AVE",
      "City": "PARLIER",
      "Zip Code": " 93648",
      "County": " FRESNO",
      "Latitude": "36.6107420  ",
      "Longitude": " -119.53086 "
   },
   {
      "Vendor": "GARCIA'S SUPERMARKET",
      "Address": "W 15040 WHITESBRIDGE AVE",
      "City": "KERMAN",
      "Zip Code": " 93630",
      "County": " FRESNO",
      "Latitude": "36.7359280  ",
      "Longitude": " -120.06169 "
   },
   {
      "Vendor": "WAL-MART NBRHD MARKET #2689",
      "Address": "N 3131 CEDAR AVE",
      "City": "FRESNO",
      "Zip Code": " 93703",
      "County": " FRESNO",
      "Latitude": "36.7783730  ",
      "Longitude": " -119.75596 "
   },
   {
      "Vendor": "STATE FOODS SUPERMARKET",
      "Address": " 237 ACADEMY AVE",
      "City": "SANGER",
      "Zip Code": " 93657",
      "County": " FRESNO",
      "Latitude": "36.7126710  ",
      "Longitude": " -119.55803 "
   },
   {
      "Vendor": "TARGET STORE T-2744",
      "Address": "N 6655 RIVERSIDE DR",
      "City": "FRESNO",
      "Zip Code": " 93722",
      "County": " FRESNO",
      "Latitude": "36.8344010  ",
      "Longitude": " -119.90906 "
   },
   {
      "Vendor": "TARGET STORE T-0275",
      "Address": "W 3150 SHAW AVE",
      "City": "FRESNO",
      "Zip Code": " 93711",
      "County": " FRESNO",
      "Latitude": "36.8085230  ",
      "Longitude": " -119.84776 "
   },
   {
      "Vendor": "AMIGOS MARKET",
      "Address": "E 3706 OLIVE AVE",
      "City": "FRESNO",
      "Zip Code": " 93702",
      "County": " FRESNO",
      "Latitude": "36.7575090  ",
      "Longitude": " -119.76326 "
   },
   {
      "Vendor": "SMART & FINAL #712",
      "Address": "N 2425 BLACKSTONE AVE",
      "City": "FRESNO",
      "Zip Code": " 93703",
      "County": " FRESNO",
      "Latitude": "36.7729500  ",
      "Longitude": " -119.79085 "
   },
   {
      "Vendor": "DULCERIA LA FIESTA",
      "Address": " 1042 OLLER ST",
      "City": "MENDOTA",
      "Zip Code": " 93640",
      "County": " FRESNO",
      "Latitude": "36.7513510  ",
      "Longitude": " -120.37642 "
   },
   {
      "Vendor": "AMIGOS FOOD MARKET",
      "Address": "E 4220 CHURCH AVE",
      "City": "FRESNO",
      "Zip Code": " 93725",
      "County": " FRESNO",
      "Latitude": "36.7135280  ",
      "Longitude": " -119.75413 "
   },
   {
      "Vendor": "BABY SHOP #3",
      "Address": " 1835 ASHLAN AVE",
      "Second Address": " STE 101",
      "City": "CLOVIS",
      "Zip Code": " 93611",
      "County": " FRESNO",
      "Latitude": "36.7943270  ",
      "Longitude": " -119.68104 "
   },
   {
      "Vendor": "FRESHCO FOOD CENTER",
      "Address": "W 3750 SHIELDS AVE",
      "City": "FRESNO",
      "Zip Code": " 93722",
      "County": " FRESNO",
      "Latitude": "36.7797820  ",
      "Longitude": " -119.86058 "
   },
   {
      "Vendor": "VALLEY FOODS SUPERMARKET",
      "Address": " 931 I ST",
      "City": "REEDLEY",
      "Zip Code": " 93654",
      "County": " FRESNO",
      "Latitude": "36.5962640  ",
      "Longitude": " -119.45489 "
   },
   {
      "Vendor": "BUY N BYE MARKET",
      "Address": " 1235 SANGER AVE",
      "City": "SANGER",
      "Zip Code": " 93657",
      "County": " FRESNO",
      "Latitude": "36.6984150  ",
      "Longitude": " -119.55672 "
   },
   {
      "Vendor": "QUICKEROO #577",
      "Address": "N 5102 WEST AVE",
      "City": "FRESNO",
      "Zip Code": " 93711",
      "County": " FRESNO",
      "Latitude": "36.8100390  ",
      "Longitude": " -119.82610 "
   },
   {
      "Vendor": "VALLEY FOODS SUPERMARKET",
      "Address": "W 2259 TAHOE AVE",
      "City": "CARUTHERS",
      "Zip Code": " 93609",
      "County": " FRESNO",
      "Latitude": "36.5428780  ",
      "Longitude": " -119.83162 "
   },
   {
      "Vendor": "SIERRA MARKET",
      "Address": " 2446 MCCALL AVE",
      "Second Address": " STE 100",
      "City": "SELMA",
      "Zip Code": " 93662",
      "County": " FRESNO",
      "Latitude": "36.5702760  ",
      "Longitude": " -119.60980 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #49",
      "Address": "W 1951 CLINTON AVE",
      "City": "FRESNO",
      "Zip Code": " 93705",
      "County": " FRESNO",
      "Latitude": "36.7716610  ",
      "Longitude": " -119.83537 "
   },
   {
      "Vendor": "BABY SHOP #4",
      "Address": "E 3263 SHIELDS AVE",
      "City": "FRESNO",
      "Zip Code": " 93726",
      "County": " FRESNO",
      "Latitude": "36.7798070  ",
      "Longitude": " -119.76921 "
   },
   {
      "Vendor": "SMART & FINAL #781",
      "Address": "N 7733 1ST ST",
      "City": "FRESNO",
      "Zip Code": " 93720",
      "County": " FRESNO",
      "Latitude": "36.8510630  ",
      "Longitude": " -119.77619 "
   },
   {
      "Vendor": "UNITED MARKET",
      "Address": " 577 I ST",
      "City": "REEDLEY",
      "Zip Code": " 93654",
      "County": " FRESNO",
      "Latitude": "36.6008620  ",
      "Longitude": " -119.46037 "
   },
   {
      "Vendor": "U-SAVE MARKET",
      "Address": "S 8646 MENDOCINO AVE",
      "City": "PARLIER",
      "Zip Code": " 93648",
      "County": " FRESNO",
      "Latitude": "36.6095330  ",
      "Longitude": " -119.54726 "
   },
   {
      "Vendor": "SMART & FINAL #807",
      "Address": "W 790 SHAW AVE",
      "City": "CLOVIS",
      "Zip Code": " 93612",
      "County": " FRESNO",
      "Latitude": "36.8084440  ",
      "Longitude": " -119.72692 "
   },
   {
      "Vendor": "FRESNO CENTRAL MARKET",
      "Address": "N 294 FRESNO ST",
      "City": "FRESNO",
      "Zip Code": " 93701",
      "County": " FRESNO",
      "Latitude": "36.7467430  ",
      "Longitude": " -119.78122 "
   },
   {
      "Vendor": "QUICK FOOD STORE",
      "Address": "E 249 BELMONT AVE",
      "City": "FRESNO",
      "Zip Code": " 93701",
      "County": " FRESNO",
      "Latitude": "36.7505130  ",
      "Longitude": " -119.80884 "
   },
   {
      "Vendor": "STATE FOODS COALINGA",
      "Address": "W 203 POLK ST",
      "City": "COALINGA",
      "Zip Code": " 93210",
      "County": " FRESNO",
      "Latitude": "36.1361270  ",
      "Longitude": " -120.36598 "
   },
   {
      "Vendor": "LA FIESTA MARKET",
      "Address": "S 307 MADERA AVE",
      "City": "KERMAN",
      "Zip Code": " 93630",
      "County": " FRESNO",
      "Latitude": "36.7312290  ",
      "Longitude": " -120.06026 "
   },
   {
      "Vendor": "STAR MEAT MARKET",
      "Address": "S 580 MADERA AVE",
      "City": "KERMAN",
      "Zip Code": " 93630",
      "County": " FRESNO",
      "Latitude": "36.7257880  ",
      "Longitude": " -120.05984 "
   },
   {
      "Vendor": "START HEALTHY NUTRITION",
      "Address": " 572 CENTER ST",
      "City": "ORANGECOVE",
      "Zip Code": " 93646",
      "County": " FRESNO",
      "Latitude": "36.6249660  ",
      "Longitude": " -119.31351 "
   },
   {
      "Vendor": "HURON VALLEY FOODS",
      "Address": "S 36220 LASSEN AVE",
      "City": "HURON",
      "Zip Code": " 93234",
      "County": " FRESNO",
      "Latitude": "36.2074010  ",
      "Longitude": " -120.10338 "
   },
   {
      "Vendor": "BINGO SUPERMARKET AND TRADING",
      "Address": "E 2143 BELMONT AVE",
      "City": "FRESNO",
      "Zip Code": " 93701",
      "County": " FRESNO",
      "Latitude": "36.7508120  ",
      "Longitude": " -119.78503 "
   },
   {
      "Vendor": "FRESNO COMMUNITY MARKET 3",
      "Address": "E 4825 OLIVE AVE",
      "City": "FRESNO",
      "Zip Code": " 93727",
      "County": " FRESNO",
      "Latitude": "36.7578010  ",
      "Longitude": " -119.73542 "
   },
   {
      "Vendor": "SABER LIQUOR MARKET",
      "Address": "E 4807 MCKINLEY AVE",
      "City": "FRESNO",
      "Zip Code": " 93703",
      "County": " FRESNO",
      "Latitude": "36.7654010  ",
      "Longitude": " -119.73598 "
   },
   {
      "Vendor": "MENDOTA MARKET",
      "Address": " 1191 7TH ST",
      "City": "MENDOTA",
      "Zip Code": " 93640",
      "County": " FRESNO",
      "Latitude": "36.7572120  ",
      "Longitude": " -120.37657 "
   },
   {
      "Vendor": "QUICK STOP NUTRITION",
      "Address": " 2707 WHITSON ST",
      "City": "SELMA",
      "Zip Code": " 93662",
      "County": " FRESNO",
      "Latitude": "36.5745920  ",
      "Longitude": " -119.62309 "
   },
   {
      "Vendor": "BABY SHOP #5",
      "Address": "W 786 SHAW AVE",
      "City": "CLOVIS",
      "Zip Code": " 93612",
      "County": " FRESNO",
      "Latitude": "36.8082440  ",
      "Longitude": " -119.72682 "
   },
   {
      "Vendor": "WEST PARK MARKET",
      "Address": "S 3466 VALENTINE AVE",
      "City": "FRESNO",
      "Zip Code": " 93706",
      "County": " FRESNO",
      "Latitude": "36.6837290  ",
      "Longitude": " -119.85286 "
   },
   {
      "Vendor": "LA ESTRELLA MARKET #2",
      "Address": " 1860 BAUDER ST",
      "City": "SELMA",
      "Zip Code": " 93662",
      "County": " FRESNO",
      "Latitude": "36.5629900  ",
      "Longitude": " -119.61585 "
   },
   {
      "Vendor": "TOWN & COUNTRY MARKET",
      "Address": "E 985 MANNING AVE",
      "City": "REEDLEY",
      "Zip Code": " 93654",
      "County": " FRESNO",
      "Latitude": "36.6031570  ",
      "Longitude": " -119.43831 "
   },
   {
      "Vendor": "LA ESTRELLA MEXICANA",
      "Address": "E 4594 OLIVE AVE",
      "City": "FRESNO",
      "Zip Code": " 93702",
      "County": " FRESNO",
      "Latitude": "36.7569600  ",
      "Longitude": " -119.74587 "
   },
   {
      "Vendor": "CITY MARKET",
      "Address": "E 1060 MANNING AVE",
      "City": "REEDLEY",
      "Zip Code": " 93654",
      "County": " FRESNO",
      "Latitude": "36.6045190  ",
      "Longitude": " -119.43779 "
   },
   {
      "Vendor": "FLORADORA FOOD MARKET",
      "Address": "E 4101 FLORADORA AVE",
      "City": "FRESNO",
      "Zip Code": " 93703",
      "County": " FRESNO",
      "Latitude": "36.7615950  ",
      "Longitude": " -119.75608 "
   },
   {
      "Vendor": "START HEALTHY NUTRITION",
      "Address": "E 1406 MANNING AVE",
      "Second Address": " STE A",
      "City": "REEDLEY",
      "Zip Code": " 93654",
      "County": " FRESNO",
      "Latitude": "36.6044230  ",
      "Longitude": " -119.43402 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1815",
      "Address": "W 4080 SHAW AVE",
      "City": "FRESNO",
      "Zip Code": " 93722",
      "County": " FRESNO",
      "Latitude": "36.8090580  ",
      "Longitude": " -119.86419 "
   },
   {
      "Vendor": "TROPICANA SUPERMARKET",
      "Address": "E 555 ELM AVE",
      "City": "COALINGA",
      "Zip Code": " 93210",
      "County": " FRESNO",
      "Latitude": "36.1446540  ",
      "Longitude": " -120.35630 "
   },
   {
      "Vendor": "SUPER MERCADO LAS PALMAS",
      "Address": "W 1405 SHIELDS AVE",
      "City": "FRESNO",
      "Zip Code": " 93705",
      "County": " FRESNO",
      "Latitude": "36.7791540  ",
      "Longitude": " -119.82792 "
   },
   {
      "Vendor": "FRESNO LATINO MARKET",
      "Address": "E 4718 KINGS CANYON RD",
      "City": "FRESNO",
      "Zip Code": " 93702",
      "County": " FRESNO",
      "Latitude": "36.7355280  ",
      "Longitude": " -119.73998 "
   },
   {
      "Vendor": "LEWIS MARKET",
      "Address": "E 2301 LEWIS AVE",
      "City": "FRESNO",
      "Zip Code": " 93701",
      "County": " FRESNO",
      "Latitude": "36.7547130  ",
      "Longitude": " -119.78336 "
   },
   {
      "Vendor": "SAV MOR FOODS #14",
      "Address": "E 35 WALKER ST",
      "City": "ORLAND",
      "Zip Code": " 95963",
      "County": " GLENN",
      "Latitude": "39.7475430  ",
      "Longitude": " -122.18652 "
   },
   {
      "Vendor": "WINCO FOODS #55",
      "Address": "W 396 ASHLAN AVE",
      "City": "CLOVIS",
      "Zip Code": " 93612",
      "County": " FRESNO",
      "Latitude": "36.7920040  ",
      "Longitude": " -119.71719 "
   },
   {
      "Vendor": "EL TORO LOCO #1",
      "Address": " 570 MAIN ST",
      "City": "HAMILTON CITY",
      "Zip Code": " 95951",
      "County": " GLENN",
      "Latitude": "39.7455820  ",
      "Longitude": " -122.01383 "
   },
   {
      "Vendor": "HAMILTON GAS & FOOD",
      "Address": " 601 6TH ST",
      "City": "HAMILTON CITY",
      "Zip Code": " 95951",
      "County": " GLENN",
      "Latitude": "39.7454320  ",
      "Longitude": " -122.01483 "
   },
   {
      "Vendor": "WAL-MART STORE #2053",
      "Address": "N 470 AIRPORT RD",
      "City": "WILLOWS",
      "Zip Code": " 95988",
      "County": " GLENN",
      "Latitude": "39.5250630  ",
      "Longitude": " -122.21879 "
   },
   {
      "Vendor": "MAR-VAL FOOD STORES#12",
      "Address": "S 517 TEHAMA ST",
      "City": "WILLOWS",
      "Zip Code": " 95988",
      "County": " GLENN",
      "Latitude": "39.5150730  ",
      "Longitude": " -122.19431 "
   },
   {
      "Vendor": "LA PERLA OCCIDENTE",
      "Address": " 424 COLUSA ST",
      "City": "ORLAND",
      "Zip Code": " 95963",
      "County": " GLENN",
      "Latitude": "39.7465080  ",
      "Longitude": " -122.19497 "
   },
   {
      "Vendor": "RAINBOW MARKET",
      "Address": " 430 BAKER ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93305",
      "County": " KERN",
      "Latitude": "35.3719430  ",
      "Longitude": " -118.99465 "
   },
   {
      "Vendor": "EDWARDS COMMISSARY",
      "Address": "W 312 FITZGERALD BLVD",
      "Second Address": " BLDG 6000",
      "City": "EDWARDS AFB",
      "Zip Code": " 93524",
      "County": " KERN",
      "Latitude": "34.9099810  ",
      "Longitude": " -117.90755 "
   },
   {
      "Vendor": "TECATE MARKET",
      "Address": "S 249 KING ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3591670  ",
      "Longitude": " -118.99379 "
   },
   {
      "Vendor": "SIERRA GATEWAY MARKET #1",
      "Address": " 13432 SIERRA WAY",
      "City": "KERNVILLE",
      "Zip Code": " 93238",
      "County": " KERN",
      "Latitude": "35.7578090  ",
      "Longitude": " -118.41879 "
   },
   {
      "Vendor": "STATER BROS. #102",
      "Address": " 16920 HIGHWAY 14",
      "City": "MOJAVE",
      "Zip Code": " 93501",
      "County": " KERN",
      "Latitude": "35.0681630  ",
      "Longitude": " -118.17377 "
   },
   {
      "Vendor": "FOOD MAXX #401",
      "Address": " 6300 WHITE LN",
      "City": "BAKERSFIELD",
      "Zip Code": " 93309",
      "County": " KERN",
      "Latitude": "35.3190810  ",
      "Longitude": " -119.07283 "
   },
   {
      "Vendor": "FOOD MAXX #402",
      "Address": " 4128 CHESTER AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93301",
      "County": " KERN",
      "Latitude": "35.3977740  ",
      "Longitude": " -119.01829 "
   },
   {
      "Vendor": "VONS #2413",
      "Address": " 5610 LAKE ISABELLA BLVD",
      "City": "LAKE ISABELLA",
      "Zip Code": " 93240",
      "County": " KERN",
      "Latitude": "35.6178820  ",
      "Longitude": " -118.47609 "
   },
   {
      "Vendor": "STATER BROS. #109",
      "Address": "N 800 CHINA LAKE BLVD",
      "City": "RIDGECREST",
      "Zip Code": " 93555",
      "County": " KERN",
      "Latitude": "35.6350510  ",
      "Longitude": " -117.66845 "
   },
   {
      "Vendor": "GARCIA'S MARKET",
      "Address": " 10904 MAIN ST",
      "City": "LAMONT",
      "Zip Code": " 93241",
      "County": " KERN",
      "Latitude": "35.2559150  ",
      "Longitude": " -118.91477 "
   },
   {
      "Vendor": "SIERRA GATEWAY MARKET #2",
      "Address": " 14606 HIGHWAY 178",
      "City": "LAKE ISABELLA",
      "Zip Code": " 93240",
      "County": " KERN",
      "Latitude": "35.6422660  ",
      "Longitude": " -118.36948 "
   },
   {
      "Vendor": "SAVE MART #064",
      "Address": " 841 TUCKER RD",
      "City": "TEHACHAPI",
      "Zip Code": " 93561",
      "County": " KERN",
      "Latitude": "35.1228680  ",
      "Longitude": " -118.46870 "
   },
   {
      "Vendor": "CHINA LAKE COMMISSARY",
      "Address": " 1 ADMINISTRATION CIR",
      "Second Address": " BLDG 02023",
      "City": "CHINA LAKE",
      "Zip Code": " 93555",
      "County": " KERN",
      "Latitude": "35.6504820  ",
      "Longitude": " -117.64479 "
   },
   {
      "Vendor": "SUPER Q MARKET",
      "Address": " 723 QUANTICO AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3647330  ",
      "Longitude": " -118.95834 "
   },
   {
      "Vendor": "FOODS CO #384",
      "Address": " 2505 HALEY ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93305",
      "County": " KERN",
      "Latitude": "35.3943360  ",
      "Longitude": " -118.97587 "
   },
   {
      "Vendor": "FOODS CO #365",
      "Address": " 1801 WHITE LN",
      "City": "BAKERSFIELD",
      "Zip Code": " 93304",
      "County": " KERN",
      "Latitude": "35.3164640  ",
      "Longitude": " -119.02253 "
   },
   {
      "Vendor": "BETTER TRADE MARKET",
      "Address": " 1310 MT VERNON AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93306",
      "County": " KERN",
      "Latitude": "35.3771040  ",
      "Longitude": " -118.96775 "
   },
   {
      "Vendor": "VONS #2033",
      "Address": " 4500 COFFEE RD",
      "City": "BAKERSFIELD",
      "Zip Code": " 93308",
      "County": " KERN",
      "Latitude": "35.4005060  ",
      "Longitude": " -119.09086 "
   },
   {
      "Vendor": "VONS #2420",
      "Address": " 9000 MING AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93311",
      "County": " KERN",
      "Latitude": "35.3403300  ",
      "Longitude": " -119.10355 "
   },
   {
      "Vendor": "FOOD MAXX #413",
      "Address": " 6465 NILES ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93306",
      "County": " KERN",
      "Latitude": "35.3750740  ",
      "Longitude": " -118.93313 "
   },
   {
      "Vendor": "ROBERT'S MARKET",
      "Address": "S 1467 FAIRFAX RD",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3417890  ",
      "Longitude": " -118.93162 "
   },
   {
      "Vendor": "SHAFTER APPLE MARKET",
      "Address": " 111 CENTRAL VALLEY HWY",
      "City": "SHAFTER",
      "Zip Code": " 93263",
      "County": " KERN",
      "Latitude": "35.5061770  ",
      "Longitude": " -119.27949 "
   },
   {
      "Vendor": "FAMILY FOODLAND MARKET",
      "Address": " 1217 MORNING DR",
      "City": "BAKERSFIELD",
      "Zip Code": " 93306",
      "County": " KERN",
      "Latitude": "35.3696560  ",
      "Longitude": " -118.91369 "
   },
   {
      "Vendor": "FAMILY FOOD MART",
      "Address": "E 138 FIRST ST",
      "City": "BUTTONWILLOW",
      "Zip Code": " 93206",
      "County": " KERN",
      "Latitude": "35.4007040  ",
      "Longitude": " -119.46856 "
   },
   {
      "Vendor": "FOODS CO #773",
      "Address": " 8200 ROSEDALE HWY",
      "City": "BAKERSFIELD",
      "Zip Code": " 93312",
      "County": " KERN",
      "Latitude": "35.3854920  ",
      "Longitude": " -119.09312 "
   },
   {
      "Vendor": "VONS #1969",
      "Address": " 5700 STOCKDALE HWY",
      "City": "BAKERSFIELD",
      "Zip Code": " 93309",
      "County": " KERN",
      "Latitude": "35.3544790  ",
      "Longitude": " -119.06565 "
   },
   {
      "Vendor": "BASIC FOODS #4",
      "Address": "S 2503 H ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93304",
      "County": " KERN",
      "Latitude": "35.3321390  ",
      "Longitude": " -119.02153 "
   },
   {
      "Vendor": "BASIC ESSENTIALS #1",
      "Address": " 1430 MAIN ST",
      "City": "DELANO",
      "Zip Code": " 93215",
      "County": " KERN",
      "Latitude": "35.7754280  ",
      "Longitude": " -119.24672 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #16",
      "Address": " 5951 NILES ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93306",
      "County": " KERN",
      "Latitude": "35.3750790  ",
      "Longitude": " -118.93787 "
   },
   {
      "Vendor": "BASIC ESSENTIALS #3",
      "Address": " 431 2ND ST",
      "City": "MCFARLAND",
      "Zip Code": " 93250",
      "County": " KERN",
      "Latitude": "35.6785280  ",
      "Longitude": " -119.22941 "
   },
   {
      "Vendor": "EL MERCADO MARKET",
      "Address": " 9317 WEEDPATCH HWY",
      "City": "LAMONT",
      "Zip Code": " 93241",
      "County": " KERN",
      "Latitude": "35.2698740  ",
      "Longitude": " -118.91396 "
   },
   {
      "Vendor": "CASA LOMA MARKET",
      "Address": "E 602 CASA LOMA DR",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3397150  ",
      "Longitude": " -118.99381 "
   },
   {
      "Vendor": "FOOD MAXX #453",
      "Address": " 4400 MING AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93309",
      "County": " KERN",
      "Latitude": "35.3396270  ",
      "Longitude": " -119.05067 "
   },
   {
      "Vendor": "FOOD MAXX #452",
      "Address": " 1115 UNION AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3672490  ",
      "Longitude": " -119.00366 "
   },
   {
      "Vendor": "EL TORO LOCO SUPER MERCADO",
      "Address": " 21315 HIGHWAY 46",
      "City": "LOST HILLS",
      "Zip Code": " 93249",
      "County": " KERN",
      "Latitude": "35.6157190  ",
      "Longitude": " -119.68866 "
   },
   {
      "Vendor": "DELANO'S FAMILY FOODS",
      "Address": " 401 11TH AVE",
      "City": "DELANO",
      "Zip Code": " 93215",
      "County": " KERN",
      "Latitude": "35.7694210  ",
      "Longitude": " -119.25367 "
   },
   {
      "Vendor": "FIESTA LATINA MARKET #3",
      "Address": "S 300 SHAFTER AVE",
      "City": "SHAFTER",
      "Zip Code": " 93263",
      "County": " KERN",
      "Latitude": "35.4978690  ",
      "Longitude": " -119.27797 "
   },
   {
      "Vendor": "ANGELS FAMILY NUTRITION",
      "Address": " 1152 7TH ST",
      "City": "WASCO",
      "Zip Code": " 93280",
      "County": " KERN",
      "Latitude": "35.5944290  ",
      "Longitude": " -119.33882 "
   },
   {
      "Vendor": "SAVE MART #096",
      "Address": " 9600 HAGEMAN RD",
      "City": "BAKERSFIELD",
      "Zip Code": " 93312",
      "County": " KERN",
      "Latitude": "35.3995670  ",
      "Longitude": " -119.10842 "
   },
   {
      "Vendor": "WINCO FOODS #32",
      "Address": " 4200 COFFEE RD",
      "City": "BAKERSFIELD",
      "Zip Code": " 93308",
      "County": " KERN",
      "Latitude": "35.3973410  ",
      "Longitude": " -119.09074 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #23",
      "Address": " 1840 CECIL AVE",
      "City": "DELANO",
      "Zip Code": " 93215",
      "County": " KERN",
      "Latitude": "35.7757090  ",
      "Longitude": " -119.23108 "
   },
   {
      "Vendor": "FIESTA LATINA MARKET #2",
      "Address": " 1220 7TH ST",
      "City": "WASCO",
      "Zip Code": " 93280",
      "County": " KERN",
      "Latitude": "35.5946090  ",
      "Longitude": " -119.33964 "
   },
   {
      "Vendor": "BORON FOOD MART",
      "Address": " 27037 TWENTY MULE TEAM RD",
      "City": "BORON",
      "Zip Code": " 93516",
      "County": " KERN",
      "Latitude": "34.9998800  ",
      "Longitude": " -117.64900 "
   },
   {
      "Vendor": "PAY-LESS MARKET",
      "Address": " 827 8TH ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93304",
      "County": " KERN",
      "Latitude": "35.3643580  ",
      "Longitude": " -119.01155 "
   },
   {
      "Vendor": "EASY WAY MARKET",
      "Address": " 3435 PIONEER DR",
      "City": "BAKERSFIELD",
      "Zip Code": " 93306",
      "County": " KERN",
      "Latitude": "35.3684470  ",
      "Longitude": " -118.94119 "
   },
   {
      "Vendor": "CACTUS MINI MARKET",
      "Address": " 7021 CALIFORNIA CITY BLVD",
      "City": "CALIFORNIA CITY",
      "Zip Code": " 93505",
      "County": " KERN",
      "Latitude": "35.1262550  ",
      "Longitude": " -118.00224 "
   },
   {
      "Vendor": "TOTAL MART",
      "Address": " 1328 NILES ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93305",
      "County": " KERN",
      "Latitude": "35.3797410  ",
      "Longitude": " -118.98032 "
   },
   {
      "Vendor": "WEEDPATCH SUPERMARKET",
      "Address": " 8101 BUENA VISTA BLVD",
      "City": "LAMONT",
      "Zip Code": " 93241",
      "County": " KERN",
      "Latitude": "35.2375360  ",
      "Longitude": " -118.91416 "
   },
   {
      "Vendor": "POTOMAC MARKET",
      "Address": " 2050 POTOMAC AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3649280  ",
      "Longitude": " -118.97247 "
   },
   {
      "Vendor": "N & H MARKET #2",
      "Address": " 1230 PEARL ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93305",
      "County": " KERN",
      "Latitude": "35.3885970  ",
      "Longitude": " -118.97887 "
   },
   {
      "Vendor": "4TH STREET MARKET",
      "Address": " 307 4TH ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93304",
      "County": " KERN",
      "Latitude": "35.3604300  ",
      "Longitude": " -119.00543 "
   },
   {
      "Vendor": "ISABELLA SUPER MARKET",
      "Address": " 6120 LAKE ISABELLA BLVD",
      "City": "LAKE ISABELLA",
      "Zip Code": " 93240",
      "County": " KERN",
      "Latitude": "35.6248610  ",
      "Longitude": " -118.47369 "
   },
   {
      "Vendor": "LA VILLA MEAT MARKET",
      "Address": "E 1513 CALIFORNIA AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3681370  ",
      "Longitude": " -118.98177 "
   },
   {
      "Vendor": "FIESTA FOOD MARKET",
      "Address": " 1400 PADRE ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3513640  ",
      "Longitude": " -118.98481 "
   },
   {
      "Vendor": "MOE'S DISCOUNT STORE",
      "Address": " 3318 NILES ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93306",
      "County": " KERN",
      "Latitude": "35.3762090  ",
      "Longitude": " -118.94383 "
   },
   {
      "Vendor": "SMART & FINAL #326",
      "Address": " 1725 GOLDEN STATE AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93301",
      "County": " KERN",
      "Latitude": "35.3900470  ",
      "Longitude": " -119.02519 "
   },
   {
      "Vendor": "SMART & FINAL #508",
      "Address": " 2749 CALLOWAY DR",
      "Second Address": " STE 500",
      "City": "BAKERSFIELD",
      "Zip Code": " 93312",
      "County": " KERN",
      "Latitude": "35.3861020  ",
      "Longitude": " -119.11140 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #28",
      "Address": " 1515 PANAMA LN",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.2955940  ",
      "Longitude": " -119.01928 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #134",
      "Address": " 2100 WHITE LN",
      "City": "BAKERSFIELD",
      "Zip Code": " 93304",
      "County": " KERN",
      "Latitude": "35.3186510  ",
      "Longitude": " -119.02675 "
   },
   {
      "Vendor": "SMART & FINAL #344",
      "Address": " 3400 WHITE LN",
      "City": "BAKERSFIELD",
      "Zip Code": " 93309",
      "County": " KERN",
      "Latitude": "35.3182260  ",
      "Longitude": " -119.04052 "
   },
   {
      "Vendor": "LA FAMILIA NUTRITION",
      "Address": " 715 CENTER ST",
      "City": "TAFT",
      "Zip Code": " 93268",
      "County": " KERN",
      "Latitude": "35.1418910  ",
      "Longitude": " -119.46274 "
   },
   {
      "Vendor": "AMIGOS MEAT MARKET",
      "Address": " 829 HIGHWAY 46",
      "City": "WASCO",
      "Zip Code": " 93280",
      "County": " KERN",
      "Latitude": "35.6012290  ",
      "Longitude": " -119.33462 "
   },
   {
      "Vendor": "BASIC NUTRITION #11",
      "Address": " 401 ELLINGTON ST",
      "Second Address": " STE C",
      "City": "DELANO",
      "Zip Code": " 93215",
      "County": " KERN",
      "Latitude": "35.7616250  ",
      "Longitude": " -119.25015 "
   },
   {
      "Vendor": "BASIC NUTRITION #1",
      "Address": " 1626 BEALE AVE",
      "Second Address": " STE A",
      "City": "BAKERSFIELD",
      "Zip Code": " 93305",
      "County": " KERN",
      "Latitude": "35.3852500  ",
      "Longitude": " -118.98690 "
   },
   {
      "Vendor": "BASIC NUTRITION #2",
      "Address": " 624 MORNING DR",
      "Second Address": " STE D",
      "City": "BAKERSFIELD",
      "Zip Code": " 93306",
      "County": " KERN",
      "Latitude": "35.3682180  ",
      "Longitude": " -118.91463 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1574",
      "Address": " 6225 COLONY ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.2987860  ",
      "Longitude": " -119.02928 "
   },
   {
      "Vendor": "11-C SUPERMARKET",
      "Address": " 661 ROBERTS LN",
      "City": "BAKERSFIELD",
      "Zip Code": " 93308",
      "County": " KERN",
      "Latitude": "35.4080420  ",
      "Longitude": " -119.03373 "
   },
   {
      "Vendor": "BASIC NUTRITION #3",
      "Address": " 104 BRUNDAGE LN",
      "City": "BAKERSFIELD",
      "Zip Code": " 93304",
      "County": " KERN",
      "Latitude": "35.3539260  ",
      "Longitude": " -119.00378 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5134",
      "Address": " 5075 GOSFORD RD",
      "City": "BAKERSFIELD",
      "Zip Code": " 93313",
      "County": " KERN",
      "Latitude": "35.3088740  ",
      "Longitude": " -119.09543 "
   },
   {
      "Vendor": "TARGET STORE T-2715",
      "Address": " 11000 STOCKDALE HWY",
      "City": "BAKERSFIELD",
      "Zip Code": " 93311",
      "County": " KERN",
      "Latitude": "35.3491440  ",
      "Longitude": " -119.12380 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #42",
      "Address": " 820 MAIN ST",
      "City": "DELANO",
      "Zip Code": " 93215",
      "County": " KERN",
      "Latitude": "35.7672800  ",
      "Longitude": " -119.24457 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #40",
      "Address": "S 2705 H ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93304",
      "County": " KERN",
      "Latitude": "35.3303090  ",
      "Longitude": " -119.02283 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #39",
      "Address": " 600 BEAR MOUNTAIN BLVD",
      "City": "ARVIN",
      "Zip Code": " 93203",
      "County": " KERN",
      "Latitude": "35.2099320  ",
      "Longitude": " -118.83222 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #41",
      "Address": " 2309 NILES POINT",
      "City": "BAKERSFIELD",
      "Zip Code": " 93306",
      "County": " KERN",
      "Latitude": "35.3751880  ",
      "Longitude": " -118.96608 "
   },
   {
      "Vendor": "BASIC NUTRITION #4",
      "Address": " 1601 MCDONALD WAY",
      "Second Address": " STE B",
      "City": "BAKERSFIELD",
      "Zip Code": " 93309",
      "County": " KERN",
      "Latitude": "35.3404020  ",
      "Longitude": " -119.05329 "
   },
   {
      "Vendor": "TARGET STORE T-2524",
      "Address": " 2901 MING AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93304",
      "County": " KERN",
      "Latitude": "35.3365520  ",
      "Longitude": " -119.03598 "
   },
   {
      "Vendor": "WAL-MART STORE #1624",
      "Address": " 2601 FASHION PL",
      "City": "BAKERSFIELD",
      "Zip Code": " 93306",
      "County": " KERN",
      "Latitude": "35.3904920  ",
      "Longitude": " -118.96135 "
   },
   {
      "Vendor": "TARGET STORE T-1384",
      "Address": " 9100 ROSEDALE HWY",
      "City": "BAKERSFIELD",
      "Zip Code": " 93312",
      "County": " KERN",
      "Latitude": "35.3837430  ",
      "Longitude": " -119.10336 "
   },
   {
      "Vendor": "TARGET STORE T-0614",
      "Address": " 3401 MALL VIEW RD",
      "City": "BAKERSFIELD",
      "Zip Code": " 93306",
      "County": " KERN",
      "Latitude": "35.3938900  ",
      "Longitude": " -118.95494 "
   },
   {
      "Vendor": "QUICKEROO #567",
      "Address": " 603 BEAR MOUNTAIN BLVD",
      "City": "ARVIN",
      "Zip Code": " 93203",
      "County": " KERN",
      "Latitude": "35.2088020  ",
      "Longitude": " -118.83198 "
   },
   {
      "Vendor": "QUICKEROO #568",
      "Address": " 500 CALIFORNIA AVE",
      "Second Address": " STE B",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3687040  ",
      "Longitude": " -119.00694 "
   },
   {
      "Vendor": "ALBERTSONS #3129",
      "Address": " 3500 PANAMA LN",
      "City": "BAKERSFIELD",
      "Zip Code": " 93313",
      "County": " KERN",
      "Latitude": "35.2966450  ",
      "Longitude": " -119.04052 "
   },
   {
      "Vendor": "ALBERTSONS #331",
      "Address": "S 927 CHINA LAKE BLVD",
      "City": "RIDGECREST",
      "Zip Code": " 93555",
      "County": " KERN",
      "Latitude": "35.6059270  ",
      "Longitude": " -117.67395 "
   },
   {
      "Vendor": "ALBERTSONS #336",
      "Address": " 1520 BRUNDAGE LN",
      "City": "BAKERSFIELD",
      "Zip Code": " 93304",
      "County": " KERN",
      "Latitude": "35.3549450  ",
      "Longitude": " -119.01955 "
   },
   {
      "Vendor": "ALBERTSONS #1337",
      "Address": " 2547 ROSAMOND BLVD",
      "City": "ROSAMOND",
      "Zip Code": " 93560",
      "County": " KERN",
      "Latitude": "34.8644820  ",
      "Longitude": " -118.17791 "
   },
   {
      "Vendor": "ALBERTSONS #1347",
      "Address": "S 775 TUCKER RD",
      "City": "TEHACHAPI",
      "Zip Code": " 93561",
      "County": " KERN",
      "Latitude": "35.1253400  ",
      "Longitude": " -118.46910 "
   },
   {
      "Vendor": "ALBERTSONS #358",
      "Address": " 2691 MT VERNON AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93306",
      "County": " KERN",
      "Latitude": "35.3959710  ",
      "Longitude": " -118.96629 "
   },
   {
      "Vendor": "ALBERTSONS #1376",
      "Address": "N 1301 NORMA ST",
      "City": "RIDGECREST",
      "Zip Code": " 93555",
      "County": " KERN",
      "Latitude": "35.6447530  ",
      "Longitude": " -117.67960 "
   },
   {
      "Vendor": "ALBERTSONS #377",
      "Address": " 13045 ROSEDALE HWY",
      "City": "BAKERSFIELD",
      "Zip Code": " 93314",
      "County": " KERN",
      "Latitude": "35.3824330  ",
      "Longitude": " -119.14639 "
   },
   {
      "Vendor": "ALBERTSONS #3172",
      "Address": "E 8200 STOCKDALE HWY",
      "City": "BAKERSFIELD",
      "Zip Code": " 93311",
      "County": " KERN",
      "Latitude": "35.3556880  ",
      "Longitude": " -119.09345 "
   },
   {
      "Vendor": "ALBERTSONS #1382",
      "Address": "W 1044 KERN ST",
      "City": "TAFT",
      "Zip Code": " 93268",
      "County": " KERN",
      "Latitude": "35.1464900  ",
      "Longitude": " -119.46627 "
   },
   {
      "Vendor": "ALBERTSONS #1398",
      "Address": " 6045 COFFEE RD",
      "City": "BAKERSFIELD",
      "Zip Code": " 93308",
      "County": " KERN",
      "Latitude": "35.4137870  ",
      "Longitude": " -119.09367 "
   },
   {
      "Vendor": "LA RAZA MARKET",
      "Address": " 702 BERNARD ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93305",
      "County": " KERN",
      "Latitude": "35.3905000  ",
      "Longitude": " -118.98788 "
   },
   {
      "Vendor": "BASIC NUTRITION #5",
      "Address": " 720 DR MARTIN L. KING JR BLVD",
      "Second Address": " STE 5",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3612250  ",
      "Longitude": " -118.98518 "
   },
   {
      "Vendor": "FOOD VILLAGE MARKET",
      "Address": " 127 PRICE ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3044600  ",
      "Longitude": " -119.00119 "
   },
   {
      "Vendor": "LA REINA NUTRITION",
      "Address": " 165 LOCKWOOD AVE",
      "City": "MCFARLAND",
      "Zip Code": " 93250",
      "County": " KERN",
      "Latitude": "35.6789860  ",
      "Longitude": " -119.22890 "
   },
   {
      "Vendor": "FRAZIER PARK MARKET",
      "Address": " 632 LAGUNA TRAIL",
      "City": "FRAZIER PARK",
      "Zip Code": " 93225",
      "County": " KERN",
      "Latitude": "34.8224240  ",
      "Longitude": " -118.94659 "
   },
   {
      "Vendor": "WAL-MART #5215",
      "Address": " 530 WOOLLOMES AVE",
      "City": "DELANO",
      "Zip Code": " 93215",
      "County": " KERN",
      "Latitude": "35.7459150  ",
      "Longitude": " -119.24853 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2557",
      "Address": " 8400 ROSEDALE HWY",
      "City": "BAKERSFIELD",
      "Zip Code": " 93312",
      "County": " KERN",
      "Latitude": "35.3836800  ",
      "Longitude": " -119.09607 "
   },
   {
      "Vendor": "SMART & FINAL #421",
      "Address": " 1700 HIGH ST",
      "City": "DELANO",
      "Zip Code": " 93215",
      "County": " KERN",
      "Latitude": "35.7777190  ",
      "Longitude": " -119.24872 "
   },
   {
      "Vendor": "QUICKEROO #569",
      "Address": " 3900 NILES ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93306",
      "County": " KERN",
      "Latitude": "35.3763260  ",
      "Longitude": " -118.94043 "
   },
   {
      "Vendor": "QUICKEROO #560",
      "Address": " 2666 MOUNT VERNON AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93306",
      "County": " KERN",
      "Latitude": "35.3933870  ",
      "Longitude": " -118.96792 "
   },
   {
      "Vendor": "SMART & FINAL #362",
      "Address": " 4980 STOCKDALE HWY",
      "City": "BAKERSFIELD",
      "Zip Code": " 93309",
      "County": " KERN",
      "Latitude": "35.3554380  ",
      "Longitude": " -119.05716 "
   },
   {
      "Vendor": "FIESTA FOODS AND MEAT MARKE",
      "Address": " 1631 BEALE AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93305",
      "County": " KERN",
      "Latitude": "35.3851430  ",
      "Longitude": " -118.98612 "
   },
   {
      "Vendor": "WINCO FOODS#119",
      "Address": " 6801 PANAMA LN",
      "City": "BAKERSFIELD",
      "Zip Code": " 93313",
      "County": " KERN",
      "Latitude": "35.2949560  ",
      "Longitude": " -119.07731 "
   },
   {
      "Vendor": "WAL-MART STORE #3140",
      "Address": "N 3111 CHESTER AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93308",
      "County": " KERN",
      "Latitude": "35.4347450  ",
      "Longitude": " -119.02232 "
   },
   {
      "Vendor": "LA HACIENDA MARKET",
      "Address": " 315 JAMES ST",
      "City": "SHAFTER",
      "Zip Code": " 93263",
      "County": " KERN",
      "Latitude": "35.5032260  ",
      "Longitude": " -119.27721 "
   },
   {
      "Vendor": "FIVE STAR MARKET",
      "Address": " 1701 FLOWER ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93305",
      "County": " KERN",
      "Latitude": "35.3825100  ",
      "Longitude": " -118.97414 "
   },
   {
      "Vendor": "FIESTA SUPERMARKET",
      "Address": " 915 POSO DR",
      "City": "WASCO",
      "Zip Code": " 93280",
      "County": " KERN",
      "Latitude": "35.5867100  ",
      "Longitude": " -119.33576 "
   },
   {
      "Vendor": "LA CANASTA MARKET",
      "Address": " 1017 7TH ST",
      "City": "WASCO",
      "Zip Code": " 93280",
      "County": " KERN",
      "Latitude": "35.5939760  ",
      "Longitude": " -119.33699 "
   },
   {
      "Vendor": "FIESTA MARKET #2",
      "Address": " 9710 MAIN ST",
      "City": "LAMONT",
      "Zip Code": " 93241",
      "County": " KERN",
      "Latitude": "35.2663790  ",
      "Longitude": " -118.91498 "
   },
   {
      "Vendor": "WATTS MARKET",
      "Address": " 801 WATTS DR",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3324560  ",
      "Longitude": " -118.98964 "
   },
   {
      "Vendor": "EL TORO LOCO MARKET #8",
      "Address": " 3001 TAFT HWY",
      "City": "BAKERSFIELD",
      "Zip Code": " 93313",
      "County": " KERN",
      "Latitude": "35.2664560  ",
      "Longitude": " -119.03532 "
   },
   {
      "Vendor": "FIRST STEP NUTRITION #11",
      "Address": " 300 STATE AVE",
      "City": "SHAFTER",
      "Zip Code": " 93263",
      "County": " KERN",
      "Latitude": "35.5003290  ",
      "Longitude": " -119.27319 "
   },
   {
      "Vendor": "BASIC NUTRITION #7",
      "Address": "W 525 COLUMBUS ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93301",
      "County": " KERN",
      "Latitude": "35.3973440  ",
      "Longitude": " -119.00776 "
   },
   {
      "Vendor": "ROY'S MARKET",
      "Address": " 502 DR MARTIN L. KING JR BLVD",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3626960  ",
      "Longitude": " -118.98519 "
   },
   {
      "Vendor": "SAM'S MARKET & GAS",
      "Address": " 318 WHITE LN",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3180830  ",
      "Longitude": " -119.00560 "
   },
   {
      "Vendor": "Q & M DISCOUNT",
      "Address": " 2327 RIVER BLVD",
      "City": "BAKERSFIELD",
      "Zip Code": " 93305",
      "County": " KERN",
      "Latitude": "35.3946240  ",
      "Longitude": " -118.98476 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKETS #15",
      "Address": " 13940 RAMONA BLVD",
      "City": "BALDWIN PARK",
      "Zip Code": " 91706",
      "County": " LOS ANGELES",
      "Latitude": "34.0834950  ",
      "Longitude": " -117.96872 "
   },
   {
      "Vendor": "PALOMINO MARKET",
      "Address": " 6159 HELIOTROPE AVE",
      "City": "MAYWOOD",
      "Zip Code": " 90270",
      "County": " LOS ANGELES",
      "Latitude": "33.9809860  ",
      "Longitude": " -118.17965 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#432",
      "Address": " 13927 SAN ANTONIO AVE",
      "City": "NORWALK",
      "Zip Code": " 90650",
      "County": " LOS ANGELES",
      "Latitude": "33.9047460  ",
      "Longitude": " -118.08039 "
   },
   {
      "Vendor": "TORITO MARKET",
      "Address": " 10804 JUNIPER ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90059",
      "County": " LOS ANGELES",
      "Latitude": "33.9374640  ",
      "Longitude": " -118.23297 "
   },
   {
      "Vendor": "EL POTRILLO MARKET",
      "Address": "W 4151 3RD ST",
      "Second Address": " STE D",
      "City": "LOS ANGELES",
      "Zip Code": " 90020",
      "County": " LOS ANGELES",
      "Latitude": "34.0692180  ",
      "Longitude": " -118.30466 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#434",
      "Address": "E 2919 FLORENCE AVE",
      "City": "HUNTINGTON PARK",
      "Zip Code": " 90255",
      "County": " LOS ANGELES",
      "Latitude": "33.9733430  ",
      "Longitude": " -118.21673 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#435",
      "Address": "W 1985 ADAMS BLVD",
      "Second Address": " UNIT 104",
      "City": "LOS ANGELES",
      "Zip Code": " 90018",
      "County": " LOS ANGELES",
      "Latitude": "34.0332520  ",
      "Longitude": " -118.30824 "
   },
   {
      "Vendor": "FOOD 4 LESS #354",
      "Address": " 16208 PARTHENIA ST",
      "City": "NORTH HILLS",
      "Zip Code": " 91343",
      "County": " LOS ANGELES",
      "Latitude": "34.2276130  ",
      "Longitude": " -118.48610 "
   },
   {
      "Vendor": "FOOD 4 LESS #772",
      "Address": "E 1600 WILLOW ST",
      "City": "SIGNAL HILL",
      "Zip Code": " 90755",
      "County": " LOS ANGELES",
      "Latitude": "33.8037000  ",
      "Longitude": " -118.17046 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #112",
      "Address": "E 111 COMPTON BLVD",
      "City": "COMPTON",
      "Zip Code": " 90220",
      "County": " LOS ANGELES",
      "Latitude": "33.8969620  ",
      "Longitude": " -118.22308 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #111",
      "Address": " 9801 LAUREL CANYON BLVD",
      "City": "PACOIMA",
      "Zip Code": " 91331",
      "County": " LOS ANGELES",
      "Latitude": "34.2473170  ",
      "Longitude": " -118.42129 "
   },
   {
      "Vendor": "VONS #1638",
      "Address": " 4226 WOODRUFF AVE",
      "City": "LAKEWOOD",
      "Zip Code": " 90713",
      "County": " LOS ANGELES",
      "Latitude": "33.8345990  ",
      "Longitude": " -118.11541 "
   },
   {
      "Vendor": "MORE 4 LESS",
      "Address": "S 10207 VERMONT AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90044",
      "County": " LOS ANGELES",
      "Latitude": "33.9440490  ",
      "Longitude": " -118.29190 "
   },
   {
      "Vendor": "FOOD 4 LESS #778",
      "Address": " 13525 LAKEWOOD BLVD",
      "City": "DOWNEY",
      "Zip Code": " 90242",
      "County": " LOS ANGELES",
      "Latitude": "33.9045970  ",
      "Longitude": " -118.14395 "
   },
   {
      "Vendor": "WALNUT PRODUCE MARKET",
      "Address": "E 2690 FLORENCE AVE",
      "City": "HUNTINGTON PARK",
      "Zip Code": " 90255",
      "County": " LOS ANGELES",
      "Latitude": "33.9739550  ",
      "Longitude": " -118.22258 "
   },
   {
      "Vendor": "SMILE FOOD #2",
      "Address": "E 16 MARKET ST",
      "City": "LONG BEACH",
      "Zip Code": " 90805",
      "County": " LOS ANGELES",
      "Latitude": "33.8540250  ",
      "Longitude": " -118.19583 "
   },
   {
      "Vendor": "FOOD 4 LESS #775",
      "Address": " 12222 CARSON ST",
      "City": "HAWAIIAN GARDENS",
      "Zip Code": " 90716",
      "County": " LOS ANGELES",
      "Latitude": "33.8312250  ",
      "Longitude": " -118.07086 "
   },
   {
      "Vendor": "RALPHS #132",
      "Address": " 1770 CARSON ST",
      "City": "TORRANCE",
      "Zip Code": " 90501",
      "County": " LOS ANGELES",
      "Latitude": "33.8303480  ",
      "Longitude": " -118.31097 "
   },
   {
      "Vendor": "FOOD 4 LESS #766",
      "Address": "N 5100 FIGUEROA ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90042",
      "County": " LOS ANGELES",
      "Latitude": "34.1053650  ",
      "Longitude": " -118.20005 "
   },
   {
      "Vendor": "FOOD 4 LESS #777",
      "Address": "W 1820 SLAUSON AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90047",
      "County": " LOS ANGELES",
      "Latitude": "33.9880270  ",
      "Longitude": " -118.31103 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #113",
      "Address": " 3600 CESAR E. CHAVEZ AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90063",
      "County": " LOS ANGELES",
      "Latitude": "34.0399060  ",
      "Longitude": " -118.18643 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#439",
      "Address": "E 8870 WHITTIER BLVD",
      "City": "PICO RIVERA",
      "Zip Code": " 90660",
      "County": " LOS ANGELES",
      "Latitude": "34.0073530  ",
      "Longitude": " -118.09781 "
   },
   {
      "Vendor": "CARNICERIA DON JUAN #2",
      "Address": " 12922 VANOWEN ST",
      "City": "NORTH HOLLYWOOD",
      "Zip Code": " 91605",
      "County": " LOS ANGELES",
      "Latitude": "34.1936640  ",
      "Longitude": " -118.41468 "
   },
   {
      "Vendor": "RALPHS #759",
      "Address": " 10861 WEYBURN AVE",
      "City": "WESTWOOD",
      "Zip Code": " 90024",
      "County": " LOS ANGELES",
      "Latitude": "34.0628460  ",
      "Longitude": " -118.44367 "
   },
   {
      "Vendor": "FOOD 4 LESS #770",
      "Address": "W 1700 6TH ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90019",
      "County": " LOS ANGELES",
      "Latitude": "34.0571190  ",
      "Longitude": " -118.26994 "
   },
   {
      "Vendor": "LOS ANGELITOS NUTRITIONAL P",
      "Address": "S 11020 AVALON BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90061",
      "County": " LOS ANGELES",
      "Latitude": "33.9354970  ",
      "Longitude": " -118.26516 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#442",
      "Address": " 22227 NORWALK BLVD",
      "City": "HAWAIIAN GARDENS",
      "Zip Code": " 90716",
      "County": " LOS ANGELES",
      "Latitude": "33.8261380  ",
      "Longitude": " -118.07245 "
   },
   {
      "Vendor": "EAST 15TH STREET MARKET",
      "Address": "E 1732 15TH ST",
      "City": "LONG BEACH",
      "Zip Code": " 90813",
      "County": " LOS ANGELES",
      "Latitude": "33.7860360  ",
      "Longitude": " -118.17029 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #115",
      "Address": "N 1375 CITRUS AVE",
      "City": "COVINA",
      "Zip Code": " 91722",
      "County": " LOS ANGELES",
      "Latitude": "34.1048680  ",
      "Longitude": " -117.89089 "
   },
   {
      "Vendor": "R-RANCH MARKET #11",
      "Address": "E 17305 VALLEY BLVD",
      "City": "LA PUENTE",
      "Zip Code": " 91744",
      "County": " LOS ANGELES",
      "Latitude": "34.0099200  ",
      "Longitude": " -117.92625 "
   },
   {
      "Vendor": "EL SUPER #03",
      "Address": " 5646 WHITTIER BLVD",
      "City": "COMMERCE",
      "Zip Code": " 90022",
      "County": " LOS ANGELES",
      "Latitude": "34.0176980  ",
      "Longitude": " -118.14915 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#446",
      "Address": "W 4222 BEVERLY BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90004",
      "County": " LOS ANGELES",
      "Latitude": "34.0762730  ",
      "Longitude": " -118.30125 "
   },
   {
      "Vendor": "RALPHS #206",
      "Address": " 5429 HOLLYWOOD BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90027",
      "County": " LOS ANGELES",
      "Latitude": "34.1019420  ",
      "Longitude": " -118.30818 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#443",
      "Address": "S 6224 VERMONT AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90044",
      "County": " LOS ANGELES",
      "Latitude": "33.9830390  ",
      "Longitude": " -118.29112 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#444",
      "Address": " 11849 LAKEWOOD BLVD",
      "City": "DOWNEY",
      "Zip Code": " 90241",
      "County": " LOS ANGELES",
      "Latitude": "33.9276570  ",
      "Longitude": " -118.12990 "
   },
   {
      "Vendor": "VONS #1707",
      "Address": "N 561 GLENDALE AVE",
      "City": "GLENDALE",
      "Zip Code": " 91206",
      "County": " LOS ANGELES",
      "Latitude": "34.1538940  ",
      "Longitude": " -118.24342 "
   },
   {
      "Vendor": "LA POBLANA CARNICERIA",
      "Address": "E 5928 WHITTIER BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90022",
      "County": " LOS ANGELES",
      "Latitude": "34.0174210  ",
      "Longitude": " -118.14317 "
   },
   {
      "Vendor": "EL SUPER #04",
      "Address": "E 3405 CESAR E CHAVEZ AVE",
      "City": "EAST LOS ANGELES",
      "Zip Code": " 90063",
      "County": " LOS ANGELES",
      "Latitude": "34.0415300  ",
      "Longitude": " -118.19186 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#447",
      "Address": "E 1350 FLORENCE AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90001",
      "County": " LOS ANGELES",
      "Latitude": "33.9744730  ",
      "Longitude": " -118.25014 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #114",
      "Address": "S 151 HACIENDA BLVD",
      "City": "CITY OF INDUSTRY",
      "Zip Code": " 91745",
      "County": " LOS ANGELES",
      "Latitude": "34.0219790  ",
      "Longitude": " -117.95823 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#440",
      "Address": " 18353 SHERMAN WAY",
      "City": "RESEDA",
      "Zip Code": " 91335",
      "County": " LOS ANGELES",
      "Latitude": "34.2014550  ",
      "Longitude": " -118.53355 "
   },
   {
      "Vendor": "BUY LOW MARKET #2",
      "Address": "E 9900 GARVEY AVE",
      "City": "EL MONTE",
      "Zip Code": " 91733",
      "County": " LOS ANGELES",
      "Latitude": "34.0627210  ",
      "Longitude": " -118.05222 "
   },
   {
      "Vendor": "BUY LOW MARKET",
      "Address": "N 250 LA BREA AVE",
      "City": "INGLEWOOD",
      "Zip Code": " 90301",
      "County": " LOS ANGELES",
      "Latitude": "33.9666500  ",
      "Longitude": " -118.35363 "
   },
   {
      "Vendor": "BIG SAVER FOODS #13",
      "Address": " 16000 WOODRUFF AVE",
      "City": "BELLFLOWER",
      "Zip Code": " 90706",
      "County": " LOS ANGELES",
      "Latitude": "33.8887790  ",
      "Longitude": " -118.11649 "
   },
   {
      "Vendor": "VONS #2598",
      "Address": " 3233 FOOTHILL BLVD",
      "City": "LA CRESCENTA",
      "Zip Code": " 91214",
      "County": " LOS ANGELES",
      "Latitude": "34.2308070  ",
      "Longitude": " -118.25018 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#450",
      "Address": " 8530 VAN NUYS BLVD",
      "City": "PANORAMA CITY",
      "Zip Code": " 91402",
      "County": " LOS ANGELES",
      "Latitude": "34.2255070  ",
      "Longitude": " -118.44890 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #116",
      "Address": " 5824 VERMONT AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90044",
      "County": " LOS ANGELES",
      "Latitude": "33.9891120  ",
      "Longitude": " -118.29147 "
   },
   {
      "Vendor": "PATITO NUTRITIONAL CENTER",
      "Address": "W 1234 LOMITA BLVD",
      "Second Address": " UNIT P",
      "City": "HARBOR CITY",
      "Zip Code": " 90710",
      "County": " LOS ANGELES",
      "Latitude": "33.7974640  ",
      "Longitude": " -118.29840 "
   },
   {
      "Vendor": "UNO PRODUCE MARKET",
      "Address": "S 4100 BROADWAY",
      "City": "LOS ANGELES",
      "Zip Code": " 90037",
      "County": " LOS ANGELES",
      "Latitude": "34.0090890  ",
      "Longitude": " -118.27834 "
   },
   {
      "Vendor": "JON'S MARKETPLACE #19",
      "Address": " 7134 SEPULVEDA BLVD",
      "City": "VAN NUYS",
      "Zip Code": " 91405",
      "County": " LOS ANGELES",
      "Latitude": "34.1999850  ",
      "Longitude": " -118.46528 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #117",
      "Address": " 1033 LONG BEACH BLVD",
      "City": "LONG BEACH",
      "Zip Code": " 90813",
      "County": " LOS ANGELES",
      "Latitude": "33.7797360  ",
      "Longitude": " -118.18998 "
   },
   {
      "Vendor": "CALIFORNIA KIDS NUTR. CENTE",
      "Address": "E 4505 SLAUSON AVE",
      "Second Address": " STE D",
      "City": "MAYWOOD",
      "Zip Code": " 90270",
      "County": " LOS ANGELES",
      "Latitude": "33.9873620  ",
      "Longitude": " -118.18476 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #118",
      "Address": " 6140 LANKERSHIM BLVD",
      "City": "NORTH HOLLYWOOD",
      "Zip Code": " 91606",
      "County": " LOS ANGELES",
      "Latitude": "34.1820390  ",
      "Longitude": " -118.38427 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#452",
      "Address": "N 4311 FIGUEROA ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90065",
      "County": " LOS ANGELES",
      "Latitude": "34.0948590  ",
      "Longitude": " -118.20821 "
   },
   {
      "Vendor": "LA TROPICANA MARKET",
      "Address": " 5200 MONTE VISTA ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90042",
      "County": " LOS ANGELES",
      "Latitude": "34.1084510  ",
      "Longitude": " -118.20082 "
   },
   {
      "Vendor": "US FOOD MARKET",
      "Address": "W 1451 WASHINGTON BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90007",
      "County": " LOS ANGELES",
      "Latitude": "34.0403340  ",
      "Longitude": " -118.28796 "
   },
   {
      "Vendor": "EL SUPER #05",
      "Address": " 12727 SHERMAN WAY",
      "City": "NORTH HOLLYWOOD",
      "Zip Code": " 91605",
      "County": " LOS ANGELES",
      "Latitude": "34.2022220  ",
      "Longitude": " -118.41073 "
   },
   {
      "Vendor": "PICO MARKET",
      "Address": "E 8329 WHITTIER BLVD",
      "City": "PICO RIVERA",
      "Zip Code": " 90660",
      "County": " LOS ANGELES",
      "Latitude": "34.0065380  ",
      "Longitude": " -118.09591 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #17",
      "Address": " 10950 SHERMAN WAY",
      "City": "BURBANK",
      "Zip Code": " 91505",
      "County": " LOS ANGELES",
      "Latitude": "34.2002830  ",
      "Longitude": " -118.36852 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #20",
      "Address": "E 1803 PALMDALE BLVD",
      "City": "PALMDALE",
      "Zip Code": " 93550",
      "County": " LOS ANGELES",
      "Latitude": "34.5808650  ",
      "Longitude": " -118.09600 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #119",
      "Address": " 5450 CHERRY AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90805",
      "County": " LOS ANGELES",
      "Latitude": "33.8560230  ",
      "Longitude": " -118.16652 "
   },
   {
      "Vendor": "R-RANCH MARKET #14",
      "Address": "W 5212 ADAMS BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90016",
      "County": " LOS ANGELES",
      "Latitude": "34.0317650  ",
      "Longitude": " -118.35599 "
   },
   {
      "Vendor": "BIG SAVER FOODS #15",
      "Address": "W 1500 WILLOW ST",
      "City": "LONG BEACH",
      "Zip Code": " 90810",
      "County": " LOS ANGELES",
      "Latitude": "33.8037770  ",
      "Longitude": " -118.21272 "
   },
   {
      "Vendor": "JON'S MARKETPLACE #24",
      "Address": " 18135 SHERMAN WAY",
      "City": "RESEDA",
      "Zip Code": " 91335",
      "County": " LOS ANGELES",
      "Latitude": "34.2021290  ",
      "Longitude": " -118.52883 "
   },
   {
      "Vendor": "PAYLESS FOODS #10",
      "Address": "E 620 EL SEGUNDO BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90059",
      "County": " LOS ANGELES",
      "Latitude": "33.9153310  ",
      "Longitude": " -118.26473 "
   },
   {
      "Vendor": "BEST BARGAIN",
      "Address": "W 209 ARBOR VITAE ST",
      "City": "INGLEWOOD",
      "Zip Code": " 90301",
      "County": " LOS ANGELES",
      "Latitude": "33.9529000  ",
      "Longitude": " -118.35845 "
   },
   {
      "Vendor": "SAFEWAY #1502",
      "Address": " 1701 SANTA RITA RD",
      "City": "PLEASANTON",
      "Zip Code": " 94566",
      "County": " ALAMEDA",
      "Latitude": "37.6748890  ",
      "Longitude": " -121.87357 "
   },
   {
      "Vendor": "SAFEWAY #0654",
      "Address": " 2096 MOUNTAIN BLVD",
      "City": "OAKLAND",
      "Zip Code": " 94611",
      "County": " ALAMEDA",
      "Latitude": "37.8254450  ",
      "Longitude": " -122.20893 "
   },
   {
      "Vendor": "SAFEWAY #0797",
      "Address": "W 231 JACKSON ST",
      "City": "HAYWARD",
      "Zip Code": " 94544",
      "County": " ALAMEDA",
      "Latitude": "37.6525050  ",
      "Longitude": " -122.09117 "
   },
   {
      "Vendor": "SAFEWAY #0908",
      "Address": " 3550 FRUITVALE AVE",
      "City": "OAKLAND",
      "Zip Code": " 94602",
      "County": " ALAMEDA",
      "Latitude": "37.8013000  ",
      "Longitude": " -122.21504 "
   },
   {
      "Vendor": "SAFEWAY #0910",
      "Address": " 1554 FIRST ST",
      "City": "LIVERMORE",
      "Zip Code": " 94550",
      "County": " ALAMEDA",
      "Latitude": "37.6795050  ",
      "Longitude": " -121.77680 "
   },
   {
      "Vendor": "SAFEWAY #0768",
      "Address": " 20629 REDWOOD RD",
      "City": "CASTRO VALLEY",
      "Zip Code": " 94546",
      "County": " ALAMEDA",
      "Latitude": "37.6960120  ",
      "Longitude": " -122.07507 "
   },
   {
      "Vendor": "SAFEWAY #0676",
      "Address": " 1500 SOLANO AVE",
      "City": "ALBANY",
      "Zip Code": " 94706",
      "County": " ALAMEDA",
      "Latitude": "37.8907060  ",
      "Longitude": " -122.28761 "
   },
   {
      "Vendor": "SAFEWAY #0691",
      "Address": " 1444 SHATTUCK PL",
      "City": "BERKELEY",
      "Zip Code": " 94709",
      "County": " ALAMEDA",
      "Latitude": "37.8813680  ",
      "Longitude": " -122.27009 "
   },
   {
      "Vendor": "SAFEWAY #0790",
      "Address": " 555 BANCROFT AVE",
      "City": "SAN LEANDRO",
      "Zip Code": " 94577",
      "County": " ALAMEDA",
      "Latitude": "37.7343870  ",
      "Longitude": " -122.15220 "
   },
   {
      "Vendor": "SAFEWAY #0951",
      "Address": " 867 ISLAND DR",
      "City": "ALAMEDA",
      "Zip Code": " 94502",
      "County": " ALAMEDA",
      "Latitude": "37.7375430  ",
      "Longitude": " -122.24025 "
   },
   {
      "Vendor": "SAFEWAY #0971",
      "Address": " 22280 FOOTHILL BLVD",
      "City": "HAYWARD",
      "Zip Code": " 94541",
      "County": " ALAMEDA",
      "Latitude": "37.6796070  ",
      "Longitude": " -122.08366 "
   },
   {
      "Vendor": "SAFEWAY #0994",
      "Address": " 1499 WASHINGTON AVE",
      "City": "SAN LEANDRO",
      "Zip Code": " 94577",
      "County": " ALAMEDA",
      "Latitude": "37.7231290  ",
      "Longitude": " -122.15616 "
   },
   {
      "Vendor": "SAFEWAY #0993",
      "Address": " 3902 WASHINGTON BLVD",
      "City": "FREMONT",
      "Zip Code": " 94538",
      "County": " ALAMEDA",
      "Latitude": "37.5317050  ",
      "Longitude": " -121.95709 "
   },
   {
      "Vendor": "PAK N SAVE #3111",
      "Address": " 555 FLORESTA BLVD",
      "City": "SAN LEANDRO",
      "Zip Code": " 94578",
      "County": " ALAMEDA",
      "Latitude": "37.7020910  ",
      "Longitude": " -122.14436 "
   },
   {
      "Vendor": "SAFEWAY #0309",
      "Address": " 39100 ARGONAUT WAY",
      "City": "FREMONT",
      "Zip Code": " 94536",
      "County": " ALAMEDA",
      "Latitude": "37.5451290  ",
      "Longitude": " -121.98964 "
   },
   {
      "Vendor": "DOLLAR PLUS MART",
      "Address": " 612 COTTONWOOD RD",
      "Second Address": " STE 100",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3479460  ",
      "Longitude": " -118.98573 "
   },
   {
      "Vendor": "EL MILAGRO MARKET",
      "Address": " 575 PANAMA LN",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.2955470  ",
      "Longitude": " -119.00830 "
   },
   {
      "Vendor": "ALBERTSONS #3364",
      "Address": " 7900 WHITE LN",
      "City": "BAKERSFIELD",
      "Zip Code": " 93309",
      "County": " KERN",
      "Latitude": "35.3191710  ",
      "Longitude": " -119.09016 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5859",
      "Address": "N 401 CENTRAL AVE",
      "City": "WASCO",
      "Zip Code": " 93280",
      "County": " KERN",
      "Latitude": "35.5978130  ",
      "Longitude": " -119.35833 "
   },
   {
      "Vendor": "WAL-MART NBRHD MARKET #3138",
      "Address": " 5625 CALLOWAY DR",
      "City": "BAKERSFIELD",
      "Zip Code": " 93312",
      "County": " KERN",
      "Latitude": "35.4119340  ",
      "Longitude": " -119.11207 "
   },
   {
      "Vendor": "WAL-MART NBRHD MARKET #3141",
      "Address": "E 5037 BRUNDAGE LN",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3534730  ",
      "Longitude": " -118.94789 "
   },
   {
      "Vendor": "WAL-MART NBRHD MARKET #3139",
      "Address": " 1249 ALLEN RD",
      "City": "BAKERSFIELD",
      "Zip Code": " 93314",
      "County": " KERN",
      "Latitude": "35.3694410  ",
      "Longitude": " -119.14577 "
   },
   {
      "Vendor": "CITY FOOD MARKET",
      "Address": " 900 DR MARTIN L. KING JR BLVD",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3668150  ",
      "Longitude": " -118.98567 "
   },
   {
      "Vendor": "LA PLAZITA MARKET",
      "Address": " 156 BEAR MOUNTAIN BLVD",
      "City": "ARVIN",
      "Zip Code": " 93203",
      "County": " KERN",
      "Latitude": "35.2092240  ",
      "Longitude": " -118.82648 "
   },
   {
      "Vendor": "MI RANCHO MARKET",
      "Address": "W 400 PERKINS AVE",
      "City": "MCFARLAND",
      "Zip Code": " 93250",
      "County": " KERN",
      "Latitude": "35.6822980  ",
      "Longitude": " -119.23274 "
   },
   {
      "Vendor": "CALIMEX MARKET",
      "Address": " 501 BOHANNAN AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3014440  ",
      "Longitude": " -118.99398 "
   },
   {
      "Vendor": "FIESTA FOOD MARKET #2",
      "Address": "E 2211 CALIFORNIA AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3682460  ",
      "Longitude": " -118.96723 "
   },
   {
      "Vendor": "ABC FOODS",
      "Address": " 2400 WIBLE RD",
      "Second Address": " STE 9",
      "City": "BAKERSFIELD",
      "Zip Code": " 93304",
      "County": " KERN",
      "Latitude": "35.3328710  ",
      "Longitude": " -119.03849 "
   },
   {
      "Vendor": "ABC FOODS",
      "Address": " 10501 MAIN ST",
      "Second Address": " STE 2",
      "City": "LAMONT",
      "Zip Code": " 93241",
      "County": " KERN",
      "Latitude": "35.2594860  ",
      "Longitude": " -118.91404 "
   },
   {
      "Vendor": "PEE WEE MARKET",
      "Address": " 1401 FLOWER ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93305",
      "County": " KERN",
      "Latitude": "35.3832620  ",
      "Longitude": " -118.97858 "
   },
   {
      "Vendor": "TROPICANA SUPERMARKET",
      "Address": " 2425 HIGHWAY 46",
      "City": "WASCO",
      "Zip Code": " 93280",
      "County": " KERN",
      "Latitude": "35.6005830  ",
      "Longitude": " -119.35255 "
   },
   {
      "Vendor": "STATE MARKET",
      "Address": " 1020 CECIL AVE",
      "City": "DELANO",
      "Zip Code": " 93215",
      "County": " KERN",
      "Latitude": "35.7750440  ",
      "Longitude": " -119.24467 "
   },
   {
      "Vendor": "FAMILY FOOD MARKET",
      "Address": " 731 34TH ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93301",
      "County": " KERN",
      "Latitude": "35.3900730  ",
      "Longitude": " -119.01023 "
   },
   {
      "Vendor": "SAVEMORE MARKET",
      "Address": " 521 FINLEY DR",
      "City": "TAFT",
      "Zip Code": " 93268",
      "County": " KERN",
      "Latitude": "35.1497750  ",
      "Longitude": " -119.45559 "
   },
   {
      "Vendor": "OWENS STREET MARKET",
      "Address": "S 347 OWENS ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3608980  ",
      "Longitude": " -118.99046 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1600",
      "Address": "E 201 BOWMAN RD",
      "City": "RIDGECREST",
      "Zip Code": " 93555",
      "County": " KERN",
      "Latitude": "35.6078140  ",
      "Longitude": " -117.66824 "
   },
   {
      "Vendor": "SMART & FINAL #803",
      "Address": " 2658 MT. VERNON AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93306",
      "County": " KERN",
      "Latitude": "35.3929720  ",
      "Longitude": " -118.96833 "
   },
   {
      "Vendor": "LA FLOR MERCADO",
      "Address": " 1200 FLOWER ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93305",
      "County": " KERN",
      "Latitude": "35.3845240  ",
      "Longitude": " -118.98148 "
   },
   {
      "Vendor": "JMJ MARKET",
      "Address": "E 1031 TRUXTON AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93305",
      "County": " KERN",
      "Latitude": "35.3729110  ",
      "Longitude": " -118.98782 "
   },
   {
      "Vendor": "BASIC NUTRITION #6",
      "Address": " 5645 AUBURN ST",
      "Second Address": " STE A",
      "City": "BAKERSFIELD",
      "Zip Code": " 93306",
      "County": " KERN",
      "Latitude": "35.3975000  ",
      "Longitude": " -118.93082 "
   },
   {
      "Vendor": "SHABAA MARKET",
      "Address": " 1101 NILES ST",
      "City": "BAKERSFIELD",
      "Zip Code": " 93305",
      "County": " KERN",
      "Latitude": "35.3801420  ",
      "Longitude": " -118.98476 "
   },
   {
      "Vendor": "JALISCO MEAT MARKET",
      "Address": " 320 HARRISON ST",
      "City": "TAFT",
      "Zip Code": " 93268",
      "County": " KERN",
      "Latitude": "35.1559390  ",
      "Longitude": " -119.45596 "
   },
   {
      "Vendor": "LA MEXICANA MARKET AND BAKERY",
      "Address": " 416 BEAR MOUNTAIN BLVD",
      "City": "ARVIN",
      "Zip Code": " 93203",
      "County": " KERN",
      "Latitude": "35.2092180  ",
      "Longitude": " -118.83032 "
   },
   {
      "Vendor": "SHAFTER FAMILY NUTRITION",
      "Address": " 226 CENTRAL AVE",
      "City": "SHAFTER",
      "Zip Code": " 93263",
      "County": " KERN",
      "Latitude": "35.5011540  ",
      "Longitude": " -119.27599 "
   },
   {
      "Vendor": "FAMILY FOOD CORNER, LLC",
      "Address": "N 2501 CHESTER AVE",
      "Second Address": "  SUITE 13",
      "City": "BAKERSFIELD",
      "Zip Code": " 93308",
      "County": " KERN",
      "Latitude": "35.4287260  ",
      "Longitude": " -119.02069 "
   },
   {
      "Vendor": "FAMILY FOODS",
      "Address": " 4621 AMERICAN AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93309",
      "County": " KERN",
      "Latitude": "35.3404060  ",
      "Longitude": " -119.05379 "
   },
   {
      "Vendor": "EL PUEBLO SUPERMARKET",
      "Address": " 1101 HWY 46",
      "City": "WASCO",
      "Zip Code": " 93280",
      "County": " KERN",
      "Latitude": "35.6012620  ",
      "Longitude": " -119.33853 "
   },
   {
      "Vendor": "LOS REYES MARKET",
      "Address": "S 2303 UNION AVE",
      "City": "BAKERSFIELD",
      "Zip Code": " 93307",
      "County": " KERN",
      "Latitude": "35.3216540  ",
      "Longitude": " -119.00553 "
   },
   {
      "Vendor": "LEMOORE COMMISSARY",
      "Address": " BLDG 795A REEVES BLVD",
      "Second Address": " BLDG 795A",
      "City": "NAS LEMOORE",
      "Zip Code": " 93246",
      "County": " KINGS",
      "Latitude": "36.2603020  ",
      "Longitude": " -119.91073 "
   },
   {
      "Vendor": "SAVE MART #036",
      "Address": "W 715 GRANGEVILLE BLVD",
      "City": "HANFORD",
      "Zip Code": " 93230",
      "County": " KINGS",
      "Latitude": "36.3413700  ",
      "Longitude": " -119.65619 "
   },
   {
      "Vendor": "SAVE MART #073",
      "Address": "W 105 HANFORD-ARMONA RD",
      "City": "LEMOORE",
      "Zip Code": " 93245",
      "County": " KINGS",
      "Latitude": "36.3130520  ",
      "Longitude": " -119.78267 "
   },
   {
      "Vendor": "COST LESS FOOD COMPANY",
      "Address": "S 102 11TH AVE",
      "City": "HANFORD",
      "Zip Code": " 93230",
      "County": " KINGS",
      "Latitude": "36.3225170  ",
      "Longitude": " -119.65575 "
   },
   {
      "Vendor": "COST LESS FOOD COMPANY",
      "Address": " 2001 WHITLEY AVE",
      "City": "CORCORAN",
      "Zip Code": " 93212",
      "County": " KINGS",
      "Latitude": "36.0975950  ",
      "Longitude": " -119.57306 "
   },
   {
      "Vendor": "BEST BUY MARKET #2",
      "Address": "N 1798 10TH AVE",
      "City": "HANFORD",
      "Zip Code": " 93230",
      "County": " KINGS",
      "Latitude": "36.3441580  ",
      "Longitude": " -119.63749 "
   },
   {
      "Vendor": "AMIGO MARKET",
      "Address": " 407 SKYLINE BLVD",
      "City": "AVENAL",
      "Zip Code": " 93204",
      "County": " KINGS",
      "Latitude": "36.0028830  ",
      "Longitude": " -120.13230 "
   },
   {
      "Vendor": "FOODS CO #520",
      "Address": "W 1850 LACEY BLVD",
      "City": "HANFORD",
      "Zip Code": " 93230",
      "County": " KINGS",
      "Latitude": "36.3283130  ",
      "Longitude": " -119.67565 "
   },
   {
      "Vendor": "STATE FOODS",
      "Address": " 708 SKYLINE BLVD",
      "City": "AVENAL",
      "Zip Code": " 93204",
      "County": " KINGS",
      "Latitude": "36.0044330  ",
      "Longitude": " -120.12800 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1645",
      "Address": "S 250 12TH AVE",
      "City": "HANFORD",
      "Zip Code": " 93230",
      "County": " KINGS",
      "Latitude": "36.3216660  ",
      "Longitude": " -119.67577 "
   },
   {
      "Vendor": "BEST BUY MARKET #4",
      "Address": "W 1135 BUSH ST",
      "City": "LEMOORE",
      "Zip Code": " 93245",
      "County": " KINGS",
      "Latitude": "36.2972840  ",
      "Longitude": " -119.79808 "
   },
   {
      "Vendor": "HLA HLA MARKET",
      "Address": " 383 BROWN ST",
      "City": "KETTLEMEN CITY",
      "Zip Code": " 93239",
      "County": " KINGS",
      "Latitude": "36.0099050  ",
      "Longitude": " -119.95964 "
   },
   {
      "Vendor": "SMART & FINAL #376",
      "Address": "E 888 LACEY BLVD",
      "City": "HANFORD",
      "Zip Code": " 93230",
      "County": " KINGS",
      "Latitude": "36.3286460  ",
      "Longitude": " -119.63360 "
   },
   {
      "Vendor": "BABY'S NUTRITION #4",
      "Address": "E 202 8TH ST",
      "City": "HANFORD",
      "Zip Code": " 93230",
      "County": " KINGS",
      "Latitude": "36.3282150  ",
      "Longitude": " -119.64410 "
   },
   {
      "Vendor": "ROYAL FOOD",
      "Address": " 10990 14TH AVE",
      "City": "ARMONA",
      "Zip Code": " 93202",
      "County": " KINGS",
      "Latitude": "36.3137000  ",
      "Longitude": " -119.70901 "
   },
   {
      "Vendor": "TARGET STORE T-1906",
      "Address": "N 140 12TH AVE",
      "City": "HANFORD",
      "Zip Code": " 93230",
      "County": " KINGS",
      "Latitude": "36.3234430  ",
      "Longitude": " -119.67321 "
   },
   {
      "Vendor": "T & T MARKET",
      "Address": " 803 SKYLINE BLVD",
      "City": "AVENAL",
      "Zip Code": " 93204",
      "County": " KINGS",
      "Latitude": "36.0057810  ",
      "Longitude": " -120.12645 "
   },
   {
      "Vendor": "LEMOORE FOOD CENTER",
      "Address": "E 150 CINNAMON DR",
      "City": "LEMOORE",
      "Zip Code": " 93245",
      "County": " KINGS",
      "Latitude": "36.3078580  ",
      "Longitude": " -119.77931 "
   },
   {
      "Vendor": "FIRST STEP NUTRITION #15",
      "Address": "W 2213 WHITLEY AVE",
      "City": "CORCORAN",
      "Zip Code": " 93212",
      "County": " KINGS",
      "Latitude": "36.0977950  ",
      "Longitude": " -119.57575 "
   },
   {
      "Vendor": "KETTLEMAN CITY MARKET",
      "Address": " 216 BECKY PEASE ST",
      "City": "KETTLEMAN CITY",
      "Zip Code": " 93239",
      "County": " KINGS",
      "Latitude": "36.0088180  ",
      "Longitude": " -119.96001 "
   },
   {
      "Vendor": "EL REY SUPERMERCADO",
      "Address": " 10833 HANFORD / ARMONA RD",
      "City": "HANFORD",
      "Zip Code": " 93230",
      "County": " KINGS",
      "Latitude": "36.3142830  ",
      "Longitude": " -119.69463 "
   },
   {
      "Vendor": "SAFEWAY #0983",
      "Address": " 1071 11TH ST",
      "City": "LAKEPORT",
      "Zip Code": " 95453",
      "County": " LAKE",
      "Latitude": "39.0484860  ",
      "Longitude": " -122.92549 "
   },
   {
      "Vendor": "SAFEWAY #0984",
      "Address": " 14922 OLYMPIC DR",
      "City": "CLEARLAKE",
      "Zip Code": " 95422",
      "County": " LAKE",
      "Latitude": "38.9624990  ",
      "Longitude": " -122.63213 "
   },
   {
      "Vendor": "HARDESTER'S COBB STORE",
      "Address": " 16295 CALIFORNIA 175",
      "City": "COBB",
      "Zip Code": " 95426",
      "County": " LAKE",
      "Latitude": "38.8255860  ",
      "Longitude": " -122.72202 "
   },
   {
      "Vendor": "HARDESTER'S HIDDEN VALLEY",
      "Address": " 18983 HARTMAN RD",
      "City": "HIDDEN VALLEY LAKE",
      "Zip Code": " 95467",
      "County": " LAKE",
      "Latitude": "38.7949060  ",
      "Longitude": " -122.55539 "
   },
   {
      "Vendor": "FOODS ETC.",
      "Address": " 15290 LAKESHORE DR",
      "City": "CLEARLAKE",
      "Zip Code": " 95422",
      "County": " LAKE",
      "Latitude": "38.9499620  ",
      "Longitude": " -122.62640 "
   },
   {
      "Vendor": "OAKS RED & WHITE STORE",
      "Address": "E 12580 HIGHWAY 20",
      "City": "CLEARLAKE OAKS",
      "Zip Code": " 95423",
      "County": " LAKE",
      "Latitude": "39.0237720  ",
      "Longitude": " -122.67488 "
   },
   {
      "Vendor": "BRUNO'S SHOP SMART #73",
      "Address": " 355 LAKEPORT BLVD",
      "City": "LAKEPORT",
      "Zip Code": " 95453",
      "County": " LAKE",
      "Latitude": "39.0338270  ",
      "Longitude": " -122.91853 "
   },
   {
      "Vendor": "WAL-MART STORE #1979",
      "Address": " 15960 DAM RD",
      "City": "CLEARLAKE",
      "Zip Code": " 95422",
      "County": " LAKE",
      "Latitude": "38.9275380  ",
      "Longitude": " -122.61611 "
   },
   {
      "Vendor": "WAL-MART #5164",
      "Address": " 11729 IMPERIAL HWY",
      "City": "NORWALK",
      "Zip Code": " 90650",
      "County": " LOS ANGELES",
      "Latitude": "33.9173600  ",
      "Longitude": " -118.08342 "
   },
   {
      "Vendor": "SUPER CHAVEZ MARKET",
      "Address": " 14110 LAKESHORE DR",
      "City": "CLEARLAKE",
      "Zip Code": " 95422",
      "County": " LAKE",
      "Latitude": "38.9570270  ",
      "Longitude": " -122.64769 "
   },
   {
      "Vendor": "MAR-VAL SENTRY MARKET",
      "Address": "E 2265 HIGHWAY 20",
      "City": "NICE",
      "Zip Code": " 95464",
      "County": " LAKE",
      "Latitude": "39.1299820  ",
      "Longitude": " -122.87054 "
   },
   {
      "Vendor": "SAFEWAY #1218",
      "Address": " 2970 MAIN ST",
      "City": "SUSANVILLE",
      "Zip Code": " 96130",
      "County": " LASSEN",
      "Latitude": "40.4059710  ",
      "Longitude": " -120.63461 "
   },
   {
      "Vendor": "SUSANVILLE SUPERMARKET",
      "Address": " 50 GRAND AVE",
      "City": "SUSANVILLE",
      "Zip Code": " 96130",
      "County": " LASSEN",
      "Latitude": "40.4171000  ",
      "Longitude": " -120.65307 "
   },
   {
      "Vendor": "WAL-MART STORE #1616",
      "Address": " 2900 MAIN ST",
      "City": "SUSANVILLE",
      "Zip Code": " 96130",
      "County": " LASSEN",
      "Latitude": "40.4093390  ",
      "Longitude": " -120.63509 "
   },
   {
      "Vendor": "SAVE MART #077",
      "Address": " 1504 HOWARD RD",
      "City": "MADERA",
      "Zip Code": " 93637",
      "County": " MADERA",
      "Latitude": "36.9516830  ",
      "Longitude": " -120.07633 "
   },
   {
      "Vendor": "RALEY'S #340",
      "Address": " 40041 HIGHWAY 49",
      "City": "OAKHURST",
      "Zip Code": " 93644",
      "County": " MADERA",
      "Latitude": "37.3330230  ",
      "Longitude": " -119.65674 "
   },
   {
      "Vendor": "FOOD 4 LESS",
      "Address": "W 2360 CLEVELAND AVE",
      "City": "MADERA",
      "Zip Code": " 93637",
      "County": " MADERA",
      "Latitude": "36.9731930  ",
      "Longitude": " -120.08599 "
   },
   {
      "Vendor": "PAK N SAVE #3121",
      "Address": "W 2237 CLEVELAND AVE",
      "City": "MADERA",
      "Zip Code": " 93637",
      "County": " MADERA",
      "Latitude": "36.9768210  ",
      "Longitude": " -120.08369 "
   },
   {
      "Vendor": "VONS #2409",
      "Address": " 40044 HIGHWAY  49",
      "City": "OAKHURST",
      "Zip Code": " 93644",
      "County": " MADERA",
      "Latitude": "37.3306220  ",
      "Longitude": " -119.65895 "
   },
   {
      "Vendor": "SAVE MART #376",
      "Address": " 1143 COUNTRY CLUB DR",
      "City": "MADERA",
      "Zip Code": " 93638",
      "County": " MADERA",
      "Latitude": "36.9763870  ",
      "Longitude": " -120.07309 "
   },
   {
      "Vendor": "LA VINA MARKET",
      "Address": " 24117 AVENUE 9",
      "City": "MADERA",
      "Zip Code": " 93637",
      "County": " MADERA",
      "Latitude": "36.8804790  ",
      "Longitude": " -120.10818 "
   },
   {
      "Vendor": "FOOD FAIR MARKET",
      "Address": "N 1100 D ST",
      "Second Address": " STE 104",
      "City": "MADERA",
      "Zip Code": " 93638",
      "County": " MADERA",
      "Latitude": "36.9746260  ",
      "Longitude": " -120.06349 "
   },
   {
      "Vendor": "LA ESPERANZA FOOD CENTER",
      "Address": "E 823 CLEVELAND AVE",
      "City": "MADERA",
      "Zip Code": " 93638",
      "County": " MADERA",
      "Latitude": "36.9748320  ",
      "Longitude": " -120.05684 "
   },
   {
      "Vendor": "SAVE MART #103",
      "Address": "E 1225 ROBERTSON BLVD",
      "City": "CHOWCHILLA",
      "Zip Code": " 93610",
      "County": " MADERA",
      "Latitude": "37.1162350  ",
      "Longitude": " -120.26846 "
   },
   {
      "Vendor": "RANCHO SAN MIGUEL #024",
      "Address": "E 1410 YOSEMITE AVE",
      "City": "MADERA",
      "Zip Code": " 93638",
      "County": " MADERA",
      "Latitude": "36.9721740  ",
      "Longitude": " -120.04483 "
   },
   {
      "Vendor": "NORTH FORK SUPER MARKET",
      "Address": " 57027 ROAD 225",
      "City": "NORTH FORK",
      "Zip Code": " 93643",
      "County": " MADERA",
      "Latitude": "37.2298350  ",
      "Longitude": " -119.50863 "
   },
   {
      "Vendor": "QUICKEROO #555",
      "Address": "E 329 YOSEMITE AVE",
      "City": "MADERA",
      "Zip Code": " 93637",
      "County": " MADERA",
      "Latitude": "36.9640420  ",
      "Longitude": " -120.05673 "
   },
   {
      "Vendor": "WAL-MART STORE #1583",
      "Address": "W 1977 CLEVELAND AVE",
      "City": "MADERA",
      "Zip Code": " 93637",
      "County": " MADERA",
      "Latitude": "36.9755720  ",
      "Longitude": " -120.08114 "
   },
   {
      "Vendor": "SOUTH C MARKET 99 CENT STOR",
      "Address": " 605 SOUTH C ST",
      "City": "MADERA",
      "Zip Code": " 93638",
      "County": " MADERA",
      "Latitude": "36.9583587  ",
      "Longitude": " -120.05185 "
   },
   {
      "Vendor": "BABY'S NUTRITION CARE",
      "Address": "S 205 4TH ST",
      "City": "CHOWCHILLA",
      "Zip Code": " 93610",
      "County": " MADERA",
      "Latitude": "37.1208740  ",
      "Longitude": " -120.26082 "
   },
   {
      "Vendor": "COARSEGOLD MARKET",
      "Address": " 35305 HIGHWAY 41",
      "City": "COARSEGOLD",
      "Zip Code": " 93614",
      "County": " MADERA",
      "Latitude": "37.2620000  ",
      "Longitude": " -119.69932 "
   },
   {
      "Vendor": "BABY NUTRITION #5",
      "Address": "N 1104 D ST",
      "City": "MADERA",
      "Zip Code": " 93638",
      "County": " MADERA",
      "Latitude": "36.9748960  ",
      "Longitude": " -120.06348 "
   },
   {
      "Vendor": "HILLSIDE SUPERMARKET",
      "Address": " 28420 YOSEMITE SPRINGS PKWY",
      "City": "COARSEGOLD",
      "Zip Code": " 93614",
      "County": " MADERA",
      "Latitude": "37.1606860  ",
      "Longitude": " -119.74849 "
   },
   {
      "Vendor": "STATE FOODS MADERA",
      "Address": " 37405 AVENUE 12",
      "Second Address": " STE 401",
      "City": "MADERA",
      "Zip Code": " 93636",
      "County": " MADERA",
      "Latitude": "36.9234730  ",
      "Longitude": " -119.86857 "
   },
   {
      "Vendor": "STATE FOODS CHOWCHILLA",
      "Address": " 1315 ROBERTSON BLVD",
      "City": "CHOWCHILLA",
      "Zip Code": " 93610",
      "County": " MADERA",
      "Latitude": "37.1147970  ",
      "Longitude": " -120.26981 "
   },
   {
      "Vendor": "TORO LOCO #11",
      "Address": "N 748 D ST",
      "City": "MADERA",
      "Zip Code": " 93638",
      "County": " MADERA",
      "Latitude": "36.9694440  ",
      "Longitude": " -120.06340 "
   },
   {
      "Vendor": "PIONEER MARKET",
      "Address": " 5034 COAKLEY CIR",
      "City": "MARIPOSA",
      "Zip Code": " 95338",
      "County": " MARIPOSA",
      "Latitude": "37.4887610  ",
      "Longitude": " -119.97211 "
   },
   {
      "Vendor": "EL SUPER #07",
      "Address": " 7000 ALAMEDA ST",
      "City": "HUNTINGTON PARK",
      "Zip Code": " 90255",
      "County": " LOS ANGELES",
      "Latitude": "33.9746830  ",
      "Longitude": " -118.23446 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKETS #25",
      "Address": " 3425 WHITTIER BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90023",
      "County": " LOS ANGELES",
      "Latitude": "34.0278250  ",
      "Longitude": " -118.20019 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #123",
      "Address": "S 11202 CRENSHAW BLVD",
      "City": "INGLEWOOD",
      "Zip Code": " 90303",
      "County": " LOS ANGELES",
      "Latitude": "33.9324070  ",
      "Longitude": " -118.32471 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1660",
      "Address": " 40130 10TH ST W",
      "City": "PALMDALE",
      "Zip Code": " 93551",
      "County": " LOS ANGELES",
      "Latitude": "34.6124340  ",
      "Longitude": " -118.14753 "
   },
   {
      "Vendor": "WINCO FOODS #57",
      "Address": " 90 RIO RANCHO RD",
      "City": "POMONA",
      "Zip Code": " 91766",
      "County": " LOS ANGELES",
      "Latitude": "34.0264360  ",
      "Longitude": " -117.76132 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKETS #18",
      "Address": " 10161 SAN FERNANDO RD",
      "City": "PACOIMA",
      "Zip Code": " 91331",
      "County": " LOS ANGELES",
      "Latitude": "34.2548800  ",
      "Longitude": " -118.41066 "
   },
   {
      "Vendor": "BIG SAVER FOODS #14",
      "Address": "E 9406 WASHINGTON BLVD",
      "City": "PICO RIVERA",
      "Zip Code": " 90660",
      "County": " LOS ANGELES",
      "Latitude": "33.9794060  ",
      "Longitude": " -118.09053 "
   },
   {
      "Vendor": "ADVANCE FOOD MARKET",
      "Address": "W 5469 ADAMS BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90016",
      "County": " LOS ANGELES",
      "Latitude": "34.0327400  ",
      "Longitude": " -118.36204 "
   },
   {
      "Vendor": "FOOD 4 LESS #761",
      "Address": " 13413 TELEGRAPH RD",
      "City": "WHITTIER",
      "Zip Code": " 90605",
      "County": " LOS ANGELES",
      "Latitude": "33.9399520  ",
      "Longitude": " -118.04556 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #3523",
      "Address": " 26471 CARL BOYER DR",
      "City": "SANTA CLARITA",
      "Zip Code": " 91350",
      "County": " LOS ANGELES",
      "Latitude": "34.4144010  ",
      "Longitude": " -118.50485 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #26",
      "Address": " 9011 WOODMAN AVE",
      "City": "ARLETA",
      "Zip Code": " 91331",
      "County": " LOS ANGELES",
      "Latitude": "34.2332020  ",
      "Longitude": " -118.43972 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #01",
      "Address": " 13051 VICTORY BLVD",
      "City": "NORTH HOLLYWOOD",
      "Zip Code": " 91606",
      "County": " LOS ANGELES",
      "Latitude": "34.1889310  ",
      "Longitude": " -118.41718 "
   },
   {
      "Vendor": "RALPHS #048",
      "Address": "W 3300 SLAUSON AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90043",
      "County": " LOS ANGELES",
      "Latitude": "33.9888150  ",
      "Longitude": " -118.32940 "
   },
   {
      "Vendor": "RALPHS #084",
      "Address": " 29675 THE OLD RD N",
      "City": "CASTAIC",
      "Zip Code": " 91384",
      "County": " LOS ANGELES",
      "Latitude": "34.4566620  ",
      "Longitude": " -118.61862 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2886",
      "Address": " 8500 WASHINGTON BLVD",
      "City": "PICO RIVERA",
      "Zip Code": " 90660",
      "County": " LOS ANGELES",
      "Latitude": "33.9851540  ",
      "Longitude": " -118.10480 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5154",
      "Address": " 1827 WALNUT GROVE BLVD",
      "City": "ROSEMEAD",
      "Zip Code": " 91770",
      "County": " LOS ANGELES",
      "Latitude": "34.0503330  ",
      "Longitude": " -118.08427 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #129",
      "Address": "W 133 AVENUE 45",
      "City": "LOS ANGELES",
      "Zip Code": " 90065",
      "County": " LOS ANGELES",
      "Latitude": "34.0971320  ",
      "Longitude": " -118.20784 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#234",
      "Address": "E 786 FOOTHILL BLVD",
      "Second Address": " STE A & B",
      "City": "RIALTO",
      "Zip Code": " 92376",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1072590  ",
      "Longitude": " -117.35565 "
   },
   {
      "Vendor": "LA MEXICANA MARKET",
      "Address": " 2090 SANTA FE AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90810",
      "County": " LOS ANGELES",
      "Latitude": "33.7951950  ",
      "Longitude": " -118.21538 "
   },
   {
      "Vendor": "ZEENA'S NUTRITION",
      "Address": "E 2120 FIRST ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90033",
      "County": " LOS ANGELES",
      "Latitude": "34.0444200  ",
      "Longitude": " -118.21316 "
   },
   {
      "Vendor": "WINCO FOODS #35",
      "Address": "W 740 AVENUE K-4",
      "City": "LANCASTER",
      "Zip Code": " 93534",
      "County": " LOS ANGELES",
      "Latitude": "34.6719370  ",
      "Longitude": " -118.14490 "
   },
   {
      "Vendor": "EL CANEY MARKET",
      "Address": " 4600 MAPLEWOOD AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90004",
      "County": " LOS ANGELES",
      "Latitude": "34.0797080  ",
      "Longitude": " -118.30475 "
   },
   {
      "Vendor": "CARNICERIA VALLARTA #2",
      "Address": " 13715 VANOWEN ST",
      "City": "VAN NUYS",
      "Zip Code": " 91405",
      "County": " LOS ANGELES",
      "Latitude": "34.1943050  ",
      "Longitude": " -118.43195 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #19",
      "Address": " 23449 LYONS AVE",
      "City": "VALENCIA",
      "Zip Code": " 91355",
      "County": " LOS ANGELES",
      "Latitude": "34.3798410  ",
      "Longitude": " -118.54399 "
   },
   {
      "Vendor": "CENTRO LATINO MARKET",
      "Address": "S 4512 HOOVER ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90037",
      "County": " LOS ANGELES",
      "Latitude": "34.0021720  ",
      "Longitude": " -118.28688 "
   },
   {
      "Vendor": "CORONADO MARKET",
      "Address": "W 2435 TEMPLE ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90026",
      "County": " LOS ANGELES",
      "Latitude": "34.0721050  ",
      "Longitude": " -118.27300 "
   },
   {
      "Vendor": "BAJA RANCH MARKET #5",
      "Address": "E 475 ORANGE GROVE BLVD",
      "City": "PASADENA",
      "Zip Code": " 91104",
      "County": " LOS ANGELES",
      "Latitude": "34.1579610  ",
      "Longitude": " -118.14058 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1563",
      "Address": " 44665 VALLEY CENTRAL WAY",
      "City": "LANCASTER",
      "Zip Code": " 93536",
      "County": " LOS ANGELES",
      "Latitude": "34.6931520  ",
      "Longitude": " -118.17202 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #24",
      "Address": " 19725 VANOWEN ST",
      "City": "WINNETKA",
      "Zip Code": " 91306",
      "County": " LOS ANGELES",
      "Latitude": "34.1938200  ",
      "Longitude": " -118.56323 "
   },
   {
      "Vendor": "EL AHORRO STORE",
      "Address": "W 449 ANAHEIM ST",
      "Second Address": " UNIT B",
      "City": "LONG BEACH",
      "Zip Code": " 90813",
      "County": " LOS ANGELES",
      "Latitude": "33.7829220  ",
      "Longitude": " -118.19753 "
   },
   {
      "Vendor": "EL RANCHITO MEAT MARKET",
      "Address": " 3293 FLETCHER DR",
      "City": "LOS ANGELES",
      "Zip Code": " 90065",
      "County": " LOS ANGELES",
      "Latitude": "34.1179550  ",
      "Longitude": " -118.24138 "
   },
   {
      "Vendor": "RALPHS #022",
      "Address": "W 645 9TH ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90015",
      "County": " LOS ANGELES",
      "Latitude": "34.0455490  ",
      "Longitude": " -118.26075 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#211",
      "Address": "S 4110 FIGUEROA ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90037",
      "County": " LOS ANGELES",
      "Latitude": "34.0087580  ",
      "Longitude": " -118.28243 "
   },
   {
      "Vendor": "SUPER KING MARKET #2",
      "Address": "N 2716 SAN FERNANDO RD",
      "City": "LOS ANGELES",
      "Zip Code": " 90065",
      "County": " LOS ANGELES",
      "Latitude": "34.1096460  ",
      "Longitude": " -118.24304 "
   },
   {
      "Vendor": "SUPER MERCADO LATINO MARKET",
      "Address": "W 1049 MARTIN L. KING JR BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90037",
      "County": " LOS ANGELES",
      "Latitude": "34.0114790  ",
      "Longitude": " -118.29340 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #104",
      "Address": "N 1858 DURFEE AVE",
      "City": "SOUTH EL MONTE",
      "Zip Code": " 91733",
      "County": " LOS ANGELES",
      "Latitude": "34.0432390  ",
      "Longitude": " -118.03060 "
   },
   {
      "Vendor": "MARAVILLA MEAT MARKET",
      "Address": "E 4732 CESAR E. CHAVEZ AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90022",
      "County": " LOS ANGELES",
      "Latitude": "34.0402840  ",
      "Longitude": " -118.16356 "
   },
   {
      "Vendor": "SADDLEBACK MARKET",
      "Address": "E 17051 AVE- O",
      "City": "PALMDALE",
      "Zip Code": " 93591",
      "County": " LOS ANGELES",
      "Latitude": "34.6169910  ",
      "Longitude": " -117.82620 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #131",
      "Address": " 9100 WHITTIER BLVD",
      "City": "PICO RIVERA",
      "Zip Code": " 90660",
      "County": " LOS ANGELES",
      "Latitude": "33.9997180  ",
      "Longitude": " -118.08284 "
   },
   {
      "Vendor": "BABY'S WORLD NUTRITION #2",
      "Address": "S 804 ALVARADO ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90057",
      "County": " LOS ANGELES",
      "Latitude": "34.0548050  ",
      "Longitude": " -118.27786 "
   },
   {
      "Vendor": "EL PAISA MARKET",
      "Address": "E 3901 CESAR E. CHAVEZ AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90063",
      "County": " LOS ANGELES",
      "Latitude": "34.0407700  ",
      "Longitude": " -118.18208 "
   },
   {
      "Vendor": "VONS #2832",
      "Address": " 1600 FOOTHILL BLVD",
      "City": "LA VERNE",
      "Zip Code": " 91750",
      "County": " LOS ANGELES",
      "Latitude": "34.1150480  ",
      "Longitude": " -117.77384 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#209",
      "Address": "W 700 IMPERIAL HWY",
      "Second Address": " UNIT 104",
      "City": "LOS ANGELES",
      "Zip Code": " 90044",
      "County": " LOS ANGELES",
      "Latitude": "33.9305880  ",
      "Longitude": " -118.28734 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#448",
      "Address": " 1805 INDIAN HILL BLVD",
      "City": "POMONA",
      "Zip Code": " 91767",
      "County": " LOS ANGELES",
      "Latitude": "34.0773100  ",
      "Longitude": " -117.71966 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #3522",
      "Address": " 3250 BIG DALTON AVE",
      "City": "BALDWIN PARK",
      "Zip Code": " 91706",
      "County": " LOS ANGELES",
      "Latitude": "34.0710870  ",
      "Longitude": " -117.96349 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2950",
      "Address": " 37140 47TH ST E",
      "City": "PALMDALE",
      "Zip Code": " 93552",
      "County": " LOS ANGELES",
      "Latitude": "34.5565940  ",
      "Longitude": " -118.04500 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2951",
      "Address": "E 1731 AVENUE J",
      "City": "LANCASTER",
      "Zip Code": " 93535",
      "County": " LOS ANGELES",
      "Latitude": "34.6898450  ",
      "Longitude": " -118.09846 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #6",
      "Address": " 16107 VICTORY BLVD",
      "City": "VAN NUYS",
      "Zip Code": " 91406",
      "County": " LOS ANGELES",
      "Latitude": "34.1869750  ",
      "Longitude": " -118.48477 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #14",
      "Address": "W 1801 AVENUE I",
      "City": "LANCASTER",
      "Zip Code": " 93534",
      "County": " LOS ANGELES",
      "Latitude": "34.7047360  ",
      "Longitude": " -118.16365 "
   },
   {
      "Vendor": "PAVILIONS #2813",
      "Address": " 29211 HEATHERCLIFF RD",
      "City": "MALIBU",
      "Zip Code": " 90265",
      "County": " LOS ANGELES",
      "Latitude": "34.0204920  ",
      "Longitude": " -118.80957 "
   },
   {
      "Vendor": "EL SUPER #09",
      "Address": "E 1575 HOLT AVE",
      "City": "POMONA",
      "Zip Code": " 91767",
      "County": " LOS ANGELES",
      "Latitude": "34.0649180  ",
      "Longitude": " -117.71980 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #27",
      "Address": "E 815 AVENUE K",
      "City": "LANCASTER",
      "Zip Code": " 93535",
      "County": " LOS ANGELES",
      "Latitude": "34.6752270  ",
      "Longitude": " -118.11447 "
   },
   {
      "Vendor": "VALLEY MARKET PLACE",
      "Address": " 18345 VANOWEN ST",
      "City": "RESEDA",
      "Zip Code": " 91335",
      "County": " LOS ANGELES",
      "Latitude": "34.1945740  ",
      "Longitude": " -118.53321 "
   },
   {
      "Vendor": "RALPHS #727",
      "Address": " 25930 MCBEAN PKWY",
      "City": "VALENCIA",
      "Zip Code": " 91355",
      "County": " LOS ANGELES",
      "Latitude": "34.4039140  ",
      "Longitude": " -118.55224 "
   },
   {
      "Vendor": "PAVILIONS #2225",
      "Address": " 6534 PLATT AVE",
      "City": "WEST HILLS",
      "Zip Code": " 91307",
      "County": " LOS ANGELES",
      "Latitude": "34.1892690  ",
      "Longitude": " -118.64266 "
   },
   {
      "Vendor": "EL SUPER #12",
      "Address": " 9710 WOODMAN AVE",
      "City": "ARLETA",
      "Zip Code": " 91331",
      "County": " LOS ANGELES",
      "Latitude": "34.2470100  ",
      "Longitude": " -118.44788 "
   },
   {
      "Vendor": "EL SUPER #13",
      "Address": "E 1301 GAGE AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90001",
      "County": " LOS ANGELES",
      "Latitude": "33.9826180  ",
      "Longitude": " -118.24989 "
   },
   {
      "Vendor": "EL SUPER #14",
      "Address": "W 960 ARROW HWY",
      "City": "COVINA",
      "Zip Code": " 91722",
      "County": " LOS ANGELES",
      "Latitude": "34.1060010  ",
      "Longitude": " -117.90883 "
   },
   {
      "Vendor": "EL SUPER #15",
      "Address": "W 3321 CENTURY BLVD",
      "City": "INGLEWOOD",
      "Zip Code": " 90303",
      "County": " LOS ANGELES",
      "Latitude": "33.9467090  ",
      "Longitude": " -118.33039 "
   },
   {
      "Vendor": "EL SUPER #16",
      "Address": " 10531 CARMENITA RD",
      "City": "SANTA FE SPRINGS",
      "Zip Code": " 90670",
      "County": " LOS ANGELES",
      "Latitude": "33.9397800  ",
      "Longitude": " -118.04678 "
   },
   {
      "Vendor": "EL SUPER #17",
      "Address": "W 1100 SLAUSON AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90044",
      "County": " LOS ANGELES",
      "Latitude": "33.9887190  ",
      "Longitude": " -118.29358 "
   },
   {
      "Vendor": "ZARAGOZA MEAT MARKET #1",
      "Address": " 14907 VANOWEN ST",
      "City": "VAN NUYS",
      "Zip Code": " 91405",
      "County": " LOS ANGELES",
      "Latitude": "34.1939180  ",
      "Longitude": " -118.45760 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#216",
      "Address": " 14549 TELEGRAPH RD",
      "City": "LA MIRADA",
      "Zip Code": " 90638",
      "County": " LOS ANGELES",
      "Latitude": "33.9232150  ",
      "Longitude": " -118.02166 "
   },
   {
      "Vendor": "SUPER KING MARKET #3",
      "Address": " 2260 LINCOLN AVE",
      "City": "ALTADENA",
      "Zip Code": " 91001",
      "County": " LOS ANGELES",
      "Latitude": "34.1844100  ",
      "Longitude": " -118.15930 "
   },
   {
      "Vendor": "QIK MARKET",
      "Address": " 7601 VINELAND AVE",
      "City": "SUN VALLEY",
      "Zip Code": " 91352",
      "County": " LOS ANGELES",
      "Latitude": "34.2087430  ",
      "Longitude": " -118.37080 "
   },
   {
      "Vendor": "JAY'S MARKET",
      "Address": "W 4000 PICO BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90019",
      "County": " LOS ANGELES",
      "Latitude": "34.0466100  ",
      "Longitude": " -118.32361 "
   },
   {
      "Vendor": "MICKEY'S NUTRITION",
      "Address": "E 7096 GAGE AVE",
      "City": "COMMERCE",
      "Zip Code": " 90040",
      "County": " LOS ANGELES",
      "Latitude": "33.9734820  ",
      "Longitude": " -118.12985 "
   },
   {
      "Vendor": "GREEN RANCHO MARKET",
      "Address": "N 837 WILMINGTON BLVD",
      "City": "WILMINGTON",
      "Zip Code": " 90744",
      "County": " LOS ANGELES",
      "Latitude": "33.7804990  ",
      "Longitude": " -118.27475 "
   },
   {
      "Vendor": "SMART & FINAL #308",
      "Address": "W 160 WILLOW ST",
      "City": "POMONA",
      "Zip Code": " 91768",
      "County": " LOS ANGELES",
      "Latitude": "34.0785830  ",
      "Longitude": " -117.75382 "
   },
   {
      "Vendor": "SMART & FINAL #310",
      "Address": " 1216 COMPTON AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90021",
      "County": " LOS ANGELES",
      "Latitude": "34.0276440  ",
      "Longitude": " -118.24177 "
   },
   {
      "Vendor": "SMART & FINAL #311",
      "Address": " 15930 BELLFLOWER BLVD",
      "City": "BELLFLOWER",
      "Zip Code": " 90706",
      "County": " LOS ANGELES",
      "Latitude": "33.8884020  ",
      "Longitude": " -118.12438 "
   },
   {
      "Vendor": "SMART & FINAL #319",
      "Address": "E 5029 FLORENCE AVE",
      "City": "BELL",
      "Zip Code": " 90201",
      "County": " LOS ANGELES",
      "Latitude": "33.9703810  ",
      "Longitude": " -118.17707 "
   },
   {
      "Vendor": "SMART & FINAL #325",
      "Address": " 10935 FIRESTONE BLVD",
      "City": "NORWALK",
      "Zip Code": " 90650",
      "County": " LOS ANGELES",
      "Latitude": "33.9232930  ",
      "Longitude": " -118.10006 "
   },
   {
      "Vendor": "SMART & FINAL #333",
      "Address": " 10833 LONG BEACH BLVD",
      "City": "LYNWOOD",
      "Zip Code": " 90262",
      "County": " LOS ANGELES",
      "Latitude": "33.9354030  ",
      "Longitude": " -118.21315 "
   },
   {
      "Vendor": "SMART & FINAL #337",
      "Address": "S 8137 VERMONT AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90044",
      "County": " LOS ANGELES",
      "Latitude": "33.9646970  ",
      "Longitude": " -118.29217 "
   },
   {
      "Vendor": "SMART & FINAL #341",
      "Address": "E 1125 EL SEGUNDO BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90059",
      "County": " LOS ANGELES",
      "Latitude": "33.9163630  ",
      "Longitude": " -118.25502 "
   },
   {
      "Vendor": "SMART & FINAL #345",
      "Address": "E 2308 4TH ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90033",
      "County": " LOS ANGELES",
      "Latitude": "34.0406630  ",
      "Longitude": " -118.21299 "
   },
   {
      "Vendor": "SMART & FINAL #349",
      "Address": " 7815 VAN NUYS BLVD",
      "City": "VAN NUYS",
      "Zip Code": " 91402",
      "County": " LOS ANGELES",
      "Latitude": "34.2127030  ",
      "Longitude": " -118.44986 "
   },
   {
      "Vendor": "SMART & FINAL #363",
      "Address": "N 939 WESTERN AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90029",
      "County": " LOS ANGELES",
      "Latitude": "34.0878910  ",
      "Longitude": " -118.30963 "
   },
   {
      "Vendor": "SMART & FINAL #364",
      "Address": "W 2949 PICO BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90006",
      "County": " LOS ANGELES",
      "Latitude": "34.0475650  ",
      "Longitude": " -118.30479 "
   },
   {
      "Vendor": "SMART & FINAL #366",
      "Address": "S 10100 CRENSHAW BLVD",
      "City": "INGLEWOOD",
      "Zip Code": " 90303",
      "County": " LOS ANGELES",
      "Latitude": "33.9331320  ",
      "Longitude": " -118.32643 "
   },
   {
      "Vendor": "SMART & FINAL #369",
      "Address": "S 20410 SUSANA RD",
      "City": "LONG BEACH",
      "Zip Code": " 90810",
      "County": " LOS ANGELES",
      "Latitude": "33.8462170  ",
      "Longitude": " -118.20609 "
   },
   {
      "Vendor": "SMART & FINAL #372",
      "Address": " 10893 SAN FERNANDO RD",
      "City": "PACOIMA",
      "Zip Code": " 91331",
      "County": " LOS ANGELES",
      "Latitude": "34.2678830  ",
      "Longitude": " -118.42462 "
   },
   {
      "Vendor": "SMART & FINAL #373",
      "Address": " 11110 RAMONA BLVD",
      "City": "EL MONTE",
      "Zip Code": " 91731",
      "County": " LOS ANGELES",
      "Latitude": "34.0728600  ",
      "Longitude": " -118.03154 "
   },
   {
      "Vendor": "SMART & FINAL #413",
      "Address": " 6060 FIGUEROA ST",
      "City": "HIGHLAND PARK",
      "Zip Code": " 90042",
      "County": " LOS ANGELES",
      "Latitude": "34.1114790  ",
      "Longitude": " -118.18763 "
   },
   {
      "Vendor": "SMART & FINAL #440",
      "Address": " 1320 ATLANTIC AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90813",
      "County": " LOS ANGELES",
      "Latitude": "33.7831550  ",
      "Longitude": " -118.18445 "
   },
   {
      "Vendor": "SMART & FINAL #456",
      "Address": "S 3607 VERMONT AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90007",
      "County": " LOS ANGELES",
      "Latitude": "34.0226570  ",
      "Longitude": " -118.29224 "
   },
   {
      "Vendor": "SMART & FINAL #457",
      "Address": " 1575 CENTINELA AVE",
      "City": "INGLEWOOD",
      "Zip Code": " 90302",
      "County": " LOS ANGELES",
      "Latitude": "33.9766290  ",
      "Longitude": " -118.36630 "
   },
   {
      "Vendor": "SMART & FINAL #459",
      "Address": " 2720 BEVERLY BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90057",
      "County": " LOS ANGELES",
      "Latitude": "34.0702870  ",
      "Longitude": " -118.27865 "
   },
   {
      "Vendor": "SMART & FINAL #470",
      "Address": " 2929 CRENSHAW BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90016",
      "County": " LOS ANGELES",
      "Latitude": "34.0281850  ",
      "Longitude": " -118.33546 "
   },
   {
      "Vendor": "SMART & FINAL #481",
      "Address": " 3123 BALDWIN PARK BLVD",
      "City": "BALDWIN PARK",
      "Zip Code": " 91706",
      "County": " LOS ANGELES",
      "Latitude": "34.0703130  ",
      "Longitude": " -117.97948 "
   },
   {
      "Vendor": "SMART & FINAL #522",
      "Address": "N 855 WILCOX AVE",
      "City": "MONTEBELLO",
      "Zip Code": " 90640",
      "County": " LOS ANGELES",
      "Latitude": "34.0314360  ",
      "Longitude": " -118.12610 "
   },
   {
      "Vendor": "BABIES CHOICE NUTRITION",
      "Address": " 1872 SANTA FE AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90810",
      "County": " LOS ANGELES",
      "Latitude": "33.7912230  ",
      "Longitude": " -118.21519 "
   },
   {
      "Vendor": "NORTHGATE MARKET #04",
      "Address": "E 9101 TELEGRAPH RD",
      "City": "PICO RIVERA",
      "Zip Code": " 90660",
      "County": " LOS ANGELES",
      "Latitude": "33.9601770  ",
      "Longitude": " -118.10770 "
   },
   {
      "Vendor": "NORTHGATE MARKET #06",
      "Address": "N 831 HACIENDA BLVD",
      "City": "LA PUENTE",
      "Zip Code": " 91744",
      "County": " LOS ANGELES",
      "Latitude": "34.0343240  ",
      "Longitude": " -117.95031 "
   },
   {
      "Vendor": "NORTHGATE MARKET #10",
      "Address": " 6801 ATLANTIC AVE",
      "City": "BELL",
      "Zip Code": " 90201",
      "County": " LOS ANGELES",
      "Latitude": "33.9742630  ",
      "Longitude": " -118.18823 "
   },
   {
      "Vendor": "NORTHGATE MARKET #12",
      "Address": " 2120 PACIFIC AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90806",
      "County": " LOS ANGELES",
      "Latitude": "33.7959140  ",
      "Longitude": " -118.19313 "
   },
   {
      "Vendor": "NORTHGATE MARKET #17",
      "Address": " 16259 PARAMOUNT BLVD",
      "City": "PARAMOUNT",
      "Zip Code": " 90723",
      "County": " LOS ANGELES",
      "Latitude": "33.8866300  ",
      "Longitude": " -118.16089 "
   },
   {
      "Vendor": "NORTHGATE MARKET #19",
      "Address": " 2633 SANTA ANA ST",
      "City": "SOUTH GATE",
      "Zip Code": " 90280",
      "County": " LOS ANGELES",
      "Latitude": "33.9646760  ",
      "Longitude": " -118.22399 "
   },
   {
      "Vendor": "NORTHGATE MARKET #20",
      "Address": " 3828 PECK RD",
      "City": "EL MONTE",
      "Zip Code": " 91732",
      "County": " LOS ANGELES",
      "Latitude": "34.0750620  ",
      "Longitude": " -118.02132 "
   },
   {
      "Vendor": "NORTHGATE MARKET #22",
      "Address": "W 1320 FRANCISQUITO AVE",
      "City": "WEST COVINA",
      "Zip Code": " 91790",
      "County": " LOS ANGELES",
      "Latitude": "34.0526310  ",
      "Longitude": " -117.95443 "
   },
   {
      "Vendor": "NORTHGATE MARKET #24",
      "Address": "E 11660 FIRESTONE BLVD",
      "City": "NORWALK",
      "Zip Code": " 90650",
      "County": " LOS ANGELES",
      "Latitude": "33.9044140  ",
      "Longitude": " -118.06576 "
   },
   {
      "Vendor": "NORTHGATE MARKET #25",
      "Address": "W 3930 ROSECRANS AVE",
      "City": "HAWTHORNE",
      "Zip Code": " 90250",
      "County": " LOS ANGELES",
      "Latitude": "33.9005820  ",
      "Longitude": " -118.34349 "
   },
   {
      "Vendor": "SMART & FINAL #332",
      "Address": " 604 LINCOLN BLVD",
      "City": "VENICE",
      "Zip Code": " 90291",
      "County": " LOS ANGELES",
      "Latitude": "33.9998880  ",
      "Longitude": " -118.46484 "
   },
   {
      "Vendor": "SMART & FINAL #477",
      "Address": " 16847 VENTURA BLVD",
      "City": "ENCINO",
      "Zip Code": " 91316",
      "County": " LOS ANGELES",
      "Latitude": "34.1591300  ",
      "Longitude": " -118.50022 "
   },
   {
      "Vendor": "SMART & FINAL #324",
      "Address": " 22631 VENTURA BLVD",
      "City": "WOODLAND HILLS",
      "Zip Code": " 91364",
      "County": " LOS ANGELES",
      "Latitude": "34.1669090  ",
      "Longitude": " -118.62052 "
   },
   {
      "Vendor": "SMART & FINAL #528",
      "Address": " 10340 MASON AVE",
      "City": "CHATSWORTH",
      "Zip Code": " 91311",
      "County": " LOS ANGELES",
      "Latitude": "34.2584990  ",
      "Longitude": " -118.57889 "
   },
   {
      "Vendor": "SMART & FINAL #414",
      "Address": " 6555 FOOTHILL BLVD",
      "City": "TUJUNGA",
      "Zip Code": " 91042",
      "County": " LOS ANGELES",
      "Latitude": "34.2463000  ",
      "Longitude": " -118.27465 "
   },
   {
      "Vendor": "SMART & FINAL #460",
      "Address": " 16210 DEVONSHIRE ST",
      "City": "GRANADA HILLS",
      "Zip Code": " 91344",
      "County": " LOS ANGELES",
      "Latitude": "34.2574130  ",
      "Longitude": " -118.48552 "
   },
   {
      "Vendor": "SMART & FINAL #483",
      "Address": " 28207 NEWHALL RANCH RD",
      "City": "VALENCIA",
      "Zip Code": " 91354",
      "County": " LOS ANGELES",
      "Latitude": "34.4416190  ",
      "Longitude": " -118.57751 "
   },
   {
      "Vendor": "SMART & FINAL #468",
      "Address": " 23640 LYONS AVE",
      "Second Address": " STE B",
      "City": "SANTA CLARITA",
      "Zip Code": " 91321",
      "County": " LOS ANGELES",
      "Latitude": "34.3779630  ",
      "Longitude": " -118.54732 "
   },
   {
      "Vendor": "SMART & FINAL #304",
      "Address": "N 210 VERDUGO RD",
      "City": "GLENDALE",
      "Zip Code": " 91206",
      "County": " LOS ANGELES",
      "Latitude": "34.1486290  ",
      "Longitude": " -118.23467 "
   },
   {
      "Vendor": "SMART & FINAL #485",
      "Address": "E 3299 COLORADO BLVD",
      "City": "PASADENA",
      "Zip Code": " 91107",
      "County": " LOS ANGELES",
      "Latitude": "34.1467540  ",
      "Longitude": " -118.08330 "
   },
   {
      "Vendor": "SMART & FINAL #370",
      "Address": "N 401 FAIR OAKS AVE",
      "City": "PASADENA",
      "Zip Code": " 91103",
      "County": " LOS ANGELES",
      "Latitude": "34.1526370  ",
      "Longitude": " -118.15143 "
   },
   {
      "Vendor": "SMART & FINAL #321",
      "Address": "E 725 MAIN ST",
      "City": "ALHAMBRA",
      "Zip Code": " 91801",
      "County": " LOS ANGELES",
      "Latitude": "34.0987690  ",
      "Longitude": " -118.11930 "
   },
   {
      "Vendor": "SMART & FINAL #367",
      "Address": "N 114 AZUSA AVE",
      "City": "COVINA",
      "Zip Code": " 91722",
      "County": " LOS ANGELES",
      "Latitude": "34.0868300  ",
      "Longitude": " -117.90659 "
   },
   {
      "Vendor": "SMART & FINAL #395",
      "Address": "W 11221 PICO BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90064",
      "County": " LOS ANGELES",
      "Latitude": "34.0367070  ",
      "Longitude": " -118.43759 "
   },
   {
      "Vendor": "SMART & FINAL #374",
      "Address": "N 6601 LAUREL CANYON BLVD",
      "City": "NORTH HOLLYWOOD",
      "Zip Code": " 91606",
      "County": " LOS ANGELES",
      "Latitude": "34.1907220  ",
      "Longitude": " -118.39743 "
   },
   {
      "Vendor": "SMART & FINAL #474",
      "Address": " 1041 FULLER AVE",
      "City": "WEST HOLLYWOOD",
      "Zip Code": " 90046",
      "County": " LOS ANGELES",
      "Latitude": "34.0899910  ",
      "Longitude": " -118.34983 "
   },
   {
      "Vendor": "SMART & FINAL #306",
      "Address": "S 28500 WESTERN AVE",
      "City": "RANCHO PALOS VERDES",
      "Zip Code": " 90275",
      "County": " LOS ANGELES",
      "Latitude": "33.7608630  ",
      "Longitude": " -118.31163 "
   },
   {
      "Vendor": "SMART & FINAL #348",
      "Address": "S 21600 VERMONT AVE",
      "City": "TORRANCE",
      "Zip Code": " 90502",
      "County": " LOS ANGELES",
      "Latitude": "33.8328630  ",
      "Longitude": " -118.28938 "
   },
   {
      "Vendor": "SMART & FINAL #458",
      "Address": " 2775 PACIFIC COAST HWY",
      "City": "TORRANCE",
      "Zip Code": " 90505",
      "County": " LOS ANGELES",
      "Latitude": "33.7934920  ",
      "Longitude": " -118.33511 "
   },
   {
      "Vendor": "SMART & FINAL #529",
      "Address": " 15205 HAWTHORNE BLVD",
      "City": "LAWNDALE",
      "Zip Code": " 90260",
      "County": " LOS ANGELES",
      "Latitude": "33.8932210  ",
      "Longitude": " -118.35333 "
   },
   {
      "Vendor": "SMART & FINAL #371",
      "Address": " 5555 WILSHIRE BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90036",
      "County": " LOS ANGELES",
      "Latitude": "34.0626990  ",
      "Longitude": " -118.34973 "
   },
   {
      "Vendor": "SMART & FINAL #315",
      "Address": " 12210 SANTA MONICA BLVD",
      "City": "WEST LOS ANGELES",
      "Zip Code": " 90025",
      "County": " LOS ANGELES",
      "Latitude": "34.0397170  ",
      "Longitude": " -118.46445 "
   },
   {
      "Vendor": "SMART & FINAL #330",
      "Address": " 10113 VENICE BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90034",
      "County": " LOS ANGELES",
      "Latitude": "34.0226830  ",
      "Longitude": " -118.40066 "
   },
   {
      "Vendor": "NORTHGATE MARKET #23",
      "Address": "W 307 PACIFIC COAST HWY",
      "City": "WILMINGTON",
      "Zip Code": " 90744",
      "County": " LOS ANGELES",
      "Latitude": "33.7922570  ",
      "Longitude": " -118.26644 "
   },
   {
      "Vendor": "NUMERO UNO MARKET #105",
      "Address": "S 2226 SAN PEDRO ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90011",
      "County": " LOS ANGELES",
      "Latitude": "34.0242820  ",
      "Longitude": " -118.25925 "
   },
   {
      "Vendor": "NUMERO UNO MARKET #101",
      "Address": "E 701 JEFFERSON BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90011",
      "County": " LOS ANGELES",
      "Latitude": "34.0153990  ",
      "Longitude": " -118.26451 "
   },
   {
      "Vendor": "NUMERO UNO MARKET #102",
      "Address": "S 1309 ALVARADO ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90006",
      "County": " LOS ANGELES",
      "Latitude": "34.0469500  ",
      "Longitude": " -118.28288 "
   },
   {
      "Vendor": "NUMERO UNO MARKET #103",
      "Address": "S 9127 FIGUEROA ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90003",
      "County": " LOS ANGELES",
      "Latitude": "33.9535640  ",
      "Longitude": " -118.28308 "
   },
   {
      "Vendor": "NUMERO UNO MARKET #104",
      "Address": "E 310 MANCHESTER AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90003",
      "County": " LOS ANGELES",
      "Latitude": "33.9598070  ",
      "Longitude": " -118.26843 "
   },
   {
      "Vendor": "NUMERO UNO MARKET #106",
      "Address": "S 500 PACIFIC AVE",
      "City": "SAN PEDRO",
      "Zip Code": " 90731",
      "County": " LOS ANGELES",
      "Latitude": "33.7393860  ",
      "Longitude": " -118.28726 "
   },
   {
      "Vendor": "NUMERO UNO MARKET #107",
      "Address": "S 4710 BROADWAY",
      "City": "LOS ANGELES",
      "Zip Code": " 90037",
      "County": " LOS ANGELES",
      "Latitude": "34.0006700  ",
      "Longitude": " -118.27794 "
   },
   {
      "Vendor": "NUMERO UNO MARKET #108",
      "Address": "S 4373 VERMONT AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90037",
      "County": " LOS ANGELES",
      "Latitude": "34.0040950  ",
      "Longitude": " -118.29240 "
   },
   {
      "Vendor": "BELLAMAR MARKET",
      "Address": "W 2607 6TH ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90057",
      "County": " LOS ANGELES",
      "Latitude": "34.0622810  ",
      "Longitude": " -118.28042 "
   },
   {
      "Vendor": "LA BODEGA #3",
      "Address": "S 2715 WESTERN AVE",
      "Second Address": " STE D",
      "City": "LOS ANGELES",
      "Zip Code": " 90018",
      "County": " LOS ANGELES",
      "Latitude": "34.0304050  ",
      "Longitude": " -118.30929 "
   },
   {
      "Vendor": "LA CACHANILLA",
      "Address": "W 615 MISSION BLVD",
      "City": "POMONA",
      "Zip Code": " 91766",
      "County": " LOS ANGELES",
      "Latitude": "34.0552420  ",
      "Longitude": " -117.75596 "
   },
   {
      "Vendor": "LA FLOR DE MICHOACAN BAKERY",
      "Address": " 7045 SOMERSET BLVD",
      "City": "PARAMOUNT",
      "Zip Code": " 90723",
      "County": " LOS ANGELES",
      "Latitude": "33.8966030  ",
      "Longitude": " -118.17597 "
   },
   {
      "Vendor": "LA FORTUNA MEAT MARKET",
      "Address": "S 3200 CENTRAL AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90011",
      "County": " LOS ANGELES",
      "Latitude": "34.0143810  ",
      "Longitude": " -118.25619 "
   },
   {
      "Vendor": "MERCADO MEXICO",
      "Address": "E 3554 WHITTIER BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90023",
      "County": " LOS ANGELES",
      "Latitude": "34.0237280  ",
      "Longitude": " -118.18473 "
   },
   {
      "Vendor": "CIRCLE H MARKETS",
      "Address": "N 3131 SAN FERNANDO RD",
      "City": "LOS ANGELES",
      "Zip Code": " 90065",
      "County": " LOS ANGELES",
      "Latitude": "34.1156440  ",
      "Longitude": " -118.24660 "
   },
   {
      "Vendor": "CIRCLE H MARKETS",
      "Address": "W 2511 SUNSET BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90026",
      "County": " LOS ANGELES",
      "Latitude": "34.0799850  ",
      "Longitude": " -118.26927 "
   },
   {
      "Vendor": "EL RANCHO MARKET",
      "Address": " 960 VINE ST N",
      "City": "LOS ANGELES",
      "Zip Code": " 90038",
      "County": " LOS ANGELES",
      "Latitude": "34.0884960  ",
      "Longitude": " -118.32642 "
   },
   {
      "Vendor": "VILLA GUERRERO MARKET",
      "Address": "W 401 ROSECRANS AVE",
      "City": "COMPTON",
      "Zip Code": " 90222",
      "County": " LOS ANGELES",
      "Latitude": "33.9035450  ",
      "Longitude": " -118.23020 "
   },
   {
      "Vendor": "THE NEW COUNTRY STORE",
      "Address": "E 458 DUARTE RD",
      "City": "MONROVIA",
      "Zip Code": " 91016",
      "County": " LOS ANGELES",
      "Latitude": "34.1322040  ",
      "Longitude": " -117.99294 "
   },
   {
      "Vendor": "TARGET STORE T-2350",
      "Address": "E 38019 47TH ST",
      "City": "PALMDALE",
      "Zip Code": " 93552",
      "County": " LOS ANGELES",
      "Latitude": "34.5739750  ",
      "Longitude": " -118.04810 "
   },
   {
      "Vendor": "EL SUPER #18",
      "Address": " 5610 YORK BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90042",
      "County": " LOS ANGELES",
      "Latitude": "34.1191350  ",
      "Longitude": " -118.19630 "
   },
   {
      "Vendor": "PAVILIONS #2739",
      "Address": " 8969 SANTA MONICA BLVD",
      "City": "WEST HOLLYWOOD",
      "Zip Code": " 90069",
      "County": " LOS ANGELES",
      "Latitude": "34.0836960  ",
      "Longitude": " -118.38680 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #135",
      "Address": "S 2000 CENTRAL AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90011",
      "County": " LOS ANGELES",
      "Latitude": "34.0229630  ",
      "Longitude": " -118.25143 "
   },
   {
      "Vendor": "BIG SAVER FOODS #18",
      "Address": "E 1313 ARTESIA BLVD",
      "City": "LONG BEACH",
      "Zip Code": " 90805",
      "County": " LOS ANGELES",
      "Latitude": "33.8751630  ",
      "Longitude": " -118.17587 "
   },
   {
      "Vendor": "EL SUPER #21",
      "Address": " 14601 LAKEWOOD BLVD",
      "Second Address": " STE B",
      "City": "PARAMOUNT",
      "Zip Code": " 90723",
      "County": " LOS ANGELES",
      "Latitude": "33.9006730  ",
      "Longitude": " -118.14470 "
   },
   {
      "Vendor": "BAJA RANCH MARKET #3",
      "Address": "S 425 CITRUS AVE",
      "City": "COVINA",
      "Zip Code": " 91723",
      "County": " LOS ANGELES",
      "Latitude": "34.0816290  ",
      "Longitude": " -117.89032 "
   },
   {
      "Vendor": "JIMENEZ MARKET",
      "Address": " 1670 INDIAN HILL BLVD",
      "City": "POMONA",
      "Zip Code": " 91762",
      "County": " LOS ANGELES",
      "Latitude": "34.0751480  ",
      "Longitude": " -117.71853 "
   },
   {
      "Vendor": "SMART & FINAL #428",
      "Address": "W 1855 GLENOAKS BLVD",
      "City": "GLENDALE",
      "Zip Code": " 91201",
      "County": " LOS ANGELES",
      "Latitude": "34.1746600  ",
      "Longitude": " -118.29230 "
   },
   {
      "Vendor": "SMART & FINAL #511",
      "Address": " 2511 DALY ST",
      "City": "LINCOLN HEIGHTS",
      "Zip Code": " 90031",
      "County": " LOS ANGELES",
      "Latitude": "34.0754640  ",
      "Longitude": " -118.21655 "
   },
   {
      "Vendor": "SUPER A FOODS #01",
      "Address": " 5595 ROSEMEAD BLVD",
      "City": "TEMPLE CITY",
      "Zip Code": " 91780",
      "County": " LOS ANGELES",
      "Latitude": "34.1012260  ",
      "Longitude": " -118.07502 "
   },
   {
      "Vendor": "MOMMY'S NUTRITIONAL CENTER",
      "Address": "W 1644 CARSON ST",
      "Second Address": " STE D",
      "City": "TORRANCE",
      "Zip Code": " 90501",
      "County": " LOS ANGELES",
      "Latitude": "33.8310010  ",
      "Longitude": " -118.30777 "
   },
   {
      "Vendor": "MOMMY'S NUTRITIONAL CENTER #11",
      "Address": " 4455 117TH ST",
      "Second Address": " STE 102",
      "City": "HAWTHORNE",
      "Zip Code": " 90250",
      "County": " LOS ANGELES",
      "Latitude": "33.9286600  ",
      "Longitude": " -118.35394 "
   },
   {
      "Vendor": "MOMMY'S NUTRITIONAL CENTER #12",
      "Address": "S 271 & 273 ATLANTIC BLVD",
      "Second Address": " STE B & A",
      "City": "LOS ANGELES",
      "Zip Code": " 90022",
      "County": " LOS ANGELES",
      "Latitude": "34.0329870  ",
      "Longitude": " -118.15403 "
   },
   {
      "Vendor": "MINI MARKET JUREMA",
      "Address": "E 852 MANCHESTER AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90001",
      "County": " LOS ANGELES",
      "Latitude": "33.9598610  ",
      "Longitude": " -118.25889 "
   },
   {
      "Vendor": "SMART & FINAL #512",
      "Address": " 7224 MASON AVE",
      "City": "WINNETKA",
      "Zip Code": " 91306",
      "County": " LOS ANGELES",
      "Latitude": "34.2020080  ",
      "Longitude": " -118.57889 "
   },
   {
      "Vendor": "TIENDA LATINA MARKET",
      "Address": "S 10333 INGLEWOOD BLVD",
      "City": "INGLEWOOD",
      "Zip Code": " 90304",
      "County": " LOS ANGELES",
      "Latitude": "33.9419720  ",
      "Longitude": " -118.36173 "
   },
   {
      "Vendor": "LA TARASCA MEAT MARKET",
      "Address": " 8204 LONG BEACH BLVD",
      "Second Address": " STE A",
      "City": "SOUTH GATE",
      "Zip Code": " 90280",
      "County": " LOS ANGELES",
      "Latitude": "33.9633770  ",
      "Longitude": " -118.22501 "
   },
   {
      "Vendor": "LOS JALISCIENSES MEAT MARKE",
      "Address": " 16310 HAWTHORNE BLVD",
      "City": "LAWNDALE",
      "Zip Code": " 90260",
      "County": " LOS ANGELES",
      "Latitude": "33.8823090  ",
      "Longitude": " -118.35204 "
   },
   {
      "Vendor": "RALEY'S #309",
      "Address": "N 3550 G ST",
      "City": "MERCED",
      "Zip Code": " 95348",
      "County": " MERCED",
      "Latitude": "37.3929960  ",
      "Longitude": " -120.46784 "
   },
   {
      "Vendor": "R-N MARKET",
      "Address": " 231 ATWATER BLVD",
      "City": "ATWATER",
      "Zip Code": " 95301",
      "County": " MERCED",
      "Latitude": "37.3422240  ",
      "Longitude": " -120.59781 "
   },
   {
      "Vendor": "SAVE MART #053",
      "Address": "W 150 OLIVE AVE",
      "City": "MERCED",
      "Zip Code": " 95348",
      "County": " MERCED",
      "Latitude": "37.3171170  ",
      "Longitude": " -120.47073 "
   },
   {
      "Vendor": "WINTON SUPERMARKET",
      "Address": "N 6592 WINTON WAY",
      "City": "WINTON",
      "Zip Code": " 95388",
      "County": " MERCED",
      "Latitude": "37.3830630  ",
      "Longitude": " -120.61205 "
   },
   {
      "Vendor": "FOOD 4 LESS",
      "Address": "W 1115 OLIVE AVE",
      "City": "MERCED",
      "Zip Code": " 95348",
      "County": " MERCED",
      "Latitude": "37.3201110  ",
      "Longitude": " -120.48901 "
   },
   {
      "Vendor": "ORIENT MARKET",
      "Address": " 254 BROADWAY AVE",
      "City": "ATWATER",
      "Zip Code": " 95301",
      "County": " MERCED",
      "Latitude": "37.3423920  ",
      "Longitude": " -120.59827 "
   },
   {
      "Vendor": "LIBERTY MARKET",
      "Address": " 1471 B ST",
      "Second Address": " STE E",
      "City": "LIVINGSTON",
      "Zip Code": " 95334",
      "County": " MERCED",
      "Latitude": "37.3864470  ",
      "Longitude": " -120.72201 "
   },
   {
      "Vendor": "FOOD MAXX #487",
      "Address": "W 1300 OLIVE AVE",
      "City": "MERCED",
      "Zip Code": " 95348",
      "County": " MERCED",
      "Latitude": "37.3182730  ",
      "Longitude": " -120.49210 "
   },
   {
      "Vendor": "SAVE MORE MARKET",
      "Address": " 2030 G ST",
      "City": "MERCED",
      "Zip Code": " 95340",
      "County": " MERCED",
      "Latitude": "37.3026070  ",
      "Longitude": " -120.47356 "
   },
   {
      "Vendor": "DELHI LIBERTY MARKET",
      "Address": " 16385 SCHENDEL AVE",
      "City": "DELHI",
      "Zip Code": " 95315",
      "County": " MERCED",
      "Latitude": "37.4261980  ",
      "Longitude": " -120.78421 "
   },
   {
      "Vendor": "FOOD 4 LESS",
      "Address": " 2840 SHAFFER RD",
      "City": "ATWATER",
      "Zip Code": " 95301",
      "County": " MERCED",
      "Latitude": "37.3623240  ",
      "Longitude": " -120.59576 "
   },
   {
      "Vendor": "FOOD 4 LESS #07",
      "Address": " 2000 PACHECO BLVD",
      "City": "LOS BANOS",
      "Zip Code": " 93635",
      "County": " MERCED",
      "Latitude": "37.0570900  ",
      "Longitude": " -120.84790 "
   },
   {
      "Vendor": "FAMILY CARE",
      "Address": " 2275 F ST",
      "Second Address": " STE 6",
      "City": "LIVINGSTON",
      "Zip Code": " 95334",
      "County": " MERCED",
      "Latitude": "37.3824320  ",
      "Longitude": " -120.71313 "
   },
   {
      "Vendor": "MERCED FOOD CENTER",
      "Address": " 1150 MARTIN LUTHER KINGJR WAY",
      "City": "MERCED",
      "Zip Code": " 95340",
      "County": " MERCED",
      "Latitude": "37.2946990  ",
      "Longitude": " -120.48336 "
   },
   {
      "Vendor": "SAVE MART #102",
      "Address": " 1701 BELLEVUE RD",
      "City": "ATWATER",
      "Zip Code": " 95301",
      "County": " MERCED",
      "Latitude": "37.3621450  ",
      "Longitude": " -120.61227 "
   },
   {
      "Vendor": "RANCHO SAN MIGUEL #023",
      "Address": " 1930 YOSEMITE PKWY",
      "City": "MERCED",
      "Zip Code": " 95341",
      "County": " MERCED",
      "Latitude": "37.2941660  ",
      "Longitude": " -120.45287 "
   },
   {
      "Vendor": "LEE'S MERCED COMMUNITY FOOD",
      "Address": "E 37 15TH ST",
      "City": "MERCED",
      "Zip Code": " 95340",
      "County": " MERCED",
      "Latitude": "37.2960020  ",
      "Longitude": " -120.47616 "
   },
   {
      "Vendor": "LA MORENITA TORTILLERIA & M",
      "Address": "W 705 H ST",
      "City": "LOS BANOS",
      "Zip Code": " 93635",
      "County": " MERCED",
      "Latitude": "37.0676850  ",
      "Longitude": " -120.86028 "
   },
   {
      "Vendor": "CALIFORNIA LIQUOR & GROCERY",
      "Address": " 1122 R ST",
      "City": "MERCED",
      "Zip Code": " 95340",
      "County": " MERCED",
      "Latitude": "37.2990200  ",
      "Longitude": " -120.49569 "
   },
   {
      "Vendor": "SMART SAVE",
      "Address": "W 211 MAIN ST",
      "City": "MERCED",
      "Zip Code": " 95340",
      "County": " MERCED",
      "Latitude": "37.3001860  ",
      "Longitude": " -120.47903 "
   },
   {
      "Vendor": "SMART & FINAL #385",
      "Address": " 1425 MARTIN L. KING JR. WAY",
      "City": "MERCED",
      "Zip Code": " 95340",
      "County": " MERCED",
      "Latitude": "37.2982500  ",
      "Longitude": " -120.48404 "
   },
   {
      "Vendor": "ELTAREB MARKET #3",
      "Address": "W 561 8TH ST",
      "City": "MERCED",
      "Zip Code": " 95341",
      "County": " MERCED",
      "Latitude": "37.2928990  ",
      "Longitude": " -120.48980 "
   },
   {
      "Vendor": "SHOP N SAVE MARKET",
      "Address": "W 1055 CHILDS AVE",
      "City": "MERCED",
      "Zip Code": " 95341",
      "County": " MERCED",
      "Latitude": "37.2884920  ",
      "Longitude": " -120.50121 "
   },
   {
      "Vendor": "TARGET STORE T-2386",
      "Address": " 1000 COMMERCE AVE",
      "City": "ATWATER",
      "Zip Code": " 95301",
      "County": " MERCED",
      "Latitude": "37.3415260  ",
      "Longitude": " -120.61149 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #543",
      "Address": " 401 LESHER DR",
      "City": "MERCED",
      "Zip Code": " 95341",
      "County": " MERCED",
      "Latitude": "37.2945850  ",
      "Longitude": " -120.50369 "
   },
   {
      "Vendor": "BUY & BYE MARKET",
      "Address": "N 1108 G ST",
      "City": "MERCED",
      "Zip Code": " 95341",
      "County": " MERCED",
      "Latitude": "37.2963790  ",
      "Longitude": " -120.48990 "
   },
   {
      "Vendor": "LA ESPERANZA FOOD CENTER",
      "Address": "W 937 PACHECO BLVD",
      "City": "LOS BANOS",
      "Zip Code": " 93635",
      "County": " MERCED",
      "Latitude": "37.0564790  ",
      "Longitude": " -120.86972 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5890",
      "Address": " 800 COMMERCE AVE",
      "City": "ATWATER",
      "Zip Code": " 95301",
      "County": " MERCED",
      "Latitude": "37.3404810  ",
      "Longitude": " -120.60911 "
   },
   {
      "Vendor": "BABY'S FIRST STEPS NUTRITIO",
      "Address": " 1828 BLOSSOM ST",
      "City": "DOS PALOS",
      "Zip Code": " 93620",
      "County": " MERCED",
      "Latitude": "36.9860290  ",
      "Longitude": " -120.62585 "
   },
   {
      "Vendor": "TARGET STORE T-0641",
      "Address": " 3280 R ST",
      "City": "MERCED",
      "Zip Code": " 95348",
      "County": " MERCED",
      "Latitude": "37.3227320  ",
      "Longitude": " -120.48666 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #565",
      "Address": " 1190 THIRD ST",
      "City": "ATWATER",
      "Zip Code": " 95301",
      "County": " MERCED",
      "Latitude": "37.3473540  ",
      "Longitude": " -120.60825 "
   },
   {
      "Vendor": "TARGET STORE T-2359",
      "Address": "W 1405 PACHECO BLVD",
      "City": "LOS BANOS",
      "Zip Code": " 93635",
      "County": " MERCED",
      "Latitude": "37.0564820  ",
      "Longitude": " -120.87561 "
   },
   {
      "Vendor": "STATE MARKET",
      "Address": " 2649 BLOSSOM ST",
      "City": "DOS PALOS",
      "Zip Code": " 93620",
      "County": " MERCED",
      "Latitude": "36.9854420  ",
      "Longitude": " -120.63748 "
   },
   {
      "Vendor": "MERCADO LATINO",
      "Address": "N 318 SUTTER ST",
      "City": "PLANADA",
      "Zip Code": " 95365",
      "County": " MERCED",
      "Latitude": "37.2925950  ",
      "Longitude": " -120.32056 "
   },
   {
      "Vendor": "WAL-MART #2039",
      "Address": " 3055 LOUGHBOROUGH DR",
      "City": "MERCED",
      "Zip Code": " 95348",
      "County": " MERCED",
      "Latitude": "37.3182260  ",
      "Longitude": " -120.49997 "
   },
   {
      "Vendor": "WAL-MART STORE #2117",
      "Address": "W 1575 PACHECO BLVD",
      "City": "LOS BANOS",
      "Zip Code": " 93635",
      "County": " MERCED",
      "Latitude": "37.0565060  ",
      "Longitude": " -120.87868 "
   },
   {
      "Vendor": "FIESTA SUPERMARKET",
      "Address": " 344 MAIN ST",
      "City": "LIVINGSTON",
      "Zip Code": " 95334",
      "County": " MERCED",
      "Latitude": "37.3868450  ",
      "Longitude": " -120.72357 "
   },
   {
      "Vendor": "RANCHO SAN MIGUEL #027",
      "Address": " 444 WINTON PKWY",
      "City": "LIVINGSTON",
      "Zip Code": " 95334",
      "County": " MERCED",
      "Latitude": "37.3871640  ",
      "Longitude": " -120.73524 "
   },
   {
      "Vendor": "RANCHO MARKET",
      "Address": "E 13199 JEFFERSON ST",
      "City": "LE GRAND",
      "Zip Code": " 95333",
      "County": " MERCED",
      "Latitude": "37.2299550  ",
      "Longitude": " -120.25026 "
   },
   {
      "Vendor": "WALGREENS #15986",
      "Address": " 8298 LANDER AVE",
      "City": "HILMAR",
      "Zip Code": " 95324",
      "County": " MERCED",
      "Latitude": "37.4082970  ",
      "Longitude": " -120.84958 "
   },
   {
      "Vendor": "EL RANCHO MARKET",
      "Address": " 9735 STEPHENS ST",
      "City": "DELHI",
      "Zip Code": " 95315",
      "County": " MERCED",
      "Latitude": "37.4301600  ",
      "Longitude": " -120.77675 "
   },
   {
      "Vendor": "BABY'S NUTRITION #6",
      "Address": "W 30 G ST",
      "Second Address": " STE C",
      "City": "LOS BANOS",
      "Zip Code": " 93635",
      "County": " MERCED",
      "Latitude": "37.0666410  ",
      "Longitude": " -120.85414 "
   },
   {
      "Vendor": "SAVE MART #631",
      "Address": " 1400 MERCEY SPRINGS RD",
      "City": "LOS BANOS",
      "Zip Code": " 93635",
      "County": " MERCED",
      "Latitude": "37.0570660  ",
      "Longitude": " -120.83534 "
   },
   {
      "Vendor": "BABY SHOP #6",
      "Address": "W 1225 MAIN ST",
      "City": "MERCED",
      "Zip Code": " 95340",
      "County": " MERCED",
      "Latitude": "37.3060390  ",
      "Longitude": " -120.49427 "
   },
   {
      "Vendor": "CHOICE FOOD MARKET",
      "Address": " 836 T ST",
      "City": "MERCED",
      "Zip Code": " 95341",
      "County": " MERCED",
      "Latitude": "37.2971690  ",
      "Longitude": " -120.50004 "
   },
   {
      "Vendor": "CARDENAS MARKET #223",
      "Address": "W 1136 MAIN ST",
      "City": "MERCED",
      "Zip Code": " 95340",
      "County": " MERCED",
      "Latitude": "37.3048740  ",
      "Longitude": " -120.49332 "
   },
   {
      "Vendor": "JOE'S VILLAGE MARKET",
      "Address": " 13191 STATE HIGHWAY 33",
      "City": "SANTA NELLA",
      "Zip Code": " 95322",
      "County": " MERCED",
      "Latitude": "37.0984520  ",
      "Longitude": " -121.01606 "
   },
   {
      "Vendor": "HOLIDAY QUALITY FOODS #41",
      "Address": "W 1200 12TH ST",
      "City": "ALTURAS",
      "Zip Code": " 96101",
      "County": " MODOC",
      "Latitude": "41.4950860  ",
      "Longitude": " -120.55998 "
   },
   {
      "Vendor": "4 CORNERS MARKET",
      "Address": "N 1077 MAIN ST",
      "City": "ALTURAS",
      "Zip Code": " 96101",
      "County": " MODOC",
      "Latitude": "41.4941930  ",
      "Longitude": " -120.54300 "
   },
   {
      "Vendor": "PAGE'S MARKET",
      "Address": " 488 MAIN ST",
      "City": "CEDARVILLE",
      "Zip Code": " 96104",
      "County": " MODOC",
      "Latitude": "41.5275580  ",
      "Longitude": " -120.17236 "
   },
   {
      "Vendor": "BRIDGEPORT COMMISSARY",
      "Address": " 1003 CHAMPAGNE AVE",
      "City": "COLEVILLE",
      "Zip Code": " 96107",
      "County": " MONO",
      "Latitude": "38.5876960  ",
      "Longitude": " -119.51969 "
   },
   {
      "Vendor": "S P D MARKET",
      "Address": " 735 ZION ST",
      "City": "NEVADA CITY",
      "Zip Code": " 95959",
      "County": " NEVADA",
      "Latitude": "39.2532680  ",
      "Longitude": " -121.02530 "
   },
   {
      "Vendor": "SAFEWAY #0111",
      "Address": " 105 NEAL ST",
      "City": "GRASS VALLEY",
      "Zip Code": " 95945",
      "County": " NEVADA",
      "Latitude": "39.2160700  ",
      "Longitude": " -121.06278 "
   },
   {
      "Vendor": "RALEY'S #213",
      "Address": " 692 FREEMAN LN",
      "City": "GRASS VALLEY",
      "Zip Code": " 95949",
      "County": " NEVADA",
      "Latitude": "39.2024930  ",
      "Longitude": " -121.06536 "
   },
   {
      "Vendor": "HOLIDAY QUALITY FOODS #37",
      "Address": " 11324 PLEASANT VALLEY RD",
      "City": "PENN VALLEY",
      "Zip Code": " 95946",
      "County": " NEVADA",
      "Latitude": "39.2235920  ",
      "Longitude": " -121.20413 "
   },
   {
      "Vendor": "SAFEWAY #1266",
      "Address": " 11290 DONNER PASS RD",
      "City": "TRUCKEE",
      "Zip Code": " 96161",
      "County": " NEVADA",
      "Latitude": "39.3272390  ",
      "Longitude": " -120.20650 "
   },
   {
      "Vendor": "SPD MARKET #2",
      "Address": "W 129 MCKNIGHT WAY",
      "City": "GRASS VALLEY",
      "Zip Code": " 95949",
      "County": " NEVADA",
      "Latitude": "39.1995150  ",
      "Longitude": " -121.06161 "
   },
   {
      "Vendor": "SAVE MART #608",
      "Address": " 2054 NEVADA CITY HWY",
      "City": "GRASS VALLEY",
      "Zip Code": " 95945",
      "County": " NEVADA",
      "Latitude": "39.2392720  ",
      "Longitude": " -121.03781 "
   },
   {
      "Vendor": "SAVE MART #627",
      "Address": " 11399 DEERFIELD DR",
      "City": "TRUCKEE",
      "Zip Code": " 96161",
      "County": " NEVADA",
      "Latitude": "39.3193070  ",
      "Longitude": " -120.20910 "
   },
   {
      "Vendor": "SAFEWAY #2842",
      "Address": " 867 SUTTON WAY",
      "City": "GRASS VALLEY",
      "Zip Code": " 95945",
      "County": " NEVADA",
      "Latitude": "39.2355750  ",
      "Longitude": " -121.03261 "
   },
   {
      "Vendor": "SMITH'S FOOD&DRUG CNTR #341",
      "Address": "S 601 HIGHWAY 160",
      "City": "PAHRUMP",
      "Zip Code": " 89048",
      "County": " NEVADA STATE 1",
      "Latitude": "36.2115240  ",
      "Longitude": " -115.98645 "
   },
   {
      "Vendor": "MI PUEBLITO MARKET",
      "Address": " 11430 DEERFIELD DR",
      "Second Address": " STE B4",
      "City": "TRUCKEE",
      "Zip Code": " 96161",
      "County": " NEVADA",
      "Latitude": "39.3217460  ",
      "Longitude": " -120.21051 "
   },
   {
      "Vendor": "RALEY'S #229",
      "Address": " 13384 LINCOLN WAY",
      "City": "AUBURN",
      "Zip Code": " 95603",
      "County": " PLACER",
      "Latitude": "38.9242680  ",
      "Longitude": " -121.05475 "
   },
   {
      "Vendor": "SAFEWAY #1592",
      "Address": "N 7815 LAKE BLVD",
      "City": "KINGS BEACH",
      "Zip Code": " 96143",
      "County": " PLACER",
      "Latitude": "39.2388010  ",
      "Longitude": " -120.03394 "
   },
   {
      "Vendor": "SAFEWAY #2258",
      "Address": "N 850 LAKE BLVD",
      "City": "TAHOE CITY",
      "Zip Code": " 96145",
      "County": " PLACER",
      "Latitude": "39.1732470  ",
      "Longitude": " -120.13698 "
   },
   {
      "Vendor": "SAFEWAY #2286",
      "Address": " 4805 GRANITE DR",
      "City": "ROCKLIN",
      "Zip Code": " 95677",
      "County": " PLACER",
      "Latitude": "38.7898990  ",
      "Longitude": " -121.22267 "
   },
   {
      "Vendor": "BEL AIR MARKET #509",
      "Address": " 1039 SUNRISE AVE",
      "City": "ROSEVILLE",
      "Zip Code": " 95661",
      "County": " PLACER",
      "Latitude": "38.7285120  ",
      "Longitude": " -121.27116 "
   },
   {
      "Vendor": "RALEY'S #412",
      "Address": " 6847 DOUGLAS BLVD",
      "City": "ROSEVILLE",
      "Zip Code": " 95746",
      "County": " PLACER",
      "Latitude": "38.7445120  ",
      "Longitude": " -121.17263 "
   },
   {
      "Vendor": "BEL AIR MARKET #512",
      "Address": " 4008 FOOTHILL BLVD",
      "City": "ROSEVILLE",
      "Zip Code": " 95747",
      "County": " PLACER",
      "Latitude": "38.7533870  ",
      "Longitude": " -121.31103 "
   },
   {
      "Vendor": "BEL AIR MARKET #517",
      "Address": " 2222 GRASS VALLEY HWY",
      "City": "AUBURN",
      "Zip Code": " 95603",
      "County": " PLACER",
      "Latitude": "38.9347570  ",
      "Longitude": " -121.09101 "
   },
   {
      "Vendor": "RALEY'S #227",
      "Address": " 1915 DOUGLAS BLVD",
      "Second Address": " STE 100",
      "City": "ROSEVILLE",
      "Zip Code": " 95661",
      "County": " PLACER",
      "Latitude": "38.7453590  ",
      "Longitude": " -121.25702 "
   },
   {
      "Vendor": "BEL AIR MARKET #518",
      "Address": " 2341 SUNSET BLVD",
      "City": "ROCKLIN",
      "Zip Code": " 95765",
      "County": " PLACER",
      "Latitude": "38.7976680  ",
      "Longitude": " -121.26484 "
   },
   {
      "Vendor": "SAFEWAY #3122",
      "Address": " 2550 BELL RD",
      "City": "AUBURN",
      "Zip Code": " 95603",
      "County": " PLACER",
      "Latitude": "38.9436690  ",
      "Longitude": " -121.09261 "
   },
   {
      "Vendor": "RALEY'S #231",
      "Address": " 6119 HORSESHOE BAR RD",
      "City": "LOOMIS",
      "Zip Code": " 95650",
      "County": " PLACER",
      "Latitude": "38.8180350  ",
      "Longitude": " -121.18877 "
   },
   {
      "Vendor": "HOLIDAY QUALITY FOODS #61",
      "Address": " 16981 PLACER HILLS RD",
      "City": "MEADOW VISTA",
      "Zip Code": " 95722",
      "County": " PLACER",
      "Latitude": "39.0000190  ",
      "Longitude": " -121.02273 "
   },
   {
      "Vendor": "SAFEWAY #1761",
      "Address": " 405 STATE HIGHWAY 65",
      "City": "LINCOLN",
      "Zip Code": " 95648",
      "County": " PLACER",
      "Latitude": "38.9667700  ",
      "Longitude": " -121.37711 "
   },
   {
      "Vendor": "WINCO FOODS #31",
      "Address": " 10151 FAIRWAY DR",
      "City": "ROSEVILLE",
      "Zip Code": " 95678",
      "County": " PLACER",
      "Latitude": "38.7853720  ",
      "Longitude": " -121.27806 "
   },
   {
      "Vendor": "SAFEWAY #1890",
      "Address": " 1080 PLEASANT GROVE BLVD",
      "City": "ROSEVILLE",
      "Zip Code": " 95678",
      "County": " PLACER",
      "Latitude": "38.7766430  ",
      "Longitude": " -121.29067 "
   },
   {
      "Vendor": "SAFEWAY #1617",
      "Address": " 8640 SIERRA COLLEGE BLVD",
      "City": "ROSEVILLE",
      "Zip Code": " 95661",
      "County": " PLACER",
      "Latitude": "38.7419850  ",
      "Longitude": " -121.22640 "
   },
   {
      "Vendor": "SAFEWAY #1899",
      "Address": " 989 SUNRISE AVE",
      "City": "ROSEVILLE",
      "Zip Code": " 95661",
      "County": " PLACER",
      "Latitude": "38.7311100  ",
      "Longitude": " -121.27131 "
   },
   {
      "Vendor": "HOLIDAY QUALITY FOODS #38",
      "Address": " 10952 COMBIE RD",
      "Second Address": " UNIT 12",
      "City": "AUBURN",
      "Zip Code": " 95602",
      "County": " PLACER",
      "Latitude": "39.0399580  ",
      "Longitude": " -121.07872 "
   },
   {
      "Vendor": "SAFEWAY #1866",
      "Address": " 2220 SUNSET BLVD",
      "City": "ROCKLIN",
      "Zip Code": " 95765",
      "County": " PLACER",
      "Latitude": "38.8028170  ",
      "Longitude": " -121.27441 "
   },
   {
      "Vendor": "RALEY'S #230",
      "Address": " 765 STATE HIGHWAY 65",
      "City": "LINCOLN",
      "Zip Code": " 95648",
      "County": " PLACER",
      "Latitude": "38.9667700  ",
      "Longitude": " -121.37711 "
   },
   {
      "Vendor": "SAFEWAY #2620",
      "Address": " 9045 WOODCREEK OAKS BLVD",
      "City": "ROSEVILLE",
      "Zip Code": " 95747",
      "County": " PLACER",
      "Latitude": "38.7940980  ",
      "Longitude": " -121.33033 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1988",
      "Address": " 900 PLEASANT GROVE BLVD",
      "City": "ROSEVILLE",
      "Zip Code": " 95678",
      "County": " PLACER",
      "Latitude": "38.7855770  ",
      "Longitude": " -121.28527 "
   },
   {
      "Vendor": "SAVE MART #600",
      "Address": " 386 ELM AVE",
      "City": "AUBURN",
      "Zip Code": " 95603",
      "County": " PLACER",
      "Latitude": "38.9056130  ",
      "Longitude": " -121.07381 "
   },
   {
      "Vendor": "SAVE MART #616",
      "Address": " 3021 STANFORD RANCH RD",
      "City": "ROCKLIN",
      "Zip Code": " 95765",
      "County": " PLACER",
      "Latitude": "38.8158090  ",
      "Longitude": " -121.25918 "
   },
   {
      "Vendor": "SAVE MART #617",
      "Address": " 5060 FOOTHILLS BLVD",
      "City": "ROSEVILLE",
      "Zip Code": " 95747",
      "County": " PLACER",
      "Latitude": "38.7602570  ",
      "Longitude": " -121.31251 "
   },
   {
      "Vendor": "SAVE MART #626",
      "Address": " 100 RIVER RD",
      "City": "TAHOE CITY",
      "Zip Code": " 96145",
      "County": " PLACER",
      "Latitude": "39.1679440  ",
      "Longitude": " -120.14571 "
   },
   {
      "Vendor": "RALEY'S #228",
      "Address": " 4051 WOODCREEK OAKS BLVD",
      "City": "ROSEVILLE",
      "Zip Code": " 95747",
      "County": " PLACER",
      "Latitude": "38.7699540  ",
      "Longitude": " -121.33152 "
   },
   {
      "Vendor": "LA MEXICANA MARKET",
      "Address": " 8515 BROOK AVE",
      "City": "KINGS BEACH",
      "Zip Code": " 96143",
      "County": " PLACER",
      "Latitude": "39.2371250  ",
      "Longitude": " -120.02317 "
   },
   {
      "Vendor": "NUGGET MARKET #07",
      "Address": " 771 PLEASANT GROVE BLVD",
      "City": "ROSEVILLE",
      "Zip Code": " 95678",
      "County": " PLACER",
      "Latitude": "38.7909280  ",
      "Longitude": " -121.28007 "
   },
   {
      "Vendor": "TARGET STORE T-2214",
      "Address": " 950 GROVELAND AVE",
      "City": "LINCOLN",
      "Zip Code": " 95648",
      "County": " PLACER",
      "Latitude": "38.8704480  ",
      "Longitude": " -121.30418 "
   },
   {
      "Vendor": "MAR-VAL'S SIERRA MARKET",
      "Address": "S 575 AUBURN ST",
      "City": "COLFAX",
      "Zip Code": " 95713",
      "County": " PLACER",
      "Latitude": "39.0935690  ",
      "Longitude": " -120.95257 "
   },
   {
      "Vendor": "WAL-MART #5980",
      "Address": " 4080 DOUGLAS BLVD",
      "City": "GRANITE BAY",
      "Zip Code": " 95746",
      "County": " PLACER",
      "Latitude": "38.7435480  ",
      "Longitude": " -121.22457 "
   },
   {
      "Vendor": "WAL-MART #3090",
      "Address": " 5609 PACIFIC ST",
      "City": "ROCKLIN",
      "Zip Code": " 95677",
      "County": " PLACER",
      "Latitude": "38.7838600  ",
      "Longitude": " -121.24052 "
   },
   {
      "Vendor": "WAL-MART #5979",
      "Address": " 255 G ST",
      "City": "LINCOLN",
      "Zip Code": " 95648",
      "County": " PLACER",
      "Latitude": "38.8885740  ",
      "Longitude": " -121.29261 "
   },
   {
      "Vendor": "WAL-MART #3587",
      "Address": " 5454 CROSSINGS DR",
      "City": "ROCKLIN",
      "Zip Code": " 95677",
      "County": " PLACER",
      "Latitude": "38.8035030  ",
      "Longitude": " -121.20257 "
   },
   {
      "Vendor": "MERCADO LOCO",
      "Address": " 201 SUNRISE AVE",
      "City": "ROSEVILLE",
      "Zip Code": " 95661",
      "County": " PLACER",
      "Latitude": "38.7433440  ",
      "Longitude": " -121.26884 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #4202",
      "Address": " 1400 LEAD HILL BLVD",
      "City": "ROSEVILLE",
      "Zip Code": " 95677",
      "County": " PLACER",
      "Latitude": "38.7480690  ",
      "Longitude": " -121.25572 "
   },
   {
      "Vendor": "TARGET STORE T-1097",
      "Address": " 2700 BELL RD",
      "City": "AUBURN",
      "Zip Code": " 95603",
      "County": " PLACER",
      "Latitude": "38.9425120  ",
      "Longitude": " -121.09578 "
   },
   {
      "Vendor": "TARGET STORE T-2604",
      "Address": " 5104 COMMONS DR",
      "City": "ROCKLIN",
      "Zip Code": " 95677",
      "County": " PLACER",
      "Latitude": "38.8046900  ",
      "Longitude": " -121.20905 "
   },
   {
      "Vendor": "SMART & FINAL #729",
      "Address": " 1159 ROSEVILLE SQUARE",
      "City": "ROSEVILLE",
      "Zip Code": " 95678",
      "County": " PLACER",
      "Latitude": "38.7459070  ",
      "Longitude": " -121.27510 "
   },
   {
      "Vendor": "SMART & FINAL #711",
      "Address": " 2825 GRASS VALLEY HWY",
      "City": "AUBURN",
      "Zip Code": " 95603",
      "County": " PLACER",
      "Latitude": "38.9418590  ",
      "Longitude": " -121.09714 "
   },
   {
      "Vendor": "SAFEWAY #0262",
      "Address": "E 20 MAIN ST",
      "City": "QUINCY",
      "Zip Code": " 95971",
      "County": " PLUMAS",
      "Latitude": "39.9377010  ",
      "Longitude": " -120.93731 "
   },
   {
      "Vendor": "EVERGREEN MARKET",
      "Address": " 427 CRESCENT (HWY 89) ST",
      "City": "GREENVILLE",
      "Zip Code": " 95947",
      "County": " PLUMAS",
      "Latitude": "40.0980530  ",
      "Longitude": " -120.91105 "
   },
   {
      "Vendor": "SAV MOR FOODS #17",
      "Address": "E 1947 MAIN ST",
      "City": "QUINCY",
      "Zip Code": " 95971",
      "County": " PLUMAS",
      "Latitude": "39.9344440  ",
      "Longitude": " -120.90224 "
   },
   {
      "Vendor": "HOLIDAY QUALITY FOODS #54",
      "Address": " 271 MAIN ST",
      "City": "CHESTER",
      "Zip Code": " 96020",
      "County": " PLUMAS",
      "Latitude": "40.3071780  ",
      "Longitude": " -121.22988 "
   },
   {
      "Vendor": "LEONARDS MARKET",
      "Address": "W 88 SIERRA ST",
      "City": "PORTOLA",
      "Zip Code": " 96122",
      "County": " PLUMAS",
      "Latitude": "39.8105610  ",
      "Longitude": " -120.47041 "
   },
   {
      "Vendor": "BEL AIR MARKET #502",
      "Address": " 4320 ARDEN WAY",
      "City": "SACRAMENTO",
      "Zip Code": " 95864",
      "County": " SACRAMENTO",
      "Latitude": "38.5949510  ",
      "Longitude": " -121.36346 "
   },
   {
      "Vendor": "BEL AIR MARKET #506",
      "Address": " 1301 FLORIN RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95831",
      "County": " SACRAMENTO",
      "Latitude": "38.4965260  ",
      "Longitude": " -121.50795 "
   },
   {
      "Vendor": "BEL AIR MARKET #501",
      "Address": " 6231 FRUITRIDGE RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95820",
      "County": " SACRAMENTO",
      "Latitude": "38.5254600  ",
      "Longitude": " -121.43180 "
   },
   {
      "Vendor": "GALT SUPER MARKET",
      "Address": " 814 A ST",
      "City": "GALT",
      "Zip Code": " 95632",
      "County": " SACRAMENTO",
      "Latitude": "38.2544700  ",
      "Longitude": " -121.29982 "
   },
   {
      "Vendor": "RALEY'S #420",
      "Address": " 8391 FOLSOM BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95826",
      "County": " SACRAMENTO",
      "Latitude": "38.5483470  ",
      "Longitude": " -121.39406 "
   },
   {
      "Vendor": "RALEY'S #405",
      "Address": " 4850 FREEPORT BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95822",
      "County": " SACRAMENTO",
      "Latitude": "38.5308560  ",
      "Longitude": " -121.49613 "
   },
   {
      "Vendor": "RALEY'S #431",
      "Address": " 5159 FAIR OAKS BLVD",
      "City": "CARMICHAEL",
      "Zip Code": " 95608",
      "County": " SACRAMENTO",
      "Latitude": "38.5975230  ",
      "Longitude": " -121.34513 "
   },
   {
      "Vendor": "RALEY'S #417",
      "Address": " 4840 SAN JUAN AVE",
      "City": "FAIR OAKS",
      "Zip Code": " 95628",
      "County": " SACRAMENTO",
      "Latitude": "38.6539900  ",
      "Longitude": " -121.29109 "
   },
   {
      "Vendor": "RALEY'S #421",
      "Address": " 8870 MADISON AVE",
      "City": "FAIR OAKS",
      "Zip Code": " 95628",
      "County": " SACRAMENTO",
      "Latitude": "38.6626220  ",
      "Longitude": " -121.22795 "
   },
   {
      "Vendor": "SAFEWAY #0190",
      "Address": " 424 HOWE AVE",
      "City": "SACRAMENTO",
      "Zip Code": " 95825",
      "County": " SACRAMENTO",
      "Latitude": "38.5731070  ",
      "Longitude": " -121.41322 "
   },
   {
      "Vendor": "SAFEWAY #2242",
      "Address": " 1025 ALHAMBRA BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95816",
      "County": " SACRAMENTO",
      "Latitude": "38.5715830  ",
      "Longitude": " -121.46468 "
   },
   {
      "Vendor": "SAFEWAY #2263",
      "Address": " 5345 ELKHORN BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95842",
      "County": " SACRAMENTO",
      "Latitude": "38.6863470  ",
      "Longitude": " -121.34009 "
   },
   {
      "Vendor": "RALEY'S #239",
      "Address": " 7847 LICHEN DR",
      "City": "CITRUS HEIGHTS",
      "Zip Code": " 95621",
      "County": " SACRAMENTO",
      "Latitude": "38.7092150  ",
      "Longitude": " -121.31310 "
   },
   {
      "Vendor": "MCCLELLAN COMMISSARY",
      "Address": " 5507 DUDLEY BLVD",
      "Second Address": " BLDG 910",
      "City": "MCCLELLAN PARK",
      "Zip Code": " 95652",
      "County": " SACRAMENTO",
      "Latitude": "38.6669150  ",
      "Longitude": " -121.38713 "
   },
   {
      "Vendor": "BEL AIR MARKET #510",
      "Address": "W 1540 EL CAMINO AVE",
      "City": "SACRAMENTO",
      "Zip Code": " 95833",
      "County": " SACRAMENTO",
      "Latitude": "38.6119650  ",
      "Longitude": " -121.49651 "
   },
   {
      "Vendor": "NUGGET MARKET #05",
      "Address": " 1040 FLORIN RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95831",
      "County": " SACRAMENTO",
      "Latitude": "38.4946590  ",
      "Longitude": " -121.52124 "
   },
   {
      "Vendor": "BEL AIR MARKET #511",
      "Address": " 4005 MANZANITA AVE",
      "City": "CARMICHAEL",
      "Zip Code": " 95608",
      "County": " SACRAMENTO",
      "Latitude": "38.6375330  ",
      "Longitude": " -121.32961 "
   },
   {
      "Vendor": "BEL AIR MARKET #514",
      "Address": " 7465 RUSH RIVER DR",
      "City": "SACRAMENTO",
      "Zip Code": " 95831",
      "County": " SACRAMENTO",
      "Latitude": "38.4859980  ",
      "Longitude": " -121.53489 "
   },
   {
      "Vendor": "IMPERIAL MARKET",
      "Address": "E 3100 IMPERIAL HWY",
      "Second Address": " STE 1300",
      "City": "LYNWOOD",
      "Zip Code": " 90262",
      "County": " LOS ANGELES",
      "Latitude": "33.9293830  ",
      "Longitude": " -118.21512 "
   },
   {
      "Vendor": "B & B NUTRITION",
      "Address": " 7008 SANTA FE AVE",
      "City": "HUNTINGTON PARK",
      "Zip Code": " 90255",
      "County": " LOS ANGELES",
      "Latitude": "33.9758320  ",
      "Longitude": " -118.23023 "
   },
   {
      "Vendor": "RANCHO LATINO SUPERMARKET",
      "Address": " 3474 TWEEDY BLVD",
      "City": "SOUTH GATE",
      "Zip Code": " 90280",
      "County": " LOS ANGELES",
      "Latitude": "33.9442150  ",
      "Longitude": " -118.20788 "
   },
   {
      "Vendor": "CENTRO MERCADO LATINO",
      "Address": " 4339 DALTON AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90062",
      "County": " LOS ANGELES",
      "Latitude": "34.0039150  ",
      "Longitude": " -118.30343 "
   },
   {
      "Vendor": "VILLALOBOS MEAT MARKET",
      "Address": " 5244 SANTA MONICA BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90029",
      "County": " LOS ANGELES",
      "Latitude": "34.0907960  ",
      "Longitude": " -118.30473 "
   },
   {
      "Vendor": "TARGET STORE T-1306",
      "Address": "S 3535 LA CIENEGA BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90016",
      "County": " LOS ANGELES",
      "Latitude": "34.0233540  ",
      "Longitude": " -118.37252 "
   },
   {
      "Vendor": "TARGET STORE T-2632",
      "Address": " 6000 SEPULVEDA BLVD",
      "City": "CULVER CITY",
      "Zip Code": " 90230",
      "County": " LOS ANGELES",
      "Latitude": "33.9858450  ",
      "Longitude": " -118.39398 "
   },
   {
      "Vendor": "TARGET STORE T-1425",
      "Address": " 8800 WHITTIER BLVD",
      "City": "PICO RIVERA",
      "Zip Code": " 90660",
      "County": " LOS ANGELES",
      "Latitude": "34.0016730  ",
      "Longitude": " -118.08528 "
   },
   {
      "Vendor": "TARGET STORE T-0290",
      "Address": " 2169 REDONDO BEACH BLVD",
      "City": "GARDENA",
      "Zip Code": " 90247",
      "County": " LOS ANGELES",
      "Latitude": "33.8863200  ",
      "Longitude": " -118.31659 "
   },
   {
      "Vendor": "TARGET STORE T-1362",
      "Address": "W 1800 EMPIRE AVE",
      "City": "BURBANK",
      "Zip Code": " 91504",
      "County": " LOS ANGELES",
      "Latitude": "34.1917350  ",
      "Longitude": " -118.32987 "
   },
   {
      "Vendor": "AZTECA 99 CENTS PLUS MARKET",
      "Address": "E 1662 1/2 41ST ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90011",
      "County": " LOS ANGELES",
      "Latitude": "34.0079640  ",
      "Longitude": " -118.24391 "
   },
   {
      "Vendor": "SANTANA MARKET",
      "Address": "S 7724 MAIN ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90003",
      "County": " LOS ANGELES",
      "Latitude": "33.9690390  ",
      "Longitude": " -118.27366 "
   },
   {
      "Vendor": "NORTHGATE MARKET #33",
      "Address": "W 2323 OLYMPIC BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90006",
      "County": " LOS ANGELES",
      "Latitude": "34.0528020  ",
      "Longitude": " -118.28269 "
   },
   {
      "Vendor": "AMIGO'S MARKET",
      "Address": "W 2609 TEMPLE ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90026",
      "County": " LOS ANGELES",
      "Latitude": "34.0728880  ",
      "Longitude": " -118.27524 "
   },
   {
      "Vendor": "TARGET STORE T-2319",
      "Address": "E 950 33RD ST",
      "City": "SIGNAL HILL",
      "Zip Code": " 90755",
      "County": " LOS ANGELES",
      "Latitude": "33.8168570  ",
      "Longitude": " -118.18177 "
   },
   {
      "Vendor": "TARGET STORE T-2424",
      "Address": " 6750 CHERRY AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90805",
      "County": " LOS ANGELES",
      "Latitude": "33.8774480  ",
      "Longitude": " -118.16841 "
   },
   {
      "Vendor": "TARGET STORE T-2195",
      "Address": " 18287 COLLIER AVE",
      "City": "LAKE ELSINORE",
      "Zip Code": " 92530",
      "County": " RIVERSIDE",
      "Latitude": "33.6906700  ",
      "Longitude": " -117.34092 "
   },
   {
      "Vendor": "BABY NUTRITIONAL CENTER",
      "Address": " 3871 WHITTIER BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90023",
      "County": " LOS ANGELES",
      "Latitude": "34.0239170  ",
      "Longitude": " -118.18979 "
   },
   {
      "Vendor": "TARGET STORE T-2280",
      "Address": "W 2700 120TH ST",
      "City": "HAWTHORNE",
      "Zip Code": " 90250",
      "County": " LOS ANGELES",
      "Latitude": "33.9235050  ",
      "Longitude": " -118.32150 "
   },
   {
      "Vendor": "TARGET STORE T-0199",
      "Address": "N 1200 SEPULVEDA BLVD",
      "City": "MANHATTAN BEACH",
      "Zip Code": " 90266",
      "County": " LOS ANGELES",
      "Latitude": "33.8883310  ",
      "Longitude": " -118.39573 "
   },
   {
      "Vendor": "TARGET STORE T-2328",
      "Address": "W 651 SEPULVEDA BLVD",
      "City": "CARSON",
      "Zip Code": " 90745",
      "County": " LOS ANGELES",
      "Latitude": "33.8087720  ",
      "Longitude": " -118.28619 "
   },
   {
      "Vendor": "TARGET STORE T-2470",
      "Address": "N 1701 GAFFEY ST",
      "City": "SAN PEDRO",
      "Zip Code": " 90731",
      "County": " LOS ANGELES",
      "Latitude": "33.7606000  ",
      "Longitude": " -118.29303 "
   },
   {
      "Vendor": "NORTHGATE MARKET #32",
      "Address": "S 15107 ATLANTIC AVE",
      "City": "COMPTON",
      "Zip Code": " 90221",
      "County": " LOS ANGELES",
      "Latitude": "33.8960900  ",
      "Longitude": " -118.19348 "
   },
   {
      "Vendor": "NORTHGATE MARKET #34",
      "Address": "W 710 CHAPMAN AVE",
      "City": "PLACENTIA",
      "Zip Code": " 92870",
      "County": " ORANGE",
      "Latitude": "33.8730990  ",
      "Longitude": " -117.87764 "
   },
   {
      "Vendor": "TARGET STORE T-1307",
      "Address": " 5711 SEPULVEDA BLVD",
      "City": "VAN NUYS",
      "Zip Code": " 91411",
      "County": " LOS ANGELES",
      "Latitude": "34.1747110  ",
      "Longitude": " -118.46646 "
   },
   {
      "Vendor": "TARGET STORE T-1408",
      "Address": " 2626 COLORADO BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90041",
      "County": " LOS ANGELES",
      "Latitude": "34.1413260  ",
      "Longitude": " -118.22391 "
   },
   {
      "Vendor": "VALLEY DALE MARKET",
      "Address": "N 5210 CLYDEBANK AVE",
      "City": "AZUSA",
      "Zip Code": " 91702",
      "County": " LOS ANGELES",
      "Latitude": "34.1076670  ",
      "Longitude": " -117.92019 "
   },
   {
      "Vendor": "LA SIMPATIA MEAT MARKET",
      "Address": " 1312 DUARTE RD",
      "City": "DUARTE",
      "Zip Code": " 91010",
      "County": " LOS ANGELES",
      "Latitude": "34.1322020  ",
      "Longitude": " -117.97698 "
   },
   {
      "Vendor": "GARNI FOOD MARKET",
      "Address": " 7073 FOOTHILL BLVD",
      "City": "TUJUNGA",
      "Zip Code": " 91042",
      "County": " LOS ANGELES",
      "Latitude": "34.2480060  ",
      "Longitude": " -118.28574 "
   },
   {
      "Vendor": "LA CAMPANITA MEAT MARKET",
      "Address": "W 1653 WASHINGTON BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90007",
      "County": " LOS ANGELES",
      "Latitude": "34.0399930  ",
      "Longitude": " -118.29328 "
   },
   {
      "Vendor": "MOM AND BABY NUTRITION STOR",
      "Address": "E 710 GARVEY AVE",
      "Second Address": " STE A",
      "City": "MONTEREY PARK",
      "Zip Code": " 91755",
      "County": " LOS ANGELES",
      "Latitude": "34.0622610  ",
      "Longitude": " -118.11261 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#202",
      "Address": "E 260 MANCHESTER BLVD",
      "Second Address": " UNIT A&B",
      "City": "LOS ANGELES",
      "Zip Code": " 90003",
      "County": " LOS ANGELES",
      "Latitude": "33.9600600  ",
      "Longitude": " -118.26940 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2292",
      "Address": "N 1275 AZUSA AVE",
      "City": "COVINA",
      "Zip Code": " 91722",
      "County": " LOS ANGELES",
      "Latitude": "34.1035850  ",
      "Longitude": " -117.90796 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2251",
      "Address": " 17150 GALE AVE",
      "City": "CITY OF INDUSTRY",
      "Zip Code": " 91745",
      "County": " LOS ANGELES",
      "Latitude": "34.0001110  ",
      "Longitude": " -117.93241 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2948",
      "Address": " 13310 TELEGRAPH RD",
      "City": "SANTA FE SPRINGS",
      "Zip Code": " 90670",
      "County": " LOS ANGELES",
      "Latitude": "33.9416040  ",
      "Longitude": " -118.04943 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2609",
      "Address": " 2770 CARSON ST",
      "City": "LAKEWOOD",
      "Zip Code": " 90712",
      "County": " LOS ANGELES",
      "Latitude": "33.8321350  ",
      "Longitude": " -118.15897 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #3477",
      "Address": " 7250 CARSON BLVD",
      "City": "LONG BEACH",
      "Zip Code": " 90808",
      "County": " LOS ANGELES",
      "Latitude": "33.8283650  ",
      "Longitude": " -118.08918 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5162",
      "Address": " 27931 KELLY JOHNSON PKWY",
      "City": "SANTA CLARITA",
      "Zip Code": " 91355",
      "County": " LOS ANGELES",
      "Latitude": "34.4446240  ",
      "Longitude": " -118.57701 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2526",
      "Address": " 19821 RINALDI ST",
      "City": "PORTER RANCH",
      "Zip Code": " 91326",
      "County": " LOS ANGELES",
      "Latitude": "34.2752440  ",
      "Longitude": " -118.56630 "
   },
   {
      "Vendor": "TARGET STORE T-1884",
      "Address": " 7100 SANTA MONICA BLVD",
      "City": "WEST HOLLYWOOD",
      "Zip Code": " 90046",
      "County": " LOS ANGELES",
      "Latitude": "34.0904970  ",
      "Longitude": " -118.34406 "
   },
   {
      "Vendor": "TARGET STORE T-1980",
      "Address": " 1601 KINGSDALE AVE",
      "City": "REDONDO BEACH",
      "Zip Code": " 90278",
      "County": " LOS ANGELES",
      "Latitude": "33.8683470  ",
      "Longitude": " -118.35648 "
   },
   {
      "Vendor": "TARGET STORE T-0190",
      "Address": " 5700 FIRESTONE BLVD",
      "City": "SOUTH GATE",
      "Zip Code": " 90280",
      "County": " LOS ANGELES",
      "Latitude": "33.9490870  ",
      "Longitude": " -118.16700 "
   },
   {
      "Vendor": "TARGET STORE T-1424",
      "Address": " 12501 IMPERIAL HWY",
      "City": "NORWALK",
      "Zip Code": " 90650",
      "County": " LOS ANGELES",
      "Latitude": "33.9181170  ",
      "Longitude": " -118.06557 "
   },
   {
      "Vendor": "TARGET STORE T-2019",
      "Address": " 15614 WHITTWOOD LN",
      "City": "WHITTIER",
      "Zip Code": " 90603",
      "County": " LOS ANGELES",
      "Latitude": "33.9443840  ",
      "Longitude": " -117.99663 "
   },
   {
      "Vendor": "TARGET STORE T-0198",
      "Address": " 10820 JEFFERSON BLVD",
      "City": "CULVER CITY",
      "Zip Code": " 90230",
      "County": " LOS ANGELES",
      "Latitude": "33.9989490  ",
      "Longitude": " -118.39342 "
   },
   {
      "Vendor": "JUREMA NUTRITION II",
      "Address": "E 1412 FLORENCE AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90001",
      "County": " LOS ANGELES",
      "Latitude": "33.9745570  ",
      "Longitude": " -118.24936 "
   },
   {
      "Vendor": "MERCADO LA CACHANILLA",
      "Address": "N 246 AZUSA AVE",
      "City": "AZUSA",
      "Zip Code": " 91702",
      "County": " LOS ANGELES",
      "Latitude": "34.1260070  ",
      "Longitude": " -117.90721 "
   },
   {
      "Vendor": "MAIN MARKET",
      "Address": " 12604 PENN ST",
      "City": "WHITTIER",
      "Zip Code": " 90602",
      "County": " LOS ANGELES",
      "Latitude": "33.9752910  ",
      "Longitude": " -118.04172 "
   },
   {
      "Vendor": "C & M MARKET",
      "Address": "N 601 BREED ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90033",
      "County": " LOS ANGELES",
      "Latitude": "34.0514900  ",
      "Longitude": " -118.20683 "
   },
   {
      "Vendor": "EL MIGUELENO MINI MARKET",
      "Address": "W 2688 PICO BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90006",
      "County": " LOS ANGELES",
      "Latitude": "34.0472260  ",
      "Longitude": " -118.29717 "
   },
   {
      "Vendor": "VICTORIA MARKET",
      "Address": "S 11149 VERMONT ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90044",
      "County": " LOS ANGELES",
      "Latitude": "33.9335020  ",
      "Longitude": " -118.29226 "
   },
   {
      "Vendor": "BELLAMAR MARKET",
      "Address": "W 1429 3RD ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90017",
      "County": " LOS ANGELES",
      "Latitude": "34.0588600  ",
      "Longitude": " -118.26241 "
   },
   {
      "Vendor": "MOMMY'S NUTRITIONAL CENTER",
      "Address": "N 603 AZUSA AVE",
      "City": "AZUSA",
      "Zip Code": " 91702",
      "County": " LOS ANGELES",
      "Latitude": "34.1321950  ",
      "Longitude": " -117.90772 "
   },
   {
      "Vendor": "MOMMY'S NUTRITIONAL CENTER",
      "Address": "E 125 ANAHEIM ST",
      "Second Address": " STE F",
      "City": "WILMINGTON",
      "Zip Code": " 90744",
      "County": " LOS ANGELES",
      "Latitude": "33.7802760  ",
      "Longitude": " -118.26155 "
   },
   {
      "Vendor": "TARGET STORE T-0226",
      "Address": " 2462 FOOTHILL BLVD",
      "City": "LA VERNE",
      "Zip Code": " 91750",
      "County": " LOS ANGELES",
      "Latitude": "34.1110690  ",
      "Longitude": " -117.75920 "
   },
   {
      "Vendor": "TARGET STORE T-1028",
      "Address": "E 2831 LAND CENTER DR",
      "City": "WEST COVINA",
      "Zip Code": " 91791",
      "County": " LOS ANGELES",
      "Latitude": "34.0742010  ",
      "Longitude": " -117.88419 "
   },
   {
      "Vendor": "TARGET STORE T-2147",
      "Address": "S 2370 AZUSA AVE",
      "City": "WEST COVINA",
      "Zip Code": " 91792",
      "County": " LOS ANGELES",
      "Latitude": "34.0334810  ",
      "Longitude": " -117.91137 "
   },
   {
      "Vendor": "TARGET STORE T-2307",
      "Address": " 2195 GLENDALE GALLERIA WAY",
      "City": "GLENDALE",
      "Zip Code": " 91210",
      "County": " LOS ANGELES",
      "Latitude": "34.1429260  ",
      "Longitude": " -118.25858 "
   },
   {
      "Vendor": "TARGET STORE T-0195",
      "Address": "N 2270 BELLFLOWER BLVD",
      "City": "LONG BEACH",
      "Zip Code": " 90815",
      "County": " LOS ANGELES",
      "Latitude": "33.7981180  ",
      "Longitude": " -118.12500 "
   },
   {
      "Vendor": "TARGET STORE T-2026",
      "Address": "S 20700 AVALON BLVD",
      "City": "CARSON",
      "Zip Code": " 90746",
      "County": " LOS ANGELES",
      "Latitude": "33.8672340  ",
      "Longitude": " -118.26581 "
   },
   {
      "Vendor": "TARGET STORE T-2020",
      "Address": " 8999 BALBOA BLVD",
      "City": "NORTHRIDGE",
      "Zip Code": " 91325",
      "County": " LOS ANGELES",
      "Latitude": "34.2345050  ",
      "Longitude": " -118.50347 "
   },
   {
      "Vendor": "TARGET STORE T-1411",
      "Address": " 3600 ROSEMEAD BLVD",
      "City": "ROSEMEAD",
      "Zip Code": " 91770",
      "County": " LOS ANGELES",
      "Latitude": "34.0746060  ",
      "Longitude": " -118.07019 "
   },
   {
      "Vendor": "TARGET STORE T-0227",
      "Address": " 10621 CARMENITA RD",
      "City": "SANTA FE SPRINGS",
      "Zip Code": " 90670",
      "County": " LOS ANGELES",
      "Latitude": "33.9384520  ",
      "Longitude": " -118.04678 "
   },
   {
      "Vendor": "TARGET STORE T-1309",
      "Address": " 14920 RAYMER ST",
      "City": "VAN NUYS",
      "Zip Code": " 91405",
      "County": " LOS ANGELES",
      "Latitude": "34.2132340  ",
      "Longitude": " -118.46013 "
   },
   {
      "Vendor": "TARGET STORE T-0228",
      "Address": " 6635 FALLBROOK AVE",
      "City": "WEST HILLS",
      "Zip Code": " 91307",
      "County": " LOS ANGELES",
      "Latitude": "34.1907400  ",
      "Longitude": " -118.62686 "
   },
   {
      "Vendor": "TARGET STORE T-1033",
      "Address": " 3100 BALDWIN PARK BLVD",
      "City": "BALDWIN PARK",
      "Zip Code": " 91706",
      "County": " LOS ANGELES",
      "Latitude": "34.0692940  ",
      "Longitude": " -117.97673 "
   },
   {
      "Vendor": "TARGET STORE T-0222",
      "Address": " 17751 COLIMA RD",
      "City": "ROWLAND HEIGHTS",
      "Zip Code": " 91748",
      "County": " LOS ANGELES",
      "Latitude": "33.9904870  ",
      "Longitude": " -117.91935 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #133",
      "Address": "E 1010 AVENUE J",
      "City": "LANCASTER",
      "Zip Code": " 93535",
      "County": " LOS ANGELES",
      "Latitude": "34.6884250  ",
      "Longitude": " -118.11162 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #137",
      "Address": "E 38360 20TH ST",
      "City": "PALMDALE",
      "Zip Code": " 93550",
      "County": " LOS ANGELES",
      "Latitude": "34.5791620  ",
      "Longitude": " -118.09207 "
   },
   {
      "Vendor": "LAGUNA MARKET",
      "Address": "W 2125 6TH ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90057",
      "County": " LOS ANGELES",
      "Latitude": "34.0599710  ",
      "Longitude": " -118.27538 "
   },
   {
      "Vendor": "TARGET STORE T-0289",
      "Address": " 20200 BLOOMFIELD AVE",
      "City": "CERRITOS",
      "Zip Code": " 90703",
      "County": " LOS ANGELES",
      "Latitude": "33.8471280  ",
      "Longitude": " -118.06313 "
   },
   {
      "Vendor": "TARGET STORE T-1305",
      "Address": "E 11525 SOUTH ST",
      "City": "CERRITOS",
      "Zip Code": " 90703",
      "County": " LOS ANGELES",
      "Latitude": "33.8594020  ",
      "Longitude": " -118.08793 "
   },
   {
      "Vendor": "TARGET STORE T-1409",
      "Address": " 141 LAKEWOOD CENTER MALL",
      "City": "LAKEWOOD",
      "Zip Code": " 90712",
      "County": " LOS ANGELES",
      "Latitude": "33.8525850  ",
      "Longitude": " -118.14051 "
   },
   {
      "Vendor": "TARGET STORE T-1329",
      "Address": "W 3471 CENTURY BLVD",
      "City": "INGLEWOOD",
      "Zip Code": " 90303",
      "County": " LOS ANGELES",
      "Latitude": "33.9481530  ",
      "Longitude": " -118.33289 "
   },
   {
      "Vendor": "TARGET STORE T-0288",
      "Address": " 20801 VENTURA BLVD",
      "City": "WOODLAND HILLS",
      "Zip Code": " 91364",
      "County": " LOS ANGELES",
      "Latitude": "34.1667810  ",
      "Longitude": " -118.58527 "
   },
   {
      "Vendor": "TARGET STORE T-2329",
      "Address": " 11133 BALBOA BLVD",
      "City": "GRANADA HILLS",
      "Zip Code": " 91344",
      "County": " LOS ANGELES",
      "Latitude": "34.2726480  ",
      "Longitude": " -118.50240 "
   },
   {
      "Vendor": "TARGET STORE T-0299",
      "Address": " 8840 CORBIN AVE",
      "City": "NORTHRIDGE",
      "Zip Code": " 91324",
      "County": " LOS ANGELES",
      "Latitude": "34.2309210  ",
      "Longitude": " -118.56209 "
   },
   {
      "Vendor": "TARGET STORE T-2143",
      "Address": " 6700 TOPANGA CANYON BLVD",
      "City": "CANOGA PARK",
      "Zip Code": " 91303",
      "County": " LOS ANGELES",
      "Latitude": "34.1919620  ",
      "Longitude": " -118.60564 "
   },
   {
      "Vendor": "TARGET STORE T-1332",
      "Address": " 3121 COLORADO BLVD",
      "City": "PASADENA",
      "Zip Code": " 91107",
      "County": " LOS ANGELES",
      "Latitude": "34.1464010  ",
      "Longitude": " -118.08570 "
   },
   {
      "Vendor": "TARGET STORE T-0883",
      "Address": "E 777 COLORADO BLVD",
      "City": "PASADENA",
      "Zip Code": " 91101",
      "County": " LOS ANGELES",
      "Latitude": "34.1460880  ",
      "Longitude": " -118.13450 "
   },
   {
      "Vendor": "TARGET STORE T-0294",
      "Address": " 11051 VICTORY BLVD",
      "City": "NORTH HOLLYWOOD",
      "Zip Code": " 91606",
      "County": " LOS ANGELES",
      "Latitude": "34.1868840  ",
      "Longitude": " -118.37124 "
   },
   {
      "Vendor": "TARGET STORE T-0767",
      "Address": "W 888 ARROW HWY",
      "City": "SAN DIMAS",
      "Zip Code": " 91773",
      "County": " LOS ANGELES",
      "Latitude": "34.1064110  ",
      "Longitude": " -117.82346 "
   },
   {
      "Vendor": "TARGET STORE T-2627",
      "Address": "N 809 AZUSA AVE",
      "City": "AZUSA",
      "Zip Code": " 91702",
      "County": " LOS ANGELES",
      "Latitude": "34.1360070  ",
      "Longitude": " -117.90771 "
   },
   {
      "Vendor": "TARGET STORE T-0302",
      "Address": " 1050 HUNTINGTON DR",
      "City": "DUARTE",
      "Zip Code": " 91010",
      "County": " LOS ANGELES",
      "Latitude": "34.1393920  ",
      "Longitude": " -117.97048 "
   },
   {
      "Vendor": "EL SUPER #27",
      "Address": " 3211 FIRESTONE BLVD",
      "City": "SOUTH GATE",
      "Zip Code": " 90280",
      "County": " LOS ANGELES",
      "Latitude": "33.9558070  ",
      "Longitude": " -118.21268 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #532",
      "Address": " 37926 47TH ST E",
      "Second Address": " STE F",
      "City": "PALMDALE",
      "Zip Code": " 93552",
      "County": " LOS ANGELES",
      "Latitude": "34.5714360  ",
      "Longitude": " -118.04400 "
   },
   {
      "Vendor": "AMAPOLA DELI & MARKET",
      "Address": " 13733 GARFIELD AVE",
      "City": "PARAMOUNT",
      "Zip Code": " 90723",
      "County": " LOS ANGELES",
      "Latitude": "33.9120180  ",
      "Longitude": " -118.16969 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#228",
      "Address": "E 156 COMPTON BLVD",
      "City": "COMPTON",
      "Zip Code": " 90221",
      "County": " LOS ANGELES",
      "Latitude": "33.8958950  ",
      "Longitude": " -118.22292 "
   },
   {
      "Vendor": "CINCO CORAS MARKET",
      "Address": "W 225 ANAHEIM ST",
      "Second Address": "  SUITE #2",
      "City": "LONG BEACH",
      "Zip Code": " 90813",
      "County": " LOS ANGELES",
      "Latitude": "33.7829870  ",
      "Longitude": " -118.19468 "
   },
   {
      "Vendor": "DEL AMO MARKET",
      "Address": " 20340 HARVARD BLVD",
      "City": "TORRANCE",
      "Zip Code": " 90501",
      "County": " LOS ANGELES",
      "Latitude": "33.8462130  ",
      "Longitude": " -118.30645 "
   },
   {
      "Vendor": "VENICE MARKET",
      "Address": " 1339 VENICE BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90006",
      "County": " LOS ANGELES",
      "Latitude": "34.0435380  ",
      "Longitude": " -118.28313 "
   },
   {
      "Vendor": "SANTA CLARITA VLY PRODUCE",
      "Address": " 23975 NEWHALL RANCH RD",
      "City": "VALENCIA",
      "Zip Code": " 91355",
      "County": " LOS ANGELES",
      "Latitude": "34.4304760  ",
      "Longitude": " -118.55570 "
   },
   {
      "Vendor": "MOM & BABY NUTRITIONAL",
      "Address": " 11230 GARVEY AVE",
      "Second Address": " STE K",
      "City": "EL MONTE",
      "Zip Code": " 91733",
      "County": " LOS ANGELES",
      "Latitude": "34.0624270  ",
      "Longitude": " -118.03097 "
   },
   {
      "Vendor": "FREDDY'S MARKET",
      "Address": " 3433 TWEEDY BLVD",
      "City": "SOUTH GATE",
      "Zip Code": " 90280",
      "County": " LOS ANGELES",
      "Latitude": "33.9445760  ",
      "Longitude": " -118.20897 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #518B",
      "Address": "E 2247 PALMDALE BLVD",
      "Second Address": " STE F",
      "City": "PALMDALE",
      "Zip Code": " 93550",
      "County": " LOS ANGELES",
      "Latitude": "34.5805110  ",
      "Longitude": " -118.08810 "
   },
   {
      "Vendor": "LA CHIQUITA MEAT MARKET",
      "Address": "E 3307 FLORENCE AVE",
      "City": "HUNTINGTON PARK",
      "Zip Code": " 90255",
      "County": " LOS ANGELES",
      "Latitude": "33.9726160  ",
      "Longitude": " -118.20794 "
   },
   {
      "Vendor": "WAL-MART STORE #5072",
      "Address": "S 19503 NORMANDIE AVE",
      "City": "TORRANCE",
      "Zip Code": " 90501",
      "County": " LOS ANGELES",
      "Latitude": "33.8552790  ",
      "Longitude": " -118.29944 "
   },
   {
      "Vendor": "CHALIA'S EXPRESS NUTRITIONA",
      "Address": "E 3578 1ST ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90063",
      "County": " LOS ANGELES",
      "Latitude": "34.0357790  ",
      "Longitude": " -118.18970 "
   },
   {
      "Vendor": "TARGET STORE T-0200",
      "Address": " 3433 SEPULVEDA BLVD",
      "City": "TORRANCE",
      "Zip Code": " 90505",
      "County": " LOS ANGELES",
      "Latitude": "33.8253390  ",
      "Longitude": " -118.34565 "
   },
   {
      "Vendor": "TARGET STORE T-2179",
      "Address": " 747 GRAND AVE",
      "City": "DIAMOND BAR",
      "Zip Code": " 91765",
      "County": " LOS ANGELES",
      "Latitude": "34.0051850  ",
      "Longitude": " -117.82084 "
   },
   {
      "Vendor": "TARGET STORE T-2275",
      "Address": "S 1621 ALAMEDA ST",
      "City": "COMPTON",
      "Zip Code": " 90220",
      "County": " LOS ANGELES",
      "Latitude": "33.8798760  ",
      "Longitude": " -118.21908 "
   },
   {
      "Vendor": "TARGET STORE T-1340",
      "Address": " 10600 FIRESTONE BLVD",
      "City": "NORWALK",
      "Zip Code": " 90650",
      "County": " LOS ANGELES",
      "Latitude": "33.9259990  ",
      "Longitude": " -118.10666 "
   },
   {
      "Vendor": "FRESCO COMMUNITY MARKET",
      "Address": " 5914 MONTEREY RD",
      "City": "LOS ANGELES",
      "Zip Code": " 90042",
      "County": " LOS ANGELES",
      "Latitude": "34.1048680  ",
      "Longitude": " -118.18451 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #128",
      "Address": " 14433 RAMONA BLVD",
      "City": "BALDWIN PARK",
      "Zip Code": " 91706",
      "County": " LOS ANGELES",
      "Latitude": "34.0868140  ",
      "Longitude": " -117.95949 "
   },
   {
      "Vendor": "SMART & FINAL #437",
      "Address": "W 39212 10TH ST",
      "City": "PALMDALE",
      "Zip Code": " 93551",
      "County": " LOS ANGELES",
      "Latitude": "34.5962970  ",
      "Longitude": " -118.14554 "
   },
   {
      "Vendor": "CENTRAL STORE",
      "Address": "S 10105 CENTRAL AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90002",
      "County": " LOS ANGELES",
      "Latitude": "33.9447650  ",
      "Longitude": " -118.25446 "
   },
   {
      "Vendor": "PALOMINO MARKET",
      "Address": "E 3085 GAGE AVE",
      "City": "HUNTINGTON PARK",
      "Zip Code": " 90255",
      "County": " LOS ANGELES",
      "Latitude": "33.9810700  ",
      "Longitude": " -118.21281 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#232",
      "Address": "E 424 WASHINGTON BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90015",
      "County": " LOS ANGELES",
      "Latitude": "34.0290140  ",
      "Longitude": " -118.26040 "
   },
   {
      "Vendor": "WINCO FOODS #107",
      "Address": "E 3400 SOUTH ST",
      "City": "LAKEWOOD",
      "Zip Code": " 90712",
      "County": " LOS ANGELES",
      "Latitude": "33.8600110  ",
      "Longitude": " -118.15095 "
   },
   {
      "Vendor": "SUPER KING MARKET #4",
      "Address": " 436 AUTO CENTER DR",
      "City": "CLAREMONT",
      "Zip Code": " 91711",
      "County": " LOS ANGELES",
      "Latitude": "34.0805970  ",
      "Longitude": " -117.72036 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #38",
      "Address": " 38118 47TH ST E",
      "City": "PALMDALE",
      "Zip Code": " 93552",
      "County": " LOS ANGELES",
      "Latitude": "34.5746390  ",
      "Longitude": " -118.04362 "
   },
   {
      "Vendor": "TARGET STORE T-0183",
      "Address": " 9725 LAUREL CANYON BLVD",
      "City": "PACOIMA",
      "Zip Code": " 91331",
      "County": " LOS ANGELES",
      "Latitude": "34.2448350  ",
      "Longitude": " -118.41881 "
   },
   {
      "Vendor": "TARGET STORE T-0189",
      "Address": " 5600 WHITTIER BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90022",
      "County": " LOS ANGELES",
      "Latitude": "34.0187440  ",
      "Longitude": " -118.15038 "
   },
   {
      "Vendor": "SAFEWAY #2315",
      "Address": " 699 LEWELLING BLVD",
      "City": "SAN LEANDRO",
      "Zip Code": " 94579",
      "County": " ALAMEDA",
      "Latitude": "37.6869150  ",
      "Longitude": " -122.13678 "
   },
   {
      "Vendor": "RALEY'S #316",
      "Address": " 5420 SUNOL BLVD",
      "Second Address": " STE 1",
      "City": "PLEASANTON",
      "Zip Code": " 94566",
      "County": " ALAMEDA",
      "Latitude": "37.6514920  ",
      "Longitude": " -121.87998 "
   },
   {
      "Vendor": "SAFEWAY #1197",
      "Address": " 1790 DECOTO RD",
      "City": "UNION CITY",
      "Zip Code": " 94587",
      "County": " ALAMEDA",
      "Latitude": "37.5884800  ",
      "Longitude": " -122.02084 "
   },
   {
      "Vendor": "MEXICO SUPER",
      "Address": " 32575 MISSION BLVD",
      "City": "HAYWARD",
      "Zip Code": " 94544",
      "County": " ALAMEDA",
      "Latitude": "37.6105420  ",
      "Longitude": " -122.02584 "
   },
   {
      "Vendor": "SAFEWAY #1224",
      "Address": " 5877 JARVIS AVE",
      "City": "NEWARK",
      "Zip Code": " 94560",
      "County": " ALAMEDA",
      "Latitude": "37.5518770  ",
      "Longitude": " -122.04954 "
   },
   {
      "Vendor": "RALEY'S #315",
      "Address": " 39200 PASEO PADRE PKWY",
      "City": "FREMONT",
      "Zip Code": " 94538",
      "County": " ALAMEDA",
      "Latitude": "37.5534840  ",
      "Longitude": " -121.97895 "
   },
   {
      "Vendor": "SAFEWAY #1257",
      "Address": " 4495 FIRST ST",
      "City": "LIVERMORE",
      "Zip Code": " 94550",
      "County": " ALAMEDA",
      "Latitude": "37.6993800  ",
      "Longitude": " -121.74280 "
   },
   {
      "Vendor": "SAFEWAY #3125",
      "Address": " 3889 SAN PABLO AVE",
      "City": "EMERYVILLE",
      "Zip Code": " 94608",
      "County": " ALAMEDA",
      "Latitude": "37.8299760  ",
      "Longitude": " -122.28022 "
   },
   {
      "Vendor": "GUADALAJARA MARKET",
      "Address": "E 14327 14TH ST",
      "City": "SAN LEANDRO",
      "Zip Code": " 94578",
      "County": " ALAMEDA",
      "Latitude": "37.7112410  ",
      "Longitude": " -122.13767 "
   },
   {
      "Vendor": "SAFEWAY #0638",
      "Address": " 4100 REDWOOD RD",
      "City": "OAKLAND",
      "Zip Code": " 94619",
      "County": " ALAMEDA",
      "Latitude": "37.7983710  ",
      "Longitude": " -122.18267 "
   },
   {
      "Vendor": "FOOD MAXX #409",
      "Address": " 39441 FREMONT BLVD",
      "City": "FREMONT",
      "Zip Code": " 94538",
      "County": " ALAMEDA",
      "Latitude": "37.5441890  ",
      "Longitude": " -121.98243 "
   },
   {
      "Vendor": "FOOD MAXX #406",
      "Address": " 27300 HESPERIAN BLVD",
      "City": "HAYWARD",
      "Zip Code": " 94545",
      "County": " ALAMEDA",
      "Latitude": "37.6314660  ",
      "Longitude": " -122.09694 "
   },
   {
      "Vendor": "FOOD SOURCE #710",
      "Address": " 26905 MISSION BLVD",
      "Second Address": " STE D",
      "City": "HAYWARD",
      "Zip Code": " 94544",
      "County": " ALAMEDA",
      "Latitude": "37.6451350  ",
      "Longitude": " -122.06252 "
   },
   {
      "Vendor": "SAFEWAY #1119",
      "Address": " 3747 GRAND AVE",
      "City": "OAKLAND",
      "Zip Code": " 94610",
      "County": " ALAMEDA",
      "Latitude": "37.8172540  ",
      "Longitude": " -122.24543 "
   },
   {
      "Vendor": "SUPERMERCADO MI TIERRA #1",
      "Address": " 1470 HIGH ST",
      "City": "OAKLAND",
      "Zip Code": " 94601",
      "County": " ALAMEDA",
      "Latitude": "37.7728000  ",
      "Longitude": " -122.21392 "
   },
   {
      "Vendor": "SUPERMERCADO MI TIERRA #2",
      "Address": " 2758 FRUITVALE AVE",
      "City": "OAKLAND",
      "Zip Code": " 94601",
      "County": " ALAMEDA",
      "Latitude": "37.7912990  ",
      "Longitude": " -122.21941 "
   },
   {
      "Vendor": "SAFEWAY #1953",
      "Address": " 7499 DUBLIN BLVD",
      "City": "DUBLIN",
      "Zip Code": " 94568",
      "County": " ALAMEDA",
      "Latitude": "37.7061160  ",
      "Longitude": " -121.92702 "
   },
   {
      "Vendor": "SAFEWAY #1932",
      "Address": " 4440 TASSAJARA RD",
      "City": "DUBLIN",
      "Zip Code": " 94568",
      "County": " ALAMEDA",
      "Latitude": "37.7069380  ",
      "Longitude": " -121.87372 "
   },
   {
      "Vendor": "FOOD MAXX #416",
      "Address": " 699 LEWELLING BLVD",
      "City": "SAN LEANDRO",
      "Zip Code": " 94579",
      "County": " ALAMEDA",
      "Latitude": "37.6869150  ",
      "Longitude": " -122.13678 "
   },
   {
      "Vendor": "SUPERMERCADO MI TIERRA #3",
      "Address": " 9520 INTERNATIONAL BLVD",
      "City": "OAKLAND",
      "Zip Code": " 94603",
      "County": " ALAMEDA",
      "Latitude": "37.7465530  ",
      "Longitude": " -122.17180 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #507",
      "Address": " 7200 BANCROFT AVE",
      "Second Address": " UNIT #205",
      "City": "OAKLAND",
      "Zip Code": " 94605",
      "County": " ALAMEDA",
      "Latitude": "37.7662220  ",
      "Longitude": " -122.17743 "
   },
   {
      "Vendor": "NOB HILL FOODS #631",
      "Address": "E 919 STANLEY BLVD",
      "City": "LIVERMORE",
      "Zip Code": " 94550",
      "County": " ALAMEDA",
      "Latitude": "37.6771320  ",
      "Longitude": " -121.78456 "
   },
   {
      "Vendor": "FOOD MAXX #462",
      "Address": " 39966 CEDAR BLVD",
      "City": "NEWARK",
      "Zip Code": " 94560",
      "County": " ALAMEDA",
      "Latitude": "37.5184640  ",
      "Longitude": " -121.99191 "
   },
   {
      "Vendor": "FOOD MAXX #463",
      "Address": " 30073 INDUSTRIAL PKWY SW",
      "City": "UNION CITY",
      "Zip Code": " 94587",
      "County": " ALAMEDA",
      "Latitude": "37.6118300  ",
      "Longitude": " -122.06695 "
   },
   {
      "Vendor": "SAFEWAY #1931",
      "Address": " 46848 MISSION BLVD",
      "City": "FREMONT",
      "Zip Code": " 94539",
      "County": " ALAMEDA",
      "Latitude": "37.4884520  ",
      "Longitude": " -121.93087 "
   },
   {
      "Vendor": "FOOD MAXX #417",
      "Address": " 10950 INTERNATIONAL BLVD",
      "City": "OAKLAND",
      "Zip Code": " 94603",
      "County": " ALAMEDA",
      "Latitude": "37.7371520  ",
      "Longitude": " -122.16354 "
   },
   {
      "Vendor": "SAFEWAY #2708",
      "Address": "S 2227 SHORE CTR",
      "City": "ALAMEDA",
      "Zip Code": " 94501",
      "County": " ALAMEDA",
      "Latitude": "37.7575770  ",
      "Longitude": " -122.25113 "
   },
   {
      "Vendor": "LUCKY #700",
      "Address": " 815 MARINA VILLAGE PKWY",
      "City": "ALAMEDA",
      "Zip Code": " 94501",
      "County": " ALAMEDA",
      "Latitude": "37.7826310  ",
      "Longitude": " -122.27325 "
   },
   {
      "Vendor": "LUCKY #704",
      "Address": " 3443 CASTRO VALLEY BLVD",
      "City": "CASTRO VALLEY",
      "Zip Code": " 94546",
      "County": " ALAMEDA",
      "Latitude": "37.6946620  ",
      "Longitude": " -122.07593 "
   },
   {
      "Vendor": "LUCKY #711",
      "Address": " 40055 MISSION BLVD",
      "City": "FREMONT",
      "Zip Code": " 94539",
      "County": " ALAMEDA",
      "Latitude": "37.5559550  ",
      "Longitude": " -121.95169 "
   },
   {
      "Vendor": "LUCKY #712",
      "Address": " 34101 FREMONT BLVD",
      "City": "FREMONT",
      "Zip Code": " 94555",
      "County": " ALAMEDA",
      "Latitude": "37.5766290  ",
      "Longitude": " -122.04436 "
   },
   {
      "Vendor": "LUCKY #713",
      "Address": " 35820 FREMONT BLVD",
      "City": "FREMONT",
      "Zip Code": " 94536",
      "County": " ALAMEDA",
      "Latitude": "37.5663540  ",
      "Longitude": " -122.02314 "
   },
   {
      "Vendor": "LUCKY #714",
      "Address": " 5000 MOWRY AVE",
      "City": "FREMONT",
      "Zip Code": " 94538",
      "County": " ALAMEDA",
      "Latitude": "37.5355710  ",
      "Longitude": " -121.99891 "
   },
   {
      "Vendor": "LUCKY #715",
      "Address": " 22555 MISSION BLVD",
      "City": "HAYWARD",
      "Zip Code": " 94541",
      "County": " ALAMEDA",
      "Latitude": "37.6720460  ",
      "Longitude": " -122.08589 "
   },
   {
      "Vendor": "LUCKY #716",
      "Address": " 25151 SANTA CLARA ST",
      "City": "HAYWARD",
      "Zip Code": " 94544",
      "County": " ALAMEDA",
      "Latitude": "37.6478340  ",
      "Longitude": " -122.09006 "
   },
   {
      "Vendor": "LUCKY #721",
      "Address": " 2000 PORTOLA AVE",
      "City": "LIVERMORE",
      "Zip Code": " 94550",
      "County": " ALAMEDA",
      "Latitude": "37.6925340  ",
      "Longitude": " -121.77450 "
   },
   {
      "Vendor": "LUCKY #722",
      "Address": " 1951 HOLMES ST",
      "City": "LIVERMORE",
      "Zip Code": " 94550",
      "County": " ALAMEDA",
      "Latitude": "37.6619490  ",
      "Longitude": " -121.78032 "
   },
   {
      "Vendor": "LUCKY #734",
      "Address": " 1963 MOUNTAIN BLVD",
      "City": "OAKLAND",
      "Zip Code": " 94611",
      "County": " ALAMEDA",
      "Latitude": "37.8280030  ",
      "Longitude": " -122.21047 "
   },
   {
      "Vendor": "FOOD MAXX #484",
      "Address": "E 3000 9TH ST",
      "City": "OAKLAND",
      "Zip Code": " 94606",
      "County": " ALAMEDA",
      "Latitude": "37.7748500  ",
      "Longitude": " -122.23182 "
   },
   {
      "Vendor": "LUCKY #736",
      "Address": "E 247 18TH ST",
      "City": "OAKLAND",
      "Zip Code": " 94606",
      "County": " ALAMEDA",
      "Latitude": "37.7993910  ",
      "Longitude": " -122.25304 "
   },
   {
      "Vendor": "LUCKY #744",
      "Address": "W 6155 LAS POSITAS AVE",
      "City": "PLEASANTON",
      "Zip Code": " 94566",
      "County": " ALAMEDA",
      "Latitude": "37.6816550  ",
      "Longitude": " -121.90511 "
   },
   {
      "Vendor": "LUCKY #767",
      "Address": " 1300 FAIRMONT DR",
      "City": "SAN LEANDRO",
      "Zip Code": " 94578",
      "County": " ALAMEDA",
      "Latitude": "37.7034950  ",
      "Longitude": " -122.12875 "
   },
   {
      "Vendor": "LUCKY #768",
      "Address": " 15840 HESPERIAN BLVD",
      "City": "SAN LORENZO",
      "Zip Code": " 94580",
      "County": " ALAMEDA",
      "Latitude": "37.6818460  ",
      "Longitude": " -122.12822 "
   },
   {
      "Vendor": "LUCKY #782",
      "Address": " 32300 DYER ST",
      "City": "UNION CITY",
      "Zip Code": " 94587",
      "County": " ALAMEDA",
      "Latitude": "37.5988720  ",
      "Longitude": " -122.07064 "
   },
   {
      "Vendor": "NOB HILL FOODS #632",
      "Address": " 2531 BLANDING AVE",
      "City": "ALAMEDA",
      "Zip Code": " 94501",
      "County": " ALAMEDA",
      "Latitude": "37.7693470  ",
      "Longitude": " -122.23448 "
   },
   {
      "Vendor": "CHAVEZ SUPERMARKET",
      "Address": "W 1157 TENNYSON RD",
      "City": "HAYWARD",
      "Zip Code": " 94544",
      "County": " ALAMEDA",
      "Latitude": "37.6315870  ",
      "Longitude": " -122.07720 "
   },
   {
      "Vendor": "HAYWARD PRODUCE MARKET",
      "Address": " 370 WINTON AVE",
      "City": "HAYWARD",
      "Zip Code": " 94544",
      "County": " ALAMEDA",
      "Latitude": "37.6625490  ",
      "Longitude": " -122.08551 "
   },
   {
      "Vendor": "RANCHO MARKET",
      "Address": " 1950 FRUITVALE AVE",
      "City": "OAKLAND",
      "Zip Code": " 94601",
      "County": " ALAMEDA",
      "Latitude": "37.7835110  ",
      "Longitude": " -122.22288 "
   },
   {
      "Vendor": "CHAPALA MARKET",
      "Address": " 5415 INTERNATIONAL BLVD",
      "City": "OAKLAND",
      "Zip Code": " 94601",
      "County": " ALAMEDA",
      "Latitude": "37.7672840  ",
      "Longitude": " -122.20481 "
   },
   {
      "Vendor": "SUPERMERCADO MI TIERRA #7",
      "Address": "E 14340 14TH ST",
      "City": "SAN LEANDRO",
      "Zip Code": " 94578",
      "County": " ALAMEDA",
      "Latitude": "37.7116220  ",
      "Longitude": " -122.13685 "
   },
   {
      "Vendor": "BABY NUTRITIONAL CARE #9",
      "Address": " 900 MARKET ST",
      "Second Address": " STE A",
      "City": "OAKLAND",
      "Zip Code": " 94607",
      "County": " ALAMEDA",
      "Latitude": "37.8037370  ",
      "Longitude": " -122.28159 "
   },
   {
      "Vendor": "A & G MARKET",
      "Address": "E 1849 21ST ST",
      "City": "OAKLAND",
      "Zip Code": " 94606",
      "County": " ALAMEDA",
      "Latitude": "37.7914540  ",
      "Longitude": " -122.23659 "
   },
   {
      "Vendor": "SUPERMERCADO LA RAZA",
      "Address": "E 16411 14TH ST",
      "City": "SAN LEANDRO",
      "Zip Code": " 94578",
      "County": " ALAMEDA",
      "Latitude": "37.6946070  ",
      "Longitude": " -122.11348 "
   },
   {
      "Vendor": "MI CARNAL MARKET",
      "Address": " 2755 FOOTHILL BLVD",
      "City": "OAKLAND",
      "Zip Code": " 94601",
      "County": " ALAMEDA",
      "Latitude": "37.7842270  ",
      "Longitude": " -122.22673 "
   },
   {
      "Vendor": "ALL GREEN PRODUCE",
      "Address": " 4095 FOOTHILL BLVD",
      "City": "OAKLAND",
      "Zip Code": " 94601",
      "County": " ALAMEDA",
      "Latitude": "37.7765600  ",
      "Longitude": " -122.21390 "
   },
   {
      "Vendor": "SHOP RITE SUPERMARKET",
      "Address": " 5800 BANCROFT AVE",
      "City": "OAKLAND",
      "Zip Code": " 94605",
      "County": " ALAMEDA",
      "Latitude": "37.7710880  ",
      "Longitude": " -122.19304 "
   },
   {
      "Vendor": "EL RANCHITO MARKET",
      "Address": " 1536 23RD AVE",
      "City": "OAKLAND",
      "Zip Code": " 94606",
      "County": " ALAMEDA",
      "Latitude": "37.7846750  ",
      "Longitude": " -122.23423 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #521",
      "Address": " 10325 INTERNATIONAL BLVD",
      "City": "OAKLAND",
      "Zip Code": " 94603",
      "County": " ALAMEDA",
      "Latitude": "37.7401840  ",
      "Longitude": " -122.16740 "
   },
   {
      "Vendor": "SMART & FINAL #424",
      "Address": " 3171 WALNUT AVE",
      "City": "FREMONT",
      "Zip Code": " 94538",
      "County": " ALAMEDA",
      "Latitude": "37.5506790  ",
      "Longitude": " -121.97887 "
   },
   {
      "Vendor": "SMART & FINAL #596",
      "Address": " 5775 JOHNSON DR",
      "City": "PLEASANTON",
      "Zip Code": " 94588",
      "County": " ALAMEDA",
      "Latitude": "37.6995200  ",
      "Longitude": " -121.90641 "
   },
   {
      "Vendor": "BABY NUTRITIONAL CARE #101",
      "Address": " 32970 ALVARADO NILES RD",
      "Second Address": " STE 752",
      "City": "UNION CITY",
      "Zip Code": " 94587",
      "County": " ALAMEDA",
      "Latitude": "37.5942780  ",
      "Longitude": " -122.04601 "
   },
   {
      "Vendor": "SMART & FINAL #445",
      "Address": " 1243 42ND AVE",
      "City": "OAKLAND",
      "Zip Code": " 94601",
      "County": " ALAMEDA",
      "Latitude": "37.7727930  ",
      "Longitude": " -122.21717 "
   },
   {
      "Vendor": "SMART & FINAL #401",
      "Address": " 1094 SUEIRRO ST",
      "City": "HAYWARD",
      "Zip Code": " 94541",
      "County": " ALAMEDA",
      "Latitude": "37.6617320  ",
      "Longitude": " -122.11734 "
   },
   {
      "Vendor": "LA ESPERANZA TRICOLOR",
      "Address": " 340 A ST",
      "City": "HAYWARD",
      "Zip Code": " 94541",
      "County": " ALAMEDA",
      "Latitude": "37.6687980  ",
      "Longitude": " -122.09525 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #534",
      "Address": " 22301 MISSION BLVD",
      "City": "HAYWARD",
      "Zip Code": " 94545",
      "County": " ALAMEDA",
      "Latitude": "37.6749110  ",
      "Longitude": " -122.08729 "
   },
   {
      "Vendor": "SMART & FINAL #523",
      "Address": " 31070 DYER ST",
      "City": "UNION CITY",
      "Zip Code": " 94587",
      "County": " ALAMEDA",
      "Latitude": "37.6011290  ",
      "Longitude": " -122.06886 "
   },
   {
      "Vendor": "JALISCO MARKET",
      "Address": " 9710 EDES AVE",
      "City": "OAKLAND",
      "Zip Code": " 94603",
      "County": " ALAMEDA",
      "Latitude": "37.7369310  ",
      "Longitude": " -122.18402 "
   },
   {
      "Vendor": "HEALTHY & HAPPY FAMILY MARK",
      "Address": " 1480 FRUITVALE AVE",
      "City": "OAKLAND",
      "Zip Code": " 94601",
      "County": " ALAMEDA",
      "Latitude": "37.7786140  ",
      "Longitude": " -122.22490 "
   },
   {
      "Vendor": "TARGET STORE T-1428",
      "Address": "E 15555 14TH ST",
      "City": "SAN LEANDRO",
      "Zip Code": " 94578",
      "County": " ALAMEDA",
      "Latitude": "37.6984740  ",
      "Longitude": " -122.12767 "
   },
   {
      "Vendor": "LOS PERICOS MARKET",
      "Address": " 2200 MARINA BLVD",
      "City": "SAN LEANDRO",
      "Zip Code": " 94577",
      "County": " ALAMEDA",
      "Latitude": "37.7046720  ",
      "Longitude": " -122.18058 "
   },
   {
      "Vendor": "TARGET STORE T-1422",
      "Address": " 39201 FREMONT BLVD",
      "City": "FREMONT",
      "Zip Code": " 94538",
      "County": " ALAMEDA",
      "Latitude": "37.5468870  ",
      "Longitude": " -121.98561 "
   },
   {
      "Vendor": "TARGET STORE T-0328",
      "Address": " 7200 AMADOR PLAZA RD",
      "City": "DUBLIN",
      "Zip Code": " 94568",
      "County": " ALAMEDA",
      "Latitude": "37.7072190  ",
      "Longitude": " -121.92963 "
   },
   {
      "Vendor": "TARGET STORE T-1926",
      "Address": " 1057 EASTSHORE HWY",
      "City": "ALBANY",
      "Zip Code": " 94710",
      "County": " ALAMEDA",
      "Latitude": "37.8838480  ",
      "Longitude": " -122.30794 "
   },
   {
      "Vendor": "LOS PERICOS MARKET",
      "Address": "E 375 14TH ST",
      "City": "SAN LEANDRO",
      "Zip Code": " 94577",
      "County": " ALAMEDA",
      "Latitude": "37.7327900  ",
      "Longitude": " -122.16225 "
   },
   {
      "Vendor": "MARIA'S MARKET AND DELI",
      "Address": " 7229 INTERNATIONAL BLVD",
      "City": "OAKLAND",
      "Zip Code": " 94621",
      "County": " ALAMEDA",
      "Latitude": "37.7595490  ",
      "Longitude": " -122.18794 "
   },
   {
      "Vendor": "TARGET STORE T-1472",
      "Address": " 2499 WHIPPLE RD",
      "City": "HAYWARD",
      "Zip Code": " 94544",
      "County": " ALAMEDA",
      "Latitude": "37.6071710  ",
      "Longitude": " -122.06350 "
   },
   {
      "Vendor": "TARGET STORE T-2185",
      "Address": " 19661 HESPERIAN BLVD",
      "City": "HAYWARD",
      "Zip Code": " 94541",
      "County": " ALAMEDA",
      "Latitude": "37.6683220  ",
      "Longitude": " -122.12008 "
   },
   {
      "Vendor": "SAFEWAY #3010",
      "Address": "E 4015 CASTRO VALLEY BLVD",
      "City": "CASTRO VALLEY",
      "Zip Code": " 94552",
      "County": " ALAMEDA",
      "Latitude": "37.6949240  ",
      "Longitude": " -122.05053 "
   },
   {
      "Vendor": "WAL-MART #5434",
      "Address": " 15555 HESPERIAN BLVD",
      "City": "SAN LEANDRO",
      "Zip Code": " 94579",
      "County": " ALAMEDA",
      "Latitude": "37.6895600  ",
      "Longitude": " -122.13083 "
   },
   {
      "Vendor": "WAL-MART STORE #2648",
      "Address": " 1919 DAVIS ST",
      "City": "SAN LEANDRO",
      "Zip Code": " 94577",
      "County": " ALAMEDA",
      "Latitude": "37.7146450  ",
      "Longitude": " -122.17777 "
   },
   {
      "Vendor": "WAL-MART STORE #2031",
      "Address": " 30600 DYER ST",
      "City": "UNION CITY",
      "Zip Code": " 94587",
      "County": " ALAMEDA",
      "Latitude": "37.6042630  ",
      "Longitude": " -122.06713 "
   },
   {
      "Vendor": "TARGET STORE T-0828",
      "Address": " 4300 LAS POSITAS RD",
      "City": "LIVERMORE",
      "Zip Code": " 94551",
      "County": " ALAMEDA",
      "Latitude": "37.7005700  ",
      "Longitude": " -121.74655 "
   },
   {
      "Vendor": "TARGET STORE T-2767",
      "Address": " 1555 40TH ST",
      "City": "EMERYVILLE",
      "Zip Code": " 94608",
      "County": " ALAMEDA",
      "Latitude": "37.8289490  ",
      "Longitude": " -122.29279 "
   },
   {
      "Vendor": "ARTEAGAS FOOD CENTER",
      "Address": " 226 JACKSON ST",
      "City": "HAYWARD",
      "Zip Code": " 94544",
      "County": " ALAMEDA",
      "Latitude": "37.6594420  ",
      "Longitude": " -122.08648 "
   },
   {
      "Vendor": "BABY NUTRITIONAL CARE #20",
      "Address": "W 213 WINTON AVE",
      "City": "HAYWARD",
      "Zip Code": " 94544",
      "County": " ALAMEDA",
      "Latitude": "37.6589600  ",
      "Longitude": " -122.09607 "
   },
   {
      "Vendor": "SAFEWAY #2856",
      "Address": " 6790 BERNAL AVE",
      "City": "PLEASANTON",
      "Zip Code": " 94566",
      "County": " ALAMEDA",
      "Latitude": "37.6561150  ",
      "Longitude": " -121.89931 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #556",
      "Address": "E 15964 14TH ST",
      "City": "SAN LEANDRO",
      "Zip Code": " 94578",
      "County": " ALAMEDA",
      "Latitude": "37.6997110  ",
      "Longitude": " -122.11943 "
   },
   {
      "Vendor": "TARGET STORE T-2771",
      "Address": " 2800 DUBLIN BLVD",
      "City": "DUBLIN",
      "Zip Code": " 94568",
      "County": " ALAMEDA",
      "Latitude": "37.7053750  ",
      "Longitude": " -121.85407 "
   },
   {
      "Vendor": "FOODS CO #534",
      "Address": " 10790 MACARTHUR BLVD",
      "City": "OAKLAND",
      "Zip Code": " 94605",
      "County": " ALAMEDA",
      "Latitude": "37.7419990  ",
      "Longitude": " -122.15061 "
   },
   {
      "Vendor": "WAL-MART #2161",
      "Address": " 4501 ROSEWOOD DR",
      "City": "PLEASANTON",
      "Zip Code": " 94588",
      "County": " ALAMEDA",
      "Latitude": "37.6983060  ",
      "Longitude": " -121.88737 "
   },
   {
      "Vendor": "WAL-MART #5611",
      "Address": " 3112 SANTA RITA RD",
      "City": "PLEASANTON",
      "Zip Code": " 94566",
      "County": " ALAMEDA",
      "Latitude": "37.6900470  ",
      "Longitude": " -121.87806 "
   },
   {
      "Vendor": "CHAVEZ SUPERMARKET",
      "Address": " 24601 MISSION BLVD",
      "City": "HAYWARD",
      "Zip Code": " 94544",
      "County": " ALAMEDA",
      "Latitude": "37.6626610  ",
      "Longitude": " -122.07646 "
   },
   {
      "Vendor": "WAL-MART STORE #2989",
      "Address": " 44009 OSGOOD RD",
      "City": "FREMONT",
      "Zip Code": " 94539",
      "County": " ALAMEDA",
      "Latitude": "37.5114680  ",
      "Longitude": " -121.94093 "
   },
   {
      "Vendor": "SAFEWAY #3281",
      "Address": " 2600 FIFTH ST",
      "City": "ALAMEDA",
      "Zip Code": " 94501",
      "County": " ALAMEDA",
      "Latitude": "37.7776400  ",
      "Longitude": " -122.28222 "
   },
   {
      "Vendor": "SAFEWAY #2870",
      "Address": " 6310 COLLEGE AVE",
      "City": "OAKLAND",
      "Zip Code": " 94618",
      "County": " ALAMEDA",
      "Latitude": "37.8505440  ",
      "Longitude": " -122.25185 "
   },
   {
      "Vendor": "OAKTREE MARKET",
      "Address": " 1601 28TH AVE",
      "City": "OAKLAND",
      "Zip Code": " 94601",
      "County": " ALAMEDA",
      "Latitude": "37.7817850  ",
      "Longitude": " -122.22857 "
   },
   {
      "Vendor": "TARGET STORE T-2615",
      "Address": " 43950 PACIFIC COMMONS BLVD",
      "City": "FREMONT",
      "Zip Code": " 94538",
      "County": " ALAMEDA",
      "Latitude": "37.5010170  ",
      "Longitude": " -121.96910 "
   },
   {
      "Vendor": "TARGET STORE T-2829",
      "Address": " 2700 FIFTH ST",
      "City": "ALAMEDA",
      "Zip Code": " 94501",
      "County": " ALAMEDA",
      "Latitude": "37.7887130  ",
      "Longitude": " -122.27950 "
   },
   {
      "Vendor": "FRESH & EASY",
      "Address": " 1943 FRUITVALE AVE",
      "City": "OAKLAND",
      "Zip Code": " 94601",
      "County": " ALAMEDA",
      "Latitude": "37.7836310  ",
      "Longitude": " -122.22317 "
   },
   {
      "Vendor": "FRESH & EASY 2",
      "Address": " 2630 INTERNATIONAL BLVD",
      "City": "OAKLAND",
      "Zip Code": " 94601",
      "County": " ALAMEDA",
      "Latitude": "37.7813940  ",
      "Longitude": " -122.23212 "
   },
   {
      "Vendor": "SAFEWAY #3132",
      "Address": " 5100 BROADWAY",
      "City": "OAKLAND",
      "Zip Code": " 94611",
      "County": " ALAMEDA",
      "Latitude": "37.8344280  ",
      "Longitude": " -122.24973 "
   },
   {
      "Vendor": "CARDENAS",
      "Address": " 1630 HIGH ST",
      "City": "OAKLAND",
      "Zip Code": " 94601",
      "County": " ALAMEDA",
      "Latitude": "37.7733820  ",
      "Longitude": " -122.21236 "
   },
   {
      "Vendor": "CARDENAS #211",
      "Address": " 187 HARDER RD",
      "City": "HAYWARD",
      "Zip Code": " 94544",
      "County": " ALAMEDA",
      "Latitude": "37.6491100  ",
      "Longitude": " -122.07515 "
   },
   {
      "Vendor": "CARDENAS #201",
      "Address": " 20812 HESPERIAN BLVD",
      "City": "HAYWARD",
      "Zip Code": " 94541",
      "County": " ALAMEDA",
      "Latitude": "37.6646360  ",
      "Longitude": " -122.11711 "
   },
   {
      "Vendor": "SAFEWAY COMMUNITY MARKET #2451",
      "Address": " 1850 SOLANO AVE",
      "City": "BERKELEY",
      "Zip Code": " 94707",
      "County": " ALAMEDA",
      "Latitude": "37.8912050  ",
      "Longitude": " -122.27859 "
   },
   {
      "Vendor": "SAFEWAY COMMUNITY MKT #2453",
      "Address": " 1550 SHATTUCK DR",
      "City": "BERKELEY",
      "Zip Code": " 94709",
      "County": " ALAMEDA",
      "Latitude": "37.8788560  ",
      "Longitude": " -122.26980 "
   },
   {
      "Vendor": "LAKE NATURAL FOODS",
      "Address": " 3622 TELEGRAPH AVE",
      "City": "OAKLAND",
      "Zip Code": " 94609",
      "County": " ALAMEDA",
      "Latitude": "37.8247200  ",
      "Longitude": " -122.26543 "
   },
   {
      "Vendor": "FAMILY FIRST",
      "Address": " 1112 INTERNATIONAL BLVD",
      "City": "OAKLAND",
      "Zip Code": " 94606",
      "County": " ALAMEDA",
      "Latitude": "37.7912480  ",
      "Longitude": " -122.24875 "
   },
   {
      "Vendor": "LUCKY CALIFORNIA #750",
      "Address": " 2840 DUBLIN BLVD",
      "City": "DUBLIN",
      "Zip Code": " 94568",
      "County": " ALAMEDA",
      "Latitude": "37.7051170  ",
      "Longitude": " -121.85451 "
   },
   {
      "Vendor": "MY AISHA",
      "Address": " 3025 FOOTHILL BLVD",
      "City": "OAKLAND",
      "Zip Code": " 94601",
      "County": " ALAMEDA",
      "Latitude": "37.7837750  ",
      "Longitude": " -122.22350 "
   },
   {
      "Vendor": "MI RANCHITO MARKET",
      "Address": " 3326 FOOTHILL BLVD",
      "Second Address": "  B",
      "City": "OAKLAND",
      "Zip Code": " 94601",
      "County": " ALAMEDA",
      "Latitude": "37.7833190  ",
      "Longitude": " -122.22052 "
   },
   {
      "Vendor": "RALEY'S #409",
      "Address": "E 715 BIDWELL ST",
      "City": "FOLSOM",
      "Zip Code": " 95630",
      "County": " SACRAMENTO",
      "Latitude": "38.6709540  ",
      "Longitude": " -121.15914 "
   },
   {
      "Vendor": "BEL AIR MARKET #516",
      "Address": " 5100 LAGUNA BLVD",
      "City": "ELK GROVE",
      "Zip Code": " 95758",
      "County": " SACRAMENTO",
      "Latitude": "38.4223600  ",
      "Longitude": " -121.44536 "
   },
   {
      "Vendor": "BEL AIR MARKET #519",
      "Address": " 7901 WALERGA RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95843",
      "County": " SACRAMENTO",
      "Latitude": "38.7114270  ",
      "Longitude": " -121.36653 "
   },
   {
      "Vendor": "SAVE MART #072",
      "Address": " 1059 C ST",
      "City": "GALT",
      "Zip Code": " 95632",
      "County": " SACRAMENTO",
      "Latitude": "38.2531310  ",
      "Longitude": " -121.29710 "
   },
   {
      "Vendor": "BEL AIR MARKET #522",
      "Address": " 2155 GOLDEN CENTRE LN",
      "City": "GOLD RIVER",
      "Zip Code": " 95670",
      "County": " SACRAMENTO",
      "Latitude": "38.6257110  ",
      "Longitude": " -121.26253 "
   },
   {
      "Vendor": "SAFEWAY #1531",
      "Address": " 7301 GREENBACK LN",
      "City": "CITRUS HEIGHTS",
      "Zip Code": " 95621",
      "County": " SACRAMENTO",
      "Latitude": "38.6794570  ",
      "Longitude": " -121.29334 "
   },
   {
      "Vendor": "KING'S SUPERMARKET",
      "Address": " 400 EL CAMINO AVE",
      "City": "SACRAMENTO",
      "Zip Code": " 95815",
      "County": " SACRAMENTO",
      "Latitude": "38.6111330  ",
      "Longitude": " -121.45749 "
   },
   {
      "Vendor": "FOOD SOURCE #702",
      "Address": " 6366 MACK RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95823",
      "County": " SACRAMENTO",
      "Latitude": "38.4731560  ",
      "Longitude": " -121.42812 "
   },
   {
      "Vendor": "RALEY'S #416",
      "Address": " 3518 MARCONI AVE",
      "City": "SACRAMENTO",
      "Zip Code": " 95821",
      "County": " SACRAMENTO",
      "Latitude": "38.6169770  ",
      "Longitude": " -121.38157 "
   },
   {
      "Vendor": "SAFEWAY #1289",
      "Address": " 8377 ELK GROVE-FLORIN RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95829",
      "County": " SACRAMENTO",
      "Latitude": "38.4535170  ",
      "Longitude": " -121.37143 "
   },
   {
      "Vendor": "WINCO FOODS #36",
      "Address": " 4137 ELVERTA RD",
      "City": "ANTELOPE",
      "Zip Code": " 95843",
      "County": " SACRAMENTO",
      "Latitude": "38.7152650  ",
      "Longitude": " -121.36707 "
   },
   {
      "Vendor": "SAFEWAY #1560",
      "Address": " 4040 MANZANITA AVE",
      "City": "CARMICHAEL",
      "Zip Code": " 95608",
      "County": " SACRAMENTO",
      "Latitude": "38.6379580  ",
      "Longitude": " -121.32626 "
   },
   {
      "Vendor": "FOOD SOURCE #703",
      "Address": " 4401 BROADWAY",
      "City": "SACRAMENTO",
      "Zip Code": " 95817",
      "County": " SACRAMENTO",
      "Latitude": "38.5473230  ",
      "Longitude": " -121.45527 "
   },
   {
      "Vendor": "FOOD SOURCE #704",
      "Address": " 3547 BRADSHAW RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95827",
      "County": " SACRAMENTO",
      "Latitude": "38.5583420  ",
      "Longitude": " -121.33443 "
   },
   {
      "Vendor": "SAFEWAY #1530",
      "Address": " 3320 ARDEN WAY",
      "City": "SACRAMENTO",
      "Zip Code": " 95825",
      "County": " SACRAMENTO",
      "Latitude": "38.5944140  ",
      "Longitude": " -121.38665 "
   },
   {
      "Vendor": "SAFEWAY #1647",
      "Address": " 5021 LAGUNA BLVD",
      "City": "ELK GROVE",
      "Zip Code": " 95758",
      "County": " SACRAMENTO",
      "Latitude": "38.4240150  ",
      "Longitude": " -121.44615 "
   },
   {
      "Vendor": "WINCO FOODS #37",
      "Address": " 8142 SHELDON RD",
      "City": "ELK GROVE",
      "Zip Code": " 95758",
      "County": " SACRAMENTO",
      "Latitude": "38.4366020  ",
      "Longitude": " -121.40675 "
   },
   {
      "Vendor": "BEL AIR MARKET #523",
      "Address": " 8425 ELK GROVE FLORIN RD",
      "City": "ELK GROVE",
      "Zip Code": " 95624",
      "County": " SACRAMENTO",
      "Latitude": "38.4515470  ",
      "Longitude": " -121.37031 "
   },
   {
      "Vendor": "SAFEWAY #1746",
      "Address": " 10635 FOLSOM BLVD",
      "City": "RANCHO CORDOVA",
      "Zip Code": " 95670",
      "County": " SACRAMENTO",
      "Latitude": "38.5954870  ",
      "Longitude": " -121.29305 "
   },
   {
      "Vendor": "SAFEWAY #1794",
      "Address": " 1840 PRAIRIE CITY RD",
      "City": "FOLSOM",
      "Zip Code": " 95630",
      "County": " SACRAMENTO",
      "Latitude": "38.6504280  ",
      "Longitude": " -121.16445 "
   },
   {
      "Vendor": "FOODS CO #355",
      "Address": " 3625 NORTHGATE BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95834",
      "County": " SACRAMENTO",
      "Latitude": "38.6316780  ",
      "Longitude": " -121.47575 "
   },
   {
      "Vendor": "FOODS CO #371",
      "Address": " 8122 GERBER RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95828",
      "County": " SACRAMENTO",
      "Latitude": "38.4807400  ",
      "Longitude": " -121.40772 "
   },
   {
      "Vendor": "FOODS CO #501",
      "Address": " 5330 STOCKTON BLVD",
      "Second Address": " STE 5412",
      "City": "SACRAMENTO",
      "Zip Code": " 95820",
      "County": " SACRAMENTO",
      "Latitude": "38.5271930  ",
      "Longitude": " -121.44383 "
   },
   {
      "Vendor": "LA SUPERIOR MERCADOS",
      "Address": " 2210 NORTHGATE BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95833",
      "County": " SACRAMENTO",
      "Latitude": "38.6073400  ",
      "Longitude": " -121.47511 "
   },
   {
      "Vendor": "RALEY'S #302",
      "Address": " 10430 TWIN CITIES RD",
      "City": "GALT",
      "Zip Code": " 95632",
      "County": " SACRAMENTO",
      "Latitude": "38.2895400  ",
      "Longitude": " -121.30735 "
   },
   {
      "Vendor": "RALEY'S #447",
      "Address": " 4650 NATOMAS BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95835",
      "County": " SACRAMENTO",
      "Latitude": "38.6573150  ",
      "Longitude": " -121.51047 "
   },
   {
      "Vendor": "BEL AIR MARKET #524",
      "Address": "E 2760 BIDWELL DR",
      "City": "FOLSOM",
      "Zip Code": " 95630",
      "County": " SACRAMENTO",
      "Latitude": "38.6559150  ",
      "Longitude": " -121.12172 "
   },
   {
      "Vendor": "BABY'S NUTRITION CENTER",
      "Address": " 7612 CALIFORNIA AVE",
      "City": "HUNTINGTON PARK",
      "Zip Code": " 90255",
      "County": " LOS ANGELES",
      "Latitude": "33.9681170  ",
      "Longitude": " -118.20367 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #12B",
      "Address": " 15948 AMAR RD",
      "City": "CITY OF INDUSTRY",
      "Zip Code": " 91744",
      "County": " LOS ANGELES",
      "Latitude": "34.0360510  ",
      "Longitude": " -117.93726 "
   },
   {
      "Vendor": "SMART & FINAL #598",
      "Address": " 4237 WOODRUFF AVE",
      "City": "LAKEWOOD",
      "Zip Code": " 90713",
      "County": " LOS ANGELES",
      "Latitude": "33.8355150  ",
      "Longitude": " -118.11649 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#600",
      "Address": " 21013 SHERMAN WAY",
      "Second Address": " STE 5",
      "City": "CANOGA PARK",
      "Zip Code": " 91303",
      "County": " LOS ANGELES",
      "Latitude": "34.2011040  ",
      "Longitude": " -118.59104 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#602",
      "Address": " 6424 BELLINGHAM AVE",
      "City": "NORTH HOLLYWOOD",
      "Zip Code": " 91606",
      "County": " LOS ANGELES",
      "Latitude": "34.1875040  ",
      "Longitude": " -118.39874 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#604",
      "Address": " 7132 VAN NUYS BLVD",
      "City": "VAN NUYS",
      "Zip Code": " 91405",
      "County": " LOS ANGELES",
      "Latitude": "34.2001990  ",
      "Longitude": " -118.44875 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#606",
      "Address": "S 15212 WESTERN AVE",
      "Second Address": " STE C",
      "City": "GARDENA",
      "Zip Code": " 90249",
      "County": " LOS ANGELES",
      "Latitude": "33.8932260  ",
      "Longitude": " -118.30915 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#607",
      "Address": "N 1008 CITRUS AVE",
      "City": "COVINA",
      "Zip Code": " 91723",
      "County": " LOS ANGELES",
      "Latitude": "34.0973470  ",
      "Longitude": " -117.89019 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#608",
      "Address": "W 1605 WASHINGTON BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90006",
      "County": " LOS ANGELES",
      "Latitude": "34.0399990  ",
      "Longitude": " -118.29245 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#612",
      "Address": " 13643 VAN NUYS BLVD",
      "City": "PACOIMA",
      "Zip Code": " 91331",
      "County": " LOS ANGELES",
      "Latitude": "34.2605940  ",
      "Longitude": " -118.43022 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#610",
      "Address": "W 4100 PICO BLVD",
      "Second Address": " STE 1 & 2",
      "City": "LOS ANGELES",
      "Zip Code": " 90019",
      "County": " LOS ANGELES",
      "Latitude": "34.0180230  ",
      "Longitude": " -118.20190 "
   },
   {
      "Vendor": "FOOD 4 LESS #762",
      "Address": "E 3210 ANAHEIM ST",
      "City": "LONG BEACH",
      "Zip Code": " 90804",
      "County": " LOS ANGELES",
      "Latitude": "33.7823990  ",
      "Longitude": " -118.15372 "
   },
   {
      "Vendor": "NORTHGATE MARKET #37",
      "Address": "S 425 SOTO ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90033",
      "County": " LOS ANGELES",
      "Latitude": "34.0402380  ",
      "Longitude": " -118.21303 "
   },
   {
      "Vendor": "ALBERTSONS #108",
      "Address": "W 1735 ARTESIA BLVD",
      "City": "GARDENA",
      "Zip Code": " 90247",
      "County": " LOS ANGELES",
      "Latitude": "33.8739510  ",
      "Longitude": " -118.30797 "
   },
   {
      "Vendor": "ALBERTSONS #4131",
      "Address": " 3901 CRENSHAW BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90008",
      "County": " LOS ANGELES",
      "Latitude": "34.0141340  ",
      "Longitude": " -118.33587 "
   },
   {
      "Vendor": "ALBERTSONS #132",
      "Address": "E 101 WILLOW ST",
      "City": "LONG BEACH",
      "Zip Code": " 90806",
      "County": " LOS ANGELES",
      "Latitude": "33.8055160  ",
      "Longitude": " -118.19176 "
   },
   {
      "Vendor": "ALBERTSONS #2935",
      "Address": "E 110 CARSON ST",
      "City": "CARSON",
      "Zip Code": " 90745",
      "County": " LOS ANGELES",
      "Latitude": "33.8309570  ",
      "Longitude": " -118.27690 "
   },
   {
      "Vendor": "ALBERTSONS #140",
      "Address": " 7676 FIRESTONE BLVD",
      "City": "DOWNEY",
      "Zip Code": " 90241",
      "County": " LOS ANGELES",
      "Latitude": "33.9452730  ",
      "Longitude": " -118.14398 "
   },
   {
      "Vendor": "ALBERTSONS #148",
      "Address": " 15200 ROSECRANS BLVD",
      "City": "LA MIRADA",
      "Zip Code": " 90638",
      "County": " LOS ANGELES",
      "Latitude": "33.8986330  ",
      "Longitude": " -118.00731 "
   },
   {
      "Vendor": "ALBERTSONS #3859",
      "Address": "E 200 SEPULVEDA BLVD",
      "City": "CARSON",
      "Zip Code": " 90745",
      "County": " LOS ANGELES",
      "Latitude": "33.8066650  ",
      "Longitude": " -118.27277 "
   },
   {
      "Vendor": "ALBERTSONS #1181",
      "Address": " 2469 VIA CAMPO ST",
      "City": "MONTEBELLO",
      "Zip Code": " 90640",
      "County": " LOS ANGELES",
      "Latitude": "34.0328350  ",
      "Longitude": " -118.12262 "
   },
   {
      "Vendor": "ALBERTSONS #191",
      "Address": " 5015 DEL AMO BLVD",
      "City": "LAKEWOOD",
      "Zip Code": " 90712",
      "County": " LOS ANGELES",
      "Latitude": "33.8477680  ",
      "Longitude": " -118.13483 "
   },
   {
      "Vendor": "ALBERTSONS #3301",
      "Address": "W 23850 COPPER HILL RD",
      "City": "SANTA CLARITA",
      "Zip Code": " 91355",
      "County": " LOS ANGELES",
      "Latitude": "34.4619410  ",
      "Longitude": " -118.55672 "
   },
   {
      "Vendor": "ALBERTSONS #2305",
      "Address": " 19307 SATICOY ST",
      "City": "RESEDA",
      "Zip Code": " 91335",
      "County": " LOS ANGELES",
      "Latitude": "34.2092920  ",
      "Longitude": " -118.55433 "
   },
   {
      "Vendor": "ALBERTSONS #1322",
      "Address": " 43543 20TH ST W",
      "City": "LANCASTER",
      "Zip Code": " 93536",
      "County": " LOS ANGELES",
      "Latitude": "34.6742720  ",
      "Longitude": " -118.16666 "
   },
   {
      "Vendor": "ALBERTSONS #1333",
      "Address": "N 38727 TIERRA SUBIDA AVE",
      "City": "PALMDALE",
      "Zip Code": " 93550",
      "County": " LOS ANGELES",
      "Latitude": "34.5389240  ",
      "Longitude": " -118.14155 "
   },
   {
      "Vendor": "ALBERTSONS #1335",
      "Address": " 26521 AGOURA RD",
      "City": "CALABASAS",
      "Zip Code": " 91302",
      "County": " LOS ANGELES",
      "Latitude": "34.1441780  ",
      "Longitude": " -118.70028 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #503",
      "Address": "N 5655 HILLSDALE BLVD",
      "Second Address": " UNIT 4",
      "City": "SACRAMENTO",
      "Zip Code": " 95842",
      "County": " SACRAMENTO",
      "Latitude": "38.6712670  ",
      "Longitude": " -121.35988 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #506",
      "Address": " 2251 FLORIN RD",
      "Second Address": " STE 107",
      "City": "SACRAMENTO",
      "Zip Code": " 95822",
      "County": " SACRAMENTO",
      "Latitude": "38.4967980  ",
      "Longitude": " -121.48470 "
   },
   {
      "Vendor": "FOOD MAXX #464",
      "Address": " 3860 FLORIN RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95823",
      "County": " SACRAMENTO",
      "Latitude": "38.4950680  ",
      "Longitude": " -121.46083 "
   },
   {
      "Vendor": "ALBERTSONS #359",
      "Address": " 9022 BALBOA BLVD",
      "City": "NORTHRIDGE",
      "Zip Code": " 91325",
      "County": " LOS ANGELES",
      "Latitude": "34.2349180  ",
      "Longitude": " -118.50256 "
   },
   {
      "Vendor": "ALBERTSONS #1360",
      "Address": "W 27631 BOUQUET CANYON RD",
      "City": "SAUGUS",
      "Zip Code": " 91350",
      "County": " LOS ANGELES",
      "Latitude": "34.4433980  ",
      "Longitude": " -118.51066 "
   },
   {
      "Vendor": "ALBERTSONS #387",
      "Address": " 2035 HILLHURST AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90027",
      "County": " LOS ANGELES",
      "Latitude": "34.1087790  ",
      "Longitude": " -118.28796 "
   },
   {
      "Vendor": "ALBERTSONS #3175",
      "Address": " 6240 FOOTHILL BLVD",
      "City": "TUJUNGA",
      "Zip Code": " 91042",
      "County": " LOS ANGELES",
      "Latitude": "34.2405680  ",
      "Longitude": " -118.26807 "
   },
   {
      "Vendor": "ALBERTSONS #2543",
      "Address": "W 2400 COMMONWEALTH AVE",
      "City": "ALHAMBRA",
      "Zip Code": " 91803",
      "County": " LOS ANGELES",
      "Latitude": "34.0869200  ",
      "Longitude": " -118.14991 "
   },
   {
      "Vendor": "ALBERTSONS #3554",
      "Address": "S 1235 DIAMOND BAR BLVD",
      "City": "DIAMOND BAR",
      "Zip Code": " 91765",
      "County": " LOS ANGELES",
      "Latitude": "34.0003790  ",
      "Longitude": " -117.81255 "
   },
   {
      "Vendor": "ALBERTSONS #561",
      "Address": "E 298 LIVE OAK AVE",
      "City": "ARCADIA",
      "Zip Code": " 91006",
      "County": " LOS ANGELES",
      "Latitude": "34.1077060  ",
      "Longitude": " -118.02318 "
   },
   {
      "Vendor": "ALBERTSONS #594",
      "Address": "E 220 BONITA AVE",
      "City": "SAN DIMAS",
      "Zip Code": " 91773",
      "County": " LOS ANGELES",
      "Latitude": "34.1060330  ",
      "Longitude": " -117.80387 "
   },
   {
      "Vendor": "ALBERTSONS #601",
      "Address": "W 133 ROUTE 66",
      "City": "GLENDORA",
      "Zip Code": " 91740",
      "County": " LOS ANGELES",
      "Latitude": "34.1298760  ",
      "Longitude": " -117.86516 "
   },
   {
      "Vendor": "LUCKY #142",
      "Address": " 4155 TWEEDY BLVD",
      "City": "SOUTH GATE",
      "Zip Code": " 90280",
      "County": " LOS ANGELES",
      "Latitude": "33.9442320  ",
      "Longitude": " -118.19864 "
   },
   {
      "Vendor": "SUPER KING MARKET #6",
      "Address": " 7227 VAN NUYS BLVD",
      "City": "VAN NUYS",
      "Zip Code": " 91405",
      "County": " LOS ANGELES",
      "Latitude": "34.2021280  ",
      "Longitude": " -118.44998 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #140",
      "Address": " 16100 LAKEWOOD BLVD",
      "City": "BELLFLOWER",
      "Zip Code": " 90706",
      "County": " LOS ANGELES",
      "Latitude": "33.8879920  ",
      "Longitude": " -118.14170 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #139",
      "Address": "S 3480 LA BREA AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90016",
      "County": " LOS ANGELES",
      "Latitude": "34.0233700  ",
      "Longitude": " -118.35558 "
   },
   {
      "Vendor": "EL SUPER #41",
      "Address": " 14103 RAMONA BLVD",
      "City": "BALDWIN PARK",
      "Zip Code": " 91706",
      "County": " LOS ANGELES",
      "Latitude": "34.0852590  ",
      "Longitude": " -117.96656 "
   },
   {
      "Vendor": "EL SUPER #43",
      "Address": " 15202 HAWTHORNE BLVD",
      "City": "LAWNDALE",
      "Zip Code": " 90260",
      "County": " LOS ANGELES",
      "Latitude": "33.8927690  ",
      "Longitude": " -118.35174 "
   },
   {
      "Vendor": "EL SUPER #44",
      "Address": " 10721 ATLANTIC AVE",
      "City": "LYNWOOD",
      "Zip Code": " 90262",
      "County": " LOS ANGELES",
      "Latitude": "33.9332820  ",
      "Longitude": " -118.18279 "
   },
   {
      "Vendor": "EL SUPER #47",
      "Address": " 315 SAN FERNANDO MISSION BLVD",
      "City": "SAN FERNANDO",
      "Zip Code": " 91340",
      "County": " LOS ANGELES",
      "Latitude": "34.2837740  ",
      "Longitude": " -118.44384 "
   },
   {
      "Vendor": "EL SUPER #48",
      "Address": "W 120 ANAHEIM ST",
      "City": "WILMINGTON",
      "Zip Code": " 90744",
      "County": " LOS ANGELES",
      "Latitude": "33.7797320  ",
      "Longitude": " -118.26315 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #43",
      "Address": "S 757 WORKMAN ST",
      "City": "SAN FERNANDO",
      "Zip Code": " 91340",
      "County": " LOS ANGELES",
      "Latitude": "34.2824690  ",
      "Longitude": " -118.45249 "
   },
   {
      "Vendor": "NUMERO UNO MARKET #109",
      "Address": "W 1141 CARSON ST",
      "City": "TORRANCE",
      "Zip Code": " 90502",
      "County": " LOS ANGELES",
      "Latitude": "33.8315740  ",
      "Longitude": " -118.29617 "
   },
   {
      "Vendor": "SUPERIOR GROCERS",
      "Address": " 12721 VALLEY VIEW AVE",
      "City": "LA MIRADA",
      "Zip Code": " 90638",
      "County": " LOS ANGELES",
      "Latitude": "33.9161460  ",
      "Longitude": " -118.03016 "
   },
   {
      "Vendor": "NORTHGATE MARKET #41",
      "Address": " 4700 INGLEWOOD BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90230",
      "County": " LOS ANGELES",
      "Latitude": "33.9937080  ",
      "Longitude": " -118.41463 "
   },
   {
      "Vendor": "NORTHGATE MARKET #42",
      "Address": "E 2038 10TH ST",
      "City": "LONG BEACH",
      "Zip Code": " 90804",
      "County": " LOS ANGELES",
      "Latitude": "33.7782930  ",
      "Longitude": " -118.16697 "
   },
   {
      "Vendor": "SMART & FINAL #420",
      "Address": " 18555 DEVONSHIRE ST",
      "City": "NORTHRIDGE",
      "Zip Code": " 91324",
      "County": " LOS ANGELES",
      "Latitude": "34.2581520  ",
      "Longitude": " -118.53779 "
   },
   {
      "Vendor": "MOMMY'S NUTRITIONAL CENTER",
      "Address": "E 860 CARSON ST",
      "Second Address": " STE 112",
      "City": "CARSON",
      "Zip Code": " 90745",
      "County": " LOS ANGELES",
      "Latitude": "33.8306810  ",
      "Longitude": " -118.25972 "
   },
   {
      "Vendor": "GELSON'S MARKET #21",
      "Address": "E 6255 2ND ST",
      "City": "LONG BEACH",
      "Zip Code": " 90803",
      "County": " LOS ANGELES",
      "Latitude": "33.7584240  ",
      "Longitude": " -118.11287 "
   },
   {
      "Vendor": "LA MEXICANA MEAT MARKET",
      "Address": " 5392 POPLAR BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90032",
      "County": " LOS ANGELES",
      "Latitude": "34.0895160  ",
      "Longitude": " -118.16378 "
   },
   {
      "Vendor": "GELSON'S MARKET #23",
      "Address": " 635 FOOTHILL BLVD",
      "City": "LA CANADA FLINTRIDGE",
      "Zip Code": " 91011",
      "County": " LOS ANGELES",
      "Latitude": "34.2012790  ",
      "Longitude": " -118.19267 "
   },
   {
      "Vendor": "WAL-MART #2226",
      "Address": " 19340 HAWTHORNE BLVD",
      "City": "TORRANCE",
      "Zip Code": " 90503",
      "County": " LOS ANGELES",
      "Latitude": "33.8553110  ",
      "Longitude": " -118.35342 "
   },
   {
      "Vendor": "WAL-MART #3133",
      "Address": "N 1425 HACIENDA BLVD",
      "City": "LA PUENTE",
      "Zip Code": " 91744",
      "County": " LOS ANGELES",
      "Latitude": "34.0466400  ",
      "Longitude": " -117.94849 "
   },
   {
      "Vendor": "WAL-MART #2082",
      "Address": " 12701 TOWNE CENTER DR",
      "City": "CERRITOS",
      "Zip Code": " 90703",
      "County": " LOS ANGELES",
      "Latitude": "33.8717200  ",
      "Longitude": " -118.06173 "
   },
   {
      "Vendor": "WAL-MART #5605",
      "Address": " 14530 NORDOFF ST",
      "City": "PANORAMA CITY",
      "Zip Code": " 91402",
      "County": " LOS ANGELES",
      "Latitude": "34.2352120  ",
      "Longitude": " -118.44912 "
   },
   {
      "Vendor": "WAL-MART #5954",
      "Address": "E 2753 EASTLAND CENTER DR",
      "Second Address": " STE 5555",
      "City": "WEST COVINA",
      "Zip Code": " 91791",
      "County": " LOS ANGELES",
      "Latitude": "34.0733790  ",
      "Longitude": " -117.88727 "
   },
   {
      "Vendor": "WAL-MART #3180",
      "Address": " 4651 FIRESTONE BLVD",
      "City": "SOUTHGATE",
      "Zip Code": " 90280",
      "County": " LOS ANGELES",
      "Latitude": "33.9525890  ",
      "Longitude": " -118.18796 "
   },
   {
      "Vendor": "WAL-MART #5603",
      "Address": " 12270 PARAMOUNT BLVD",
      "City": "DOWNEY",
      "Zip Code": " 90242",
      "County": " LOS ANGELES",
      "Latitude": "33.9282700  ",
      "Longitude": " -118.14792 "
   },
   {
      "Vendor": "WAL-MART #5661",
      "Address": " 14865 TELEGRAPH RD",
      "City": "LA MIRADA",
      "Zip Code": " 90638",
      "County": " LOS ANGELES",
      "Latitude": "33.9185840  ",
      "Longitude": " -118.01411 "
   },
   {
      "Vendor": "BIG SAVER FOODS #05",
      "Address": "S 5829 COMPTON AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90001",
      "County": " LOS ANGELES",
      "Latitude": "33.9889470  ",
      "Longitude": " -118.24806 "
   },
   {
      "Vendor": "EL SUPER #24",
      "Address": "N 1285 HACIENDA BLVD",
      "City": "LA PUENTE",
      "Zip Code": " 91744",
      "County": " LOS ANGELES",
      "Latitude": "34.0443150  ",
      "Longitude": " -117.94953 "
   },
   {
      "Vendor": "SUPER KING MARKET #5",
      "Address": " 19500 PLUMMER ST",
      "City": "NORTHRIDGE",
      "Zip Code": " 91324",
      "County": " LOS ANGELES",
      "Latitude": "34.2420220  ",
      "Longitude": " -118.55966 "
   },
   {
      "Vendor": "WAL-MART #5604",
      "Address": " 14441 INGLEWOOD AVE",
      "City": "HAWTHORNE",
      "Zip Code": " 90250",
      "County": " LOS ANGELES",
      "Latitude": "33.9005480  ",
      "Longitude": " -118.36147 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#235",
      "Address": "S 10223 CENTRAL AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90002",
      "County": " LOS ANGELES",
      "Latitude": "33.9434970  ",
      "Longitude": " -118.25440 "
   },
   {
      "Vendor": "RALPHS #222",
      "Address": " 14049 VENTURA BLVD",
      "City": "SHERMAN OAKS",
      "Zip Code": " 91423",
      "County": " LOS ANGELES",
      "Latitude": "34.1498440  ",
      "Longitude": " -118.43915 "
   },
   {
      "Vendor": "SMART & FINAL #305",
      "Address": "W 1005 ARROW HWY",
      "City": "SAN DIMAS",
      "Zip Code": " 91773",
      "County": " LOS ANGELES",
      "Latitude": "34.1067410  ",
      "Longitude": " -117.82737 "
   },
   {
      "Vendor": "SMART & FINAL #482",
      "Address": " 15055 MULBERRY DR",
      "City": "WHITTIER",
      "Zip Code": " 90604",
      "County": " LOS ANGELES",
      "Latitude": "33.9355970  ",
      "Longitude": " -118.01036 "
   },
   {
      "Vendor": "SMART & FINAL #444",
      "Address": "W 4550 PICO BLVD",
      "Second Address": " STE D303",
      "City": "LOS ANGELES",
      "Zip Code": " 90019",
      "County": " LOS ANGELES",
      "Latitude": "34.0484990  ",
      "Longitude": " -118.33644 "
   },
   {
      "Vendor": "NORTHGATE MARKET #38",
      "Address": "E 944 SLAUSON AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90011",
      "County": " LOS ANGELES",
      "Latitude": "33.9887320  ",
      "Longitude": " -118.25844 "
   },
   {
      "Vendor": "NORTHGATE MARKET #35",
      "Address": "S 10801 PRAIRIE AVE",
      "City": "INGLEWOOD",
      "Zip Code": " 90303",
      "County": " LOS ANGELES",
      "Latitude": "33.9375300  ",
      "Longitude": " -118.34464 "
   },
   {
      "Vendor": "NUMERO UNO MARKET #110",
      "Address": "W 1831 3RD ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90057",
      "County": " LOS ANGELES",
      "Latitude": "34.0614670  ",
      "Longitude": " -118.26929 "
   },
   {
      "Vendor": "WAL-MART STORE #2110",
      "Address": " 14501 LAKEWOOD BLVD",
      "City": "PARAMOUNT",
      "Zip Code": " 90723",
      "County": " LOS ANGELES",
      "Latitude": "33.9016440  ",
      "Longitude": " -118.14312 "
   },
   {
      "Vendor": "WAL-MART STORE #2401",
      "Address": " 1600 MOUNTAIN AVE",
      "City": "DUARTE",
      "Zip Code": " 91010",
      "County": " LOS ANGELES",
      "Latitude": "34.1341570  ",
      "Longitude": " -117.98615 "
   },
   {
      "Vendor": "WAL-MART STORE #5602",
      "Address": " 20226 AVALON BLVD",
      "City": "CARSON",
      "Zip Code": " 90746",
      "County": " LOS ANGELES",
      "Latitude": "33.8486660  ",
      "Longitude": " -118.26458 "
   },
   {
      "Vendor": "WAL-MART STORE #1941",
      "Address": " 1950 AUTO CENTER DR",
      "City": "GLENDORA",
      "Zip Code": " 91740",
      "County": " LOS ANGELES",
      "Latitude": "34.1173010  ",
      "Longitude": " -117.82661 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #143",
      "Address": "E 4308 SLAUSON AVE",
      "City": "MAYWOOD",
      "Zip Code": " 90270",
      "County": " LOS ANGELES",
      "Latitude": "33.9872970  ",
      "Longitude": " -118.18973 "
   },
   {
      "Vendor": "WAL-MART STORE #2297",
      "Address": " 25450 THE OLD RD",
      "City": "STEVENSON RANCH",
      "Zip Code": " 91381",
      "County": " LOS ANGELES",
      "Latitude": "34.3832260  ",
      "Longitude": " -118.56975 "
   },
   {
      "Vendor": "WAL-MART STORE #5874",
      "Address": " 22015 HAWTHORNE BLVD",
      "City": "TORRANCE",
      "Zip Code": " 90503",
      "County": " LOS ANGELES",
      "Latitude": "33.8275740  ",
      "Longitude": " -118.35228 "
   },
   {
      "Vendor": "WAL-MART STORE #5152",
      "Address": " 6433 FALLBROOK AVE",
      "City": "WEST HILLS",
      "Zip Code": " 91307",
      "County": " LOS ANGELES",
      "Latitude": "34.1878300  ",
      "Longitude": " -118.62622 "
   },
   {
      "Vendor": "SUPERIOR GROCERS",
      "Address": "N 3180 GAREY AVE",
      "City": "POMONA",
      "Zip Code": " 91767",
      "County": " LOS ANGELES",
      "Latitude": "34.1060900  ",
      "Longitude": " -117.74741 "
   },
   {
      "Vendor": "LA CACHANILLA #3",
      "Address": "N 345 AZUSA AVE",
      "City": "AZUSA",
      "Zip Code": " 91702",
      "County": " LOS ANGELES",
      "Latitude": "34.1278240  ",
      "Longitude": " -117.90792 "
   },
   {
      "Vendor": "ABC NUTRITIONAL CARE",
      "Address": "E 1460 HOLT AVE",
      "Second Address": " STE 6",
      "City": "POMONA",
      "Zip Code": " 91767",
      "County": " LOS ANGELES",
      "Latitude": "34.0614080  ",
      "Longitude": " -117.72072 "
   },
   {
      "Vendor": "EL SUPER #49",
      "Address": " 450 LONG BEACH BLVD",
      "City": "LONG BEACH",
      "Zip Code": " 90802",
      "County": " LOS ANGELES",
      "Latitude": "33.7730050  ",
      "Longitude": " -118.18842 "
   },
   {
      "Vendor": "NORTHGATE MARKET #39",
      "Address": " 4700 CHERRY AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90807",
      "County": " LOS ANGELES",
      "Latitude": "33.8445910  ",
      "Longitude": " -118.16700 "
   },
   {
      "Vendor": "RANCHO FIESTA MARKET",
      "Address": "E 2816 GAGE AVE",
      "Second Address": " STE 18",
      "City": "HUNTINGTON PARK",
      "Zip Code": " 90255",
      "County": " LOS ANGELES",
      "Latitude": "33.9813890  ",
      "Longitude": " -118.21945 "
   },
   {
      "Vendor": "EL NUEVO GUADALAJARA MEAT M",
      "Address": " 6790 LONG BEACH BLVD",
      "City": "LONG BEACH",
      "Zip Code": " 90805",
      "County": " LOS ANGELES",
      "Latitude": "33.8775540  ",
      "Longitude": " -118.20344 "
   },
   {
      "Vendor": "EL RECREO MARKET",
      "Address": "W 2501 TEMPLE ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90026",
      "County": " LOS ANGELES",
      "Latitude": "34.0720640  ",
      "Longitude": " -118.27351 "
   },
   {
      "Vendor": "SUPERIOR GROCERS",
      "Address": " 15000 CRENSHAW BLVD",
      "City": "GARDENA",
      "Zip Code": " 90249",
      "County": " LOS ANGELES",
      "Latitude": "33.8949520  ",
      "Longitude": " -118.32558 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKETS #3",
      "Address": " 9134 VAN NUYS BLVD",
      "City": "PANORAMA CITY",
      "Zip Code": " 91402",
      "County": " LOS ANGELES",
      "Latitude": "34.2362610  ",
      "Longitude": " -118.44996 "
   },
   {
      "Vendor": "LA POBLANA MEAT MARKET",
      "Address": "E 5111 OLYMPIC BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90022",
      "County": " LOS ANGELES",
      "Latitude": "34.0169350  ",
      "Longitude": " -118.16044 "
   },
   {
      "Vendor": "LA MEXICANA MEAT MARKET",
      "Address": "S 14309 ATLANTIC AVE",
      "Second Address": " STE 106",
      "City": "COMPTON",
      "Zip Code": " 90221",
      "County": " LOS ANGELES",
      "Latitude": "33.9030900  ",
      "Longitude": " -118.19424 "
   },
   {
      "Vendor": "GREEN FARM MARKET",
      "Address": "W 2301 ROSENCRANS AVE",
      "City": "GARDENA",
      "Zip Code": " 90249",
      "County": " LOS ANGELES",
      "Latitude": "33.9027490  ",
      "Longitude": " -118.31924 "
   },
   {
      "Vendor": "STATER BROS. #194",
      "Address": "N 1023 GRAND AVE",
      "City": "COVINA",
      "Zip Code": " 91724",
      "County": " LOS ANGELES",
      "Latitude": "34.0979100  ",
      "Longitude": " -117.87359 "
   },
   {
      "Vendor": "WAL-MART NBRHD MARKET #3132",
      "Address": "E 778 ARROW HWY",
      "City": "POMONA",
      "Zip Code": " 91767",
      "County": " LOS ANGELES",
      "Latitude": "34.0898180  ",
      "Longitude": " -117.73718 "
   },
   {
      "Vendor": "SUPERIOR GROCERS",
      "Address": " 12630 HAWTHORNE BLVD",
      "City": "HAWTHORNE",
      "Zip Code": " 90250",
      "County": " LOS ANGELES",
      "Latitude": "33.9174100  ",
      "Longitude": " -118.35124 "
   },
   {
      "Vendor": "LA GAVIOTA MEAT MARKET",
      "Address": "E 1701 ANAHEIM ST",
      "City": "LONG BEACH",
      "Zip Code": " 90813",
      "County": " LOS ANGELES",
      "Latitude": "33.7829140  ",
      "Longitude": " -118.17060 "
   },
   {
      "Vendor": "ABC NUTRITIONAL CARE",
      "Address": "N 4827 HUNTINGTON DR",
      "Second Address": " STE B",
      "City": "LOS ANGELES",
      "Zip Code": " 90032",
      "County": " LOS ANGELES",
      "Latitude": "34.0861350  ",
      "Longitude": " -118.17936 "
   },
   {
      "Vendor": "LA BODEGA #2",
      "Address": "E 1001 10TH ST",
      "City": "LONG BEACH",
      "Zip Code": " 90813",
      "County": " LOS ANGELES",
      "Latitude": "33.7789690  ",
      "Longitude": " -118.18055 "
   },
   {
      "Vendor": "EL PROGRESO SUPERMARKET#1",
      "Address": " 19047 PARTHENIA ST",
      "City": "NORTHRIDGE",
      "Zip Code": " 91324",
      "County": " LOS ANGELES",
      "Latitude": "34.2284470  ",
      "Longitude": " -118.54861 "
   },
   {
      "Vendor": "VERNON MARKET",
      "Address": "E 272 VERNON AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90011",
      "County": " LOS ANGELES",
      "Latitude": "34.0038530  ",
      "Longitude": " -118.26969 "
   },
   {
      "Vendor": "RAPIDO LONG BEACH MARKET",
      "Address": " 6820 LONG BEACH BLVD",
      "City": "LONG BEACH",
      "Zip Code": " 90805",
      "County": " LOS ANGELES",
      "Latitude": "33.8781370  ",
      "Longitude": " -118.20355 "
   },
   {
      "Vendor": "RAUL'S MARKET",
      "Address": "S 11214 CENTRAL AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90059",
      "County": " LOS ANGELES",
      "Latitude": "33.9325170  ",
      "Longitude": " -118.25390 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #4101",
      "Address": "E 3705 SOUTH ST",
      "City": "LONG BEACH",
      "Zip Code": " 90805",
      "County": " LOS ANGELES",
      "Latitude": "33.8614190  ",
      "Longitude": " -118.14770 "
   },
   {
      "Vendor": "WAL-MART NBRHD MARKET #5689",
      "Address": " 3875 RANCHO VISTA BLVD",
      "City": "PALMDALE",
      "Zip Code": " 93551",
      "County": " LOS ANGELES",
      "Latitude": "34.6141210  ",
      "Longitude": " -118.20010 "
   },
   {
      "Vendor": "HAPPY MARKET",
      "Address": " 8609 LONG BEACH BLVD",
      "City": "SOUTH GATE",
      "Zip Code": " 90280",
      "County": " LOS ANGELES",
      "Latitude": "33.9587770  ",
      "Longitude": " -118.22221 "
   },
   {
      "Vendor": "ROWAN FOOD MARKET",
      "Address": "S 535 ROWAN AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90063",
      "County": " LOS ANGELES",
      "Latitude": "34.0294400  ",
      "Longitude": " -118.18755 "
   },
   {
      "Vendor": "COUNTRY RANCH MARKET",
      "Address": " 2800 BEVERLY BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90057",
      "County": " LOS ANGELES",
      "Latitude": "34.0702780  ",
      "Longitude": " -118.27926 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #47",
      "Address": " 18571 SOLEDAD CANYON RD",
      "City": "CANYON COUNTRY",
      "Zip Code": " 91351",
      "County": " LOS ANGELES",
      "Latitude": "34.4165150  ",
      "Longitude": " -118.45742 "
   },
   {
      "Vendor": "NUMERO UNO RANCHO #9",
      "Address": "S 8200 CENTRAL AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90001",
      "County": " LOS ANGELES",
      "Latitude": "33.9645820  ",
      "Longitude": " -118.25606 "
   },
   {
      "Vendor": "TARGET STORE T-0257",
      "Address": " 24425 MAGIC MOUNTAIN PKWY",
      "City": "VALENCIA",
      "Zip Code": " 91355",
      "County": " LOS ANGELES",
      "Latitude": "34.4211040  ",
      "Longitude": " -118.56157 "
   },
   {
      "Vendor": "TARGET STORE T-0245",
      "Address": " 43525 10TH ST W",
      "City": "LANCASTER",
      "Zip Code": " 93534",
      "County": " LOS ANGELES",
      "Latitude": "34.6736520  ",
      "Longitude": " -118.14815 "
   },
   {
      "Vendor": "RIO MEAT MARKET & RESTAURANT",
      "Address": "N 2029 FAIR OAKS AVE",
      "City": "PASADENA",
      "Zip Code": " 91103",
      "County": " LOS ANGELES",
      "Latitude": "34.1808920  ",
      "Longitude": " -118.15075 "
   },
   {
      "Vendor": "MAYWOOD MINI MARKET",
      "Address": " 5720 MAYWOOD AVE",
      "City": "MAYWOOD",
      "Zip Code": " 90270",
      "County": " LOS ANGELES",
      "Latitude": "33.9904590  ",
      "Longitude": " -118.20335 "
   },
   {
      "Vendor": "BUY LOW MARKET",
      "Address": " 10951 ROSECRANS AVE",
      "City": "NORWALK",
      "Zip Code": " 90650",
      "County": " LOS ANGELES",
      "Latitude": "33.9024810  ",
      "Longitude": " -118.10118 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#237",
      "Address": "E 2238 1ST ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90033",
      "County": " LOS ANGELES",
      "Latitude": "34.0442640  ",
      "Longitude": " -118.21103 "
   },
   {
      "Vendor": "TARGET STORE T-2810",
      "Address": " 30740 RUSSELL RANCH RD",
      "City": "WESTLAKE VILLAGE",
      "Zip Code": " 91362",
      "County": " LOS ANGELES",
      "Latitude": "34.1476290  ",
      "Longitude": " -118.79386 "
   },
   {
      "Vendor": "MONTEBELLO RANCH MARKET",
      "Address": "W 1801 WHITTIER BLVD",
      "City": "MONTEBELLO",
      "Zip Code": " 90640",
      "County": " LOS ANGELES",
      "Latitude": "34.0123620  ",
      "Longitude": " -118.12063 "
   },
   {
      "Vendor": "TARGET STORE T-0184",
      "Address": "W 2120 MAIN ST",
      "City": "ALHAMBRA",
      "Zip Code": " 91801",
      "County": " LOS ANGELES",
      "Latitude": "34.0916580  ",
      "Longitude": " -118.14659 "
   },
   {
      "Vendor": "TARGET STORE T-2776",
      "Address": "S 735 FIGUEROA ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90017",
      "County": " LOS ANGELES",
      "Latitude": "34.0492410  ",
      "Longitude": " -118.26088 "
   },
   {
      "Vendor": "RANCHO MEAT MARKET #1",
      "Address": "N 2910 BROADWAY",
      "City": "LOS ANGELES",
      "Zip Code": " 90031",
      "County": " LOS ANGELES",
      "Latitude": "34.0732220  ",
      "Longitude": " -118.21111 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#236",
      "Address": "N 1900 LONG BEACH BLVD",
      "Second Address": " STE 109",
      "City": "COMPTON",
      "Zip Code": " 90221",
      "County": " LOS ANGELES",
      "Latitude": "33.9087200  ",
      "Longitude": " -118.20784 "
   },
   {
      "Vendor": "TARGET STORE T-0685",
      "Address": " 39440 10TH ST W",
      "City": "PALMDALE",
      "Zip Code": " 93551",
      "County": " LOS ANGELES",
      "Latitude": "34.5992640  ",
      "Longitude": " -118.14645 "
   },
   {
      "Vendor": "MOTHERS & BABYS NUTRITION",
      "Address": "S 4269 VERMONT AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90037",
      "County": " LOS ANGELES",
      "Latitude": "34.0059430  ",
      "Longitude": " -118.29174 "
   },
   {
      "Vendor": "MOTHERS & BABYS NUTRITION #",
      "Address": " 10820 HAWTHORNE BLVD",
      "City": "LENNOX",
      "Zip Code": " 90304",
      "County": " LOS ANGELES",
      "Latitude": "33.9378050  ",
      "Longitude": " -118.35157 "
   },
   {
      "Vendor": "S & M NUTRITION #2",
      "Address": " 12039 LONG BEACH BLVD",
      "City": "LYNWOOD",
      "Zip Code": " 90262",
      "County": " LOS ANGELES",
      "Latitude": "33.9181870  ",
      "Longitude": " -118.20983 "
   },
   {
      "Vendor": "EL NOVILLO MARKET",
      "Address": "E 8714 AVENUE T",
      "Second Address": " STE Q",
      "City": "LITTLEROCK",
      "Zip Code": " 93543",
      "County": " LOS ANGELES",
      "Latitude": "34.5423950  ",
      "Longitude": " -117.97452 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #50",
      "Address": " 8510 PAINTER AVE",
      "Second Address": " STE L",
      "City": "WHITTIER",
      "Zip Code": " 90602",
      "County": " LOS ANGELES",
      "Latitude": "33.9609410  ",
      "Longitude": " -118.03477 "
   },
   {
      "Vendor": "TARGET STORE T-2831",
      "Address": " 701 RIO RANCHO RD",
      "City": "POMONA",
      "Zip Code": " 91765",
      "County": " LOS ANGELES",
      "Latitude": "34.0346530  ",
      "Longitude": " -117.75593 "
   },
   {
      "Vendor": "LA BODEGA RANCH MARKET",
      "Address": " 13690 GOLDENWEST ST",
      "Second Address": " STE A",
      "City": "WESTMINSTER",
      "Zip Code": " 92683",
      "County": " ORANGE",
      "Latitude": "33.7635690  ",
      "Longitude": " -118.00665 "
   },
   {
      "Vendor": "GS & F FAMILY STORE",
      "Address": "E 2168 92ND ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90002",
      "County": " LOS ANGELES",
      "Latitude": "33.9529690  ",
      "Longitude": " -118.23306 "
   },
   {
      "Vendor": "TODOS MARKET",
      "Address": "E 1801 FLORENCE AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90001",
      "County": " LOS ANGELES",
      "Latitude": "33.9751450  ",
      "Longitude": " -118.24068 "
   },
   {
      "Vendor": "SINALOA FRESH MEAT MARKET",
      "Address": " 601 ATLANTIC AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90802",
      "County": " LOS ANGELES",
      "Latitude": "33.7743450  ",
      "Longitude": " -118.18528 "
   },
   {
      "Vendor": "SMART & FINAL #323",
      "Address": " 2040 GLENOAKS BLVD",
      "City": "SAN FERNANDO",
      "Zip Code": " 91340",
      "County": " LOS ANGELES",
      "Latitude": "34.2989130  ",
      "Longitude": " -118.43856 "
   },
   {
      "Vendor": "SAMAYA FRESH",
      "Address": " 13406 LEMOLI AVE",
      "City": "HAWTHORNE",
      "Zip Code": " 90250",
      "County": " LOS ANGELES",
      "Latitude": "33.9105300  ",
      "Longitude": " -118.33064 "
   },
   {
      "Vendor": "NUMERO UNO MARKET #111",
      "Address": " 10455 LAUREL CANYON BLVD",
      "City": "PACOIMA",
      "Zip Code": " 91331",
      "County": " LOS ANGELES",
      "Latitude": "34.2595130  ",
      "Longitude": " -118.43389 "
   },
   {
      "Vendor": "SMART & FINAL #317",
      "Address": " 15427 AMAR RD",
      "City": "LA PUENTE",
      "Zip Code": " 91744",
      "County": " LOS ANGELES",
      "Latitude": "34.0376230  ",
      "Longitude": " -117.94894 "
   },
   {
      "Vendor": "SMART & FINAL #716",
      "Address": " 13003 WHITTIER BLVD",
      "City": "WHITTIER",
      "Zip Code": " 90602",
      "County": " LOS ANGELES",
      "Latitude": "33.9657670  ",
      "Longitude": " -118.03737 "
   },
   {
      "Vendor": "SMART & FINAL #434",
      "Address": " 644 REDONDO AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90814",
      "County": " LOS ANGELES",
      "Latitude": "33.7745780  ",
      "Longitude": " -118.15174 "
   },
   {
      "Vendor": "OSI FOODMART",
      "Address": "N 601 VIRGIL AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90004",
      "County": " LOS ANGELES",
      "Latitude": "34.0819260  ",
      "Longitude": " -118.28717 "
   },
   {
      "Vendor": "FOOD SOURCE #708",
      "Address": " 1375 BUCHANAN RD",
      "City": "PITTSBURG",
      "Zip Code": " 94565",
      "County": " CONTRA COSTA",
      "Latitude": "37.9981670  ",
      "Longitude": " -121.87175 "
   },
   {
      "Vendor": "SAFEWAY #0917",
      "Address": "S 600 BROADWAY",
      "City": "WALNUT CREEK",
      "Zip Code": " 94596",
      "County": " CONTRA COSTA",
      "Latitude": "37.8981320  ",
      "Longitude": " -122.05674 "
   },
   {
      "Vendor": "SAFEWAY #1714",
      "Address": " 1421 TARA HILLS DR",
      "City": "PINOLE",
      "Zip Code": " 94564",
      "County": " CONTRA COSTA",
      "Latitude": "37.9948190  ",
      "Longitude": " -122.30416 "
   },
   {
      "Vendor": "SAFEWAY #0697",
      "Address": " 1972 TICE VALLEY BLVD",
      "City": "WALNUT CREEK",
      "Zip Code": " 94595",
      "County": " CONTRA COSTA",
      "Latitude": "37.8784200  ",
      "Longitude": " -122.07190 "
   },
   {
      "Vendor": "SAFEWAY #0955",
      "Address": " 2600 WILLOW PASS RD",
      "City": "CONCORD",
      "Zip Code": " 94520",
      "County": " CONTRA COSTA",
      "Latitude": "37.9782560  ",
      "Longitude": " -122.02837 "
   },
   {
      "Vendor": "SAFEWAY #0967",
      "Address": " 2 CAMINO SOBRANTE",
      "City": "ORINDA",
      "Zip Code": " 94563",
      "County": " CONTRA COSTA",
      "Latitude": "37.8839470  ",
      "Longitude": " -122.19092 "
   },
   {
      "Vendor": "SAFEWAY #0783",
      "Address": " 3540 MOUNT DIABLO BLVD",
      "City": "LAFAYETTE",
      "Zip Code": " 94549",
      "County": " CONTRA COSTA",
      "Latitude": "37.8927960  ",
      "Longitude": " -122.11966 "
   },
   {
      "Vendor": "SAFEWAY #0939",
      "Address": " 3334 ALHAMBRA AVE",
      "City": "MARTINEZ",
      "Zip Code": " 94553",
      "County": " CONTRA COSTA",
      "Latitude": "38.0007660  ",
      "Longitude": " -122.13303 "
   },
   {
      "Vendor": "RALEY'S #333",
      "Address": " 3632 LONE TREE WAY",
      "City": "ANTIOCH",
      "Zip Code": " 94509",
      "County": " CONTRA COSTA",
      "Latitude": "37.9856870  ",
      "Longitude": " -121.80702 "
   },
   {
      "Vendor": "SAFEWAY #0972",
      "Address": " 6688 ALHAMBRA AVE",
      "City": "MARTINEZ",
      "Zip Code": " 94553",
      "County": " CONTRA COSTA",
      "Latitude": "37.9579680  ",
      "Longitude": " -122.09387 "
   },
   {
      "Vendor": "SAFEWAY #0928",
      "Address": " 600 PATTERSON BLVD",
      "City": "PLEASANT HILL",
      "Zip Code": " 94523",
      "County": " CONTRA COSTA",
      "Latitude": "37.9341570  ",
      "Longitude": " -122.07291 "
   },
   {
      "Vendor": "SAFEWAY #0936",
      "Address": " 710 BANCROFT RD",
      "City": "WALNUT CREEK",
      "Zip Code": " 94598",
      "County": " CONTRA COSTA",
      "Latitude": "37.9273310  ",
      "Longitude": " -122.04038 "
   },
   {
      "Vendor": "SAFEWAY #0976",
      "Address": " 605 PARKER AVE",
      "Second Address": " BLDG A",
      "City": "RODEO",
      "Zip Code": " 94572",
      "County": " CONTRA COSTA",
      "Latitude": "38.0298760  ",
      "Longitude": " -122.26575 "
   },
   {
      "Vendor": "SAFEWAY #0962",
      "Address": " 200 ALAMO PLAZA",
      "City": "ALAMO",
      "Zip Code": " 94507",
      "County": " CONTRA COSTA",
      "Latitude": "37.8504070  ",
      "Longitude": " -122.03484 "
   },
   {
      "Vendor": "SAFEWAY #0982",
      "Address": " 2505 SAN RAMON VALLEY RD",
      "City": "SAN RAMON",
      "Zip Code": " 94583",
      "County": " CONTRA COSTA",
      "Latitude": "37.7736850  ",
      "Longitude": " -121.97540 "
   },
   {
      "Vendor": "SAFEWAY #0969",
      "Address": " 1355 MORAGA WAY",
      "City": "MORAGA",
      "Zip Code": " 94556",
      "County": " CONTRA COSTA",
      "Latitude": "37.8351480  ",
      "Longitude": " -122.12951 "
   },
   {
      "Vendor": "NOB HILL FOODS #621",
      "Address": " 520 CENTER AVE",
      "City": "MARTINEZ",
      "Zip Code": " 94553",
      "County": " CONTRA COSTA",
      "Latitude": "37.9939020  ",
      "Longitude": " -122.11978 "
   },
   {
      "Vendor": "LUCKY #212",
      "Address": " 3190 CONTRA LOMA BLVD",
      "City": "ANTIOCH",
      "Zip Code": " 94509",
      "County": " CONTRA COSTA",
      "Latitude": "37.9904500  ",
      "Longitude": " -121.82369 "
   },
   {
      "Vendor": "LUCKY #223",
      "Address": "E 111 18TH ST",
      "City": "ANTIOCH",
      "Zip Code": " 94509",
      "County": " CONTRA COSTA",
      "Latitude": "38.0054240  ",
      "Longitude": " -121.80145 "
   },
   {
      "Vendor": "SAFEWAY #1215",
      "Address": " 660 BAILEY RD",
      "City": "BAY POINT",
      "Zip Code": " 94565",
      "County": " CONTRA COSTA",
      "Latitude": "38.0161360  ",
      "Longitude": " -121.94331 "
   },
   {
      "Vendor": "RALEY'S #321",
      "Address": " 3360 SAN PABLO DAM RD",
      "City": "SAN PABLO",
      "Zip Code": " 94806",
      "County": " CONTRA COSTA",
      "Latitude": "37.9619320  ",
      "Longitude": " -122.32510 "
   },
   {
      "Vendor": "SAFEWAY #1192",
      "Address": " 4309 CLAYTON RD",
      "City": "CONCORD",
      "Zip Code": " 94521",
      "County": " CONTRA COSTA",
      "Latitude": "37.9663660  ",
      "Longitude": " -121.99098 "
   },
   {
      "Vendor": "RALEY'S #304",
      "Address": " 2077 MAIN ST",
      "City": "OAKLEY",
      "Zip Code": " 94561",
      "County": " CONTRA COSTA",
      "Latitude": "38.0030670  ",
      "Longitude": " -121.73368 "
   },
   {
      "Vendor": "SAFEWAY #1195",
      "Address": " 5431 CLAYTON RD",
      "City": "CLAYTON",
      "Zip Code": " 94517",
      "County": " CONTRA COSTA",
      "Latitude": "37.9517930  ",
      "Longitude": " -121.95594 "
   },
   {
      "Vendor": "SAFEWAY #1211",
      "Address": " 3496 CAMINO TASSAJARA",
      "City": "DANVILLE",
      "Zip Code": " 94506",
      "County": " CONTRA COSTA",
      "Latitude": "37.7981820  ",
      "Longitude": " -121.91812 "
   },
   {
      "Vendor": "SAFEWAY #1234",
      "Address": " 1125 SECOND ST",
      "City": "BRENTWOOD",
      "Zip Code": " 94513",
      "County": " CONTRA COSTA",
      "Latitude": "37.9361300  ",
      "Longitude": " -121.69871 "
   },
   {
      "Vendor": "NOB HILL FOODS #629",
      "Address": " 130 MARKET PL",
      "City": "SAN RAMON",
      "Zip Code": " 94583",
      "County": " CONTRA COSTA",
      "Latitude": "37.7627230  ",
      "Longitude": " -121.95152 "
   },
   {
      "Vendor": "SAFEWAY #1259",
      "Address": " 3365 DEER VALLEY RD",
      "City": "ANTIOCH",
      "Zip Code": " 94509",
      "County": " CONTRA COSTA",
      "Latitude": "37.9882940  ",
      "Longitude": " -121.78536 "
   },
   {
      "Vendor": "FOODS CO #352",
      "Address": " 1250 MACDONALD AVE",
      "City": "RICHMOND",
      "Zip Code": " 94801",
      "County": " CONTRA COSTA",
      "Latitude": "37.9354540  ",
      "Longitude": " -122.35712 "
   },
   {
      "Vendor": "NOB HILL FOODS #627",
      "Address": " 2270 OAK GROVE RD",
      "City": "WALNUT CREEK",
      "Zip Code": " 94598",
      "County": " CONTRA COSTA",
      "Latitude": "37.9307310  ",
      "Longitude": " -122.01397 "
   },
   {
      "Vendor": "FOOD MAXX #411",
      "Address": " 13220 SAN PABLO AVE",
      "City": "SAN PABLO",
      "Zip Code": " 94806",
      "County": " CONTRA COSTA",
      "Latitude": "37.9531350  ",
      "Longitude": " -122.33244 "
   },
   {
      "Vendor": "SAFEWAY #1541",
      "Address": " 1978 CONTRA COSTA BLVD",
      "City": "PLEASANT HILL",
      "Zip Code": " 94523",
      "County": " CONTRA COSTA",
      "Latitude": "37.9488720  ",
      "Longitude": " -122.05989 "
   },
   {
      "Vendor": "RICHMOND FOOD CENTER",
      "Address": " 2230 CUTTING BLVD",
      "City": "RICHMOND",
      "Zip Code": " 94804",
      "County": " CONTRA COSTA",
      "Latitude": "37.9251370  ",
      "Longitude": " -122.34771 "
   },
   {
      "Vendor": "FOODS CO #764",
      "Address": " 300 ATLANTIC AVE",
      "City": "PITTSBURG",
      "Zip Code": " 94565",
      "County": " CONTRA COSTA",
      "Latitude": "38.0078340  ",
      "Longitude": " -121.88873 "
   },
   {
      "Vendor": "RALEY'S #336",
      "Address": " 2400 SAND CREEK RD",
      "City": "BRENTWOOD",
      "Zip Code": " 94513",
      "County": " CONTRA COSTA",
      "Latitude": "37.9427520  ",
      "Longitude": " -121.73667 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #505",
      "Address": " 3900 MAC DONALD AVE",
      "City": "RICHMOND",
      "Zip Code": " 94805",
      "County": " CONTRA COSTA",
      "Latitude": "37.9330720  ",
      "Longitude": " -122.33205 "
   },
   {
      "Vendor": "SAFEWAY #1917",
      "Address": " 14840 HIGHWAY 4",
      "City": "DISCOVERY BAY",
      "Zip Code": " 94514",
      "County": " CONTRA COSTA",
      "Latitude": "37.8905950  ",
      "Longitude": " -121.62128 "
   },
   {
      "Vendor": "FOOD MAXX #466",
      "Address": " 1370 FITZGERALD DR",
      "City": "PINOLE",
      "Zip Code": " 94564",
      "County": " CONTRA COSTA",
      "Latitude": "37.9876060  ",
      "Longitude": " -122.31148 "
   },
   {
      "Vendor": "WINCO FOODS #52",
      "Address": " 6700 LONE TREE WAY",
      "City": "BRENTWOOD",
      "Zip Code": " 94513",
      "County": " CONTRA COSTA",
      "Latitude": "37.9644900  ",
      "Longitude": " -121.72928 "
   },
   {
      "Vendor": "SAFEWAY #2621",
      "Address": " 3110 BALFOUR RD",
      "City": "BRENTWOOD",
      "Zip Code": " 94513",
      "County": " CONTRA COSTA",
      "Latitude": "37.9250540  ",
      "Longitude": " -121.72130 "
   },
   {
      "Vendor": "FOOD MAXX #418",
      "Address": " 4505 CLAYTON RD",
      "City": "CONCORD",
      "Zip Code": " 94521",
      "County": " CONTRA COSTA",
      "Latitude": "37.9640520  ",
      "Longitude": " -121.98722 "
   },
   {
      "Vendor": "FOOD MAXX #482",
      "Address": " 4500 LONE TREE WAY",
      "City": "ANTIOCH",
      "Zip Code": " 94531",
      "County": " CONTRA COSTA",
      "Latitude": "37.9653320  ",
      "Longitude": " -121.78200 "
   },
   {
      "Vendor": "LUCKY #708",
      "Address": " 660 SAN RAMON VALLEY RD",
      "City": "DANVILLE",
      "Zip Code": " 94526",
      "County": " CONTRA COSTA",
      "Latitude": "37.8130660  ",
      "Longitude": " -121.99445 "
   },
   {
      "Vendor": "LUCKY #709",
      "Address": " 1000 EL CERRITO PLAZA",
      "City": "EL CERRITO",
      "Zip Code": " 94530",
      "County": " CONTRA COSTA",
      "Latitude": "37.9001770  ",
      "Longitude": " -122.29852 "
   },
   {
      "Vendor": "LUCKY #718",
      "Address": " 1590 SYCAMORE AVE",
      "City": "HERCULES",
      "Zip Code": " 94547",
      "County": " CONTRA COSTA",
      "Latitude": "38.0076150  ",
      "Longitude": " -122.27072 "
   },
   {
      "Vendor": "LUCKY #725",
      "Address": " 1145 ARNOLD DR",
      "City": "MARTINEZ",
      "Zip Code": " 94553",
      "County": " CONTRA COSTA",
      "Latitude": "37.9946330  ",
      "Longitude": " -122.10258 "
   },
   {
      "Vendor": "LUCKY #737",
      "Address": " 2545 MAIN ST",
      "City": "OAKLEY",
      "Zip Code": " 94561",
      "County": " CONTRA COSTA",
      "Latitude": "37.9969970  ",
      "Longitude": " -121.73123 "
   },
   {
      "Vendor": "LUCKY #742",
      "Address": " 1530 FITZGERALD DR",
      "City": "PINOLE",
      "Zip Code": " 94564",
      "County": " CONTRA COSTA",
      "Latitude": "37.9904750  ",
      "Longitude": " -122.30249 "
   },
   {
      "Vendor": "LUCKY #770",
      "Address": " 21001 SAN RAMON VALLEY BLVD",
      "City": "SAN RAMON",
      "Zip Code": " 94583",
      "County": " CONTRA COSTA",
      "Latitude": "37.7240960  ",
      "Longitude": " -121.94434 "
   },
   {
      "Vendor": "LAS MONTANAS SUPERMARKET",
      "Address": " 1725 WILLOW PASS RD",
      "City": "CONCORD",
      "Zip Code": " 94520",
      "County": " CONTRA COSTA",
      "Latitude": "37.9740440  ",
      "Longitude": " -122.04090 "
   },
   {
      "Vendor": "DEL VALLE SUPERMERCADO",
      "Address": " 1651 MONUMENT BLVD",
      "City": "CONCORD",
      "Zip Code": " 94520",
      "County": " CONTRA COSTA",
      "Latitude": "37.9545940  ",
      "Longitude": " -122.04262 "
   },
   {
      "Vendor": "SAFEWAY #2712",
      "Address": " 11050 BOLLINGER CANYON RD",
      "City": "SAN RAMON",
      "Zip Code": " 94582",
      "County": " CONTRA COSTA",
      "Latitude": "37.7739400  ",
      "Longitude": " -121.92314 "
   },
   {
      "Vendor": "FOOD MAXX #480",
      "Address": " 4461 BALFOUR RD",
      "City": "BRENTWOOD",
      "Zip Code": " 94513",
      "County": " CONTRA COSTA",
      "Latitude": "37.9266930  ",
      "Longitude": " -121.69711 "
   },
   {
      "Vendor": "WINCO FOODS #63",
      "Address": "N 2400 PARK BLVD",
      "City": "PITTSBURG",
      "Zip Code": " 94565",
      "County": " CONTRA COSTA",
      "Latitude": "38.0112520  ",
      "Longitude": " -121.85782 "
   },
   {
      "Vendor": "LUCKY #705",
      "Address": " 5190 CLAYTON RD",
      "City": "CONCORD",
      "Zip Code": " 94521",
      "County": " CONTRA COSTA",
      "Latitude": "37.9541580  ",
      "Longitude": " -121.96557 "
   },
   {
      "Vendor": "FOOD MAXX #481",
      "Address": " 1751 MONUMENT BLVD",
      "City": "CONCORD",
      "Zip Code": " 94520",
      "County": " CONTRA COSTA",
      "Latitude": "37.9557490  ",
      "Longitude": " -122.04124 "
   },
   {
      "Vendor": "LA SUPERIOR MERCADOS",
      "Address": " 2941 RAILROAD AVE",
      "City": "PITTSBURG",
      "Zip Code": " 94565",
      "County": " CONTRA COSTA",
      "Latitude": "38.0089000  ",
      "Longitude": " -121.89208 "
   },
   {
      "Vendor": "RODEO GROCERY",
      "Address": " 1000 MARIPOSA AVE",
      "City": "RODEO",
      "Zip Code": " 94572",
      "County": " CONTRA COSTA",
      "Latitude": "38.0370000  ",
      "Longitude": " -122.26250 "
   },
   {
      "Vendor": "PRIME YEARS NUTRITION",
      "Address": " 2344 STANWELL CIR",
      "City": "CONCORD",
      "Zip Code": " 94520",
      "County": " CONTRA COSTA",
      "Latitude": "37.9820530  ",
      "Longitude": " -122.04845 "
   },
   {
      "Vendor": "FARMERS MARKET",
      "Address": " 1160 RUMRILL BLVD",
      "City": "SAN PABLO",
      "Zip Code": " 94806",
      "County": " CONTRA COSTA",
      "Latitude": "37.9507190  ",
      "Longitude": " -122.35675 "
   },
   {
      "Vendor": "SMART & FINAL #568",
      "Address": " 13110 SAN PABLO AVE",
      "City": "SAN PABLO",
      "Zip Code": " 94805",
      "County": " CONTRA COSTA",
      "Latitude": "37.9505820  ",
      "Longitude": " -122.33090 "
   },
   {
      "Vendor": "SMART & FINAL #447",
      "Address": " 2100 CONTRA COSTA BLVD",
      "City": "PLEASANT HILL",
      "Zip Code": " 94523",
      "County": " CONTRA COSTA",
      "Latitude": "37.9470950  ",
      "Longitude": " -122.05918 "
   },
   {
      "Vendor": "LOS PRIMOS MARKET & PRODUCE",
      "Address": " 2571 RUMRILL BLVD",
      "City": "SAN PABLO",
      "Zip Code": " 94806",
      "County": " CONTRA COSTA",
      "Latitude": "37.9679930  ",
      "Longitude": " -122.34774 "
   },
   {
      "Vendor": "BARRETT AVENUE MARKET",
      "Address": " 1913 BARRETT AVE",
      "City": "RICHMOND",
      "Zip Code": " 94801",
      "County": " CONTRA COSTA",
      "Latitude": "37.9387430  ",
      "Longitude": " -122.35108 "
   },
   {
      "Vendor": "TARGET STORE T-1507",
      "Address": " 4500 MACDONALD AVE",
      "City": "RICHMOND",
      "Zip Code": " 94805",
      "County": " CONTRA COSTA",
      "Latitude": "37.9326720  ",
      "Longitude": " -122.32740 "
   },
   {
      "Vendor": "TARGET STORE T-0949",
      "Address": " 2610 BISHOP DR",
      "City": "SAN RAMON",
      "Zip Code": " 94583",
      "County": " CONTRA COSTA",
      "Latitude": "37.7628310  ",
      "Longitude": " -121.96354 "
   },
   {
      "Vendor": "TARGET STORE T-1819",
      "Address": " 5769 LONE TREE WAY",
      "City": "ANTIOCH",
      "Zip Code": " 94531",
      "County": " CONTRA COSTA",
      "Latitude": "37.9619140  ",
      "Longitude": " -121.73826 "
   },
   {
      "Vendor": "TARGET STORE T-1208",
      "Address": "N 1871 MAIN ST",
      "City": "WALNUT CREEK",
      "Zip Code": " 94596",
      "County": " CONTRA COSTA",
      "Latitude": "37.9045820  ",
      "Longitude": " -122.06367 "
   },
   {
      "Vendor": "EVERGREEN PRODUCE #2",
      "Address": " 1320 MARKET AVE",
      "City": "SAN PABLO",
      "Zip Code": " 94806",
      "County": " CONTRA COSTA",
      "Latitude": "37.9587730  ",
      "Longitude": " -122.35616 "
   },
   {
      "Vendor": "FOOD BARN",
      "Address": " 1835 RUMRILL BLVD",
      "City": "SAN PABLO",
      "Zip Code": " 94806",
      "County": " CONTRA COSTA",
      "Latitude": "37.9596180  ",
      "Longitude": " -122.35687 "
   },
   {
      "Vendor": "WAL-MART STORE #3455",
      "Address": " 1400 HILLTOP MALL RD",
      "City": "RICHMOND",
      "Zip Code": " 94806",
      "County": " CONTRA COSTA",
      "Latitude": "37.9798430  ",
      "Longitude": " -122.32817 "
   },
   {
      "Vendor": "TARGET STORE T-0737",
      "Address": " 1400 FITZGERALD RD",
      "City": "PINOLE",
      "Zip Code": " 94564",
      "County": " CONTRA COSTA",
      "Latitude": "37.9878020  ",
      "Longitude": " -122.31105 "
   },
   {
      "Vendor": "LAS MONTANAS SUPERMARKET",
      "Address": " 2691 MONUMENT BLVD",
      "City": "CONCORD",
      "Zip Code": " 94520",
      "County": " CONTRA COSTA",
      "Latitude": "37.9631020  ",
      "Longitude": " -122.03317 "
   },
   {
      "Vendor": "SAFEWAY #2940",
      "Address": " 11450 SAN PABLO AVE",
      "City": "EL CERRITO",
      "Zip Code": " 94530",
      "County": " CONTRA COSTA",
      "Latitude": "37.9226230  ",
      "Longitude": " -122.31581 "
   },
   {
      "Vendor": "SAFEWAY #2941",
      "Address": " 707 CONTRA COSTA BLVD",
      "City": "PLEASANT HILL",
      "Zip Code": " 94523",
      "County": " CONTRA COSTA",
      "Latitude": "37.9705760  ",
      "Longitude": " -122.06308 "
   },
   {
      "Vendor": "TARGET STORE T-0330",
      "Address": " 560 CONTRA COSTA BLVD",
      "City": "PLEASANT HILL",
      "Zip Code": " 94523",
      "County": " CONTRA COSTA",
      "Latitude": "37.9770850  ",
      "Longitude": " -122.06582 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #573",
      "Address": " 1955 MONUMENT BLVD",
      "Second Address": " STE 4-F",
      "City": "CONCORD",
      "Zip Code": " 94520",
      "County": " CONTRA COSTA",
      "Latitude": "37.9570030  ",
      "Longitude": " -122.04014 "
   },
   {
      "Vendor": "WAL-MART #2697",
      "Address": " 4893 LONE TREE WAY",
      "City": "ANTIOCH",
      "Zip Code": " 94531",
      "County": " CONTRA COSTA",
      "Latitude": "37.9620240  ",
      "Longitude": " -121.76344 "
   },
   {
      "Vendor": "WAL-MART #5610",
      "Address": " 9100 ALCOSTA BLVD",
      "City": "SAN RAMON",
      "Zip Code": " 94583",
      "County": " CONTRA COSTA",
      "Latitude": "37.7292850  ",
      "Longitude": " -121.92928 "
   },
   {
      "Vendor": "WAL-MART STORE #3493",
      "Address": " 1021 ARNOLD DR",
      "City": "MARTINEZ",
      "Zip Code": " 94553",
      "County": " CONTRA COSTA",
      "Latitude": "37.9969030  ",
      "Longitude": " -122.10940 "
   },
   {
      "Vendor": "LAS MONTANAS",
      "Address": " 13901 SAN PABLO AVE",
      "City": "SAN PABLO",
      "Zip Code": " 94806",
      "County": " CONTRA COSTA",
      "Latitude": "37.9596600  ",
      "Longitude": " -122.34197 "
   },
   {
      "Vendor": "SMART & FINAL #717",
      "Address": " 2638 SOMERSVILLE RD",
      "City": "ANTIOCH",
      "Zip Code": " 94509",
      "County": " CONTRA COSTA",
      "Latitude": "37.9996080  ",
      "Longitude": " -121.84236 "
   },
   {
      "Vendor": "GOLDEN STAR MARKET",
      "Address": "W 44 10TH ST",
      "City": "PITTSBURG",
      "Zip Code": " 94565",
      "County": " CONTRA COSTA",
      "Latitude": "38.0288050  ",
      "Longitude": " -121.88688 "
   },
   {
      "Vendor": "SAFEWAY #3026",
      "Address": " 2800 YGNACIO VALLEY RD",
      "City": "WALNUT CREEK",
      "Zip Code": " 94598",
      "County": " CONTRA COSTA",
      "Latitude": "37.9274160  ",
      "Longitude": " -122.01780 "
   },
   {
      "Vendor": "BNC #48",
      "Address": " 3718 MACDONALD AVE",
      "City": "RICHMOND",
      "Zip Code": " 94805",
      "County": " CONTRA COSTA",
      "Latitude": "37.9334210  ",
      "Longitude": " -122.33378 "
   },
   {
      "Vendor": "CARDENAS #207",
      "Address": " 2100 RAILROAD AVE",
      "City": "PITTSBURG",
      "Zip Code": " 94565",
      "County": " CONTRA COSTA",
      "Latitude": "38.0163310  ",
      "Longitude": " -121.89122 "
   },
   {
      "Vendor": "SMART & FINAL #786",
      "Address": " 460 DIABLO RD",
      "City": "DANVILLE",
      "Zip Code": " 94526",
      "County": " CONTRA COSTA",
      "Latitude": "37.8241480  ",
      "Longitude": " -121.99226 "
   },
   {
      "Vendor": "MI RANCHITO MARKET",
      "Address": " 1634 RUMRILL BLVD",
      "City": "SAN PABLO",
      "Zip Code": " 94806",
      "County": " CONTRA COSTA",
      "Latitude": "37.9565940  ",
      "Longitude": " -122.35638 "
   },
   {
      "Vendor": "LA FIESTA MEXICANA MARKET",
      "Address": " 620 PORT CHICAGO HWY",
      "City": "BAY POINT",
      "Zip Code": " 94565",
      "County": " CONTRA COSTA",
      "Latitude": "38.0343170  ",
      "Longitude": " -121.96048 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #581",
      "Address": " 13751 SAN PABLO AVE",
      "City": "SAN PABLO",
      "Zip Code": " 94806",
      "County": " CONTRA COSTA",
      "Latitude": "37.9580160  ",
      "Longitude": " -122.33997 "
   },
   {
      "Vendor": "EASTERN MARKET",
      "Address": " 7351 BRENTWOOD BLVD",
      "Second Address": "  SUITE F",
      "City": "BRENTWOOD",
      "Zip Code": " 94513",
      "County": " CONTRA COSTA",
      "Latitude": "37.9484280  ",
      "Longitude": " -121.69667 "
   },
   {
      "Vendor": "HEALTHY FAMILIES MARKET",
      "Address": "E 1270 LELAND RD",
      "Second Address": " STE 103",
      "City": "PITTSBURG",
      "Zip Code": " 94565",
      "County": " CONTRA COSTA",
      "Latitude": "38.0079280  ",
      "Longitude": " -121.87008 "
   },
   {
      "Vendor": "SAFEWAY #0954",
      "Address": " 475 M ST",
      "City": "CRESCENT CITY",
      "Zip Code": " 95531",
      "County": " DEL NORTE",
      "Latitude": "41.7559810  ",
      "Longitude": " -124.19339 "
   },
   {
      "Vendor": "WAL-MART STORE #1910",
      "Address": "E 900 WASHINGTON BLVD",
      "City": "CRESCENT CITY",
      "Zip Code": " 95531",
      "County": " DEL NORTE",
      "Latitude": "41.7729130  ",
      "Longitude": " -124.18985 "
   },
   {
      "Vendor": "BABY NUTRITIONAL CARE #104",
      "Address": " 7632 GREENBACK LN",
      "City": "CITRUS HEIGHTS",
      "Zip Code": " 95610",
      "County": " SACRAMENTO",
      "Latitude": "38.6780130  ",
      "Longitude": " -121.28356 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #515",
      "Address": " 5037 FRUITRIDGE RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95820",
      "County": " SACRAMENTO",
      "Latitude": "38.5251460  ",
      "Longitude": " -121.44568 "
   },
   {
      "Vendor": "SAFEWAY #1895",
      "Address": " 5450 DEWEY DR",
      "City": "FAIR OAKS",
      "Zip Code": " 95628",
      "County": " SACRAMENTO",
      "Latitude": "38.6651410  ",
      "Longitude": " -121.30708 "
   },
   {
      "Vendor": "T & Y MARKET",
      "Address": " 2835 NORWOOD AVE",
      "City": "SACRAMENTO",
      "Zip Code": " 95815",
      "County": " SACRAMENTO",
      "Latitude": "38.6192960  ",
      "Longitude": " -121.45714 "
   },
   {
      "Vendor": "LA SUPERIOR MERCADOS",
      "Address": " 4940 STOCKTON BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95820",
      "County": " SACRAMENTO",
      "Latitude": "38.5308880  ",
      "Longitude": " -121.44601 "
   },
   {
      "Vendor": "WINCO FOODS #53",
      "Address": " 200 BLUE RAVINE RD",
      "City": "FOLSOM",
      "Zip Code": " 95630",
      "County": " SACRAMENTO",
      "Latitude": "38.6557160  ",
      "Longitude": " -121.17571 "
   },
   {
      "Vendor": "BEL AIR MARKET #525",
      "Address": " 9435 ELK GROVE BLVD",
      "City": "ELK GROVE",
      "Zip Code": " 95624",
      "County": " SACRAMENTO",
      "Latitude": "38.4098560  ",
      "Longitude": " -121.35186 "
   },
   {
      "Vendor": "FOOD MAXX #420",
      "Address": " 6982 SUNRISE BLVD",
      "City": "CITRUS HEIGHTS",
      "Zip Code": " 95610",
      "County": " SACRAMENTO",
      "Latitude": "38.6929630  ",
      "Longitude": " -121.27156 "
   },
   {
      "Vendor": "FOOD SOURCE #705",
      "Address": " 440 ELKHORN BLVD",
      "City": "RIO LINDA",
      "Zip Code": " 95673",
      "County": " SACRAMENTO",
      "Latitude": "38.6833590  ",
      "Longitude": " -121.45481 "
   },
   {
      "Vendor": "SAFEWAY #2684",
      "Address": " 1814 19TH ST",
      "City": "SACRAMENTO",
      "Zip Code": " 95814",
      "County": " SACRAMENTO",
      "Latitude": "38.5681380  ",
      "Longitude": " -121.48590 "
   },
   {
      "Vendor": "SAFEWAY #2697",
      "Address": " 2851 DEL PASO RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95835",
      "County": " SACRAMENTO",
      "Latitude": "38.6575950  ",
      "Longitude": " -121.52449 "
   },
   {
      "Vendor": "WINCO FOODS #54",
      "Address": " 8701 GREENBACK LN",
      "City": "ORANGEVALE",
      "Zip Code": " 95662",
      "County": " SACRAMENTO",
      "Latitude": "38.6795150  ",
      "Longitude": " -121.23375 "
   },
   {
      "Vendor": "RALEY'S #410",
      "Address": " 25025 BLUE RAVINE RD",
      "City": "FOLSOM",
      "Zip Code": " 95630",
      "County": " SACRAMENTO",
      "Latitude": "38.6892950  ",
      "Longitude": " -121.12265 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5192",
      "Address": " 5821 ANTELOPE RD",
      "City": "ANTELOPE",
      "Zip Code": " 95843",
      "County": " SACRAMENTO",
      "Latitude": "38.7030240  ",
      "Longitude": " -121.33019 "
   },
   {
      "Vendor": "BEL AIR MARKET #528",
      "Address": " 3250 ARENA BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95835",
      "County": " SACRAMENTO",
      "Latitude": "38.6419020  ",
      "Longitude": " -121.53360 "
   },
   {
      "Vendor": "RALEY'S #443",
      "Address": " 4900 ELK GROVE BLVD",
      "City": "ELK GROVE",
      "Zip Code": " 95757",
      "County": " SACRAMENTO",
      "Latitude": "38.4075290  ",
      "Longitude": " -121.44843 "
   },
   {
      "Vendor": "SAVE MART #601",
      "Address": " 4708 MANZANITA AVE",
      "City": "CARMICHAEL",
      "Zip Code": " 95608",
      "County": " SACRAMENTO",
      "Latitude": "38.6497770  ",
      "Longitude": " -121.32603 "
   },
   {
      "Vendor": "SAVE MART #605",
      "Address": " 9160 ELK GROVE FLORIN RD",
      "City": "ELK GROVE",
      "Zip Code": " 95624",
      "County": " SACRAMENTO",
      "Latitude": "38.4248210  ",
      "Longitude": " -121.37272 "
   },
   {
      "Vendor": "FOOD MAXX #488",
      "Address": " 3291 TRUXEL RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95833",
      "County": " SACRAMENTO",
      "Latitude": "38.6270810  ",
      "Longitude": " -121.49844 "
   },
   {
      "Vendor": "SAVE MART #619",
      "Address": " 7960 GERBER RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95828",
      "County": " SACRAMENTO",
      "Latitude": "38.4808300  ",
      "Longitude": " -121.40979 "
   },
   {
      "Vendor": "SAVE MART #622",
      "Address": " 5600 FOLSOM BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95819",
      "County": " SACRAMENTO",
      "Latitude": "38.5579370  ",
      "Longitude": " -121.43863 "
   },
   {
      "Vendor": "SAVE MART #623",
      "Address": " 9137 KIEFER BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95826",
      "County": " SACRAMENTO",
      "Latitude": "38.5472620  ",
      "Longitude": " -121.36061 "
   },
   {
      "Vendor": "SAVE MART #625",
      "Address": " 2501 FAIR OAKS BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95825",
      "County": " SACRAMENTO",
      "Latitude": "38.5743340  ",
      "Longitude": " -121.40391 "
   },
   {
      "Vendor": "BABY NUTRITIONAL CARE #108",
      "Address": "E 8233 STOCKTON BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95828",
      "County": " SACRAMENTO",
      "Latitude": "38.4596720  ",
      "Longitude": " -121.40982 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #3712",
      "Address": " 7010 AUBURN BLVD",
      "City": "CITRUS HEIGHTS",
      "Zip Code": " 95621",
      "County": " SACRAMENTO",
      "Latitude": "38.6899960  ",
      "Longitude": " -121.29496 "
   },
   {
      "Vendor": "FOODS CO #532",
      "Address": "W 7421 STOCKTON BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95823",
      "County": " SACRAMENTO",
      "Latitude": "38.4564030  ",
      "Longitude": " -121.41566 "
   },
   {
      "Vendor": "BABY NUTRITIONAL CARE #110",
      "Address": " 10661 COLOMA RD",
      "City": "RANCHO CORDOVA",
      "Zip Code": " 95670",
      "County": " SACRAMENTO",
      "Latitude": "38.6123540  ",
      "Longitude": " -121.29135 "
   },
   {
      "Vendor": "LA SUPERIOR MERCADOS",
      "Address": " 5731 HILLSDALE BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95842",
      "County": " SACRAMENTO",
      "Latitude": "38.6720470  ",
      "Longitude": " -121.35871 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #4309",
      "Address": " 8961 GREENBACK LN",
      "City": "ORANGEVALE",
      "Zip Code": " 95662",
      "County": " SACRAMENTO",
      "Latitude": "38.6791150  ",
      "Longitude": " -121.22304 "
   },
   {
      "Vendor": "NUGGET MARKET #08",
      "Address": " 7101 ELK GROVE BLVD",
      "City": "ELK GROVE",
      "Zip Code": " 95758",
      "County": " SACRAMENTO",
      "Latitude": "38.4097590  ",
      "Longitude": " -121.42026 "
   },
   {
      "Vendor": "VIVA SUPERMARKET",
      "Address": " 4211 NORWOOD AVE",
      "City": "SACRAMENTO",
      "Zip Code": " 95838",
      "County": " SACRAMENTO",
      "Latitude": "38.6447770  ",
      "Longitude": " -121.45845 "
   },
   {
      "Vendor": "SAFEWAY #1846",
      "Address": " 8925 MADISON AVE",
      "City": "FAIR OAKS",
      "Zip Code": " 95628",
      "County": " SACRAMENTO",
      "Latitude": "38.6647260  ",
      "Longitude": " -121.22302 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #530",
      "Address": " 811 GRAND AVE",
      "Second Address": " STE A2",
      "City": "SACRAMENTO",
      "Zip Code": " 95838",
      "County": " SACRAMENTO",
      "Latitude": "38.6376140  ",
      "Longitude": " -121.44699 "
   },
   {
      "Vendor": "SMART & FINAL #591",
      "Address": " 1734 WATT AVE",
      "City": "SACRAMENTO",
      "Zip Code": " 95825",
      "County": " SACRAMENTO",
      "Latitude": "38.5973850  ",
      "Longitude": " -121.38291 "
   },
   {
      "Vendor": "SMART & FINAL #404",
      "Address": " 4820 MADISON AVE",
      "City": "SACRAMENTO",
      "Zip Code": " 95841",
      "County": " SACRAMENTO",
      "Latitude": "38.6603840  ",
      "Longitude": " -121.35143 "
   },
   {
      "Vendor": "SMART & FINAL #405",
      "Address": " 2431 28TH ST",
      "City": "SACRAMENTO",
      "Zip Code": " 95818",
      "County": " SACRAMENTO",
      "Latitude": "38.5580430  ",
      "Longitude": " -121.47577 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2735",
      "Address": " 6051 FLORIN RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95823",
      "County": " SACRAMENTO",
      "Latitude": "38.4987760  ",
      "Longitude": " -121.43375 "
   },
   {
      "Vendor": "MI RANCHO",
      "Address": " 2355 FLORIN RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95822",
      "County": " SACRAMENTO",
      "Latitude": "38.4968360  ",
      "Longitude": " -121.48343 "
   },
   {
      "Vendor": "TARGET STORE T-2463",
      "Address": " 10881 OLSON DR",
      "City": "RANCHO CORDOVA",
      "Zip Code": " 95670",
      "County": " SACRAMENTO",
      "Latitude": "38.5945970  ",
      "Longitude": " -121.28425 "
   },
   {
      "Vendor": "TARGET STORE T-1527",
      "Address": " 8101 COSUMNES RIVER BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95823",
      "County": " SACRAMENTO",
      "Latitude": "38.4575120  ",
      "Longitude": " -121.41427 "
   },
   {
      "Vendor": "TARGET STORE T-1098",
      "Address": " 430 BLUE RAVINE RD",
      "City": "FOLSOM",
      "Zip Code": " 95630",
      "County": " SACRAMENTO",
      "Latitude": "38.6709940  ",
      "Longitude": " -121.15203 "
   },
   {
      "Vendor": "TARGET STORE T-0312",
      "Address": " 1919 FULTON AVE",
      "City": "SACRAMENTO",
      "Zip Code": " 95825",
      "County": " SACRAMENTO",
      "Latitude": "38.6004040  ",
      "Longitude": " -121.40175 "
   },
   {
      "Vendor": "TARGET STORE T-2115",
      "Address": "N 3601 FREEWAY BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95834",
      "County": " SACRAMENTO",
      "Latitude": "38.6400150  ",
      "Longitude": " -121.49963 "
   },
   {
      "Vendor": "TARGET STORE T-1025",
      "Address": " 7505 LAGUNA BLVD",
      "City": "ELK GROVE",
      "Zip Code": " 95758",
      "County": " SACRAMENTO",
      "Latitude": "38.4237350  ",
      "Longitude": " -121.41604 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1881",
      "Address": " 7901 WATT AVE",
      "City": "ANTELOPE",
      "Zip Code": " 95843",
      "County": " SACRAMENTO",
      "Latitude": "38.7120400  ",
      "Longitude": " -121.39192 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2457",
      "Address": " 10655 FOLSOM BLVD",
      "City": "RANCHO CORDOVA",
      "Zip Code": " 95670",
      "County": " SACRAMENTO",
      "Latitude": "38.5952110  ",
      "Longitude": " -121.29120 "
   },
   {
      "Vendor": "DEJACK'S COUNTRY STORE",
      "Address": " 105 2ND ST",
      "City": "ISLETON",
      "Zip Code": " 95641",
      "County": " SACRAMENTO",
      "Latitude": "38.1620570  ",
      "Longitude": " -121.61230 "
   },
   {
      "Vendor": "TARGET STORE T-1121",
      "Address": " 5837 SUNRISE BLVD",
      "City": "CITRUS HEIGHTS",
      "Zip Code": " 95610",
      "County": " SACRAMENTO",
      "Latitude": "38.6718540  ",
      "Longitude": " -121.27179 "
   },
   {
      "Vendor": "TARGET STORE T-1502",
      "Address": " 10451 FAIRWAY DR",
      "City": "ROSEVILLE",
      "Zip Code": " 95678",
      "County": " PLACER",
      "Latitude": "38.7916620  ",
      "Longitude": " -121.28973 "
   },
   {
      "Vendor": "TARGET STORE T-2492",
      "Address": " 6507 4TH AVE",
      "City": "SACRAMENTO",
      "Zip Code": " 95817",
      "County": " SACRAMENTO",
      "Latitude": "38.5485620  ",
      "Longitude": " -121.42651 "
   },
   {
      "Vendor": "TARGET STORE T-0310",
      "Address": " 2505 RIVERSIDE BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95818",
      "County": " SACRAMENTO",
      "Latitude": "38.5629970  ",
      "Longitude": " -121.49832 "
   },
   {
      "Vendor": "WAL-MART STORE #1760",
      "Address": " 1018 RILEY ST",
      "City": "FOLSOM",
      "Zip Code": " 95630",
      "County": " SACRAMENTO",
      "Latitude": "38.6691790  ",
      "Longitude": " -121.16727 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #562",
      "Address": " 5580 POWER INN RD",
      "Second Address": " STE A",
      "City": "SACRAMENTO",
      "Zip Code": " 95820",
      "County": " SACRAMENTO",
      "Latitude": "38.5252620  ",
      "Longitude": " -121.40941 "
   },
   {
      "Vendor": "VINAI WHOLESALE",
      "Address": " 6968 65TH ST",
      "Second Address": " STE F",
      "City": "SACRAMENTO",
      "Zip Code": " 95823",
      "County": " SACRAMENTO",
      "Latitude": "38.5004000  ",
      "Longitude": " -121.43796 "
   },
   {
      "Vendor": "WAL-MART #5982",
      "Address": " 2700 MARCONI AVE",
      "City": "SACRAMENTO",
      "Zip Code": " 95821",
      "County": " SACRAMENTO",
      "Latitude": "38.6177380  ",
      "Longitude": " -121.39914 "
   },
   {
      "Vendor": "WAL-MART #5981",
      "Address": " 6005 MADISON AVE",
      "City": "CARMICHAEL",
      "Zip Code": " 95608",
      "County": " SACRAMENTO",
      "Latitude": "38.6615090  ",
      "Longitude": " -121.32415 "
   },
   {
      "Vendor": "WAL-MART #5683",
      "Address": " 8455 ELK GROVE BLVD",
      "City": "ELK GROVE",
      "Zip Code": " 95758",
      "County": " SACRAMENTO",
      "Latitude": "38.4093770  ",
      "Longitude": " -121.39206 "
   },
   {
      "Vendor": "WAL-MART #5848",
      "Address": " 10075 BRUCEVILLE RD",
      "City": "ELK GROVE",
      "Zip Code": " 95757",
      "County": " SACRAMENTO",
      "Latitude": "38.3918630  ",
      "Longitude": " -121.41628 "
   },
   {
      "Vendor": "WAL-MART STORE #5231",
      "Address": " 10470 TWIN CITIES RD",
      "City": "GALT",
      "Zip Code": " 95632",
      "County": " SACRAMENTO",
      "Latitude": "38.2899970  ",
      "Longitude": " -121.30485 "
   },
   {
      "Vendor": "LA SUPERIOR FRANKLIN",
      "Address": " 4604 FRANKLIN BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95820",
      "County": " SACRAMENTO",
      "Latitude": "38.5331790  ",
      "Longitude": " -121.47438 "
   },
   {
      "Vendor": "WAL-MART NBRHD MARKET #4759",
      "Address": " 6197 SUNRISE BLVD",
      "City": "CITRUS HEIGHTS",
      "Zip Code": " 95610",
      "County": " SACRAMENTO",
      "Latitude": "38.6767480  ",
      "Longitude": " -121.27298 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #574",
      "Address": " 2143 HURLEY WAY",
      "Second Address": " STE 101",
      "City": "SACRAMENTO",
      "Zip Code": " 95825",
      "County": " SACRAMENTO",
      "Latitude": "38.5893100  ",
      "Longitude": " -121.41629 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #4393",
      "Address": " 4675 WATT AVE",
      "City": "NORTH HIGHLANDS",
      "Zip Code": " 95660",
      "County": " SACRAMENTO",
      "Latitude": "38.6500780  ",
      "Longitude": " -121.38323 "
   },
   {
      "Vendor": "KP INTERNATIONAL MARKET",
      "Address": " 10971 OLSON DR",
      "City": "RANCHO CORDOVA",
      "Zip Code": " 95670",
      "County": " SACRAMENTO",
      "Latitude": "38.5966860  ",
      "Longitude": " -121.28351 "
   },
   {
      "Vendor": "SMART & FINAL #701",
      "Address": " 2344 SUNRISE BLVD",
      "City": "RANCHO CORDOVA",
      "Zip Code": " 95670",
      "County": " SACRAMENTO",
      "Latitude": "38.6163590  ",
      "Longitude": " -121.27026 "
   },
   {
      "Vendor": "SMART & FINAL #722",
      "Address": " 8787 ELK GROVE BLVD",
      "City": "ELK GROVE",
      "Zip Code": " 95624",
      "County": " SACRAMENTO",
      "Latitude": "38.4097480  ",
      "Longitude": " -121.37692 "
   },
   {
      "Vendor": "SMART & FINAL #479",
      "Address": " 7205 FREEPORT BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95831",
      "County": " SACRAMENTO",
      "Latitude": "38.4941740  ",
      "Longitude": " -121.50476 "
   },
   {
      "Vendor": "SMART & FINAL #724",
      "Address": " 3315 NORTHGATE BLVD",
      "Second Address": " STE 4",
      "City": "SACRAMENTO",
      "Zip Code": " 95834",
      "County": " SACRAMENTO",
      "Latitude": "38.6282520  ",
      "Longitude": " -121.47676 "
   },
   {
      "Vendor": "SMART & FINAL #582",
      "Address": " 7223 FAIR OAKS BLVD",
      "City": "CARMICHAEL",
      "Zip Code": " 95608",
      "County": " SACRAMENTO",
      "Latitude": "38.6323420  ",
      "Longitude": " -121.32941 "
   },
   {
      "Vendor": "LA ESPERANZA SUPERMARKET",
      "Address": " 5040 FRANKLIN BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95820",
      "County": " SACRAMENTO",
      "Latitude": "38.5295830  ",
      "Longitude": " -121.47294 "
   },
   {
      "Vendor": "VIVA SUPERMARKET",
      "Address": " 3845 MARYSVILLE BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95838",
      "County": " SACRAMENTO",
      "Latitude": "38.6377710  ",
      "Longitude": " -121.43000 "
   },
   {
      "Vendor": "TARGET STORE T-0311",
      "Address": " 5001 MADISON AVE",
      "City": "SACRAMENTO",
      "Zip Code": " 95841",
      "County": " SACRAMENTO",
      "Latitude": "38.6611720  ",
      "Longitude": " -121.34920 "
   },
   {
      "Vendor": "SMART & FINAL #703",
      "Address": " 7945 MADISON AVE",
      "City": "CITRUS HEIGHTS",
      "Zip Code": " 95610",
      "County": " SACRAMENTO",
      "Latitude": "38.6640220  ",
      "Longitude": " -121.26978 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #578",
      "Address": " 3628 MADISON AVE",
      "City": "NORTH HIGHLANDS",
      "Zip Code": " 95660",
      "County": " SACRAMENTO",
      "Latitude": "38.6610000  ",
      "Longitude": " -121.37919 "
   },
   {
      "Vendor": "MI RANCHO",
      "Address": " 10669 COLOMA RD",
      "City": "RANCHO CORDOVA",
      "Zip Code": " 95670",
      "County": " SACRAMENTO",
      "Latitude": "38.6117390  ",
      "Longitude": " -121.29050 "
   },
   {
      "Vendor": "WINCO FOODS#133",
      "Address": " 2300 WATT AVE",
      "City": "SACRAMENTO",
      "Zip Code": " 95825",
      "County": " SACRAMENTO",
      "Latitude": "38.6071480  ",
      "Longitude": " -121.38069 "
   },
   {
      "Vendor": "WAL-MART NBRHD MARKET #6530",
      "Address": " 4420 FLORIN RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95823",
      "County": " SACRAMENTO",
      "Latitude": "38.4946360  ",
      "Longitude": " -121.45452 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #3081",
      "Address": " 8915 GERBER RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95829",
      "County": " SACRAMENTO",
      "Latitude": "38.4824290  ",
      "Longitude": " -121.37033 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1747",
      "Address": "N 1800 PERRIS BLVD",
      "City": "PERRIS",
      "Zip Code": " 92571",
      "County": " RIVERSIDE",
      "Latitude": "33.8048090  ",
      "Longitude": " -117.22641 "
   },
   {
      "Vendor": "VIVA SUPERMARKET #4",
      "Address": " 10385 FOLSOM BLVD",
      "City": "RANCHO CORDOVA",
      "Zip Code": " 95670",
      "County": " SACRAMENTO",
      "Latitude": "38.5897780  ",
      "Longitude": " -121.30415 "
   },
   {
      "Vendor": "FOOD MAXX #497",
      "Address": " 7477 WATT AVE",
      "City": "NORTH HIGHLANDS",
      "Zip Code": " 95660",
      "County": " SACRAMENTO",
      "Latitude": "38.7028960  ",
      "Longitude": " -121.38406 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #579",
      "Address": " 3821 41ST AVE",
      "City": "SACRAMENTO",
      "Zip Code": " 95824",
      "County": " SACRAMENTO",
      "Latitude": "38.5160530  ",
      "Longitude": " -121.46417 "
   },
   {
      "Vendor": "RALEY'S #435",
      "Address": " 2075 FAIR OAKS BLVD",
      "Second Address": " STE 130",
      "City": "SACRAMENTO",
      "Zip Code": " 95825",
      "County": " SACRAMENTO",
      "Latitude": "38.5738480  ",
      "Longitude": " -121.41653 "
   },
   {
      "Vendor": "RALEY'S #440",
      "Address": " 4030 SUNRISE BLVD",
      "City": "RANCHO CORDOVA",
      "Zip Code": " 95742",
      "County": " SACRAMENTO",
      "Latitude": "38.5576440  ",
      "Longitude": " -121.24459 "
   },
   {
      "Vendor": "LA VICTORIA SUPERMERCADO",
      "Address": " 2537 DEL PASO BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95815",
      "County": " SACRAMENTO",
      "Latitude": "38.6133370  ",
      "Longitude": " -121.44643 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2464",
      "Address": " 8270 DELTA SHORES CIR",
      "City": "SACRAMENTO",
      "Zip Code": " 95832",
      "County": " SACRAMENTO",
      "Latitude": "38.4595300  ",
      "Longitude": " -121.49291 "
   },
   {
      "Vendor": "BABY NUTRITIONAL CARE #111",
      "Address": " 3312 MARTIN L. KING JR. BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95817",
      "County": " SACRAMENTO",
      "Latitude": "38.5444550  ",
      "Longitude": " -121.46506 "
   },
   {
      "Vendor": "MUIR WAY MARKET",
      "Address": " 2736 MUIR WAY",
      "City": "SACRAMENTO",
      "Zip Code": " 95818",
      "County": " SACRAMENTO",
      "Latitude": "38.5594530  ",
      "Longitude": " -121.50498 "
   },
   {
      "Vendor": "SUPER X MARKET",
      "Address": " 2711 FAIRFIELD ST",
      "City": "SACRAMENTO",
      "Zip Code": " 95815",
      "County": " SACRAMENTO",
      "Latitude": "38.6170210  ",
      "Longitude": " -121.45293 "
   },
   {
      "Vendor": "FOOD 4 LESS",
      "Address": " 4551 MACK RD",
      "City": "SACRAMENTO",
      "Zip Code": " 95823",
      "County": " SACRAMENTO",
      "Latitude": "38.4753230  ",
      "Longitude": " -121.44874 "
   },
   {
      "Vendor": "GO HEALTHY GROCERY STORE",
      "Address": " 4208 MARTIN LUTHER KINGJR BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95820",
      "County": " SACRAMENTO",
      "Latitude": "38.5366860  ",
      "Longitude": " -121.46506 "
   },
   {
      "Vendor": "SMART & FINAL #806",
      "Address": " 5128 STOCKTON BLVD",
      "City": "SACRAMENTO",
      "Zip Code": " 95820",
      "County": " SACRAMENTO",
      "Latitude": "38.5285420  ",
      "Longitude": " -121.44445 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #583",
      "Address": " 7171 BOWLING DR",
      "Second Address": " STE 900",
      "City": "SACRAMENTO",
      "Zip Code": " 95823",
      "County": " SACRAMENTO",
      "Latitude": "38.4974930  ",
      "Longitude": " -121.45530 "
   },
   {
      "Vendor": "BIG VALUE MARKET",
      "Address": "E 2053 MARIPOSA RD",
      "City": "STOCKTON",
      "Zip Code": " 95205",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9388690  ",
      "Longitude": " -121.24486 "
   },
   {
      "Vendor": "YOUNG'S LOCKEFORD PAYLESS M",
      "Address": "N 18980 HIGHWAY 88",
      "City": "LOCKEFORD",
      "Zip Code": " 95237",
      "County": " SAN JOAQUIN",
      "Latitude": "38.1559480  ",
      "Longitude": " -121.15374 "
   },
   {
      "Vendor": "SAVE MART #012",
      "Address": "W 1431 YOSEMITE AVE",
      "City": "MANTECA",
      "Zip Code": " 95336",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7980280  ",
      "Longitude": " -121.23814 "
   },
   {
      "Vendor": "SAVE MART #039",
      "Address": " 4725 QUAIL LAKES DR",
      "City": "STOCKTON",
      "Zip Code": " 95207",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9864280  ",
      "Longitude": " -121.34226 "
   },
   {
      "Vendor": "RALEY'S #445",
      "Address": "S 311 LOWER SACRAMENTO RD",
      "City": "LODI",
      "Zip Code": " 95240",
      "County": " SAN JOAQUIN",
      "Latitude": "38.1289190  ",
      "Longitude": " -121.30694 "
   },
   {
      "Vendor": "S-MART FOODS #209",
      "Address": "W 610 KETTLEMAN LN",
      "City": "LODI",
      "Zip Code": " 95240",
      "County": " SAN JOAQUIN",
      "Latitude": "38.1143260  ",
      "Longitude": " -121.28132 "
   },
   {
      "Vendor": "RALEY'S #311",
      "Address": " 1280 LATHROP RD",
      "City": "MANTECA",
      "Zip Code": " 95336",
      "County": " SAN JOAQUIN",
      "Latitude": "37.8260170  ",
      "Longitude": " -121.23784 "
   },
   {
      "Vendor": "SAFEWAY #3124",
      "Address": "S 1187 MAIN ST",
      "City": "MANTECA",
      "Zip Code": " 95337",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7867430  ",
      "Longitude": " -121.21841 "
   },
   {
      "Vendor": "ALDEE MARKET",
      "Address": "N 216 CHEROKEE LN",
      "City": "LODI",
      "Zip Code": " 95240",
      "County": " SAN JOAQUIN",
      "Latitude": "38.1369130  ",
      "Longitude": " -121.26037 "
   },
   {
      "Vendor": "FOOD 4 LESS #01",
      "Address": "E 255 MARCH LN",
      "City": "STOCKTON",
      "Zip Code": " 95207",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9988160  ",
      "Longitude": " -121.30319 "
   },
   {
      "Vendor": "FOOD 4 LESS #02",
      "Address": "N 678 WILSON WAY",
      "City": "STOCKTON",
      "Zip Code": " 95205",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9623520  ",
      "Longitude": " -121.27281 "
   },
   {
      "Vendor": "FOOD 4 LESS #03",
      "Address": "W 2430 KETTLEMAN LN",
      "City": "LODI",
      "Zip Code": " 95242",
      "County": " SAN JOAQUIN",
      "Latitude": "38.1140750  ",
      "Longitude": " -121.30571 "
   },
   {
      "Vendor": "SUPER SAVE MARKET",
      "Address": "W 39 DRMARTINLUTHERKINGJR BLVD",
      "City": "STOCKTON",
      "Zip Code": " 95206",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9388120  ",
      "Longitude": " -121.28827 "
   },
   {
      "Vendor": "SAVE MART #386",
      "Address": "N 1172 MAIN ST",
      "City": "MANTECA",
      "Zip Code": " 95336",
      "County": " SAN JOAQUIN",
      "Latitude": "37.8132480  ",
      "Longitude": " -121.21546 "
   },
   {
      "Vendor": "SAVE MART #334",
      "Address": " 3215 PACIFIC AVE",
      "City": "STOCKTON",
      "Zip Code": " 95204",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9777020  ",
      "Longitude": " -121.30540 "
   },
   {
      "Vendor": "SAVE MART #091",
      "Address": " 7506 PACIFIC AVE",
      "City": "STOCKTON",
      "Zip Code": " 95207",
      "County": " SAN JOAQUIN",
      "Latitude": "38.0174600  ",
      "Longitude": " -121.32262 "
   },
   {
      "Vendor": "FOOD 4 LESS #04",
      "Address": " 3434 MANTHEY RD",
      "City": "STOCKTON",
      "Zip Code": " 95206",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9118000  ",
      "Longitude": " -121.29275 "
   },
   {
      "Vendor": "FOOD SOURCE #712",
      "Address": "W 2323 HAMMER LN",
      "City": "STOCKTON",
      "Zip Code": " 95209",
      "County": " SAN JOAQUIN",
      "Latitude": "38.0222480  ",
      "Longitude": " -121.34393 "
   },
   {
      "Vendor": "FOOD 4 LESS #05",
      "Address": "W 789 HAMMER LN",
      "City": "STOCKTON",
      "Zip Code": " 95210",
      "County": " SAN JOAQUIN",
      "Latitude": "38.0224810  ",
      "Longitude": " -121.32160 "
   },
   {
      "Vendor": "SAFEWAY #1648",
      "Address": "W 2449 KETTLEMAN LN",
      "City": "LODI",
      "Zip Code": " 95242",
      "County": " SAN JOAQUIN",
      "Latitude": "38.1157820  ",
      "Longitude": " -121.30451 "
   },
   {
      "Vendor": "FOOD 4 LESS #06",
      "Address": " 131 SPRECKELS AVE",
      "City": "MANTECA",
      "Zip Code": " 95336",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7961650  ",
      "Longitude": " -121.19945 "
   },
   {
      "Vendor": "CARNICERIA MONARCA #2",
      "Address": "S 1200 GREENWOOD AVE",
      "City": "MONTEBELLO",
      "Zip Code": " 90640",
      "County": " LOS ANGELES",
      "Latitude": "33.9902770  ",
      "Longitude": " -118.12160 "
   },
   {
      "Vendor": "LITTLE FARMERS MARKET",
      "Address": "S 619 ATLANTIC BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90022",
      "County": " LOS ANGELES",
      "Latitude": "34.0243450  ",
      "Longitude": " -118.15644 "
   },
   {
      "Vendor": "SMART & FINAL #727",
      "Address": "E 280 COMPTON BLVD",
      "City": "COMPTON",
      "Zip Code": " 90220",
      "County": " LOS ANGELES",
      "Latitude": "33.8959100  ",
      "Longitude": " -118.22102 "
   },
   {
      "Vendor": "LA SUPREMA MEAT MARKET",
      "Address": "E 16006-08 MAIN ST",
      "City": "LA PUENTE",
      "Zip Code": " 91744",
      "County": " LOS ANGELES",
      "Latitude": "34.0201210  ",
      "Longitude": " -117.94862 "
   },
   {
      "Vendor": "LA VENADITA MEAT MARKET",
      "Address": "N 601 WILMINGTON BLVD",
      "Second Address": "  11",
      "City": "WILMINGTON",
      "Zip Code": " 90744",
      "County": " LOS ANGELES",
      "Latitude": "33.7766270  ",
      "Longitude": " -118.27422 "
   },
   {
      "Vendor": "CARNICERIA NUEVA BALLARTAS",
      "Address": " 15713 DOWNEY AVE",
      "City": "PARAMOUNT",
      "Zip Code": " 90723",
      "County": " LOS ANGELES",
      "Latitude": "33.8907150  ",
      "Longitude": " -118.15145 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #145",
      "Address": " 10683 VALLEY BLVD",
      "City": "EL MONTE",
      "Zip Code": " 91731",
      "County": " LOS ANGELES",
      "Latitude": "34.0766080  ",
      "Longitude": " -118.03950 "
   },
   {
      "Vendor": "FARMERS BIG 7 MARKET",
      "Address": " 25513 NORMANDIE AVE",
      "City": "HARBOR CITY",
      "Zip Code": " 90710",
      "County": " LOS ANGELES",
      "Latitude": "33.7925550  ",
      "Longitude": " -118.29779 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#411",
      "Address": " 3726 TWEEDY BLVD",
      "City": "SOUTH GATE",
      "Zip Code": " 90280",
      "County": " LOS ANGELES",
      "Latitude": "33.9439420  ",
      "Longitude": " -118.20505 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #48",
      "Address": " 7900 IMPERIAL HWY",
      "City": "DOWNEY",
      "Zip Code": " 90242",
      "County": " LOS ANGELES",
      "Latitude": "33.9249130  ",
      "Longitude": " -118.15410 "
   },
   {
      "Vendor": "RANCHO SINALOA MARKET",
      "Address": " 3969 BEVERLY BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90004",
      "County": " LOS ANGELES",
      "Latitude": "34.0764890  ",
      "Longitude": " -118.29543 "
   },
   {
      "Vendor": "CORONA RANCH MARKET",
      "Address": "S 5903 MAIN ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90003",
      "County": " LOS ANGELES",
      "Latitude": "33.9867100  ",
      "Longitude": " -118.27424 "
   },
   {
      "Vendor": "HAPPY FAMILY NUTRITIONAL CT",
      "Address": "W 3045 8TH ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90005",
      "County": " LOS ANGELES",
      "Latitude": "34.0579400  ",
      "Longitude": " -118.29314 "
   },
   {
      "Vendor": "EL SUPER #54",
      "Address": " 9320 SLAUSON AVE",
      "City": "PICO RIVERA",
      "Zip Code": " 90660",
      "County": " LOS ANGELES",
      "Latitude": "33.9683540  ",
      "Longitude": " -118.09882 "
   },
   {
      "Vendor": "AZTECA MARKET",
      "Address": " 9020 LONG BEACH BLVD",
      "City": "SOUTH GATE",
      "Zip Code": " 90280",
      "County": " LOS ANGELES",
      "Latitude": "33.9538490  ",
      "Longitude": " -118.21868 "
   },
   {
      "Vendor": "DON PANCHITO MARKET, INC.",
      "Address": " 6015 AVALON BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90003",
      "County": " LOS ANGELES",
      "Latitude": "33.9846630  ",
      "Longitude": " -118.26540 "
   },
   {
      "Vendor": "VONS #3325",
      "Address": " 26518 BOUQUET CANYON RD",
      "City": "SAUGUS",
      "Zip Code": " 91350",
      "County": " LOS ANGELES",
      "Latitude": "34.4280930  ",
      "Longitude": " -118.53634 "
   },
   {
      "Vendor": "TOMATO MARKET",
      "Address": "S 10400 PRAIRIE AVE",
      "City": "INGLEWOOD",
      "Zip Code": " 90303",
      "County": " LOS ANGELES",
      "Latitude": "33.9418150  ",
      "Longitude": " -118.34392 "
   },
   {
      "Vendor": "EL SUPER #58",
      "Address": "E 310 FLORENCE AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90003",
      "County": " LOS ANGELES",
      "Latitude": "33.9745160  ",
      "Longitude": " -118.26882 "
   },
   {
      "Vendor": "TRESIERRAS MARKET #1",
      "Address": " 13158 VAN NUYS BLVD",
      "City": "PACOIMA",
      "Zip Code": " 91331",
      "County": " LOS ANGELES",
      "Latitude": "34.2677120  ",
      "Longitude": " -118.41926 "
   },
   {
      "Vendor": "UPTOWN MARKET",
      "Address": " 7601 GREENLEAF AVE",
      "City": "WHITTIER",
      "Zip Code": " 90602",
      "County": " LOS ANGELES",
      "Latitude": "33.9734700  ",
      "Longitude": " -118.03773 "
   },
   {
      "Vendor": "HOA BINH ROSEMEAD SUPERMARKET",
      "Address": " 8235 GARVEY AVE",
      "City": "ROSEMEAD",
      "Zip Code": " 91770",
      "County": " LOS ANGELES",
      "Latitude": "34.0631850  ",
      "Longitude": " -118.08884 "
   },
   {
      "Vendor": "AGNES MINI MARKET",
      "Address": " 6755 AGNES DR",
      "City": "NORTH HOLLYWOOD",
      "Zip Code": " 91606",
      "County": " LOS ANGELES",
      "Latitude": "34.1932720  ",
      "Longitude": " -118.39558 "
   },
   {
      "Vendor": "NUMERO UNO MARKET #113",
      "Address": "E 129 LOMITA BLVD",
      "City": "CARSON",
      "Zip Code": " 90745",
      "County": " LOS ANGELES",
      "Latitude": "33.7995680  ",
      "Longitude": " -118.27367 "
   },
   {
      "Vendor": "SMART & FINAL #938",
      "Address": "S 1516 PACIFIC COAST HWY",
      "City": "REDONDO BEACH",
      "Zip Code": " 90277",
      "County": " LOS ANGELES",
      "Latitude": "33.8209290  ",
      "Longitude": " -118.38434 "
   },
   {
      "Vendor": "SMART & FINAL #921",
      "Address": "N 615 PACIFIC COAST HWY",
      "City": "REDONDO BEACH",
      "Zip Code": " 90277",
      "County": " LOS ANGELES",
      "Latitude": "33.8523240  ",
      "Longitude": " -118.38952 "
   },
   {
      "Vendor": "LA BODEGA MARKET #4",
      "Address": "E 1420 ANAHEIM ST",
      "City": "LONG BEACH",
      "Zip Code": " 90813",
      "County": " LOS ANGELES",
      "Latitude": "33.7823600  ",
      "Longitude": " -118.17383 "
   },
   {
      "Vendor": "NUMERO UNO MARKET #112",
      "Address": " 9990 LONG BEACH BLVD",
      "City": "LYNWOOD",
      "Zip Code": " 90262",
      "County": " LOS ANGELES",
      "Latitude": "33.9443980  ",
      "Longitude": " -118.21583 "
   },
   {
      "Vendor": "KEA NUTRITION",
      "Address": "E 2201 ANAHEIM ST",
      "Second Address": " STE 101",
      "City": "LONG BEACH",
      "Zip Code": " 90804",
      "County": " LOS ANGELES",
      "Latitude": "33.7828840  ",
      "Longitude": " -118.16529 "
   },
   {
      "Vendor": "JON'S FRESH MARKETPLACE #4",
      "Address": "W 4848 190TH ST",
      "City": "TORRANCE",
      "Zip Code": " 90503",
      "County": " LOS ANGELES",
      "Latitude": "33.8576210  ",
      "Longitude": " -118.36335 "
   },
   {
      "Vendor": "SMART & FINAL #920",
      "Address": "W 5038 AVENUE  N",
      "City": "PALMDALE",
      "Zip Code": " 93551",
      "County": " LOS ANGELES",
      "Latitude": "34.6297520  ",
      "Longitude": " -118.22035 "
   },
   {
      "Vendor": "SMART & FINAL #942",
      "Address": "S 240 DIAMOND BAR BLVD",
      "City": "DIAMOND BAR",
      "Zip Code": " 91765",
      "County": " LOS ANGELES",
      "Latitude": "34.0218270  ",
      "Longitude": " -117.80950 "
   },
   {
      "Vendor": "ANGELINO'S NUTRITION",
      "Address": "S 4919 HOOPER AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90011",
      "County": " LOS ANGELES",
      "Latitude": "33.9983390  ",
      "Longitude": " -118.25232 "
   },
   {
      "Vendor": "LA BLANQUITA MEAT MARKET",
      "Address": " 13810 LOS ANGELES ST",
      "City": "BALDWIN PARK",
      "Zip Code": " 91706",
      "County": " LOS ANGELES",
      "Latitude": "34.0919510  ",
      "Longitude": " -117.97316 "
   },
   {
      "Vendor": "SMART & FINAL #922",
      "Address": " 21035 HAWTHORNE BLVD",
      "City": "TORRANCE",
      "Zip Code": " 90503",
      "County": " LOS ANGELES",
      "Latitude": "33.8389480  ",
      "Longitude": " -118.35533 "
   },
   {
      "Vendor": "SMART & FINAL #923",
      "Address": "W 1636 25TH ST",
      "City": "SAN PEDRO",
      "Zip Code": " 90732",
      "County": " LOS ANGELES",
      "Latitude": "33.7239560  ",
      "Longitude": " -118.31339 "
   },
   {
      "Vendor": "D.D.S. PLUS",
      "Address": " 24259 MAIN ST",
      "City": "NEWHALL",
      "Zip Code": " 91321",
      "County": " LOS ANGELES",
      "Latitude": "34.3782100  ",
      "Longitude": " -118.52744 "
   },
   {
      "Vendor": "BABY NUTRITION #2",
      "Address": "W 1967 SLAUSON AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90047",
      "County": " LOS ANGELES",
      "Latitude": "33.9894050  ",
      "Longitude": " -118.31329 "
   },
   {
      "Vendor": "SMART & FINAL #746",
      "Address": " 1193 HUNTINGTON DR",
      "City": "DUARTE",
      "Zip Code": " 91010",
      "County": " LOS ANGELES",
      "Latitude": "34.1407600  ",
      "Longitude": " -117.97872 "
   },
   {
      "Vendor": "SMART & FINAL #941",
      "Address": "W 3830 VERDUGO AVE",
      "City": "BURBANK",
      "Zip Code": " 91505",
      "County": " LOS ANGELES",
      "Latitude": "34.1597810  ",
      "Longitude": " -118.34476 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#614",
      "Address": "N 943 LA BREA AVE",
      "City": "INGLEWOOD",
      "Zip Code": " 90302",
      "County": " LOS ANGELES",
      "Latitude": "33.9757450  ",
      "Longitude": " -118.35762 "
   },
   {
      "Vendor": "SMART & FINAL #735",
      "Address": "S 1833 LA CIENEGA BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90035",
      "County": " LOS ANGELES",
      "Latitude": "34.0436830  ",
      "Longitude": " -118.37689 "
   },
   {
      "Vendor": "LA BODEGA RANCH MARKET",
      "Address": "W 2434 ORANGETHORPE AVE",
      "City": "FULLERTON",
      "Zip Code": " 92833",
      "County": " LOS ANGELES",
      "Latitude": "33.8587250  ",
      "Longitude": " -117.97105 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #4132",
      "Address": " 9001 APOLLO WAY",
      "City": "DOWNEY",
      "Zip Code": " 90242",
      "County": " LOS ANGELES",
      "Latitude": "33.9243570  ",
      "Longitude": " -118.12911 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5686",
      "Address": "N 1301 VICTORY PL",
      "City": "BURBANK",
      "Zip Code": " 91502",
      "County": " LOS ANGELES",
      "Latitude": "34.1891600  ",
      "Longitude": " -118.32549 "
   },
   {
      "Vendor": "WAL-MART NBRHD MARKET #4762",
      "Address": "S 1180 DIAMOND BAR BLVD",
      "City": "DIAMOND BAR",
      "Zip Code": " 91765",
      "County": " LOS ANGELES",
      "Latitude": "34.0012630  ",
      "Longitude": " -117.81061 "
   },
   {
      "Vendor": "LA BODEGA RANCH MARKET",
      "Address": " 17438 BEACH BLVD",
      "City": "HUNTINGTON BEACH",
      "Zip Code": " 92647",
      "County": " ORANGE",
      "Latitude": "33.7092480  ",
      "Longitude": " -117.98903 "
   },
   {
      "Vendor": "MERCADO HIDALGO",
      "Address": " 4101 CITY TERRACE DR",
      "City": "LOS ANGELES",
      "Zip Code": " 90063",
      "County": " LOS ANGELES",
      "Latitude": "34.0559710  ",
      "Longitude": " -118.17759 "
   },
   {
      "Vendor": "LA HACIENDA MEAT MARKET",
      "Address": " 13305 PRAIRIE AVE",
      "City": "HAWTHORNE",
      "Zip Code": " 90250",
      "County": " LOS ANGELES",
      "Latitude": "33.9118180  ",
      "Longitude": " -118.34415 "
   },
   {
      "Vendor": "SAFEWAY #1769",
      "Address": " 2808 COUNTRY CLUB BLVD",
      "City": "STOCKTON",
      "Zip Code": " 95204",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9624070  ",
      "Longitude": " -121.33784 "
   },
   {
      "Vendor": "WINCO FOODS #10",
      "Address": " 5110 MONTAUBAN AVE",
      "City": "STOCKTON",
      "Zip Code": " 95210",
      "County": " SAN JOAQUIN",
      "Latitude": "38.0050690  ",
      "Longitude": " -121.28395 "
   },
   {
      "Vendor": "SAFEWAY #2600",
      "Address": "W 1801 11TH ST",
      "City": "TRACY",
      "Zip Code": " 95376",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7400750  ",
      "Longitude": " -121.44953 "
   },
   {
      "Vendor": "SAFEWAY #2707",
      "Address": " 6445 PACIFIC AVE",
      "City": "STOCKTON",
      "Zip Code": " 95207",
      "County": " SAN JOAQUIN",
      "Latitude": "38.0087440  ",
      "Longitude": " -121.32125 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1554",
      "Address": "E 3223 HAMMER LN",
      "City": "STOCKTON",
      "Zip Code": " 95212",
      "County": " SAN JOAQUIN",
      "Latitude": "38.0214090  ",
      "Longitude": " -121.27487 "
   },
   {
      "Vendor": "SAVE MART #094",
      "Address": "S 15240 HARLAN RD",
      "City": "LATHROP",
      "Zip Code": " 95330",
      "County": " SAN JOAQUIN",
      "Latitude": "37.8234430  ",
      "Longitude": " -121.28827 "
   },
   {
      "Vendor": "RANCHO SAN MIGUEL #021",
      "Address": "S 1409 AIRPORT WAY",
      "City": "STOCKTON",
      "Zip Code": " 95206",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9408170  ",
      "Longitude": " -121.27186 "
   },
   {
      "Vendor": "RANCHO SAN MIGUEL #022",
      "Address": "S 620 CHEROKEE LN",
      "City": "LODI",
      "Zip Code": " 95240",
      "County": " SAN JOAQUIN",
      "Latitude": "38.1274380  ",
      "Longitude": " -121.25956 "
   },
   {
      "Vendor": "NEW VERNON RANCHO MARKET",
      "Address": "E 1713 VERNON AVE",
      "Second Address": " STE 107",
      "City": "LOS ANGELES",
      "Zip Code": " 90058",
      "County": " LOS ANGELES",
      "Latitude": "34.0043170  ",
      "Longitude": " -118.24271 "
   },
   {
      "Vendor": "EL CHILITOS MARKET",
      "Address": "E 309 MARKET ST",
      "City": "LONG BEACH",
      "Zip Code": " 90805",
      "County": " LOS ANGELES",
      "Latitude": "33.8543210  ",
      "Longitude": " -118.18961 "
   },
   {
      "Vendor": "HOOPER MARKET",
      "Address": " 2339 HOOPER AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90011",
      "County": " LOS ANGELES",
      "Latitude": "34.0177750  ",
      "Longitude": " -118.24934 "
   },
   {
      "Vendor": "LA AURORA MARKET",
      "Address": " 2904 TWEEDY BLVD",
      "City": "SOUTH GATE",
      "Zip Code": " 90280",
      "County": " LOS ANGELES",
      "Latitude": "33.9458180  ",
      "Longitude": " -118.22030 "
   },
   {
      "Vendor": "CITY NUTRITION",
      "Address": "E 2031 10TH ST",
      "City": "LONG BEACH",
      "Zip Code": " 90804",
      "County": " LOS ANGELES",
      "Latitude": "33.7791380  ",
      "Longitude": " -118.16691 "
   },
   {
      "Vendor": "51ST MARKET",
      "Address": "S 5026 AVALON BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90011",
      "County": " LOS ANGELES",
      "Latitude": "33.9968540  ",
      "Longitude": " -118.26467 "
   },
   {
      "Vendor": "MERCADO EL OAXAQUENO",
      "Address": "S 263 ALEXANDRIA AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90004",
      "County": " LOS ANGELES",
      "Latitude": "34.0692320  ",
      "Longitude": " -118.29818 "
   },
   {
      "Vendor": "CARDENAS MARKET #6",
      "Address": "S 2001 GAREY AVE",
      "City": "POMONA",
      "Zip Code": " 91766",
      "County": " LOS ANGELES",
      "Latitude": "34.0351000  ",
      "Longitude": " -117.75069 "
   },
   {
      "Vendor": "CARDENAS MARKET #16",
      "Address": "E 690 HOLT AVE",
      "City": "POMONA",
      "Zip Code": " 91767",
      "County": " LOS ANGELES",
      "Latitude": "34.0620040  ",
      "Longitude": " -117.73772 "
   },
   {
      "Vendor": "CARDENAS MARKET #20",
      "Address": "W 1645 HOLT AVE",
      "City": "POMONA",
      "Zip Code": " 91768",
      "County": " LOS ANGELES",
      "Latitude": "34.0624910  ",
      "Longitude": " -117.77828 "
   },
   {
      "Vendor": "LA VISTA MARKET",
      "Address": "E 1168 4TH ST",
      "City": "LONG BEACH",
      "Zip Code": " 90802",
      "County": " LOS ANGELES",
      "Latitude": "33.7715390  ",
      "Longitude": " -118.17657 "
   },
   {
      "Vendor": "ALBERTSONS #699",
      "Address": "S 28090 WESTERN AVE",
      "City": "SAN PEDRO",
      "Zip Code": " 90732",
      "County": " LOS ANGELES",
      "Latitude": "33.7650530  ",
      "Longitude": " -118.31015 "
   },
   {
      "Vendor": "LA MEXICANA MARKET",
      "Address": "W 1261 EL SEGUNDO BLVD",
      "City": "GARDENA",
      "Zip Code": " 90247",
      "County": " LOS ANGELES",
      "Latitude": "33.9166280  ",
      "Longitude": " -118.29790 "
   },
   {
      "Vendor": "MERCADO EL REY #5",
      "Address": " 15256 PARTHENIA ST",
      "City": "NORTH HILLS",
      "Zip Code": " 91343",
      "County": " LOS ANGELES",
      "Latitude": "34.2280670  ",
      "Longitude": " -118.46517 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5807",
      "Address": "N 2100 LONG BEACH BLVD",
      "City": "COMPTON",
      "Zip Code": " 90221",
      "County": " LOS ANGELES",
      "Latitude": "33.9100130  ",
      "Longitude": " -118.20769 "
   },
   {
      "Vendor": "DOWNEY SUPERMARKET",
      "Address": " 13240 WOODRUFF AVE",
      "City": "DOWNEY",
      "Zip Code": " 90242",
      "County": " LOS ANGELES",
      "Latitude": "33.9104400  ",
      "Longitude": " -118.11617 "
   },
   {
      "Vendor": "ONE STOP CORNER MARKET",
      "Address": " 10756 GARVEY AVE",
      "City": "EL MONTE",
      "Zip Code": " 91733",
      "County": " LOS ANGELES",
      "Latitude": "34.0625390  ",
      "Longitude": " -118.03965 "
   },
   {
      "Vendor": "MI OAXACA MARKET",
      "Address": " 3824 BEVERLY BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90004",
      "County": " LOS ANGELES",
      "Latitude": "34.0763160  ",
      "Longitude": " -118.29244 "
   },
   {
      "Vendor": "AMIGO MARKET",
      "Address": "W 2400 WARDLOW RD",
      "City": "LONG BEACH",
      "Zip Code": " 90810",
      "County": " LOS ANGELES",
      "Latitude": "33.8240270  ",
      "Longitude": " -118.22355 "
   },
   {
      "Vendor": "VIVA MEAT MARKET",
      "Address": "E 281 NEWBURGH ST",
      "City": "AZUSA",
      "Zip Code": " 91702",
      "County": " LOS ANGELES",
      "Latitude": "34.1101760  ",
      "Longitude": " -117.90560 "
   },
   {
      "Vendor": "CAMILA'S NUTRITION, INC.",
      "Address": "S 8628 CENTRAL AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90002",
      "County": " LOS ANGELES",
      "Latitude": "33.9599080  ",
      "Longitude": " -118.25619 "
   },
   {
      "Vendor": "R & G'S FOOD BASKET",
      "Address": " 14407 PIONEER BLVD",
      "City": "NORWALK",
      "Zip Code": " 90650",
      "County": " LOS ANGELES",
      "Latitude": "33.9000150  ",
      "Longitude": " -118.08307 "
   },
   {
      "Vendor": "VICTORIA MARKET #2",
      "Address": "E 1865 97TH ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90002",
      "County": " LOS ANGELES",
      "Latitude": "33.9483410  ",
      "Longitude": " -118.23910 "
   },
   {
      "Vendor": "MONTEBELLO RANCH EXPRESS",
      "Address": "N 544 MONTEBELLO BLVD",
      "City": "MONTEBELLO",
      "Zip Code": " 90640",
      "County": " LOS ANGELES",
      "Latitude": "34.0187160  ",
      "Longitude": " -118.10516 "
   },
   {
      "Vendor": "EL CARRUCEL FOOD NUTRITION",
      "Address": "E 1703 COMPTON BLVD",
      "Second Address": " STE B",
      "City": "COMPTON",
      "Zip Code": " 90221",
      "County": " LOS ANGELES",
      "Latitude": "33.8963130  ",
      "Longitude": " -118.20423 "
   },
   {
      "Vendor": "LUCKY 16 MARKET",
      "Address": " 545 EUCLID AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90063",
      "County": " LOS ANGELES",
      "Latitude": "34.0341220  ",
      "Longitude": " -118.20515 "
   },
   {
      "Vendor": "FOR THE CHILDREN NUTRITION",
      "Address": "W 1627 PICO BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90015",
      "County": " LOS ANGELES",
      "Latitude": "34.0450550  ",
      "Longitude": " -118.27732 "
   },
   {
      "Vendor": "HEARTY NUTRITION #4",
      "Address": "S 6001 VERMONT AVE",
      "Second Address": " STE C",
      "City": "LOS ANGELES",
      "Zip Code": " 90044",
      "County": " LOS ANGELES",
      "Latitude": "33.9855220  ",
      "Longitude": " -118.29186 "
   },
   {
      "Vendor": "HEARTY NUTRITION #3",
      "Address": "S 4123 HOOVER ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90037",
      "County": " LOS ANGELES",
      "Latitude": "34.0085800  ",
      "Longitude": " -118.28742 "
   },
   {
      "Vendor": "HEARTY NUTRITION #1",
      "Address": " 6526 CRENSHAW BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90043",
      "County": " LOS ANGELES",
      "Latitude": "33.9801070  ",
      "Longitude": " -118.33066 "
   },
   {
      "Vendor": "SMART & FINAL #484",
      "Address": "S 845 FIGUEROA ST",
      "Second Address": " STE 100",
      "City": "LOS ANGELES",
      "Zip Code": " 90017",
      "County": " LOS ANGELES",
      "Latitude": "34.0472080  ",
      "Longitude": " -118.26236 "
   },
   {
      "Vendor": "DANA'S NUTRITION",
      "Address": " 8320 COMPTON AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90001",
      "County": " LOS ANGELES",
      "Latitude": "33.9625390  ",
      "Longitude": " -118.24729 "
   },
   {
      "Vendor": "CORONA MARKET",
      "Address": "E 1913 1ST ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90033",
      "County": " LOS ANGELES",
      "Latitude": "34.0466100  ",
      "Longitude": " -118.21677 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #51",
      "Address": "N 655 FAIR OAKS AVE",
      "City": "PASADENA",
      "Zip Code": " 91103",
      "County": " LOS ANGELES",
      "Latitude": "34.1570900  ",
      "Longitude": " -118.15078 "
   },
   {
      "Vendor": "SMART & FINAL #817",
      "Address": " 17500 CRENSHAW BLVD",
      "City": "TORRANCE",
      "Zip Code": " 90504",
      "County": " LOS ANGELES",
      "Latitude": "33.8716290  ",
      "Longitude": " -118.32648 "
   },
   {
      "Vendor": "SMART & FINAL #794",
      "Address": "E 303 FOOTHILL BLVD",
      "City": "AZUSA",
      "Zip Code": " 91702",
      "County": " LOS ANGELES",
      "Latitude": "34.1338600  ",
      "Longitude": " -117.90456 "
   },
   {
      "Vendor": "CHIVAS FARM MARKET",
      "Address": "S 7902 BROADWAY",
      "City": "LOS ANGELES",
      "Zip Code": " 90003",
      "County": " LOS ANGELES",
      "Latitude": "33.9677400  ",
      "Longitude": " -118.27801 "
   },
   {
      "Vendor": "SUPER UNO MEAT MRKT & 99 CE",
      "Address": "S 4375 VAN NESS AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90062",
      "County": " LOS ANGELES",
      "Latitude": "34.0040340  ",
      "Longitude": " -118.31731 "
   },
   {
      "Vendor": "ALFA MEAT MARKET",
      "Address": "E 8111 ROSECRANS AVE",
      "City": "PARAMOUNT",
      "Zip Code": " 90723",
      "County": " LOS ANGELES",
      "Latitude": "33.9040660  ",
      "Longitude": " -118.15754 "
   },
   {
      "Vendor": "FAMILY FRESH NUTRITIONAL CE",
      "Address": "S 1706 WESTERN AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90006",
      "County": " LOS ANGELES",
      "Latitude": "34.0417110  ",
      "Longitude": " -118.30880 "
   },
   {
      "Vendor": "PALOMA MEAT MARKET",
      "Address": " 6531 RITA AVE",
      "City": "HUNTINGTON PARK",
      "Zip Code": " 90255",
      "County": " LOS ANGELES",
      "Latitude": "33.9794900  ",
      "Longitude": " -118.22405 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#242",
      "Address": "N 1161 MACLAY AVE",
      "City": "SAN FERNANDO",
      "Zip Code": " 91340",
      "County": " LOS ANGELES",
      "Latitude": "34.2958310  ",
      "Longitude": " -118.42450 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#239",
      "Address": " 5172 ATLANTIC AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90805",
      "County": " LOS ANGELES",
      "Latitude": "33.8504470  ",
      "Longitude": " -118.18463 "
   },
   {
      "Vendor": "EL MEXICANO MARKET",
      "Address": "E 1900 ALONDRA BLVD",
      "City": "COMPTON",
      "Zip Code": " 90221",
      "County": " LOS ANGELES",
      "Latitude": "33.8884460  ",
      "Longitude": " -118.20181 "
   },
   {
      "Vendor": "ALFALFA FARMERS MARKET",
      "Address": "W 5151 PICO BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90019",
      "County": " LOS ANGELES",
      "Latitude": "34.0484680  ",
      "Longitude": " -118.35067 "
   },
   {
      "Vendor": "MID TOWN MARKET",
      "Address": " 2825 JAMES M WOOD BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90006",
      "County": " LOS ANGELES",
      "Latitude": "34.0560880  ",
      "Longitude": " -118.28999 "
   },
   {
      "Vendor": "VILLA DE ETLA MARKET",
      "Address": "W 1601 12TH ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90015",
      "County": " LOS ANGELES",
      "Latitude": "34.0464360  ",
      "Longitude": " -118.27606 "
   },
   {
      "Vendor": "ABC NUTRITION DEPOT",
      "Address": "E 336 ORANGE GROVE BLVD",
      "City": "PASADENA",
      "Zip Code": " 91104",
      "County": " LOS ANGELES",
      "Latitude": "34.1576600  ",
      "Longitude": " -118.14344 "
   },
   {
      "Vendor": "LA TERNERA MEAT MARKET",
      "Address": " 6841 LENNOX AVE",
      "City": "VAN NUYS",
      "Zip Code": " 91405",
      "County": " LOS ANGELES",
      "Latitude": "34.1951380  ",
      "Longitude": " -118.44604 "
   },
   {
      "Vendor": "EL RANCHO MICHOACANO MARKET",
      "Address": " 2930 BEVERLY BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90057",
      "County": " LOS ANGELES",
      "Latitude": "34.0710850  ",
      "Longitude": " -118.28128 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #582",
      "Address": "N 44220 10TH ST W",
      "City": "LANCASTER",
      "Zip Code": " 93534",
      "County": " LOS ANGELES",
      "Latitude": "34.6862470  ",
      "Longitude": " -118.14777 "
   },
   {
      "Vendor": "GARCIA MINI MARKET#2",
      "Address": "S 4050 BROADWAY PL",
      "City": "LOS ANGELES",
      "Zip Code": " 90037",
      "County": " LOS ANGELES",
      "Latitude": "34.0097760  ",
      "Longitude": " -118.27788 "
   },
   {
      "Vendor": "LUPITA'S MARKET",
      "Address": "W 1401 3RD ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90017",
      "County": " LOS ANGELES",
      "Latitude": "34.0585790  ",
      "Longitude": " -118.26181 "
   },
   {
      "Vendor": "GENESIS NUTRITIONAL CENTER",
      "Address": " 1436 CHERRY AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90813",
      "County": " LOS ANGELES",
      "Latitude": "33.7855840  ",
      "Longitude": " -118.16729 "
   },
   {
      "Vendor": "ANGELITOS NUTRICIONAL",
      "Address": " 4000 GAGE AVE",
      "City": "BELL",
      "Zip Code": " 90201",
      "County": " LOS ANGELES",
      "Latitude": "33.9787370  ",
      "Longitude": " -118.19612 "
   },
   {
      "Vendor": "LA BODEGA MARKET #5",
      "Address": "E 2900 ANAHEIM ST",
      "City": "LONG BEACH",
      "Zip Code": " 90804",
      "County": " LOS ANGELES",
      "Latitude": "33.7823460  ",
      "Longitude": " -118.15769 "
   },
   {
      "Vendor": "EL SUPER #500",
      "Address": " 8601 HOOPER AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90002",
      "County": " LOS ANGELES",
      "Latitude": "33.9598820  ",
      "Longitude": " -118.25459 "
   },
   {
      "Vendor": "EL SUPER #501",
      "Address": "S 7220 VERMONT AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90044",
      "County": " LOS ANGELES",
      "Latitude": "33.9743370  ",
      "Longitude": " -118.29125 "
   },
   {
      "Vendor": "WHITTIER NUTRITION",
      "Address": " 4962 WHITTIER BLVD",
      "City": "EAST LOS ANGELES",
      "Zip Code": " 90022",
      "County": " LOS ANGELES",
      "Latitude": "34.0212810  ",
      "Longitude": " -118.16224 "
   },
   {
      "Vendor": "AAA HEALTHY NUTRITION",
      "Address": " 7728 GARVEY AVE",
      "Second Address": "  SUITE #1",
      "City": "ROSEMEAD",
      "Zip Code": " 91770",
      "County": " LOS ANGELES",
      "Latitude": "34.0623580  ",
      "Longitude": " -118.10116 "
   },
   {
      "Vendor": "VIRGIL FARM MARKET",
      "Address": "N 868 VIRGIL AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90020",
      "County": " LOS ANGELES",
      "Latitude": "34.0871460  ",
      "Longitude": " -118.28667 "
   },
   {
      "Vendor": "GUADALAJARA  MEAT MARKET",
      "Address": " 1985 FIRESTONE BLVD",
      "City": "LOS ANGELES",
      "Zip Code": " 90001",
      "County": " LOS ANGELES",
      "Latitude": "33.9604310  ",
      "Longitude": " -118.23646 "
   },
   {
      "Vendor": "GAREY MEAT MARKET",
      "Address": "S 1090 GAREY AVE",
      "City": "POMONA",
      "Zip Code": " 91766",
      "County": " LOS ANGELES",
      "Latitude": "34.0498330  ",
      "Longitude": " -117.74951 "
   },
   {
      "Vendor": "BUY LOW MARKET #10",
      "Address": "S 420 LONG BEACH BLVD",
      "City": "COMPTON",
      "Zip Code": " 90221",
      "County": " LOS ANGELES",
      "Latitude": "33.8930030  ",
      "Longitude": " -118.20755 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#437",
      "Address": "W 2325 WHITTIER BLVD",
      "City": "MONTEBELLO",
      "Zip Code": " 90640",
      "County": " LOS ANGELES",
      "Latitude": "34.0133480  ",
      "Longitude": " -118.12594 "
   },
   {
      "Vendor": "SMART & FINAL #745",
      "Address": " 4480 ATLANTIC AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90807",
      "County": " LOS ANGELES",
      "Latitude": "33.8390170  ",
      "Longitude": " -118.18429 "
   },
   {
      "Vendor": "SMART & FINAL #790",
      "Address": "E 3111 FLORENCE AVE",
      "City": "HUNTINGTON PARK",
      "Zip Code": " 90255",
      "County": " LOS ANGELES",
      "Latitude": "33.9730220  ",
      "Longitude": " -118.21162 "
   },
   {
      "Vendor": "EL SUPER #502",
      "Address": "S 1035 LA BREA AVE",
      "City": "INGLEWOOD",
      "Zip Code": " 90301",
      "County": " LOS ANGELES",
      "Latitude": "33.9503130  ",
      "Longitude": " -118.35304 "
   },
   {
      "Vendor": "STATER BROS. MARKETS #202",
      "Address": "N 1390 ALLEN AVE",
      "City": "PASADENA",
      "Zip Code": " 91104",
      "County": " LOS ANGELES",
      "Latitude": "34.1700480  ",
      "Longitude": " -118.11195 "
   },
   {
      "Vendor": "LA BODEGA RANCH MARKET JRS",
      "Address": " 6688 LONG BEACH BLVD",
      "City": "LONG BEACH",
      "Zip Code": " 90805",
      "County": " LOS ANGELES",
      "Latitude": "33.8760230  ",
      "Longitude": " -118.20298 "
   },
   {
      "Vendor": "JJ NUTRITION",
      "Address": " 13076 VAN NUYS BLVD",
      "City": "PACOIMA",
      "Zip Code": " 91331",
      "County": " LOS ANGELES",
      "Latitude": "34.2689240  ",
      "Longitude": " -118.41786 "
   },
   {
      "Vendor": "B AND Z DISCOUNT STORE",
      "Address": "E 240 FLORENCE AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90003",
      "County": " LOS ANGELES",
      "Latitude": "33.9745070  ",
      "Longitude": " -118.27064 "
   },
   {
      "Vendor": "SINA NUTRITIONAL",
      "Address": " 43535 GADSEN AVE",
      "City": "LANCASTER",
      "Zip Code": " 93534",
      "County": " LOS ANGELES",
      "Latitude": "34.6744140  ",
      "Longitude": " -118.14384 "
   },
   {
      "Vendor": "Q & M STORE",
      "Address": "E 853 91ST ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90002",
      "County": " LOS ANGELES",
      "Latitude": "33.9540400  ",
      "Longitude": " -118.25891 "
   },
   {
      "Vendor": "VONS #3280",
      "Address": " 240 SUMNER AVE",
      "City": "AVALON",
      "Zip Code": " 90704",
      "County": " LOS ANGELES",
      "Latitude": "33.3424750  ",
      "Longitude": " -118.32703 "
   },
   {
      "Vendor": "CALIMEX FAMILY MARKET",
      "Address": "N 6604 FIGUEROA ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90042",
      "County": " LOS ANGELES",
      "Latitude": "34.1223480  ",
      "Longitude": " -118.18438 "
   },
   {
      "Vendor": "FAMILY DISCOUNT STORE",
      "Address": "W 1727 7TH ST",
      "City": "LOS ANGELES",
      "Zip Code": " 90017",
      "County": " LOS ANGELES",
      "Latitude": "34.0548260  ",
      "Longitude": " -118.27273 "
   },
   {
      "Vendor": "EL CASTILLO CARNICERIA FOOD MK",
      "Address": " 11924 FOOTHILL BLVD",
      "City": "SYLMAR",
      "Zip Code": " 91342",
      "County": " LOS ANGELES",
      "Latitude": "34.2751370  ",
      "Longitude": " -118.39605 "
   },
   {
      "Vendor": "LA CACHANILLA #5",
      "Address": "N 1135 WHITE AVE",
      "City": "POMONA",
      "Zip Code": " 91768",
      "County": " LOS ANGELES",
      "Latitude": "34.0682780  ",
      "Longitude": " -117.75952 "
   },
   {
      "Vendor": "HAPPY KIDS NUTRITION",
      "Address": " 23630 NEWHALL AVE",
      "Second Address": "  SUITE D",
      "City": "NEWHALL",
      "Zip Code": " 91321",
      "County": " LOS ANGELES",
      "Latitude": "34.3698720  ",
      "Longitude": " -118.51264 "
   },
   {
      "Vendor": "BABY NUTRITION",
      "Address": " 27538 SIERRA HIGHWAY",
      "City": "SANTA CLARITA",
      "Zip Code": " 91351",
      "County": " LOS ANGELES",
      "Latitude": "34.4148300  ",
      "Longitude": " -118.45632 "
   },
   {
      "Vendor": "BLUE DRAGON MINI MRKT & SNACKS",
      "Address": " 12819 PENN ST",
      "City": "WHITTIER",
      "Zip Code": " 90602",
      "County": " LOS ANGELES",
      "Latitude": "33.9756470  ",
      "Longitude": " -118.03899 "
   },
   {
      "Vendor": "LA BODEGA #1",
      "Address": " 6001 ATLANTIC AVE",
      "City": "LONG BEACH",
      "Zip Code": " 90805",
      "County": " LOS ANGELES",
      "Latitude": "33.8639110  ",
      "Longitude": " -118.18541 "
   },
   {
      "Vendor": "LA BODEGA #2",
      "Address": " 5575 ATLANTIC BLVD",
      "City": "LONG BEACH",
      "Zip Code": " 90805",
      "County": " LOS ANGELES",
      "Latitude": "33.8576050  ",
      "Longitude": " -118.18525 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #112",
      "Address": " 8201 TOPANGA CANYON BLVD",
      "City": "CANOGA PARK",
      "Zip Code": " 91304",
      "County": " LOS ANGELES",
      "Latitude": "34.2179810  ",
      "Longitude": " -118.60694 "
   },
   {
      "Vendor": "CARNICERIA LA OAXAQUENA #01",
      "Address": "E 200 PACIFIC COAST HWY",
      "City": "LONG BEACH",
      "Zip Code": " 90806",
      "County": " LOS ANGELES",
      "Latitude": "33.7896580  ",
      "Longitude": " -118.19076 "
   },
   {
      "Vendor": "AMIR HAPPY NUTRITION",
      "Address": " 14712 PARTHENIA ST",
      "Second Address": " STE C",
      "City": "PANORAMA CITY",
      "Zip Code": " 91402",
      "County": " LOS ANGELES",
      "Latitude": "34.2278000  ",
      "Longitude": " -118.45408 "
   },
   {
      "Vendor": "SECOYA MARKET",
      "Address": " 15233 GALE AVE",
      "City": "CITY OF INDUSTRY",
      "Zip Code": " 91745",
      "County": " LOS ANGELES",
      "Latitude": "34.0148280  ",
      "Longitude": " -117.97487 "
   },
   {
      "Vendor": "MOMMY & KIDS NUTRITIONL CENTER",
      "Address": "N 601 AZUSA AVE",
      "City": "AZUSA",
      "Zip Code": " 91702",
      "County": " LOS ANGELES",
      "Latitude": "34.1318230  ",
      "Longitude": " -117.90789 "
   },
   {
      "Vendor": "SHORTY MARKET",
      "Address": " 5504 SOUTH CENTRAL AVE",
      "City": "LOS ANGELES",
      "Zip Code": " 90011",
      "County": " LOS ANGELES",
      "Latitude": "33.9927370  ",
      "Longitude": " -118.25625 "
   },
   {
      "Vendor": "SUPER KING MARKET",
      "Address": " 6501 SAN FERNANDO RD",
      "City": "GLENDALE",
      "Zip Code": " 91201",
      "County": " LOS ANGELES",
      "Latitude": "34.1674000  ",
      "Longitude": " -118.29058 "
   },
   {
      "Vendor": "AYAH MARKET",
      "Address": "W 146 10TH ST",
      "City": "LONG BEACH",
      "Zip Code": " 90813",
      "County": " LOS ANGELES",
      "Latitude": "33.7787710  ",
      "Longitude": " -118.19377 "
   },
   {
      "Vendor": "VONS #2400",
      "Address": " 481 OLD MAMMOTH RD",
      "City": "MAMMOTH LAKES",
      "Zip Code": " 93546",
      "County": " MONO",
      "Latitude": "37.6388860  ",
      "Longitude": " -118.96666 "
   },
   {
      "Vendor": "RALPHS #221",
      "Address": "S 903 EL CAMINO REAL",
      "City": "SAN CLEMENTE",
      "Zip Code": " 92672",
      "County": " ORANGE",
      "Latitude": "33.4222680  ",
      "Longitude": " -117.60834 "
   },
   {
      "Vendor": "RALPHS #067",
      "Address": " 3330 YORBA LINDA BLVD",
      "City": "FULLERTON",
      "Zip Code": " 92831",
      "County": " ORANGE",
      "Latitude": "33.8883460  ",
      "Longitude": " -117.86864 "
   },
   {
      "Vendor": "VONS #2335",
      "Address": "N 2684 TUSTIN ST",
      "City": "ORANGE",
      "Zip Code": " 92865",
      "County": " ORANGE",
      "Latitude": "33.8331220  ",
      "Longitude": " -117.83766 "
   },
   {
      "Vendor": "VONS #2326",
      "Address": "N 780 BREA BLVD",
      "City": "BREA",
      "Zip Code": " 92821",
      "County": " ORANGE",
      "Latitude": "33.9317460  ",
      "Longitude": " -117.89408 "
   },
   {
      "Vendor": "SANTA ANA FOOD MARKET",
      "Address": "W 1216 1ST ST",
      "City": "SANTA ANA",
      "Zip Code": " 92703",
      "County": " ORANGE",
      "Latitude": "33.7451190  ",
      "Longitude": " -117.88401 "
   },
   {
      "Vendor": "STATER BROS. #037",
      "Address": " 14171 RED HILL AVE",
      "City": "TUSTIN",
      "Zip Code": " 92780",
      "County": " ORANGE",
      "Latitude": "33.7321430  ",
      "Longitude": " -117.81789 "
   },
   {
      "Vendor": "STATER BROS. #027",
      "Address": " 8522 WESTMINSTER BLVD",
      "City": "WESTMINSTER",
      "Zip Code": " 92683",
      "County": " ORANGE",
      "Latitude": "33.7583900  ",
      "Longitude": " -117.98041 "
   },
   {
      "Vendor": "VONS #3160",
      "Address": " 8891 ATLANTA AVE",
      "City": "HUNTINGTON BEACH",
      "Zip Code": " 92646",
      "County": " ORANGE",
      "Latitude": "33.6577020  ",
      "Longitude": " -117.97358 "
   },
   {
      "Vendor": "RALPHS #223",
      "Address": " 25539 PASEO DE VALENCIA",
      "City": "LAGUNA HILLS",
      "Zip Code": " 92653",
      "County": " ORANGE",
      "Latitude": "33.5908970  ",
      "Longitude": " -117.69848 "
   },
   {
      "Vendor": "RALPHS #233",
      "Address": " 4033 BALL RD",
      "City": "CYPRESS",
      "Zip Code": " 90630",
      "County": " ORANGE",
      "Latitude": "33.8178500  ",
      "Longitude": " -118.06282 "
   },
   {
      "Vendor": "PAVILIONS #2803",
      "Address": " 1101 PACIFIC COAST HWY",
      "City": "SEAL BEACH",
      "Zip Code": " 90740",
      "County": " ORANGE",
      "Latitude": "33.7440260  ",
      "Longitude": " -118.09999 "
   },
   {
      "Vendor": "VONS #2103",
      "Address": " 5600 SANTA ANA CANYON RD",
      "City": "ANAHEIM",
      "Zip Code": " 92807",
      "County": " ORANGE",
      "Latitude": "33.8512960  ",
      "Longitude": " -117.79231 "
   },
   {
      "Vendor": "VONS #2091",
      "Address": " 32401 CAMINO CAPISTRANO",
      "City": "SAN JUAN CAPISTRANO",
      "Zip Code": " 92675",
      "County": " ORANGE",
      "Latitude": "33.4928370  ",
      "Longitude": " -117.66346 "
   },
   {
      "Vendor": "VONS #2090",
      "Address": " 5922 EDINGER AVE",
      "City": "HUNTINGTON BEACH",
      "Zip Code": " 92649",
      "County": " ORANGE",
      "Latitude": "33.7287250  ",
      "Longitude": " -118.02506 "
   },
   {
      "Vendor": "VONS #2041",
      "Address": " 11861 VALLEY VIEW ST",
      "City": "GARDEN GROVE",
      "Zip Code": " 92845",
      "County": " ORANGE",
      "Latitude": "33.7899580  ",
      "Longitude": " -118.02857 "
   },
   {
      "Vendor": "RALPHS #033",
      "Address": "E 380 17TH ST",
      "City": "COSTA MESA",
      "Zip Code": " 92627",
      "County": " ORANGE",
      "Latitude": "33.6317420  ",
      "Longitude": " -117.91242 "
   },
   {
      "Vendor": "RALPHS #068",
      "Address": " 17801 SANTIAGO BLVD",
      "City": "VILLA PARK",
      "Zip Code": " 92861",
      "County": " ORANGE",
      "Latitude": "33.8150540  ",
      "Longitude": " -117.82176 "
   },
   {
      "Vendor": "RALPHS #071",
      "Address": " 12051 EUCLID ST",
      "City": "GARDEN GROVE",
      "Zip Code": " 92840",
      "County": " ORANGE",
      "Latitude": "33.7876960  ",
      "Longitude": " -117.94258 "
   },
   {
      "Vendor": "RALPHS #072",
      "Address": "N 1121 HARBOR BLVD",
      "City": "FULLERTON",
      "Zip Code": " 92832",
      "County": " ORANGE",
      "Latitude": "33.8812210  ",
      "Longitude": " -117.92543 "
   },
   {
      "Vendor": "RALPHS #076",
      "Address": " 25104 MARGUERITE PKWY",
      "City": "MISSION VIEJO",
      "Zip Code": " 92692",
      "County": " ORANGE",
      "Latitude": "33.5975770  ",
      "Longitude": " -117.65715 "
   },
   {
      "Vendor": "STATER BROS. #066",
      "Address": "N 1741 KELLOGG DR",
      "City": "ANAHEIM",
      "Zip Code": " 92807",
      "County": " ORANGE",
      "Latitude": "33.8659970  ",
      "Longitude": " -117.80497 "
   },
   {
      "Vendor": "S-MART FOODS #655",
      "Address": "W 530 LODI AVE",
      "City": "LODI",
      "Zip Code": " 95240",
      "County": " SAN JOAQUIN",
      "Latitude": "38.1292510  ",
      "Longitude": " -121.28122 "
   },
   {
      "Vendor": "SAVE MART #781",
      "Address": "S 875 TRACY BLVD",
      "City": "TRACY",
      "Zip Code": " 95376",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7239530  ",
      "Longitude": " -121.43669 "
   },
   {
      "Vendor": "RALEY'S #306",
      "Address": " 4255 MORADA LN",
      "City": "STOCKTON",
      "Zip Code": " 95212",
      "County": " SAN JOAQUIN",
      "Latitude": "38.0375070  ",
      "Longitude": " -121.25612 "
   },
   {
      "Vendor": "SAVE MART #100",
      "Address": " 1453 GOODWIN DR",
      "City": "RIPON",
      "Zip Code": " 95366",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7527780  ",
      "Longitude": " -121.13557 "
   },
   {
      "Vendor": "BABY NUTRITIONAL CARE #109",
      "Address": "S 314 CRESCENT AVE",
      "City": "LODI",
      "Zip Code": " 95240",
      "County": " SAN JOAQUIN",
      "Latitude": "38.1295640  ",
      "Longitude": " -121.28281 "
   },
   {
      "Vendor": "U-SAVE MARKET",
      "Address": "S 443 CALIFORNIA ST",
      "City": "STOCKTON",
      "Zip Code": " 95203",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9488940  ",
      "Longitude": " -121.28349 "
   },
   {
      "Vendor": "SMART & FINAL #403",
      "Address": "N 147 WILSON WAY",
      "City": "STOCKTON",
      "Zip Code": " 95205",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9574200  ",
      "Longitude": " -121.27273 "
   },
   {
      "Vendor": "SMART & FINAL #593",
      "Address": "E 215 LODI AVE",
      "City": "LODI",
      "Zip Code": " 95240",
      "County": " SAN JOAQUIN",
      "Latitude": "38.1310400  ",
      "Longitude": " -121.26892 "
   },
   {
      "Vendor": "MAIN STREET MARKET #8",
      "Address": " 1900 MCHENRY AVE",
      "City": "ESCALON",
      "Zip Code": " 95320",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7925870  ",
      "Longitude": " -120.99568 "
   },
   {
      "Vendor": "RALEY'S #317",
      "Address": "S 2550 TRACY BLVD",
      "City": "TRACY",
      "Zip Code": " 95376",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7124000  ",
      "Longitude": " -121.43282 "
   },
   {
      "Vendor": "SMART & FINAL #393",
      "Address": "W 744 HAMMER LN",
      "City": "STOCKTON",
      "Zip Code": " 95210",
      "County": " SAN JOAQUIN",
      "Latitude": "38.0209710  ",
      "Longitude": " -121.32153 "
   },
   {
      "Vendor": "LA MEXICANA SUPER MEAT MARK",
      "Address": " 3332 DELAWARE AVE",
      "City": "STOCKTON",
      "Zip Code": " 95204",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9719980  ",
      "Longitude": " -121.33308 "
   },
   {
      "Vendor": "TARGET STORE T-0738",
      "Address": " 2800 NAGLEE RD",
      "City": "TRACY",
      "Zip Code": " 95304",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7575010  ",
      "Longitude": " -121.45831 "
   },
   {
      "Vendor": "WINCO FOODS #103",
      "Address": " 2850 PAVILLION PKWY",
      "City": "TRACY",
      "Zip Code": " 95376",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7589690  ",
      "Longitude": " -121.46802 "
   },
   {
      "Vendor": "LA SUPERIOR SUPERMERCADOS",
      "Address": " 1536 WATERLOO RD",
      "City": "STOCKTON",
      "Zip Code": " 95205",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9722910  ",
      "Longitude": " -121.26838 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1840",
      "Address": "S 1205 MAIN ST",
      "City": "MANTECA",
      "Zip Code": " 95337",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7854310  ",
      "Longitude": " -121.21906 "
   },
   {
      "Vendor": "BUY 4 LESS",
      "Address": "W 401 LOCKEFORD ST",
      "City": "LODI",
      "Zip Code": " 95240",
      "County": " SAN JOAQUIN",
      "Latitude": "38.1383130  ",
      "Longitude": " -121.27776 "
   },
   {
      "Vendor": "WAL-MART STORE #2025",
      "Address": "W 3010 GRANT LINE RD",
      "City": "TRACY",
      "Zip Code": " 95304",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7537510  ",
      "Longitude": " -121.47236 "
   },
   {
      "Vendor": "TARGET STORE T-0853",
      "Address": "W 2355 KETTLEMAN LN",
      "City": "LODI",
      "Zip Code": " 95242",
      "County": " SAN JOAQUIN",
      "Latitude": "38.1157850  ",
      "Longitude": " -121.30333 "
   },
   {
      "Vendor": "TARGET STORE T-1862",
      "Address": " 10424 TRINITY PKWY",
      "City": "STOCKTON",
      "Zip Code": " 95219",
      "County": " SAN JOAQUIN",
      "Latitude": "38.0518760  ",
      "Longitude": " -121.37499 "
   },
   {
      "Vendor": "TARGET STORE T-0313",
      "Address": " 4707 PACIFIC AVE",
      "City": "STOCKTON",
      "Zip Code": " 95207",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9914480  ",
      "Longitude": " -121.31303 "
   },
   {
      "Vendor": "TARGET STORE T-2347",
      "Address": " 16858 GOLDEN VALLEY PKWY",
      "City": "LATHROP",
      "Zip Code": " 95330",
      "County": " SAN JOAQUIN",
      "Latitude": "37.8082990  ",
      "Longitude": " -121.29991 "
   },
   {
      "Vendor": "TARGET STORE T-1526",
      "Address": " 280 SPRECKELS AVE",
      "City": "MANTECA",
      "Zip Code": " 95336",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7947810  ",
      "Longitude": " -121.19707 "
   },
   {
      "Vendor": "WAL-MART #3022",
      "Address": "E 1189 MARCH LN",
      "City": "STOCKTON",
      "Zip Code": " 95210",
      "County": " SAN JOAQUIN",
      "Latitude": "38.0021250  ",
      "Longitude": " -121.29155 "
   },
   {
      "Vendor": "WAL-MART #3352",
      "Address": " 10355 TRINITY PKWY",
      "City": "STOCKTON",
      "Zip Code": " 95219",
      "County": " SAN JOAQUIN",
      "Latitude": "38.0495940  ",
      "Longitude": " -121.37475 "
   },
   {
      "Vendor": "BIG VALLEY FOOD",
      "Address": " 1832 MONTE DIABLO AVE",
      "City": "STOCKTON",
      "Zip Code": " 95203",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9587430  ",
      "Longitude": " -121.32017 "
   },
   {
      "Vendor": "GOOD START NUTRITION",
      "Address": "N 411 CALIFORNIA ST",
      "City": "STOCKTON",
      "Zip Code": " 95202",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9577910  ",
      "Longitude": " -121.28610 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #576",
      "Address": "E 71 10TH ST",
      "City": "TRACY",
      "Zip Code": " 95376",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7388400  ",
      "Longitude": " -121.42424 "
   },
   {
      "Vendor": "FOOD MAXX #490",
      "Address": "W 1950 11TH ST",
      "City": "TRACY",
      "Zip Code": " 95376",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7376040  ",
      "Longitude": " -121.45152 "
   },
   {
      "Vendor": "FRESH PRODUCE NUTRITION",
      "Address": " 4662 PRECISSI LN",
      "Second Address": " STE 100",
      "City": "STOCKTON",
      "Zip Code": " 95207",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9897780  ",
      "Longitude": " -121.31484 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1789",
      "Address": "S 1601 LOWER SACRAMENTO RD",
      "City": "LODI",
      "Zip Code": " 95242",
      "County": " SAN JOAQUIN",
      "Latitude": "38.1131620  ",
      "Longitude": " -121.30929 "
   },
   {
      "Vendor": "LA PLAZA MARKET #1",
      "Address": "N 3225 TRACY BLVD",
      "City": "TRACY",
      "Zip Code": " 95376",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7604180  ",
      "Longitude": " -121.43633 "
   },
   {
      "Vendor": "LA SUPERIOR MERCADOS",
      "Address": " 3310 EAST MAIN ST",
      "City": "STOCKTON",
      "Zip Code": " 95205",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9537990  ",
      "Longitude": " -121.24252 "
   },
   {
      "Vendor": "SOUTH SIDE MARKET",
      "Address": "S 2122 AIRPORT WAY",
      "City": "STOCKTON",
      "Zip Code": " 95206",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9322920  ",
      "Longitude": " -121.26690 "
   },
   {
      "Vendor": "3 KIDS NUTRITIONAL CARE 2",
      "Address": " 9210 THORNTON RD",
      "City": "STOCKTON",
      "Zip Code": " 95209",
      "County": " SAN JOAQUIN",
      "Latitude": "38.0343780  ",
      "Longitude": " -121.33738 "
   },
   {
      "Vendor": "LA REINA SUPERMARKET",
      "Address": "E 1357 LOUISE AVE",
      "City": "LATHROP",
      "Zip Code": " 95330",
      "County": " SAN JOAQUIN",
      "Latitude": "37.8125670  ",
      "Longitude": " -121.27647 "
   },
   {
      "Vendor": "OAK STREET MARKET",
      "Address": "E 900 OAK ST",
      "City": "STOCKTON",
      "Zip Code": " 95202",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9603360  ",
      "Longitude": " -121.28058 "
   },
   {
      "Vendor": "BABY NUTRITION SHOP",
      "Address": " 273 SPRECKELS DR",
      "City": "MANTECA",
      "Zip Code": " 95336",
      "County": " SAN JOAQUIN",
      "Latitude": "37.7951590  ",
      "Longitude": " -121.19821 "
   },
   {
      "Vendor": "PENA'S MEAT MARKET",
      "Address": "E 123 JAMESTOWN ST",
      "City": "STOCKTON",
      "Zip Code": " 95207",
      "County": " SAN JOAQUIN",
      "Latitude": "37.9941490  ",
      "Longitude": " -121.30264 "
   },
   {
      "Vendor": "FARMERS MARKET PLACE",
      "Address": " 4525 SHASTA DAM BLVD",
      "City": "SHASTA LAKE",
      "Zip Code": " 96019",
      "County": " SHASTA",
      "Latitude": "40.6807850  ",
      "Longitude": " -122.36417 "
   },
   {
      "Vendor": "SAFEWAY #0273",
      "Address": " 2601 BALLS FERRY RD",
      "City": "ANDERSON",
      "Zip Code": " 96007",
      "County": " SHASTA",
      "Latitude": "40.4566760  ",
      "Longitude": " -122.28247 "
   },
   {
      "Vendor": "SAFEWAY #4178",
      "Address": " 37264 MAIN ST",
      "City": "BURNEY",
      "Zip Code": " 96013",
      "County": " SHASTA",
      "Latitude": "40.8843620  ",
      "Longitude": " -121.65904 "
   },
   {
      "Vendor": "HOLIDAY QUALITY FOODS #34",
      "Address": " 20635 GAS POINT RD",
      "City": "COTTONWOOD",
      "Zip Code": " 96022",
      "County": " SHASTA",
      "Latitude": "40.3883860  ",
      "Longitude": " -122.28814 "
   },
   {
      "Vendor": "HOLIDAY QUALITY FOODS #45",
      "Address": " 2455 HARTNELL AVE",
      "City": "REDDING",
      "Zip Code": " 96002",
      "County": " SHASTA",
      "Latitude": "40.5630480  ",
      "Longitude": " -122.32574 "
   },
   {
      "Vendor": "RALEY'S #248",
      "Address": " 201 LAKE BLVD",
      "Second Address": " UNIT A",
      "City": "REDDING",
      "Zip Code": " 96003",
      "County": " SHASTA",
      "Latitude": "40.6114770  ",
      "Longitude": " -122.37950 "
   },
   {
      "Vendor": "HOLIDAY QUALITY FOODS #40",
      "Address": " 9350 DESCHUTES RD",
      "City": "PALO CEDRO",
      "Zip Code": " 96073",
      "County": " SHASTA",
      "Latitude": "40.5595900  ",
      "Longitude": " -122.24021 "
   },
   {
      "Vendor": "SAV MOR FOODS #12",
      "Address": " 6536 WESTSIDE RD",
      "City": "REDDING",
      "Zip Code": " 96001",
      "County": " SHASTA",
      "Latitude": "40.5199780  ",
      "Longitude": " -122.38248 "
   },
   {
      "Vendor": "HOLIDAY QUALITY FOODS #59",
      "Address": " 3315 PLACER ST",
      "City": "REDDING",
      "Zip Code": " 96001",
      "County": " SHASTA",
      "Latitude": "40.5744740  ",
      "Longitude": " -122.41565 "
   },
   {
      "Vendor": "RAY'S FOOD PLACE #52",
      "Address": " 43622 HIGHWAY 299  E",
      "City": "FALL RIVER MILLS",
      "Zip Code": " 96028",
      "County": " SHASTA",
      "Latitude": "41.0275970  ",
      "Longitude": " -121.42238 "
   },
   {
      "Vendor": "SAFEWAY #1826",
      "Address": "E 1070 CYPRESS AVE",
      "City": "REDDING",
      "Zip Code": " 96002",
      "County": " SHASTA",
      "Latitude": "40.5723570  ",
      "Longitude": " -122.35140 "
   },
   {
      "Vendor": "SAFEWAY #1954",
      "Address": " 2275 PINE ST",
      "City": "REDDING",
      "Zip Code": " 96001",
      "County": " SHASTA",
      "Latitude": "40.5768040  ",
      "Longitude": " -122.38532 "
   },
   {
      "Vendor": "FOOD MAXX #477",
      "Address": " 1330 CHURN CREEK RD",
      "City": "REDDING",
      "Zip Code": " 96003",
      "County": " SHASTA",
      "Latitude": "40.5878180  ",
      "Longitude": " -122.35211 "
   },
   {
      "Vendor": "WINCO FOODS #58",
      "Address": " 1050 OLD ALTURAS RD",
      "City": "REDDING",
      "Zip Code": " 96003",
      "County": " SHASTA",
      "Latitude": "40.5879670  ",
      "Longitude": " -122.34498 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5133",
      "Address": " 5000 RHONDA RD",
      "City": "ANDERSON",
      "Zip Code": " 96007",
      "County": " SHASTA",
      "Latitude": "40.4288970  ",
      "Longitude": " -122.28489 "
   },
   {
      "Vendor": "TARGET STORE T-0615",
      "Address": " 1280 DANA DR",
      "City": "REDDING",
      "Zip Code": " 96003",
      "County": " SHASTA",
      "Latitude": "40.5859380  ",
      "Longitude": " -122.34875 "
   },
   {
      "Vendor": "SUNSHINE MARKET",
      "Address": " 4265 SHASTA DAM BLVD",
      "City": "SHASTA LAKE",
      "Zip Code": " 96019",
      "County": " SHASTA",
      "Latitude": "40.6808080  ",
      "Longitude": " -122.36922 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #584",
      "Address": " 2920 CHURN CREEK RD",
      "City": "REDDING",
      "Zip Code": " 96002",
      "County": " SHASTA",
      "Latitude": "40.5647710  ",
      "Longitude": " -122.35331 "
   },
   {
      "Vendor": "LEONARDS MARKET",
      "Address": " 606 MAIN ST",
      "City": "LOYALTON",
      "Zip Code": " 96118",
      "County": " SIERRA",
      "Latitude": "39.6754410  ",
      "Longitude": " -120.24216 "
   },
   {
      "Vendor": "RALEY'S #247",
      "Address": " 1842 FORT JONES",
      "City": "YREKA",
      "Zip Code": " 96097",
      "County": " SISKIYOU",
      "Latitude": "41.7004940  ",
      "Longitude": " -122.64429 "
   },
   {
      "Vendor": "MCCLOUD MARKET",
      "Address": " 117 BROADWAY AVE",
      "City": "MCCLOUD",
      "Zip Code": " 96057",
      "County": " SISKIYOU",
      "Latitude": "41.2522150  ",
      "Longitude": " -122.13621 "
   },
   {
      "Vendor": "STATER BROS. #035",
      "Address": " 1175 BAKER ST",
      "Second Address": " BLDG C",
      "City": "COSTA MESA",
      "Zip Code": " 92626",
      "County": " ORANGE",
      "Latitude": "33.6798640  ",
      "Longitude": " -117.90649 "
   },
   {
      "Vendor": "STATER BROS. #025",
      "Address": " 2180 NEWPORT BLVD",
      "City": "COSTA MESA",
      "Zip Code": " 92627",
      "County": " ORANGE",
      "Latitude": "33.6509080  ",
      "Longitude": " -117.90854 "
   },
   {
      "Vendor": "STATER BROS. #077",
      "Address": " 11085 WARNER AVE",
      "City": "FOUNTAIN VALLEY",
      "Zip Code": " 92708",
      "County": " ORANGE",
      "Latitude": "33.7169990  ",
      "Longitude": " -117.93549 "
   },
   {
      "Vendor": "STATER BROS. #032",
      "Address": " 8888 CHAPMAN AVE",
      "City": "GARDEN GROVE",
      "Zip Code": " 92841",
      "County": " ORANGE",
      "Latitude": "33.7878660  ",
      "Longitude": " -117.97710 "
   },
   {
      "Vendor": "STATER BROS. #028",
      "Address": "E 1800 COLLINS AVE",
      "City": "ORANGE",
      "Zip Code": " 92867",
      "County": " ORANGE",
      "Latitude": "33.8017430  ",
      "Longitude": " -117.83469 "
   },
   {
      "Vendor": "STATER BROS. #029",
      "Address": " 2630 EDINGER ST",
      "City": "SANTA ANA",
      "Zip Code": " 92704",
      "County": " ORANGE",
      "Latitude": "33.7311760  ",
      "Longitude": " -117.93639 "
   },
   {
      "Vendor": "STATER BROS. #038",
      "Address": "E 1230 MCFADDEN AVE",
      "City": "SANTA ANA",
      "Zip Code": " 92705",
      "County": " ORANGE",
      "Latitude": "33.7322190  ",
      "Longitude": " -117.85598 "
   },
   {
      "Vendor": "STATER BROS. #033",
      "Address": " 2603 WESTMINSTER AVE",
      "City": "SANTA ANA",
      "Zip Code": " 92706",
      "County": " ORANGE",
      "Latitude": "33.7604860  ",
      "Longitude": " -117.90469 "
   },
   {
      "Vendor": "STATER BROS. #040",
      "Address": "N 2360 TUSTIN AVE",
      "City": "SANTA ANA",
      "Zip Code": " 92705",
      "County": " ORANGE",
      "Latitude": "33.7681390  ",
      "Longitude": " -117.83703 "
   },
   {
      "Vendor": "STATER BROS. #041",
      "Address": "S 14600 BROOKHURST AVE",
      "City": "WESTMINSTER",
      "Zip Code": " 92683",
      "County": " ORANGE",
      "Latitude": "33.7509190  ",
      "Longitude": " -117.95409 "
   },
   {
      "Vendor": "STATER BROS. #060",
      "Address": " 18527 YORBA LINDA BLVD",
      "City": "YORBA LINDA",
      "Zip Code": " 92886",
      "County": " ORANGE",
      "Latitude": "33.8900910  ",
      "Longitude": " -117.80995 "
   },
   {
      "Vendor": "RALPHS #744",
      "Address": " 2555 EASTBLUFF DR",
      "City": "NEWPORT BEACH",
      "Zip Code": " 92660",
      "County": " ORANGE",
      "Latitude": "33.6409910  ",
      "Longitude": " -117.87620 "
   },
   {
      "Vendor": "RAY'S FOOD PLACE #24",
      "Address": " 160 MORGAN WAY",
      "City": "MOUNT SHASTA",
      "Zip Code": " 96067",
      "County": " SISKIYOU",
      "Latitude": "41.3108240  ",
      "Longitude": " -122.31710 "
   },
   {
      "Vendor": "RAY'S FOOD PLACE #26",
      "Address": " 11307 MAIN ST",
      "City": "FORT JONES",
      "Zip Code": " 96032",
      "County": " SISKIYOU",
      "Latitude": "41.6018890  ",
      "Longitude": " -122.84661 "
   },
   {
      "Vendor": "RAY'S FOOD PLACE #23",
      "Address": "N 175 WEED ST",
      "City": "WEED",
      "Zip Code": " 96094",
      "County": " SISKIYOU",
      "Latitude": "41.4232100  ",
      "Longitude": " -122.38860 "
   },
   {
      "Vendor": "RAY'S FOOD PLACE #25",
      "Address": " 124 COLLIER WAY",
      "City": "ETNA",
      "Zip Code": " 96027",
      "County": " SISKIYOU",
      "Latitude": "41.4573290  ",
      "Longitude": " -122.89386 "
   },
   {
      "Vendor": "DUNSMUIR SUPERMARKET",
      "Address": " 5529 DUNSMUIR AVE",
      "City": "DUNSMUIR",
      "Zip Code": " 96025",
      "County": " SISKIYOU",
      "Latitude": "41.2127900  ",
      "Longitude": " -122.27164 "
   },
   {
      "Vendor": "KINGFISHER MARKET",
      "Address": " 143 DAVIS RD",
      "City": "HAPPY CAMP",
      "Zip Code": " 96039",
      "County": " SISKIYOU",
      "Latitude": "41.7998980  ",
      "Longitude": " -123.37659 "
   },
   {
      "Vendor": "JOCK'S SUPER MARKET",
      "Address": " 396 MODOC AVE",
      "City": "TULELAKE",
      "Zip Code": " 96134",
      "County": " SISKIYOU",
      "Latitude": "41.9535830  ",
      "Longitude": " -121.47214 "
   },
   {
      "Vendor": "MAXX VALUE FOODS #250",
      "Address": " 415 PARADISE RD",
      "City": "MODESTO",
      "Zip Code": " 95351",
      "County": " STANISLAUS",
      "Latitude": "37.6273040  ",
      "Longitude": " -121.01256 "
   },
   {
      "Vendor": "O'BRIEN'S MARKET",
      "Address": "W 839 ROSEBURG AVE",
      "City": "MODESTO",
      "Zip Code": " 95350",
      "County": " STANISLAUS",
      "Latitude": "37.6615970  ",
      "Longitude": " -121.00406 "
   },
   {
      "Vendor": "RALEY'S #308",
      "Address": " 3430 TULLY RD",
      "City": "MODESTO",
      "Zip Code": " 95350",
      "County": " STANISLAUS",
      "Latitude": "37.6875420  ",
      "Longitude": " -121.01126 "
   },
   {
      "Vendor": "FAIRVIEW MARKET",
      "Address": " 1554 INYO AVE",
      "City": "MODESTO",
      "Zip Code": " 95358",
      "County": " STANISLAUS",
      "Latitude": "37.5997780  ",
      "Longitude": " -121.01417 "
   },
   {
      "Vendor": "SAVE MART #048",
      "Address": "E 1449 F ST",
      "City": "OAKDALE",
      "Zip Code": " 95361",
      "County": " STANISLAUS",
      "Latitude": "37.7699580  ",
      "Longitude": " -120.83123 "
   },
   {
      "Vendor": "LE JOHN'S MARKET",
      "Address": " 1420 OREGON DR",
      "City": "MODESTO",
      "Zip Code": " 95354",
      "County": " STANISLAUS",
      "Latitude": "37.6310400  ",
      "Longitude": " -120.97280 "
   },
   {
      "Vendor": "SAVE MART #049",
      "Address": " 2100 STANDIFORD AVE",
      "City": "MODESTO",
      "Zip Code": " 95350",
      "County": " STANISLAUS",
      "Latitude": "37.6887580  ",
      "Longitude": " -121.03298 "
   },
   {
      "Vendor": "SAVE MART #061",
      "Address": " 2601 OAKDALE RD",
      "Second Address": " STE L",
      "City": "MODESTO",
      "Zip Code": " 95355",
      "County": " STANISLAUS",
      "Latitude": "37.6788180  ",
      "Longitude": " -120.95924 "
   },
   {
      "Vendor": "RALEY'S #310",
      "Address": " 2900 GEER RD",
      "City": "TURLOCK",
      "Zip Code": " 95380",
      "County": " STANISLAUS",
      "Latitude": "37.5189160  ",
      "Longitude": " -120.84768 "
   },
   {
      "Vendor": "SAVE MART #066",
      "Address": " 1631 LANDER AVE",
      "City": "TURLOCK",
      "Zip Code": " 95380",
      "County": " STANISLAUS",
      "Latitude": "37.4770850  ",
      "Longitude": " -120.85055 "
   },
   {
      "Vendor": "NOB HILL FOODS #601",
      "Address": " 1945 N ST",
      "City": "NEWMAN",
      "Zip Code": " 95360",
      "County": " STANISLAUS",
      "Latitude": "37.3092570  ",
      "Longitude": " -121.02059 "
   },
   {
      "Vendor": "O'BRIEN'S SUPERMARKET",
      "Address": " 6331 OAKDALE ROAD",
      "City": "RIVERBANK",
      "Zip Code": " 95367",
      "County": " STANISLAUS",
      "Latitude": "37.7319680  ",
      "Longitude": " -120.96002 "
   },
   {
      "Vendor": "LA PERLA TAPATIA #07",
      "Address": " 7045 HUGHSON AVE",
      "City": "HUGHSON",
      "Zip Code": " 95326",
      "County": " STANISLAUS",
      "Latitude": "37.5971210  ",
      "Longitude": " -120.86451 "
   },
   {
      "Vendor": "FOOD MAXX #407",
      "Address": " 1845 COUNTRYSIDE LN",
      "City": "TURLOCK",
      "Zip Code": " 95380",
      "County": " STANISLAUS",
      "Latitude": "37.5095860  ",
      "Longitude": " -120.87749 "
   },
   {
      "Vendor": "FOOD MAXX #410",
      "Address": "W 2020 BRIGGSMORE AVE",
      "City": "MODESTO",
      "Zip Code": " 95350",
      "County": " STANISLAUS",
      "Latitude": "37.6696970  ",
      "Longitude": " -121.02867 "
   },
   {
      "Vendor": "LA PERLA TAPATIA #05",
      "Address": " 475 7TH ST",
      "City": "TURLOCK",
      "Zip Code": " 95380",
      "County": " STANISLAUS",
      "Latitude": "37.4865370  ",
      "Longitude": " -120.84781 "
   },
   {
      "Vendor": "SAVE MART #371",
      "Address": " 2595 GEER RD",
      "City": "TURLOCK",
      "Zip Code": " 95380",
      "County": " STANISLAUS",
      "Latitude": "37.5158190  ",
      "Longitude": " -120.84998 "
   },
   {
      "Vendor": "BEST DEAL COST LESS MARKET",
      "Address": "W 255 MAIN ST",
      "City": "TURLOCK",
      "Zip Code": " 95380",
      "County": " STANISLAUS",
      "Latitude": "37.4933070  ",
      "Longitude": " -120.85021 "
   },
   {
      "Vendor": "SAVE MART #082",
      "Address": " 1035 SPERRY RD",
      "City": "PATTERSON",
      "Zip Code": " 95363",
      "County": " STANISLAUS",
      "Latitude": "37.4647950  ",
      "Longitude": " -121.14147 "
   },
   {
      "Vendor": "SAFEWAY #1661",
      "Address": " 2001 MCHENRY AVE",
      "Second Address": " STE C",
      "City": "MODESTO",
      "Zip Code": " 95350",
      "County": " STANISLAUS",
      "Latitude": "37.6731120  ",
      "Longitude": " -120.99437 "
   },
   {
      "Vendor": "COST LESS MARKET",
      "Address": "N 888 YOSEMITE AVE",
      "City": "OAKDALE",
      "Zip Code": " 95361",
      "County": " STANISLAUS",
      "Latitude": "37.7761160  ",
      "Longitude": " -120.85482 "
   },
   {
      "Vendor": "SAVE MART #086",
      "Address": " 801 OAKDALE RD",
      "Second Address": " STE C",
      "City": "MODESTO",
      "Zip Code": " 95355",
      "County": " STANISLAUS",
      "Latitude": "37.6537170  ",
      "Longitude": " -120.95887 "
   },
   {
      "Vendor": "SAFEWAY #1968",
      "Address": " 3051 COUNTRYSIDE DR",
      "City": "TURLOCK",
      "Zip Code": " 95380",
      "County": " STANISLAUS",
      "Latitude": "37.5210530  ",
      "Longitude": " -120.88327 "
   },
   {
      "Vendor": "LA PERLA TAPATIA #10",
      "Address": " 2031 CROWS LANDING RD",
      "City": "MODESTO",
      "Zip Code": " 95358",
      "County": " STANISLAUS",
      "Latitude": "37.5993730  ",
      "Longitude": " -120.99411 "
   },
   {
      "Vendor": "O'BRIEN'S MARKET",
      "Address": " 4120 DALE RD",
      "Second Address": " STE H",
      "City": "MODESTO",
      "Zip Code": " 95356",
      "County": " STANISLAUS",
      "Latitude": "37.6985090  ",
      "Longitude": " -121.04806 "
   },
   {
      "Vendor": "DENAIR MARKET",
      "Address": " 4330 MAIN ST",
      "City": "DENAIR",
      "Zip Code": " 95316",
      "County": " STANISLAUS",
      "Latitude": "37.5244580  ",
      "Longitude": " -120.79840 "
   },
   {
      "Vendor": "WINCO FOODS #21",
      "Address": " 2200 PLAZA PKWY",
      "City": "MODESTO",
      "Zip Code": " 95350",
      "County": " STANISLAUS",
      "Latitude": "37.6709280  ",
      "Longitude": " -121.03439 "
   },
   {
      "Vendor": "COST LESS FOOD COMPANY",
      "Address": "E 1610 HATCH RD",
      "City": "MODESTO",
      "Zip Code": " 95351",
      "County": " STANISLAUS",
      "Latitude": "37.6079860  ",
      "Longitude": " -120.96822 "
   },
   {
      "Vendor": "FOOD 4 LESS #09",
      "Address": " 1561 MITCHELL RD",
      "City": "CERES",
      "Zip Code": " 95307",
      "County": " STANISLAUS",
      "Latitude": "37.6080130  ",
      "Longitude": " -120.94032 "
   },
   {
      "Vendor": "VILLAGE FRESH MARKET",
      "Address": "E 2090 CANAL DR",
      "City": "TURLOCK",
      "Zip Code": " 95380",
      "County": " STANISLAUS",
      "Latitude": "37.4995240  ",
      "Longitude": " -120.82427 "
   },
   {
      "Vendor": "RALEY'S #339",
      "Address": " 3020 FLOYD AVE",
      "Second Address": " STE 189",
      "City": "MODESTO",
      "Zip Code": " 95355",
      "County": " STANISLAUS",
      "Latitude": "37.6768370  ",
      "Longitude": " -120.93820 "
   },
   {
      "Vendor": "SAVE MART #105",
      "Address": " 2237 CLARIBEL RD",
      "City": "RIVERBANK",
      "Zip Code": " 95367",
      "County": " STANISLAUS",
      "Latitude": "37.7110490  ",
      "Longitude": " -120.95960 "
   },
   {
      "Vendor": "RALEY'S #338",
      "Address": "E 1550 F ST",
      "City": "OAKDALE",
      "Zip Code": " 95361",
      "County": " STANISLAUS",
      "Latitude": "37.7737460  ",
      "Longitude": " -120.83151 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5710",
      "Address": " 3848 MCHENRY AVE",
      "City": "MODESTO",
      "Zip Code": " 95350",
      "County": " STANISLAUS",
      "Latitude": "37.6947020  ",
      "Longitude": " -120.99419 "
   },
   {
      "Vendor": "COUNTRY MARKET",
      "Address": " 2147 PINE ST",
      "City": "CERES",
      "Zip Code": " 95307",
      "County": " STANISLAUS",
      "Latitude": "37.5871540  ",
      "Longitude": " -120.95540 "
   },
   {
      "Vendor": "SMART & FINAL #588",
      "Address": " 2900 STANDIFORD AVE",
      "Second Address": " STE 15",
      "City": "MODESTO",
      "Zip Code": " 95350",
      "County": " STANISLAUS",
      "Latitude": "37.6846440  ",
      "Longitude": " -121.04893 "
   },
   {
      "Vendor": "COST LESS FOOD COMPANY",
      "Address": "N 901 CARPENTER RD",
      "City": "MODESTO",
      "Zip Code": " 95351",
      "County": " STANISLAUS",
      "Latitude": "37.6479710  ",
      "Longitude": " -121.03084 "
   },
   {
      "Vendor": "COST LESS FOOD COMPANY",
      "Address": " 3801 YOSEMITE BLVD",
      "City": "MODESTO",
      "Zip Code": " 95357",
      "County": " STANISLAUS",
      "Latitude": "37.6386800  ",
      "Longitude": " -120.92624 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #531",
      "Address": " 1940 CROWS LANDING RD",
      "Second Address": " STE 18",
      "City": "MODESTO",
      "Zip Code": " 95358",
      "County": " STANISLAUS",
      "Latitude": "37.6011380  ",
      "Longitude": " -120.99070 "
   },
   {
      "Vendor": "SAVE MART #095",
      "Address": " 3601 PELANDALE ST",
      "City": "MODESTO",
      "Zip Code": " 95356",
      "County": " STANISLAUS",
      "Latitude": "37.7006410  ",
      "Longitude": " -121.06303 "
   },
   {
      "Vendor": "PACIFIC MARKET",
      "Address": " 131 COLFAX AVE",
      "City": "MODESTO",
      "Zip Code": " 95354",
      "County": " STANISLAUS",
      "Latitude": "37.6390610  ",
      "Longitude": " -120.95491 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #538",
      "Address": "W 1405 F ST",
      "Second Address": " STE G",
      "City": "OAKDALE",
      "Zip Code": " 95361",
      "County": " STANISLAUS",
      "Latitude": "37.7597320  ",
      "Longitude": " -120.86232 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #547",
      "Address": " 1400 PARADISE RD",
      "City": "MODESTO",
      "Zip Code": " 95351",
      "County": " STANISLAUS",
      "Latitude": "37.6167040  ",
      "Longitude": " -121.02831 "
   },
   {
      "Vendor": "LA AURORA MARKET",
      "Address": " 1125 BOULDER AVE",
      "City": "MODESTO",
      "Zip Code": " 95351",
      "County": " STANISLAUS",
      "Latitude": "37.6130460  ",
      "Longitude": " -120.98641 "
   },
   {
      "Vendor": "GARCIA'S MARKET",
      "Address": " 6450 THIRD ST",
      "City": "RIVERBANK",
      "Zip Code": " 95367",
      "County": " STANISLAUS",
      "Latitude": "37.7337800  ",
      "Longitude": " -120.93537 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #552",
      "Address": " 1396 MITCHELL RD",
      "City": "MODESTO",
      "Zip Code": " 95351",
      "County": " STANISLAUS",
      "Latitude": "37.6109200  ",
      "Longitude": " -120.93788 "
   },
   {
      "Vendor": "WAL-MART STORE #1983",
      "Address": " 1670 MITCHELL RD",
      "City": "CERES",
      "Zip Code": " 95307",
      "County": " STANISLAUS",
      "Latitude": "37.6060180  ",
      "Longitude": " -120.93846 "
   },
   {
      "Vendor": "WAL-MART STORE #1587",
      "Address": " 2225 PLAZA PKWY",
      "City": "MODESTO",
      "Zip Code": " 95350",
      "County": " STANISLAUS",
      "Latitude": "37.6720130  ",
      "Longitude": " -121.03495 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #561",
      "Address": "N 25 EL CIRCULO",
      "City": "PATTERSON",
      "Zip Code": " 95363",
      "County": " STANISLAUS",
      "Latitude": "37.4710700  ",
      "Longitude": " -121.13203 "
   },
   {
      "Vendor": "TARGET STORE T-2096",
      "Address": " 2425 CLARIBEL RD",
      "City": "RIVERBANK",
      "Zip Code": " 95367",
      "County": " STANISLAUS",
      "Latitude": "37.7138740  ",
      "Longitude": " -120.95286 "
   },
   {
      "Vendor": "TARGET STORE T-0938",
      "Address": " 3900 SISK RD",
      "City": "MODESTO",
      "Zip Code": " 95356",
      "County": " STANISLAUS",
      "Latitude": "37.6958790  ",
      "Longitude": " -121.06559 "
   },
   {
      "Vendor": "TARGET STORE T-0273",
      "Address": " 3405 MCHENRY AVE",
      "City": "MODESTO",
      "Zip Code": " 95350",
      "County": " STANISLAUS",
      "Latitude": "37.6875860  ",
      "Longitude": " -120.99448 "
   },
   {
      "Vendor": "PIONEER MARKET",
      "Address": " 12138 YOSEMITE BLVD",
      "City": "WATERFORD",
      "Zip Code": " 95386",
      "County": " STANISLAUS",
      "Latitude": "37.6371990  ",
      "Longitude": " -120.76811 "
   },
   {
      "Vendor": "WAL-MART #3047",
      "Address": " 2480 GEER RD",
      "City": "TURLOCK",
      "Zip Code": " 95380",
      "County": " STANISLAUS",
      "Latitude": "37.5158180  ",
      "Longitude": " -120.84861 "
   },
   {
      "Vendor": "WAL-MART #5843",
      "Address": " 1030 SPERRY AVE",
      "City": "PATTERSON",
      "Zip Code": " 95363",
      "County": " STANISLAUS",
      "Latitude": "37.4641170  ",
      "Longitude": " -121.14261 "
   },
   {
      "Vendor": "WAL-MART #3046",
      "Address": " 1421 COFFEE RD",
      "City": "MODESTO",
      "Zip Code": " 95355",
      "County": " STANISLAUS",
      "Latitude": "37.6642270  ",
      "Longitude": " -120.97669 "
   },
   {
      "Vendor": "BABY NUTRITIONAL CARE #151",
      "Address": " 1416 MITCHELL RD",
      "Second Address": " STE A",
      "City": "MODESTO",
      "Zip Code": " 95351",
      "County": " STANISLAUS",
      "Latitude": "37.6104850  ",
      "Longitude": " -120.93832 "
   },
   {
      "Vendor": "GARCIA'S MARKET",
      "Address": " 5013 YOSEMITE BLVD",
      "City": "EMPIRE",
      "Zip Code": " 95319",
      "County": " STANISLAUS",
      "Latitude": "37.6388900  ",
      "Longitude": " -120.90178 "
   },
   {
      "Vendor": "BABY NUTRITION #4",
      "Address": "N 1125 GOLDEN STATE BLVD",
      "Second Address": " STE H",
      "City": "TURLOCK",
      "Zip Code": " 95380",
      "County": " STANISLAUS",
      "Latitude": "37.5036210  ",
      "Longitude": " -120.85532 "
   },
   {
      "Vendor": "NEWMAN FOOD CENTER",
      "Address": " 1046 FRESNO ST",
      "City": "NEWMAN",
      "Zip Code": " 95360",
      "County": " STANISLAUS",
      "Latitude": "37.3141150  ",
      "Longitude": " -121.02325 "
   },
   {
      "Vendor": "CARDENAS #208",
      "Address": " 1612 CROWS LANDING RD",
      "City": "MODESTO",
      "Zip Code": " 95358",
      "County": " STANISLAUS",
      "Latitude": "37.6064290  ",
      "Longitude": " -120.99274 "
   },
   {
      "Vendor": "SUPERMERCADO MI TIERRA #8",
      "Address": " 1349 CROWS LANDING RD",
      "City": "MODESTO",
      "Zip Code": " 95351",
      "County": " STANISLAUS",
      "Latitude": "37.6104200  ",
      "Longitude": " -120.99440 "
   },
   {
      "Vendor": "SAVE MART #635",
      "Address": "E 2920 WHITMORE AVE",
      "City": "CERES",
      "Zip Code": " 95307",
      "County": " STANISLAUS",
      "Latitude": "37.5935360  ",
      "Longitude": " -120.93944 "
   },
   {
      "Vendor": "SAVE MORE MARKET",
      "Address": " 7128 HUGHSON AVE",
      "City": "HUGHSON",
      "Zip Code": " 95326",
      "County": " STANISLAUS",
      "Latitude": "37.5964710  ",
      "Longitude": " -120.86363 "
   },
   {
      "Vendor": "STATE FOODS KEYES",
      "Address": " 5471 7TH ST",
      "City": "KEYES",
      "Zip Code": " 95328",
      "County": " STANISLAUS",
      "Latitude": "37.5560130  ",
      "Longitude": " -120.91449 "
   },
   {
      "Vendor": "SMART & FINAL #811",
      "Address": " 1801 H ST",
      "City": "MODESTO",
      "Zip Code": " 95354",
      "County": " STANISLAUS",
      "Latitude": "37.6450280  ",
      "Longitude": " -120.98982 "
   },
   {
      "Vendor": "PATTERSON VALLEY FOODS",
      "Address": "S 125 EL CIRCULO AVE",
      "City": "PATTERSON",
      "Zip Code": " 95363",
      "County": " STANISLAUS",
      "Latitude": "37.4696160  ",
      "Longitude": " -121.12949 "
   },
   {
      "Vendor": "LA FAMILIA MARKET",
      "Address": " 4600 BROADWAY AVE",
      "City": "SALIDA",
      "Zip Code": " 95368",
      "County": " STANISLAUS",
      "Latitude": "37.7062590  ",
      "Longitude": " -121.08400 "
   },
   {
      "Vendor": "RALEY'S #242",
      "Address": "W 700 ONSTOTT RD",
      "City": "YUBA CITY",
      "Zip Code": " 95993",
      "County": " SUTTER",
      "Latitude": "39.1332990  ",
      "Longitude": " -121.63653 "
   },
   {
      "Vendor": "BEL AIR MARKET #521",
      "Address": " 1286 STABLER LN",
      "City": "YUBA CITY",
      "Zip Code": " 95993",
      "County": " SUTTER",
      "Latitude": "39.1476680  ",
      "Longitude": " -121.64564 "
   },
   {
      "Vendor": "WINCO FOODS #26",
      "Address": " 1350 FRANKLIN RD",
      "City": "YUBA CITY",
      "Zip Code": " 95993",
      "County": " SUTTER",
      "Latitude": "39.1257280  ",
      "Longitude": " -121.63685 "
   },
   {
      "Vendor": "FOOD MAXX #471",
      "Address": " 1232 COLUSA AVE",
      "City": "YUBA CITY",
      "Zip Code": " 95991",
      "County": " SUTTER",
      "Latitude": "39.1407900  ",
      "Longitude": " -121.63333 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1903",
      "Address": " 1150 HARTER RD",
      "City": "YUBA CITY",
      "Zip Code": " 95993",
      "County": " SUTTER",
      "Latitude": "39.1442320  ",
      "Longitude": " -121.65380 "
   },
   {
      "Vendor": "PANADERIA FLORES",
      "Address": " 1380 FRANKLIN RD",
      "Second Address": " STE E",
      "City": "YUBA CITY",
      "Zip Code": " 95991",
      "County": " SUTTER",
      "Latitude": "39.1269860  ",
      "Longitude": " -121.63765 "
   },
   {
      "Vendor": "EL TORO LOCO MARKET",
      "Address": " 240 GARDEN HWY",
      "City": "YUBA CITY",
      "Zip Code": " 95991",
      "County": " SUTTER",
      "Latitude": "39.1262100  ",
      "Longitude": " -121.60808 "
   },
   {
      "Vendor": "LA SUPERIOR MERCADOS",
      "Address": " 700 GRAY AVE",
      "City": "YUBA CITY",
      "Zip Code": " 95991",
      "County": " SUTTER",
      "Latitude": "39.1329830  ",
      "Longitude": " -121.63057 "
   },
   {
      "Vendor": "TARGET STORE T-0318",
      "Address": " 1153 BUTTE HOUSE RD",
      "City": "YUBA CITY",
      "Zip Code": " 95991",
      "County": " SUTTER",
      "Latitude": "39.1455820  ",
      "Longitude": " -121.63303 "
   },
   {
      "Vendor": "SMART & FINAL #795",
      "Address": " 905 COLUSA AVE",
      "Second Address": " STE A",
      "City": "YUBA CITY",
      "Zip Code": " 95991",
      "County": " SUTTER",
      "Latitude": "39.1425960  ",
      "Longitude": " -121.63155 "
   },
   {
      "Vendor": "RALEY'S #233",
      "Address": "S 725 MAIN ST",
      "City": "RED BLUFF",
      "Zip Code": " 96080",
      "County": " TEHAMA",
      "Latitude": "40.1626760  ",
      "Longitude": " -122.22939 "
   },
   {
      "Vendor": "SAV MOR FOODS #32",
      "Address": " 590 SOLANO ST",
      "City": "CORNING",
      "Zip Code": " 96021",
      "County": " TEHAMA",
      "Latitude": "39.9280730  ",
      "Longitude": " -122.17295 "
   },
   {
      "Vendor": "SAFEWAY #2295",
      "Address": " 600 EDITH AVE",
      "City": "CORNING",
      "Zip Code": " 96021",
      "County": " TEHAMA",
      "Latitude": "39.9292870  ",
      "Longitude": " -122.19815 "
   },
   {
      "Vendor": "FOOD MAXX #476",
      "Address": " 94 BELLE MILL RD",
      "City": "RED BLUFF",
      "Zip Code": " 96080",
      "County": " TEHAMA",
      "Latitude": "40.1803150  ",
      "Longitude": " -122.22794 "
   },
   {
      "Vendor": "NU-WAY MARKET",
      "Address": " 8049 HIGHWAY 99  E",
      "City": "LOS MOLINOS",
      "Zip Code": " 96055",
      "County": " TEHAMA",
      "Latitude": "40.0299030  ",
      "Longitude": " -122.10060 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1608",
      "Address": " 608 LUTHER RD",
      "City": "RED BLUFF",
      "Zip Code": " 96080",
      "County": " TEHAMA",
      "Latitude": "40.1610820  ",
      "Longitude": " -122.23357 "
   },
   {
      "Vendor": "WILEY'S SUPERMARKET",
      "Address": " 7520 HWY 3",
      "City": "HAYFORK",
      "Zip Code": " 96041",
      "County": " TRINITY",
      "Latitude": "40.5949840  ",
      "Longitude": " -123.01485 "
   },
   {
      "Vendor": "HAYFORK DISCOUNT MARKET",
      "Address": " 8060 HIGHWAY 3",
      "City": "HAYFORK",
      "Zip Code": " 96041",
      "County": " TRINITY",
      "Latitude": "40.5539790  ",
      "Longitude": " -123.16994 "
   },
   {
      "Vendor": "HOLIDAY MARKET #64",
      "Address": "S 1665 MAIN ST",
      "City": "WEAVERVILLE",
      "Zip Code": " 96093",
      "County": " TRINITY",
      "Latitude": "40.7181910  ",
      "Longitude": " -122.92696 "
   },
   {
      "Vendor": "PALACE FOOD DEPOT",
      "Address": "S 115 WEST ST",
      "City": "TULARE",
      "Zip Code": " 93274",
      "County": " TULARE",
      "Latitude": "36.2056960  ",
      "Longitude": " -119.36683 "
   },
   {
      "Vendor": "R-N MARKET",
      "Address": "W 655 VISALIA RD",
      "City": "EXETER",
      "Zip Code": " 93221",
      "County": " TULARE",
      "Latitude": "36.2976930  ",
      "Longitude": " -119.15089 "
   },
   {
      "Vendor": "R-N MARKET",
      "Address": "N 765 HARVARD AVE",
      "City": "LINDSAY",
      "Zip Code": " 93247",
      "County": " TULARE",
      "Latitude": "36.2120890  ",
      "Longitude": " -119.08322 "
   },
   {
      "Vendor": "R-N MARKET",
      "Address": " 12760 AVENUE 416",
      "City": "OROSI",
      "Zip Code": " 93647",
      "County": " TULARE",
      "Latitude": "36.5450480  ",
      "Longitude": " -119.28768 "
   },
   {
      "Vendor": "R-N MARKET",
      "Address": "E 1043 BARDSLEY AVE",
      "City": "TULARE",
      "Zip Code": " 93274",
      "County": " TULARE",
      "Latitude": "36.1966560  ",
      "Longitude": " -119.33333 "
   },
   {
      "Vendor": "TOWN & COUNTRY MARKET",
      "Address": "W 1310 OLIVE AVE",
      "City": "PORTERVILLE",
      "Zip Code": " 93257",
      "County": " TULARE",
      "Latitude": "36.0662800  ",
      "Longitude": " -119.04511 "
   },
   {
      "Vendor": "GENERAL FOOD STORE",
      "Address": "N 211 VALENCIA BLVD",
      "City": "WOODLAKE",
      "Zip Code": " 93286",
      "County": " TULARE",
      "Latitude": "36.4162140  ",
      "Longitude": " -119.09929 "
   },
   {
      "Vendor": "SAVE MART #040",
      "Address": "W 1121 VISALIA RD",
      "City": "EXETER",
      "Zip Code": " 93221",
      "County": " TULARE",
      "Latitude": "36.2984310  ",
      "Longitude": " -119.15519 "
   },
   {
      "Vendor": "SAVE MART #042",
      "Address": " 260 HIGHWAY 65",
      "City": "LINDSAY",
      "Zip Code": " 93247",
      "County": " TULARE",
      "Latitude": "36.1959710  ",
      "Longitude": " -119.09959 "
   },
   {
      "Vendor": "SAVE MART #045",
      "Address": "W 900 HENDERSON AVE",
      "City": "PORTERVILLE",
      "Zip Code": " 93257",
      "County": " TULARE",
      "Latitude": "36.0820530  ",
      "Longitude": " -119.03640 "
   },
   {
      "Vendor": "R-N MARKET",
      "Address": "S 737 LOVERS LN",
      "City": "VISALIA",
      "Zip Code": " 93292",
      "County": " TULARE",
      "Latitude": "36.3239870  ",
      "Longitude": " -119.26192 "
   },
   {
      "Vendor": "SAVE MART #067",
      "Address": "E 1591 NOBLE AVE",
      "City": "VISALIA",
      "Zip Code": " 93277",
      "County": " TULARE",
      "Latitude": "36.3254880  ",
      "Longitude": " -119.27509 "
   },
   {
      "Vendor": "RICHGROVE HANDI MARKET",
      "Address": " 20653 CHANEY DR",
      "City": "RICHGROVE",
      "Zip Code": " 93261",
      "County": " TULARE",
      "Latitude": "35.7961240  ",
      "Longitude": " -119.11049 "
   },
   {
      "Vendor": "TIPTON FOOD CENTER",
      "Address": "E 321 KLINDERA ST",
      "City": "TIPTON",
      "Zip Code": " 93272",
      "County": " TULARE",
      "Latitude": "36.0593550  ",
      "Longitude": " -119.30950 "
   },
   {
      "Vendor": "POPLAR MARKET",
      "Address": " 14454 ROAD 192",
      "City": "POPLAR",
      "Zip Code": " 93258",
      "County": " TULARE",
      "Latitude": "36.0522810  ",
      "Longitude": " -119.14309 "
   },
   {
      "Vendor": "SAVE MART #083",
      "Address": "W 5203 WALNUT AVE",
      "City": "VISALIA",
      "Zip Code": " 93277",
      "County": " TULARE",
      "Latitude": "36.3112400  ",
      "Longitude": " -119.34840 "
   },
   {
      "Vendor": "FRESCO MARKET PLACE",
      "Address": "S 183 L ST",
      "City": "DINUBA",
      "Zip Code": " 93618",
      "County": " TULARE",
      "Latitude": "36.5399920  ",
      "Longitude": " -119.38922 "
   },
   {
      "Vendor": "VONS #2328",
      "Address": "W 130 LINCOLN AVE",
      "City": "ANAHEIM",
      "Zip Code": " 92805",
      "County": " ORANGE",
      "Latitude": "33.8350380  ",
      "Longitude": " -117.91463 "
   },
   {
      "Vendor": "R-RANCH MARKET #2",
      "Address": "W 2521 MCFADDEN AVE",
      "City": "SANTA ANA",
      "Zip Code": " 92704",
      "County": " ORANGE",
      "Latitude": "33.7354270  ",
      "Longitude": " -117.90328 "
   },
   {
      "Vendor": "VONS #2176",
      "Address": "W 12961 CHAPMAN AVE",
      "City": "GARDEN GROVE",
      "Zip Code": " 92840",
      "County": " ORANGE",
      "Latitude": "33.7896760  ",
      "Longitude": " -117.90773 "
   },
   {
      "Vendor": "RALPHS #745",
      "Address": " 1150 IRVINE AVE",
      "City": "NEWPORT BEACH",
      "Zip Code": " 92660",
      "County": " ORANGE",
      "Latitude": "33.6294710  ",
      "Longitude": " -117.90683 "
   },
   {
      "Vendor": "VONS #2285",
      "Address": " 11322 LOS ALAMITOS BLVD",
      "City": "LOS ALAMITOS",
      "Zip Code": " 90720",
      "County": " ORANGE",
      "Latitude": "33.7977530  ",
      "Longitude": " -118.07095 "
   },
   {
      "Vendor": "RALPHS #008",
      "Address": "W 1435 CHAPMAN AVE",
      "City": "ORANGE",
      "Zip Code": " 92868",
      "County": " ORANGE",
      "Latitude": "33.7886450  ",
      "Longitude": " -117.86833 "
   },
   {
      "Vendor": "RALPHS #079",
      "Address": " 21751 LAKE FOREST DR",
      "City": "LAKE FOREST",
      "Zip Code": " 92630",
      "County": " ORANGE",
      "Latitude": "33.6469970  ",
      "Longitude": " -117.68782 "
   },
   {
      "Vendor": "RALPHS #161",
      "Address": " 14400 CULVER DR",
      "City": "IRVINE",
      "Zip Code": " 92604",
      "County": " ORANGE",
      "Latitude": "33.7047610  ",
      "Longitude": " -117.78542 "
   },
   {
      "Vendor": "RALPHS #163",
      "Address": " 31874 DEL OBISPO ST",
      "City": "SAN JUAN CAPISTRANO",
      "Zip Code": " 92675",
      "County": " ORANGE",
      "Latitude": "33.4985750  ",
      "Longitude": " -117.65950 "
   },
   {
      "Vendor": "FOOD 4 LESS #382",
      "Address": "E 315 FIRST ST",
      "City": "SANTA ANA",
      "Zip Code": " 92701",
      "County": " ORANGE",
      "Latitude": "33.7457400  ",
      "Longitude": " -117.86497 "
   },
   {
      "Vendor": "RALPHS #117",
      "Address": " 27730 SANTA MARGARITA PKWY",
      "City": "MISSION VIEJO",
      "Zip Code": " 92691",
      "County": " ORANGE",
      "Latitude": "33.6516610  ",
      "Longitude": " -117.64662 "
   },
   {
      "Vendor": "RALPHS #188",
      "Address": " 24871 DEL PRADO AVE",
      "City": "DANA POINT",
      "Zip Code": " 92629",
      "County": " ORANGE",
      "Latitude": "33.4623340  ",
      "Longitude": " -117.69410 "
   },
   {
      "Vendor": "RALPHS #738",
      "Address": " 28231 CROWN VALLEY PKWY",
      "City": "LAGUNA NIGUEL",
      "Zip Code": " 92677",
      "County": " ORANGE",
      "Latitude": "33.5538820  ",
      "Longitude": " -117.68736 "
   },
   {
      "Vendor": "RALPHS #739",
      "Address": " 32555 GOLDEN LANTERN ST",
      "City": "DANA POINT",
      "Zip Code": " 92629",
      "County": " ORANGE",
      "Latitude": "33.4901730  ",
      "Longitude": " -117.69927 "
   },
   {
      "Vendor": "RALPHS #078",
      "Address": " 31481 SANTA MARGARITA PKWY",
      "City": "RANCHOSANTAMARGARITA",
      "Zip Code": " 92688",
      "County": " ORANGE",
      "Latitude": "33.6501880  ",
      "Longitude": " -117.58219 "
   },
   {
      "Vendor": "RALPHS #059",
      "Address": " 18405 BROOKHURST ST",
      "City": "FOUNTAIN VALLEY",
      "Zip Code": " 92708",
      "County": " ORANGE",
      "Latitude": "33.6960910  ",
      "Longitude": " -117.95449 "
   },
   {
      "Vendor": "RALPHS #154",
      "Address": " 5345 ALTON PKWY",
      "City": "IRVINE",
      "Zip Code": " 92604",
      "County": " ORANGE",
      "Latitude": "33.6711740  ",
      "Longitude": " -117.79041 "
   },
   {
      "Vendor": "RALPHS #015",
      "Address": " 638 CAMINO DE LOS MARES",
      "City": "SAN CLEMENTE",
      "Zip Code": " 92672",
      "County": " ORANGE",
      "Latitude": "33.4587030  ",
      "Longitude": " -117.65122 "
   },
   {
      "Vendor": "RALPHS #135",
      "Address": "S 711 WEIR CANYON RD",
      "City": "ANAHEIM",
      "Zip Code": " 92808",
      "County": " ORANGE",
      "Latitude": "33.8613180  ",
      "Longitude": " -117.73992 "
   },
   {
      "Vendor": "FOOD 4 LESS #310",
      "Address": "W 1616 KATELLA AVE",
      "City": "ANAHEIM",
      "Zip Code": " 92802",
      "County": " ORANGE",
      "Latitude": "33.8019220  ",
      "Longitude": " -117.93772 "
   },
   {
      "Vendor": "VONS #3069",
      "Address": " 20445 YORBA LINDA BLVD",
      "City": "YORBA LINDA",
      "Zip Code": " 92886",
      "County": " ORANGE",
      "Latitude": "33.8912330  ",
      "Longitude": " -117.77652 "
   },
   {
      "Vendor": "VONS #2206",
      "Address": " 16450 BEACH BLVD",
      "City": "WESTMINSTER",
      "Zip Code": " 92683",
      "County": " ORANGE",
      "Latitude": "33.7244780  ",
      "Longitude": " -117.98908 "
   },
   {
      "Vendor": "PAVILIONS #2210",
      "Address": " 26022 MARGUERITE PARKWAY",
      "City": "MISSION VIEJO",
      "Zip Code": " 92692",
      "County": " ORANGE",
      "Latitude": "33.5855070  ",
      "Longitude": " -117.66023 "
   },
   {
      "Vendor": "PAVILIONS #2235",
      "Address": " 1000 BAYSIDE DR",
      "City": "NEWPORT BEACH",
      "Zip Code": " 92662",
      "County": " ORANGE",
      "Latitude": "33.6114260  ",
      "Longitude": " -117.89276 "
   },
   {
      "Vendor": "PAVILIONS #2217",
      "Address": " 22451 ANTONIO PARKWAY",
      "City": "RANCHO SANTA MARGARI",
      "Zip Code": " 92688",
      "County": " ORANGE",
      "Latitude": "33.6368390  ",
      "Longitude": " -117.59042 "
   },
   {
      "Vendor": "PAVILIONS #2216",
      "Address": "E 8010 SANTA ANA CANYON RD",
      "City": "ANAHEIM HILLS",
      "Zip Code": " 92808",
      "County": " ORANGE",
      "Latitude": "33.8683340  ",
      "Longitude": " -117.75214 "
   },
   {
      "Vendor": "GELSON'S MARKET #006",
      "Address": " 1660 SAN MIGUEL DR",
      "City": "NEWPORT BEACH",
      "Zip Code": " 92660",
      "County": " ORANGE",
      "Latitude": "33.6114840  ",
      "Longitude": " -117.86332 "
   },
   {
      "Vendor": "RALPHS #099",
      "Address": " 26751 PORTOLA PKWY",
      "City": "FOOTHILL RANCH",
      "Zip Code": " 92610",
      "County": " ORANGE",
      "Latitude": "33.6801500  ",
      "Longitude": " -117.66325 "
   },
   {
      "Vendor": "RALPHS #131",
      "Address": " 5241 WARNER AVE",
      "City": "HUNTINGTON BEACH",
      "Zip Code": " 92649",
      "County": " ORANGE",
      "Latitude": "33.7164840  ",
      "Longitude": " -118.03792 "
   },
   {
      "Vendor": "RALPHS #192",
      "Address": "W 305 IMPERIAL HWY",
      "City": "BREA",
      "Zip Code": " 92821",
      "County": " ORANGE",
      "Latitude": "33.9188560  ",
      "Longitude": " -117.90310 "
   },
   {
      "Vendor": "RALPHS #139",
      "Address": " 13321 JAMBOREE RD",
      "City": "TUSTIN",
      "Zip Code": " 92782",
      "County": " ORANGE",
      "Latitude": "33.7306670  ",
      "Longitude": " -117.78812 "
   },
   {
      "Vendor": "PAVILIONS #2508",
      "Address": " 27320 ALICIA PKWY",
      "City": "LAGUNA NIGUEL",
      "Zip Code": " 92656",
      "County": " ORANGE",
      "Latitude": "33.5663060  ",
      "Longitude": " -117.71507 "
   },
   {
      "Vendor": "RALPHS #080",
      "Address": " 17605 HARVARD AVE",
      "City": "IRVINE",
      "Zip Code": " 92614",
      "County": " ORANGE",
      "Latitude": "33.6768720  ",
      "Longitude": " -117.83178 "
   },
   {
      "Vendor": "BIG SAVER FOODS #07",
      "Address": "W 420 17TH ST",
      "City": "SANTA ANA",
      "Zip Code": " 92706",
      "County": " ORANGE",
      "Latitude": "33.7597770  ",
      "Longitude": " -117.87257 "
   },
   {
      "Vendor": "RALPHS #296",
      "Address": "S 915 BROOKHURST ST",
      "City": "ANAHEIM",
      "Zip Code": " 92804",
      "County": " ORANGE",
      "Latitude": "33.8195960  ",
      "Longitude": " -117.96010 "
   },
   {
      "Vendor": "RALPHS #755",
      "Address": " 26901 ALISO CREEK RD",
      "City": "ALISO VIEJO",
      "Zip Code": " 92656",
      "County": " ORANGE",
      "Latitude": "33.5717350  ",
      "Longitude": " -117.72516 "
   },
   {
      "Vendor": "RALPHS #756",
      "Address": "N 710 ROSE DR",
      "City": "PLACENTIA",
      "Zip Code": " 92870",
      "County": " ORANGE",
      "Latitude": "33.8773710  ",
      "Longitude": " -117.84312 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#409",
      "Address": "W 5015 EDINGER AVE",
      "Second Address": " UNIT R",
      "City": "SANTA ANA",
      "Zip Code": " 92704",
      "County": " ORANGE",
      "Latitude": "33.7309790  ",
      "Longitude": " -117.93599 "
   },
   {
      "Vendor": "PRIME TIME NUTRITION #8",
      "Address": " 4470 LINCOLN AVE",
      "Second Address": " UNIT 5",
      "City": "CYPRESS",
      "Zip Code": " 90630",
      "County": " ORANGE",
      "Latitude": "33.8311090  ",
      "Longitude": " -118.05624 "
   },
   {
      "Vendor": "STATER BROS. #124",
      "Address": " 24336 EL TORO RD",
      "City": "LAGUNA HILLS",
      "Zip Code": " 92653",
      "County": " ORANGE",
      "Latitude": "33.6082680  ",
      "Longitude": " -117.73128 "
   },
   {
      "Vendor": "FOOD 4 LESS #340",
      "Address": "S 2140 BRISTOL ST",
      "City": "SANTA ANA",
      "Zip Code": " 92704",
      "County": " ORANGE",
      "Latitude": "33.7176570  ",
      "Longitude": " -117.88548 "
   },
   {
      "Vendor": "VONS #1626",
      "Address": "S 3650 BRISTOL ST",
      "City": "SANTA ANA",
      "Zip Code": " 92704",
      "County": " ORANGE",
      "Latitude": "33.6983090  ",
      "Longitude": " -117.88693 "
   },
   {
      "Vendor": "MOM'S & BABY'S MARKET",
      "Address": "E 1640 1ST ST",
      "Second Address": " STE F",
      "City": "SANTA ANA",
      "Zip Code": " 92701",
      "County": " ORANGE",
      "Latitude": "33.7450320  ",
      "Longitude": " -117.84561 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #109",
      "Address": "S 1710 MAIN ST",
      "City": "SANTA ANA",
      "Zip Code": " 92707",
      "County": " ORANGE",
      "Latitude": "33.7246470  ",
      "Longitude": " -117.86891 "
   },
   {
      "Vendor": "STATER BROS. #129",
      "Address": "E 1040 BASTANCHURY RD",
      "City": "FULLERTON",
      "Zip Code": " 92835",
      "County": " ORANGE",
      "Latitude": "33.8982860  ",
      "Longitude": " -117.91117 "
   },
   {
      "Vendor": "STATER BROS. #131",
      "Address": "N 1131 STATE COLLEGE BLVD",
      "City": "ANAHEIM",
      "Zip Code": " 92806",
      "County": " ORANGE",
      "Latitude": "33.8495380  ",
      "Longitude": " -117.89033 "
   },
   {
      "Vendor": "STATER BROS. #132",
      "Address": "E 7511 ORANGETHORPE AVE",
      "City": "BUENA PARK",
      "Zip Code": " 90621",
      "County": " ORANGE",
      "Latitude": "33.8600760  ",
      "Longitude": " -118.00183 "
   },
   {
      "Vendor": "STATER BROS. #133",
      "Address": "N 851 HARBOR BLVD",
      "City": "LA HABRA",
      "Zip Code": " 90631",
      "County": " ORANGE",
      "Latitude": "33.9399410  ",
      "Longitude": " -117.93385 "
   },
   {
      "Vendor": "STATER BROS. #135",
      "Address": "E 1111 IMPERIAL HWY",
      "City": "PLACENTIA",
      "Zip Code": " 92870",
      "County": " ORANGE",
      "Latitude": "33.9057350  ",
      "Longitude": " -117.84320 "
   },
   {
      "Vendor": "STATER BROS. #136",
      "Address": "N 333 EUCLID ST",
      "City": "FULLERTON",
      "Zip Code": " 92832",
      "County": " ORANGE",
      "Latitude": "33.8729650  ",
      "Longitude": " -117.94249 "
   },
   {
      "Vendor": "STATER BROS. #142",
      "Address": " 22351 EL TORO RD",
      "City": "LAKE FOREST",
      "Zip Code": " 92630",
      "County": " ORANGE",
      "Latitude": "33.6383880  ",
      "Longitude": " -117.68008 "
   },
   {
      "Vendor": "STATER BROS. #143",
      "Address": " 26892 LA PAZ RD",
      "City": "ALISO VIEJO",
      "Zip Code": " 92656",
      "County": " ORANGE",
      "Latitude": "33.5720060  ",
      "Longitude": " -117.70609 "
   },
   {
      "Vendor": "STATER BROS. #147",
      "Address": " 10114 ADAMS AVE",
      "City": "HUNTINGTON BEACH",
      "Zip Code": " 92646",
      "County": " ORANGE",
      "Latitude": "33.6721410  ",
      "Longitude": " -117.95060 "
   },
   {
      "Vendor": "STATER BROS. #148",
      "Address": " 7101 WARNER AVE",
      "City": "HUNTINGTON BEACH",
      "Zip Code": " 92647",
      "County": " ORANGE",
      "Latitude": "33.7162910  ",
      "Longitude": " -118.00472 "
   },
   {
      "Vendor": "STATER BROS. #149",
      "Address": " 616 CAMINO DE LOS MARES",
      "City": "SAN CLEMENTE",
      "Zip Code": " 92673",
      "County": " ORANGE",
      "Latitude": "33.4591900  ",
      "Longitude": " -117.65358 "
   },
   {
      "Vendor": "STATER BROS. #159",
      "Address": " 10051 VALLEY VIEW AVE",
      "City": "CYPRESS",
      "Zip Code": " 90630",
      "County": " ORANGE",
      "Latitude": "33.8160740  ",
      "Longitude": " -118.02917 "
   },
   {
      "Vendor": "STATER BROS. #165",
      "Address": "E 3325 CHAPMAN AVE",
      "City": "ORANGE",
      "Zip Code": " 92869",
      "County": " ORANGE",
      "Latitude": "33.7887870  ",
      "Longitude": " -117.81780 "
   },
   {
      "Vendor": "STATER BROS. #166",
      "Address": "S 610 BROOKHURST ST",
      "City": "ANAHEIM",
      "Zip Code": " 92804",
      "County": " ORANGE",
      "Latitude": "33.8240460  ",
      "Longitude": " -117.95794 "
   },
   {
      "Vendor": "RALPHS #004",
      "Address": "S 700 COAST HWY",
      "City": "LAGUNA BEACH",
      "Zip Code": " 92651",
      "County": " ORANGE",
      "Latitude": "33.5376850  ",
      "Longitude": " -117.77895 "
   },
   {
      "Vendor": "VONS #1736",
      "Address": " 2701C HARBOR BLVD",
      "City": "COSTA MESA",
      "Zip Code": " 92626",
      "County": " ORANGE",
      "Latitude": "33.6717230  ",
      "Longitude": " -117.91977 "
   },
   {
      "Vendor": "JON'S FRESH MARKETPLACE #18",
      "Address": " 15300 GOLDENWEST ST",
      "City": "WESTMINSTER",
      "Zip Code": " 92683",
      "County": " ORANGE",
      "Latitude": "33.7403720  ",
      "Longitude": " -118.00619 "
   },
   {
      "Vendor": "MOM'S & BABY'S MARKET",
      "Address": " 6906 WESTMINSTER BLVD",
      "City": "WESTMINSTER",
      "Zip Code": " 92683",
      "County": " ORANGE",
      "Latitude": "33.7590470  ",
      "Longitude": " -118.00850 "
   },
   {
      "Vendor": "MOM'S & BABY'S MARKET",
      "Address": "W 3524 FIRST ST",
      "City": "SANTA ANA",
      "Zip Code": " 92703",
      "County": " ORANGE",
      "Latitude": "33.7451930  ",
      "Longitude": " -117.91614 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #110",
      "Address": "E 1720 17TH ST",
      "City": "SANTA ANA",
      "Zip Code": " 92705",
      "County": " ORANGE",
      "Latitude": "33.7587010  ",
      "Longitude": " -117.84310 "
   },
   {
      "Vendor": "RALPHS #650",
      "Address": " 19081 GOLDENWEST ST",
      "City": "HUNTINGTON BEACH",
      "Zip Code": " 92648",
      "County": " ORANGE",
      "Latitude": "33.6859590  ",
      "Longitude": " -118.00646 "
   },
   {
      "Vendor": "GELSON'S MARKET #018",
      "Address": " 5521 ALTON PKWY",
      "City": "IRVINE",
      "Zip Code": " 92618",
      "County": " ORANGE",
      "Latitude": "33.6696630  ",
      "Longitude": " -117.78663 "
   },
   {
      "Vendor": "GELSON'S MARKET #019",
      "Address": " 24 MONARCH BAY PLAZA",
      "City": "DANA POINT",
      "Zip Code": " 92629",
      "County": " ORANGE",
      "Latitude": "33.4855080  ",
      "Longitude": " -117.72380 "
   },
   {
      "Vendor": "PAVILIONS #2089",
      "Address": "N 600 COAST HIGHWAY",
      "City": "LAGUNA BEACH",
      "Zip Code": " 92651",
      "County": " ORANGE",
      "Latitude": "33.5466710  ",
      "Longitude": " -117.79376 "
   },
   {
      "Vendor": "MARTHA'S MARKET",
      "Address": "S 1007 BRISTOL ST",
      "Second Address": " STE A",
      "City": "SANTA ANA",
      "Zip Code": " 92703",
      "County": " ORANGE",
      "Latitude": "33.7351390  ",
      "Longitude": " -117.88484 "
   },
   {
      "Vendor": "EL METATE MARKET #2",
      "Address": "N 125 RANCHO SANTIAGO BLVD",
      "City": "ORANGE",
      "Zip Code": " 92869",
      "County": " ORANGE",
      "Latitude": "33.7883840  ",
      "Longitude": " -117.80095 "
   },
   {
      "Vendor": "EL METATE MARKET #3",
      "Address": "W 817 19TH ST",
      "City": "COSTA MESA",
      "Zip Code": " 92627",
      "County": " ORANGE",
      "Latitude": "33.6427920  ",
      "Longitude": " -117.93272 "
   },
   {
      "Vendor": "LA PALMA NUTRITION",
      "Address": "N 1062 STATE COLLEGE BLVD",
      "City": "ANAHEIM",
      "Zip Code": " 92806",
      "County": " ORANGE",
      "Latitude": "33.8483890  ",
      "Longitude": " -117.88912 "
   },
   {
      "Vendor": "RALPHS #604",
      "Address": " 12470 SEAL BEACH BLVD",
      "City": "SEAL BEACH",
      "Zip Code": " 90740",
      "County": " ORANGE",
      "Latitude": "33.7810480  ",
      "Longitude": " -118.06950 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#441",
      "Address": " 18551 CHAPMAN AVE",
      "Second Address": " UNIT B",
      "City": "ORANGE",
      "Zip Code": " 92869",
      "County": " ORANGE",
      "Latitude": "33.7900440  ",
      "Longitude": " -117.75607 "
   },
   {
      "Vendor": "PAVILIONS #1911",
      "Address": " 21181 NEWPORT COAST DR",
      "City": "NEWPORT COAST",
      "Zip Code": " 92657",
      "County": " ORANGE",
      "Latitude": "33.6069620  ",
      "Longitude": " -117.82761 "
   },
   {
      "Vendor": "R-RANCH MARKET #12",
      "Address": " 1112 WALNUT AVE",
      "City": "TUSTIN",
      "Zip Code": " 92780",
      "County": " ORANGE",
      "Latitude": "33.7312390  ",
      "Longitude": " -117.82657 "
   },
   {
      "Vendor": "PAVILIONS #1912",
      "Address": " 2660 SAN MIGUEL DR",
      "City": "NEWPORT BEACH",
      "Zip Code": " 92660",
      "County": " ORANGE",
      "Latitude": "33.6265680  ",
      "Longitude": " -117.84845 "
   },
   {
      "Vendor": "MARTHA'S MARKET",
      "Address": "W 1120 LA PALMA AVE",
      "Second Address": " STE 4",
      "City": "ANAHEIM",
      "Zip Code": " 92801",
      "County": " ORANGE",
      "Latitude": "33.8468190  ",
      "Longitude": " -117.93274 "
   },
   {
      "Vendor": "STANTON 98 CENTS + GEN MERC",
      "Address": " 10576 MAGNOLIA AVE",
      "City": "ANAHEIM",
      "Zip Code": " 92804",
      "County": " ORANGE",
      "Latitude": "33.8090090  ",
      "Longitude": " -117.97553 "
   },
   {
      "Vendor": "BEACH NUTRITION",
      "Address": " 17406 BEACH BLVD",
      "City": "HUNTINGTON BEACH",
      "Zip Code": " 92647",
      "County": " ORANGE",
      "Latitude": "33.7096750  ",
      "Longitude": " -117.98900 "
   },
   {
      "Vendor": "JIMENEZ MARKET",
      "Address": "N 1303 MAIN ST",
      "City": "SANTA ANA",
      "Zip Code": " 92701",
      "County": " ORANGE",
      "Latitude": "33.7558620  ",
      "Longitude": " -117.86739 "
   },
   {
      "Vendor": "LA FAMILIA NUTRITIONS #2",
      "Address": " 32086 CAMINO CAPISTRANO",
      "Second Address": " UNIT 2",
      "City": "SAN JUAN CAPISTRANO",
      "Zip Code": " 92675",
      "County": " ORANGE",
      "Latitude": "33.4964030  ",
      "Longitude": " -117.66203 "
   },
   {
      "Vendor": "MAMA Y BEBE FOOD",
      "Address": " 8194 COMMONWEALTH AVE",
      "Second Address": " UNIT A & B",
      "City": "BUENA PARK",
      "Zip Code": " 90621",
      "County": " ORANGE",
      "Latitude": "33.8696620  ",
      "Longitude": " -117.99026 "
   },
   {
      "Vendor": "BABIES 4 US NUTRITIONAL",
      "Address": "N 816 ANAHEIM BLVD",
      "City": "ANAHEIM",
      "Zip Code": " 92805",
      "County": " ORANGE",
      "Latitude": "33.8450480  ",
      "Longitude": " -117.91666 "
   },
   {
      "Vendor": "E Z NUTRITION #2",
      "Address": " 12531 HARBOR BLVD",
      "Second Address": " UNIT B",
      "City": "GARDEN GROVE",
      "Zip Code": " 92840",
      "County": " ORANGE",
      "Latitude": "33.7808730  ",
      "Longitude": " -117.91552 "
   },
   {
      "Vendor": "LA FAMILIA NUTRITIONS #3",
      "Address": "S 714 MAIN ST",
      "City": "SANTA ANA",
      "Zip Code": " 92701",
      "County": " ORANGE",
      "Latitude": "33.7388010  ",
      "Longitude": " -117.86802 "
   },
   {
      "Vendor": "ORANGE NUTRITION",
      "Address": "N 1120 TUSTIN AVE",
      "Second Address": " UNIT 102",
      "City": "ORANGE",
      "Zip Code": " 92867",
      "County": " ORANGE",
      "Latitude": "33.8335000  ",
      "Longitude": " -117.83610 "
   },
   {
      "Vendor": "MOMMY'S NUTRITIONAL CENTER",
      "Address": "E 1136 17TH ST",
      "City": "SANTA ANA",
      "Zip Code": " 92706",
      "County": " ORANGE",
      "Latitude": "33.7591950  ",
      "Longitude": " -117.85453 "
   },
   {
      "Vendor": "EL SUPER #06",
      "Address": "W 3700 MCFADDEN AVE",
      "City": "SANTA ANA",
      "Zip Code": " 92704",
      "County": " ORANGE",
      "Latitude": "33.7370190  ",
      "Longitude": " -117.91761 "
   },
   {
      "Vendor": "FOOD 4 LESS #508",
      "Address": "W 914 ORANGETHORPE AVE",
      "City": "FULLERTON",
      "Zip Code": " 92832",
      "County": " ORANGE",
      "Latitude": "33.8581140  ",
      "Longitude": " -117.94053 "
   },
   {
      "Vendor": "FOOD 4 LESS #518",
      "Address": " 7910 KATELLA AVE",
      "City": "STANTON",
      "Zip Code": " 90680",
      "County": " ORANGE",
      "Latitude": "33.8018360  ",
      "Longitude": " -117.99472 "
   },
   {
      "Vendor": "MOMMY'S NUTRITIONAL CENTER",
      "Address": "W 2323 LINCOLN AVE",
      "Second Address": " STE 103",
      "City": "ANAHEIM",
      "Zip Code": " 92801",
      "County": " ORANGE",
      "Latitude": "33.8329060  ",
      "Longitude": " -117.96428 "
   },
   {
      "Vendor": "LA CARRETA SUPERMARKETS",
      "Address": "E 4637 CHAPMAN AVE",
      "City": "ORANGE",
      "Zip Code": " 92869",
      "County": " ORANGE",
      "Latitude": "33.7882500  ",
      "Longitude": " -117.80433 "
   },
   {
      "Vendor": "C & C MARKET",
      "Address": "W 2329 FIRST ST",
      "City": "SANTA ANA",
      "Zip Code": " 92703",
      "County": " ORANGE",
      "Latitude": "33.7453020  ",
      "Longitude": " -117.90055 "
   },
   {
      "Vendor": "LA BODEGA MARKET",
      "Address": "S 259 TUSTIN ST",
      "City": "ORANGE",
      "Zip Code": " 92866",
      "County": " ORANGE",
      "Latitude": "33.7849180  ",
      "Longitude": " -117.83574 "
   },
   {
      "Vendor": "RALPHS #288",
      "Address": " 23716 EL TORO RD",
      "City": "LAKE FOREST",
      "Zip Code": " 92630",
      "County": " ORANGE",
      "Latitude": "33.6168160  ",
      "Longitude": " -117.70217 "
   },
   {
      "Vendor": "RALPHS #299",
      "Address": " 6300 IRVINE BLVD",
      "City": "IRVINE",
      "Zip Code": " 92620",
      "County": " ORANGE",
      "Latitude": "33.6965800  ",
      "Longitude": " -117.74278 "
   },
   {
      "Vendor": "SUPER KING MARKET #1",
      "Address": " 10500 MAGNOLIA AVE",
      "City": "ANAHEIM",
      "Zip Code": " 92804",
      "County": " ORANGE",
      "Latitude": "33.8098220  ",
      "Longitude": " -117.97466 "
   },
   {
      "Vendor": "FAMILY NUTRITION #2",
      "Address": "S 2835 BRISTOL ST",
      "Second Address": " UNIT C",
      "City": "SANTA ANA",
      "Zip Code": " 92707",
      "County": " ORANGE",
      "Latitude": "33.7090080  ",
      "Longitude": " -117.88544 "
   },
   {
      "Vendor": "RALPHS #287",
      "Address": " 811 AVENIDA TALEGA",
      "City": "SAN CLEMENTE",
      "Zip Code": " 92673",
      "County": " ORANGE",
      "Latitude": "33.4622300  ",
      "Longitude": " -117.59808 "
   },
   {
      "Vendor": "HEALTH NUTRITION PRODUCTS",
      "Address": " 6281 BEACH BLVD",
      "Second Address": " STE 98",
      "City": "BUENA PARK",
      "Zip Code": " 90621",
      "County": " ORANGE",
      "Latitude": "33.8688410  ",
      "Longitude": " -117.99887 "
   },
   {
      "Vendor": "MOM & KID NUTRITION",
      "Address": " 12023 GARDEN GROVE BLVD",
      "City": "GARDEN GROVE",
      "Zip Code": " 92843",
      "County": " ORANGE",
      "Latitude": "33.7746320  ",
      "Longitude": " -117.92298 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #132",
      "Address": "W 2009 1ST ST",
      "City": "SANTA ANA",
      "Zip Code": " 92703",
      "County": " ORANGE",
      "Latitude": "33.7454250  ",
      "Longitude": " -117.89626 "
   },
   {
      "Vendor": "EL SUPER #11",
      "Address": "N 650 EUCLID ST",
      "City": "ANAHEIM",
      "Zip Code": " 92801",
      "County": " ORANGE",
      "Latitude": "33.8406920  ",
      "Longitude": " -117.93998 "
   },
   {
      "Vendor": "SMART & FINAL #313",
      "Address": "N 630 EUCLID ST",
      "City": "ANAHEIM",
      "Zip Code": " 92801",
      "County": " ORANGE",
      "Latitude": "33.8402670  ",
      "Longitude": " -117.94152 "
   },
   {
      "Vendor": "SMART & FINAL #388",
      "Address": "E 1401 KATELLA AVE",
      "City": "ORANGE",
      "Zip Code": " 92867",
      "County": " ORANGE",
      "Latitude": "33.8100590  ",
      "Longitude": " -117.83885 "
   },
   {
      "Vendor": "SMART & FINAL #422",
      "Address": "W 1941 IMPERIAL HWY",
      "City": "LA HABRA",
      "Zip Code": " 90631",
      "County": " ORANGE",
      "Latitude": "33.9174170  ",
      "Longitude": " -117.96676 "
   },
   {
      "Vendor": "SMART & FINAL #423",
      "Address": " 9062 ADAMS AVE",
      "City": "HUNTINGTON BEACH",
      "Zip Code": " 92646",
      "County": " ORANGE",
      "Latitude": "33.6715080  ",
      "Longitude": " -117.96974 "
   },
   {
      "Vendor": "SMART & FINAL #425",
      "Address": "E 2475 CHAPMAN AVE",
      "City": "FULLERTON",
      "Zip Code": " 92831",
      "County": " ORANGE",
      "Latitude": "33.8742210  ",
      "Longitude": " -117.88777 "
   },
   {
      "Vendor": "NORTHGATE MARKET #03",
      "Address": "N 1150 EAST ST",
      "City": "ANAHEIM",
      "Zip Code": " 92805",
      "County": " ORANGE",
      "Latitude": "33.8500270  ",
      "Longitude": " -117.90607 "
   },
   {
      "Vendor": "NORTHGATE MARKET #05",
      "Address": "W 720 LA PALMA AVE",
      "City": "ANAHEIM",
      "Zip Code": " 92801",
      "County": " ORANGE",
      "Latitude": "33.8463330  ",
      "Longitude": " -117.92695 "
   },
   {
      "Vendor": "NORTHGATE MARKET #07",
      "Address": "W 1623 17TH ST",
      "City": "SANTA ANA",
      "Zip Code": " 92706",
      "County": " ORANGE",
      "Latitude": "33.7600290  ",
      "Longitude": " -117.89077 "
   },
   {
      "Vendor": "NORTHGATE MARKET #08",
      "Address": "E 409 4TH ST",
      "City": "SANTA ANA",
      "Zip Code": " 92701",
      "County": " ORANGE",
      "Latitude": "33.7484460  ",
      "Longitude": " -117.86400 "
   },
   {
      "Vendor": "NORTHGATE MARKET #09",
      "Address": "N 230 HARBOR BLVD",
      "City": "SANTA ANA",
      "Zip Code": " 92703",
      "County": " ORANGE",
      "Latitude": "33.7463500  ",
      "Longitude": " -117.92170 "
   },
   {
      "Vendor": "NORTHGATE MARKET #11",
      "Address": "S 1120 BRISTOL ST",
      "City": "SANTA ANA",
      "Zip Code": " 92704",
      "County": " ORANGE",
      "Latitude": "33.7336560  ",
      "Longitude": " -117.88602 "
   },
   {
      "Vendor": "NORTHGATE MARKET #14",
      "Address": " 6991 LINCOLN AVE",
      "City": "BUENA PARK",
      "Zip Code": " 90620",
      "County": " ORANGE",
      "Latitude": "33.8319810  ",
      "Longitude": " -118.01014 "
   },
   {
      "Vendor": "NORTHGATE MARKET #15",
      "Address": "S 1010 MAIN ST",
      "City": "SANTA ANA",
      "Zip Code": " 92701",
      "County": " ORANGE",
      "Latitude": "33.7354360  ",
      "Longitude": " -117.86822 "
   },
   {
      "Vendor": "NORTHGATE MARKET #16",
      "Address": "S 929 EUCLID ST",
      "City": "ANAHEIM",
      "Zip Code": " 92802",
      "County": " ORANGE",
      "Latitude": "33.8188420  ",
      "Longitude": " -117.94151 "
   },
   {
      "Vendor": "NORTHGATE MARKET #18",
      "Address": "S 770 HARBOR BLVD",
      "City": "SANTA ANA",
      "Zip Code": " 92704",
      "County": " ORANGE",
      "Latitude": "33.7374720  ",
      "Longitude": " -117.92116 "
   },
   {
      "Vendor": "SMART & FINAL #399",
      "Address": " 34091 DOHENY PARK RD",
      "City": "CAPISTRANO BEACH",
      "Zip Code": " 92624",
      "County": " ORANGE",
      "Latitude": "33.4676430  ",
      "Longitude": " -117.67651 "
   },
   {
      "Vendor": "SMART & FINAL #383",
      "Address": " 23631 EL TORO RD",
      "Second Address": " STE A",
      "City": "LAKE FOREST",
      "Zip Code": " 92630",
      "County": " ORANGE",
      "Latitude": "33.6188900  ",
      "Longitude": " -117.70268 "
   },
   {
      "Vendor": "SMART & FINAL #382",
      "Address": " 6882 EDINGER AVE",
      "City": "HUNTINGTON BEACH",
      "Zip Code": " 92647",
      "County": " ORANGE",
      "Latitude": "33.7286890  ",
      "Longitude": " -118.00895 "
   },
   {
      "Vendor": "SMART & FINAL #375",
      "Address": " 14417 CULVER DR",
      "City": "IRVINE",
      "Zip Code": " 92604",
      "County": " ORANGE",
      "Latitude": "33.7064270  ",
      "Longitude": " -117.78730 "
   },
   {
      "Vendor": "SMART & FINAL #594",
      "Address": " 7050 KATELLA BLVD",
      "City": "STANTON",
      "Zip Code": " 90680",
      "County": " ORANGE",
      "Latitude": "33.8023130  ",
      "Longitude": " -118.00986 "
   },
   {
      "Vendor": "SMART & FINAL #381",
      "Address": " 7930 VALLEY VIEW ST",
      "City": "BUENA PARK",
      "Zip Code": " 90620",
      "County": " ORANGE",
      "Latitude": "33.8471210  ",
      "Longitude": " -118.02729 "
   },
   {
      "Vendor": "SMART & FINAL #389",
      "Address": "W 707 19TH ST",
      "City": "COSTA MESA",
      "Zip Code": " 92627",
      "County": " ORANGE",
      "Latitude": "33.6428820  ",
      "Longitude": " -117.92822 "
   },
   {
      "Vendor": "BAJA RANCH MARKET #2",
      "Address": "N 2515 FAIR OAKS AVE",
      "City": "ALTADENA",
      "Zip Code": " 91001",
      "County": " LOS ANGELES",
      "Latitude": "34.1888620  ",
      "Longitude": " -118.15043 "
   },
   {
      "Vendor": "BABY & MOM NUTRITION",
      "Address": "S 119 HARBOR BLVD",
      "City": "SANTA ANA",
      "Zip Code": " 92703",
      "County": " ORANGE",
      "Latitude": "33.7444040  ",
      "Longitude": " -117.91979 "
   },
   {
      "Vendor": "KID NUTRITION CENTER",
      "Address": "N 709 BRISTOL ST",
      "Second Address": " STE L",
      "City": "SANTA ANA",
      "Zip Code": " 92703",
      "County": " ORANGE",
      "Latitude": "33.7509820  ",
      "Longitude": " -117.88488 "
   },
   {
      "Vendor": "MOM & BABY NUTRITION",
      "Address": "W 1734 1ST ST",
      "Second Address": " STE G",
      "City": "SANTA ANA",
      "Zip Code": " 92703",
      "County": " ORANGE",
      "Latitude": "33.7449290  ",
      "Longitude": " -117.89277 "
   },
   {
      "Vendor": "EL TORO MEAT SHOP",
      "Address": "W 1340 FIRST ST",
      "City": "SANTA ANA",
      "Zip Code": " 92703",
      "County": " ORANGE",
      "Latitude": "33.7454560  ",
      "Longitude": " -117.88646 "
   },
   {
      "Vendor": "KIDS NUTRITION R US",
      "Address": "S 1601 GRAND AVE",
      "Second Address": " STE G",
      "City": "SANTA ANA",
      "Zip Code": " 92705",
      "County": " ORANGE",
      "Latitude": "33.7258800  ",
      "Longitude": " -117.85002 "
   },
   {
      "Vendor": "SMART & FINAL #519",
      "Address": "W 1523 17TH ST",
      "City": "SANTA ANA",
      "Zip Code": " 92706",
      "County": " ORANGE",
      "Latitude": "33.7608840  ",
      "Longitude": " -117.88921 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #136",
      "Address": " 6931 LA PALMA AVE",
      "City": "BUENA PARK",
      "Zip Code": " 90620",
      "County": " ORANGE",
      "Latitude": "33.8471150  ",
      "Longitude": " -118.01243 "
   },
   {
      "Vendor": "MOM MARKET",
      "Address": " 13039 MAGNOLIA ST",
      "City": "GARDEN GROVE",
      "Zip Code": " 92843",
      "County": " ORANGE",
      "Latitude": "33.7733350  ",
      "Longitude": " -117.97506 "
   },
   {
      "Vendor": "RA FOOD STORE & ENT SERVICE",
      "Address": "S 2225 MAIN ST",
      "City": "SANTA ANA",
      "Zip Code": " 92707",
      "County": " ORANGE",
      "Latitude": "33.7169530  ",
      "Longitude": " -117.86751 "
   },
   {
      "Vendor": "BABY NUTRITIONAL CENTER",
      "Address": " 12436 BROOKHURST ST",
      "City": "GARDEN GROVE",
      "Zip Code": " 92840",
      "County": " ORANGE",
      "Latitude": "33.7818880  ",
      "Longitude": " -117.95848 "
   },
   {
      "Vendor": "RAMONA CARNICERIA",
      "Address": "N 1965 TUSTIN AVE",
      "City": "ORANGE",
      "Zip Code": " 92865",
      "County": " ORANGE",
      "Latitude": "33.8207030  ",
      "Longitude": " -117.83577 "
   },
   {
      "Vendor": "MY PROBEEDOR",
      "Address": "E 171 ANTELOPE AVE",
      "City": "WOODLAKE",
      "Zip Code": " 93286",
      "County": " TULARE",
      "Latitude": "36.4154060  ",
      "Longitude": " -119.09804 "
   },
   {
      "Vendor": "MANA DEL CIELO",
      "Address": " 32343 ROAD 160",
      "City": "IVANHOE",
      "Zip Code": " 93235",
      "County": " TULARE",
      "Latitude": "36.3769380  ",
      "Longitude": " -119.21611 "
   },
   {
      "Vendor": "PIXLEY FOOD CENTER",
      "Address": "S 930 MAIN ST",
      "City": "PIXLEY",
      "Zip Code": " 93256",
      "County": " TULARE",
      "Latitude": "35.9655720  ",
      "Longitude": " -119.29205 "
   },
   {
      "Vendor": "BEST BUY MARKET",
      "Address": "W 1300 WALNUT AVE",
      "City": "VISALIA",
      "Zip Code": " 93277",
      "County": " TULARE",
      "Latitude": "36.3133940  ",
      "Longitude": " -119.30615 "
   },
   {
      "Vendor": "FOOD 4 LESS",
      "Address": "W 1254 HENDERSON AVE",
      "City": "PORTERVILLE",
      "Zip Code": " 93257",
      "County": " TULARE",
      "Latitude": "36.0815770  ",
      "Longitude": " -119.04602 "
   },
   {
      "Vendor": "FOODS CO #783",
      "Address": "E 1210 PROSPERITY AVE",
      "City": "TULARE",
      "Zip Code": " 93274",
      "County": " TULARE",
      "Latitude": "36.2280480  ",
      "Longitude": " -119.32745 "
   },
   {
      "Vendor": "SAVE MART #089",
      "Address": "W 5201 GOSHEN AVE",
      "City": "VISALIA",
      "Zip Code": " 93291",
      "County": " TULARE",
      "Latitude": "36.3403710  ",
      "Longitude": " -119.34895 "
   },
   {
      "Vendor": "FOOD MAXX #455",
      "Address": "N 1550 BEN MADDOX WAY",
      "City": "VISALIA",
      "Zip Code": " 93292",
      "County": " TULARE",
      "Latitude": "36.3431270  ",
      "Longitude": " -119.27878 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5394",
      "Address": "W 700 EL MONTE WAY",
      "City": "DINUBA",
      "Zip Code": " 93618",
      "County": " TULARE",
      "Latitude": "36.5457480  ",
      "Longitude": " -119.40122 "
   },
   {
      "Vendor": "SAVE MART #657",
      "Address": "W 3615 NOBLE AVE",
      "City": "VISALIA",
      "Zip Code": " 93277",
      "County": " TULARE",
      "Latitude": "36.3257310  ",
      "Longitude": " -119.33090 "
   },
   {
      "Vendor": "FOOD 4 LESS",
      "Address": "N 2025 DINUBA BLVD",
      "City": "VISALIA",
      "Zip Code": " 93291",
      "County": " TULARE",
      "Latitude": "36.3483850  ",
      "Longitude": " -119.29815 "
   },
   {
      "Vendor": "WINCO FOODS #61",
      "Address": "W 3939 CALDWELL AVE",
      "City": "VISALIA",
      "Zip Code": " 93291",
      "County": " TULARE",
      "Latitude": "36.2959350  ",
      "Longitude": " -119.33426 "
   },
   {
      "Vendor": "U.S. MINI MART",
      "Address": "N 508 STATE ST",
      "City": "EARLIMART",
      "Zip Code": " 93219",
      "County": " TULARE",
      "Latitude": "35.8881510  ",
      "Longitude": " -119.27193 "
   },
   {
      "Vendor": "UNITED MARKET",
      "Address": "E 1665 EL MONTE WAY",
      "City": "DINUBA",
      "Zip Code": " 93618",
      "County": " TULARE",
      "Latitude": "36.5454420  ",
      "Longitude": " -119.37724 "
   },
   {
      "Vendor": "TARGET STORE T-2349",
      "Address": "E 2195 PROSPERITY AVE",
      "City": "TULARE",
      "Zip Code": " 93274",
      "County": " TULARE",
      "Latitude": "36.2256650  ",
      "Longitude": " -119.31318 "
   },
   {
      "Vendor": "SMART & FINAL #384",
      "Address": "W 600 CENTER ST",
      "City": "VISALIA",
      "Zip Code": " 93291",
      "County": " TULARE",
      "Latitude": "36.3314850  ",
      "Longitude": " -119.29827 "
   },
   {
      "Vendor": "SMART & FINAL #430",
      "Address": "E 1019 PROSPERITY AVE",
      "City": "TULARE",
      "Zip Code": " 93274",
      "County": " TULARE",
      "Latitude": "36.2242370  ",
      "Longitude": " -119.33254 "
   },
   {
      "Vendor": "FRESCO MARKET PLACE",
      "Address": " 12825 AVENUE 413",
      "Second Address": " STE K",
      "City": "OROSI",
      "Zip Code": " 93647",
      "County": " TULARE",
      "Latitude": "36.5389040  ",
      "Longitude": " -119.28630 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #32",
      "Address": "E 305 OLIVE AVE",
      "City": "PORTERVILLE",
      "Zip Code": " 93257",
      "County": " TULARE",
      "Latitude": "36.0642490  ",
      "Longitude": " -119.00982 "
   },
   {
      "Vendor": "MOMMY TO BE NUTRITIONAL STO",
      "Address": "S 122 K ST",
      "City": "DINUBA",
      "Zip Code": " 93618",
      "County": " TULARE",
      "Latitude": "36.5413970  ",
      "Longitude": " -119.38897 "
   },
   {
      "Vendor": "FASTRIP FOOD STORE",
      "Address": "W 195 HERMOSA ST",
      "City": "LINDSAY",
      "Zip Code": " 93247",
      "County": " TULARE",
      "Latitude": "36.2050020  ",
      "Longitude": " -119.09231 "
   },
   {
      "Vendor": "FASTRIP FOOD STORE #702",
      "Address": "W 101 VISALIA RD",
      "City": "FARMERSVILLE",
      "Zip Code": " 93223",
      "County": " TULARE",
      "Latitude": "36.2974840  ",
      "Longitude": " -119.20756 "
   },
   {
      "Vendor": "TERRA BELLA FOOD CENTER",
      "Address": " 9190 ROAD 236",
      "City": "TERRA BELLA",
      "Zip Code": " 93270",
      "County": " TULARE",
      "Latitude": "35.9568070  ",
      "Longitude": " -119.04378 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #33",
      "Address": "N 3112 DINUBA BLVD",
      "City": "VISALIA",
      "Zip Code": " 93291",
      "County": " TULARE",
      "Latitude": "36.3572680  ",
      "Longitude": " -119.29519 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #34",
      "Address": "N 1111 CHERRY ST",
      "City": "TULARE",
      "Zip Code": " 93274",
      "County": " TULARE",
      "Latitude": "36.2241410  ",
      "Longitude": " -119.33732 "
   },
   {
      "Vendor": "TARGET STORE T-1805",
      "Address": "S 4247 MOONEY BLVD",
      "City": "VISALIA",
      "Zip Code": " 93277",
      "County": " TULARE",
      "Latitude": "36.2918380  ",
      "Longitude": " -119.31390 "
   },
   {
      "Vendor": "TARGET STORE T-2420",
      "Address": "W 1363 HENDERSON AVE",
      "City": "PORTERVILLE",
      "Zip Code": " 93257",
      "County": " TULARE",
      "Latitude": "36.0801030  ",
      "Longitude": " -119.04765 "
   },
   {
      "Vendor": "FIRST STEP NUTRITION #2",
      "Address": "E 238 CROSS AVE",
      "City": "TULARE",
      "Zip Code": " 93274",
      "County": " TULARE",
      "Latitude": "36.2135290  ",
      "Longitude": " -119.34676 "
   },
   {
      "Vendor": "WAL-MART STORE #1877",
      "Address": "W 1250 HENDERSON AVE",
      "City": "PORTERVILLE",
      "Zip Code": " 93257",
      "County": " TULARE",
      "Latitude": "36.0806610  ",
      "Longitude": " -119.04517 "
   },
   {
      "Vendor": "WAL-MART STORE #2536",
      "Address": "E 1110 PROSPERITY AVE",
      "City": "TULARE",
      "Zip Code": " 93274",
      "County": " TULARE",
      "Latitude": "36.2261960  ",
      "Longitude": " -119.33004 "
   },
   {
      "Vendor": "WAL-MART STORE #1826",
      "Address": "E 1819 NOBLE AVE",
      "City": "VISALIA",
      "Zip Code": " 93292",
      "County": " TULARE",
      "Latitude": "36.3258080  ",
      "Longitude": " -119.27298 "
   },
   {
      "Vendor": "STATE FOODS SUPERMARKET",
      "Address": "E 250 ANTELOPE AVE",
      "Second Address": " STE A",
      "City": "WOODLAKE",
      "Zip Code": " 93286",
      "County": " TULARE",
      "Latitude": "36.4160520  ",
      "Longitude": " -119.09711 "
   },
   {
      "Vendor": "HEALTHY FAM. NUTR. EARLIMAR",
      "Address": "N 396 CHURCH RD",
      "City": "EARLIMART",
      "Zip Code": " 93219",
      "County": " TULARE",
      "Latitude": "35.8872570  ",
      "Longitude": " -119.26770 "
   },
   {
      "Vendor": "WAL-MART #5956",
      "Address": "S 3750 MOONEY BLVD",
      "City": "VISALIA",
      "Zip Code": " 93277",
      "County": " TULARE",
      "Latitude": "36.2964870  ",
      "Longitude": " -119.31116 "
   },
   {
      "Vendor": "GIFFORD'S MARKET",
      "Address": " 35637 HIGHWAY 190",
      "City": "SPRINGVILLE",
      "Zip Code": " 93265",
      "County": " TULARE",
      "Latitude": "36.1305280  ",
      "Longitude": " -118.81749 "
   },
   {
      "Vendor": "WAL-MART #5635",
      "Address": "N 1320 DEMAREE ST",
      "City": "VISALIA",
      "Zip Code": " 93291",
      "County": " TULARE",
      "Latitude": "36.3413590  ",
      "Longitude": " -119.32996 "
   },
   {
      "Vendor": "HEALTHY FAMILY NUTRITION",
      "Address": " 240 HWY 65",
      "City": "LINDSAY",
      "Zip Code": " 93247",
      "County": " TULARE",
      "Latitude": "36.1951670  ",
      "Longitude": " -119.09883 "
   },
   {
      "Vendor": "FIRST STEP NUTRITION #5",
      "Address": " 138 FRONT ST",
      "City": "FARMERSVILLE",
      "Zip Code": " 93223",
      "County": " TULARE",
      "Latitude": "36.3048830  ",
      "Longitude": " -119.20760 "
   },
   {
      "Vendor": "TROPICANA SUPERMARKET #3",
      "Address": "N 1010 ALTA AVE",
      "City": "DINUBA",
      "Zip Code": " 93618",
      "County": " TULARE",
      "Latitude": "36.5539670  ",
      "Longitude": " -119.39491 "
   },
   {
      "Vendor": "EL TORO LOCO FOOD CENTER",
      "Address": "S 636 CHURCH RD",
      "City": "EARLIMART",
      "Zip Code": " 93219",
      "County": " TULARE",
      "Latitude": "35.8787760  ",
      "Longitude": " -119.26778 "
   },
   {
      "Vendor": "TU CASA MARKET",
      "Address": " 16841 AVENUE 168",
      "City": "PORTERVILLE",
      "Zip Code": " 93257",
      "County": " TULARE",
      "Latitude": "36.0943630  ",
      "Longitude": " -119.19587 "
   },
   {
      "Vendor": "LA FIESTA FOODS",
      "Address": " 12732 1ST ST",
      "City": "CUTLER",
      "Zip Code": " 93615",
      "County": " TULARE",
      "Latitude": "36.5240540  ",
      "Longitude": " -119.28788 "
   },
   {
      "Vendor": "TARGET STORE T-2469",
      "Address": "N 3308 DINUBA BLVD",
      "City": "VISALIA",
      "Zip Code": " 93291",
      "County": " TULARE",
      "Latitude": "36.3598480  ",
      "Longitude": " -119.29669 "
   },
   {
      "Vendor": "ORANGE BELT MARKET",
      "Address": " 25390 ROAD 216",
      "City": "LINDSAY",
      "Zip Code": " 93247",
      "County": " TULARE",
      "Latitude": "36.2494540  ",
      "Longitude": " -119.09104 "
   },
   {
      "Vendor": "FAMILY FOODS",
      "Address": "E 2274 SPRINGVILLE AVE",
      "City": "PORTERVILLE",
      "Zip Code": " 93257",
      "County": " TULARE",
      "Latitude": "36.0552160  ",
      "Longitude": " -118.96675 "
   },
   {
      "Vendor": "LINDSAY FOOD CENTER",
      "Address": "S 455 MIRAGE AVE",
      "City": "LINDSAY",
      "Zip Code": " 93247",
      "County": " TULARE",
      "Latitude": "36.1990940  ",
      "Longitude": " -119.08735 "
   },
   {
      "Vendor": "FIRST STEP NUTRITION #12",
      "Address": "W 308 OLIVE AVE",
      "City": "PORTERVILLE",
      "Zip Code": " 93257",
      "County": " TULARE",
      "Latitude": "36.0656430  ",
      "Longitude": " -119.02379 "
   },
   {
      "Vendor": "LA GUADALUPANA MEAT MARKET 1",
      "Address": " 23701 AVENUE 95",
      "City": "TERRA BELLA",
      "Zip Code": " 93270",
      "County": " TULARE",
      "Latitude": "35.9621900  ",
      "Longitude": " -119.04163 "
   },
   {
      "Vendor": "FIRST STEP NUTRITION #13",
      "Address": "W 300 INYO AVE",
      "City": "TULARE",
      "Zip Code": " 93274",
      "County": " TULARE",
      "Latitude": "36.2047150  ",
      "Longitude": " -119.35190 "
   },
   {
      "Vendor": "NAGI'S MARKET",
      "Address": "E 592 CLAY AVE",
      "City": "EARLIMART",
      "Zip Code": " 93219",
      "County": " TULARE",
      "Latitude": "35.8833380  ",
      "Longitude": " -119.27058 "
   },
   {
      "Vendor": "SMART & FINAL #791",
      "Address": "S 3424 MOONEY BLVD",
      "City": "VISALIA",
      "Zip Code": " 93277",
      "County": " TULARE",
      "Latitude": "36.3000620  ",
      "Longitude": " -119.31363 "
   },
   {
      "Vendor": "MY BABY FOOD STORE 2",
      "Address": "S 1010 MAIN ST",
      "Second Address": " STE B",
      "City": "PIXLEY",
      "Zip Code": " 93256",
      "County": " TULARE",
      "Latitude": "35.9649760  ",
      "Longitude": " -119.29192 "
   },
   {
      "Vendor": "A & Z NUTRITION",
      "Address": "W 1314 WALNUT AVE",
      "City": "VISALIA",
      "Zip Code": " 93277",
      "County": " TULARE",
      "Latitude": "36.3129230  ",
      "Longitude": " -119.30551 "
   },
   {
      "Vendor": "VISALIA AMIGO MARKET",
      "Address": " 30980 CAMP DR",
      "City": "VISALIA",
      "Zip Code": " 93291",
      "County": " TULARE",
      "Latitude": "36.3520680  ",
      "Longitude": " -119.42045 "
   },
   {
      "Vendor": "HLTHY FAMLY NUTRITION PRTRV",
      "Address": " 600 PROSPECT AVE",
      "Second Address": "  SUITE K",
      "City": "PORTERVILLE",
      "Zip Code": " 93257",
      "County": " TULARE",
      "Latitude": "36.0772680  ",
      "Longitude": " -119.04299 "
   },
   {
      "Vendor": "START HEALTHY NUTRITION",
      "Address": "E 497 CENTER AVE",
      "Second Address": " STE B",
      "City": "EARLIMART",
      "Zip Code": " 93219",
      "County": " TULARE",
      "Latitude": "35.8853020  ",
      "Longitude": " -119.27153 "
   },
   {
      "Vendor": "KIDS NUTRICARE",
      "Address": "W 260 OLIVE AVE",
      "Second Address": "  SUITE D",
      "City": "PORTERVILLE",
      "Zip Code": " 93257",
      "County": " TULARE",
      "Latitude": "36.0654850  ",
      "Longitude": " -119.02264 "
   },
   {
      "Vendor": "KIDS NUTRICARE",
      "Address": "S 160 FARMERSVILLE BLVD",
      "Second Address": "  SUITE B",
      "City": "FARMERSVILLE",
      "Zip Code": " 93223",
      "County": " TULARE",
      "Latitude": "36.2970980  ",
      "Longitude": " -119.20685 "
   },
   {
      "Vendor": "NUTRIKIDS",
      "Address": "E 1368 BARDSLEY AVE",
      "City": "TULARE",
      "Zip Code": " 93274",
      "County": " TULARE",
      "Latitude": "36.1968830  ",
      "Longitude": " -119.32683 "
   },
   {
      "Vendor": "SAVE MART #008",
      "Address": "W 130 STOCKTON ST",
      "City": "SONORA",
      "Zip Code": " 95370",
      "County": " TUOLUMNE",
      "Latitude": "37.9833570  ",
      "Longitude": " -120.38423 "
   },
   {
      "Vendor": "SAVE MART #076",
      "Address": " 1045 MONO WAY",
      "City": "SONORA",
      "Zip Code": " 95370",
      "County": " TUOLUMNE",
      "Latitude": "37.9759010  ",
      "Longitude": " -120.36605 "
   },
   {
      "Vendor": "SAFEWAY #3127",
      "Address": " 1291 SANGUINETTI RD",
      "City": "SONORA",
      "Zip Code": " 95370",
      "County": " TUOLUMNE",
      "Latitude": "37.9735070  ",
      "Longitude": " -120.36250 "
   },
   {
      "Vendor": "TUOLUMNE MARKET",
      "Address": " 18352 TUOLUMNE RD",
      "City": "TUOLUMNE",
      "Zip Code": " 95379",
      "County": " TUOLUMNE",
      "Latitude": "37.9652400  ",
      "Longitude": " -120.23801 "
   },
   {
      "Vendor": "MAIN STREET MARKET #5",
      "Address": " 19000 MAIN ST",
      "City": "GROVELAND",
      "Zip Code": " 95321",
      "County": " TUOLUMNE",
      "Latitude": "37.8391330  ",
      "Longitude": " -120.22489 "
   },
   {
      "Vendor": "PRICECO FOODS",
      "Address": " 13765 MONO WAY",
      "City": "SONORA",
      "Zip Code": " 95370",
      "County": " TUOLUMNE",
      "Latitude": "37.9740630  ",
      "Longitude": " -120.34206 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2030",
      "Address": " 1101 SANGUINETTI RD",
      "City": "SONORA",
      "Zip Code": " 95370",
      "County": " TUOLUMNE",
      "Latitude": "37.9738860  ",
      "Longitude": " -120.36447 "
   },
   {
      "Vendor": "WAL-MART #3087",
      "Address": " 2701 SAVIERS RD",
      "City": "OXNARD",
      "Zip Code": " 93033",
      "County": " VENTURA",
      "Latitude": "34.1745540  ",
      "Longitude": " -119.17956 "
   },
   {
      "Vendor": "DAVIS FOOD CO-OP",
      "Address": " 620 G ST",
      "City": "DAVIS",
      "Zip Code": " 95616",
      "County": " YOLO",
      "Latitude": "38.5493260  ",
      "Longitude": " -121.73993 "
   },
   {
      "Vendor": "RALEY'S #448",
      "Address": "W 1601 CAPITOL AVE",
      "City": "WEST SACRAMENTO",
      "Zip Code": " 95691",
      "County": " YOLO",
      "Latitude": "38.5796780  ",
      "Longitude": " -121.52997 "
   },
   {
      "Vendor": "NUGGET MARKET #01",
      "Address": " 157 MAIN ST",
      "City": "WOODLAND",
      "Zip Code": " 95695",
      "County": " YOLO",
      "Latitude": "38.6781710  ",
      "Longitude": " -121.78044 "
   },
   {
      "Vendor": "NUGGET MARKET #02",
      "Address": " 409 MACE BLVD",
      "City": "DAVIS",
      "Zip Code": " 95616",
      "County": " YOLO",
      "Latitude": "38.5497550  ",
      "Longitude": " -121.69570 "
   },
   {
      "Vendor": "RALEY'S #206",
      "Address": "W 367 MAIN ST",
      "City": "WOODLAND",
      "Zip Code": " 95695",
      "County": " YOLO",
      "Latitude": "38.6765650  ",
      "Longitude": " -121.80101 "
   },
   {
      "Vendor": "TOWN & COUNTRY MARKET",
      "Address": "E 121 GRANT AVE",
      "City": "WINTERS",
      "Zip Code": " 95694",
      "County": " YOLO",
      "Latitude": "38.5278920  ",
      "Longitude": " -121.96541 "
   },
   {
      "Vendor": "SAFEWAY #1205",
      "Address": "W 1435 COVELL BLVD",
      "City": "DAVIS",
      "Zip Code": " 95616",
      "County": " YOLO",
      "Latitude": "38.5611430  ",
      "Longitude": " -121.76595 "
   },
   {
      "Vendor": "FOOD 4 LESS",
      "Address": " 451 PIONEER AVE",
      "City": "WOODLAND",
      "Zip Code": " 95776",
      "County": " YOLO",
      "Latitude": "38.6749590  ",
      "Longitude": " -121.74509 "
   },
   {
      "Vendor": "SAFEWAY #1561",
      "Address": " 2121 COWELL BLVD",
      "City": "DAVIS",
      "Zip Code": " 95616",
      "County": " YOLO",
      "Latitude": "38.5412310  ",
      "Longitude": " -121.72510 "
   },
   {
      "Vendor": "NUGGET MARKET OAKTREE PLAZA",
      "Address": "E 1414 COVELL BLVD",
      "City": "DAVIS",
      "Zip Code": " 95616",
      "County": " YOLO",
      "Latitude": "38.5612380  ",
      "Longitude": " -121.73306 "
   },
   {
      "Vendor": "ARTEAGAS STARLITE SUPER MARKET",
      "Address": " 940 SACRAMENTO AVE",
      "City": "WEST SACRAMENTO",
      "Zip Code": " 95605",
      "County": " YOLO",
      "Latitude": "38.5893780  ",
      "Longitude": " -121.52546 "
   },
   {
      "Vendor": "BEL AIR MARKET #526",
      "Address": "E 1885 GIBSON RD",
      "City": "WOODLAND",
      "Zip Code": " 95776",
      "County": " YOLO",
      "Latitude": "38.6637080  ",
      "Longitude": " -121.73981 "
   },
   {
      "Vendor": "NUGGET MARKET #06",
      "Address": " 2000 TOWN CENTER PLAZA",
      "City": "WEST SACRAMENTO",
      "Zip Code": " 95691",
      "County": " YOLO",
      "Latitude": "38.5507190  ",
      "Longitude": " -121.53544 "
   },
   {
      "Vendor": "SAVE MART #604",
      "Address": " 1900 ANDERSON RD",
      "City": "DAVIS",
      "Zip Code": " 95616",
      "County": " YOLO",
      "Latitude": "38.5597330  ",
      "Longitude": " -121.75782 "
   },
   {
      "Vendor": "LA SUPERIOR MERCADOS",
      "Address": "W 34 COURT ST",
      "City": "WOODLAND",
      "Zip Code": " 95695",
      "County": " YOLO",
      "Latitude": "38.6797150  ",
      "Longitude": " -121.78554 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #3652",
      "Address": " 755 RIVERPOINT CT",
      "City": "WEST SACRAMENTO",
      "Zip Code": " 95691",
      "County": " YOLO",
      "Latitude": "38.5875950  ",
      "Longitude": " -121.55018 "
   },
   {
      "Vendor": "TARGET STORE T-2455",
      "Address": " 4601 2ND ST",
      "City": "DAVIS",
      "Zip Code": " 95618",
      "County": " YOLO",
      "Latitude": "38.5536930  ",
      "Longitude": " -121.69796 "
   },
   {
      "Vendor": "NICKY'S MARKET",
      "Address": "W 3225 CAPITOL AVE",
      "City": "WEST SACRAMENTO",
      "Zip Code": " 95691",
      "County": " YOLO",
      "Latitude": "38.5789040  ",
      "Longitude": " -121.55474 "
   },
   {
      "Vendor": "TARGET STORE T-2408",
      "Address": " 2185 BRONZE STAR DR",
      "City": "WOODLAND",
      "Zip Code": " 95776",
      "County": " YOLO",
      "Latitude": "38.6702110  ",
      "Longitude": " -121.72405 "
   },
   {
      "Vendor": "TARGET STORE T-2268",
      "Address": " 2005 TOWN CENTER PLAZA",
      "City": "WEST SACRAMENTO",
      "Zip Code": " 95691",
      "County": " YOLO",
      "Latitude": "38.5494430  ",
      "Longitude": " -121.53632 "
   },
   {
      "Vendor": "WAL-MART #5606",
      "Address": "E 1250 GIBSON RD",
      "City": "WOODLAND",
      "Zip Code": " 95776",
      "County": " YOLO",
      "Latitude": "38.6613630  ",
      "Longitude": " -121.76437 "
   },
   {
      "Vendor": "WAL-MART #4127",
      "Address": " 215 CALIFORNIA ST",
      "City": "WOODLAND",
      "Zip Code": " 95695",
      "County": " YOLO",
      "Latitude": "38.6800480  ",
      "Longitude": " -121.78772 "
   },
   {
      "Vendor": "MERCADO LOCO",
      "Address": "W 3049 CAPITOL AVE",
      "City": "WEST SACRAMENTO",
      "Zip Code": " 95691",
      "County": " YOLO",
      "Latitude": "38.5791210  ",
      "Longitude": " -121.55087 "
   },
   {
      "Vendor": "BEALE COMMISSARY",
      "Address": " 17601 25TH STREET, DET 414",
      "City": "BEALE AFB",
      "Zip Code": " 95903",
      "County": " YUBA",
      "Latitude": "39.1177850  ",
      "Longitude": " -121.39223 "
   },
   {
      "Vendor": "BIG AL'S MARKET",
      "Address": " 422 MAIN ST",
      "City": "WHEATLAND",
      "Zip Code": " 95692",
      "County": " YUBA",
      "Latitude": "39.0098210  ",
      "Longitude": " -121.42217 "
   },
   {
      "Vendor": "GOLD EAGLE MARKET #2",
      "Address": " 11269 LOMA RICA RD",
      "City": "LOMA RICA",
      "Zip Code": " 95901",
      "County": " YUBA",
      "Latitude": "39.3067550  ",
      "Longitude": " -121.42646 "
   },
   {
      "Vendor": "FOOD MAXX #472",
      "Address": " 6000 LINDHURST AVE",
      "City": "MARYSVILLE",
      "Zip Code": " 95901",
      "County": " YUBA",
      "Latitude": "39.1225240  ",
      "Longitude": " -121.57118 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5136",
      "Address": "N 1131 BEALE RD",
      "City": "MARYSVILLE",
      "Zip Code": " 95901",
      "County": " YUBA",
      "Latitude": "39.1258050  ",
      "Longitude": " -121.57518 "
   },
   {
      "Vendor": "SAVE MART #610",
      "Address": " 828 J ST",
      "City": "MARYSVILLE",
      "Zip Code": " 95901",
      "County": " YUBA",
      "Latitude": "39.1421510  ",
      "Longitude": " -121.59843 "
   },
   {
      "Vendor": "FARMER'S MARKETPLACE",
      "Address": " 1912 COVILLAUD ST",
      "City": "MARYSVILLE",
      "Zip Code": " 95901",
      "County": " YUBA",
      "Latitude": "39.1573210  ",
      "Longitude": " -121.57816 "
   },
   {
      "Vendor": "CLOVERLEAF MARKET",
      "Address": " 5780 FEATHER RIVER BLVD",
      "City": "OLIVEHURST",
      "Zip Code": " 95961",
      "County": " YUBA",
      "Latitude": "39.1204490  ",
      "Longitude": " -121.58147 "
   },
   {
      "Vendor": "EATWELL NUTRITION",
      "Address": " 1113 YUBA ST",
      "City": "MARYSVILLE",
      "Zip Code": " 95901",
      "County": " YUBA",
      "Latitude": "39.1481760  ",
      "Longitude": " -121.58362 "
   },
   {
      "Vendor": "BABY NUTRITIONAL CENTER",
      "Address": " 24602 RAYMOND WAY",
      "Second Address": " STE B",
      "City": "LAKE FOREST",
      "Zip Code": " 92630",
      "County": " ORANGE",
      "Latitude": "33.6212220  ",
      "Longitude": " -117.70165 "
   },
   {
      "Vendor": "TARGET STORE T-1383",
      "Address": "W 1893 MALVERN AVE",
      "City": "FULLERTON",
      "Zip Code": " 92833",
      "County": " ORANGE",
      "Latitude": "33.8775220  ",
      "Longitude": " -117.96265 "
   },
   {
      "Vendor": "TARGET STORE T-0229",
      "Address": " 6835 KATELLA AVE",
      "City": "CYPRESS",
      "Zip Code": " 90630",
      "County": " ORANGE",
      "Latitude": "33.8031610  ",
      "Longitude": " -118.01332 "
   },
   {
      "Vendor": "TARGET STORE T-2482",
      "Address": "E 855 BIRCH ST",
      "City": "BREA",
      "Zip Code": " 92821",
      "County": " ORANGE",
      "Latitude": "33.9180640  ",
      "Longitude": " -117.88738 "
   },
   {
      "Vendor": "TARGET STORE T-1293",
      "Address": " 3030 HARBOR BLVD",
      "Second Address": " STE A",
      "City": "COSTA MESA",
      "Zip Code": " 92626",
      "County": " ORANGE",
      "Latitude": "33.6826190  ",
      "Longitude": " -117.91788 "
   },
   {
      "Vendor": "TARGET STORE T-1238",
      "Address": " 13200 JAMBOREE RD",
      "City": "IRVINE",
      "Zip Code": " 92602",
      "County": " ORANGE",
      "Latitude": "33.7291180  ",
      "Longitude": " -117.78791 "
   },
   {
      "Vendor": "MOM & ME NUTRITION",
      "Address": "W 2327 EDINGER AVE",
      "Second Address": " STE A",
      "City": "SANTA ANA",
      "Zip Code": " 92704",
      "County": " ORANGE",
      "Latitude": "33.7275540  ",
      "Longitude": " -117.90080 "
   },
   {
      "Vendor": "TARGET STORE T-2421",
      "Address": "S 101 EUCLID ST",
      "City": "ANAHEIM",
      "Zip Code": " 92802",
      "County": " ORANGE",
      "Latitude": "33.8324340  ",
      "Longitude": " -117.94179 "
   },
   {
      "Vendor": "TARGET STORE T-0249",
      "Address": " 16400 BEACH BLVD",
      "City": "WESTMINSTER",
      "Zip Code": " 92683",
      "County": " ORANGE",
      "Latitude": "33.7254920  ",
      "Longitude": " -117.98889 "
   },
   {
      "Vendor": "TARGET STORE T-2397",
      "Address": "W 1000 IMPERIAL HWY",
      "City": "LA HABRA",
      "Zip Code": " 90631",
      "County": " ORANGE",
      "Latitude": "33.9170350  ",
      "Longitude": " -117.95732 "
   },
   {
      "Vendor": "TARGET STORE T-0230",
      "Address": "N 2191 TUSTIN ST",
      "City": "ORANGE",
      "Zip Code": " 92865",
      "County": " ORANGE",
      "Latitude": "33.8241080  ",
      "Longitude": " -117.83583 "
   },
   {
      "Vendor": "CARNICERIA MERCADO CALIMEX",
      "Address": "W 2930 LINCOLN AVE",
      "City": "ANAHEIM",
      "Zip Code": " 92801",
      "County": " ORANGE",
      "Latitude": "33.8320280  ",
      "Longitude": " -117.99057 "
   },
   {
      "Vendor": "EL SUPER #30",
      "Address": "S 1221 ANAHEIM BLVD",
      "City": "ANAHEIM",
      "Zip Code": " 92805",
      "County": " ORANGE",
      "Latitude": "33.8165940  ",
      "Longitude": " -117.90853 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#220",
      "Address": "N 911 EUCLID AVE",
      "City": "ANAHEIM",
      "Zip Code": " 92801",
      "County": " ORANGE",
      "Latitude": "33.8447750  ",
      "Longitude": " -117.94165 "
   },
   {
      "Vendor": "TARGET STORE T-2304",
      "Address": " 200 WESTMINSTER MALL",
      "City": "WESTMINSTER",
      "Zip Code": " 92683",
      "County": " ORANGE",
      "Latitude": "33.7453650  ",
      "Longitude": " -118.01234 "
   },
   {
      "Vendor": "TARGET STORE T-1328",
      "Address": " 12300 SEAL BEACH BLVD",
      "City": "SEAL BEACH",
      "Zip Code": " 90740",
      "County": " ORANGE",
      "Latitude": "33.7830760  ",
      "Longitude": " -118.06981 "
   },
   {
      "Vendor": "TARGET STORE T-2151",
      "Address": " 2300 PARK AVE",
      "City": "TUSTIN",
      "Zip Code": " 92782",
      "County": " ORANGE",
      "Latitude": "33.7003160  ",
      "Longitude": " -117.82746 "
   },
   {
      "Vendor": "TARGET STORE T-2082",
      "Address": " 7530 ORANGETHORPE AVE",
      "City": "BUENA PARK",
      "Zip Code": " 90621",
      "County": " ORANGE",
      "Latitude": "33.8586930  ",
      "Longitude": " -118.00118 "
   },
   {
      "Vendor": "BABY BONG SUA MARKET",
      "Address": " 10252 WESTMINSTER AVE",
      "City": "GARDEN GROVE",
      "Zip Code": " 92843",
      "County": " ORANGE",
      "Latitude": "33.7595250  ",
      "Longitude": " -117.95103 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #3248",
      "Address": "S 1340 BEACH BLVD",
      "City": "LA HABRA",
      "Zip Code": " 90631",
      "County": " ORANGE",
      "Latitude": "33.9164090  ",
      "Longitude": " -117.96825 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2517",
      "Address": "W 3600 MCFADDEN AVE",
      "City": "SANTA ANA",
      "Zip Code": " 92704",
      "County": " ORANGE",
      "Latitude": "33.7380450  ",
      "Longitude": " -117.91566 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2242",
      "Address": "N 440 EUCLID ST",
      "City": "ANAHEIM",
      "Zip Code": " 92801",
      "County": " ORANGE",
      "Latitude": "33.8373430  ",
      "Longitude": " -117.94126 "
   },
   {
      "Vendor": "VONS #2513",
      "Address": "E 185 17TH ST",
      "City": "COSTA MESA",
      "Zip Code": " 92627",
      "County": " ORANGE",
      "Latitude": "33.6360840  ",
      "Longitude": " -117.91971 "
   },
   {
      "Vendor": "MERCADO EL REY LAKE FOREST",
      "Address": " 23532 EL TORO RD",
      "Second Address": " STE 19",
      "City": "LAKE FOREST",
      "Zip Code": " 92630",
      "County": " ORANGE",
      "Latitude": "33.6208950  ",
      "Longitude": " -117.69873 "
   },
   {
      "Vendor": "WAL-MART STORE #5032",
      "Address": " 8450 LA PALMA AVE",
      "City": "BUENA PARK",
      "Zip Code": " 90620",
      "County": " ORANGE",
      "Latitude": "33.8449420  ",
      "Longitude": " -117.98613 "
   },
   {
      "Vendor": "EL SUPER #23",
      "Address": "S 2445 BRISTOL ST",
      "City": "SANTA ANA",
      "Zip Code": " 92704",
      "County": " ORANGE",
      "Latitude": "33.7137710  ",
      "Longitude": " -117.88515 "
   },
   {
      "Vendor": "PAVILIONS #3005",
      "Address": "W 3100 BALBOA BLVD",
      "City": "NEWPORT BEACH",
      "Zip Code": " 92663",
      "County": " ORANGE",
      "Latitude": "33.6144430  ",
      "Longitude": " -117.93226 "
   },
   {
      "Vendor": "TARGET STORE T-0336",
      "Address": " 3750 BARRANCA PKWY",
      "City": "IRVINE",
      "Zip Code": " 92606",
      "County": " ORANGE",
      "Latitude": "33.6847350  ",
      "Longitude": " -117.81138 "
   },
   {
      "Vendor": "TARGET STORE T-2128",
      "Address": " 115 FORTUNE DR",
      "City": "IRVINE",
      "Zip Code": " 92628",
      "County": " ORANGE",
      "Latitude": "33.6532180  ",
      "Longitude": " -117.74488 "
   },
   {
      "Vendor": "TARGET STORE T-0300",
      "Address": " 24500 ALICIA PKWY",
      "City": "MISSION VIEJO",
      "Zip Code": " 92691",
      "County": " ORANGE",
      "Latitude": "33.6067550  ",
      "Longitude": " -117.68947 "
   },
   {
      "Vendor": "TARGET STORE T-2163",
      "Address": " 25601 JERONIMO RD",
      "City": "MISSION VIEJO",
      "Zip Code": " 92691",
      "County": " ORANGE",
      "Latitude": "33.6224680  ",
      "Longitude": " -117.68412 "
   },
   {
      "Vendor": "TARGET STORE T-0286",
      "Address": "E 1330 17TH ST",
      "City": "SANTA ANA",
      "Zip Code": " 92705",
      "County": " ORANGE",
      "Latitude": "33.7597280  ",
      "Longitude": " -117.85100 "
   },
   {
      "Vendor": "TARGET STORE T-0914",
      "Address": " 30602 SANTA MARGARITA PKWY",
      "City": "RANCHO SANTA MARGAR.",
      "Zip Code": " 92688",
      "County": " ORANGE",
      "Latitude": "33.6432630  ",
      "Longitude": " -117.59678 "
   },
   {
      "Vendor": "TARGET STORE T-0677",
      "Address": "E 8148 SANTA ANA CANYON RD",
      "City": "ANAHEIM",
      "Zip Code": " 92805",
      "County": " ORANGE",
      "Latitude": "33.8684080  ",
      "Longitude": " -117.74882 "
   },
   {
      "Vendor": "TARGET STORE T-1418",
      "Address": "W 200 ORANGETHORPE AVE",
      "City": "FULLERTON",
      "Zip Code": " 92832",
      "County": " ORANGE",
      "Latitude": "33.8582440  ",
      "Longitude": " -117.92694 "
   },
   {
      "Vendor": "TARGET STORE T-2051",
      "Address": " 9882 ADAMS AVE",
      "City": "HUNTINGTON BEACH",
      "Zip Code": " 92646",
      "County": " ORANGE",
      "Latitude": "33.6720930  ",
      "Longitude": " -117.95583 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5930",
      "Address": "E 88 ORANGETHORPE AVE",
      "City": "ANAHEIM",
      "Zip Code": " 92801",
      "County": " ORANGE",
      "Latitude": "33.8592930  ",
      "Longitude": " -117.91848 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #37",
      "Address": "W 2394 LINCOLN AVE",
      "City": "ANAHEIM",
      "Zip Code": " 92801",
      "County": " ORANGE",
      "Latitude": "33.8313570  ",
      "Longitude": " -117.96705 "
   },
   {
      "Vendor": "TARGET STORE T-0193",
      "Address": " 13831 BROOKHURST ST",
      "City": "GARDEN GROVE",
      "Zip Code": " 92843",
      "County": " ORANGE",
      "Latitude": "33.7612470  ",
      "Longitude": " -117.95523 "
   },
   {
      "Vendor": "TARGET STORE T-0250",
      "Address": "S 33000 BRISTOL ST",
      "City": "SANTA ANA",
      "Zip Code": " 92704",
      "County": " ORANGE",
      "Latitude": "33.6946190  ",
      "Longitude": " -117.88574 "
   },
   {
      "Vendor": "ALBERTSONS #802",
      "Address": " 16600 BOLSA CHICA ST",
      "City": "HUNTINGTON BEACH",
      "Zip Code": " 92649",
      "County": " ORANGE",
      "Latitude": "33.7215050  ",
      "Longitude": " -118.04076 "
   },
   {
      "Vendor": "ALBERTSONS #1105",
      "Address": " 8880 VALLEY VIEW ST",
      "City": "BUENA PARK",
      "Zip Code": " 90620",
      "County": " ORANGE",
      "Latitude": "33.8336780  ",
      "Longitude": " -118.02711 "
   },
   {
      "Vendor": "ALBERTSONS #110",
      "Address": " 7201 YORKTOWN AVE",
      "City": "HUNTINGTON BEACH",
      "Zip Code": " 92648",
      "County": " ORANGE",
      "Latitude": "33.6792980  ",
      "Longitude": " -118.00365 "
   },
   {
      "Vendor": "ALBERTSONS #819",
      "Address": "N 1930 PLACENTA AVE",
      "City": "FULLERTON",
      "Zip Code": " 92835",
      "County": " ORANGE",
      "Latitude": "33.9037670  ",
      "Longitude": " -117.87245 "
   },
   {
      "Vendor": "ALBERTSONS #724",
      "Address": " 19640 BEACH BLVD",
      "City": "HUNTINGTON BEACH",
      "Zip Code": " 92648",
      "County": " ORANGE",
      "Latitude": "33.6770040  ",
      "Longitude": " -117.98852 "
   },
   {
      "Vendor": "ALBERTSONS #2141",
      "Address": "E 2500 IMPERIAL HWY",
      "Second Address": " STE 158",
      "City": "BREA",
      "Zip Code": " 92821",
      "County": " ORANGE",
      "Latitude": "33.9104980  ",
      "Longitude": " -117.87069 "
   },
   {
      "Vendor": "ALBERTSONS #4145",
      "Address": " 6755 WESTMINSTER BLVD",
      "City": "WESTMINSTER",
      "Zip Code": " 92683",
      "County": " ORANGE",
      "Latitude": "33.7613500  ",
      "Longitude": " -118.00932 "
   },
   {
      "Vendor": "ALBERTSONS #1157",
      "Address": " 16061 BROOKHURST ST",
      "City": "FOUNTAIN VALLEY",
      "Zip Code": " 92708",
      "County": " ORANGE",
      "Latitude": "33.7294180  ",
      "Longitude": " -117.95471 "
   },
   {
      "Vendor": "ALBERTSONS #158",
      "Address": "W 1800 WHITTIER BLVD",
      "City": "LA HABRA",
      "Zip Code": " 90631",
      "County": " ORANGE",
      "Latitude": "33.9388840  ",
      "Longitude": " -117.96625 "
   },
   {
      "Vendor": "ALBERTSONS #1165",
      "Address": "W 2291 MALVERN AVE",
      "City": "FULLERTON",
      "Zip Code": " 92833",
      "County": " ORANGE",
      "Latitude": "33.8778380  ",
      "Longitude": " -117.96622 "
   },
   {
      "Vendor": "ALBERTSONS #170",
      "Address": " 18579 BROOKHURST ST",
      "City": "FOUNTAIN VALLEY",
      "Zip Code": " 92708",
      "County": " ORANGE",
      "Latitude": "33.6929570  ",
      "Longitude": " -117.95424 "
   },
   {
      "Vendor": "ALBERTSONS #194",
      "Address": "S 810 STATE COLLEGE BLVD",
      "City": "ANAHEIM",
      "Zip Code": " 92806",
      "County": " ORANGE",
      "Latitude": "33.8312660  ",
      "Longitude": " -117.88856 "
   },
   {
      "Vendor": "ALBERTSONS #597",
      "Address": " 4541 CAMPUS DR",
      "City": "IRVINE",
      "Zip Code": " 92612",
      "County": " ORANGE",
      "Latitude": "33.6497530  ",
      "Longitude": " -117.83165 "
   },
   {
      "Vendor": "ALBERTSONS #208",
      "Address": " 30241 GOLDEN LANTERN",
      "City": "LAGUNA NIGUEL",
      "Zip Code": " 92677",
      "County": " ORANGE",
      "Latitude": "33.5239960  ",
      "Longitude": " -117.68738 "
   },
   {
      "Vendor": "ALBERTSONS #2509",
      "Address": " 804 AVENIDA PICO",
      "City": "SAN CLEMENTE",
      "Zip Code": " 92672",
      "County": " ORANGE",
      "Latitude": "33.4427660  ",
      "Longitude": " -117.61414 "
   },
   {
      "Vendor": "ALBERTSONS #825",
      "Address": " 3931 IRVINE BLVD",
      "City": "IRVINE",
      "Zip Code": " 92602",
      "County": " ORANGE",
      "Latitude": "33.7221010  ",
      "Longitude": " -117.77182 "
   },
   {
      "Vendor": "ALBERTSONS #3526",
      "Address": " 24251 MUIRLANDS BLVD",
      "City": "LAKE FOREST",
      "Zip Code": " 92630",
      "County": " ORANGE",
      "Latitude": "33.6301970  ",
      "Longitude": " -117.70646 "
   },
   {
      "Vendor": "ALBERTSONS #527",
      "Address": " 6601 QUAIL HILL PKWY",
      "City": "IRVINE",
      "Zip Code": " 92603",
      "County": " ORANGE",
      "Latitude": "33.6536860  ",
      "Longitude": " -117.77943 "
   },
   {
      "Vendor": "ALBERTSONS #532",
      "Address": " 2300 HARBOR BLVD",
      "Second Address": " STE C",
      "City": "COSTA MESA",
      "Zip Code": " 92626",
      "County": " ORANGE",
      "Latitude": "33.6576310  ",
      "Longitude": " -117.91905 "
   },
   {
      "Vendor": "ALBERTSONS #3534",
      "Address": "N 940 TUSTIN AVE",
      "City": "ORANGE",
      "Zip Code": " 92867",
      "County": " ORANGE",
      "Latitude": "33.8335000  ",
      "Longitude": " -117.83610 "
   },
   {
      "Vendor": "ALBERTSONS #2549",
      "Address": " 23072 ALICIA PKWY",
      "City": "MISSION VIEJO",
      "Zip Code": " 92692",
      "County": " ORANGE",
      "Latitude": "33.6278650  ",
      "Longitude": " -117.63541 "
   },
   {
      "Vendor": "ALBERTSONS #2551",
      "Address": "E 8440 CHAPMAN AVE",
      "City": "ORANGE",
      "Zip Code": " 92869",
      "County": " ORANGE",
      "Latitude": "33.7921040  ",
      "Longitude": " -117.76308 "
   },
   {
      "Vendor": "ALBERTSONS #552",
      "Address": " 27702 CROWN VALLEY PKWY",
      "Second Address": " STE B",
      "City": "LADERA RANCH",
      "Zip Code": " 92694",
      "County": " ORANGE",
      "Latitude": "33.5639990  ",
      "Longitude": " -117.64613 "
   },
   {
      "Vendor": "ALBERTSONS #2556",
      "Address": " 29941 ALICIA PKWY",
      "City": "LAGUNA NIGUEL",
      "Zip Code": " 92677",
      "County": " ORANGE",
      "Latitude": "33.5280830  ",
      "Longitude": " -117.71752 "
   },
   {
      "Vendor": "ALBERTSONS #2558",
      "Address": " 33601 DEL OBISPO",
      "City": "DANA POINT",
      "Zip Code": " 92629",
      "County": " ORANGE",
      "Latitude": "33.4751080  ",
      "Longitude": " -117.68497 "
   },
   {
      "Vendor": "ALBERTSONS #4563",
      "Address": " 989 AVENIDA PICO",
      "City": "SAN CLEMENTE",
      "Zip Code": " 92673",
      "County": " ORANGE",
      "Latitude": "33.4542460  ",
      "Longitude": " -117.60463 "
   },
   {
      "Vendor": "ALBERTSONS #3574",
      "Address": " 13270 NEWPORT AVE",
      "City": "TUSTIN",
      "Zip Code": " 92780",
      "County": " ORANGE",
      "Latitude": "33.7458150  ",
      "Longitude": " -117.81275 "
   },
   {
      "Vendor": "ALBERTSONS #1585",
      "Address": "E 4550 CHAPMAN AVE",
      "City": "ORANGE",
      "Zip Code": " 92869",
      "County": " ORANGE",
      "Latitude": "33.7869610  ",
      "Longitude": " -117.80419 "
   },
   {
      "Vendor": "ALBERTSONS #2591",
      "Address": " 14201 JEFFREY RD",
      "City": "IRVINE",
      "Zip Code": " 92620",
      "County": " ORANGE",
      "Latitude": "33.6952750  ",
      "Longitude": " -117.76535 "
   },
   {
      "Vendor": "ALBERTSONS #3596",
      "Address": " 3825 ALTON PKWY",
      "City": "IRVINE",
      "Zip Code": " 92606",
      "County": " ORANGE",
      "Latitude": "33.6821180  ",
      "Longitude": " -117.81358 "
   },
   {
      "Vendor": "ALBERTSONS #598",
      "Address": "E 2000 17TH ST",
      "City": "SANTA ANA",
      "Zip Code": " 92705",
      "County": " ORANGE",
      "Latitude": "33.7588990  ",
      "Longitude": " -117.83832 "
   },
   {
      "Vendor": "EL SUPER #42",
      "Address": " 12891 HARBOR BLVD",
      "City": "GARDEN GROVE",
      "Zip Code": " 92840",
      "County": " ORANGE",
      "Latitude": "33.7774620  ",
      "Longitude": " -117.91826 "
   },
   {
      "Vendor": "MOMMY'S NUTRITIONAL CENTER",
      "Address": "S 141 HARBOR BLVD",
      "City": "LA HABRA",
      "Zip Code": " 90631",
      "County": " ORANGE",
      "Latitude": "33.9314440  ",
      "Longitude": " -117.93325 "
   },
   {
      "Vendor": "BUY LOW MARKET #6",
      "Address": "N 1086 STATE COLLEGE BLVD",
      "City": "ANAHEIM",
      "Zip Code": " 92806",
      "County": " ORANGE",
      "Latitude": "33.8486300  ",
      "Longitude": " -117.88893 "
   },
   {
      "Vendor": "WAL-MART #5644",
      "Address": " 16555 VON KARMAN AVE",
      "Second Address": " STE 2",
      "City": "IRVINE",
      "Zip Code": " 92606",
      "County": " ORANGE",
      "Latitude": "33.6979670  ",
      "Longitude": " -117.83423 "
   },
   {
      "Vendor": "WAL-MART #2546",
      "Address": "N 2300 TUSTIN ST",
      "City": "ORANGE",
      "Zip Code": " 92865",
      "County": " ORANGE",
      "Latitude": "33.8286390  ",
      "Longitude": " -117.83559 "
   },
   {
      "Vendor": "WAL-MART #5601",
      "Address": " 21132 BEACH BLVD",
      "City": "HUNTINGTON BEACH",
      "Zip Code": " 92648",
      "County": " ORANGE",
      "Latitude": "33.6554230  ",
      "Longitude": " -117.98762 "
   },
   {
      "Vendor": "WAL-MART #5639",
      "Address": " 10912 KATELLA AVE",
      "City": "GARDEN GROVE",
      "Zip Code": " 92840",
      "County": " ORANGE",
      "Latitude": "33.8028780  ",
      "Longitude": " -117.95861 "
   },
   {
      "Vendor": "WAL-MART #5687",
      "Address": " 71 TECHNOLOGY DR",
      "City": "IRVINE",
      "Zip Code": " 92618",
      "County": " ORANGE",
      "Latitude": "33.6578100  ",
      "Longitude": " -117.74046 "
   },
   {
      "Vendor": "WAL-MART #5640",
      "Address": "S 1120 ANAHEIM BLVD",
      "City": "ANAHEIM",
      "Zip Code": " 92805",
      "County": " ORANGE",
      "Latitude": "33.8194430  ",
      "Longitude": " -117.90825 "
   },
   {
      "Vendor": "WAL-MART #4134",
      "Address": " 12840 BEACH BLVD",
      "City": "STANTON",
      "Zip Code": " 90680",
      "County": " ORANGE",
      "Latitude": "33.7749830  ",
      "Longitude": " -117.99148 "
   },
   {
      "Vendor": "WAL-MART #2218",
      "Address": " 26502 TOWNE CENTRE DR",
      "City": "FOOTHILL RANCH",
      "Zip Code": " 92610",
      "County": " ORANGE",
      "Latitude": "33.6805630  ",
      "Longitude": " -117.66846 "
   },
   {
      "Vendor": "WAL-MART #5641",
      "Address": "E 1000 IMPERIAL HWY",
      "City": "LA HABRA",
      "Zip Code": " 90631",
      "County": " ORANGE",
      "Latitude": "33.9171130  ",
      "Longitude": " -117.93511 "
   },
   {
      "Vendor": "WAL-MART NBRHD MARKET #3101",
      "Address": "N 121 BEACH BLVD",
      "City": "ANAHEIM",
      "Zip Code": " 92801",
      "County": " ORANGE",
      "Latitude": "33.8332390  ",
      "Longitude": " -117.99499 "
   },
   {
      "Vendor": "WAL-MART #3099",
      "Address": " 5420 LA PALMA AVE",
      "City": "LA PALMA",
      "Zip Code": " 90623",
      "County": " ORANGE",
      "Latitude": "33.8460830  ",
      "Longitude": " -118.03842 "
   },
   {
      "Vendor": "WAL-MART #5600",
      "Address": " 30491 AVENIDA DE LA FLORES",
      "City": "RANCHO SANTA MARGARI",
      "Zip Code": " 92688",
      "County": " ORANGE",
      "Latitude": "33.6407360  ",
      "Longitude": " -117.60122 "
   },
   {
      "Vendor": "WAL-MART #2523",
      "Address": "E 2595 IMPERIAL HWY",
      "City": "BREA",
      "Zip Code": " 92821",
      "County": " ORANGE",
      "Latitude": "33.9113240  ",
      "Longitude": " -117.86391 "
   },
   {
      "Vendor": "WAL-MART #2495",
      "Address": " 13331 BEACH BLVD",
      "City": "WESTMINSTER",
      "Zip Code": " 92683",
      "County": " ORANGE",
      "Latitude": "33.7681780  ",
      "Longitude": " -117.99114 "
   },
   {
      "Vendor": "SMART & FINAL #592",
      "Address": " 8956 WARNER WAY",
      "City": "FOUNTAIN VALLEY",
      "Zip Code": " 92708",
      "County": " ORANGE",
      "Latitude": "33.7157280  ",
      "Longitude": " -117.97268 "
   },
   {
      "Vendor": "WAL-MART STORE #4171",
      "Address": " 11822 GILBERT ST",
      "City": "GARDEN GROVE",
      "Zip Code": " 92841",
      "County": " ORANGE",
      "Latitude": "33.7908450  ",
      "Longitude": " -117.96727 "
   },
   {
      "Vendor": "WAL-MART STORE #2636",
      "Address": " 8230 TALBERT AVE",
      "City": "HUNTINGTON BEACH",
      "Zip Code": " 92646",
      "County": " ORANGE",
      "Latitude": "33.7009610  ",
      "Longitude": " -117.98618 "
   },
   {
      "Vendor": "GLASSELL NUTRITION",
      "Address": "N 1190 GLASSELL ST",
      "Second Address": " STE B",
      "City": "ORANGE",
      "Zip Code": " 92867",
      "County": " ORANGE",
      "Latitude": "33.8079280  ",
      "Longitude": " -117.85336 "
   },
   {
      "Vendor": "EL CHARRITO MEAT MARKET",
      "Address": "S 1459 MAIN ST",
      "City": "SANTA ANA",
      "Zip Code": " 92707",
      "County": " ORANGE",
      "Latitude": "33.7283240  ",
      "Longitude": " -117.86779 "
   },
   {
      "Vendor": "MERCADO EL REY #4",
      "Address": " 32252 CAMINO CAPISTRANO",
      "City": "SAN JUAN CAPISTRANO",
      "Zip Code": " 92675",
      "County": " ORANGE",
      "Latitude": "33.4942500  ",
      "Longitude": " -117.66209 "
   },
   {
      "Vendor": "NORTH SOUTH MARKET",
      "Address": " 32091 ALIPAZ ST",
      "City": "SAN JUAN CAPISTRANO",
      "Zip Code": " 92675",
      "County": " ORANGE",
      "Latitude": "33.4966420  ",
      "Longitude": " -117.66751 "
   },
   {
      "Vendor": "LA SABROSA MARKET",
      "Address": "E 4004 CHAPMAN AVE",
      "Second Address": " STE A",
      "City": "ORANGE",
      "Zip Code": " 92869",
      "County": " ORANGE",
      "Latitude": "33.7873890  ",
      "Longitude": " -117.81111 "
   },
   {
      "Vendor": "HEALTH NUTRITION PRODUCTS",
      "Address": "E 2123 BALL RD",
      "City": "ANAHEIM",
      "Zip Code": " 92806",
      "County": " ORANGE",
      "Latitude": "33.8183000  ",
      "Longitude": " -117.88634 "
   },
   {
      "Vendor": "CALIMEX MARKET",
      "Address": "N 318 BROOKHURST ST",
      "City": "ANAHEIM",
      "Zip Code": " 92801",
      "County": " ORANGE",
      "Latitude": "33.8362660  ",
      "Longitude": " -117.95879 "
   },
   {
      "Vendor": "TARGET STORE T-0192",
      "Address": " 12100 HARBOR BLVD",
      "City": "GARDEN GROVE",
      "Zip Code": " 92840",
      "County": " ORANGE",
      "Latitude": "33.7878230  ",
      "Longitude": " -117.91459 "
   },
   {
      "Vendor": "TARGET STORE T-0293",
      "Address": " 2920 YORBA LINDA BLVD",
      "City": "FULLERTON",
      "Zip Code": " 92831",
      "County": " ORANGE",
      "Latitude": "33.8887950  ",
      "Longitude": " -117.87789 "
   },
   {
      "Vendor": "TARGET STORE T-0913",
      "Address": " 26762 PORTOLA PKWY",
      "City": "FOOTHILL RANCH",
      "Zip Code": " 92610",
      "County": " ORANGE",
      "Latitude": "33.6764470  ",
      "Longitude": " -117.66428 "
   },
   {
      "Vendor": "TARGET STORE T-2730",
      "Address": " 990 AVENIDA VIS. HERMOSA",
      "City": "SAN CLEMENTE",
      "Zip Code": " 92673",
      "County": " ORANGE",
      "Latitude": "33.4625980  ",
      "Longitude": " -117.60692 "
   },
   {
      "Vendor": "COMERCIAL NUTRITION MEXICAN",
      "Address": "W 210 1ST ST",
      "Second Address": " STE 112",
      "City": "SANTA ANA",
      "Zip Code": " 92701",
      "County": " ORANGE",
      "Latitude": "33.7447210  ",
      "Longitude": " -117.86918 "
   },
   {
      "Vendor": "SMART & FINAL #580",
      "Address": "W 1308 EDINGER AVE",
      "City": "SANTA ANA",
      "Zip Code": " 92704",
      "County": " ORANGE",
      "Latitude": "33.7262160  ",
      "Longitude": " -117.88572 "
   },
   {
      "Vendor": "GUADALAJARA MEAT MARKET",
      "Address": "W 2950 BALL RD",
      "City": "ANAHEIM",
      "Zip Code": " 92804",
      "County": " ORANGE",
      "Latitude": "33.8168610  ",
      "Longitude": " -117.99148 "
   },
   {
      "Vendor": "SMART & FINAL #726",
      "Address": " 1114 IRVINE BLVD",
      "City": "TUSTIN",
      "Zip Code": " 92780",
      "County": " ORANGE",
      "Latitude": "33.7469880  ",
      "Longitude": " -117.80929 "
   },
   {
      "Vendor": "SMART & FINAL #713",
      "Address": " 26911 TRABUCO RD",
      "City": "MISSION VIEJO",
      "Zip Code": " 92691",
      "County": " ORANGE",
      "Latitude": "33.6221910  ",
      "Longitude": " -117.66028 "
   },
   {
      "Vendor": "SMART & FINAL #737",
      "Address": " 26560 MOULTON PKWY",
      "City": "LAGUNA HILLS",
      "Zip Code": " 92653",
      "County": " ORANGE",
      "Latitude": "33.5764770  ",
      "Longitude": " -117.70231 "
   },
   {
      "Vendor": "R & D EL MERCADITO",
      "Address": "W 1400 MCFADDEN AVE",
      "Second Address": " STE 3",
      "City": "SANTA ANA",
      "Zip Code": " 92704",
      "County": " ORANGE",
      "Latitude": "33.7341400  ",
      "Longitude": " -117.88702 "
   },
   {
      "Vendor": "LA BODEGA RANCH MARKET",
      "Address": "N 1700 PLACENTIA AVE",
      "City": "FULLERTON",
      "Zip Code": " 92831",
      "County": " ORANGE",
      "Latitude": "33.8878100  ",
      "Longitude": " -117.87460 "
   },
   {
      "Vendor": "SMART & FINAL #927",
      "Address": " 3049 COAST HWY",
      "City": "CORONA DEL MAR",
      "Zip Code": " 92625",
      "County": " ORANGE",
      "Latitude": "33.5979430  ",
      "Longitude": " -117.87212 "
   },
   {
      "Vendor": "MISHA'S NUTRITION AND WATER",
      "Address": "W 1721 KATELLA AVE",
      "Second Address": " STE I",
      "City": "ANAHEIM",
      "Zip Code": " 92804",
      "County": " ORANGE",
      "Latitude": "33.8041170  ",
      "Longitude": " -117.94208 "
   },
   {
      "Vendor": "SMART & FINAL #926",
      "Address": " 21672 PLANO TRABUCO RD",
      "City": "TRABUCO CANYON",
      "Zip Code": " 92679",
      "County": " ORANGE",
      "Latitude": "33.6477980  ",
      "Longitude": " -117.57743 "
   },
   {
      "Vendor": "SMART & FINAL #943",
      "Address": " 30252 CROWN VALLEY PKWY",
      "City": "LAGUNA NIGUEL",
      "Zip Code": " 92677",
      "County": " ORANGE",
      "Latitude": "33.5228750  ",
      "Longitude": " -117.71418 "
   },
   {
      "Vendor": "SMART & FINAL #925",
      "Address": " 21500 YORBA LINDA BLVD",
      "City": "YORBA LINDA",
      "Zip Code": " 92887",
      "County": " ORANGE",
      "Latitude": "33.8770920  ",
      "Longitude": " -117.75378 "
   },
   {
      "Vendor": "BABIES NUTRITION",
      "Address": "W 2960 LINCOLN AVE",
      "Second Address": " STE I",
      "City": "ANAHEIM",
      "Zip Code": " 92801",
      "County": " ORANGE",
      "Latitude": "33.8314640  ",
      "Longitude": " -117.99223 "
   },
   {
      "Vendor": "DOLLAR MART PLUS",
      "Address": "W 841 1/2 19TH ST",
      "City": "COSTA MESA",
      "Zip Code": " 92627",
      "County": " ORANGE",
      "Latitude": "33.6433270  ",
      "Longitude": " -117.93376 "
   },
   {
      "Vendor": "NORTHGATE MARKET #40",
      "Address": "E 2030 LINCOLN AVE",
      "City": "ANAHEIM",
      "Zip Code": " 92806",
      "County": " ORANGE",
      "Latitude": "33.8396550  ",
      "Longitude": " -117.88760 "
   },
   {
      "Vendor": "SUPER KING MARKET #7",
      "Address": "W 2741 MACARTHUR BLVD",
      "City": "SANTA ANA",
      "Zip Code": " 92704",
      "County": " ORANGE",
      "Latitude": "33.7009310  ",
      "Longitude": " -117.90635 "
   },
   {
      "Vendor": "5W FOOD MARKET",
      "Address": "S 500 KNOTT AVE",
      "City": "ANAHEIM",
      "Zip Code": " 92804",
      "County": " ORANGE",
      "Latitude": "33.8254260  ",
      "Longitude": " -118.01039 "
   },
   {
      "Vendor": "EZ BABY MEAT MARKET",
      "Address": "S 1320 MAGNOLIA AVE",
      "City": "ANAHEIM",
      "Zip Code": " 92804",
      "County": " ORANGE",
      "Latitude": "33.8136750  ",
      "Longitude": " -117.97559 "
   },
   {
      "Vendor": "5W BABY MARKET",
      "Address": "S 1212 BRISTOL ST",
      "Second Address": " STE 22",
      "City": "SANTA ANA",
      "Zip Code": " 92704",
      "County": " ORANGE",
      "Latitude": "33.7320080  ",
      "Longitude": " -117.88611 "
   },
   {
      "Vendor": "BABY NUTRITION #4",
      "Address": "W 628 CHAPMAN AVE",
      "City": "PLACENTIA",
      "Zip Code": " 92870",
      "County": " ORANGE",
      "Latitude": "33.8732200  ",
      "Longitude": " -117.87672 "
   },
   {
      "Vendor": "NORTHGATE MARKET #02",
      "Address": "W 1305 WHITTIER BLVD",
      "City": "LA HABRA",
      "Zip Code": " 90631",
      "County": " ORANGE",
      "Latitude": "33.9400430  ",
      "Longitude": " -117.96016 "
   },
   {
      "Vendor": "KIDS NUTRITION R US",
      "Address": " 14120 BEACH BLVD",
      "City": "WESTMINSTER",
      "Zip Code": " 92683",
      "County": " ORANGE",
      "Latitude": "33.7570830  ",
      "Longitude": " -117.98892 "
   },
   {
      "Vendor": "THANH LONG QUALITY FOOD",
      "Address": " 12471 WESTMINSTER AVE",
      "City": "SANTA ANA",
      "Zip Code": " 92703",
      "County": " ORANGE",
      "Latitude": "33.7602270  ",
      "Longitude": " -117.91193 "
   },
   {
      "Vendor": "PAVILIONS #2412",
      "Address": " 3901 PORTOLA PKWY",
      "City": "IRVINE",
      "Zip Code": " 92602",
      "County": " ORANGE",
      "Latitude": "33.7341500  ",
      "Longitude": " -117.76049 "
   },
   {
      "Vendor": "SMART & FINAL #788",
      "Address": " 10870 KATELLA AVE",
      "Second Address": " STE G",
      "City": "GARDEN GROVE",
      "Zip Code": " 92840",
      "County": " ORANGE",
      "Latitude": "33.8030160  ",
      "Longitude": " -117.97262 "
   },
   {
      "Vendor": "NUNO BROTHERS MARKET",
      "Address": "S 1206 STANDARD AVE",
      "City": "SANTA ANA",
      "Zip Code": " 92707",
      "County": " ORANGE",
      "Latitude": "33.7331690  ",
      "Longitude": " -117.85638 "
   },
   {
      "Vendor": "EL MERCADO NEGRO",
      "Address": "W 919 ST ANDREW PL",
      "City": "SANTA ANA",
      "Zip Code": " 92707",
      "County": " ORANGE",
      "Latitude": "33.7226990  ",
      "Longitude": " -117.87744 "
   },
   {
      "Vendor": "STATER BROS. MARKETS #198",
      "Address": " 15150 KENSINGTON PARK DR",
      "City": "TUSTIN",
      "Zip Code": " 92782",
      "County": " ORANGE",
      "Latitude": "33.7141900  ",
      "Longitude": " -117.81619 "
   },
   {
      "Vendor": "NOVY RANCH MARKET",
      "Address": "E 701 4TH ST",
      "City": "SANTA ANA",
      "Zip Code": " 92701",
      "County": " ORANGE",
      "Latitude": "33.7483560  ",
      "Longitude": " -117.86111 "
   },
   {
      "Vendor": "CERRITOS NUTRITION",
      "Address": " 7514 CERRITOS AVE",
      "City": "STANTON",
      "Zip Code": " 90680",
      "County": " ORANGE",
      "Latitude": "33.8098820  ",
      "Longitude": " -118.00160 "
   },
   {
      "Vendor": "LA TIENDITA EXPRESS",
      "Address": " 24882 MUIRLANDS BLVD",
      "City": "LAKE FOREST",
      "Zip Code": " 92630",
      "County": " ORANGE",
      "Latitude": "33.6221350  ",
      "Longitude": " -117.69641 "
   },
   {
      "Vendor": "MAMA NUTRITION MARKET",
      "Address": "W 786 19TH ST",
      "City": "COSTA MESA",
      "Zip Code": " 92627",
      "County": " ORANGE",
      "Latitude": "33.6435660  ",
      "Longitude": " -117.93138 "
   },
   {
      "Vendor": "HAPPY BEBE MARKET",
      "Address": "W 135 BALL RD",
      "Second Address": " STE F",
      "City": "ANAHEIM",
      "Zip Code": " 92805",
      "County": " ORANGE",
      "Latitude": "33.8184450  ",
      "Longitude": " -117.91009 "
   },
   {
      "Vendor": "MOM'S NUTRITION",
      "Address": " 8897 WESTMINSTER AVE",
      "City": "GARDEN GROVE",
      "Zip Code": " 92844",
      "County": " ORANGE",
      "Latitude": "33.7596950  ",
      "Longitude": " -117.97415 "
   },
   {
      "Vendor": "LA BAMBA #2",
      "Address": "N 1601 MAIN ST",
      "City": "SANTA ANA",
      "Zip Code": " 92701",
      "County": " ORANGE",
      "Latitude": "33.7591380  ",
      "Longitude": " -117.86724 "
   },
   {
      "Vendor": "BABY NUTRITION",
      "Address": "W 130 LA HABRA BLVD",
      "City": "LA HABRA",
      "Zip Code": " 90631",
      "County": " ORANGE",
      "Latitude": "33.9316660  ",
      "Longitude": " -117.94669 "
   },
   {
      "Vendor": "OC MOM & BABY NUTRITION CENTER",
      "Address": "S 327 MAGNOLIA AVE",
      "City": "ANAHEIM",
      "Zip Code": " 92804",
      "County": " ORANGE",
      "Latitude": "33.8281780  ",
      "Longitude": " -117.97615 "
   },
   {
      "Vendor": "FRESH CHOICE MARKETPLACE",
      "Address": " 9922 KATELLA AVE",
      "City": "GARDEN GROVE",
      "Zip Code": " 92804",
      "County": " ORANGE",
      "Latitude": "33.8028120  ",
      "Longitude": " -117.97342 "
   },
   {
      "Vendor": "GONZALEZ VALENCIA MARKETS",
      "Address": "W 2230 VALENCIA DR",
      "City": "FULLERTON",
      "Zip Code": " 92833",
      "County": " ORANGE",
      "Latitude": "33.8662620  ",
      "Longitude": " -117.96779 "
   },
   {
      "Vendor": "STATER BROS. #001",
      "Address": " 9225 MAGNOLIA AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92503",
      "County": " RIVERSIDE",
      "Latitude": "33.9238600  ",
      "Longitude": " -117.44202 "
   },
   {
      "Vendor": "RALPHS #609",
      "Address": " 5225 CANYON CREST DR",
      "City": "RIVERSIDE",
      "Zip Code": " 92507",
      "County": " RIVERSIDE",
      "Latitude": "33.9553240  ",
      "Longitude": " -117.33006 "
   },
   {
      "Vendor": "STATER BROS. #086",
      "Address": "E 1661 6TH ST",
      "City": "BEAUMONT",
      "Zip Code": " 92223",
      "County": " RIVERSIDE",
      "Latitude": "33.9284180  ",
      "Longitude": " -116.94965 "
   },
   {
      "Vendor": "STATER BROS. #071",
      "Address": " 1155 CALIMESA BLVD",
      "City": "CALIMESA",
      "Zip Code": " 92320",
      "County": " RIVERSIDE",
      "Latitude": "33.9958060  ",
      "Longitude": " -117.05700 "
   },
   {
      "Vendor": "STATER BROS. #062",
      "Address": " 1288 BORDER AVE",
      "City": "CORONA",
      "Zip Code": " 92882",
      "County": " RIVERSIDE",
      "Latitude": "33.8693570  ",
      "Longitude": " -117.59419 "
   },
   {
      "Vendor": "STATER BROS. #084",
      "Address": " 13200 PALM DR",
      "City": "DESERT HOT SPRINGS",
      "Zip Code": " 92240",
      "County": " RIVERSIDE",
      "Latitude": "33.9525490  ",
      "Longitude": " -116.50063 "
   },
   {
      "Vendor": "STATER BROS. #069",
      "Address": " 9155 JURUPA RD",
      "City": "GLEN AVON",
      "Zip Code": " 92509",
      "County": " RIVERSIDE",
      "Latitude": "33.9986320  ",
      "Longitude": " -117.48278 "
   },
   {
      "Vendor": "STATER BROS. #075",
      "Address": " 41849 FLORIDA AVE",
      "City": "HEMET",
      "Zip Code": " 92543",
      "County": " RIVERSIDE",
      "Latitude": "33.7472520  ",
      "Longitude": " -116.98897 "
   },
   {
      "Vendor": "STATER BROS. #046",
      "Address": "E 210 STETSON AVE",
      "City": "HEMET",
      "Zip Code": " 92543",
      "County": " RIVERSIDE",
      "Latitude": "33.7311090  ",
      "Longitude": " -116.96998 "
   },
   {
      "Vendor": "STATER BROS. #022",
      "Address": " 4680 LA SIERRA AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92505",
      "County": " RIVERSIDE",
      "Latitude": "33.9161910  ",
      "Longitude": " -117.48763 "
   },
   {
      "Vendor": "STATER BROS. #044",
      "Address": " 2790 HAMNER AVE",
      "City": "NORCO",
      "Zip Code": " 92860",
      "County": " RIVERSIDE",
      "Latitude": "33.9227850  ",
      "Longitude": " -117.56003 "
   },
   {
      "Vendor": "STATER BROS. #042",
      "Address": " 6160 ARLINGTON AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92504",
      "County": " RIVERSIDE",
      "Latitude": "33.9448710  ",
      "Longitude": " -117.43628 "
   },
   {
      "Vendor": "STATER BROS. #079",
      "Address": " 10370 ARLINGTON AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92505",
      "County": " RIVERSIDE",
      "Latitude": "33.9459440  ",
      "Longitude": " -117.47927 "
   },
   {
      "Vendor": "STATER BROS. #090",
      "Address": " 7770 LIMONITE AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92509",
      "County": " RIVERSIDE",
      "Latitude": "33.9769810  ",
      "Longitude": " -117.45199 "
   },
   {
      "Vendor": "STATER BROS. #014",
      "Address": " 5571 MISSION BLVD",
      "City": "RUBIDOUX",
      "Zip Code": " 92509",
      "County": " RIVERSIDE",
      "Latitude": "33.9977790  ",
      "Longitude": " -117.40454 "
   },
   {
      "Vendor": "STATER BROS. #083",
      "Address": " 27160 SUN CITY BLVD",
      "City": "SUN CITY",
      "Zip Code": " 92586",
      "County": " RIVERSIDE",
      "Latitude": "33.7114290  ",
      "Longitude": " -117.19269 "
   },
   {
      "Vendor": "STATER BROS. #082",
      "Address": " 24931 SUNNYMEAD BLVD",
      "City": "MORENO VALLEY",
      "Zip Code": " 92553",
      "County": " RIVERSIDE",
      "Latitude": "33.9373810  ",
      "Longitude": " -117.22739 "
   },
   {
      "Vendor": "STATER BROS. #094",
      "Address": " 81056 US HIGHWAY 111",
      "City": "INDIO",
      "Zip Code": " 92201",
      "County": " RIVERSIDE",
      "Latitude": "33.7085120  ",
      "Longitude": " -116.25045 "
   },
   {
      "Vendor": "STATER BROS. #080",
      "Address": " 17050 VAN BUREN BLVD",
      "City": "RIVERSIDE",
      "Zip Code": " 92504",
      "County": " RIVERSIDE",
      "Latitude": "33.8837510  ",
      "Longitude": " -117.36534 "
   },
   {
      "Vendor": "STATER BROS. #088",
      "Address": " 11070 LIMONITE AVE",
      "City": "MIRA LOMA",
      "Zip Code": " 91752",
      "County": " RIVERSIDE",
      "Latitude": "33.9747430  ",
      "Longitude": " -117.52465 "
   },
   {
      "Vendor": "VONS #2386",
      "Address": " 27220 SUN CITY BLVD",
      "City": "SUN CITY",
      "Zip Code": " 92586",
      "County": " RIVERSIDE",
      "Latitude": "33.7131180  ",
      "Longitude": " -117.19301 "
   },
   {
      "Vendor": "VONS #2175",
      "Address": " 78-271 HWY 111",
      "City": "LA QUINTA",
      "Zip Code": " 92253",
      "County": " RIVERSIDE",
      "Latitude": "33.7159950  ",
      "Longitude": " -116.29804 "
   },
   {
      "Vendor": "VONS #2384",
      "Address": "E 4733 PALM CANYON DR",
      "City": "PALM SPRINGS",
      "Zip Code": " 92264",
      "County": " RIVERSIDE",
      "Latitude": "33.7919530  ",
      "Longitude": " -116.49459 "
   },
   {
      "Vendor": "VONS #2177",
      "Address": " 14200 PALM DR",
      "City": "DESERT HOT SPRINGS",
      "Zip Code": " 92240",
      "County": " RIVERSIDE",
      "Latitude": "33.9459860  ",
      "Longitude": " -116.49964 "
   },
   {
      "Vendor": "STATER BROS. #103",
      "Address": " 1193 MAGNOLIA AVE",
      "City": "CORONA",
      "Zip Code": " 92879",
      "County": " RIVERSIDE",
      "Latitude": "33.8653180  ",
      "Longitude": " -117.54637 "
   },
   {
      "Vendor": "MARCH COMMISSARY",
      "Address": " 15150 6TH ST",
      "Second Address": " BLDG 1000",
      "City": "RIVERSIDE",
      "Zip Code": " 92518",
      "County": " RIVERSIDE",
      "Latitude": "33.9046550  ",
      "Longitude": " -117.24676 "
   },
   {
      "Vendor": "STATER BROS. #113",
      "Address": "W 47 NUEVO RD",
      "City": "PERRIS",
      "Zip Code": " 92570",
      "County": " RIVERSIDE",
      "Latitude": "33.8003080  ",
      "Longitude": " -117.22695 "
   },
   {
      "Vendor": "STATER BROS. #115",
      "Address": " 3420 LA SIERRA AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92503",
      "County": " RIVERSIDE",
      "Latitude": "33.8977380  ",
      "Longitude": " -117.47356 "
   },
   {
      "Vendor": "FOOD 4 LESS #304",
      "Address": "N 109 MCKINLEY ST",
      "City": "CORONA",
      "Zip Code": " 92879",
      "County": " RIVERSIDE",
      "Latitude": "33.8832540  ",
      "Longitude": " -117.51382 "
   },
   {
      "Vendor": "STATER BROS. #114",
      "Address": " 2995 IOWA AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92507",
      "County": " RIVERSIDE",
      "Latitude": "33.9858280  ",
      "Longitude": " -117.34141 "
   },
   {
      "Vendor": "RALPHS #181",
      "Address": "E 1733 PALM CANYON DR",
      "City": "PALM SPRINGS",
      "Zip Code": " 92264",
      "County": " RIVERSIDE",
      "Latitude": "33.8001460  ",
      "Longitude": " -116.52615 "
   },
   {
      "Vendor": "FOOD 4 LESS #308",
      "Address": " 34251 DATE PALM DR",
      "City": "CATHEDRAL CITY",
      "Zip Code": " 92234",
      "County": " RIVERSIDE",
      "Latitude": "33.7994030  ",
      "Longitude": " -116.46047 "
   },
   {
      "Vendor": "RALPHS #136",
      "Address": " 2661 GREEN RIVER RD",
      "City": "CORONA",
      "Zip Code": " 92882",
      "County": " RIVERSIDE",
      "Latitude": "33.8714900  ",
      "Longitude": " -117.62229 "
   },
   {
      "Vendor": "STATER BROS. #111",
      "Address": " 25904 NEWPORT RD",
      "City": "SUN CITY",
      "Zip Code": " 92584",
      "County": " RIVERSIDE",
      "Latitude": "33.6866280  ",
      "Longitude": " -117.20668 "
   },
   {
      "Vendor": "STATER BROS. #119",
      "Address": " 43396 FLORIDA AVE",
      "City": "HEMET",
      "Zip Code": " 92544",
      "County": " RIVERSIDE",
      "Latitude": "33.7486370  ",
      "Longitude": " -116.90386 "
   },
   {
      "Vendor": "RALPHS #140",
      "Address": " 30125 ANTELOPE RD",
      "City": "MENIFEE",
      "Zip Code": " 92584",
      "County": " RIVERSIDE",
      "Latitude": "33.6842330  ",
      "Longitude": " -117.16859 "
   },
   {
      "Vendor": "FOOD 4 LESS #319",
      "Address": " 26419 YNEZ RD",
      "City": "TEMECULA",
      "Zip Code": " 92591",
      "County": " RIVERSIDE",
      "Latitude": "33.5224240  ",
      "Longitude": " -117.15979 "
   },
   {
      "Vendor": "RALPHS #144",
      "Address": " 6155 MAGNOLIA AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92506",
      "County": " RIVERSIDE",
      "Latitude": "33.9597090  ",
      "Longitude": " -117.39371 "
   },
   {
      "Vendor": "STATER BROS. #121",
      "Address": "S 1537 SAN JACINTO AVE",
      "City": "SAN JACINTO",
      "Zip Code": " 92583",
      "County": " RIVERSIDE",
      "Latitude": "33.7721690  ",
      "Longitude": " -116.95675 "
   },
   {
      "Vendor": "VONS #2381",
      "Address": " 535 MCKINLEY ST",
      "City": "CORONA",
      "Zip Code": " 92879",
      "County": " RIVERSIDE",
      "Latitude": "33.8909880  ",
      "Longitude": " -117.52157 "
   },
   {
      "Vendor": "RALPHS #027",
      "Address": " 74-884 COUNTRY CLUB DR",
      "City": "PALM DESERT",
      "Zip Code": " 92260",
      "County": " RIVERSIDE",
      "Latitude": "33.7594850  ",
      "Longitude": " -116.35785 "
   },
   {
      "Vendor": "FOOD 4 LESS #315",
      "Address": "N 1688 PERRIS BLVD",
      "Second Address": " BLDG E",
      "City": "PERRIS",
      "Zip Code": " 92571",
      "County": " RIVERSIDE",
      "Latitude": "33.8024860  ",
      "Longitude": " -117.22665 "
   },
   {
      "Vendor": "FOOD 4 LESS #343",
      "Address": " 4250 VAN BUREN BLVD",
      "City": "RIVERSIDE",
      "Zip Code": " 92503",
      "County": " RIVERSIDE",
      "Latitude": "33.9270480  ",
      "Longitude": " -117.45317 "
   },
   {
      "Vendor": "FOOD 4 LESS #386",
      "Address": "E 1691 6TH ST",
      "City": "BEAUMONT",
      "Zip Code": " 92223",
      "County": " RIVERSIDE",
      "Latitude": "33.9281710  ",
      "Longitude": " -116.94790 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#406",
      "Address": " 9415 MISSION BLVD",
      "Second Address": " STE G-H",
      "City": "RIVERSIDE",
      "Zip Code": " 92509",
      "County": " RIVERSIDE",
      "Latitude": "34.0121070  ",
      "Longitude": " -117.49042 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#410",
      "Address": "W 1307 SIXTH ST",
      "Second Address": " UNIT 130",
      "City": "CORONA",
      "Zip Code": " 92882",
      "County": " RIVERSIDE",
      "Latitude": "33.8792830  ",
      "Longitude": " -117.58938 "
   },
   {
      "Vendor": "MAXI FOODS #1",
      "Address": " 8616 CALIFORNIA AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92504",
      "County": " RIVERSIDE",
      "Latitude": "33.9353430  ",
      "Longitude": " -117.43498 "
   },
   {
      "Vendor": "FOOD 4 LESS #398",
      "Address": " 24440 ALESSANDRO BLVD",
      "City": "MORENO VALLEY",
      "Zip Code": " 92553",
      "County": " RIVERSIDE",
      "Latitude": "33.9177370  ",
      "Longitude": " -117.23621 "
   },
   {
      "Vendor": "STATER BROS. #127",
      "Address": " 69255 RAMON RD",
      "City": "CATHEDRAL CITY",
      "Zip Code": " 92234",
      "County": " RIVERSIDE",
      "Latitude": "33.8149580  ",
      "Longitude": " -116.45647 "
   },
   {
      "Vendor": "STATER BROS. #128",
      "Address": " 78-630 HIGHWAY 111",
      "City": "LA QUINTA",
      "Zip Code": " 92253",
      "County": " RIVERSIDE",
      "Latitude": "33.7155470  ",
      "Longitude": " -116.29302 "
   },
   {
      "Vendor": "STATER BROS. #138",
      "Address": " 31813 TEMECULA PKWY",
      "City": "TEMECULA",
      "Zip Code": " 92592",
      "County": " RIVERSIDE",
      "Latitude": "33.4783650  ",
      "Longitude": " -117.10149 "
   },
   {
      "Vendor": "STATER BROS. #139",
      "Address": " 25050 HANCOCK AVE",
      "City": "MURRIETA",
      "Zip Code": " 92562",
      "County": " RIVERSIDE",
      "Latitude": "33.5712570  ",
      "Longitude": " -117.18297 "
   },
   {
      "Vendor": "STATER BROS. #126",
      "Address": " 1717 VISTA CHINO",
      "City": "PALM SPRINGS",
      "Zip Code": " 92262",
      "County": " RIVERSIDE",
      "Latitude": "33.8448470  ",
      "Longitude": " -116.52591 "
   },
   {
      "Vendor": "FOOD 4 LESS #765",
      "Address": " 82124 HIGHWAY 111",
      "City": "INDIO",
      "Zip Code": " 92201",
      "County": " RIVERSIDE",
      "Latitude": "33.7075960  ",
      "Longitude": " -116.25118 "
   },
   {
      "Vendor": "RALPHS #681",
      "Address": " 42150 WASHINGTON ST",
      "City": "BERMUDA DUNES",
      "Zip Code": " 92203",
      "County": " RIVERSIDE",
      "Latitude": "33.7420860  ",
      "Longitude": " -116.30258 "
   },
   {
      "Vendor": "PEREZ MARKET",
      "Address": " 9790 JURUPA RD",
      "City": "RIVERSIDE",
      "Zip Code": " 92509",
      "County": " RIVERSIDE",
      "Latitude": "33.9941010  ",
      "Longitude": " -117.49658 "
   },
   {
      "Vendor": "VONS #1962",
      "Address": " 29530 RANCHO CALIFORNIA RD",
      "City": "TEMECULA",
      "Zip Code": " 92591",
      "County": " RIVERSIDE",
      "Latitude": "33.5051900  ",
      "Longitude": " -117.14776 "
   },
   {
      "Vendor": "RALPHS #686",
      "Address": " 33145 HIGHWAY 79  S",
      "City": "TEMECULA",
      "Zip Code": " 92592",
      "County": " RIVERSIDE",
      "Latitude": "33.4866040  ",
      "Longitude": " -117.07595 "
   },
   {
      "Vendor": "RALPHS #160",
      "Address": " 49908 JEFFERSON ST",
      "City": "INDIO",
      "Zip Code": " 92201",
      "County": " RIVERSIDE",
      "Latitude": "33.6871790  ",
      "Longitude": " -116.26751 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#433",
      "Address": " 7120 INDIANA AVE",
      "Second Address": " UNIT C",
      "City": "RIVERSIDE",
      "Zip Code": " 92504",
      "County": " RIVERSIDE",
      "Latitude": "33.9388830  ",
      "Longitude": " -117.39712 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#445",
      "Address": "E 2497 LAKESHORE DR",
      "Second Address": " UNIT C",
      "City": "LAKE ELSINORE",
      "Zip Code": " 92530",
      "County": " RIVERSIDE",
      "Latitude": "33.6591150  ",
      "Longitude": " -117.30258 "
   },
   {
      "Vendor": "VONS #2596",
      "Address": " 369 MAGNOLIA AVE",
      "City": "CORONA",
      "Zip Code": " 92879",
      "County": " RIVERSIDE",
      "Latitude": "33.8542870  ",
      "Longitude": " -117.56541 "
   },
   {
      "Vendor": "RALPHS #118",
      "Address": " 23801 WASHINGTON AVE",
      "City": "MURRIETA",
      "Zip Code": " 92562",
      "County": " RIVERSIDE",
      "Latitude": "33.5717790  ",
      "Longitude": " -117.23459 "
   },
   {
      "Vendor": "MAXI FOODS #2",
      "Address": " 4050 UNIVERSITY AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92501",
      "County": " RIVERSIDE",
      "Latitude": "33.9833760  ",
      "Longitude": " -117.37892 "
   },
   {
      "Vendor": "STATER BROS. #170",
      "Address": " 2243 EAGLE GLEN PKWY",
      "City": "CORONA",
      "Zip Code": " 92883",
      "County": " RIVERSIDE",
      "Latitude": "33.8228520  ",
      "Longitude": " -117.52297 "
   },
   {
      "Vendor": "RALPHS #611",
      "Address": "S 425 SUNRISE WAY",
      "Second Address": " STE A",
      "City": "PALM SPRINGS",
      "Zip Code": " 92262",
      "County": " RIVERSIDE",
      "Latitude": "33.8168250  ",
      "Longitude": " -116.52879 "
   },
   {
      "Vendor": "STATER BROS. #172",
      "Address": " 25900 IRIS AVE",
      "City": "MORENO VALLEY",
      "Zip Code": " 92551",
      "County": " RIVERSIDE",
      "Latitude": "33.8913700  ",
      "Longitude": " -117.20858 "
   },
   {
      "Vendor": "STATER BROS. #171",
      "Address": " 550 HIDDEN VALLEY PKWY",
      "City": "CORONA",
      "Zip Code": " 92879",
      "County": " RIVERSIDE",
      "Latitude": "33.8986070  ",
      "Longitude": " -117.55550 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1805",
      "Address": " 79295 US HIGHWAY 111",
      "City": "LA QUINTA",
      "Zip Code": " 92253",
      "County": " RIVERSIDE",
      "Latitude": "33.7072350  ",
      "Longitude": " -116.28069 "
   },
   {
      "Vendor": "LA FAMOSA MARKET#2",
      "Address": "W 650 LATHAM AVE",
      "City": "HEMET",
      "Zip Code": " 92544",
      "County": " RIVERSIDE",
      "Latitude": "33.7495620  ",
      "Longitude": " -116.97788 "
   },
   {
      "Vendor": "FOOD 4 LESS #302",
      "Address": " 12200 PERRIS BLVD",
      "City": "MORENO VALLEY",
      "Zip Code": " 92557",
      "County": " RIVERSIDE",
      "Latitude": "33.9436800  ",
      "Longitude": " -117.22455 "
   },
   {
      "Vendor": "STATER BROS. #173",
      "Address": " 1430 BEAUMONT AVE",
      "City": "BEAUMONT",
      "Zip Code": " 92223",
      "County": " RIVERSIDE",
      "Latitude": "33.9481860  ",
      "Longitude": " -116.97598 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1853",
      "Address": "S 1231 SANDERSON AVE",
      "City": "HEMET",
      "Zip Code": " 92545",
      "County": " RIVERSIDE",
      "Latitude": "33.7264500  ",
      "Longitude": " -117.01014 "
   },
   {
      "Vendor": "WINCO FOODS #56",
      "Address": " 40435 WINCHESTER RD",
      "City": "TEMECULA",
      "Zip Code": " 92591",
      "County": " RIVERSIDE",
      "Latitude": "33.5315390  ",
      "Longitude": " -117.15306 "
   },
   {
      "Vendor": "STATER BROS. #174",
      "Address": " 36010 HIDDEN SPRINGS RD",
      "City": "WILDOMAR",
      "Zip Code": " 92595",
      "County": " RIVERSIDE",
      "Latitude": "33.5972070  ",
      "Longitude": " -117.24776 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1832",
      "Address": "E 5601 RAMON RD",
      "City": "PALM SPRINGS",
      "Zip Code": " 92262",
      "County": " RIVERSIDE",
      "Latitude": "33.8153970  ",
      "Longitude": " -116.49335 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5156",
      "Address": "E 1540 2ND ST",
      "City": "BEAUMONT",
      "Zip Code": " 92223",
      "County": " RIVERSIDE",
      "Latitude": "33.9251380  ",
      "Longitude": " -116.95177 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #126",
      "Address": "W 1130 SIXTH ST",
      "City": "CORONA",
      "Zip Code": " 92882",
      "County": " RIVERSIDE",
      "Latitude": "33.8762570  ",
      "Longitude": " -117.58471 "
   },
   {
      "Vendor": "STATER BROS. #177",
      "Address": " 30712 BENTON RD",
      "City": "WINCHESTER",
      "Zip Code": " 92596",
      "County": " RIVERSIDE",
      "Latitude": "33.5923940  ",
      "Longitude": " -117.12235 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5096",
      "Address": " 34500 MONTEREY AVE",
      "City": "PALM DESERT",
      "Zip Code": " 92260",
      "County": " RIVERSIDE",
      "Latitude": "33.7979420  ",
      "Longitude": " -116.38783 "
   },
   {
      "Vendor": "FOOD 4 LESS #517",
      "Address": " 49-241 GRAPEFRUIT BLVD",
      "City": "COACHELLA",
      "Zip Code": " 92236",
      "County": " RIVERSIDE",
      "Latitude": "33.6900670  ",
      "Longitude": " -116.18527 "
   },
   {
      "Vendor": "RALPHS #045",
      "Address": " 12660 LIMONITE AVE",
      "City": "CORONA",
      "Zip Code": " 92880",
      "County": " RIVERSIDE",
      "Latitude": "33.9754000  ",
      "Longitude": " -117.55230 "
   },
   {
      "Vendor": "FOOD 4 LESS #329",
      "Address": " 3900 CHICAGO AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92507",
      "County": " RIVERSIDE",
      "Latitude": "33.9739050  ",
      "Longitude": " -117.34819 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #127",
      "Address": " 23857 SUNNYMEAD BLVD",
      "City": "MORENO VALLEY",
      "Zip Code": " 92553",
      "County": " RIVERSIDE",
      "Latitude": "33.9386780  ",
      "Longitude": " -117.24815 "
   },
   {
      "Vendor": "VONS #2659",
      "Address": " 3520 RIVERSIDE PLAZA",
      "City": "RIVERSIDE",
      "Zip Code": " 92506",
      "County": " RIVERSIDE",
      "Latitude": "33.9550200  ",
      "Longitude": " -117.38936 "
   },
   {
      "Vendor": "VONS #2688",
      "Address": " 6170 HAMNER AVE",
      "City": "MIRA LOMA",
      "Zip Code": " 91752",
      "County": " RIVERSIDE",
      "Latitude": "33.9765320  ",
      "Longitude": " -117.55715 "
   },
   {
      "Vendor": "VONS #2660",
      "Address": " 38995 SKY CANYON DR",
      "City": "MURRIETA",
      "Zip Code": " 92563",
      "County": " RIVERSIDE",
      "Latitude": "33.5543460  ",
      "Longitude": " -117.13874 "
   },
   {
      "Vendor": "RALPHS #098",
      "Address": " 3350 LA SIERRA AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92503",
      "County": " RIVERSIDE",
      "Latitude": "33.8955900  ",
      "Longitude": " -117.47136 "
   },
   {
      "Vendor": "STATER BROS. #180",
      "Address": "N 1271 STATE ST",
      "City": "SAN JACINTO",
      "Zip Code": " 92583",
      "County": " RIVERSIDE",
      "Latitude": "33.8042530  ",
      "Longitude": " -116.97068 "
   },
   {
      "Vendor": "WINCO FOODS #46",
      "Address": " 12880 DAY ST",
      "City": "MORENO VALLEY",
      "Zip Code": " 92553",
      "County": " RIVERSIDE",
      "Latitude": "33.9336760  ",
      "Longitude": " -117.27554 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#208",
      "Address": " 23591 SUNNYMEAD BLVD",
      "Second Address": " UNIT C",
      "City": "MORENO VALLEY",
      "Zip Code": " 92553",
      "County": " RIVERSIDE",
      "Latitude": "33.9389190  ",
      "Longitude": " -117.25093 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#210",
      "Address": " 2308 UNIVERSITY AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92507",
      "County": " RIVERSIDE",
      "Latitude": "33.9752890  ",
      "Longitude": " -117.35998 "
   },
   {
      "Vendor": "STATER BROS. #181",
      "Address": " 78210 VARNER RD",
      "City": "PALM DESERT",
      "Zip Code": " 92211",
      "County": " RIVERSIDE",
      "Latitude": "33.7624900  ",
      "Longitude": " -116.29949 "
   },
   {
      "Vendor": "WINCO FOODS #62",
      "Address": "N 3150 CASE RD",
      "City": "PERRIS",
      "Zip Code": " 92571",
      "County": " RIVERSIDE",
      "Latitude": "33.7444920  ",
      "Longitude": " -117.19113 "
   },
   {
      "Vendor": "STATER BROS. #183",
      "Address": " 67800 VISTA CHINO",
      "City": "CATHEDRAL CITY",
      "Zip Code": " 92234",
      "County": " RIVERSIDE",
      "Latitude": "33.8459040  ",
      "Longitude": " -116.47793 "
   },
   {
      "Vendor": "TARGET STORE T-2309",
      "Address": " 27100 EUCALYPTUS AVE",
      "City": "MORENO VALLEY",
      "Zip Code": " 92555",
      "County": " RIVERSIDE",
      "Latitude": "33.9380580  ",
      "Longitude": " -117.18978 "
   },
   {
      "Vendor": "JIMENEZ MARKET",
      "Address": " 5600 MISSION BLVD",
      "City": "RIVERSIDE",
      "Zip Code": " 92509",
      "County": " RIVERSIDE",
      "Latitude": "33.9969280  ",
      "Longitude": " -117.40760 "
   },
   {
      "Vendor": "WINCO FOODS #66",
      "Address": " 42600 JACKSON ST",
      "City": "INDIO",
      "Zip Code": " 92203",
      "County": " RIVERSIDE",
      "Latitude": "33.7394940  ",
      "Longitude": " -116.21385 "
   },
   {
      "Vendor": "VONS #2818",
      "Address": " 11800 DE PALMA RD",
      "City": "CORONA",
      "Zip Code": " 92883",
      "County": " RIVERSIDE",
      "Latitude": "33.7475470  ",
      "Longitude": " -117.45300 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5193",
      "Address": " 12721 MORENO BEACH DR",
      "City": "MORENO VALLEY",
      "Zip Code": " 92555",
      "County": " RIVERSIDE",
      "Latitude": "33.9357470  ",
      "Longitude": " -117.18196 "
   },
   {
      "Vendor": "STATER BROS. #185",
      "Address": " 14425 MORENO BEACH DR",
      "City": "MORENO VALLEY",
      "Zip Code": " 92555",
      "County": " RIVERSIDE",
      "Latitude": "33.9112470  ",
      "Longitude": " -117.17531 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5425",
      "Address": "S 1861 SAN JACINTO AVE",
      "City": "SAN JACINTO",
      "Zip Code": " 92583",
      "County": " RIVERSIDE",
      "Latitude": "33.7674840  ",
      "Longitude": " -116.95846 "
   },
   {
      "Vendor": "STATER BROS. #098",
      "Address": " 16750 LAKESHORE DR",
      "City": "LAKE ELSINORE",
      "Zip Code": " 92530",
      "County": " RIVERSIDE",
      "Latitude": "33.6868330  ",
      "Longitude": " -117.36803 "
   },
   {
      "Vendor": "LA FAVORITA SUPERMARKET",
      "Address": " 546 INDIAN HILLS CIR",
      "Second Address": " STE B",
      "City": "PERRIS",
      "Zip Code": " 92570",
      "County": " RIVERSIDE",
      "Latitude": "33.7814680  ",
      "Longitude": " -117.24488 "
   },
   {
      "Vendor": "SMART & FINAL #490",
      "Address": " 79770 HIGHWAY 111",
      "City": "LA QUINTA",
      "Zip Code": " 92253",
      "County": " RIVERSIDE",
      "Latitude": "33.7074220  ",
      "Longitude": " -116.27285 "
   },
   {
      "Vendor": "SMART & FINAL #443",
      "Address": "W 2525 FLORIDA AVE",
      "City": "HEMET",
      "Zip Code": " 92545",
      "County": " RIVERSIDE",
      "Latitude": "33.7458410  ",
      "Longitude": " -116.99830 "
   },
   {
      "Vendor": "SMART & FINAL #340",
      "Address": "N 760 MAIN ST",
      "City": "CORONA",
      "Zip Code": " 92880",
      "County": " RIVERSIDE",
      "Latitude": "33.8929550  ",
      "Longitude": " -117.56368 "
   },
   {
      "Vendor": "SMART & FINAL #521",
      "Address": " 2744 CANYON SPRINGS PKWY",
      "City": "RIVERSIDE",
      "Zip Code": " 92507",
      "County": " RIVERSIDE",
      "Latitude": "33.9405010  ",
      "Longitude": " -117.28145 "
   },
   {
      "Vendor": "SMART & FINAL #316",
      "Address": " 3310 VINE ST",
      "City": "RIVERSIDE",
      "Zip Code": " 92507",
      "County": " RIVERSIDE",
      "Latitude": "33.9835260  ",
      "Longitude": " -117.36500 "
   },
   {
      "Vendor": "SMART & FINAL #473",
      "Address": " 4039 TYLER ST",
      "City": "RIVERSIDE",
      "Zip Code": " 92503",
      "County": " RIVERSIDE",
      "Latitude": "33.9167180  ",
      "Longitude": " -117.46483 "
   },
   {
      "Vendor": "SMART & FINAL #331",
      "Address": "W 2971 RAMSEY ST",
      "City": "BANNING",
      "Zip Code": " 92220",
      "County": " RIVERSIDE",
      "Latitude": "33.9262910  ",
      "Longitude": " -116.90926 "
   },
   {
      "Vendor": "SMART & FINAL #469",
      "Address": " 25060 MADISON AVE",
      "City": "MURRIETA",
      "Zip Code": " 92562",
      "County": " RIVERSIDE",
      "Latitude": "33.5587710  ",
      "Longitude": " -117.20000 "
   },
   {
      "Vendor": "TARGET STORE T-2471",
      "Address": " 30340 HAUN RD",
      "City": "MENIFEE",
      "Zip Code": " 92584",
      "County": " RIVERSIDE",
      "Latitude": "33.6803240  ",
      "Longitude": " -117.17240 "
   },
   {
      "Vendor": "STATER BROS. #187",
      "Address": " 29995 CANYON HILLS RD",
      "City": "LAKE ELSINORE",
      "Zip Code": " 92532",
      "County": " RIVERSIDE",
      "Latitude": "33.6663240  ",
      "Longitude": " -117.26215 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2708",
      "Address": " 32225 HIGHWAY 79  S",
      "City": "TEMECULA",
      "Zip Code": " 92592",
      "County": " RIVERSIDE",
      "Latitude": "33.4866040  ",
      "Longitude": " -117.07595 "
   },
   {
      "Vendor": "WINCO FOODS #71",
      "Address": "W 4602 FLORIDA AVE",
      "City": "HEMET",
      "Zip Code": " 92545",
      "County": " RIVERSIDE",
      "Latitude": "33.7452970  ",
      "Longitude": " -117.02139 "
   },
   {
      "Vendor": "SMART & FINAL #429",
      "Address": " 5001 RAMON RD",
      "Second Address": " BLDG 4",
      "City": "PALM SPRINGS",
      "Zip Code": " 92264",
      "County": " RIVERSIDE",
      "Latitude": "33.8157420  ",
      "Longitude": " -116.49176 "
   },
   {
      "Vendor": "STOP-N-SHOP",
      "Address": "E 846 6TH ST",
      "Second Address": " STE E",
      "City": "BEAUMONT",
      "Zip Code": " 92223",
      "County": " RIVERSIDE",
      "Latitude": "33.9296710  ",
      "Longitude": " -116.97062 "
   },
   {
      "Vendor": "LOS ALTOS MEAT MARKET #2",
      "Address": "N 126 CARMALITA ST",
      "City": "HEMET",
      "Zip Code": " 92543",
      "County": " RIVERSIDE",
      "Latitude": "33.7482620  ",
      "Longitude": " -116.96917 "
   },
   {
      "Vendor": "LOS ALTOS MEAT MARKET #3",
      "Address": " 43880 FLORIDA AVE",
      "City": "HEMET",
      "Zip Code": " 92544",
      "County": " RIVERSIDE",
      "Latitude": "33.7481550  ",
      "Longitude": " -116.89531 "
   },
   {
      "Vendor": "EL SUPER #34",
      "Address": " 24899 ALESSANDRO BLVD",
      "City": "MORENO VALLEY",
      "Zip Code": " 92553",
      "County": " RIVERSIDE",
      "Latitude": "33.9161960  ",
      "Longitude": " -117.22755 "
   },
   {
      "Vendor": "TARGET STORE T-2499",
      "Address": " 27818 CLINTON KEITH RD",
      "City": "MURRIETA",
      "Zip Code": " 92562",
      "County": " RIVERSIDE",
      "Latitude": "33.5991150  ",
      "Longitude": " -117.17666 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#229",
      "Address": "W 3081 RAMSEY ST",
      "Second Address": " UNIT B",
      "City": "BANNING",
      "Zip Code": " 92220",
      "County": " RIVERSIDE",
      "Latitude": "33.9259400  ",
      "Longitude": " -116.91007 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2842",
      "Address": "E 1290 ONTARIO AVE",
      "City": "CORONA",
      "Zip Code": " 92881",
      "County": " RIVERSIDE",
      "Latitude": "33.8459830  ",
      "Longitude": " -117.54139 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1912",
      "Address": "N 479 MCKINLEY ST",
      "City": "CORONA",
      "Zip Code": " 92879",
      "County": " RIVERSIDE",
      "Latitude": "33.8897850  ",
      "Longitude": " -117.52031 "
   },
   {
      "Vendor": "CARNICERIA RANCHO GRANDE",
      "Address": " 68300 RAMON RD",
      "Second Address": " STE 3",
      "City": "CATHEDRAL CITY",
      "Zip Code": " 92234",
      "County": " RIVERSIDE",
      "Latitude": "33.8161930  ",
      "Longitude": " -116.46942 "
   },
   {
      "Vendor": "CARNICERIA RANCHO GRANDE #2",
      "Address": " 51508 HARRISON ST",
      "City": "COACHELLA",
      "Zip Code": " 92236",
      "County": " RIVERSIDE",
      "Latitude": "33.6744670  ",
      "Longitude": " -116.18122 "
   },
   {
      "Vendor": "CARNICERIA RANCHO GRANDE #3",
      "Address": " 13313 PALM DR",
      "Second Address": " STE F",
      "City": "DESERT HOT SPRINGS",
      "Zip Code": " 92240",
      "County": " RIVERSIDE",
      "Latitude": "33.9516180  ",
      "Longitude": " -116.50174 "
   },
   {
      "Vendor": "CARNICERIA LAS GLORIAS",
      "Address": " 13373 PERRIS BLVD",
      "Second Address": " STE D-304",
      "City": "MORENO VALLEY",
      "Zip Code": " 92553",
      "County": " RIVERSIDE",
      "Latitude": "33.9261370  ",
      "Longitude": " -117.22694 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#230",
      "Address": "N 199 STATE ST",
      "Second Address": " UNIT 106",
      "City": "HEMET",
      "Zip Code": " 92543",
      "County": " RIVERSIDE",
      "Latitude": "33.7490160  ",
      "Longitude": " -116.97224 "
   },
   {
      "Vendor": "TARGET STORE T-1867",
      "Address": " 78935 CA-111",
      "City": "LA QUINTA",
      "Zip Code": " 92253",
      "County": " RIVERSIDE",
      "Latitude": "33.7085570  ",
      "Longitude": " -116.29008 "
   },
   {
      "Vendor": "TARGET STORE T-0940",
      "Address": " 72549 CA-111",
      "City": "PALM DESERT",
      "Zip Code": " 92260",
      "County": " RIVERSIDE",
      "Latitude": "33.7250170  ",
      "Longitude": " -116.40064 "
   },
   {
      "Vendor": "TARGET STORE T-0736",
      "Address": " 1290 HAMMER AVE",
      "City": "NORCO",
      "Zip Code": " 92860",
      "County": " RIVERSIDE",
      "Latitude": "33.9007420  ",
      "Longitude": " -117.56451 "
   },
   {
      "Vendor": "TARGET STORE T-1961",
      "Address": " 12471 LIMONITE AVE",
      "City": "EASTVALE",
      "Zip Code": " 91752",
      "County": " RIVERSIDE",
      "Latitude": "33.9782060  ",
      "Longitude": " -117.55442 "
   },
   {
      "Vendor": "TARGET STORE T-1548",
      "Address": " 2615 TUSCANY ST",
      "City": "CORONA",
      "Zip Code": " 92881",
      "County": " RIVERSIDE",
      "Latitude": "33.8268580  ",
      "Longitude": " -117.51652 "
   },
   {
      "Vendor": "TARGET STORE T-0212",
      "Address": " 3520 TYLER AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92503",
      "County": " RIVERSIDE",
      "Latitude": "33.9467520  ",
      "Longitude": " -117.47778 "
   },
   {
      "Vendor": "TARGET STORE T-0359",
      "Address": " 29676 RANCHO CALIFORNIA RD",
      "City": "TEMECULA",
      "Zip Code": " 92881",
      "County": " RIVERSIDE",
      "Latitude": "33.5066700  ",
      "Longitude": " -117.14635 "
   },
   {
      "Vendor": "TARGET STORE T-1843",
      "Address": " 2755 CANYON SPRINGS PKWY",
      "City": "RIVERSIDE",
      "Zip Code": " 92507",
      "County": " RIVERSIDE",
      "Latitude": "33.9386070  ",
      "Longitude": " -117.28257 "
   },
   {
      "Vendor": "STATER BROS. #189",
      "Address": " 32281 MISSION TRAIL RD",
      "City": "LAKE ELSINORE",
      "Zip Code": " 92530",
      "County": " RIVERSIDE",
      "Latitude": "33.6532360  ",
      "Longitude": " -117.29771 "
   },
   {
      "Vendor": "MOTHER EARTH NUTRITION",
      "Address": " 91275 66TH AVE",
      "Second Address": " STE B",
      "City": "MECCA",
      "Zip Code": " 92254",
      "County": " RIVERSIDE",
      "Latitude": "33.5682430  ",
      "Longitude": " -116.07405 "
   },
   {
      "Vendor": "MOTHER EARTH NUTRITION",
      "Address": " 52669 HARRISON ST",
      "Second Address": " STE 207",
      "City": "COACHELLA",
      "Zip Code": " 92236",
      "County": " RIVERSIDE",
      "Latitude": "33.6659880  ",
      "Longitude": " -116.18171 "
   },
   {
      "Vendor": "MOTHER EARTH NUTRITION",
      "Address": "S 308 D ST",
      "City": "PERRIS",
      "Zip Code": " 92570",
      "County": " RIVERSIDE",
      "Latitude": "33.7831570  ",
      "Longitude": " -117.22877 "
   },
   {
      "Vendor": "ALBERTSONS #2514",
      "Address": " 8938 TRAUTWEIN RD",
      "City": "RIVERSIDE",
      "Zip Code": " 92508",
      "County": " RIVERSIDE",
      "Latitude": "33.8902240  ",
      "Longitude": " -117.32311 "
   },
   {
      "Vendor": "ALBERTSONS #567",
      "Address": " 42095 WASHINGTON ST",
      "City": "PALM DESERT",
      "Zip Code": " 92211",
      "County": " RIVERSIDE",
      "Latitude": "33.7427740  ",
      "Longitude": " -116.30534 "
   },
   {
      "Vendor": "ALBERTSONS #1569",
      "Address": "N 1751 SUNRISE WAY",
      "Second Address": " STE 1",
      "City": "PALM SPRINGS",
      "Zip Code": " 92262",
      "County": " RIVERSIDE",
      "Latitude": "33.8470680  ",
      "Longitude": " -116.52957 "
   },
   {
      "Vendor": "ALBERTSONS #2572",
      "Address": " 2975 VAN BUREN BLVD",
      "City": "RIVERSIDE",
      "Zip Code": " 92503",
      "County": " RIVERSIDE",
      "Latitude": "33.9098770  ",
      "Longitude": " -117.43627 "
   },
   {
      "Vendor": "ALBERTSONS #2586",
      "Address": " 40101 MONTEREY AVE",
      "City": "RANCHO MIRAGE",
      "Zip Code": " 92270",
      "County": " RIVERSIDE",
      "Latitude": "33.7562940  ",
      "Longitude": " -116.39264 "
   },
   {
      "Vendor": "ALBERTSONS #3587",
      "Address": "E 840 HOBSON WAY",
      "City": "BLYTHE",
      "Zip Code": " 92225",
      "County": " RIVERSIDE",
      "Latitude": "33.6095850  ",
      "Longitude": " -114.58718 "
   },
   {
      "Vendor": "ALBERTSONS #609",
      "Address": " 28047 SCOTT RD",
      "City": "MURRIETA",
      "Zip Code": " 92562",
      "County": " RIVERSIDE",
      "Latitude": "33.6396650  ",
      "Longitude": " -117.16953 "
   },
   {
      "Vendor": "ALBERTSONS #1641",
      "Address": " 7070 ARCHIBALD AVE",
      "City": "CORONA",
      "Zip Code": " 92880",
      "County": " RIVERSIDE",
      "Latitude": "33.9595370  ",
      "Longitude": " -117.59160 "
   },
   {
      "Vendor": "ALBERTSONS #4706",
      "Address": " 30530 RANCHO CALIFORNIA RD",
      "City": "TEMECULA",
      "Zip Code": " 92591",
      "County": " RIVERSIDE",
      "Latitude": "33.5100540  ",
      "Longitude": " -117.12721 "
   },
   {
      "Vendor": "ALBERTSONS #728",
      "Address": "W 260 FOOTHILL PKWY",
      "City": "CORONA",
      "Zip Code": " 92882",
      "County": " RIVERSIDE",
      "Latitude": "33.8434990  ",
      "Longitude": " -117.57439 "
   },
   {
      "Vendor": "ALBERTSONS #734",
      "Address": " 39140 WINCHESTER RD",
      "City": "MURRIETA",
      "Zip Code": " 92563",
      "County": " RIVERSIDE",
      "Latitude": "33.5510630  ",
      "Longitude": " -117.13892 "
   },
   {
      "Vendor": "ALBERTSONS #735",
      "Address": " 23893 CLINTON KEITH RD",
      "City": "WILDOMAR",
      "Zip Code": " 92595",
      "County": " RIVERSIDE",
      "Latitude": "33.5956690  ",
      "Longitude": " -117.24189 "
   },
   {
      "Vendor": "ALBERTSONS #2743",
      "Address": " 41000 CALIFORNIA OAKS RD",
      "City": "MURRIETA",
      "Zip Code": " 92562",
      "County": " RIVERSIDE",
      "Latitude": "33.5673840  ",
      "Longitude": " -117.20535 "
   },
   {
      "Vendor": "ALBERTSONS #753",
      "Address": " 31960 TEMECULA PKWY",
      "City": "TEMECULA",
      "Zip Code": " 92589",
      "County": " RIVERSIDE",
      "Latitude": "33.4807070  ",
      "Longitude": " -117.10022 "
   },
   {
      "Vendor": "ALBERTSONS #2796",
      "Address": "E 1260 ONTARIO AVE",
      "City": "CORONA",
      "Zip Code": " 92881",
      "County": " RIVERSIDE",
      "Latitude": "33.8465990  ",
      "Longitude": " -117.54238 "
   },
   {
      "Vendor": "ALBERTSONS #798",
      "Address": " 30901 RIVERSIDE DR",
      "City": "LAKE ELSINORE",
      "Zip Code": " 92530",
      "County": " RIVERSIDE",
      "Latitude": "33.6861930  ",
      "Longitude": " -117.36662 "
   },
   {
      "Vendor": "ALBERTSONS #3512",
      "Address": "S 300 HIGHLAND SPRINGS AVE",
      "Second Address": " STE 7",
      "City": "BANNING",
      "Zip Code": " 92220",
      "County": " RIVERSIDE",
      "Latitude": "33.9242300  ",
      "Longitude": " -116.94548 "
   },
   {
      "Vendor": "ALBERTSONS #3559",
      "Address": " 74590 HIGHWAY 111",
      "City": "PALM DESERT",
      "Zip Code": " 92260",
      "County": " RIVERSIDE",
      "Latitude": "33.7229780  ",
      "Longitude": " -116.36383 "
   },
   {
      "Vendor": "STATER BROS. #193",
      "Address": " 11875 PIGEON PASS RD",
      "Second Address": " STE A",
      "City": "MORENO VALLEY",
      "Zip Code": " 92557",
      "County": " RIVERSIDE",
      "Latitude": "33.9480370  ",
      "Longitude": " -117.26217 "
   },
   {
      "Vendor": "WAL-MART #1899",
      "Address": " 6250 VALLEY SPRINGS PKWY",
      "City": "RIVERSIDE",
      "Zip Code": " 92507",
      "County": " RIVERSIDE",
      "Latitude": "33.9426260  ",
      "Longitude": " -117.28793 "
   },
   {
      "Vendor": "WAL-MART #2826",
      "Address": " 83053 AVENUE 48",
      "City": "COACHELLA",
      "Zip Code": " 92236",
      "County": " RIVERSIDE",
      "Latitude": "33.6992310  ",
      "Longitude": " -116.21541 "
   },
   {
      "Vendor": "WAL-MART #3026",
      "Address": " 72314 HIGHWAY 111",
      "City": "PALM DESERT",
      "Zip Code": " 92260",
      "County": " RIVERSIDE",
      "Latitude": "33.7280540  ",
      "Longitude": " -116.40075 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2028",
      "Address": " 5200 VAN BUREN BLVD",
      "City": "RIVERSIDE",
      "Zip Code": " 92503",
      "County": " RIVERSIDE",
      "Latitude": "33.9357640  ",
      "Longitude": " -117.45430 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#233",
      "Address": "N 1675 PERRIS BLVD",
      "Second Address": " STE F5",
      "City": "PERRIS",
      "Zip Code": " 92571",
      "County": " RIVERSIDE",
      "Latitude": "33.8021200  ",
      "Longitude": " -117.22553 "
   },
   {
      "Vendor": "SMART & FINAL #514",
      "Address": " 5202 ARLINGTON AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92504",
      "County": " RIVERSIDE",
      "Latitude": "33.9460100  ",
      "Longitude": " -117.41756 "
   },
   {
      "Vendor": "STATER BROS. #192",
      "Address": " 2841 MARY ST",
      "City": "RIVERSIDE",
      "Zip Code": " 92506",
      "County": " RIVERSIDE",
      "Latitude": "33.9342400  ",
      "Longitude": " -117.38701 "
   },
   {
      "Vendor": "WAL-MART STORE #5663",
      "Address": " 8844 LIMONITE AVE",
      "City": "JURUPA VALLEY",
      "Zip Code": " 92509",
      "County": " RIVERSIDE",
      "Latitude": "33.9753340  ",
      "Longitude": " -117.47833 "
   },
   {
      "Vendor": "WINCO FOODS #123",
      "Address": " 1100 HAMNER AVE",
      "City": "NORCO",
      "Zip Code": " 92860",
      "County": " RIVERSIDE",
      "Latitude": "33.8993440  ",
      "Longitude": " -117.56468 "
   },
   {
      "Vendor": "WAL-MART #2077",
      "Address": " 31700 GRAPE ST",
      "City": "LAKE ELSINORE",
      "Zip Code": " 92532",
      "County": " RIVERSIDE",
      "Latitude": "33.6622720  ",
      "Longitude": " -117.29395 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2181",
      "Address": " 82-491 AVENUE 42",
      "City": "INDIO",
      "Zip Code": " 92203",
      "County": " RIVERSIDE",
      "Latitude": "33.7407390  ",
      "Longitude": " -116.22942 "
   },
   {
      "Vendor": "LOS JUNIOR'S MARKET",
      "Address": "W 510 4TH ST",
      "City": "PERRIS",
      "Zip Code": " 92570",
      "County": " RIVERSIDE",
      "Latitude": "33.7827290  ",
      "Longitude": " -117.23720 "
   },
   {
      "Vendor": "MOTHER EARTH NUTRITION",
      "Address": "N 960 STATE ST",
      "Second Address": " STE B",
      "City": "HEMET",
      "Zip Code": " 92543",
      "County": " RIVERSIDE",
      "Latitude": "33.7635100  ",
      "Longitude": " -116.97182 "
   },
   {
      "Vendor": "CALIFORNIA RANCH MARKET",
      "Address": " 27526 US HIGHWAY 74",
      "City": "ROMOLAND",
      "Zip Code": " 92585",
      "County": " RIVERSIDE",
      "Latitude": "33.7490300  ",
      "Longitude": " -117.17990 "
   },
   {
      "Vendor": "WAL-MART NBRHD MARKET #2487",
      "Address": "W 1560 SIXTH ST",
      "City": "CORONA",
      "Zip Code": " 92882",
      "County": " RIVERSIDE",
      "Latitude": "33.8775820  ",
      "Longitude": " -117.59612 "
   },
   {
      "Vendor": "TARGET STORE T-0291",
      "Address": " 3333 ARLINGTON AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92506",
      "County": " RIVERSIDE",
      "Latitude": "33.9466410  ",
      "Longitude": " -117.38326 "
   },
   {
      "Vendor": "MOTHER EARTH NUTRITION",
      "Address": " 14256 PALM DR",
      "City": "DESERT HOT SPRINGS",
      "Zip Code": " 92240",
      "County": " RIVERSIDE",
      "Latitude": "33.9452130  ",
      "Longitude": " -116.50128 "
   },
   {
      "Vendor": "RIO RANCH MARKET #2",
      "Address": " 9001 MISSION BLVD",
      "City": "RIVERSIDE",
      "Zip Code": " 92509",
      "County": " RIVERSIDE",
      "Latitude": "34.0128330  ",
      "Longitude": " -117.48055 "
   },
   {
      "Vendor": "RIO RANCH MARKET #6",
      "Address": "W 3317 RAMSEY ST",
      "City": "BANNING",
      "Zip Code": " 92220",
      "County": " RIVERSIDE",
      "Latitude": "33.9266260  ",
      "Longitude": " -116.91301 "
   },
   {
      "Vendor": "RIO RANCH MARKET #5",
      "Address": "E 460 4TH ST",
      "City": "PERRIS",
      "Zip Code": " 92570",
      "County": " RIVERSIDE",
      "Latitude": "33.7827800  ",
      "Longitude": " -117.22018 "
   },
   {
      "Vendor": "TARGET STORE T-0307",
      "Address": "E 67750 PALM CANYON DR",
      "City": "CATHEDRAL CITY",
      "Zip Code": " 92234",
      "County": " RIVERSIDE",
      "Latitude": "33.7876100  ",
      "Longitude": " -116.48026 "
   },
   {
      "Vendor": "PANDITA BABIES NUTRITION",
      "Address": " 22700 ALESSANDRO BLVD",
      "Second Address": " STE G",
      "City": "MORENO VALLEY",
      "Zip Code": " 92553",
      "County": " RIVERSIDE",
      "Latitude": "33.9177830  ",
      "Longitude": " -117.26751 "
   },
   {
      "Vendor": "SMART & FINAL #719",
      "Address": " 25050 ALESSANDRO BLVD",
      "Second Address": " STE B",
      "City": "MORENO VALLEY",
      "Zip Code": " 92553",
      "County": " RIVERSIDE",
      "Latitude": "33.9184610  ",
      "Longitude": " -117.22554 "
   },
   {
      "Vendor": "SMART & FINAL #454",
      "Address": "E 701 HOBSON WAY",
      "City": "BLYTHE",
      "Zip Code": " 92225",
      "County": " RIVERSIDE",
      "Latitude": "33.6115550  ",
      "Longitude": " -114.58900 "
   },
   {
      "Vendor": "STATER BROS. #195",
      "Address": "W 3125 FLORIDA AVE",
      "City": "HEMET",
      "Zip Code": " 92545",
      "County": " RIVERSIDE",
      "Latitude": "33.7472530  ",
      "Longitude": " -117.00465 "
   },
   {
      "Vendor": "MOTHERS & KIDS NUTRITION #3",
      "Address": " 13800 HEACOCK ST",
      "Second Address": " STE 119",
      "City": "MORENO VALLEY",
      "Zip Code": " 92553",
      "County": " RIVERSIDE",
      "Latitude": "33.9196720  ",
      "Longitude": " -117.24284 "
   },
   {
      "Vendor": "EL SUPER #56",
      "Address": " 1212 MAGNOLIA AVE",
      "City": "CORONA",
      "Zip Code": " 92881",
      "County": " RIVERSIDE",
      "Latitude": "33.8637740  ",
      "Longitude": " -117.54272 "
   },
   {
      "Vendor": "EL SUPER #57",
      "Address": " 5800 VAN BUREN BLVD",
      "City": "RIVERSIDE",
      "Zip Code": " 92503",
      "County": " RIVERSIDE",
      "Latitude": "33.9421170  ",
      "Longitude": " -117.45500 "
   },
   {
      "Vendor": "TARGET STORE T-0761",
      "Address": "W 3527 FLORIDA AVE",
      "City": "HEMET",
      "Zip Code": " 92545",
      "County": " RIVERSIDE",
      "Latitude": "33.7469080  ",
      "Longitude": " -117.00997 "
   },
   {
      "Vendor": "SMART & FINAL #944",
      "Address": " 72675 HIGHWAY 111",
      "City": "PALM DESERT",
      "Zip Code": " 92260",
      "County": " RIVERSIDE",
      "Latitude": "33.7205110  ",
      "Longitude": " -116.39662 "
   },
   {
      "Vendor": "WAL-MART NBRHD MARKET #5008",
      "Address": "W 859 FLORIDA AVE",
      "City": "HEMET",
      "Zip Code": " 92543",
      "County": " RIVERSIDE",
      "Latitude": "33.7472940  ",
      "Longitude": " -116.98014 "
   },
   {
      "Vendor": "KIDS CHOICE NUTRITION",
      "Address": " 23962 ALESSANDRO BLVD",
      "Second Address": " STE S",
      "City": "MORENO VALLEY",
      "Zip Code": " 92553",
      "County": " RIVERSIDE",
      "Latitude": "33.9182590  ",
      "Longitude": " -117.24491 "
   },
   {
      "Vendor": "SUPER PENNY",
      "Address": " 5694 MISSION BLVD",
      "City": "RIVERSIDE",
      "Zip Code": " 92509",
      "County": " RIVERSIDE",
      "Latitude": "33.9981050  ",
      "Longitude": " -117.41003 "
   },
   {
      "Vendor": "LOS NOVILLOS MARKET",
      "Address": " 2650 MAIN ST",
      "City": "RIVERSIDE",
      "Zip Code": " 92501",
      "County": " RIVERSIDE",
      "Latitude": "33.9923650  ",
      "Longitude": " -117.36700 "
   },
   {
      "Vendor": "CARDENAS MARKET #4",
      "Address": "N 2560 PERRIS BLVD",
      "Second Address": " STE H",
      "City": "PERRIS",
      "Zip Code": " 92571",
      "County": " RIVERSIDE",
      "Latitude": "33.8182900  ",
      "Longitude": " -117.22726 "
   },
   {
      "Vendor": "CARDENAS MARKET #8",
      "Address": " 25065 SUNNYMEAD BLVD",
      "City": "MORENO VALLEY",
      "Zip Code": " 92553",
      "County": " RIVERSIDE",
      "Latitude": "33.9373060  ",
      "Longitude": " -117.22555 "
   },
   {
      "Vendor": "CARDENAS MARKET #11",
      "Address": " 6350 VAN BUREN BLVD",
      "City": "RIVERSIDE",
      "Zip Code": " 92503",
      "County": " RIVERSIDE",
      "Latitude": "33.9452440  ",
      "Longitude": " -117.45512 "
   },
   {
      "Vendor": "CARDENAS MARKET #13",
      "Address": "S 1475 SAN JACINTO AVE",
      "City": "SAN JACINTO",
      "Zip Code": " 92583",
      "County": " RIVERSIDE",
      "Latitude": "33.7739150  ",
      "Longitude": " -116.95803 "
   },
   {
      "Vendor": "CARDENAS MARKET #14",
      "Address": "S 301 LINCOLN AVE",
      "City": "CORONA",
      "Zip Code": " 92882",
      "County": " RIVERSIDE",
      "Latitude": "33.8795580  ",
      "Longitude": " -117.58076 "
   },
   {
      "Vendor": "CARDENAS MARKET #22",
      "Address": " 14930 PERRIS BLVD",
      "City": "MORENO VALLEY",
      "Zip Code": " 92553",
      "County": " RIVERSIDE",
      "Latitude": "33.9039850  ",
      "Longitude": " -117.22511 "
   },
   {
      "Vendor": "CARDENAS MARKET #33",
      "Address": " 3840 LA SIERRA AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92505",
      "County": " RIVERSIDE",
      "Latitude": "33.9040440  ",
      "Longitude": " -117.47852 "
   },
   {
      "Vendor": "CARDENAS MARKET #17",
      "Address": " 82266 US HWY 111",
      "City": "INDIO",
      "Zip Code": " 92201",
      "County": " RIVERSIDE",
      "Latitude": "33.7165770  ",
      "Longitude": " -116.23044 "
   },
   {
      "Vendor": "CARDENAS MARKET #18",
      "Address": " 50037 HARRISON ST",
      "City": "COACHELLA",
      "Zip Code": " 92236",
      "County": " RIVERSIDE",
      "Latitude": "33.6841310  ",
      "Longitude": " -116.18253 "
   },
   {
      "Vendor": "CARDENAS MARKET #25",
      "Address": " 31655 DATE PALM DR",
      "City": "CATHEDRAL CITY",
      "Zip Code": " 92234",
      "County": " RIVERSIDE",
      "Latitude": "33.8182500  ",
      "Longitude": " -116.46011 "
   },
   {
      "Vendor": "CARDENAS MARKET #31",
      "Address": " 31952 MISSION TRAIL",
      "City": "LAKE ELSINORE",
      "Zip Code": " 92530",
      "County": " RIVERSIDE",
      "Latitude": "33.6570690  ",
      "Longitude": " -117.29721 "
   },
   {
      "Vendor": "CARDENAS MARKET #32",
      "Address": " 25310 MADISON AVE",
      "City": "MURRIETA",
      "Zip Code": " 92562",
      "County": " RIVERSIDE",
      "Latitude": "33.5545880  ",
      "Longitude": " -117.19553 "
   },
   {
      "Vendor": "STATER BROS. MARKETS #197",
      "Address": " 29061 NEWPORT RD",
      "City": "MENIFEE",
      "Zip Code": " 92584",
      "County": " RIVERSIDE",
      "Latitude": "33.6847750  ",
      "Longitude": " -117.15281 "
   },
   {
      "Vendor": "STATER BROS. MARKET #201",
      "Address": "E 315 ALESSANDRO BLVD",
      "City": "RIVERSIDE",
      "Zip Code": " 92508",
      "County": " RIVERSIDE",
      "Latitude": "33.9138510  ",
      "Longitude": " -117.32845 "
   },
   {
      "Vendor": "HAPPY BABY NUTRITION#1",
      "Address": "W 944 6TH ST",
      "City": "CORONA",
      "Zip Code": " 92882",
      "County": " RIVERSIDE",
      "Latitude": "33.8764740  ",
      "Longitude": " -117.57920 "
   },
   {
      "Vendor": "SMART & FINAL #789",
      "Address": " 13346 LIMONITE AVE",
      "City": "EASTVALE",
      "Zip Code": " 92880",
      "County": " RIVERSIDE",
      "Latitude": "33.9753520  ",
      "Longitude": " -117.57478 "
   },
   {
      "Vendor": "LA FAVORITA RANCH MARKET",
      "Address": " 28266 OLD TOWN FRONT ST",
      "City": "TEMECULA",
      "Zip Code": " 92590",
      "County": " RIVERSIDE",
      "Latitude": "33.4982710  ",
      "Longitude": " -117.15298 "
   },
   {
      "Vendor": "STATER BROS. MARKETS #199",
      "Address": " 2430 RIVER RD",
      "City": "NORCO",
      "Zip Code": " 92860",
      "County": " RIVERSIDE",
      "Latitude": "33.9161530  ",
      "Longitude": " -117.58956 "
   },
   {
      "Vendor": "EL TORO FRESH MARKET",
      "Address": " 10775 HOLE AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92505",
      "County": " RIVERSIDE",
      "Latitude": "33.9182080  ",
      "Longitude": " -117.48107 "
   },
   {
      "Vendor": "HEALTHY KIDS NUTRITION",
      "Address": " 371 WILKERSON AVE",
      "Second Address": "  SUITE N",
      "City": "PERRIS",
      "Zip Code": " 92570",
      "County": " RIVERSIDE",
      "Latitude": "33.7832980  ",
      "Longitude": " -117.21820 "
   },
   {
      "Vendor": "SMART & FINAL #705",
      "Address": "E 928 ONTARIO AVE",
      "City": "CORONA",
      "Zip Code": " 92881",
      "County": " RIVERSIDE",
      "Latitude": "33.8509310  ",
      "Longitude": " -117.55039 "
   },
   {
      "Vendor": "FIESTA MARKET",
      "Address": "E 105 MAIN ST",
      "City": "SAN JACINTO",
      "Zip Code": " 92583",
      "County": " RIVERSIDE",
      "Latitude": "33.7840480  ",
      "Longitude": " -116.95868 "
   },
   {
      "Vendor": "WAL-MART NBRHD MARKET #8958",
      "Address": " 44100 JEFFERSON ST",
      "Second Address": " STE F",
      "City": "INDIO",
      "Zip Code": " 92201",
      "County": " RIVERSIDE",
      "Latitude": "33.7275190  ",
      "Longitude": " -116.26821 "
   },
   {
      "Vendor": "EL TORO EXPRESS 5",
      "Address": "E 533 MAIN ST",
      "City": "SAN JACINTO",
      "Zip Code": " 92583",
      "County": " RIVERSIDE",
      "Latitude": "33.7841220  ",
      "Longitude": " -116.95167 "
   },
   {
      "Vendor": "MOTHER EARTH NUTRITION",
      "Address": "E 1717 VISTA CHINO",
      "Second Address": "  STE #J3",
      "City": "PALM SPRINGS",
      "Zip Code": " 92262",
      "County": " RIVERSIDE",
      "Latitude": "33.8445170  ",
      "Longitude": " -116.52637 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#241",
      "Address": " 5655 VAN BUREN BLVD",
      "Second Address": " STE C & D",
      "City": "RIVERSIDE",
      "Zip Code": " 92503",
      "County": " RIVERSIDE",
      "Latitude": "33.9407730  ",
      "Longitude": " -117.45321 "
   },
   {
      "Vendor": "LA BODEGUITA",
      "Address": " 4174 BEYER BLVD",
      "City": "SAN YSIDRO",
      "Zip Code": " 92173",
      "County": " SAN DIEGO",
      "Latitude": "32.5587530  ",
      "Longitude": " -117.04484 "
   },
   {
      "Vendor": "INDIO NUTRITION",
      "Address": " 82013 DR CARREON BLVD",
      "Second Address": " STE P",
      "City": "INDIO",
      "Zip Code": " 92201",
      "County": " RIVERSIDE",
      "Latitude": "33.7069030  ",
      "Longitude": " -116.23327 "
   },
   {
      "Vendor": "BANNING VILLAGE MARKET",
      "Address": "N 266 SAN GORGONIO AVE",
      "City": "BANNING",
      "Zip Code": " 92220",
      "County": " RIVERSIDE",
      "Latitude": "33.9276240  ",
      "Longitude": " -116.87649 "
   },
   {
      "Vendor": "EL SUPER #63",
      "Address": " 81691 US HWY 111",
      "Second Address": "  STE 102",
      "City": "INDIO",
      "Zip Code": " 92201",
      "County": " RIVERSIDE",
      "Latitude": "33.7136400  ",
      "Longitude": " -116.23777 "
   },
   {
      "Vendor": "LOS NOVILLOS ARLINGTON INC.",
      "Address": " 5405 ARLINGTON AVE",
      "City": "RIVERSIDE",
      "Zip Code": " 92504",
      "County": " RIVERSIDE",
      "Latitude": "33.9464620  ",
      "Longitude": " -117.42087 "
   },
   {
      "Vendor": "LUCERNE VALLEY MARKET",
      "Address": " 32946 HIGHWAY 18",
      "City": "LUCERNE VALLEY",
      "Zip Code": " 92356",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4403800  ",
      "Longitude": " -116.94473 "
   },
   {
      "Vendor": "STATER BROS. #052",
      "Address": " 4721 RIVERSIDE AVE",
      "City": "CHINO",
      "Zip Code": " 91710",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0184470  ",
      "Longitude": " -117.70160 "
   },
   {
      "Vendor": "STATER BROS. #023",
      "Address": " 34460 YUCAIPA BLVD",
      "City": "YUCAIPA",
      "Zip Code": " 92399",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0340760  ",
      "Longitude": " -117.05252 "
   },
   {
      "Vendor": "VONS #2147",
      "Address": " 8778 19TH ST",
      "City": "RANCHO CUCAMONGA",
      "Zip Code": " 91701",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1326020  ",
      "Longitude": " -117.61442 "
   },
   {
      "Vendor": "STATER BROS. #061",
      "Address": "S 1045 BLOOMINGTON AVE",
      "City": "BLOOMINGTON",
      "Zip Code": " 92316",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0748630  ",
      "Longitude": " -117.38978 "
   },
   {
      "Vendor": "STATER BROS. #087",
      "Address": " 1904 RANCHO AVE",
      "City": "COLTON",
      "Zip Code": " 92324",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0905820  ",
      "Longitude": " -117.33279 "
   },
   {
      "Vendor": "STATER BROS. #003",
      "Address": "E 151 VALLEY BLVD",
      "City": "COLTON",
      "Zip Code": " 92324",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0673300  ",
      "Longitude": " -117.32340 "
   },
   {
      "Vendor": "STATER BROS. #078",
      "Address": " 9750 NINETEENTH ST",
      "City": "RANCHO CUCAMONGA",
      "Zip Code": " 91730",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1338460  ",
      "Longitude": " -117.59262 "
   },
   {
      "Vendor": "STATER BROS. #095",
      "Address": " 18140 ARROW BLVD",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1006840  ",
      "Longitude": " -117.40888 "
   },
   {
      "Vendor": "STATER BROS. #005",
      "Address": "N 8228 SIERRA AVE",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1042730  ",
      "Longitude": " -117.43661 "
   },
   {
      "Vendor": "STATER BROS. #017",
      "Address": "S 9954 SIERRA AVE",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0732710  ",
      "Longitude": " -117.43677 "
   },
   {
      "Vendor": "STATER BROS. #190",
      "Address": " 16904 MAIN ST",
      "City": "HESPERIA",
      "Zip Code": " 92345",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4214280  ",
      "Longitude": " -117.29452 "
   },
   {
      "Vendor": "STATER BROS. #073",
      "Address": " 9575 CENTRAL AVE",
      "City": "MONTCLAIR",
      "Zip Code": " 91763",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0803190  ",
      "Longitude": " -117.68872 "
   },
   {
      "Vendor": "STATER BROS. #085",
      "Address": " 1939 FOURTH ST",
      "City": "ONTARIO",
      "Zip Code": " 91764",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0782670  ",
      "Longitude": " -117.60952 "
   },
   {
      "Vendor": "STATER BROS. #059",
      "Address": "W 1105 PHILADELPHIA AVE",
      "City": "ONTARIO",
      "Zip Code": " 91761",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0343250  ",
      "Longitude": " -117.55744 "
   },
   {
      "Vendor": "STATER BROS. #018",
      "Address": "E 11 COLTON AVE",
      "City": "REDLANDS",
      "Zip Code": " 92373",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0634780  ",
      "Longitude": " -117.18194 "
   },
   {
      "Vendor": "STATER BROS. #043",
      "Address": "E 168 BASELINE AVE",
      "City": "RIALTO",
      "Zip Code": " 92376",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1226700  ",
      "Longitude": " -117.36956 "
   },
   {
      "Vendor": "STATER BROS. #012",
      "Address": "E 571 FOOTHILL BLVD",
      "City": "RIALTO",
      "Zip Code": " 92376",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1055930  ",
      "Longitude": " -117.36013 "
   },
   {
      "Vendor": "STATER BROS. #008",
      "Address": "W 1085 HIGHLAND AVE",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92405",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1345340  ",
      "Longitude": " -117.30814 "
   },
   {
      "Vendor": "STATER BROS. #024",
      "Address": "E 1522 HIGHLAND AVE",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92404",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1369180  ",
      "Longitude": " -117.25415 "
   },
   {
      "Vendor": "STATER BROS. #002",
      "Address": "E 444 BASELINE AVE",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92404",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1214750  ",
      "Longitude": " -117.27618 "
   },
   {
      "Vendor": "STATER BROS. #045",
      "Address": "N 919 MOUNTAIN AVE",
      "City": "UPLAND",
      "Zip Code": " 91786",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1056710  ",
      "Longitude": " -117.67075 "
   },
   {
      "Vendor": "STATER BROS. #065",
      "Address": "N 1619 MOUNTAIN AVE",
      "City": "UPLAND",
      "Zip Code": " 91786",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1222400  ",
      "Longitude": " -117.67177 "
   },
   {
      "Vendor": "STATER BROS. #058",
      "Address": "E 3633 HIGHLAND AVE",
      "City": "HIGHLAND",
      "Zip Code": " 92346",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1348010  ",
      "Longitude": " -117.20796 "
   },
   {
      "Vendor": "TWENTYNINE PALMS COMMISSARY",
      "Address": " 1025 DEL VALLE DR",
      "Second Address": " BLDG 1025",
      "City": "TWENTYNINE PALMS",
      "Zip Code": " 92278",
      "County": " SAN BERNARDINO",
      "Latitude": "34.2346830  ",
      "Longitude": " -116.06418 "
   },
   {
      "Vendor": "VONS #2374",
      "Address": " 42170 BIG BEAR BLVD",
      "City": "BIG BEAR LAKE",
      "Zip Code": " 92315",
      "County": " SAN BERNARDINO",
      "Latitude": "34.2522980  ",
      "Longitude": " -116.88514 "
   },
   {
      "Vendor": "BARSTOW COMMISSARY",
      "Address": " 364 IWO JIMA ST",
      "Second Address": " BLDG 364",
      "City": "BARSTOW",
      "Zip Code": " 92311",
      "County": " SAN BERNARDINO",
      "Latitude": "34.8743910  ",
      "Longitude": " -116.95308 "
   },
   {
      "Vendor": "STATER BROS. #096",
      "Address": " 57075 TWENTYNINE PALMS HWY",
      "City": "YUCCA VALLEY",
      "Zip Code": " 92284",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1213510  ",
      "Longitude": " -116.41834 "
   },
   {
      "Vendor": "STATER BROS. #097",
      "Address": " 15757 MAIN ST",
      "City": "HESPERIA",
      "Zip Code": " 92345",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4227870  ",
      "Longitude": " -117.31920 "
   },
   {
      "Vendor": "STATER BROS. #191",
      "Address": "E 1775 LUGONIA AVE",
      "City": "REDLANDS",
      "Zip Code": " 92374",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0712950  ",
      "Longitude": " -117.13932 "
   },
   {
      "Vendor": "STATER BROS. #092",
      "Address": " 28100 STATE HIGHWAY 189",
      "City": "LAKE ARROWHEAD",
      "Zip Code": " 92352",
      "County": " SAN BERNARDINO",
      "Latitude": "34.2497570  ",
      "Longitude": " -117.19404 "
   },
   {
      "Vendor": "FORT IRWIN COMMISSARY",
      "Address": " 3920 INNER LOOP RD",
      "Second Address": " BLDG 920",
      "City": "FORT IRWIN",
      "Zip Code": " 92310",
      "County": " SAN BERNARDINO",
      "Latitude": "35.2523610  ",
      "Longitude": " -116.68414 "
   },
   {
      "Vendor": "STATER BROS. #091",
      "Address": " 42171 BIG BEAR BLVD",
      "City": "BIG BEAR LAKE",
      "Zip Code": " 92315",
      "County": " SAN BERNARDINO",
      "Latitude": "34.2522890  ",
      "Longitude": " -116.88327 "
   },
   {
      "Vendor": "STATER BROS. #101",
      "Address": "E 957 ARMORY RD",
      "City": "BARSTOW",
      "Zip Code": " 92311",
      "County": " SAN BERNARDINO",
      "Latitude": "34.8847240  ",
      "Longitude": " -117.01390 "
   },
   {
      "Vendor": "VONS #2131",
      "Address": " 12199 HESPERIA RD",
      "City": "VICTORVILLE",
      "Zip Code": " 92395",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4728650  ",
      "Longitude": " -117.29170 "
   },
   {
      "Vendor": "STATER BROS. #105",
      "Address": " 71727 TWENTYNINE PALMS HWY",
      "City": "TWENTYNINE PALMS",
      "Zip Code": " 92277",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1344960  ",
      "Longitude": " -116.09727 "
   },
   {
      "Vendor": "STATER BROS. #108",
      "Address": "W 646 HOLT BLVD",
      "City": "ONTARIO",
      "Zip Code": " 91762",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0640800  ",
      "Longitude": " -117.65962 "
   },
   {
      "Vendor": "RALPHS #717",
      "Address": " 7243 HAVEN AVE",
      "City": "RANCHO CUCAMONGA",
      "Zip Code": " 91701",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1226260  ",
      "Longitude": " -117.57337 "
   },
   {
      "Vendor": "STATER BROS. #107",
      "Address": " 977 KENDALL DR",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92407",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1632440  ",
      "Longitude": " -117.30570 "
   },
   {
      "Vendor": "STATER BROS. #110",
      "Address": " 21602 BEAR VALLEY RD",
      "City": "APPLE VALLEY",
      "Zip Code": " 92308",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4716610  ",
      "Longitude": " -117.19246 "
   },
   {
      "Vendor": "STATER BROS. #112",
      "Address": " 1536 BARTON RD",
      "City": "REDLANDS",
      "Zip Code": " 92373",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0468780  ",
      "Longitude": " -117.20639 "
   },
   {
      "Vendor": "FOOD 4 LESS #301",
      "Address": "W 555 SECOND ST",
      "Second Address": " STE A",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92401",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1017780  ",
      "Longitude": " -117.29575 "
   },
   {
      "Vendor": "FOOD 4 LESS #303",
      "Address": "W 1410 FOOTHILL BLVD",
      "City": "RIALTO",
      "Zip Code": " 92376",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1077420  ",
      "Longitude": " -117.39875 "
   },
   {
      "Vendor": "FOOD 4 LESS #305",
      "Address": " 16266 BEAR VALLEY RD",
      "City": "VICTORVILLE",
      "Zip Code": " 92392",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4711670  ",
      "Longitude": " -117.30852 "
   },
   {
      "Vendor": "STATER BROS. #053",
      "Address": " 8770 BASELINE AVE",
      "City": "RANCHO CUCAMONGA",
      "Zip Code": " 91701",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1227450  ",
      "Longitude": " -117.61460 "
   },
   {
      "Vendor": "STATER BROS. #117",
      "Address": "E 2053 WASHINGTON ST",
      "City": "COLTON",
      "Zip Code": " 92324",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0501680  ",
      "Longitude": " -117.29124 "
   },
   {
      "Vendor": "STATER BROS. #116",
      "Address": " 4059 PHELAN RD",
      "City": "PHELAN",
      "Zip Code": " 92371",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4253680  ",
      "Longitude": " -117.57357 "
   },
   {
      "Vendor": "RALPHS #752",
      "Address": "S 3075 ARCHIBALD AVE",
      "Second Address": " BLDG C",
      "City": "ONTARIO",
      "Zip Code": " 91761",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0179500  ",
      "Longitude": " -117.59236 "
   },
   {
      "Vendor": "STATER BROS. #118",
      "Address": " 13760 BEAR VALLEY RD",
      "City": "VICTORVILLE",
      "Zip Code": " 92392",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4713710  ",
      "Longitude": " -117.36277 "
   },
   {
      "Vendor": "VONS #3058",
      "Address": " 57590 TWENTYNINE PALMS HWY",
      "City": "YUCCA VALLEY",
      "Zip Code": " 92284",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1262800  ",
      "Longitude": " -116.40833 "
   },
   {
      "Vendor": "FOOD 4 LESS #320",
      "Address": "S 2246 EUCLID AVE",
      "City": "ONTARIO",
      "Zip Code": " 91762",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0328180  ",
      "Longitude": " -117.65124 "
   },
   {
      "Vendor": "STATER BROS. #120",
      "Address": " 58060 TWENTYNINE PALMS HWY",
      "City": "YUCCA VALLEY",
      "Zip Code": " 92284",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1282570  ",
      "Longitude": " -116.39671 "
   },
   {
      "Vendor": "FOOD 4 LESS #311",
      "Address": "W 2070 REDLANDS BLVD",
      "City": "REDLANDS",
      "Zip Code": " 92373",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0647130  ",
      "Longitude": " -117.22487 "
   },
   {
      "Vendor": "MIDWAY MARKET",
      "Address": "W 685 BASELINE ST",
      "Second Address": " STE A B C",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92410",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1213220  ",
      "Longitude": " -117.27226 "
   },
   {
      "Vendor": "RALPHS #753",
      "Address": " 4444 UNIVERSITY PKWY",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92407",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1696430  ",
      "Longitude": " -117.33401 "
   },
   {
      "Vendor": "STATER BROS. #123",
      "Address": " 15235 HOOK BLVD",
      "City": "VICTORVILLE",
      "Zip Code": " 92394",
      "County": " SAN BERNARDINO",
      "Latitude": "34.5203220  ",
      "Longitude": " -117.33139 "
   },
   {
      "Vendor": "FOOD 4 LESS #328",
      "Address": " 12879 FOOTHILL BLVD",
      "City": "RANCHO CUCAMONGA",
      "Zip Code": " 91739",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1052770  ",
      "Longitude": " -117.52456 "
   },
   {
      "Vendor": "STATER BROS. #122",
      "Address": " 14466 MAIN ST",
      "City": "HESPERIA",
      "Zip Code": " 92345",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4277650  ",
      "Longitude": " -117.34852 "
   },
   {
      "Vendor": "FOOD 4 LESS #312",
      "Address": " 580 VIRGINIA WAY",
      "City": "BARSTOW",
      "Zip Code": " 92311",
      "County": " SAN BERNARDINO",
      "Latitude": "34.8870460  ",
      "Longitude": " -117.01880 "
   },
   {
      "Vendor": "FOOD 4 LESS #397",
      "Address": " 14738 LA PAZ DR",
      "City": "VICTORVILLE",
      "Zip Code": " 92392",
      "County": " SAN BERNARDINO",
      "Latitude": "34.5192130  ",
      "Longitude": " -117.31465 "
   },
   {
      "Vendor": "FOOD 4 LESS #385",
      "Address": " 26529 HIGHLAND AVE",
      "City": "HIGHLAND",
      "Zip Code": " 92346",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1347140  ",
      "Longitude": " -117.22537 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#403",
      "Address": "W 320 G ST",
      "Second Address": " STE 105",
      "City": "ONTARIO",
      "Zip Code": " 91762",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0711420  ",
      "Longitude": " -117.65459 "
   },
   {
      "Vendor": "REDLANDS RANCH MARKET",
      "Address": "E 800 LUGONIA AVE",
      "City": "REDLANDS",
      "Zip Code": " 92374",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0695340  ",
      "Longitude": " -117.17305 "
   },
   {
      "Vendor": "FOOD 4 LESS #389",
      "Address": " 16991 VALLEY BLVD",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0690400  ",
      "Longitude": " -117.43377 "
   },
   {
      "Vendor": "STATER BROS. #125",
      "Address": " 11365 BRYANT ST",
      "City": "YUCAIPA",
      "Zip Code": " 92399",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0474640  ",
      "Longitude": " -117.03307 "
   },
   {
      "Vendor": "STATER BROS. #081",
      "Address": " 25630 BARTON RD",
      "City": "LOMA LINDA",
      "Zip Code": " 92354",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0493610  ",
      "Longitude": " -117.24579 "
   },
   {
      "Vendor": "VONS #1734",
      "Address": "N 522 ORANGE ST",
      "City": "REDLANDS",
      "Zip Code": " 92374",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0601500  ",
      "Longitude": " -117.18105 "
   },
   {
      "Vendor": "SANDY'S MARKET",
      "Address": " 85 GROVE AVE",
      "City": "UPLAND",
      "Zip Code": " 91786",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0947470  ",
      "Longitude": " -117.62883 "
   },
   {
      "Vendor": "VONS #1914",
      "Address": " 6351 HAVEN AVE",
      "City": "RANCHO CUCAMONGA",
      "Zip Code": " 91737",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1384930  ",
      "Longitude": " -117.57462 "
   },
   {
      "Vendor": "VONS #1742",
      "Address": " 7390 CHERRY AVE",
      "City": "FONTANA",
      "Zip Code": " 92336",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1202350  ",
      "Longitude": " -117.48996 "
   },
   {
      "Vendor": "STATER BROS. #036",
      "Address": "E 161 40TH ST",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92404",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1639450  ",
      "Longitude": " -117.28303 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#438",
      "Address": " 9745 SIERRA AVE",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0766880  ",
      "Longitude": " -117.43505 "
   },
   {
      "Vendor": "VONS #1796",
      "Address": " 33644 YUCAIPA BLVD",
      "City": "YUCAIPA",
      "Zip Code": " 92399",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0340110  ",
      "Longitude": " -117.07036 "
   },
   {
      "Vendor": "STATER BROS. #169",
      "Address": " 14250 CHINO HILLS PKWY",
      "City": "CHINO HILLS",
      "Zip Code": " 91709",
      "County": " SAN BERNARDINO",
      "Latitude": "33.9938610  ",
      "Longitude": " -117.75870 "
   },
   {
      "Vendor": "FOOD 4 LESS #782",
      "Address": " 20801 BEAR VALLEY RD",
      "City": "APPLE VALLEY",
      "Zip Code": " 92308",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4707200  ",
      "Longitude": " -117.20804 "
   },
   {
      "Vendor": "CARNICERIA LA FAMOSA",
      "Address": "W 397 HIGHLAND AVE",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92405",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1359750  ",
      "Longitude": " -117.29181 "
   },
   {
      "Vendor": "VONS #2681",
      "Address": "W 81 FOOTHILL BLVD",
      "City": "UPLAND",
      "Zip Code": " 91786",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1080420  ",
      "Longitude": " -117.65295 "
   },
   {
      "Vendor": "FOOD 4 LESS #786",
      "Address": "N 1150 PEPPER AVE",
      "City": "COLTON",
      "Zip Code": " 92324",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0798590  ",
      "Longitude": " -117.35157 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#449",
      "Address": "S 806-808 MOUNTAIN AVE",
      "City": "ONTARIO",
      "Zip Code": " 91762",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0551330  ",
      "Longitude": " -117.66985 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#451",
      "Address": "N 1535 BAKER AVE",
      "Second Address": " STE D & E",
      "City": "ONTARIO",
      "Zip Code": " 91764",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0859900  ",
      "Longitude": " -117.62051 "
   },
   {
      "Vendor": "RALPHS #700",
      "Address": " 12201 HIGHLAND AVE",
      "City": "RANCHO CUCAMONGA",
      "Zip Code": " 91739",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1349880  ",
      "Longitude": " -117.53893 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #120",
      "Address": "W 815 HOLT BLVD",
      "City": "ONTARIO",
      "Zip Code": " 91762",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0622040  ",
      "Longitude": " -117.66370 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #122",
      "Address": " 16055 FOOTHILL BLVD",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1055580  ",
      "Longitude": " -117.45478 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #121",
      "Address": "W 151 BASELINE RD",
      "City": "RIALTO",
      "Zip Code": " 92376",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1203680  ",
      "Longitude": " -117.37157 "
   },
   {
      "Vendor": "STATER BROS. #178",
      "Address": " 12253 APPLE VALLEY RD",
      "City": "APPLE VALLEY",
      "Zip Code": " 92308",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4740250  ",
      "Longitude": " -117.24085 "
   },
   {
      "Vendor": "STATER BROS. #176",
      "Address": " 14168 HIGHWAY 395",
      "City": "ADELANTO",
      "Zip Code": " 92301",
      "County": " SAN BERNARDINO",
      "Latitude": "34.5076960  ",
      "Longitude": " -117.40090 "
   },
   {
      "Vendor": "STATER BROS. #175",
      "Address": " 15222 SUMMIT AVE",
      "City": "FONTANA",
      "Zip Code": " 92336",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1512390  ",
      "Longitude": " -117.47495 "
   },
   {
      "Vendor": "STATER BROS. #179",
      "Address": " 11225 SIERRA AVE",
      "City": "FONTANA",
      "Zip Code": " 92337",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0502630  ",
      "Longitude": " -117.43415 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #22",
      "Address": " 12351 MARIPOSA RD",
      "City": "VICTORVILLE",
      "Zip Code": " 92395",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4748910  ",
      "Longitude": " -117.33935 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #3464",
      "Address": " 3493 GRAND AVE",
      "City": "CHINO",
      "Zip Code": " 91710",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0001110  ",
      "Longitude": " -117.72177 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #125",
      "Address": " 12375 CENTRAL AVE",
      "City": "CHINO",
      "Zip Code": " 91710",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0276240  ",
      "Longitude": " -117.68820 "
   },
   {
      "Vendor": "STATER BROS. #182",
      "Address": " 28988 GREENSPOT RD",
      "City": "HIGHLAND",
      "Zip Code": " 92346",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1114160  ",
      "Longitude": " -117.17259 "
   },
   {
      "Vendor": "RALPHS #113",
      "Address": " 16225 SIERRA LAKE PKWY",
      "City": "FONTANA",
      "Zip Code": " 92336",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1376670  ",
      "Longitude": " -117.45089 "
   },
   {
      "Vendor": "MT & H FOOD MARKET",
      "Address": "W 196 HIGHLAND AVE",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92405",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1362740  ",
      "Longitude": " -117.28704 "
   },
   {
      "Vendor": "WINCO FOODS #65",
      "Address": " 19047 BEAR VALLEY RD",
      "City": "APPLE VALLEY",
      "Zip Code": " 92308",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4686310  ",
      "Longitude": " -117.24758 "
   },
   {
      "Vendor": "TARGET STORE T-2260",
      "Address": " 20288 CA-18",
      "City": "APPLE VALLEY",
      "Zip Code": " 92307",
      "County": " SAN BERNARDINO",
      "Latitude": "34.5280350  ",
      "Longitude": " -117.21706 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #130",
      "Address": "W 1108 SECOND ST",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92410",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1029650  ",
      "Longitude": " -117.30807 "
   },
   {
      "Vendor": "STATER BROS. #184",
      "Address": " 6989 SCHAEFER AVE",
      "City": "CHINO",
      "Zip Code": " 91710",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0036100  ",
      "Longitude": " -117.65242 "
   },
   {
      "Vendor": "M & G MARKET",
      "Address": " 26710 5TH ST",
      "City": "HIGHLAND",
      "Zip Code": " 92346",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1087520  ",
      "Longitude": " -117.22156 "
   },
   {
      "Vendor": "WINCO FOODS #67",
      "Address": " 15350 ROY ROGERS DR",
      "City": "VICTORVILLE",
      "Zip Code": " 92394",
      "County": " SAN BERNARDINO",
      "Latitude": "34.5229940  ",
      "Longitude": " -117.32899 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#215",
      "Address": "E 270 BASELINE ST",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92410",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1216610  ",
      "Longitude": " -117.27964 "
   },
   {
      "Vendor": "RALPHS #013",
      "Address": " 7369 MILLIKEN AVE",
      "City": "RANCHO CUCAMONGA",
      "Zip Code": " 91730",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1196580  ",
      "Longitude": " -117.55825 "
   },
   {
      "Vendor": "WINCO FOODS #33",
      "Address": " 14338 FOOTHILL BLVD",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1075370  ",
      "Longitude": " -117.48929 "
   },
   {
      "Vendor": "SMART & FINAL #408",
      "Address": "E 1337 4TH ST",
      "City": "ONTARIO",
      "Zip Code": " 91764",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0776430  ",
      "Longitude": " -117.62717 "
   },
   {
      "Vendor": "SMART & FINAL #353",
      "Address": " 17000 FOOTHILL BLVD",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1072200  ",
      "Longitude": " -117.43314 "
   },
   {
      "Vendor": "BABY & INFANTS NUTRITIONAL",
      "Address": " 9648 9TH AVE",
      "Second Address": " STE 3",
      "City": "HESPERIA",
      "Zip Code": " 92345",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4257130  ",
      "Longitude": " -117.32041 "
   },
   {
      "Vendor": "SMART & FINAL #494",
      "Address": " 12164 CENTRAL AVE",
      "City": "CHINO",
      "Zip Code": " 91710",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0331900  ",
      "Longitude": " -117.68956 "
   },
   {
      "Vendor": "SMART & FINAL #467",
      "Address": " 8675 BASELINE RD",
      "City": "RANCHO CUCAMONGA",
      "Zip Code": " 91739",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1215440  ",
      "Longitude": " -117.61635 "
   },
   {
      "Vendor": "SMART & FINAL #354",
      "Address": " 15111 BEAR VALLEY RD",
      "City": "HESPERIA",
      "Zip Code": " 92345",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4699810  ",
      "Longitude": " -117.33366 "
   },
   {
      "Vendor": "SMART & FINAL #318",
      "Address": "W 1720 REDLANDS BLVD",
      "City": "REDLANDS",
      "Zip Code": " 92373",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0633880  ",
      "Longitude": " -117.21350 "
   },
   {
      "Vendor": "ABC NUTRITIONAL CARE",
      "Address": " 1505 17TH ST",
      "Second Address": " STE 1A",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92411",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1302970  ",
      "Longitude": " -117.32705 "
   },
   {
      "Vendor": "FONTANA RANCH MARKET",
      "Address": " 15324 MERRILL AVE",
      "Second Address": " STE A",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0925100  ",
      "Longitude": " -117.47074 "
   },
   {
      "Vendor": "TARGET STORE T-2468",
      "Address": " 12795 MAIN ST",
      "City": "HESPERIA",
      "Zip Code": " 92345",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4264110  ",
      "Longitude": " -117.38383 "
   },
   {
      "Vendor": "VILLAGE RANCH MARKET",
      "Address": " 15091 MERRILL AVE",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0917970  ",
      "Longitude": " -117.47571 "
   },
   {
      "Vendor": "EL SUPER #31",
      "Address": " 16950 FOOTHILL BLVD",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1068280  ",
      "Longitude": " -117.43436 "
   },
   {
      "Vendor": "EL SUPER #32",
      "Address": " 9850 SIERRA AVE",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0749320  ",
      "Longitude": " -117.43694 "
   },
   {
      "Vendor": "EL SUPER #35",
      "Address": "S 515 RIVERSIDE AVE",
      "City": "RIALTO",
      "Zip Code": " 92376",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0915090  ",
      "Longitude": " -117.36915 "
   },
   {
      "Vendor": "EL SUPER #37",
      "Address": "E 263 9TH ST",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92401",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1148120  ",
      "Longitude": " -117.28014 "
   },
   {
      "Vendor": "EL SUPER #38",
      "Address": "W 1578 BASELINE ST",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92411",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1223220  ",
      "Longitude": " -117.32125 "
   },
   {
      "Vendor": "EL SUPER #39",
      "Address": "S 570 MOUNT VERNON AVE",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92410",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0908100  ",
      "Longitude": " -117.31515 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1692",
      "Address": "S 1120 MOUNT VERNON AVE",
      "City": "COLTON",
      "Zip Code": " 92324",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0498120  ",
      "Longitude": " -117.30887 "
   },
   {
      "Vendor": "MERCADO DON JUAN #2",
      "Address": " 2199 DARBY ST",
      "Second Address": " STE A",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92407",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1466360  ",
      "Longitude": " -117.34383 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#224",
      "Address": " 7993 SIERRA AVE",
      "Second Address": " UNIT A",
      "City": "FONTANA",
      "Zip Code": " 92336",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1089120  ",
      "Longitude": " -117.43580 "
   },
   {
      "Vendor": "WAL-MART STORE #1922",
      "Address": " 12549 FOOTHILL BLVD",
      "City": "RANCHO CUCAMONGA",
      "Zip Code": " 91739",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1035820  ",
      "Longitude": " -117.53140 "
   },
   {
      "Vendor": "MOMMY & ME NUTRITIONAL CENT",
      "Address": "E 326 HOLT BLVD",
      "Second Address": " STE D",
      "City": "ONTARIO",
      "Zip Code": " 91761",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0629700  ",
      "Longitude": " -117.64747 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#227",
      "Address": " 4774 RIVERSIDE DR",
      "Second Address": " UNIT A",
      "City": "CHINO",
      "Zip Code": " 91710",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0193380  ",
      "Longitude": " -117.70094 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#231",
      "Address": "N 1136 MOUNT VERNON AVE",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92411",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1200960  ",
      "Longitude": " -117.31443 "
   },
   {
      "Vendor": "HEALTHY FAM. NUTRITION BARS",
      "Address": "S 119 FIRST AVE",
      "City": "BARSTOW",
      "Zip Code": " 92311",
      "County": " SAN BERNARDINO",
      "Latitude": "34.8981320  ",
      "Longitude": " -117.02747 "
   },
   {
      "Vendor": "STATER BROS. #188",
      "Address": " 22201 BARTON RD",
      "City": "GRAND TERRACE",
      "Zip Code": " 92313",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0328590  ",
      "Longitude": " -117.32049 "
   },
   {
      "Vendor": "TARGET STORE T-1834",
      "Address": " 1931 CAMPUS AVE",
      "City": "UPLAND",
      "Zip Code": " 91784",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1336290  ",
      "Longitude": " -117.64087 "
   },
   {
      "Vendor": "TARGET STORE T-0660",
      "Address": " 16964 SLOVER AVE",
      "City": "FONTANA",
      "Zip Code": " 92337",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0633080  ",
      "Longitude": " -117.43419 "
   },
   {
      "Vendor": "TARGET STORE T-1869",
      "Address": " 27320 LUGONIA AVE",
      "City": "REDLANDS",
      "Zip Code": " 92374",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0705020  ",
      "Longitude": " -117.20776 "
   },
   {
      "Vendor": "TARGET STORE T-2245",
      "Address": "E 4200 4TH ST",
      "City": "ONTARIO",
      "Zip Code": " 91764",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0769890  ",
      "Longitude": " -117.56145 "
   },
   {
      "Vendor": "TARGET STORE T-1958",
      "Address": " 15272 SUMMIT AVE",
      "City": "FONTANA",
      "Zip Code": " 92336",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1526770  ",
      "Longitude": " -117.47247 "
   },
   {
      "Vendor": "TARGET STORE T-0912",
      "Address": " 3944 GRAND AVE",
      "City": "CHINO",
      "Zip Code": " 91710",
      "County": " SAN BERNARDINO",
      "Latitude": "33.9986230  ",
      "Longitude": " -117.71888 "
   },
   {
      "Vendor": "TARGET STORE T-1423",
      "Address": " 9052 CENTRAL AVE",
      "City": "MONTCLAIR",
      "Zip Code": " 91763",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0895830  ",
      "Longitude": " -117.68989 "
   },
   {
      "Vendor": "ALBERTSONS #2303",
      "Address": " 7201 BOULDER AVE",
      "City": "HIGHLAND",
      "Zip Code": " 92346",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1236810  ",
      "Longitude": " -117.19413 "
   },
   {
      "Vendor": "ALBERTSONS #3513",
      "Address": " 20261 HIGHWAY 18",
      "City": "APPLE VALLEY",
      "Zip Code": " 92307",
      "County": " SAN BERNARDINO",
      "Latitude": "34.5251760  ",
      "Longitude": " -117.22026 "
   },
   {
      "Vendor": "ALBERTSONS #2515",
      "Address": " 3255 GRAND AVE",
      "City": "CHINO HILLS",
      "Zip Code": " 91709",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0010390  ",
      "Longitude": " -117.73433 "
   },
   {
      "Vendor": "ALBERTSONS #1319",
      "Address": "E 450 CYPRESS AVE",
      "City": "REDLANDS",
      "Zip Code": " 92373",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0489710  ",
      "Longitude": " -117.17147 "
   },
   {
      "Vendor": "ALBERTSONS #3520",
      "Address": " 11358 KENYON WAY",
      "City": "RANCHO CUCAMONGA",
      "Zip Code": " 91737",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1343050  ",
      "Longitude": " -117.55739 "
   },
   {
      "Vendor": "ALBERTSONS #3177",
      "Address": " 8850 FOOTHILL BLVD",
      "City": "RANCHO CUCAMONGA",
      "Zip Code": " 91730",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1067310  ",
      "Longitude": " -117.61267 "
   },
   {
      "Vendor": "ALBERTSONS #524",
      "Address": " 12013 CENTRAL AVE",
      "City": "CHINO",
      "Zip Code": " 91710",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0354450  ",
      "Longitude": " -117.68833 "
   },
   {
      "Vendor": "ALBERTSONS #3592",
      "Address": " 15970 LOS SERRANOS CNTYCLB DR",
      "City": "CHINO HILLS",
      "Zip Code": " 91709",
      "County": " SAN BERNARDINO",
      "Latitude": "33.9790850  ",
      "Longitude": " -117.71129 "
   },
   {
      "Vendor": "GOODWIN'S MARKET",
      "Address": " 24089 LAKE GREGORY DR",
      "City": "CRESTLINE",
      "Zip Code": " 92325",
      "County": " SAN BERNARDINO",
      "Latitude": "34.2432320  ",
      "Longitude": " -117.27754 "
   },
   {
      "Vendor": "CHILDREN'S NUTRITION CENTER",
      "Address": " 11450 BARTLETT AVE",
      "City": "ADELANTO",
      "Zip Code": " 92301",
      "County": " SAN BERNARDINO",
      "Latitude": "34.5794040  ",
      "Longitude": " -117.41508 "
   },
   {
      "Vendor": "EL SUPER #28",
      "Address": " 14950 BEAR VALLEY RD",
      "City": "VICTORVILLE",
      "Zip Code": " 92395",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4714230  ",
      "Longitude": " -117.33762 "
   },
   {
      "Vendor": "WAL-MART #2998",
      "Address": " 25755 BARTON RD",
      "City": "LOMA LINDA",
      "Zip Code": " 92354",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0472740  ",
      "Longitude": " -117.24223 "
   },
   {
      "Vendor": "WAL-MART #3796",
      "Address": "N 1333 MOUNTAIN AVE",
      "City": "ONTARIO",
      "Zip Code": " 91762",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0827530  ",
      "Longitude": " -117.67177 "
   },
   {
      "Vendor": "WAL-MART #1588",
      "Address": " 11896 AMARGOSA RD",
      "City": "VICTORVILLE",
      "Zip Code": " 92395",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4664680  ",
      "Longitude": " -117.35004 "
   },
   {
      "Vendor": "WAL-MART #1693",
      "Address": "W 2050 REDLANDS BLVD",
      "City": "REDLANDS",
      "Zip Code": " 92373",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0632910  ",
      "Longitude": " -117.22338 "
   },
   {
      "Vendor": "WAL-MART #1914",
      "Address": "E 4210 HIGHLAND AVE",
      "City": "HIGHLAND",
      "Zip Code": " 92346",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1367530  ",
      "Longitude": " -117.19567 "
   },
   {
      "Vendor": "WAL-MART #5691",
      "Address": "E 1445 FOOTHILL BLVD",
      "City": "UPLAND",
      "Zip Code": " 91786",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1085830  ",
      "Longitude": " -117.62978 "
   },
   {
      "Vendor": "WAL-MART #1756",
      "Address": " 17251 FOOTHILL BLVD",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1063790  ",
      "Longitude": " -117.42794 "
   },
   {
      "Vendor": "WAL-MART #1915",
      "Address": " 58501 29 PALMS HWY",
      "City": "YUCCA VALLEY",
      "Zip Code": " 92284",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1331210  ",
      "Longitude": " -116.38573 "
   },
   {
      "Vendor": "WAL-MART #3131",
      "Address": "W 300 BASELINE RD",
      "City": "RIALTO",
      "Zip Code": " 92376",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1215460  ",
      "Longitude": " -117.37447 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #45",
      "Address": " 17390 MAIN ST",
      "City": "HESPERIA",
      "Zip Code": " 92345",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4204280  ",
      "Longitude": " -117.28332 "
   },
   {
      "Vendor": "WAL-MART #1992",
      "Address": "W 1540 FOOTHILL BLVD",
      "City": "UPLAND",
      "Zip Code": " 91786",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1059340  ",
      "Longitude": " -117.67835 "
   },
   {
      "Vendor": "WAL-MART #4392",
      "Address": " 12234 PALMDALE BLVD",
      "City": "VICTORVILLE",
      "Zip Code": " 92392",
      "County": " SAN BERNARDINO",
      "Latitude": "34.5088230  ",
      "Longitude": " -117.39698 "
   },
   {
      "Vendor": "WAL-MART #2952",
      "Address": " 41200 MURRIETA HOT SPRINGS RD",
      "City": "MURRIETA",
      "Zip Code": " 92562",
      "County": " RIVERSIDE",
      "Latitude": "33.5527560  ",
      "Longitude": " -117.19558 "
   },
   {
      "Vendor": "WAL-MART STORE #3276",
      "Address": " 4001 HALLMARK PKWY",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92407",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1631810  ",
      "Longitude": " -117.33515 "
   },
   {
      "Vendor": "WAL-MART STORE #2333",
      "Address": " 20251 HWY 18",
      "City": "APPLE VALLEY",
      "Zip Code": " 92307",
      "County": " SAN BERNARDINO",
      "Latitude": "34.5257170  ",
      "Longitude": " -117.22288 "
   },
   {
      "Vendor": "EL SUPER #50",
      "Address": "N 1000 MOUNTAIN AVE",
      "City": "ONTARIO",
      "Zip Code": " 91762",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0765380  ",
      "Longitude": " -117.66898 "
   },
   {
      "Vendor": "MOMMY & ME NUTRITIONAL CENT",
      "Address": " 8922 BEECH AVE",
      "Second Address": " STE J",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0914930  ",
      "Longitude": " -117.47176 "
   },
   {
      "Vendor": "BABY OPTIONS NUTRITION CTR",
      "Address": " 15247 11TH ST",
      "Second Address": " STE 900",
      "City": "VICTORVILLE",
      "Zip Code": " 92395",
      "County": " SAN BERNARDINO",
      "Latitude": "34.5287480  ",
      "Longitude": " -117.29166 "
   },
   {
      "Vendor": "LA CADENA MARKET",
      "Address": " 17683 SAN BERNARDINO AVE",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0776570  ",
      "Longitude": " -117.41853 "
   },
   {
      "Vendor": "MI PUEBLO MERCADITO",
      "Address": " 9069 CITRUS AVE",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0889050  ",
      "Longitude": " -117.45327 "
   },
   {
      "Vendor": "TARGET STORE T-0188",
      "Address": "W 499 ORANGE SHOW RD",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92408",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0793580  ",
      "Longitude": " -117.29410 "
   },
   {
      "Vendor": "TARGET STORE T-0258",
      "Address": " 5555 PHILADELPHIA ST",
      "City": "CHINO",
      "Zip Code": " 91710",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0325300  ",
      "Longitude": " -117.68304 "
   },
   {
      "Vendor": "TARGET STORE T-0301",
      "Address": " 10576 FOOTHILL BLVD",
      "City": "RANCHO CUCAMONGA",
      "Zip Code": " 91730",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1083910  ",
      "Longitude": " -117.57385 "
   },
   {
      "Vendor": "ABC MINI MARKET",
      "Address": " 1331 KENDALL DR",
      "Second Address": " STE 8",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92407",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1681350  ",
      "Longitude": " -117.31476 "
   },
   {
      "Vendor": "TARGET STORE T-0939",
      "Address": " 19201 BEAR VALLEY RD",
      "City": "APPLE VALLEY",
      "Zip Code": " 92308",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4690620  ",
      "Longitude": " -117.24491 "
   },
   {
      "Vendor": "CHINO RANCH MARKET",
      "Address": " 5832 RIVERSIDE DR",
      "City": "CHINO",
      "Zip Code": " 91710",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0195300  ",
      "Longitude": " -117.67744 "
   },
   {
      "Vendor": "RIO RANCH MARKET #1",
      "Address": " 25745 BASELINE RD",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92410",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1203020  ",
      "Longitude": " -117.24251 "
   },
   {
      "Vendor": "RIO RANCH MARKET #7",
      "Address": " 11647 CHERRY AVE",
      "City": "FONTANA",
      "Zip Code": " 92337",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0427930  ",
      "Longitude": " -117.48704 "
   },
   {
      "Vendor": "SMART & FINAL #707",
      "Address": "N 1028 MOUNTAIN AVE",
      "City": "UPLAND",
      "Zip Code": " 91786",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1078470  ",
      "Longitude": " -117.67015 "
   },
   {
      "Vendor": "BABY & ME WORLD NUTRITION",
      "Address": "W 245 FRANCIS ST",
      "City": "ONTARIO",
      "Zip Code": " 91762",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0410630  ",
      "Longitude": " -117.65280 "
   },
   {
      "Vendor": "MOTHERS & KIDS NUTRITION #2",
      "Address": "N 2015 D ST",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92405",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1339570  ",
      "Longitude": " -117.29168 "
   },
   {
      "Vendor": "LOS JUNIORS MARKET 2",
      "Address": " 3548 CAJON BLVD",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92407",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1584510  ",
      "Longitude": " -117.33644 "
   },
   {
      "Vendor": "MOTHERS AND KIDS NUTRITION",
      "Address": "S 1513 RIVERSIDE AVE",
      "City": "RIALTO",
      "Zip Code": " 92376",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0735670  ",
      "Longitude": " -117.37008 "
   },
   {
      "Vendor": "SMART & FINAL #924",
      "Address": " 4200 CHINO HILLS PKWY",
      "City": "CHINO HILLS",
      "Zip Code": " 91709",
      "County": " SAN BERNARDINO",
      "Latitude": "33.9826970  ",
      "Longitude": " -117.71323 "
   },
   {
      "Vendor": "ALBERTSONS #599",
      "Address": "N 1910 CAMPUS AVE",
      "City": "UPLAND",
      "Zip Code": " 91784",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1313200  ",
      "Longitude": " -117.63718 "
   },
   {
      "Vendor": "BIG BEAR NUTRITION CENTER",
      "Address": " 41933 BIG BEAR BLVD",
      "City": "BIG BEAR LAKE",
      "Zip Code": " 92315",
      "County": " SAN BERNARDINO",
      "Latitude": "34.2427820  ",
      "Longitude": " -116.88688 "
   },
   {
      "Vendor": "CARDENAS MARKET #83",
      "Address": "S 1848-1850 EUCLID AVE",
      "City": "ONTARIO",
      "Zip Code": " 91762",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0400990  ",
      "Longitude": " -117.65254 "
   },
   {
      "Vendor": "CARDENAS MARKET #5",
      "Address": "E 720 HOLT BLVD",
      "City": "ONTARIO",
      "Zip Code": " 91761",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0630710  ",
      "Longitude": " -117.64034 "
   },
   {
      "Vendor": "CARDENAS MARKET #7",
      "Address": " 16721 VALLEY BLVD",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0703020  ",
      "Longitude": " -117.43958 "
   },
   {
      "Vendor": "CARDENAS MARKET #9",
      "Address": "W 250 FOOTHILL BLVD",
      "City": "RIALTO",
      "Zip Code": " 92376",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1070760  ",
      "Longitude": " -117.37317 "
   },
   {
      "Vendor": "CARDENAS MARKET #10",
      "Address": "N 1067 MT VERNON AVE",
      "City": "COLTON",
      "Zip Code": " 92324",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0749020  ",
      "Longitude": " -117.31391 "
   },
   {
      "Vendor": "CARDENAS MARKET #15",
      "Address": " 16212 FOOTHILL BLVD",
      "City": "FONTANA",
      "Zip Code": " 92335",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1075710  ",
      "Longitude": " -117.45121 "
   },
   {
      "Vendor": "CARDENAS MARKET #19",
      "Address": " 15555 MAIN ST",
      "Second Address": " STE B",
      "City": "HESPERIA",
      "Zip Code": " 92345",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4242800  ",
      "Longitude": " -117.32287 "
   },
   {
      "Vendor": "CARDENAS MARKET #24",
      "Address": "W 140 40TH ST",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92407",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1655600  ",
      "Longitude": " -117.28642 "
   },
   {
      "Vendor": "CARDENAS MARKET #29",
      "Address": "E 1837 4TH ST",
      "City": "ONTARIO",
      "Zip Code": " 91764",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0777830  ",
      "Longitude": " -117.61268 "
   },
   {
      "Vendor": "CARDENAS MARKET #81",
      "Address": "S 2450 VINEYARD AVE",
      "City": "ONTARIO",
      "Zip Code": " 91761",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0284370  ",
      "Longitude": " -117.61229 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1862",
      "Address": "S 1366 RIVERSIDE AVE",
      "City": "RIALTO",
      "Zip Code": " 92376",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0756060  ",
      "Longitude": " -117.37048 "
   },
   {
      "Vendor": "CHULYS & BABYS NUTRITIONAL",
      "Address": "W 802 COLTON AVE",
      "City": "REDLANDS",
      "Zip Code": " 92374",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0633030  ",
      "Longitude": " -117.19183 "
   },
   {
      "Vendor": "SMART & FINAL #733",
      "Address": "N 1023 MT. VERNON AVE",
      "City": "COLTON",
      "Zip Code": " 92324",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0745460  ",
      "Longitude": " -117.31423 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1879",
      "Address": " 301 MONTARA RD",
      "City": "BARSTOW",
      "Zip Code": " 92311",
      "County": " SAN BERNARDINO",
      "Latitude": "34.8841020  ",
      "Longitude": " -116.99355 "
   },
   {
      "Vendor": "RIO RANCH MARKET #3",
      "Address": "N 2337 SIERRA WAY",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92405",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1369550  ",
      "Longitude": " -117.28472 "
   },
   {
      "Vendor": "SMART & FINAL #741",
      "Address": " 27550 BASELINE RD",
      "City": "HIGHLAND",
      "Zip Code": " 92346",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1212920  ",
      "Longitude": " -117.20312 "
   },
   {
      "Vendor": "STATER BROS. MARKETS #200",
      "Address": " 7200 DAY CREEK BLVD",
      "City": "RANCHO CUCAMONGA",
      "Zip Code": " 91739",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1238400  ",
      "Longitude": " -117.53709 "
   },
   {
      "Vendor": "CARDENAS MARKET #36",
      "Address": "E 2045 HIGHLAND AVE",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92404",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1356690  ",
      "Longitude": " -117.24271 "
   },
   {
      "Vendor": "A-1 NUTRITION INC",
      "Address": "N 723 D ST",
      "City": "SAN BERNARDINO",
      "Zip Code": " 92401",
      "County": " SAN BERNARDINO",
      "Latitude": "34.1125250  ",
      "Longitude": " -117.29151 "
   },
   {
      "Vendor": "SUPER DEALS MARKET",
      "Address": " 11391 CEDAR AVE",
      "Second Address": " UNIT B",
      "City": "BLOOMINGTON",
      "Zip Code": " 92316",
      "County": " SAN BERNARDINO",
      "Latitude": "34.0468380  ",
      "Longitude": " -117.39599 "
   },
   {
      "Vendor": "VONS #2348",
      "Address": " 2606 DEL MAR HEIGHTS RD",
      "City": "DEL MAR",
      "Zip Code": " 92014",
      "County": " SAN DIEGO",
      "Latitude": "32.9491950  ",
      "Longitude": " -117.24640 "
   },
   {
      "Vendor": "VONS #2355",
      "Address": " 4145 30TH ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92104",
      "County": " SAN DIEGO",
      "Latitude": "32.7532350  ",
      "Longitude": " -117.12952 "
   },
   {
      "Vendor": "VONS #2344",
      "Address": "W 351 FELICITA AVE",
      "City": "ESCONDIDO",
      "Zip Code": " 92025",
      "County": " SAN DIEGO",
      "Latitude": "33.1029750  ",
      "Longitude": " -117.07338 "
   },
   {
      "Vendor": "VONS #2859",
      "Address": " 453 SANTA FE DR",
      "City": "ENCINITAS",
      "Zip Code": " 92024",
      "County": " SAN DIEGO",
      "Latitude": "33.0348220  ",
      "Longitude": " -117.28253 "
   },
   {
      "Vendor": "VONS #2121",
      "Address": "S 940 SANTA FE AVE",
      "City": "VISTA",
      "Zip Code": " 92083",
      "County": " SAN DIEGO",
      "Latitude": "33.1941170  ",
      "Longitude": " -117.23290 "
   },
   {
      "Vendor": "VONS #2134",
      "Address": " 10460 CLAIREMONT MESA BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92124",
      "County": " SAN DIEGO",
      "Latitude": "32.8301730  ",
      "Longitude": " -117.10431 "
   },
   {
      "Vendor": "VONS #2136",
      "Address": " 8310 MIRA MESA BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92126",
      "County": " SAN DIEGO",
      "Latitude": "32.9127750  ",
      "Longitude": " -117.14454 "
   },
   {
      "Vendor": "VONS #2142",
      "Address": " 2560 EL CAMINO REAL",
      "City": "CARLSBAD",
      "Zip Code": " 92008",
      "County": " SAN DIEGO",
      "Latitude": "33.1793230  ",
      "Longitude": " -117.32664 "
   },
   {
      "Vendor": "VONS #2130",
      "Address": " 4404 BONITA RD",
      "City": "BONITA",
      "Zip Code": " 91902",
      "County": " SAN DIEGO",
      "Latitude": "32.6607670  ",
      "Longitude": " -117.03261 "
   },
   {
      "Vendor": "VONS #2343",
      "Address": " 985 TAMARACK AVE",
      "City": "CARLSBAD",
      "Zip Code": " 92008",
      "County": " SAN DIEGO",
      "Latitude": "33.1525660  ",
      "Longitude": " -117.33405 "
   },
   {
      "Vendor": "VONS #2364",
      "Address": " 868 ORANGE ST",
      "City": "CORONADO",
      "Zip Code": " 92118",
      "County": " SAN DIEGO",
      "Latitude": "32.6878950  ",
      "Longitude": " -117.17919 "
   },
   {
      "Vendor": "VONS #2359",
      "Address": " 6555 MISSION GORGE RD",
      "City": "SAN DIEGO",
      "Zip Code": " 92120",
      "County": " SAN DIEGO",
      "Latitude": "32.7923210  ",
      "Longitude": " -117.09646 "
   },
   {
      "Vendor": "VONS #2370",
      "Address": " 3993 GOVERNOR DR",
      "City": "SAN DIEGO",
      "Zip Code": " 92122",
      "County": " SAN DIEGO",
      "Latitude": "32.8534780  ",
      "Longitude": " -117.20317 "
   },
   {
      "Vendor": "VONS #2349",
      "Address": " 13438 POWAY RD",
      "City": "POWAY",
      "Zip Code": " 92064",
      "County": " SAN DIEGO",
      "Latitude": "32.9575010  ",
      "Longitude": " -117.03949 "
   },
   {
      "Vendor": "VONS #2040",
      "Address": " 5555 BALBOA AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92111",
      "County": " SAN DIEGO",
      "Latitude": "32.8198040  ",
      "Longitude": " -117.18026 "
   },
   {
      "Vendor": "VONS #2079",
      "Address": " 11986 BERNARDO PLAZA DR",
      "City": "SAN DIEGO",
      "Zip Code": " 92128",
      "County": " SAN DIEGO",
      "Latitude": "33.0207370  ",
      "Longitude": " -117.07263 "
   },
   {
      "Vendor": "VONS #2116",
      "Address": " 1702 GARNET AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92109",
      "County": " SAN DIEGO",
      "Latitude": "32.8002230  ",
      "Longitude": " -117.23887 "
   },
   {
      "Vendor": "CAMP PENDLETON COMMISSARY",
      "Address": " BLDG 20850 VANDERGRIFT BLVD",
      "City": "CAMP PENDLETON MCB",
      "Zip Code": " 92055",
      "County": " SAN DIEGO",
      "Latitude": "33.2983700  ",
      "Longitude": " -117.34891 "
   },
   {
      "Vendor": "SAN ONOFRE COMMISSARY",
      "Address": " BLDG 51094 BASILONE RD",
      "City": "MCB CAMP PENDLETON",
      "Zip Code": " 92055",
      "County": " SAN DIEGO",
      "Latitude": "33.3858750  ",
      "Longitude": " -117.58015 "
   },
   {
      "Vendor": "VONS #2156",
      "Address": "E 2345 VALLEY PKWY",
      "City": "ESCONDIDO",
      "Zip Code": " 92027",
      "County": " SAN DIEGO",
      "Latitude": "33.1396810  ",
      "Longitude": " -117.04456 "
   },
   {
      "Vendor": "RALPHS #168",
      "Address": "N 125 EL CAMINO REAL",
      "City": "ENCINITAS",
      "Zip Code": " 92024",
      "County": " SAN DIEGO",
      "Latitude": "33.0478770  ",
      "Longitude": " -117.25739 "
   },
   {
      "Vendor": "VONS #4018",
      "Address": " 10016 SCRIPPS RANCH BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92131",
      "County": " SAN DIEGO",
      "Latitude": "32.9030420  ",
      "Longitude": " -117.10038 "
   },
   {
      "Vendor": "VONS #2049",
      "Address": "W 330 EL NORTE PKWY",
      "City": "ESCONDIDO",
      "Zip Code": " 92026",
      "County": " SAN DIEGO",
      "Latitude": "33.1425500  ",
      "Longitude": " -117.09531 "
   },
   {
      "Vendor": "VONS #2358",
      "Address": " 3610 ADAMS AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92116",
      "County": " SAN DIEGO",
      "Latitude": "32.7633060  ",
      "Longitude": " -117.11483 "
   },
   {
      "Vendor": "MIRAMAR COMMISSARY",
      "Address": " 2661 MOORE AVE",
      "Second Address": " BLDG 2661",
      "City": "SAN DIEGO",
      "Zip Code": " 92145",
      "County": " SAN DIEGO",
      "Latitude": "32.7491640  ",
      "Longitude": " -117.19450 "
   },
   {
      "Vendor": "VONS #2338",
      "Address": " 665 SATURN BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92154",
      "County": " SAN DIEGO",
      "Latitude": "32.5850920  ",
      "Longitude": " -117.09028 "
   },
   {
      "Vendor": "VONS #2352",
      "Address": " 6155 EL CAJON BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92115",
      "County": " SAN DIEGO",
      "Latitude": "32.7623960  ",
      "Longitude": " -117.06530 "
   },
   {
      "Vendor": "VONS #2053",
      "Address": " 3645 MIDWAY DR",
      "City": "SAN DIEGO",
      "Zip Code": " 92110",
      "County": " SAN DIEGO",
      "Latitude": "32.7528540  ",
      "Longitude": " -117.21642 "
   },
   {
      "Vendor": "VONS #2120",
      "Address": " 4725 CLAIREMONT DR",
      "City": "SAN DIEGO",
      "Zip Code": " 92117",
      "County": " SAN DIEGO",
      "Latitude": "32.8299160  ",
      "Longitude": " -117.20613 "
   },
   {
      "Vendor": "IMPERIAL BEACH COMMISSARY",
      "Address": " 1500 13TH ST",
      "Second Address": " BLDG 1264",
      "City": "IMPERIAL BEACH",
      "Zip Code": " 91932",
      "County": " SAN DIEGO",
      "Latitude": "32.5689270  ",
      "Longitude": " -117.10558 "
   },
   {
      "Vendor": "APPLE TREE MARKET",
      "Address": " 4976 NEWPORT AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92107",
      "County": " SAN DIEGO",
      "Latitude": "32.7468230  ",
      "Longitude": " -117.25037 "
   },
   {
      "Vendor": "RALPHS #159",
      "Address": " 3011 ALTA VIEW DR",
      "City": "SAN DIEGO",
      "Zip Code": " 92139",
      "County": " SAN DIEGO",
      "Latitude": "32.6769890  ",
      "Longitude": " -117.03814 "
   },
   {
      "Vendor": "FAIRMOUNT SUPER MERCADO",
      "Address": " 3086 FAIRMOUNT AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92105",
      "County": " SAN DIEGO",
      "Latitude": "32.7386200  ",
      "Longitude": " -117.10133 "
   },
   {
      "Vendor": "STUMP'S MARKET",
      "Address": " 3770 VOLTAIRE ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92107",
      "County": " SAN DIEGO",
      "Latitude": "32.7412110  ",
      "Longitude": " -117.22919 "
   },
   {
      "Vendor": "RALPHS #075",
      "Address": " 780 OTAY LAKES RD",
      "City": "CHULA VISTA",
      "Zip Code": " 91910",
      "County": " SAN DIEGO",
      "Latitude": "32.6446950  ",
      "Longitude": " -117.00140 "
   },
   {
      "Vendor": "RALPHS #167",
      "Address": " 3455 DEL MAR HEIGHTS RD",
      "City": "SAN DIEGO",
      "Zip Code": " 92130",
      "County": " SAN DIEGO",
      "Latitude": "32.9527750  ",
      "Longitude": " -117.23274 "
   },
   {
      "Vendor": "VONS #2345",
      "Address": "W 1000 EL NORTE PKWY",
      "City": "ESCONDIDO",
      "Zip Code": " 92026",
      "County": " SAN DIEGO",
      "Latitude": "33.1471130  ",
      "Longitude": " -117.10684 "
   },
   {
      "Vendor": "RALPHS #175",
      "Address": " 7140 AVENIDA ENCINAS",
      "City": "CARLSBAD",
      "Zip Code": " 92011",
      "County": " SAN DIEGO",
      "Latitude": "33.1005530  ",
      "Longitude": " -117.31199 "
   },
   {
      "Vendor": "RALPHS #057",
      "Address": " 2652 JAMACHA RD",
      "City": "EL CAJON",
      "Zip Code": " 92019",
      "County": " SAN DIEGO",
      "Latitude": "32.7444240  ",
      "Longitude": " -116.93324 "
   },
   {
      "Vendor": "RALPHS #077",
      "Address": " 5680 MISSION CENTER RD",
      "City": "SAN DIEGO",
      "Zip Code": " 92108",
      "County": " SAN DIEGO",
      "Latitude": "32.7757380  ",
      "Longitude": " -117.15509 "
   },
   {
      "Vendor": "RALPHS #051",
      "Address": " 1030 UNIVERSITY AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92103",
      "County": " SAN DIEGO",
      "Latitude": "32.7487000  ",
      "Longitude": " -117.15465 "
   },
   {
      "Vendor": "RALPHS #019",
      "Address": " 11875 CARMEL MOUNTAIN RD",
      "City": "SAN DIEGO",
      "Zip Code": " 92128",
      "County": " SAN DIEGO",
      "Latitude": "32.9811490  ",
      "Longitude": " -117.07589 "
   },
   {
      "Vendor": "NORTH ISLAND COMMISSARY",
      "Address": " BLDG 2017 COLORADO ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92135",
      "County": " SAN DIEGO",
      "Latitude": "32.7028020  ",
      "Longitude": " -117.18490 "
   },
   {
      "Vendor": "SAN DIEGO NAVSTA COMMISSARY",
      "Address": " 2525 CALLAGAN HWY",
      "Second Address": " BLDG 3629",
      "City": "SAN DIEGO",
      "Zip Code": " 92136",
      "County": " SAN DIEGO",
      "Latitude": "32.6905940  ",
      "Longitude": " -117.12795 "
   },
   {
      "Vendor": "FOODLAND SUPERMARKET #1",
      "Address": " 920 CARDIFF ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92114",
      "County": " SAN DIEGO",
      "Latitude": "32.7158960  ",
      "Longitude": " -117.02626 "
   },
   {
      "Vendor": "FOOD BOWL MARKET",
      "Address": " 3035 CEDAR ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92102",
      "County": " SAN DIEGO",
      "Latitude": "32.7220390  ",
      "Longitude": " -117.12902 "
   },
   {
      "Vendor": "RALPHS #090",
      "Address": "E 2417 VALLEY PKWY",
      "City": "ESCONDIDO",
      "Zip Code": " 92027",
      "County": " SAN DIEGO",
      "Latitude": "33.1406810  ",
      "Longitude": " -117.04290 "
   },
   {
      "Vendor": "VONS #3044",
      "Address": " 1201 AVOCADO AVE",
      "City": "EL CAJON",
      "Zip Code": " 92020",
      "County": " SAN DIEGO",
      "Latitude": "32.7788950  ",
      "Longitude": " -116.95649 "
   },
   {
      "Vendor": "VONS #2065",
      "Address": " 6951 EL CAMINO REAL",
      "City": "CARLSBAD",
      "Zip Code": " 92009",
      "County": " SAN DIEGO",
      "Latitude": "33.1039730  ",
      "Longitude": " -117.26688 "
   },
   {
      "Vendor": "VONS #2081",
      "Address": " 13255 BLACK MOUNTAIN ROAD",
      "City": "SAN DIEGO",
      "Zip Code": " 92129",
      "County": " SAN DIEGO",
      "Latitude": "32.9586920  ",
      "Longitude": " -117.12678 "
   },
   {
      "Vendor": "VONS #2093",
      "Address": " 8011 UNIVERSITY AVE",
      "City": "LA MESA",
      "Zip Code": " 91941",
      "County": " SAN DIEGO",
      "Latitude": "32.7656390  ",
      "Longitude": " -117.02533 "
   },
   {
      "Vendor": "PAVILIONS #2119",
      "Address": " 3850 VALLEY CENTRE DR",
      "City": "SAN DIEGO",
      "Zip Code": " 92130",
      "County": " SAN DIEGO",
      "Latitude": "32.9389820  ",
      "Longitude": " -117.23114 "
   },
   {
      "Vendor": "VONS #2012",
      "Address": " 7788 REGENTS RD",
      "City": "SAN DIEGO",
      "Zip Code": " 92122",
      "County": " SAN DIEGO",
      "Latitude": "32.8625900  ",
      "Longitude": " -117.22344 "
   },
   {
      "Vendor": "FOODLAND #2",
      "Address": " 303 HIGHLAND AVE",
      "City": "NATIONAL CITY",
      "Zip Code": " 91950",
      "County": " SAN DIEGO",
      "Latitude": "32.6826750  ",
      "Longitude": " -117.09948 "
   },
   {
      "Vendor": "FOODLAND #3",
      "Address": " 5075 FEDERAL BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92102",
      "County": " SAN DIEGO",
      "Latitude": "32.7209760  ",
      "Longitude": " -117.08564 "
   },
   {
      "Vendor": "FOODLAND #8",
      "Address": " 646 E ST",
      "City": "CHULA VISTA",
      "Zip Code": " 91910",
      "County": " SAN DIEGO",
      "Latitude": "32.6399830  ",
      "Longitude": " -117.09551 "
   },
   {
      "Vendor": "DANIEL'S MARKET",
      "Address": "S 5256 MISSION RD",
      "Second Address": " UNIT 701",
      "City": "BONSALL",
      "Zip Code": " 92003",
      "County": " SAN DIEGO",
      "Latitude": "33.2961150  ",
      "Longitude": " -117.22216 "
   },
   {
      "Vendor": "MURPHY'S MARKET #1",
      "Address": " 3596 FAIRMOUNT AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92105",
      "County": " SAN DIEGO",
      "Latitude": "32.7438430  ",
      "Longitude": " -117.10118 "
   },
   {
      "Vendor": "WRIGLEY'S SUPERMARKET",
      "Address": "N 34 EUCLID AVE",
      "City": "NATIONAL CITY",
      "Zip Code": " 91950",
      "County": " SAN DIEGO",
      "Latitude": "32.6905430  ",
      "Longitude": " -117.08514 "
   },
   {
      "Vendor": "FOOD 4 LESS #333",
      "Address": " 7730 HAZARD CENTER DR",
      "City": "SAN DIEGO",
      "Zip Code": " 92108",
      "County": " SAN DIEGO",
      "Latitude": "32.7719190  ",
      "Longitude": " -117.15566 "
   },
   {
      "Vendor": "FOOD 4 LESS #349",
      "Address": " 9430 CUYAMACA ST",
      "City": "SANTEE",
      "Zip Code": " 92071",
      "County": " SAN DIEGO",
      "Latitude": "32.8485760  ",
      "Longitude": " -116.98367 "
   },
   {
      "Vendor": "FOOD 4 LESS #374",
      "Address": " 5975 UNIVERSITY AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92115",
      "County": " SAN DIEGO",
      "Latitude": "32.7508830  ",
      "Longitude": " -117.06815 "
   },
   {
      "Vendor": "FOOD 4 LESS #347",
      "Address": " 4995 SHAWLINE ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92111",
      "County": " SAN DIEGO",
      "Latitude": "32.8313760  ",
      "Longitude": " -117.16306 "
   },
   {
      "Vendor": "FOOD 4 LESS #346",
      "Address": "E 1320 30TH ST",
      "City": "NATIONAL CITY",
      "Zip Code": " 91950",
      "County": " SAN DIEGO",
      "Latitude": "32.6602030  ",
      "Longitude": " -117.08587 "
   },
   {
      "Vendor": "FOOD 4 LESS #345",
      "Address": "N 644 BROADWAY",
      "City": "ESCONDIDO",
      "Zip Code": " 92025",
      "County": " SAN DIEGO",
      "Latitude": "33.1285500  ",
      "Longitude": " -117.08324 "
   },
   {
      "Vendor": "VONS #2144",
      "Address": "N 262 EL CAMINO REAL",
      "City": "ENCINITAS",
      "Zip Code": " 92024",
      "County": " SAN DIEGO",
      "Latitude": "33.0520670  ",
      "Longitude": " -117.26102 "
   },
   {
      "Vendor": "VONS #2115",
      "Address": " 620 DENNERY RD",
      "City": "SAN DIEGO",
      "Zip Code": " 92154",
      "County": " SAN DIEGO",
      "Latitude": "32.5825710  ",
      "Longitude": " -117.03255 "
   },
   {
      "Vendor": "VONS #2118",
      "Address": " 3550 MURPHY CANYON RD",
      "City": "SAN DIEGO",
      "Zip Code": " 92123",
      "County": " SAN DIEGO",
      "Latitude": "32.8075460  ",
      "Longitude": " -117.11602 "
   },
   {
      "Vendor": "VONS #2360",
      "Address": " 845 COLLEGE BLVD",
      "City": "OCEANSIDE",
      "Zip Code": " 92057",
      "County": " SAN DIEGO",
      "Latitude": "33.2412330  ",
      "Longitude": " -117.29438 "
   },
   {
      "Vendor": "RALPHS #207",
      "Address": " 4315 MISSION BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92109",
      "County": " SAN DIEGO",
      "Latitude": "32.7944040  ",
      "Longitude": " -117.25425 "
   },
   {
      "Vendor": "EL PICADOR FOODS",
      "Address": " 3702 DEL SOL BLVD",
      "Second Address": " STE B",
      "City": "SAN DIEGO",
      "Zip Code": " 92154",
      "County": " SAN DIEGO",
      "Latitude": "32.5737870  ",
      "Longitude": " -117.05550 "
   },
   {
      "Vendor": "APPLE TREE MARKET II",
      "Address": " 1556 3RD AVE",
      "City": "CHULA VISTA",
      "Zip Code": " 91911",
      "County": " SAN DIEGO",
      "Latitude": "32.5992490  ",
      "Longitude": " -117.06472 "
   },
   {
      "Vendor": "RALPHS #108",
      "Address": " 8657 VILLA LA JOLLA DR",
      "Second Address": " UNIT 201",
      "City": "LA JOLLA",
      "Zip Code": " 92037",
      "County": " SAN DIEGO",
      "Latitude": "32.8657390  ",
      "Longitude": " -117.23193 "
   },
   {
      "Vendor": "VONS #2071",
      "Address": " 2250 OTAY LAKES RD",
      "City": "CHULA VISTA",
      "Zip Code": " 91915",
      "County": " SAN DIEGO",
      "Latitude": "32.6474270  ",
      "Longitude": " -116.96725 "
   },
   {
      "Vendor": "FOOD 4 LESS #318",
      "Address": " 7420 BROADWAY ST",
      "City": "LEMON GROVE",
      "Zip Code": " 91945",
      "County": " SAN DIEGO",
      "Latitude": "32.7429370  ",
      "Longitude": " -117.03768 "
   },
   {
      "Vendor": "FOOD 4 LESS #300",
      "Address": " 500 HACIENDA DR",
      "City": "VISTA",
      "Zip Code": " 92081",
      "County": " SAN DIEGO",
      "Latitude": "33.1928670  ",
      "Longitude": " -117.25093 "
   },
   {
      "Vendor": "KEIL'S FOOD STORES",
      "Address": " 7403 JACKSON DR",
      "City": "SAN DIEGO",
      "Zip Code": " 92119",
      "County": " SAN DIEGO",
      "Latitude": "32.8025470  ",
      "Longitude": " -117.04423 "
   },
   {
      "Vendor": "RALPHS #123",
      "Address": " 101 G ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92101",
      "County": " SAN DIEGO",
      "Latitude": "32.7121100  ",
      "Longitude": " -117.16335 "
   },
   {
      "Vendor": "RALPHS #220",
      "Address": " 6670 MONTEZUMA RD",
      "City": "SAN DIEGO",
      "Zip Code": " 92115",
      "County": " SAN DIEGO",
      "Latitude": "32.7692440  ",
      "Longitude": " -117.05437 "
   },
   {
      "Vendor": "EL CAJON NUTRITION CENTER",
      "Address": " 323 VAN HOUTEN AVE",
      "City": "EL CAJON",
      "Zip Code": " 92020",
      "County": " SAN DIEGO",
      "Latitude": "32.7921350  ",
      "Longitude": " -116.96616 "
   },
   {
      "Vendor": "EGG MARKET",
      "Address": "S 2202 SANTA FE AVE",
      "City": "VISTA",
      "Zip Code": " 92084",
      "County": " SAN DIEGO",
      "Latitude": "33.1706600  ",
      "Longitude": " -117.20658 "
   },
   {
      "Vendor": "FOOD 4 LESS #394",
      "Address": " 444 BROADWAY",
      "City": "EL CAJON",
      "Zip Code": " 92021",
      "County": " SAN DIEGO",
      "Latitude": "32.8086300  ",
      "Longitude": " -116.95759 "
   },
   {
      "Vendor": "VONS #2327",
      "Address": " 931 LOMAS SANTA FE DR",
      "City": "SOLANA BEACH",
      "Zip Code": " 92075",
      "County": " SAN DIEGO",
      "Latitude": "32.9956620  ",
      "Longitude": " -117.25422 "
   },
   {
      "Vendor": "KAELIN'S MARKET",
      "Address": "E 1435 MAIN ST",
      "City": "EL CAJON",
      "Zip Code": " 92021",
      "County": " SAN DIEGO",
      "Latitude": "32.8005230  ",
      "Longitude": " -116.92933 "
   },
   {
      "Vendor": "VONS #2107",
      "Address": " 10675 SCRIPPS POWAY PKWY",
      "City": "SAN DIEGO",
      "Zip Code": " 92131",
      "County": " SAN DIEGO",
      "Latitude": "32.9358790  ",
      "Longitude": " -117.09849 "
   },
   {
      "Vendor": "VONS #2323",
      "Address": " 7544 GIRARD AVE",
      "City": "LA JOLLA",
      "Zip Code": " 92037",
      "County": " SAN DIEGO",
      "Latitude": "32.8416400  ",
      "Longitude": " -117.27330 "
   },
   {
      "Vendor": "RED BIRD MARKET",
      "Address": " 2035 HIGHLAND AVE",
      "City": "NATIONAL CITY",
      "Zip Code": " 91950",
      "County": " SAN DIEGO",
      "Latitude": "32.6672060  ",
      "Longitude": " -117.09411 "
   },
   {
      "Vendor": "NUTRITION EXPRESS #1",
      "Address": " 7612 LINDA VISTA RD",
      "Second Address": " STE 110",
      "City": "SAN DIEGO",
      "Zip Code": " 92111",
      "County": " SAN DIEGO",
      "Latitude": "32.8017650  ",
      "Longitude": " -117.15821 "
   },
   {
      "Vendor": "WIRE MOUNTAIN",
      "Address": "  BUILDING 201015",
      "City": "CAMP PENDLETON",
      "Zip Code": " 92055",
      "County": " SAN DIEGO",
      "Latitude": "33.2213890  ",
      "Longitude": " -117.38450 "
   },
   {
      "Vendor": "STUART MESA",
      "Address": "  BUILDING 31000",
      "City": "CAMP PENDLETON",
      "Zip Code": " 92055",
      "County": " SAN DIEGO",
      "Latitude": "33.2514450  ",
      "Longitude": " -117.40460 "
   },
   {
      "Vendor": "MAINSIDE MARINE MART",
      "Address": "  BUILDING 15110",
      "City": "CAMP PENDLETON",
      "Zip Code": " 92055",
      "County": " SAN DIEGO",
      "Latitude": "33.3020440  ",
      "Longitude": " -117.31046 "
   },
   {
      "Vendor": "RINCON INDIAN RESERV. MKT.",
      "Address": " 34323 VALLEY CENTER RD",
      "City": "VALLEY CENTER",
      "Zip Code": " 92082",
      "County": " SAN DIEGO",
      "Latitude": "33.2815240  ",
      "Longitude": " -116.95383 "
   },
   {
      "Vendor": "STATER BROS. #140",
      "Address": "N 635 BROADWAY",
      "City": "ESCONDIDO",
      "Zip Code": " 92025",
      "County": " SAN DIEGO",
      "Latitude": "33.1273050  ",
      "Longitude": " -117.08615 "
   },
   {
      "Vendor": "STATER BROS. #150",
      "Address": " 3770 MISSION AVE",
      "City": "OCEANSIDE",
      "Zip Code": " 92054",
      "County": " SAN DIEGO",
      "Latitude": "33.2264730  ",
      "Longitude": " -117.33335 "
   },
   {
      "Vendor": "STATER BROS. #151",
      "Address": " 2170 VISTA WAY",
      "City": "OCEANSIDE",
      "Zip Code": " 92054",
      "County": " SAN DIEGO",
      "Latitude": "33.1820140  ",
      "Longitude": " -117.34450 "
   },
   {
      "Vendor": "STATER BROS. #156",
      "Address": " 780 SYCAMORE AVE",
      "City": "VISTA",
      "Zip Code": " 92083",
      "County": " SAN DIEGO",
      "Latitude": "33.1630340  ",
      "Longitude": " -117.21770 "
   },
   {
      "Vendor": "STATER BROS. #157",
      "Address": "N 1451 SANTA FE AVE",
      "City": "VISTA",
      "Zip Code": " 92084",
      "County": " SAN DIEGO",
      "Latitude": "33.2203260  ",
      "Longitude": " -117.24373 "
   },
   {
      "Vendor": "STATER BROS. #158",
      "Address": "N 1048 EL CAMINO REAL",
      "City": "ENCINITAS",
      "Zip Code": " 92024",
      "County": " SAN DIEGO",
      "Latitude": "33.0671630  ",
      "Longitude": " -117.26580 "
   },
   {
      "Vendor": "STATER BROS. #162",
      "Address": " 13589 POWAY RD",
      "City": "POWAY",
      "Zip Code": " 92064",
      "County": " SAN DIEGO",
      "Latitude": "32.9558580  ",
      "Longitude": " -117.03784 "
   },
   {
      "Vendor": "STATER BROS. #163",
      "Address": " 1674 MAIN ST",
      "City": "RAMONA",
      "Zip Code": " 92065",
      "County": " SAN DIEGO",
      "Latitude": "33.0351720  ",
      "Longitude": " -116.87924 "
   },
   {
      "Vendor": "STATER BROS. #167",
      "Address": " 9909 CARMEL MOUNTAIN RD",
      "City": "SAN DIEGO",
      "Zip Code": " 92129",
      "County": " SAN DIEGO",
      "Latitude": "32.9597090  ",
      "Longitude": " -117.11363 "
   },
   {
      "Vendor": "LA POSTA MARKET",
      "Address": " 2796 K ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92102",
      "County": " SAN DIEGO",
      "Latitude": "32.7086750  ",
      "Longitude": " -117.13398 "
   },
   {
      "Vendor": "STATER BROS. #152",
      "Address": "E 1330 MISSION RD",
      "City": "SAN MARCOS",
      "Zip Code": " 92069",
      "County": " SAN DIEGO",
      "Latitude": "33.1368900  ",
      "Longitude": " -117.12953 "
   },
   {
      "Vendor": "MISSION WEST MARKET",
      "Address": "W 478 MISSION RD",
      "Second Address": " STE 157",
      "City": "SAN MARCOS",
      "Zip Code": " 92069",
      "County": " SAN DIEGO",
      "Latitude": "33.1449340  ",
      "Longitude": " -117.17190 "
   },
   {
      "Vendor": "MINNEHAHA FOOD MARKET",
      "Address": " 4990 UNIVERSITY AVE",
      "Second Address": " STE B & C",
      "City": "SAN DIEGO",
      "Zip Code": " 92105",
      "County": " SAN DIEGO",
      "Latitude": "32.7497710  ",
      "Longitude": " -117.08730 "
   },
   {
      "Vendor": "FOOD 4 LESS #763",
      "Address": "N 312 EUCLID AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92114",
      "County": " SAN DIEGO",
      "Latitude": "32.7087190  ",
      "Longitude": " -117.08528 "
   },
   {
      "Vendor": "LA PALAPA #2",
      "Address": " 2365 REO DR",
      "City": "SAN DIEGO",
      "Zip Code": " 92139",
      "County": " SAN DIEGO",
      "Latitude": "32.6758520  ",
      "Longitude": " -117.06449 "
   },
   {
      "Vendor": "FOOD 4 LESS #780",
      "Address": " 660 PALOMAR ST",
      "City": "CHULA VISTA",
      "Zip Code": " 91911",
      "County": " SAN DIEGO",
      "Latitude": "32.6034100  ",
      "Longitude": " -117.08317 "
   },
   {
      "Vendor": "BIG BEN MARKET",
      "Address": "E 108 8TH ST",
      "City": "NATIONAL CITY",
      "Zip Code": " 91950",
      "County": " SAN DIEGO",
      "Latitude": "32.6760220  ",
      "Longitude": " -117.10548 "
   },
   {
      "Vendor": "RALPHS #683",
      "Address": " 306 TWIN OAKS VALLEY RD",
      "City": "SAN MARCOS",
      "Zip Code": " 92078",
      "County": " SAN DIEGO",
      "Latitude": "33.1307360  ",
      "Longitude": " -117.16690 "
   },
   {
      "Vendor": "RALPHS #235",
      "Address": "E 659 PALOMAR ST",
      "City": "CHULA VISTA",
      "Zip Code": " 91911",
      "County": " SAN DIEGO",
      "Latitude": "32.6156590  ",
      "Longitude": " -117.02486 "
   },
   {
      "Vendor": "VONS #1897",
      "Address": " 9643 MISSION GORGE RD",
      "City": "SANTEE",
      "Zip Code": " 92071",
      "County": " SAN DIEGO",
      "Latitude": "32.8386150  ",
      "Longitude": " -116.98719 "
   },
   {
      "Vendor": "DON JOHN MARKET",
      "Address": "N 431 HIGHLAND AVE",
      "City": "NATIONAL CITY",
      "Zip Code": " 91950",
      "County": " SAN DIEGO",
      "Latitude": "32.6884840  ",
      "Longitude": " -117.10244 "
   },
   {
      "Vendor": "FOODLAND #4",
      "Address": "E 1099 MAIN ST",
      "City": "EL CAJON",
      "Zip Code": " 92021",
      "County": " SAN DIEGO",
      "Latitude": "32.7946930  ",
      "Longitude": " -116.94461 "
   },
   {
      "Vendor": "RALPHS #054",
      "Address": " 101 OLD GROVE RD",
      "City": "OCEANSIDE",
      "Zip Code": " 92057",
      "County": " SAN DIEGO",
      "Latitude": "33.2299970  ",
      "Longitude": " -117.30721 "
   },
   {
      "Vendor": "VONS #1797",
      "Address": " 4627 CARMEL MOUNTAIN RD",
      "City": "SAN DIEGO",
      "Zip Code": " 92130",
      "County": " SAN DIEGO",
      "Latitude": "32.9205730  ",
      "Longitude": " -117.21500 "
   },
   {
      "Vendor": "RALPHS #105",
      "Address": " 10525 4S COMMONS DR",
      "City": "SAN DIEGO",
      "Zip Code": " 92127",
      "County": " SAN DIEGO",
      "Latitude": "33.0195310  ",
      "Longitude": " -117.11298 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#201",
      "Address": " 924 HIGHLAND AVE",
      "Second Address": " UNIT 104",
      "City": "NATIONAL CITY",
      "Zip Code": " 91950",
      "County": " SAN DIEGO",
      "Latitude": "32.6768160  ",
      "Longitude": " -117.09825 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#200",
      "Address": " 220 EUCLID AVE",
      "Second Address": " STE 140",
      "City": "SAN DIEGO",
      "Zip Code": " 92114",
      "County": " SAN DIEGO",
      "Latitude": "32.7063500  ",
      "Longitude": " -117.08571 "
   },
   {
      "Vendor": "SUPERMERCADO MURPHY'S",
      "Address": " 4580 UNIVERSITY AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92105",
      "County": " SAN DIEGO",
      "Latitude": "32.7498880  ",
      "Longitude": " -117.09580 "
   },
   {
      "Vendor": "CARNIVAL SUPERMARKET",
      "Address": "E 1750 8TH ST",
      "City": "NATIONAL CITY",
      "Zip Code": " 91950",
      "County": " SAN DIEGO",
      "Latitude": "32.6804710  ",
      "Longitude": " -117.08874 "
   },
   {
      "Vendor": "LA PRESA MARKET",
      "Address": " 9307 JAMACHA BLVD",
      "City": "SPRING VALLEY",
      "Zip Code": " 91977",
      "County": " SAN DIEGO",
      "Latitude": "32.7076860  ",
      "Longitude": " -116.99967 "
   },
   {
      "Vendor": "PANCHO VILLA FARMERS MARK",
      "Address": " 3245 EL CAJON BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92104",
      "County": " SAN DIEGO",
      "Latitude": "32.7547810  ",
      "Longitude": " -117.12360 "
   },
   {
      "Vendor": "CARNIVAL SUPER MARKET",
      "Address": " 3560 ASHFORD ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92111",
      "County": " SAN DIEGO",
      "Latitude": "32.8087660  ",
      "Longitude": " -117.16058 "
   },
   {
      "Vendor": "LA POSTA MARKET #2",
      "Address": " 1266 IMPERIAL BEACH BLVD",
      "City": "IMPERIAL BEACH",
      "Zip Code": " 91932",
      "County": " SAN DIEGO",
      "Latitude": "32.5767010  ",
      "Longitude": " -117.10652 "
   },
   {
      "Vendor": "UNIVERSITY MARKET",
      "Address": " 4950 UNIVERSITY AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92105",
      "County": " SAN DIEGO",
      "Latitude": "32.7497690  ",
      "Longitude": " -117.08767 "
   },
   {
      "Vendor": "HILLTOP MARKET",
      "Address": " 1500 HILLTOP DR",
      "City": "CHULA VISTA",
      "Zip Code": " 91911",
      "County": " SAN DIEGO",
      "Latitude": "32.5997860  ",
      "Longitude": " -117.05185 "
   },
   {
      "Vendor": "LA NUEVA MICHOACANA MEAT MKT &",
      "Address": " 3793 NATIONAL AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92113",
      "County": " SAN DIEGO",
      "Latitude": "32.6956680  ",
      "Longitude": " -117.11283 "
   },
   {
      "Vendor": "LITTLE KIDS NUTRITION",
      "Address": "N 1021 SANTA FE AVE",
      "Second Address": " STE B",
      "City": "VISTA",
      "Zip Code": " 92084",
      "County": " SAN DIEGO",
      "Latitude": "33.2132460  ",
      "Longitude": " -117.24454 "
   },
   {
      "Vendor": "VONS #2735",
      "Address": " 2535 TRUXTUN RD",
      "Second Address": "  BLDG 28",
      "City": "SAN DIEGO",
      "Zip Code": " 92106",
      "County": " SAN DIEGO",
      "Latitude": "32.7287510  ",
      "Longitude": " -117.22068 "
   },
   {
      "Vendor": "LEW'S MARKET",
      "Address": " 3302 IMPERIAL AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92102",
      "County": " SAN DIEGO",
      "Latitude": "32.7070350  ",
      "Longitude": " -117.12237 "
   },
   {
      "Vendor": "TROPICANA MARKET",
      "Address": "N 829 SANTA FE AVE",
      "City": "VISTA",
      "Zip Code": " 92084",
      "County": " SAN DIEGO",
      "Latitude": "33.2109200  ",
      "Longitude": " -117.24485 "
   },
   {
      "Vendor": "NORTHGATE MARKET #26",
      "Address": " 2909 CORONADO AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92154",
      "County": " SAN DIEGO",
      "Latitude": "32.5760210  ",
      "Longitude": " -117.07018 "
   },
   {
      "Vendor": "NORTHGATE MARKET #27",
      "Address": " 1058 3RD AVE",
      "City": "CHULA VISTA",
      "Zip Code": " 91911",
      "County": " SAN DIEGO",
      "Latitude": "32.6140750  ",
      "Longitude": " -117.07082 "
   },
   {
      "Vendor": "NORTHGATE MARKET #28",
      "Address": "N 606 ESCONDIDO BLVD",
      "City": "ESCONDIDO",
      "Zip Code": " 92025",
      "County": " SAN DIEGO",
      "Latitude": "33.1271200  ",
      "Longitude": " -117.08702 "
   },
   {
      "Vendor": "NORTHGATE MARKET #29",
      "Address": "E 1150 VISTA WAY",
      "City": "VISTA",
      "Zip Code": " 92084",
      "County": " SAN DIEGO",
      "Latitude": "33.2163740  ",
      "Longitude": " -117.22713 "
   },
   {
      "Vendor": "NORTHGATE MARKET #30",
      "Address": "S 1346 MISSION RD",
      "City": "FALLBROOK",
      "Zip Code": " 92028",
      "County": " SAN DIEGO",
      "Latitude": "33.3684800  ",
      "Longitude": " -117.24982 "
   },
   {
      "Vendor": "VALLEY MAX SUPERMARKET",
      "Address": "E 2040 VALLEY PKWY",
      "City": "ESCONDIDO",
      "Zip Code": " 92027",
      "County": " SAN DIEGO",
      "Latitude": "33.1387720  ",
      "Longitude": " -117.05121 "
   },
   {
      "Vendor": "MANOLO FARMERS MARKET 5",
      "Address": " 3550 NATIONAL AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92113",
      "County": " SAN DIEGO",
      "Latitude": "32.6970500  ",
      "Longitude": " -117.11756 "
   },
   {
      "Vendor": "VONS #2826",
      "Address": " 1745 EASTLAKE PKWY",
      "City": "CHULA VISTA",
      "Zip Code": " 91915",
      "County": " SAN DIEGO",
      "Latitude": "32.6195560  ",
      "Longitude": " -116.96201 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #30",
      "Address": "E 1315 VALLEY PARKWAY",
      "City": "ESCONDIDO",
      "Zip Code": " 92027",
      "County": " SAN DIEGO",
      "Latitude": "33.1305270  ",
      "Longitude": " -117.06421 "
   },
   {
      "Vendor": "SMART & FINAL #347",
      "Address": " 1220 PLAZA BLVD",
      "City": "NATIONAL CITY",
      "Zip Code": " 91950",
      "County": " SAN DIEGO",
      "Latitude": "32.6759370  ",
      "Longitude": " -117.09306 "
   },
   {
      "Vendor": "SMART & FINAL #463",
      "Address": " 3141 MAIN ST",
      "City": "CHULA VISTA",
      "Zip Code": " 91911",
      "County": " SAN DIEGO",
      "Latitude": "32.5942130  ",
      "Longitude": " -117.06591 "
   },
   {
      "Vendor": "BEST NUTRITION STORE",
      "Address": " 155 JAMACHA RD",
      "City": "EL CAJON",
      "Zip Code": " 92019",
      "County": " SAN DIEGO",
      "Latitude": "32.7943540  ",
      "Longitude": " -116.93563 "
   },
   {
      "Vendor": "STATER BROS. #186",
      "Address": " 2687 GATEWAY RD",
      "City": "CARLSBAD",
      "Zip Code": " 92009",
      "County": " SAN DIEGO",
      "Latitude": "33.1266310  ",
      "Longitude": " -117.25190 "
   },
   {
      "Vendor": "NORTHGATE MARKET #21",
      "Address": "S 1410 43RD ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92113",
      "County": " SAN DIEGO",
      "Latitude": "32.6914700  ",
      "Longitude": " -117.10366 "
   },
   {
      "Vendor": "SMART & FINAL #368",
      "Address": " 5195 CLAIREMONT MESA BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92117",
      "County": " SAN DIEGO",
      "Latitude": "32.8337180  ",
      "Longitude": " -117.17940 "
   },
   {
      "Vendor": "SMART & FINAL #398",
      "Address": " 1090 FLETCHER PKWY",
      "City": "EL CAJON",
      "Zip Code": " 92020",
      "County": " SAN DIEGO",
      "Latitude": "32.8084260  ",
      "Longitude": " -116.97423 "
   },
   {
      "Vendor": "SMART & FINAL #488",
      "Address": "W 770 SAN MARCOS BLVD",
      "City": "SAN MARCOS",
      "Zip Code": " 92078",
      "County": " SAN DIEGO",
      "Latitude": "33.1371300  ",
      "Longitude": " -117.18127 "
   },
   {
      "Vendor": "SMART & FINAL #464",
      "Address": " 2804 MIDWAY DR",
      "City": "SAN DIEGO",
      "Zip Code": " 92110",
      "County": " SAN DIEGO",
      "Latitude": "32.7487400  ",
      "Longitude": " -117.20366 "
   },
   {
      "Vendor": "SMART & FINAL #360",
      "Address": "N 395 ESCONDIDO BLVD",
      "City": "ESCONDIDO",
      "Zip Code": " 92025",
      "County": " SAN DIEGO",
      "Latitude": "33.1234380  ",
      "Longitude": " -117.08641 "
   },
   {
      "Vendor": "SMART & FINAL #355",
      "Address": " 6235 EL CAJON BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92115",
      "County": " SAN DIEGO",
      "Latitude": "32.7630130  ",
      "Longitude": " -117.06368 "
   },
   {
      "Vendor": "SMART & FINAL #378",
      "Address": " 720 15TH ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92101",
      "County": " SAN DIEGO",
      "Latitude": "32.7129390  ",
      "Longitude": " -117.15077 "
   },
   {
      "Vendor": "SMART & FINAL #426",
      "Address": " 1737 OCEANSIDE BLVD",
      "City": "OCEANSIDE",
      "Zip Code": " 92054",
      "County": " SAN DIEGO",
      "Latitude": "33.1895580  ",
      "Longitude": " -117.36006 "
   },
   {
      "Vendor": "SAN YSIDRO NUTRITION",
      "Address": "W 416 SAN YSIDRO BLVD",
      "Second Address": " STE G",
      "City": "SAN YSIDRO",
      "Zip Code": " 92173",
      "County": " SAN DIEGO",
      "Latitude": "32.5545730  ",
      "Longitude": " -117.05149 "
   },
   {
      "Vendor": "VIVA MARKET",
      "Address": " 2031 MISSION AVE",
      "City": "OCEANSIDE",
      "Zip Code": " 92058",
      "County": " SAN DIEGO",
      "Latitude": "33.2048210  ",
      "Longitude": " -117.36352 "
   },
   {
      "Vendor": "CASITA NUTRITION #1",
      "Address": "W 1825 VISTA WAY",
      "Second Address": " STE B",
      "City": "VISTA",
      "Zip Code": " 92083",
      "County": " SAN DIEGO",
      "Latitude": "33.1888020  ",
      "Longitude": " -117.28033 "
   },
   {
      "Vendor": "SMART & FINAL #427",
      "Address": " 479 ENCINITAS BLVD",
      "City": "ENCINITAS",
      "Zip Code": " 92024",
      "County": " SAN DIEGO",
      "Latitude": "33.0464180  ",
      "Longitude": " -117.28332 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2245",
      "Address": " 705 COLLEGE BLVD",
      "City": "OCEANSIDE",
      "Zip Code": " 92057",
      "County": " SAN DIEGO",
      "Latitude": "33.2430140  ",
      "Longitude": " -117.29000 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #3516",
      "Address": " 1360 EASTLAKE PKWY",
      "City": "CHULA VISTA",
      "Zip Code": " 91915",
      "County": " SAN DIEGO",
      "Latitude": "32.6311090  ",
      "Longitude": " -116.96827 "
   },
   {
      "Vendor": "NOVILLOS MEAT MARKET",
      "Address": "N 620 REDONDO DR",
      "Second Address": " STE E",
      "City": "OCEANSIDE",
      "Zip Code": " 92057",
      "County": " SAN DIEGO",
      "Latitude": "33.2552430  ",
      "Longitude": " -117.30072 "
   },
   {
      "Vendor": "BEL AIR MARKET",
      "Address": " 4473 LOGAN AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92113",
      "County": " SAN DIEGO",
      "Latitude": "32.6968380  ",
      "Longitude": " -117.09846 "
   },
   {
      "Vendor": "CENTER CITY MARKET",
      "Address": " 3890 50TH ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92105",
      "County": " SAN DIEGO",
      "Latitude": "32.7490230  ",
      "Longitude": " -117.08726 "
   },
   {
      "Vendor": "GARDEN FARMS MARKET #2",
      "Address": " 12580 LAKESHORE DR",
      "City": "LAKESIDE",
      "Zip Code": " 92040",
      "County": " SAN DIEGO",
      "Latitude": "32.8605890  ",
      "Longitude": " -116.92012 "
   },
   {
      "Vendor": "GARDEN FARMS MARKET #1",
      "Address": " 370 E ST",
      "City": "CHULA VISTA",
      "Zip Code": " 91910",
      "County": " SAN DIEGO",
      "Latitude": "32.6436600  ",
      "Longitude": " -117.08386 "
   },
   {
      "Vendor": "BENADIR FOOD MARKET",
      "Address": " 6122 UNIVERSITY AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92115",
      "County": " SAN DIEGO",
      "Latitude": "32.7533440  ",
      "Longitude": " -117.06399 "
   },
   {
      "Vendor": "CAMPO STORE",
      "Address": " 31080 HIGHWAY 94",
      "City": "CAMPO",
      "Zip Code": " 91906",
      "County": " SAN DIEGO",
      "Latitude": "32.6065940  ",
      "Longitude": " -116.48089 "
   },
   {
      "Vendor": "TARGET STORE T-1140",
      "Address": " 2911 JAMACHA RD",
      "City": "EL CAJON",
      "Zip Code": " 92019",
      "County": " SAN DIEGO",
      "Latitude": "32.7386840  ",
      "Longitude": " -116.93894 "
   },
   {
      "Vendor": "TARGET STORE T-2165",
      "Address": " 3150 BUSINESS PARK DR",
      "City": "VISTA",
      "Zip Code": " 92081",
      "County": " SAN DIEGO",
      "Latitude": "33.1367400  ",
      "Longitude": " -117.22976 "
   },
   {
      "Vendor": "TARGET STORE T-1485",
      "Address": " 9846 MISSION GORGE RD",
      "City": "SANTEE",
      "Zip Code": " 92071",
      "County": " SAN DIEGO",
      "Latitude": "32.8389090  ",
      "Longitude": " -116.98185 "
   },
   {
      "Vendor": "EL SUPER #25",
      "Address": " 3007 HIGHLAND AVE",
      "City": "NATIONAL CITY",
      "Zip Code": " 91950",
      "County": " SAN DIEGO",
      "Latitude": "32.6588950  ",
      "Longitude": " -117.08878 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#218",
      "Address": " 4502 UNIVERSITY AVE",
      "Second Address": " UNIT 102",
      "City": "SAN DIEGO",
      "Zip Code": " 92105",
      "County": " SAN DIEGO",
      "Latitude": "32.7498320  ",
      "Longitude": " -117.09742 "
   },
   {
      "Vendor": "VALLEY FOODS",
      "Address": "E 1275 MAIN ST",
      "City": "EL CAJON",
      "Zip Code": " 92021",
      "County": " SAN DIEGO",
      "Latitude": "32.7948720  ",
      "Longitude": " -116.93813 "
   },
   {
      "Vendor": "DON'S MARKET",
      "Address": " 30250 HIGHWAY 78",
      "City": "SANTA YSABEL",
      "Zip Code": " 92070",
      "County": " SAN DIEGO",
      "Latitude": "33.1090340  ",
      "Longitude": " -116.67447 "
   },
   {
      "Vendor": "IMPERIAL FOOD SUPERMARKET",
      "Address": " 6503 IMPERIAL AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92114",
      "County": " SAN DIEGO",
      "Latitude": "32.7102560  ",
      "Longitude": " -117.05774 "
   },
   {
      "Vendor": "SOUTH BAY NUTRITION",
      "Address": " 2949 BEYER BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92154",
      "County": " SAN DIEGO",
      "Latitude": "32.5750330  ",
      "Longitude": " -117.06822 "
   },
   {
      "Vendor": "TARGET STORE T-1846",
      "Address": " 3424 COLLEGE AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92115",
      "County": " SAN DIEGO",
      "Latitude": "32.7432480  ",
      "Longitude": " -117.05245 "
   },
   {
      "Vendor": "TARGET STORE T-0304",
      "Address": " 250 BROADWAY",
      "City": "EL CAJON",
      "Zip Code": " 92021",
      "County": " SAN DIEGO",
      "Latitude": "32.8097850  ",
      "Longitude": " -116.95933 "
   },
   {
      "Vendor": "TARGET STORE T-0274",
      "Address": "S 1280 AUTO PKWY",
      "City": "ESCONDIDO",
      "Zip Code": " 92029",
      "County": " SAN DIEGO",
      "Latitude": "33.1146940  ",
      "Longitude": " -117.10727 "
   },
   {
      "Vendor": "TARGET STORE T-1040",
      "Address": " 1751 UNIVERSITY DR",
      "City": "VISTA",
      "Zip Code": " 92083",
      "County": " SAN DIEGO",
      "Latitude": "33.1701230  ",
      "Longitude": " -117.21448 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5075",
      "Address": " 3405 MARRON RD",
      "City": "OCEANSIDE",
      "Zip Code": " 92056",
      "County": " SAN DIEGO",
      "Latitude": "33.1776090  ",
      "Longitude": " -117.29944 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #5023",
      "Address": " 1200 HIGHLAND AVE",
      "City": "NATIONAL CITY",
      "Zip Code": " 91950",
      "County": " SAN DIEGO",
      "Latitude": "32.6747710  ",
      "Longitude": " -117.09937 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2494",
      "Address": " 2100 VISTA WAY",
      "City": "OCEANSIDE",
      "Zip Code": " 92054",
      "County": " SAN DIEGO",
      "Latitude": "33.1810150  ",
      "Longitude": " -117.34687 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2479",
      "Address": " 3412 COLLEGE AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92115",
      "County": " SAN DIEGO",
      "Latitude": "32.7415150  ",
      "Longitude": " -117.05320 "
   },
   {
      "Vendor": "TARGET STORE T-0203",
      "Address": " 1240 BROADWAY",
      "City": "CHULA VISTA",
      "Zip Code": " 91911",
      "County": " SAN DIEGO",
      "Latitude": "32.6045570  ",
      "Longitude": " -117.08057 "
   },
   {
      "Vendor": "TARGET STORE T-1815",
      "Address": "E 910 LAKE PKWY",
      "City": "CHULA VISTA",
      "Zip Code": " 91914",
      "County": " SAN DIEGO",
      "Latitude": "32.6511450  ",
      "Longitude": " -116.96802 "
   },
   {
      "Vendor": "TARGET STORE T-2465",
      "Address": " 5454 BALBOA AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92111",
      "County": " SAN DIEGO",
      "Latitude": "32.8220200  ",
      "Longitude": " -117.18015 "
   },
   {
      "Vendor": "TARGET STORE T-0997",
      "Address": " 5500 GROSSMONT CENTER DR",
      "City": "LA MESA",
      "Zip Code": " 91942",
      "County": " SAN DIEGO",
      "Latitude": "32.7780620  ",
      "Longitude": " -117.01063 "
   },
   {
      "Vendor": "TARGET STORE T-2232",
      "Address": " 3060 PLAZA BONITA RD",
      "City": "NATIONAL CITY",
      "Zip Code": " 91950",
      "County": " SAN DIEGO",
      "Latitude": "32.6526070  ",
      "Longitude": " -117.06502 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2253",
      "Address": " 13487 CAMINO CANADA",
      "City": "EL CAJON",
      "Zip Code": " 92021",
      "County": " SAN DIEGO",
      "Latitude": "32.8247690  ",
      "Longitude": " -116.90211 "
   },
   {
      "Vendor": "SAVERS 99 CENT STORE",
      "Address": " 4129 UNIVERSITY AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92105",
      "County": " SAN DIEGO",
      "Latitude": "32.7491270  ",
      "Longitude": " -117.10605 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2094",
      "Address": " 1800 UNIVERSITY DR",
      "City": "VISTA",
      "Zip Code": " 92083",
      "County": " SAN DIEGO",
      "Latitude": "33.1707250  ",
      "Longitude": " -117.21552 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#225",
      "Address": " 1793 NATIONAL AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92113",
      "County": " SAN DIEGO",
      "Latitude": "32.7017130  ",
      "Longitude": " -117.14708 "
   },
   {
      "Vendor": "TARGET STORE T-0303",
      "Address": " 2255 EL CAMINO REAL",
      "City": "OCEANSIDE",
      "Zip Code": " 92054",
      "County": " SAN DIEGO",
      "Latitude": "33.1852090  ",
      "Longitude": " -117.32825 "
   },
   {
      "Vendor": "TARGET STORE T-1410",
      "Address": " 1288 CAMINO DEL RIO NORTH",
      "City": "SAN DIEGO",
      "Zip Code": " 92108",
      "County": " SAN DIEGO",
      "Latitude": "32.7671790  ",
      "Longitude": " -117.14941 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #36",
      "Address": " 901 EUCLID AVE",
      "City": "NATIONAL CITY",
      "Zip Code": " 91950",
      "County": " SAN DIEGO",
      "Latitude": "32.6814720  ",
      "Longitude": " -117.07988 "
   },
   {
      "Vendor": "NORTHGATE MARKET #36",
      "Address": " 5403 UNIVERSITY AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92115",
      "County": " SAN DIEGO",
      "Latitude": "32.7471700  ",
      "Longitude": " -117.07859 "
   },
   {
      "Vendor": "RALPHS #201",
      "Address": " 3345 SPORTS ARENA BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92110",
      "County": " SAN DIEGO",
      "Latitude": "32.7529240  ",
      "Longitude": " -117.20906 "
   },
   {
      "Vendor": "TARGET STORE T-1029",
      "Address": "N 1010 EL CAMINO REAL",
      "City": "ENCINITAS",
      "Zip Code": " 92024",
      "County": " SAN DIEGO",
      "Latitude": "33.0649250  ",
      "Longitude": " -117.26268 "
   },
   {
      "Vendor": "VONS #2784",
      "Address": "W 515 WASHINGTON ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92103",
      "County": " SAN DIEGO",
      "Latitude": "32.7498070  ",
      "Longitude": " -117.16875 "
   },
   {
      "Vendor": "MOTHER EARTH NUTRITION",
      "Address": "W 208 SAN MARCOS BLVD",
      "Second Address": " STE 105",
      "City": "SAN MARCOS",
      "Zip Code": " 92069",
      "County": " SAN DIEGO",
      "Latitude": "33.1414540  ",
      "Longitude": " -117.16575 "
   },
   {
      "Vendor": "MOTHER & BABY NUTRITION",
      "Address": "N 560 2ND ST",
      "City": "EL CAJON",
      "Zip Code": " 92021",
      "County": " SAN DIEGO",
      "Latitude": "32.8014280  ",
      "Longitude": " -116.93579 "
   },
   {
      "Vendor": "ALBERTSONS #3201",
      "Address": "E 1301 VISTA WAY",
      "City": "VISTA",
      "Zip Code": " 92084",
      "County": " SAN DIEGO",
      "Latitude": "33.2184880  ",
      "Longitude": " -117.22435 "
   },
   {
      "Vendor": "ALBERTSONS #704",
      "Address": " 2955 ALPINE BLVD",
      "City": "ALPINE",
      "Zip Code": " 91901",
      "County": " SAN DIEGO",
      "Latitude": "32.8333860  ",
      "Longitude": " -116.75019 "
   },
   {
      "Vendor": "ALBERTSONS #1705",
      "Address": "W 1570 VALLEY PKWY",
      "City": "ESCONDIDO",
      "Zip Code": " 92029",
      "County": " SAN DIEGO",
      "Latitude": "33.1088810  ",
      "Longitude": " -117.10574 "
   },
   {
      "Vendor": "ALBERTSONS #707",
      "Address": " 7090 BROADWAY",
      "City": "LEMON GROVE",
      "Zip Code": " 91945",
      "County": " SAN DIEGO",
      "Latitude": "32.7425840  ",
      "Longitude": " -117.04521 "
   },
   {
      "Vendor": "ALBERTSONS #708",
      "Address": " 151 WOODLAND PKWY",
      "City": "SAN MARCOS",
      "Zip Code": " 92069",
      "County": " SAN DIEGO",
      "Latitude": "33.1403750  ",
      "Longitude": " -117.13875 "
   },
   {
      "Vendor": "ALBERTSONS #710",
      "Address": " 8920 FLETCHER PKWY",
      "City": "LA MESA",
      "Zip Code": " 91941",
      "County": " SAN DIEGO",
      "Latitude": "32.7858020  ",
      "Longitude": " -117.00531 "
   },
   {
      "Vendor": "ALBERTSONS #711",
      "Address": "W 1929 SAN MARCOS BLVD",
      "City": "SAN MARCOS",
      "Zip Code": " 92069",
      "County": " SAN DIEGO",
      "Latitude": "33.1321630  ",
      "Longitude": " -117.21034 "
   },
   {
      "Vendor": "ALBERTSONS #4713",
      "Address": "E 1509 VALLEY PKWY",
      "City": "ESCONDIDO",
      "Zip Code": " 92027",
      "County": " SAN DIEGO",
      "Latitude": "33.1333430  ",
      "Longitude": " -117.06085 "
   },
   {
      "Vendor": "ALBERTSONS #723",
      "Address": " 9831 CAMPO RD",
      "City": "SPRING VALLEY",
      "Zip Code": " 91977",
      "County": " SAN DIEGO",
      "Latitude": "32.7470060  ",
      "Longitude": " -116.98406 "
   },
   {
      "Vendor": "ALBERTSONS #725",
      "Address": " 1459 MAIN ST",
      "City": "RAMONA",
      "Zip Code": " 92065",
      "County": " SAN DIEGO",
      "Latitude": "33.0380050  ",
      "Longitude": " -116.87585 "
   },
   {
      "Vendor": "ALBERTSONS #733",
      "Address": " 3450 MARRON RD",
      "City": "OCEANSIDE",
      "Zip Code": " 92056",
      "County": " SAN DIEGO",
      "Latitude": "33.1795030  ",
      "Longitude": " -117.29650 "
   },
   {
      "Vendor": "ALBERTSONS #738",
      "Address": " 9560 WINTER GARDENS BLVD",
      "City": "LAKESIDE",
      "Zip Code": " 92040",
      "County": " SAN DIEGO",
      "Latitude": "32.8510010  ",
      "Longitude": " -116.93192 "
   },
   {
      "Vendor": "ALBERTSONS #740",
      "Address": " 4150 OCEANSIDE BLVD",
      "City": "OCEANSIDE",
      "Zip Code": " 92056",
      "County": " SAN DIEGO",
      "Latitude": "33.2076990  ",
      "Longitude": " -117.28731 "
   },
   {
      "Vendor": "ALBERTSONS #745",
      "Address": " 655 14TH ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92101",
      "County": " SAN DIEGO",
      "Latitude": "32.7121260  ",
      "Longitude": " -117.15195 "
   },
   {
      "Vendor": "ALBERTSONS #750",
      "Address": " 1571 SAN ELIJO RD S",
      "City": "SAN MARCOS",
      "Zip Code": " 92078",
      "County": " SAN DIEGO",
      "Latitude": "33.0978630  ",
      "Longitude": " -117.19978 "
   },
   {
      "Vendor": "ALBERTSONS #757",
      "Address": " 720 3RD AVE",
      "City": "CHULA VISTA",
      "Zip Code": " 91910",
      "County": " SAN DIEGO",
      "Latitude": "32.6265840  ",
      "Longitude": " -117.07522 "
   },
   {
      "Vendor": "ALBERTSONS #758",
      "Address": " 543 SWEETWATER RD",
      "City": "SPRING VALLEY",
      "Zip Code": " 91977",
      "County": " SAN DIEGO",
      "Latitude": "32.7080180  ",
      "Longitude": " -117.00863 "
   },
   {
      "Vendor": "ALBERTSONS #3179",
      "Address": " 12475 RANCHO BERNARDO RD",
      "City": "SAN DIEGO",
      "Zip Code": " 92128",
      "County": " SAN DIEGO",
      "Latitude": "33.0175570  ",
      "Longitude": " -117.06183 "
   },
   {
      "Vendor": "ALBERTSONS #2767",
      "Address": " 3925 MISSION AVE",
      "City": "OCEANSIDE",
      "Zip Code": " 92054",
      "County": " SAN DIEGO",
      "Latitude": "33.2275990  ",
      "Longitude": " -117.32392 "
   },
   {
      "Vendor": "ALBERTSONS #3202",
      "Address": " 1608 BROADWAY ST",
      "City": "EL CAJON",
      "Zip Code": " 92021",
      "County": " SAN DIEGO",
      "Latitude": "32.8086300  ",
      "Longitude": " -116.92022 "
   },
   {
      "Vendor": "ALBERTSONS #2783",
      "Address": " 2899 JAMACHA RD",
      "City": "EL CAJON",
      "Zip Code": " 92019",
      "County": " SAN DIEGO",
      "Latitude": "32.7396110  ",
      "Longitude": " -116.93793 "
   },
   {
      "Vendor": "ALBERTSONS #2785",
      "Address": " 8650 LAKE MURRAY BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92119",
      "County": " SAN DIEGO",
      "Latitude": "32.8024420  ",
      "Longitude": " -117.01304 "
   },
   {
      "Vendor": "ALBERTSONS #4786",
      "Address": "S 1133 MISSION RD",
      "City": "FALLBROOK",
      "Zip Code": " 92028",
      "County": " SAN DIEGO",
      "Latitude": "33.3722390  ",
      "Longitude": " -117.25319 "
   },
   {
      "Vendor": "ALBERTSONS #3797",
      "Address": "S 1601 MELROSE DR",
      "City": "VISTA",
      "Zip Code": " 92083",
      "County": " SAN DIEGO",
      "Latitude": "33.1660070  ",
      "Longitude": " -117.24758 "
   },
   {
      "Vendor": "EL SUPER #45",
      "Address": " 1527 MISSION AVE",
      "City": "OCEANSIDE",
      "Zip Code": " 92057",
      "County": " SAN DIEGO",
      "Latitude": "33.2008200  ",
      "Longitude": " -117.36737 "
   },
   {
      "Vendor": "WAL-MART #3084",
      "Address": "E 1266 VALLEY PKWY",
      "City": "ESCONDIDO",
      "Zip Code": " 92027",
      "County": " SAN DIEGO",
      "Latitude": "33.1310120  ",
      "Longitude": " -117.06691 "
   },
   {
      "Vendor": "WAL-MART #5886",
      "Address": " 1550 LEUCADIA BLVD",
      "City": "ENCINITAS",
      "Zip Code": " 92024",
      "County": " SAN DIEGO",
      "Latitude": "33.0685170  ",
      "Longitude": " -117.26582 "
   },
   {
      "Vendor": "WAL-MART #4169",
      "Address": "N 300 2ND ST",
      "City": "EL CAJON",
      "Zip Code": " 92021",
      "County": " SAN DIEGO",
      "Latitude": "32.7987660  ",
      "Longitude": " -116.93665 "
   },
   {
      "Vendor": "WAL-MART #2177",
      "Address": " 3382 MURPHY CANYON RD",
      "City": "SAN DIEGO",
      "Zip Code": " 92123",
      "County": " SAN DIEGO",
      "Latitude": "32.8054440  ",
      "Longitude": " -117.11432 "
   },
   {
      "Vendor": "WAL-MART #5684",
      "Address": " 8810 GROSSMONT BLVD",
      "City": "LA MESA",
      "Zip Code": " 91942",
      "County": " SAN DIEGO",
      "Latitude": "32.7738110  ",
      "Longitude": " -117.00866 "
   },
   {
      "Vendor": "WAL-MART #2291",
      "Address": "N 75 BROADWAY",
      "City": "CHULA VISTA",
      "Zip Code": " 91910",
      "County": " SAN DIEGO",
      "Latitude": "32.6456710  ",
      "Longitude": " -117.09497 "
   },
   {
      "Vendor": "WAL-MART #5637",
      "Address": " 1046 MISSION AVE",
      "City": "OCEANSIDE",
      "Zip Code": " 92054",
      "County": " SAN DIEGO",
      "Latitude": "33.1989210  ",
      "Longitude": " -117.37492 "
   },
   {
      "Vendor": "WAL-MART #5638",
      "Address": " 2121 IMPERIAL AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92102",
      "County": " SAN DIEGO",
      "Latitude": "32.7060700  ",
      "Longitude": " -117.14471 "
   },
   {
      "Vendor": "RALPHS #212",
      "Address": " 1666 ROSECRANS ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92106",
      "County": " SAN DIEGO",
      "Latitude": "32.7285240  ",
      "Longitude": " -117.22676 "
   },
   {
      "Vendor": "SMART & FINAL #581",
      "Address": " 12339 POWAY RD",
      "City": "POWAY",
      "Zip Code": " 92064",
      "County": " SAN DIEGO",
      "Latitude": "32.9511010  ",
      "Longitude": " -117.06364 "
   },
   {
      "Vendor": "NORTHGATE MARKET #31",
      "Address": " 1950 MAIN ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92113",
      "County": " SAN DIEGO",
      "Latitude": "32.6992980  ",
      "Longitude": " -117.14553 "
   },
   {
      "Vendor": "WAL-MART STORE #5996",
      "Address": "E 1330 GRAND AVE",
      "City": "ESCONDIDO",
      "Zip Code": " 92027",
      "County": " SAN DIEGO",
      "Latitude": "33.1297160  ",
      "Longitude": " -117.06273 "
   },
   {
      "Vendor": "WAL-MART #5140",
      "Address": " 5500 GROSSMONT CENTER DR",
      "City": "LA MESA",
      "Zip Code": " 91942",
      "County": " SAN DIEGO",
      "Latitude": "32.7780620  ",
      "Longitude": " -117.01063 "
   },
   {
      "Vendor": "MANOLO FARMERS MARKET",
      "Address": " 1860 CORONADO AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92154",
      "County": " SAN DIEGO",
      "Latitude": "32.5777730  ",
      "Longitude": " -117.09332 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1700",
      "Address": " 13425 COMMUNITY RD",
      "City": "POWAY",
      "Zip Code": " 92064",
      "County": " SAN DIEGO",
      "Latitude": "32.9593290  ",
      "Longitude": " -117.04033 "
   },
   {
      "Vendor": "VONS #2724",
      "Address": " 3439 VIA MONTEBELLO",
      "City": "CARLSBAD",
      "Zip Code": " 92009",
      "County": " SAN DIEGO",
      "Latitude": "33.0819700  ",
      "Longitude": " -117.23504 "
   },
   {
      "Vendor": "SAWAYA BROTHER MARKET",
      "Address": "S 425 30TH ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92113",
      "County": " SAN DIEGO",
      "Latitude": "32.7014970  ",
      "Longitude": " -117.12927 "
   },
   {
      "Vendor": "PANCHO VILLA NO. 2",
      "Address": " 2004 DAIRY MART RD",
      "Second Address": " STE 105",
      "City": "SAN YSIDRO",
      "Zip Code": " 92173",
      "County": " SAN DIEGO",
      "Latitude": "32.5610160  ",
      "Longitude": " -117.06354 "
   },
   {
      "Vendor": "EL SUPER #51",
      "Address": " 4421 UNIVERSITY AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92105",
      "County": " SAN DIEGO",
      "Latitude": "32.7486360  ",
      "Longitude": " -117.09920 "
   },
   {
      "Vendor": "VINE RIPE MARKET",
      "Address": " 8191 FLETCHER PKWY",
      "City": "LA MESA",
      "Zip Code": " 91942",
      "County": " SAN DIEGO",
      "Latitude": "32.7760640  ",
      "Longitude": " -117.01974 "
   },
   {
      "Vendor": "MOLLISON MARKET",
      "Address": "S 725 MOLLISON AVE",
      "City": "EL CAJON",
      "Zip Code": " 92020",
      "County": " SAN DIEGO",
      "Latitude": "32.7870330  ",
      "Longitude": " -116.95062 "
   },
   {
      "Vendor": "LIVA DISTRIBUTORS",
      "Address": " 3173 IRIS AVE",
      "City": "SAN YSIDRO",
      "Zip Code": " 92173",
      "County": " SAN DIEGO",
      "Latitude": "32.5691260  ",
      "Longitude": " -117.06570 "
   },
   {
      "Vendor": "DESERT PANTRY GROCERS",
      "Address": " 587 PALM CANYON DR",
      "Second Address": " STE 105",
      "City": "BORREGO SPRINGS",
      "Zip Code": " 92004",
      "County": " SAN DIEGO",
      "Latitude": "33.2554690  ",
      "Longitude": " -116.37957 "
   },
   {
      "Vendor": "LILAC FOODS",
      "Address": " 28958 LILAC RD",
      "Second Address": " STE 3",
      "City": "VALLEY CENTER",
      "Zip Code": " 92082",
      "County": " SAN DIEGO",
      "Latitude": "33.2366240  ",
      "Longitude": " -117.05221 "
   },
   {
      "Vendor": "EL PAISANO LA FAMILIA",
      "Address": " 3820 UNIVERSITY AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92105",
      "County": " SAN DIEGO",
      "Latitude": "32.7500430  ",
      "Longitude": " -117.11150 "
   },
   {
      "Vendor": "TARGET STORE T-0205",
      "Address": " 8001 OTHELLO AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92111",
      "County": " SAN DIEGO",
      "Latitude": "32.8161850  ",
      "Longitude": " -117.15112 "
   },
   {
      "Vendor": "TARGET STORE T-0296",
      "Address": " 14823 POMERADO RD",
      "City": "POWAY",
      "Zip Code": " 92064",
      "County": " SAN DIEGO",
      "Latitude": "32.9803490  ",
      "Longitude": " -117.06060 "
   },
   {
      "Vendor": "TARGET STORE T-2802",
      "Address": "E 280 VIA RANCHO PKWY",
      "City": "ESCONDIDO",
      "Zip Code": " 92025",
      "County": " SAN DIEGO",
      "Latitude": "33.0687860  ",
      "Longitude": " -117.06651 "
   },
   {
      "Vendor": "TARGET STORE T-0305",
      "Address": " 8251 MIRA MESA BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92126",
      "County": " SAN DIEGO",
      "Latitude": "32.9123880  ",
      "Longitude": " -117.14598 "
   },
   {
      "Vendor": "GARDEN PICK MARKET #1",
      "Address": "E 1131 WASHINGTON AVE",
      "Second Address": " STE B-E",
      "City": "ESCONDIDO",
      "Zip Code": " 92025",
      "County": " SAN DIEGO",
      "Latitude": "33.1317030  ",
      "Longitude": " -117.06803 "
   },
   {
      "Vendor": "SMART & FINAL #718",
      "Address": " 49978 HARRISON ST",
      "City": "COACHELLA",
      "Zip Code": " 92236",
      "County": " RIVERSIDE",
      "Latitude": "33.6862720  ",
      "Longitude": " -116.18017 "
   },
   {
      "Vendor": "SMART & FINAL #725",
      "Address": " 933 SWEETWATER RD",
      "City": "SPRING VALLEY",
      "Zip Code": " 91977",
      "County": " SAN DIEGO",
      "Latitude": "32.7126110  ",
      "Longitude": " -117.01169 "
   },
   {
      "Vendor": "SMART & FINAL #599",
      "Address": "W 1845 VISTA WAY",
      "City": "VISTA",
      "Zip Code": " 92083",
      "County": " SAN DIEGO",
      "Latitude": "33.1891730  ",
      "Longitude": " -117.28068 "
   },
   {
      "Vendor": "WINCO FOODS #134",
      "Address": " 555 GRAND AVE",
      "City": "SAN MARCOS",
      "Zip Code": " 92078",
      "County": " SAN DIEGO",
      "Latitude": "33.1347280  ",
      "Longitude": " -117.17781 "
   },
   {
      "Vendor": "MOMS & KIDS NUTRITION STORE",
      "Address": " 839 WILLIAMSTON ST",
      "City": "VISTA",
      "Zip Code": " 92084",
      "County": " SAN DIEGO",
      "Latitude": "33.2098750  ",
      "Longitude": " -117.22932 "
   },
   {
      "Vendor": "LA SALSA MARKET",
      "Address": " 3702 EUCLID AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92105",
      "County": " SAN DIEGO",
      "Latitude": "32.7460080  ",
      "Longitude": " -117.09254 "
   },
   {
      "Vendor": "LIVA DISTRIBUTORS DOS",
      "Address": " 8450 JAMACHA RD",
      "City": "SAN DIEGO",
      "Zip Code": " 92114",
      "County": " SAN DIEGO",
      "Latitude": "32.7177440  ",
      "Longitude": " -117.02664 "
   },
   {
      "Vendor": "MAJOR MARKET",
      "Address": "S 1855 CENTRE CITY PKWY",
      "City": "ESCONDIDO",
      "Zip Code": " 92025",
      "County": " SAN DIEGO",
      "Latitude": "33.1006540  ",
      "Longitude": " -117.07404 "
   },
   {
      "Vendor": "MAJOR MARKET #2",
      "Address": "S 845 MAIN AVE",
      "City": "FALLBROOK",
      "Zip Code": " 92028",
      "County": " SAN DIEGO",
      "Latitude": "33.3753280  ",
      "Longitude": " -117.25291 "
   },
   {
      "Vendor": "MERCADO INTERNATIONAL",
      "Address": " 1415 THIRD AVE",
      "City": "CHULA VISTA",
      "Zip Code": " 91911",
      "County": " SAN DIEGO",
      "Latitude": "32.6027840  ",
      "Longitude": " -117.06426 "
   },
   {
      "Vendor": "NORTH PARK PRODUCE",
      "Address": " 3551 EL CAJON BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92104",
      "County": " SAN DIEGO",
      "Latitude": "32.7549360  ",
      "Longitude": " -117.11653 "
   },
   {
      "Vendor": "MOTHERS NUTRITIONAL CTR#238",
      "Address": "E 1420 PLAZA BLVD",
      "Second Address": " STE B5",
      "City": "NATIONAL CITY",
      "Zip Code": " 91950",
      "County": " SAN DIEGO",
      "Latitude": "32.6751390  ",
      "Longitude": " -117.09128 "
   },
   {
      "Vendor": "SMART & FINAL #935",
      "Address": " 150 B AVE",
      "City": "CORONADO",
      "Zip Code": " 92118",
      "County": " SAN DIEGO",
      "Latitude": "32.6973290  ",
      "Longitude": " -117.17122 "
   },
   {
      "Vendor": "SMART & FINAL #928",
      "Address": " 955 CARLSBAD VILLAGE DR",
      "City": "CARLSBAD",
      "Zip Code": " 92008",
      "County": " SAN DIEGO",
      "Latitude": "33.1616750  ",
      "Longitude": " -117.34335 "
   },
   {
      "Vendor": "VONS #3330",
      "Address": "S 671 RANCHO SANTA FE",
      "City": "SAN MARCOS",
      "Zip Code": " 92078",
      "County": " SAN DIEGO",
      "Latitude": "33.1326070  ",
      "Longitude": " -117.20742 "
   },
   {
      "Vendor": "VONS #3327",
      "Address": " 5630 LAKE MURRAY BLVD",
      "City": "LA MESA",
      "Zip Code": " 91942",
      "County": " SAN DIEGO",
      "Latitude": "32.7814400  ",
      "Longitude": " -117.03177 "
   },
   {
      "Vendor": "SAWAYA BROTHER JR MARKET",
      "Address": " 183 BROADWAY ST",
      "City": "CHULA VISTA",
      "Zip Code": " 91910",
      "County": " SAN DIEGO",
      "Latitude": "32.6422260  ",
      "Longitude": " -117.09351 "
   },
   {
      "Vendor": "LITTLE KIDS NUTRITION/FISH",
      "Address": "E 1078 VISTA WAY",
      "City": "VISTA",
      "Zip Code": " 92084",
      "County": " SAN DIEGO",
      "Latitude": "33.2144450  ",
      "Longitude": " -117.22835 "
   },
   {
      "Vendor": "SMART & FINAL #932",
      "Address": " 10740 WESTVIEW PKWY",
      "City": "SAN DIEGO",
      "Zip Code": " 92126",
      "County": " SAN DIEGO",
      "Latitude": "32.9154800  ",
      "Longitude": " -117.12194 "
   },
   {
      "Vendor": "SMART & FINAL #936",
      "Address": "E 360 H ST",
      "City": "CHULA VISTA",
      "Zip Code": " 91910",
      "County": " SAN DIEGO",
      "Latitude": "32.6406850  ",
      "Longitude": " -117.04945 "
   },
   {
      "Vendor": "SMART & FINAL #934",
      "Address": " 3681 AVOCADO BLVD",
      "City": "LA MESA",
      "Zip Code": " 91941",
      "County": " SAN DIEGO",
      "Latitude": "32.7467090  ",
      "Longitude": " -116.96257 "
   },
   {
      "Vendor": "SMART & FINAL #930",
      "Address": " 13439 CAMINO CANADA",
      "City": "EL CAJON",
      "Zip Code": " 92021",
      "County": " SAN DIEGO",
      "Latitude": "32.8242370  ",
      "Longitude": " -116.90373 "
   },
   {
      "Vendor": "SMART & FINAL #931",
      "Address": " 2800 FLETCHER PKWY",
      "City": "EL CAJON",
      "Zip Code": " 92020",
      "County": " SAN DIEGO",
      "Latitude": "32.8003110  ",
      "Longitude": " -117.00206 "
   },
   {
      "Vendor": "SMART & FINAL #929",
      "Address": " 9870 MAGNOLIA AVE",
      "City": "SANTEE",
      "Zip Code": " 92071",
      "County": " SAN DIEGO",
      "Latitude": "32.8564170  ",
      "Longitude": " -116.97181 "
   },
   {
      "Vendor": "MI FAMILIA SUPERMARKET",
      "Address": "S 420 MEADOWBROOKE DR",
      "City": "SAN DIEGO",
      "Zip Code": " 92114",
      "County": " SAN DIEGO",
      "Latitude": "32.6982420  ",
      "Longitude": " -117.02729 "
   },
   {
      "Vendor": "SMART & FINAL #937",
      "Address": "W 350 SAN YSIDRO BLVD",
      "City": "SAN YSIDRO",
      "Zip Code": " 92173",
      "County": " SAN DIEGO",
      "Latitude": "32.5543330  ",
      "Longitude": " -117.05061 "
   },
   {
      "Vendor": "CASITA NUTRITION",
      "Address": "N 610 REDONDO DR",
      "Second Address": " STE B2 AND C",
      "City": "OCEANSIDE",
      "Zip Code": " 92057",
      "County": " SAN DIEGO",
      "Latitude": "33.2559970  ",
      "Longitude": " -117.30074 "
   },
   {
      "Vendor": "EL TORO MARKET",
      "Address": "N 337 MAIN AVE",
      "City": "FALLBROOK",
      "Zip Code": " 92028",
      "County": " SAN DIEGO",
      "Latitude": "33.3843010  ",
      "Longitude": " -117.25105 "
   },
   {
      "Vendor": "SMART & FINAL #940",
      "Address": " 2235 UNIVERSITY AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92104",
      "County": " SAN DIEGO",
      "Latitude": "32.7479750  ",
      "Longitude": " -117.14058 "
   },
   {
      "Vendor": "SMART & FINAL #933",
      "Address": " 10633 TIERRA SANTA BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92124",
      "County": " SAN DIEGO",
      "Latitude": "32.8210670  ",
      "Longitude": " -117.10104 "
   },
   {
      "Vendor": "CARNIVAL SUPERMARKET",
      "Address": " 870 THIRD AVE",
      "City": "CHULA VISTA",
      "Zip Code": " 91911",
      "County": " SAN DIEGO",
      "Latitude": "32.6217110  ",
      "Longitude": " -117.07287 "
   },
   {
      "Vendor": "LOUIE'S MARKET PLACE",
      "Address": " 5409 REDWOOD ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92105",
      "County": " SAN DIEGO",
      "Latitude": "32.7373310  ",
      "Longitude": " -117.07896 "
   },
   {
      "Vendor": "LULU'S INTERNATIONAL MARKET",
      "Address": " 678 JAMACHA RD",
      "City": "EL CAJON",
      "Zip Code": " 92019",
      "County": " SAN DIEGO",
      "Latitude": "32.7882690  ",
      "Longitude": " -116.92861 "
   },
   {
      "Vendor": "EDDIE'S MARKET",
      "Address": "N 415 SANTA FE AVE",
      "City": "VISTA",
      "Zip Code": " 92084",
      "County": " SAN DIEGO",
      "Latitude": "33.2182710  ",
      "Longitude": " -117.24422 "
   },
   {
      "Vendor": "VONS #3323",
      "Address": " 7895 HIGHLAND VILLAGE PL",
      "City": "SAN DIEGO",
      "Zip Code": " 92129",
      "County": " SAN DIEGO",
      "Latitude": "32.9610840  ",
      "Longitude": " -117.15382 "
   },
   {
      "Vendor": "SMART & FINAL #742",
      "Address": "N 40 4TH AVE",
      "Second Address": " UNIT D",
      "City": "CHULA VISTA",
      "Zip Code": " 91910",
      "County": " SAN DIEGO",
      "Latitude": "32.6513760  ",
      "Longitude": " -117.08982 "
   },
   {
      "Vendor": "DUR DUR MARKET",
      "Address": " 4973 UNIVERSITY AVE",
      "Second Address": " STE A",
      "City": "SAN DIEGO",
      "Zip Code": " 92105",
      "County": " SAN DIEGO",
      "Latitude": "32.7491930  ",
      "Longitude": " -117.08729 "
   },
   {
      "Vendor": "NUTRITION HEALTHY BITES",
      "Address": "S 1408 MISSION RD",
      "City": "FALLBROOK",
      "Zip Code": " 92028",
      "County": " SAN DIEGO",
      "Latitude": "33.3673800  ",
      "Longitude": " -117.25010 "
   },
   {
      "Vendor": "SAN MARCOS MARKET",
      "Address": "W 228 MISSION RD",
      "City": "SAN MARCOS",
      "Zip Code": " 92069",
      "County": " SAN DIEGO",
      "Latitude": "33.1437410  ",
      "Longitude": " -117.16577 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #3947",
      "Address": "E 875 H ST",
      "City": "CHULA VISTA",
      "Zip Code": " 91910",
      "County": " SAN DIEGO",
      "Latitude": "32.6361240  ",
      "Longitude": " -117.02469 "
   },
   {
      "Vendor": "SAN MARCOS MARKET #2",
      "Address": "S 500 RANCHO SANTA FE RD",
      "Second Address": " STE 105-106",
      "City": "SAN MARCOS",
      "Zip Code": " 92078",
      "County": " SAN DIEGO",
      "Latitude": "33.1367730  ",
      "Longitude": " -117.20541 "
   },
   {
      "Vendor": "APPLE TREE MARKET",
      "Address": " 1193 BROADWAY",
      "City": "CHULA VISTA",
      "Zip Code": " 91911",
      "County": " SAN DIEGO",
      "Latitude": "32.6071200  ",
      "Longitude": " -117.08007 "
   },
   {
      "Vendor": "CONCHITAS BAKERY REST & MARKET",
      "Address": "W 649 MISSION AVE",
      "Second Address": "  STE #10",
      "City": "ESCONDIDO",
      "Zip Code": " 92025",
      "County": " SAN DIEGO",
      "Latitude": "33.1266830  ",
      "Longitude": " -117.09505 "
   },
   {
      "Vendor": "FARM FRESH MARKET",
      "Address": " 1879 PALM AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92154",
      "County": " SAN DIEGO",
      "Latitude": "32.5831970  ",
      "Longitude": " -117.09418 "
   },
   {
      "Vendor": "EL SUPER TORO",
      "Address": "N 1021 SANTA FE AVE",
      "Second Address": "  SUITE H",
      "City": "VISTA",
      "Zip Code": " 92084",
      "County": " SAN DIEGO",
      "Latitude": "33.2132460  ",
      "Longitude": " -117.24454 "
   },
   {
      "Vendor": "CIRCLE K",
      "Address": " 31471 HWY 94",
      "City": "CAMPO",
      "Zip Code": " 91906",
      "County": " SAN DIEGO",
      "Latitude": "32.6282090  ",
      "Longitude": " -116.47217 "
   },
   {
      "Vendor": "MAMAS",
      "Address": " 7328 BROADWAY",
      "City": "LEMON GROVE",
      "Zip Code": " 91945",
      "County": " SAN DIEGO",
      "Latitude": "32.7428880  ",
      "Longitude": " -117.03992 "
   },
   {
      "Vendor": "SAN MARCOS MARKET",
      "Address": " 261 AUTUMN DR",
      "Second Address": "  STE #111",
      "City": "SAN MARCOS",
      "Zip Code": " 92069",
      "County": " SAN DIEGO",
      "Latitude": "33.1428000  ",
      "Longitude": " -117.16833 "
   },
   {
      "Vendor": "LA FAMOSA #3",
      "Address": " 22608 ALESSANDRO BLVD",
      "City": "MORENO VALLEY",
      "Zip Code": " 92553",
      "County": " RIVERSIDE",
      "Latitude": "33.9173310  ",
      "Longitude": " -117.26859 "
   },
   {
      "Vendor": "COCO NUTRITION",
      "Address": "N 423 SANTA FE AVE",
      "City": "VISTA",
      "Zip Code": " 92084",
      "County": " SAN DIEGO",
      "Latitude": "33.2052010  ",
      "Longitude": " -117.24470 "
   },
   {
      "Vendor": "EL SUPER #29",
      "Address": "W 151 LINCOLN AVE",
      "City": "ESCONDIDO",
      "Zip Code": " 92026",
      "County": " SAN DIEGO",
      "Latitude": "33.1332350  ",
      "Longitude": " -117.08787 "
   },
   {
      "Vendor": "WINCO FOODS #145",
      "Address": "S 2245 EL CAMINO REAL",
      "City": "OCEANSIDE",
      "Zip Code": " 92054",
      "County": " SAN DIEGO",
      "Latitude": "33.1855580  ",
      "Longitude": " -117.32836 "
   },
   {
      "Vendor": "LINDA VISTA MARKET",
      "Address": " 2187 ULRIC ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92111",
      "County": " SAN DIEGO",
      "Latitude": "32.7837220  ",
      "Longitude": " -117.16925 "
   },
   {
      "Vendor": "MOM'S AND KIDS NUTRITION #2",
      "Address": "S 1031 SANTA FE AVE",
      "Second Address": "  E2",
      "City": "VISTA",
      "Zip Code": " 92083",
      "County": " SAN DIEGO",
      "Latitude": "33.1914520  ",
      "Longitude": " -117.22955 "
   },
   {
      "Vendor": "ABUELA MARKET",
      "Address": " 1906 OCEANSIDE BLVD",
      "Second Address": " STE W",
      "City": "OCEANSIDE",
      "Zip Code": " 92054",
      "County": " SAN DIEGO",
      "Latitude": "33.1942420  ",
      "Longitude": " -117.35686 "
   },
   {
      "Vendor": "ABUELA NUTRITION",
      "Address": " 542 BROADWAY AVE",
      "Second Address": "  SUITE R",
      "City": "CHULA VISTA",
      "Zip Code": " 91910",
      "County": " SAN DIEGO",
      "Latitude": "32.6292330  ",
      "Longitude": " -117.08979 "
   },
   {
      "Vendor": "ABUELA NUTRITION",
      "Address": " 1655 BROADWAY AVE",
      "Second Address": "  SUITE 19",
      "City": "CHULA VISTA",
      "Zip Code": " 91911",
      "County": " SAN DIEGO",
      "Latitude": "32.5974930  ",
      "Longitude": " -117.07580 "
   },
   {
      "Vendor": "IDEAL MARKET",
      "Address": " 3101 NATIONAL AVE",
      "City": "SAN DIEGO",
      "Zip Code": " 92113",
      "County": " SAN DIEGO",
      "Latitude": "32.6956560  ",
      "Longitude": " -117.12695 "
   },
   {
      "Vendor": "WASHINGTON MARKET",
      "Address": "W 121 WASHINGTON AVE",
      "City": "EL CAJON",
      "Zip Code": " 92020",
      "County": " SAN DIEGO",
      "Latitude": "32.7874640  ",
      "Longitude": " -116.96306 "
   },
   {
      "Vendor": "MEX MART",
      "Address": "S 1740 43RD ST",
      "City": "SAN DIEGO",
      "Zip Code": " 92113",
      "County": " SAN DIEGO",
      "Latitude": "32.6880610  ",
      "Longitude": " -117.10271 "
   },
   {
      "Vendor": "TARGET STORE T-0201",
      "Address": " 3245 SPORTS ARENA BLVD",
      "City": "SAN DIEGO",
      "Zip Code": " 92110",
      "County": " SAN DIEGO",
      "Latitude": "32.7513620  ",
      "Longitude": " -117.21053 "
   },
   {
      "Vendor": "WAL-MART #4340",
      "Address": " 13401 MAIN ST",
      "City": "HESPERIA",
      "Zip Code": " 92345",
      "County": " SAN BERNARDINO",
      "Latitude": "34.4242390  ",
      "Longitude": " -117.37003 "
   },
   {
      "Vendor": "MASATANI'S MARKET",
      "Address": " 771 GUADALUPE ST",
      "City": "GUADALUPE",
      "Zip Code": " 93434",
      "County": " SANTA BARBARA",
      "Latitude": "34.9678170  ",
      "Longitude": " -120.57385 "
   },
   {
      "Vendor": "VONS #2101",
      "Address": " 1040 COAST VILLAGE RD",
      "City": "MONTECITO",
      "Zip Code": " 93108",
      "County": " SANTA BARBARA",
      "Latitude": "34.4225890  ",
      "Longitude": " -119.65107 "
   },
   {
      "Vendor": "VONS #2301",
      "Address": "E 817 MAIN ST",
      "City": "SANTA MARIA",
      "Zip Code": " 93454",
      "County": " SANTA BARBARA",
      "Latitude": "34.9535340  ",
      "Longitude": " -120.42402 "
   },
   {
      "Vendor": "VANDENBERG COMMISSARY",
      "Address": " 135 WYOMING AVE",
      "Second Address": " BLDG 14300",
      "City": "VANDENBERG AFB",
      "Zip Code": " 93437",
      "County": " SANTA BARBARA",
      "Latitude": "34.7497690  ",
      "Longitude": " -120.53543 "
   },
   {
      "Vendor": "MASHHOON'S FOODLAND",
      "Address": " 1501 SAN ANDRES ST",
      "City": "SANTA BARBARA",
      "Zip Code": " 93101",
      "County": " SANTA BARBARA",
      "Latitude": "34.4187430  ",
      "Longitude": " -119.71677 "
   },
   {
      "Vendor": "SPENCER'S FRESH MARKET",
      "Address": " 3580 ORCUTT RD",
      "City": "SANTA MARIA",
      "Zip Code": " 93455",
      "County": " SANTA BARBARA",
      "Latitude": "34.8950590  ",
      "Longitude": " -120.43567 "
   },
   {
      "Vendor": "GELSON'S MARKET #017",
      "Address": " 3305 STATE ST",
      "City": "SANTA BARBARA",
      "Zip Code": " 93105",
      "County": " SANTA BARBARA",
      "Latitude": "34.4401910  ",
      "Longitude": " -119.74047 "
   },
   {
      "Vendor": "FOODS CO #771",
      "Address": "W 601 CENTRAL AVE",
      "City": "LOMPOC",
      "Zip Code": " 93436",
      "County": " SANTA BARBARA",
      "Latitude": "34.6621070  ",
      "Longitude": " -120.46330 "
   },
   {
      "Vendor": "VONS #1738",
      "Address": "N 729 H ST",
      "City": "LOMPOC",
      "Zip Code": " 93436",
      "County": " SANTA BARBARA",
      "Latitude": "34.6496950  ",
      "Longitude": " -120.45922 "
   },
   {
      "Vendor": "RALPHS #680",
      "Address": "W 100 CARRILLO ST",
      "City": "SANTA BARBARA",
      "Zip Code": " 93101",
      "County": " SANTA BARBARA",
      "Latitude": "34.4201970  ",
      "Longitude": " -119.70403 "
   },
   {
      "Vendor": "FOODS CO #779",
      "Address": "S 1465 BROADWAY",
      "City": "SANTA MARIA",
      "Zip Code": " 93454",
      "County": " SANTA BARBARA",
      "Latitude": "34.9347560  ",
      "Longitude": " -120.43645 "
   },
   {
      "Vendor": "FOOD MAXX #450",
      "Address": "S 2440 BROADWAY",
      "City": "SANTA MARIA",
      "Zip Code": " 93454",
      "County": " SANTA BARBARA",
      "Latitude": "34.9152100  ",
      "Longitude": " -120.43463 "
   },
   {
      "Vendor": "FOOD MAXX #451",
      "Address": "N 1870 BROADWAY",
      "City": "SANTA MARIA",
      "Zip Code": " 93454",
      "County": " SANTA BARBARA",
      "Latitude": "34.9744000  ",
      "Longitude": " -120.43387 "
   },
   {
      "Vendor": "RALPHS #010",
      "Address": " 5170 HOLLISTER AVE",
      "City": "GOLETA",
      "Zip Code": " 93111",
      "County": " SANTA BARBARA",
      "Latitude": "34.4356420  ",
      "Longitude": " -119.80382 "
   },
   {
      "Vendor": "CARNICERIA LA BONITA",
      "Address": "W 1000 MAIN ST",
      "City": "SANTA MARIA",
      "Zip Code": " 93458",
      "County": " SANTA BARBARA",
      "Latitude": "34.9528950  ",
      "Longitude": " -120.44961 "
   },
   {
      "Vendor": "C & H MARKET",
      "Address": " 4855 PRIMERO ST",
      "City": "NEW CUYAMA",
      "Zip Code": " 93254",
      "County": " SANTA BARBARA",
      "Latitude": "34.9478500  ",
      "Longitude": " -119.68923 "
   },
   {
      "Vendor": "LA PRINCESA MARKET",
      "Address": "N 1000 BROADWAY ST",
      "City": "SANTA MARIA",
      "Zip Code": " 93454",
      "County": " SANTA BARBARA",
      "Latitude": "34.9625150  ",
      "Longitude": " -120.43531 "
   },
   {
      "Vendor": "MAIN CENTRAL MARKET",
      "Address": "W 822 MAIN ST",
      "City": "SANTA MARIA",
      "Zip Code": " 93458",
      "County": " SANTA BARBARA",
      "Latitude": "34.9528630  ",
      "Longitude": " -120.44624 "
   },
   {
      "Vendor": "BABY'S NUTRITION #2",
      "Address": "N 919 BROADWAY",
      "Second Address": " STE B",
      "City": "SANTA MARIA",
      "Zip Code": " 93454",
      "County": " SANTA BARBARA",
      "Latitude": "34.9621050  ",
      "Longitude": " -120.43605 "
   },
   {
      "Vendor": "BABY'S NUTRITION #3",
      "Address": "S 1543 BROADWAY",
      "City": "SANTA MARIA",
      "Zip Code": " 93454",
      "County": " SANTA BARBARA",
      "Latitude": "34.9324760  ",
      "Longitude": " -120.43610 "
   },
   {
      "Vendor": "SMART & FINAL #391",
      "Address": "E 217 GUTIERREZ ST",
      "City": "SANTA BARBARA",
      "Zip Code": " 93101",
      "County": " SANTA BARBARA",
      "Latitude": "34.4189390  ",
      "Longitude": " -119.69193 "
   },
   {
      "Vendor": "SMART & FINAL #336",
      "Address": "S 1721 BROADWAY",
      "City": "SANTA MARIA",
      "Zip Code": " 93455",
      "County": " SANTA BARBARA",
      "Latitude": "34.9269190  ",
      "Longitude": " -120.43611 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2537",
      "Address": " 1515 DANA DR",
      "City": "REDDING",
      "Zip Code": " 96003",
      "County": " SHASTA",
      "Latitude": "40.5854430  ",
      "Longitude": " -122.34342 "
   },
   {
      "Vendor": "LA FAVORITA MARKET SM #1",
      "Address": "W 721 CHURCH ST",
      "City": "SANTA MARIA",
      "Zip Code": " 93458",
      "County": " SANTA BARBARA",
      "Latitude": "34.9520950  ",
      "Longitude": " -120.44488 "
   },
   {
      "Vendor": "LA FAVORITA MARKET SM #3",
      "Address": "S 1711 BROADWAY",
      "City": "SANTA MARIA",
      "Zip Code": " 93454",
      "County": " SANTA BARBARA",
      "Latitude": "34.9296130  ",
      "Longitude": " -120.43735 "
   },
   {
      "Vendor": "BABY'S NUTRITION #4",
      "Address": "S 425 BLOSSER RD",
      "City": "SANTA MARIA",
      "Zip Code": " 93458",
      "County": " SANTA BARBARA",
      "Latitude": "34.9485590  ",
      "Longitude": " -120.45423 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #31",
      "Address": "N 1875 BROADWAY",
      "City": "SANTA MARIA",
      "Zip Code": " 93454",
      "County": " SANTA BARBARA",
      "Latitude": "34.9745340  ",
      "Longitude": " -120.43609 "
   },
   {
      "Vendor": "TARGET STORE T-0309",
      "Address": "E 223 BETTERAVIA RD",
      "City": "SANTA MARIA",
      "Zip Code": " 93454",
      "County": " SANTA BARBARA",
      "Latitude": "34.9213110  ",
      "Longitude": " -120.43434 "
   },
   {
      "Vendor": "ALBERTSONS #3324",
      "Address": "E 222 HWY 246",
      "City": "BUELLTON",
      "Zip Code": " 93427",
      "County": " SANTA BARBARA",
      "Latitude": "34.6094950  ",
      "Longitude": " -120.18844 "
   },
   {
      "Vendor": "ALBERTSONS #3171",
      "Address": "N 1500 H ST",
      "City": "LOMPOC",
      "Zip Code": " 93436",
      "County": " SANTA BARBARA",
      "Latitude": "34.6624500  ",
      "Longitude": " -120.45642 "
   },
   {
      "Vendor": "ALBERTSONS #1348",
      "Address": "S 2320 BROADWAY",
      "City": "SANTA MARIA",
      "Zip Code": " 93454",
      "County": " SANTA BARBARA",
      "Latitude": "34.9181810  ",
      "Longitude": " -120.43590 "
   },
   {
      "Vendor": "ALBERTSONS #354",
      "Address": " 7127 HOLLISTER AVE",
      "Second Address": " STE 27",
      "City": "GOLETA",
      "Zip Code": " 93117",
      "County": " SANTA BARBARA",
      "Latitude": "34.4291460  ",
      "Longitude": " -119.87687 "
   },
   {
      "Vendor": "ALBERTSONS #355",
      "Address": " 1018 CASITAS PASS RD",
      "City": "CARPINTERIA",
      "Zip Code": " 93013",
      "County": " SANTA BARBARA",
      "Latitude": "34.3959000  ",
      "Longitude": " -119.51340 "
   },
   {
      "Vendor": "ALBERTSONS #357",
      "Address": " 5801 CALLE REAL",
      "City": "GOLETA",
      "Zip Code": " 93117",
      "County": " SANTA BARBARA",
      "Latitude": "34.4408000  ",
      "Longitude": " -119.82680 "
   },
   {
      "Vendor": "ALBERTSONS #1394",
      "Address": "E 1120 CLARK AVE",
      "City": "ORCUTT",
      "Zip Code": " 93455",
      "County": " SANTA BARBARA",
      "Latitude": "34.8649640  ",
      "Longitude": " -120.41717 "
   },
   {
      "Vendor": "LA CHIQUITA FAMILY NUTR CTR",
      "Address": "N 437 H ST",
      "Second Address": " STE D",
      "City": "LOMPOC",
      "Zip Code": " 93436",
      "County": " SANTA BARBARA",
      "Latitude": "34.6450310  ",
      "Longitude": " -120.45820 "
   },
   {
      "Vendor": "WAL-MART #5659",
      "Address": "S 500 BLOSSER RD",
      "City": "SANTA MARIA",
      "Zip Code": " 93458",
      "County": " SANTA BARBARA",
      "Latitude": "34.9480870  ",
      "Longitude": " -120.45277 "
   },
   {
      "Vendor": "WAL-MART #5658",
      "Address": "S 2240 BRADLEY RD",
      "City": "SANTA MARIA",
      "Zip Code": " 93454",
      "County": " SANTA BARBARA",
      "Latitude": "34.9190290  ",
      "Longitude": " -120.42134 "
   },
   {
      "Vendor": "WAL-MART #1989",
      "Address": "W 701 CENTRAL AVE",
      "City": "LOMPOC",
      "Zip Code": " 93436",
      "County": " SANTA BARBARA",
      "Latitude": "34.6629630  ",
      "Longitude": " -120.46527 "
   },
   {
      "Vendor": "WAL-MART STORE #2507",
      "Address": "S 2220 BRADLEY RD",
      "City": "SANTA MARIA",
      "Zip Code": " 93455",
      "County": " SANTA BARBARA",
      "Latitude": "34.9197660  ",
      "Longitude": " -120.42158 "
   },
   {
      "Vendor": "SUPER CARNICERIA LA CHIQUITA",
      "Address": "W 819 LAUREL AVE",
      "City": "LOMPOC",
      "Zip Code": " 93436",
      "County": " SANTA BARBARA",
      "Latitude": "34.6438970  ",
      "Longitude": " -120.46743 "
   },
   {
      "Vendor": "BABY'S NUTRITION #5",
      "Address": "N 908 H ST",
      "City": "LOMPOC",
      "Zip Code": " 93436",
      "County": " SANTA BARBARA",
      "Latitude": "34.6521950  ",
      "Longitude": " -120.45730 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #46",
      "Address": "S 1482 BROADWAY",
      "City": "SANTA MARIA",
      "Zip Code": " 93454",
      "County": " SANTA BARBARA",
      "Latitude": "34.9349850  ",
      "Longitude": " -120.43531 "
   },
   {
      "Vendor": "SMART & FINAL #702",
      "Address": " 7090 HOLLISTER AVE",
      "Second Address": " STE 105",
      "City": "GOLETA",
      "Zip Code": " 93117",
      "County": " SANTA BARBARA",
      "Latitude": "34.4302360  ",
      "Longitude": " -119.87697 "
   },
   {
      "Vendor": "VONS #3326",
      "Address": "S 163 TURNPIKE RD",
      "City": "GOLETA",
      "Zip Code": " 93111",
      "County": " SANTA BARBARA",
      "Latitude": "34.4376910  ",
      "Longitude": " -119.79046 "
   },
   {
      "Vendor": "LA ESPERANZA GROCERIES",
      "Address": " 843 GUADALUPE ST",
      "City": "GUADALUPE",
      "Zip Code": " 93434",
      "County": " SANTA BARBARA",
      "Latitude": "34.9694460  ",
      "Longitude": " -120.57388 "
   },
   {
      "Vendor": "SMART & FINAL #915",
      "Address": " 850 LINDEN AVE",
      "City": "CARPINTERIA",
      "Zip Code": " 93013",
      "County": " SANTA BARBARA",
      "Latitude": "34.3972780  ",
      "Longitude": " -119.51890 "
   },
   {
      "Vendor": "LA PUERTA DEL SOL",
      "Address": "W 1125 MAIN ST",
      "Second Address": " STE A & B",
      "City": "SANTA MARIA",
      "Zip Code": " 93458",
      "County": " SANTA BARBARA",
      "Latitude": "34.9530480  ",
      "Longitude": " -120.41704 "
   },
   {
      "Vendor": "VONS #3329",
      "Address": " 2010 CLIFF DR",
      "City": "SANTA BARBARA",
      "Zip Code": " 93109",
      "County": " SANTA BARBARA",
      "Latitude": "34.4023380  ",
      "Longitude": " -119.72320 "
   },
   {
      "Vendor": "SMART & FINAL #914",
      "Address": " 3943 STATE ST",
      "City": "SANTA BARBARA",
      "Zip Code": " 93105",
      "County": " SANTA BARBARA",
      "Latitude": "34.4389200  ",
      "Longitude": " -119.75249 "
   },
   {
      "Vendor": "LA FAVORITA MARKET",
      "Address": "N 1635 BROADWAY",
      "City": "SANTA MARIA",
      "Zip Code": " 93454",
      "County": " SANTA BARBARA",
      "Latitude": "34.9690540  ",
      "Longitude": " -120.43640 "
   },
   {
      "Vendor": "BABY'S NUTRITION #6",
      "Address": "N 311 MCCLELLAND ST",
      "City": "SANTA MARIA",
      "Zip Code": " 93454",
      "County": " SANTA BARBARA",
      "Latitude": "34.9558070  ",
      "Longitude": " -120.43446 "
   },
   {
      "Vendor": "RALPHS #009",
      "Address": " 3963 THOUSAND OAKS BLVD",
      "City": "THOUSAND OAKS",
      "Zip Code": " 91362",
      "County": " VENTURA",
      "Latitude": "34.1734910  ",
      "Longitude": " -118.84274 "
   },
   {
      "Vendor": "RALPHS #190",
      "Address": " 3443 SAVIERS RD",
      "City": "OXNARD",
      "Zip Code": " 93033",
      "County": " VENTURA",
      "Latitude": "34.1688260  ",
      "Longitude": " -119.17896 "
   },
   {
      "Vendor": "RALPHS #052",
      "Address": " 2726 LOS ANGELES AVE",
      "City": "SIMI VALLEY",
      "Zip Code": " 93065",
      "County": " VENTURA",
      "Latitude": "34.2714230  ",
      "Longitude": " -118.74351 "
   },
   {
      "Vendor": "VONS #2047",
      "Address": "E 5805 LOS ANGELES AVE",
      "City": "SIMI VALLEY",
      "Zip Code": " 93063",
      "County": " VENTURA",
      "Latitude": "34.2717820  ",
      "Longitude": " -118.67815 "
   },
   {
      "Vendor": "VONS #2677",
      "Address": " 2764 THOMPSON BLVD",
      "City": "VENTURA",
      "Zip Code": " 93001",
      "County": " VENTURA",
      "Latitude": "34.2736450  ",
      "Longitude": " -119.26660 "
   },
   {
      "Vendor": "VONS #3135",
      "Address": " 2725 AGOURA RD",
      "City": "WESTLAKE VILLAGE",
      "Zip Code": " 91361",
      "County": " VENTURA",
      "Latitude": "34.1520010  ",
      "Longitude": " -118.82584 "
   },
   {
      "Vendor": "VONS #2430",
      "Address": " 1125 MARICOPA HWY",
      "City": "OJAI",
      "Zip Code": " 93023",
      "County": " VENTURA",
      "Latitude": "34.4411490  ",
      "Longitude": " -119.26233 "
   },
   {
      "Vendor": "PORT HUENEME COMMISSARY",
      "Address": " 130 23RD AVE",
      "Second Address": " BLDG 1512",
      "City": "PORT HUENEME",
      "Zip Code": " 93043",
      "County": " VENTURA",
      "Latitude": "34.1682120  ",
      "Longitude": " -119.19586 "
   },
   {
      "Vendor": "VONS #2092",
      "Address": "E 2048 AVENIDA DE LOS ARBOL",
      "City": "THOUSAND OAKS",
      "Zip Code": " 91362",
      "County": " VENTURA",
      "Latitude": "34.2097410  ",
      "Longitude": " -118.84082 "
   },
   {
      "Vendor": "VONS #2094",
      "Address": " 5275 MISSION OAKS BLVD",
      "City": "CAMARILLO",
      "Zip Code": " 93010",
      "County": " VENTURA",
      "Latitude": "34.2284610  ",
      "Longitude": " -118.99795 "
   },
   {
      "Vendor": "VONS #2431",
      "Address": " 2433 HARBOR BLVD",
      "City": "VENTURA",
      "Zip Code": " 93001",
      "County": " VENTURA",
      "Latitude": "34.2630610  ",
      "Longitude": " -119.27020 "
   },
   {
      "Vendor": "VONS #2096",
      "Address": "W 115 MAIN ST",
      "City": "VENTURA",
      "Zip Code": " 93001",
      "County": " VENTURA",
      "Latitude": "34.2822750  ",
      "Longitude": " -119.30236 "
   },
   {
      "Vendor": "VONS #2164",
      "Address": " 5688 TELEPHONE RD",
      "City": "VENTURA",
      "Zip Code": " 93003",
      "County": " VENTURA",
      "Latitude": "34.2644300  ",
      "Longitude": " -119.21499 "
   },
   {
      "Vendor": "RALPHS #723",
      "Address": "W 101 LOS ANGELES AVE",
      "City": "MOORPARK",
      "Zip Code": " 93021",
      "County": " VENTURA",
      "Latitude": "34.2802390  ",
      "Longitude": " -118.88321 "
   },
   {
      "Vendor": "RALPHS #729",
      "Address": "N 583 VENTU PARK RD",
      "City": "NEWBURY PARK",
      "Zip Code": " 91320",
      "County": " VENTURA",
      "Latitude": "34.1874470  ",
      "Longitude": " -118.91242 "
   },
   {
      "Vendor": "RALPHS #741",
      "Address": " 674 LAS POSAS RD",
      "City": "CAMARILLO",
      "Zip Code": " 93010",
      "County": " VENTURA",
      "Latitude": "34.2234770  ",
      "Longitude": " -119.06951 "
   },
   {
      "Vendor": "RALPHS #062",
      "Address": "W 615 CHANNEL ISLANDS BLVD",
      "City": "PORT HUENEME",
      "Zip Code": " 93041",
      "County": " VENTURA",
      "Latitude": "34.1771300  ",
      "Longitude": " -119.21631 "
   },
   {
      "Vendor": "VONS #2434",
      "Address": "W 576 MAIN ST",
      "City": "SANTA PAULA",
      "Zip Code": " 93060",
      "County": " VENTURA",
      "Latitude": "34.3444480  ",
      "Longitude": " -119.08117 "
   },
   {
      "Vendor": "PAVILIONS #2215",
      "Address": " 1135 LINDERO CANYON RD",
      "City": "THOUSAND OAKS",
      "Zip Code": " 91362",
      "County": " VENTURA",
      "Latitude": "34.1842080  ",
      "Longitude": " -118.78798 "
   },
   {
      "Vendor": "VONS #2501",
      "Address": "E 1855 COCHRAN ST",
      "City": "SIMI VALLEY",
      "Zip Code": " 93065",
      "County": " VENTURA",
      "Latitude": "34.2801510  ",
      "Longitude": " -118.76275 "
   },
   {
      "Vendor": "VONS #2436",
      "Address": "N 2101 ROSE AVE",
      "City": "OXNARD",
      "Zip Code": " 93030",
      "County": " VENTURA",
      "Latitude": "34.2213620  ",
      "Longitude": " -119.15835 "
   },
   {
      "Vendor": "AMAR RANCH FOOD WAREHOUSE",
      "Address": "E 1111 CHANNEL ISLANDS BLVD",
      "City": "OXNARD",
      "Zip Code": " 93033",
      "County": " VENTURA",
      "Latitude": "34.1743590  ",
      "Longitude": " -119.16472 "
   },
   {
      "Vendor": "VONS #2442",
      "Address": " 636 VENTURA ST",
      "City": "FILLMORE",
      "Zip Code": " 93015",
      "County": " VENTURA",
      "Latitude": "34.3817240  ",
      "Longitude": " -118.93321 "
   },
   {
      "Vendor": "TRESIERRAS MARKET #5",
      "Address": "E 280 HARVARD BLVD",
      "City": "SANTA PAULA",
      "Zip Code": " 93060",
      "County": " VENTURA",
      "Latitude": "34.3470560  ",
      "Longitude": " -119.06782 "
   },
   {
      "Vendor": "SUPER A FOODS #12",
      "Address": " 725 VENTURA ST",
      "City": "FILLMORE",
      "Zip Code": " 93015",
      "County": " VENTURA",
      "Latitude": "34.3801620  ",
      "Longitude": " -118.93342 "
   },
   {
      "Vendor": "VONS #1672",
      "Address": " 820 ARNEILL RD",
      "City": "CAMARILLO",
      "Zip Code": " 93010",
      "County": " VENTURA",
      "Latitude": "34.2249380  ",
      "Longitude": " -119.03705 "
   },
   {
      "Vendor": "VONS #1735",
      "Address": " 4241 TIERRA REJADA RD",
      "City": "MOORPARK",
      "Zip Code": " 93021",
      "County": " VENTURA",
      "Latitude": "34.2685840  ",
      "Longitude": " -118.89804 "
   },
   {
      "Vendor": "VONS #1913",
      "Address": "S 450 VENTURA RD",
      "City": "OXNARD",
      "Zip Code": " 93030",
      "County": " VENTURA",
      "Latitude": "34.1985700  ",
      "Longitude": " -119.19347 "
   },
   {
      "Vendor": "J R D FOODS",
      "Address": "W 636 HARVARD BLVD",
      "City": "SANTA PAULA",
      "Zip Code": " 93060",
      "County": " VENTURA",
      "Latitude": "34.3419500  ",
      "Longitude": " -119.08154 "
   },
   {
      "Vendor": "VONS #1610",
      "Address": "N 1790 MOORPARK RD",
      "City": "THOUSAND OAKS",
      "Zip Code": " 91360",
      "County": " VENTURA",
      "Latitude": "34.2017530  ",
      "Longitude": " -118.86820 "
   },
   {
      "Vendor": "RALPHS #664",
      "Address": "S 1776 VICTORIA AVE",
      "City": "VENTURA",
      "Zip Code": " 93003",
      "County": " VENTURA",
      "Latitude": "34.2580310  ",
      "Longitude": " -119.20895 "
   },
   {
      "Vendor": "RALPHS #620",
      "Address": "N 1500 MOORPARK RD",
      "City": "THOUSAND OAKS",
      "Zip Code": " 91360",
      "County": " VENTURA",
      "Latitude": "34.1984510  ",
      "Longitude": " -118.86745 "
   },
   {
      "Vendor": "VONS #2678",
      "Address": " 6040 TELEGRAPH RD",
      "City": "VENTURA",
      "Zip Code": " 93003",
      "County": " VENTURA",
      "Latitude": "34.2767840  ",
      "Longitude": " -119.21235 "
   },
   {
      "Vendor": "HEALTHY BABY NUTRITION",
      "Address": "S 326 C ST",
      "Second Address": " STE B",
      "City": "OXNARD",
      "Zip Code": " 93030",
      "County": " VENTURA",
      "Latitude": "34.1996720  ",
      "Longitude": " -119.18071 "
   },
   {
      "Vendor": "OXNARD NUTRITIONAL CENTER",
      "Address": "W 450 PLEASANT VALLEY RD",
      "City": "OXNARD",
      "Zip Code": " 93033",
      "County": " VENTURA",
      "Latitude": "34.1546860  ",
      "Longitude": " -119.18175 "
   },
   {
      "Vendor": "TRESIERRAS MARKET #7",
      "Address": "W 133 PLEASANT VALLEY RD",
      "City": "OXNARD",
      "Zip Code": " 93033",
      "County": " VENTURA",
      "Latitude": "34.1557720  ",
      "Longitude": " -119.17848 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKETS #21",
      "Address": "S 1050 A ST",
      "City": "OXNARD",
      "Zip Code": " 93030",
      "County": " VENTURA",
      "Latitude": "34.1907280  ",
      "Longitude": " -119.17829 "
   },
   {
      "Vendor": "VONS #2825",
      "Address": "S 1291 VICTORIA BLVD",
      "City": "OXNARD",
      "Zip Code": " 93030",
      "County": " VENTURA",
      "Latitude": "34.1979410  ",
      "Longitude": " -119.22124 "
   },
   {
      "Vendor": "VONS #2692",
      "Address": " 2938 TAPO CANYON RD",
      "City": "SIMI VALLEY",
      "Zip Code": " 93063",
      "County": " VENTURA",
      "Latitude": "34.2886630  ",
      "Longitude": " -118.71760 "
   },
   {
      "Vendor": "CARNICERIA LA PLAZA",
      "Address": "W 1055 VENTURA ST",
      "City": "FILLMORE",
      "Zip Code": " 93015",
      "County": " VENTURA",
      "Latitude": "34.3953960  ",
      "Longitude": " -118.92683 "
   },
   {
      "Vendor": "OXNARD MARKET",
      "Address": " 160 BRYCE CANYON AVE",
      "City": "OXNARD",
      "Zip Code": " 93033",
      "County": " VENTURA",
      "Latitude": "34.1695640  ",
      "Longitude": " -119.17870 "
   },
   {
      "Vendor": "VALLEY MARKETPLACE",
      "Address": "E 1117 LOS ANGELES AVE",
      "City": "SIMI VALLEY",
      "Zip Code": " 93065",
      "County": " VENTURA",
      "Latitude": "34.2725350  ",
      "Longitude": " -118.77758 "
   },
   {
      "Vendor": "GELSON'S MARKET #008",
      "Address": " 2734 TOWNSGATE RD",
      "City": "WESTLAKE VILLAGE",
      "Zip Code": " 91361",
      "County": " VENTURA",
      "Latitude": "34.1526070  ",
      "Longitude": " -118.82538 "
   },
   {
      "Vendor": "BINDI FOOD MART #3",
      "Address": " 11025 VIOLETA ST",
      "City": "SATICOY",
      "Zip Code": " 93004",
      "County": " VENTURA",
      "Latitude": "34.2834880  ",
      "Longitude": " -119.15011 "
   },
   {
      "Vendor": "SMART & FINAL #390",
      "Address": "E 2750 MAIN ST",
      "City": "VENTURA",
      "Zip Code": " 93001",
      "County": " VENTURA",
      "Latitude": "34.2727670  ",
      "Longitude": " -119.25946 "
   },
   {
      "Vendor": "SMART & FINAL #400",
      "Address": " 389 ARNEILL RD",
      "City": "CAMARILLO",
      "Zip Code": " 93010",
      "County": " VENTURA",
      "Latitude": "34.2209770  ",
      "Longitude": " -119.03899 "
   },
   {
      "Vendor": "SMART & FINAL #465",
      "Address": " 1856 ERRINGER RD",
      "Second Address": " STE B",
      "City": "SIMI VALLEY",
      "Zip Code": " 93065",
      "County": " VENTURA",
      "Latitude": "34.2702950  ",
      "Longitude": " -118.76055 "
   },
   {
      "Vendor": "SMART & FINAL #525",
      "Address": "W 864 LOS ANGELES AVE",
      "City": "MOORPARK",
      "Zip Code": " 93020",
      "County": " VENTURA",
      "Latitude": "34.2789600  ",
      "Longitude": " -118.89271 "
   },
   {
      "Vendor": "MONARCA'S MEAT MARKET",
      "Address": "N 2671 VENTURA RD",
      "City": "PORT HUENEME",
      "Zip Code": " 93041",
      "County": " VENTURA",
      "Latitude": "34.1779910  ",
      "Longitude": " -119.19554 "
   },
   {
      "Vendor": "CARNICERIA HACIENDA",
      "Address": "S 657 VENTURA RD",
      "City": "OXNARD",
      "Zip Code": " 93030",
      "County": " VENTURA",
      "Latitude": "34.1957170  ",
      "Longitude": " -119.19484 "
   },
   {
      "Vendor": "RED BARN LIQUOR MARKET",
      "Address": "S 1712 SAVIERS RD",
      "City": "OXNARD",
      "Zip Code": " 93030",
      "County": " VENTURA",
      "Latitude": "34.1827680  ",
      "Longitude": " -119.17739 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #2032",
      "Address": "N 2001 ROSE AVE",
      "City": "OXNARD",
      "Zip Code": " 93036",
      "County": " VENTURA",
      "Latitude": "34.2201010  ",
      "Longitude": " -119.16087 "
   },
   {
      "Vendor": "J & K FOOD MART",
      "Address": "W 609 HUENEME RD",
      "City": "OXNARD",
      "Zip Code": " 93033",
      "County": " VENTURA",
      "Latitude": "34.1475570  ",
      "Longitude": " -119.18399 "
   },
   {
      "Vendor": "CARNICERIA HNOS GARCIA",
      "Address": " 603 COOPER RD",
      "City": "OXNARD",
      "Zip Code": " 93030",
      "County": " VENTURA",
      "Latitude": "34.2047850  ",
      "Longitude": " -119.17252 "
   },
   {
      "Vendor": "TARGET STORE T-0246",
      "Address": " 2907 COCHRAN ST",
      "City": "SIMI VALLEY",
      "Zip Code": " 93065",
      "County": " VENTURA",
      "Latitude": "34.2792410  ",
      "Longitude": " -118.73968 "
   },
   {
      "Vendor": "TARGET STORE T-2462",
      "Address": "E 51 TIERRA RAJADA RD",
      "City": "SIMI VALLEY",
      "Zip Code": " 93065",
      "County": " VENTURA",
      "Latitude": "34.2724360  ",
      "Longitude": " -118.79838 "
   },
   {
      "Vendor": "TARGET STORE T-0298",
      "Address": "E 4200 MAIN ST",
      "City": "VENTURA",
      "Zip Code": " 93003",
      "County": " VENTURA",
      "Latitude": "34.2625650  ",
      "Longitude": " -119.23575 "
   },
   {
      "Vendor": "SUPERIOR GROCERS #138",
      "Address": " 2401 SAVIERS RD",
      "City": "OXNARD",
      "Zip Code": " 93033",
      "County": " VENTURA",
      "Latitude": "34.1766600  ",
      "Longitude": " -119.17955 "
   },
   {
      "Vendor": "TARGET STORE T-1027",
      "Address": "W 209 VENTURA BLVD",
      "City": "CAMARILLO",
      "Zip Code": " 93010",
      "County": " VENTURA",
      "Latitude": "34.2161480  ",
      "Longitude": " -119.07309 "
   },
   {
      "Vendor": "TARGET STORE T-1547",
      "Address": " 800 NEW LOS ANGELES AVE",
      "City": "MOORPARK",
      "Zip Code": " 93021",
      "County": " VENTURA",
      "Latitude": "34.2792390  ",
      "Longitude": " -118.86900 "
   },
   {
      "Vendor": "TARGET STORE T-2760",
      "Address": " 2850 OXNARD BLVD",
      "City": "OXNARD",
      "Zip Code": " 93036",
      "County": " VENTURA",
      "Latitude": "34.2427020  ",
      "Longitude": " -119.17867 "
   },
   {
      "Vendor": "TARGET STORE T-2398",
      "Address": "S 245 MILL RD",
      "City": "VENTURA",
      "Zip Code": " 93003",
      "County": " VENTURA",
      "Latitude": "34.2701300  ",
      "Longitude": " -119.24738 "
   },
   {
      "Vendor": "ALBERTSONS #391",
      "Address": "S 541 REINO RD",
      "City": "NEWBURY PARK",
      "Zip Code": " 91320",
      "County": " VENTURA",
      "Latitude": "34.1697110  ",
      "Longitude": " -118.95640 "
   },
   {
      "Vendor": "ALBERTSONS #393",
      "Address": " 1268 MADERA RD",
      "City": "SIMI VALLEY",
      "Zip Code": " 93065",
      "County": " VENTURA",
      "Latitude": "34.2617000  ",
      "Longitude": " -118.79619 "
   },
   {
      "Vendor": "EL SUPER #46",
      "Address": " 2800 SAVIERS RD",
      "City": "OXNARD",
      "Zip Code": " 93033",
      "County": " VENTURA",
      "Latitude": "34.1740340  ",
      "Longitude": " -119.17662 "
   },
   {
      "Vendor": "4 WAY MEAT MARKET #5",
      "Address": " 403 COOPER RD",
      "City": "OXNARD",
      "Zip Code": " 93030",
      "County": " VENTURA",
      "Latitude": "34.2047990  ",
      "Longitude": " -119.17413 "
   },
   {
      "Vendor": "HEALTHY FAM. NUTRITION OXNA",
      "Address": " 2190 SAVIERS RD",
      "City": "OXNARD",
      "Zip Code": " 93033",
      "County": " VENTURA",
      "Latitude": "34.1786660  ",
      "Longitude": " -119.17722 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #44",
      "Address": "E 2690 VINEYARD AVE",
      "City": "OXNARD",
      "Zip Code": " 93036",
      "County": " VENTURA",
      "Latitude": "34.2334180  ",
      "Longitude": " -119.16976 "
   },
   {
      "Vendor": "VALLARTA SUPERMARKET #35",
      "Address": "E 1357 LOS ANGELES AVE",
      "City": "SIMI VALLEY",
      "Zip Code": " 93065",
      "County": " VENTURA",
      "Latitude": "34.2736030  ",
      "Longitude": " -118.77350 "
   },
   {
      "Vendor": "WAL-MART #3179",
      "Address": "N 512 VENTU PARK RD",
      "City": "THOUSAND OAKS",
      "Zip Code": " 91320",
      "County": " VENTURA",
      "Latitude": "34.1869330  ",
      "Longitude": " -118.91087 "
   },
   {
      "Vendor": "WAL-MART #5643",
      "Address": "W 421 ESPLANADE DR",
      "City": "OXNARD",
      "Zip Code": " 93036",
      "County": " VENTURA",
      "Latitude": "34.2364360  ",
      "Longitude": " -119.17955 "
   },
   {
      "Vendor": "WAL-MART #3147",
      "Address": " 2204 TAPO ST",
      "City": "SIMI VALLEY",
      "Zip Code": " 93063",
      "County": " VENTURA",
      "Latitude": "34.2758180  ",
      "Longitude": " -118.70795 "
   },
   {
      "Vendor": "WAL-MART #5664",
      "Address": "W 275 VENTURA BLVD",
      "City": "CAMARILLO",
      "Zip Code": " 93010",
      "County": " VENTURA",
      "Latitude": "34.2172770  ",
      "Longitude": " -119.07467 "
   },
   {
      "Vendor": "WAL-MART #3650",
      "Address": "S 1739 VICTORIA AVE",
      "City": "VENTURA",
      "Zip Code": " 93003",
      "County": " VENTURA",
      "Latitude": "34.2584000  ",
      "Longitude": " -119.21280 "
   },
   {
      "Vendor": "WINCO FOODS#116",
      "Address": " 4750 TELEPHONE RD",
      "City": "VENTURA",
      "Zip Code": " 93003",
      "County": " VENTURA",
      "Latitude": "34.2600780  ",
      "Longitude": " -119.23238 "
   },
   {
      "Vendor": "WAL-MART STORE #2621",
      "Address": " 255 COCHRAN ST",
      "City": "SIMI VALLEY",
      "Zip Code": " 93065",
      "County": " VENTURA",
      "Latitude": "34.2811960  ",
      "Longitude": " -118.79215 "
   },
   {
      "Vendor": "DOC'S MEAT MARKET #2",
      "Address": "S 630 C ST",
      "City": "OXNARD",
      "Zip Code": " 93030",
      "County": " VENTURA",
      "Latitude": "34.1957750  ",
      "Longitude": " -119.18074 "
   },
   {
      "Vendor": "VENTURA COUNTY MARKET",
      "Address": "S 116 MILL ST",
      "City": "SANTA PAULA",
      "Zip Code": " 93060",
      "County": " VENTURA",
      "Latitude": "34.3529010  ",
      "Longitude": " -119.06077 "
   },
   {
      "Vendor": "RED BARN MARKET #2",
      "Address": "N 995 VENTURA AVE",
      "City": "VENTURA",
      "Zip Code": " 93001",
      "County": " VENTURA",
      "Latitude": "34.2922760  ",
      "Longitude": " -119.29779 "
   },
   {
      "Vendor": "BOY'S MARKET",
      "Address": "E 438 COLONIA RD",
      "City": "OXNARD",
      "Zip Code": " 93030",
      "County": " VENTURA",
      "Latitude": "34.2062860  ",
      "Longitude": " -119.17342 "
   },
   {
      "Vendor": "DOC'S MARKET",
      "Address": "W 354 RAMONA ST",
      "City": "VENTURA",
      "Zip Code": " 93001",
      "County": " VENTURA",
      "Latitude": "34.2905450  ",
      "Longitude": " -119.30373 "
   },
   {
      "Vendor": "LUPITAS FRUIT AND MINI MARK",
      "Address": "W 834 WOOLEY RD",
      "Second Address": " STE B",
      "City": "OXNARD",
      "Zip Code": " 93030",
      "County": " VENTURA",
      "Latitude": "34.1896730  ",
      "Longitude": " -119.18705 "
   },
   {
      "Vendor": "TARGET STORE T-1100",
      "Address": " 2705 TELLER RD",
      "City": "THOUSAND OAKS",
      "Zip Code": " 91320",
      "County": " VENTURA",
      "Latitude": "34.1902130  ",
      "Longitude": " -118.93487 "
   },
   {
      "Vendor": "FOOD 4 LESS #335",
      "Address": "W 250 ESPLANADE DR",
      "City": "OXNARD",
      "Zip Code": " 93036",
      "County": " VENTURA",
      "Latitude": "34.2317140  ",
      "Longitude": " -119.17691 "
   },
   {
      "Vendor": "ROCIO'S MARKET",
      "Address": "N 453 GARFIELD AVE",
      "City": "OXNARD",
      "Zip Code": " 93030",
      "County": " VENTURA",
      "Latitude": "34.2065650  ",
      "Longitude": " -119.17401 "
   },
   {
      "Vendor": "FIERROS MEAT MARKET",
      "Address": "S 1355 C ST",
      "City": "OXNARD",
      "Zip Code": " 93033",
      "County": " VENTURA",
      "Latitude": "34.1858480  ",
      "Longitude": " -119.18157 "
   },
   {
      "Vendor": "EL RIO OXNARD MARKET",
      "Address": "E 2585 VINEYARD AVE",
      "City": "OXNARD",
      "Zip Code": " 93036",
      "County": " VENTURA",
      "Latitude": "34.2345200  ",
      "Longitude": " -119.17137 "
   },
   {
      "Vendor": "SMART & FINAL #731",
      "Address": "N 2021 OXNARD BLVD",
      "City": "OXNARD",
      "Zip Code": " 93036",
      "County": " VENTURA",
      "Latitude": "34.2218640  ",
      "Longitude": " -119.17874 "
   },
   {
      "Vendor": "EL MATADOR MEAT MARKET #1",
      "Address": " 3801 SAVIERS RD",
      "City": "OXNARD",
      "Zip Code": " 93033",
      "County": " VENTURA",
      "Latitude": "34.1648760  ",
      "Longitude": " -119.17801 "
   },
   {
      "Vendor": "CHHINA'S MARKET",
      "Address": " 133 DEAN DR",
      "City": "SANTA PAULA",
      "Zip Code": " 93060",
      "County": " VENTURA",
      "Latitude": "34.3494710  ",
      "Longitude": " -119.07726 "
   },
   {
      "Vendor": "WRIGHT'S MARKET",
      "Address": "E 2691 VENTURA BLVD",
      "City": "OXNARD",
      "Zip Code": " 93036",
      "County": " VENTURA",
      "Latitude": "34.2230090  ",
      "Longitude": " -119.13765 "
   },
   {
      "Vendor": "SMART & FINAL #916",
      "Address": " 7800 TELEGRAPH RD",
      "City": "VENTURA",
      "Zip Code": " 93004",
      "County": " VENTURA",
      "Latitude": "34.2797680  ",
      "Longitude": " -119.19123 "
   },
   {
      "Vendor": "SMART & FINAL #918",
      "Address": " 2100 NEWBURY RD",
      "City": "THOUSAND OAKS",
      "Zip Code": " 91320",
      "County": " VENTURA",
      "Latitude": "34.1827380  ",
      "Longitude": " -118.92371 "
   },
   {
      "Vendor": "SMART & FINAL #919",
      "Address": " 5770 LINDERO CANYON RD",
      "City": "WESTLAKE VILLAGE",
      "Zip Code": " 91362",
      "County": " VENTURA",
      "Latitude": "34.1540570  ",
      "Longitude": " -118.79464 "
   },
   {
      "Vendor": "CARNICERIA LA UNICA",
      "Address": " 517 COOPER RD",
      "City": "OXNARD",
      "Zip Code": " 93030",
      "County": " VENTURA",
      "Latitude": "34.2047920  ",
      "Longitude": " -119.17331 "
   },
   {
      "Vendor": "SMART & FINAL #917",
      "Address": " 5135 LOS ANGELES AVE",
      "City": "SIMI VALLEY",
      "Zip Code": " 93063",
      "County": " VENTURA",
      "Latitude": "34.2727580  ",
      "Longitude": " -118.69266 "
   },
   {
      "Vendor": "STATER BROS. #196",
      "Address": "E 660 LOS ANGELES AVE",
      "City": "SIMI VALLEY",
      "Zip Code": " 93065",
      "County": " VENTURA",
      "Latitude": "34.2704990  ",
      "Longitude": " -118.78465 "
   },
   {
      "Vendor": "SMART & FINAL #740",
      "Address": "W 1341 CHANNEL ISLANDS BLVD",
      "City": "OXNARD",
      "Zip Code": " 93033",
      "County": " VENTURA",
      "Latitude": "34.1758860  ",
      "Longitude": " -119.19307 "
   },
   {
      "Vendor": "4 WAY MEAT MARKET EL RIO",
      "Address": "E 2746 VINEYARD AVE",
      "City": "OXNARD",
      "Zip Code": " 93036",
      "County": " VENTURA",
      "Latitude": "34.2365170  ",
      "Longitude": " -119.16942 "
   },
   {
      "Vendor": "SEVEROS MEAT AND GROCERY MARKE",
      "Address": "S 147 12 ST",
      "City": "SANTA PAULA",
      "Zip Code": " 93060",
      "County": " VENTURA",
      "Latitude": "34.3538690  ",
      "Longitude": " -119.05486 "
   },
   {
      "Vendor": "4 WAY MEAT MARKET #7 HUENEME",
      "Address": "W 541 HUENEME RD",
      "City": "OXNARD",
      "Zip Code": " 93033",
      "County": " VENTURA",
      "Latitude": "34.1479480  ",
      "Longitude": " -119.18325 "
   },
   {
      "Vendor": "CARNICERIA MI PUEBLITO",
      "Address": "S 148 OJAI ST",
      "City": "SANTA PAULA",
      "Zip Code": " 93060",
      "County": " VENTURA",
      "Latitude": "34.3530430  ",
      "Longitude": " -119.05865 "
   },
   {
      "Vendor": "RALEY'S #109",
      "Address": "S 1363 HIGHWAY 395",
      "City": "GARDNERVILLE",
      "Zip Code": " 89410",
      "County": " NEVADA STATE 3",
      "Latitude": "38.9380920  ",
      "Longitude": " -119.74105 "
   },
   {
      "Vendor": "RALEY'S #114",
      "Address": "S 3701 CARSON ST",
      "City": "CARSON CITY",
      "Zip Code": " 89701",
      "County": " NEVADA STATE 3",
      "Latitude": "39.1331400  ",
      "Longitude": " -119.76779 "
   },
   {
      "Vendor": "RALEY'S #106",
      "Address": " 701 KEYSTONE AVE",
      "City": "RENO",
      "Zip Code": " 89503",
      "County": " NEVADA STATE 3",
      "Latitude": "39.5315290  ",
      "Longitude": " -119.83158 "
   },
   {
      "Vendor": "RALEY'S #103",
      "Address": " 1441 MAYBERRY DR",
      "City": "RENO",
      "Zip Code": " 89501",
      "County": " NEVADA STATE 3",
      "Latitude": "39.5104380  ",
      "Longitude": " -119.83663 "
   },
   {
      "Vendor": "RALEY'S #113",
      "Address": " 930 TAHOE BLVD",
      "City": "INCLINE VILLAGE",
      "Zip Code": " 89450",
      "County": " NEVADA STATE 3",
      "Latitude": "39.2498150  ",
      "Longitude": " -119.95002 "
   },
   {
      "Vendor": "FOOD SOURCE #754",
      "Address": "S 4047 VIRGINIA ST",
      "City": "RENO",
      "Zip Code": " 89502",
      "County": " NEVADA STATE 3",
      "Latitude": "39.4864660  ",
      "Longitude": " -119.79685 "
   },
   {
      "Vendor": "RALEY'S #115",
      "Address": "N 1075 HILLS BLVD",
      "Second Address": " UNIT 260",
      "City": "RENO",
      "Zip Code": " 89506",
      "County": " NEVADA STATE 3",
      "Latitude": "39.6048880  ",
      "Longitude": " -119.83984 "
   },
   {
      "Vendor": "SMITH'S FOOD & DRUG #389",
      "Address": " 1341 HIGHWAY 395  N",
      "City": "GARDNERVILLE",
      "Zip Code": " 89410",
      "County": " NEVADA STATE 3",
      "Latitude": "38.9373230  ",
      "Longitude": " -119.73882 "
   },
   {
      "Vendor": "SAFEWAY #1537",
      "Address": " 212 ELK POINT DR",
      "City": "ZEPHYR COVE",
      "Zip Code": " 89448",
      "County": " NEVADA STATE 3",
      "Latitude": "38.9867770  ",
      "Longitude": " -119.94376 "
   },
   {
      "Vendor": "SAFEWAY #1474",
      "Address": "S 4823 HIGHWAY 95",
      "City": "FORT MOHAVE",
      "Zip Code": " 86427",
      "County": " ARIZONA STATE 1",
      "Latitude": "35.0171920  ",
      "Longitude": " -114.59996 "
   },
   {
      "Vendor": "SMITH'S FOOD & DRUG #191",
      "Address": " 1775 LAKESIDE DR",
      "City": "BULLHEAD CITY",
      "Zip Code": " 86442",
      "County": " ARIZONA STATE 1",
      "Latitude": "35.1076560  ",
      "Longitude": " -114.61350 "
   },
   {
      "Vendor": "SMITH'S FOOD & DRUG #473",
      "Address": " 4747 HIGHWAY 95",
      "City": "FORT MOHAVE",
      "Zip Code": " 86426",
      "County": " ARIZONA STATE 1",
      "Latitude": "35.0191860  ",
      "Longitude": " -114.60044 "
   },
   {
      "Vendor": "SAFEWAY #0248",
      "Address": " 1751 HIGHWAY 95",
      "City": "BULLHEAD CITY",
      "Zip Code": " 86442",
      "County": " ARIZONA STATE 1",
      "Latitude": "35.1218950  ",
      "Longitude": " -114.58576 "
   },
   {
      "Vendor": "SHERM'S THUNDERBIRD MARKET #2",
      "Address": " 1877 AVALON ST",
      "City": "KLAMATH FALLS",
      "Zip Code": " 97603",
      "County": " DEL NORTE",
      "Latitude": "42.2116140  ",
      "Longitude": " -121.75389 "
   },
   {
      "Vendor": "WAL-MART SUPERCENTER #1772",
      "Address": " 3600 WASHBURN WAY",
      "City": "KLAMATH FALLS",
      "Zip Code": " 97603",
      "County": " BUTTE",
      "Latitude": "42.1938240  ",
      "Longitude": " -121.75734 "
   }
]}